
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7515"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7515"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jiXHd", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ceZxO"));

});
parcelRegister("ceZxO", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $8e96884721cb3eeb$export$dca3b0875bd9a954; }, function (v) { return $8e96884721cb3eeb$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $8e96884721cb3eeb$export$16fa2f45be04daa8; }, function (v) { return $8e96884721cb3eeb$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $8e96884721cb3eeb$export$ffb0004e005737fa; }, function (v) { return $8e96884721cb3eeb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $8e96884721cb3eeb$export$e2c29f18771995cb; }, function (v) { return $8e96884721cb3eeb$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $8e96884721cb3eeb$export$221d75b3f55bb0bd; }, function (v) { return $8e96884721cb3eeb$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $8e96884721cb3eeb$export$5f8d39834fd61797; }, function (v) { return $8e96884721cb3eeb$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $8e96884721cb3eeb$export$74bf444e3cd11ea5; }, function (v) { return $8e96884721cb3eeb$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8e96884721cb3eeb$export$ae55be85d98224ed; }, function (v) { return $8e96884721cb3eeb$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $8e96884721cb3eeb$export$e530037191fcd5d7; }, function (v) { return $8e96884721cb3eeb$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $8e96884721cb3eeb$export$fd42f52fd3ae1109; }, function (v) { return $8e96884721cb3eeb$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $8e96884721cb3eeb$export$c8a8987d4410bf2d; }, function (v) { return $8e96884721cb3eeb$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $8e96884721cb3eeb$export$d38cd72104c1f0e9; }, function (v) { return $8e96884721cb3eeb$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $8e96884721cb3eeb$export$7d1e3a5e95ceca43; }, function (v) { return $8e96884721cb3eeb$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $8e96884721cb3eeb$export$257a8862b851cb5b; }, function (v) { return $8e96884721cb3eeb$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $8e96884721cb3eeb$export$a8257692ac88316c; }, function (v) { return $8e96884721cb3eeb$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $8e96884721cb3eeb$export$488013bae63b21da; }, function (v) { return $8e96884721cb3eeb$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $8e96884721cb3eeb$export$7c73462e0d25e514; }, function (v) { return $8e96884721cb3eeb$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $8e96884721cb3eeb$export$35808ee640e87ca7; }, function (v) { return $8e96884721cb3eeb$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $8e96884721cb3eeb$export$fae74005e78b1a27; }, function (v) { return $8e96884721cb3eeb$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $8e96884721cb3eeb$export$dc8fbce3eb94dc1e; }, function (v) { return $8e96884721cb3eeb$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $8e96884721cb3eeb$export$6d9c69b0de29b591; }, function (v) { return $8e96884721cb3eeb$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $8e96884721cb3eeb$export$d5a552a76deda3c2; }, function (v) { return $8e96884721cb3eeb$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $8e96884721cb3eeb$export$e5c5a5f917a5871c; }, function (v) { return $8e96884721cb3eeb$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $8e96884721cb3eeb$export$1538c33de8887b59; }, function (v) { return $8e96884721cb3eeb$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $8e96884721cb3eeb$export$13e3392192263954; }, function (v) { return $8e96884721cb3eeb$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $8e96884721cb3eeb$export$b8f5890fc79d6aca; }, function (v) { return $8e96884721cb3eeb$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $8e96884721cb3eeb$export$60241385465d0a34; }, function (v) { return $8e96884721cb3eeb$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $8e96884721cb3eeb$export$83d89fbfd8236492; }, function (v) { return $8e96884721cb3eeb$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8e96884721cb3eeb$export$dca3b0875bd9a954;
var $8e96884721cb3eeb$export$16fa2f45be04daa8;
var $8e96884721cb3eeb$export$ffb0004e005737fa;
var $8e96884721cb3eeb$export$e2c29f18771995cb;
var $8e96884721cb3eeb$export$221d75b3f55bb0bd;
var $8e96884721cb3eeb$export$5f8d39834fd61797;
var $8e96884721cb3eeb$export$74bf444e3cd11ea5;
var $8e96884721cb3eeb$export$ae55be85d98224ed;
var $8e96884721cb3eeb$export$e530037191fcd5d7;
var $8e96884721cb3eeb$export$fd42f52fd3ae1109;
var $8e96884721cb3eeb$export$c8a8987d4410bf2d;
var $8e96884721cb3eeb$export$d38cd72104c1f0e9;
var $8e96884721cb3eeb$export$7d1e3a5e95ceca43;
var $8e96884721cb3eeb$export$257a8862b851cb5b;
var $8e96884721cb3eeb$export$a8257692ac88316c;
var $8e96884721cb3eeb$export$488013bae63b21da;
var $8e96884721cb3eeb$export$7c73462e0d25e514;
var $8e96884721cb3eeb$export$35808ee640e87ca7;
var $8e96884721cb3eeb$export$fae74005e78b1a27;
var $8e96884721cb3eeb$export$dc8fbce3eb94dc1e;
var $8e96884721cb3eeb$export$6d9c69b0de29b591;
var $8e96884721cb3eeb$export$d5a552a76deda3c2;
var $8e96884721cb3eeb$export$e5c5a5f917a5871c;
var $8e96884721cb3eeb$export$1538c33de8887b59;
var $8e96884721cb3eeb$export$13e3392192263954;
var $8e96884721cb3eeb$export$b8f5890fc79d6aca;
var $8e96884721cb3eeb$export$60241385465d0a34;
var $8e96884721cb3eeb$export$83d89fbfd8236492;
'use strict';

var $lT6GZ = parcelRequire("lT6GZ");
var $8e96884721cb3eeb$var$n = "function" === typeof Symbol && Symbol.for, $8e96884721cb3eeb$var$p = $8e96884721cb3eeb$var$n ? Symbol.for("react.element") : 60103, $8e96884721cb3eeb$var$q = $8e96884721cb3eeb$var$n ? Symbol.for("react.portal") : 60106, $8e96884721cb3eeb$var$r = $8e96884721cb3eeb$var$n ? Symbol.for("react.fragment") : 60107, $8e96884721cb3eeb$var$t = $8e96884721cb3eeb$var$n ? Symbol.for("react.strict_mode") : 60108, $8e96884721cb3eeb$var$u = $8e96884721cb3eeb$var$n ? Symbol.for("react.profiler") : 60114, $8e96884721cb3eeb$var$v = $8e96884721cb3eeb$var$n ? Symbol.for("react.provider") : 60109, $8e96884721cb3eeb$var$w = $8e96884721cb3eeb$var$n ? Symbol.for("react.context") : 60110, $8e96884721cb3eeb$var$x = $8e96884721cb3eeb$var$n ? Symbol.for("react.forward_ref") : 60112, $8e96884721cb3eeb$var$y = $8e96884721cb3eeb$var$n ? Symbol.for("react.suspense") : 60113, $8e96884721cb3eeb$var$z = $8e96884721cb3eeb$var$n ? Symbol.for("react.memo") : 60115, $8e96884721cb3eeb$var$A = $8e96884721cb3eeb$var$n ? Symbol.for("react.lazy") : 60116, $8e96884721cb3eeb$var$B = "function" === typeof Symbol && Symbol.iterator;
function $8e96884721cb3eeb$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8e96884721cb3eeb$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8e96884721cb3eeb$var$E = {};
function $8e96884721cb3eeb$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $8e96884721cb3eeb$var$E;
    this.updater = c || $8e96884721cb3eeb$var$D;
}
$8e96884721cb3eeb$var$F.prototype.isReactComponent = {};
$8e96884721cb3eeb$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($8e96884721cb3eeb$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$8e96884721cb3eeb$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $8e96884721cb3eeb$var$G() {}
$8e96884721cb3eeb$var$G.prototype = $8e96884721cb3eeb$var$F.prototype;
function $8e96884721cb3eeb$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $8e96884721cb3eeb$var$E;
    this.updater = c || $8e96884721cb3eeb$var$D;
}
var $8e96884721cb3eeb$var$I = $8e96884721cb3eeb$var$H.prototype = new $8e96884721cb3eeb$var$G;
$8e96884721cb3eeb$var$I.constructor = $8e96884721cb3eeb$var$H;
$lT6GZ($8e96884721cb3eeb$var$I, $8e96884721cb3eeb$var$F.prototype);
$8e96884721cb3eeb$var$I.isPureReactComponent = !0;
var $8e96884721cb3eeb$var$J = {
    current: null
}, $8e96884721cb3eeb$var$K = Object.prototype.hasOwnProperty, $8e96884721cb3eeb$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8e96884721cb3eeb$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$8e96884721cb3eeb$var$K.call(b, e) && !$8e96884721cb3eeb$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $8e96884721cb3eeb$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $8e96884721cb3eeb$var$J.current
    };
}
function $8e96884721cb3eeb$var$N(a, b) {
    return {
        $$typeof: $8e96884721cb3eeb$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $8e96884721cb3eeb$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8e96884721cb3eeb$var$p;
}
function $8e96884721cb3eeb$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $8e96884721cb3eeb$var$P = /\/+/g, $8e96884721cb3eeb$var$Q = [];
function $8e96884721cb3eeb$var$R(a, b, c, e) {
    if ($8e96884721cb3eeb$var$Q.length) {
        var d = $8e96884721cb3eeb$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $8e96884721cb3eeb$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $8e96884721cb3eeb$var$Q.length && $8e96884721cb3eeb$var$Q.push(a);
}
function $8e96884721cb3eeb$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $8e96884721cb3eeb$var$p:
                case $8e96884721cb3eeb$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $8e96884721cb3eeb$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $8e96884721cb3eeb$var$U(d, k);
        g += $8e96884721cb3eeb$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $8e96884721cb3eeb$var$B && a[$8e96884721cb3eeb$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $8e96884721cb3eeb$var$U(d, k++), g += $8e96884721cb3eeb$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($8e96884721cb3eeb$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $8e96884721cb3eeb$var$V(a, b, c) {
    return null == a ? 0 : $8e96884721cb3eeb$var$T(a, "", b, c);
}
function $8e96884721cb3eeb$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $8e96884721cb3eeb$var$escape(a.key) : b.toString(36);
}
function $8e96884721cb3eeb$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $8e96884721cb3eeb$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $8e96884721cb3eeb$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($8e96884721cb3eeb$var$O(a) && (a = $8e96884721cb3eeb$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($8e96884721cb3eeb$var$P, "$&/") + "/") + c)), e.push(a));
}
function $8e96884721cb3eeb$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($8e96884721cb3eeb$var$P, "$&/") + "/");
    b = $8e96884721cb3eeb$var$R(b, g, e, d);
    $8e96884721cb3eeb$var$V(a, $8e96884721cb3eeb$var$aa, b);
    $8e96884721cb3eeb$var$S(b);
}
var $8e96884721cb3eeb$var$Y = {
    current: null
};
function $8e96884721cb3eeb$var$Z() {
    var a = $8e96884721cb3eeb$var$Y.current;
    if (null === a) throw Error($8e96884721cb3eeb$var$C(321));
    return a;
}
var $8e96884721cb3eeb$var$ba = {
    ReactCurrentDispatcher: $8e96884721cb3eeb$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $8e96884721cb3eeb$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $lT6GZ
};
$8e96884721cb3eeb$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $8e96884721cb3eeb$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $8e96884721cb3eeb$var$R(null, null, b, c);
        $8e96884721cb3eeb$var$V(a, $8e96884721cb3eeb$var$W, b);
        $8e96884721cb3eeb$var$S(b);
    },
    count: function(a) {
        return $8e96884721cb3eeb$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $8e96884721cb3eeb$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$8e96884721cb3eeb$var$O(a)) throw Error($8e96884721cb3eeb$var$C(143));
        return a;
    }
};
$8e96884721cb3eeb$export$16fa2f45be04daa8 = $8e96884721cb3eeb$var$F;
$8e96884721cb3eeb$export$ffb0004e005737fa = $8e96884721cb3eeb$var$r;
$8e96884721cb3eeb$export$e2c29f18771995cb = $8e96884721cb3eeb$var$u;
$8e96884721cb3eeb$export$221d75b3f55bb0bd = $8e96884721cb3eeb$var$H;
$8e96884721cb3eeb$export$5f8d39834fd61797 = $8e96884721cb3eeb$var$t;
$8e96884721cb3eeb$export$74bf444e3cd11ea5 = $8e96884721cb3eeb$var$y;
$8e96884721cb3eeb$export$ae55be85d98224ed = $8e96884721cb3eeb$var$ba;
$8e96884721cb3eeb$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($8e96884721cb3eeb$var$C(267, a));
    var e = $lT6GZ({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $8e96884721cb3eeb$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$8e96884721cb3eeb$var$K.call(b, h) && !$8e96884721cb3eeb$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $8e96884721cb3eeb$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$8e96884721cb3eeb$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $8e96884721cb3eeb$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $8e96884721cb3eeb$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$8e96884721cb3eeb$export$c8a8987d4410bf2d = $8e96884721cb3eeb$var$M;
$8e96884721cb3eeb$export$d38cd72104c1f0e9 = function(a) {
    var b = $8e96884721cb3eeb$var$M.bind(null, a);
    b.type = a;
    return b;
};
$8e96884721cb3eeb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8e96884721cb3eeb$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $8e96884721cb3eeb$var$x,
        render: a
    };
};
$8e96884721cb3eeb$export$a8257692ac88316c = $8e96884721cb3eeb$var$O;
$8e96884721cb3eeb$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $8e96884721cb3eeb$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$8e96884721cb3eeb$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $8e96884721cb3eeb$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$8e96884721cb3eeb$export$35808ee640e87ca7 = function(a, b) {
    return $8e96884721cb3eeb$var$Z().useCallback(a, b);
};
$8e96884721cb3eeb$export$fae74005e78b1a27 = function(a, b) {
    return $8e96884721cb3eeb$var$Z().useContext(a, b);
};
$8e96884721cb3eeb$export$dc8fbce3eb94dc1e = function() {};
$8e96884721cb3eeb$export$6d9c69b0de29b591 = function(a, b) {
    return $8e96884721cb3eeb$var$Z().useEffect(a, b);
};
$8e96884721cb3eeb$export$d5a552a76deda3c2 = function(a, b, c) {
    return $8e96884721cb3eeb$var$Z().useImperativeHandle(a, b, c);
};
$8e96884721cb3eeb$export$e5c5a5f917a5871c = function(a, b) {
    return $8e96884721cb3eeb$var$Z().useLayoutEffect(a, b);
};
$8e96884721cb3eeb$export$1538c33de8887b59 = function(a, b) {
    return $8e96884721cb3eeb$var$Z().useMemo(a, b);
};
$8e96884721cb3eeb$export$13e3392192263954 = function(a, b, c) {
    return $8e96884721cb3eeb$var$Z().useReducer(a, b, c);
};
$8e96884721cb3eeb$export$b8f5890fc79d6aca = function(a) {
    return $8e96884721cb3eeb$var$Z().useRef(a);
};
$8e96884721cb3eeb$export$60241385465d0a34 = function(a) {
    return $8e96884721cb3eeb$var$Z().useState(a);
};
$8e96884721cb3eeb$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("lT6GZ", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $fef3ecffb17916f5$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $fef3ecffb17916f5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $fef3ecffb17916f5$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $fef3ecffb17916f5$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $fef3ecffb17916f5$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $fef3ecffb17916f5$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $fef3ecffb17916f5$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($fef3ecffb17916f5$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($fef3ecffb17916f5$var$getOwnPropertySymbols) {
            symbols = $fef3ecffb17916f5$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($fef3ecffb17916f5$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("aYihZ", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $jiXHd = parcelRequire("jiXHd");

var $lT6GZ = parcelRequire("lT6GZ");

var $5WVcJ = parcelRequire("5WVcJ");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$jiXHd) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $jiXHd.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $lT6GZ({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $jiXHd.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $lT6GZ({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $lT6GZ({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $5WVcJ.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $5WVcJ.unstable_scheduleCallback($5WVcJ.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $5WVcJ.unstable_UserBlockingPriority, ed = $5WVcJ.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $lT6GZ({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$lT6GZ(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $lT6GZ(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $lT6GZ({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $lT6GZ({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $5WVcJ.unstable_runWithPriority, Jf = $5WVcJ.unstable_scheduleCallback, Kf = $5WVcJ.unstable_cancelCallback, Lf = $5WVcJ.unstable_requestPaint, Mf = $5WVcJ.unstable_now, Nf = $5WVcJ.unstable_getCurrentPriorityLevel, Of = $5WVcJ.unstable_ImmediatePriority, Pf = $5WVcJ.unstable_UserBlockingPriority, Qf = $5WVcJ.unstable_NormalPriority, Rf = $5WVcJ.unstable_LowPriority, Sf = $5WVcJ.unstable_IdlePriority, Tf = {}, Uf = $5WVcJ.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $lT6GZ({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $lT6GZ({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $jiXHd.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $lT6GZ({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $lT6GZ({}, f, {
                    value: void 0
                });
                d = $lT6GZ({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $lT6GZ({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($lT6GZ({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("5WVcJ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iMkz5"));

});
parcelRegister("iMkz5", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $dabca9700420a4b1$export$c4744153514ff05d; }, function (v) { return $dabca9700420a4b1$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $dabca9700420a4b1$export$d66a1c1c77bd778b; }, function (v) { return $dabca9700420a4b1$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $dabca9700420a4b1$export$3e506c1ccc9cc1a7; }, function (v) { return $dabca9700420a4b1$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $dabca9700420a4b1$export$e26fe2ed2fa76875; }, function (v) { return $dabca9700420a4b1$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $dabca9700420a4b1$export$502329bbf4b505b1; }, function (v) { return $dabca9700420a4b1$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $dabca9700420a4b1$export$6e3807111c4874c4; }, function (v) { return $dabca9700420a4b1$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $dabca9700420a4b1$export$c27134553091fb3a; }, function (v) { return $dabca9700420a4b1$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $dabca9700420a4b1$export$33ee1acdc04fd2a2; }, function (v) { return $dabca9700420a4b1$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $dabca9700420a4b1$export$b00a404bbd5edef2; }, function (v) { return $dabca9700420a4b1$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $dabca9700420a4b1$export$8352ce38b91d0c62; }, function (v) { return $dabca9700420a4b1$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $dabca9700420a4b1$export$d3dfb8e4810cb555; }, function (v) { return $dabca9700420a4b1$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $dabca9700420a4b1$export$839f9183b0465a69; }, function (v) { return $dabca9700420a4b1$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $dabca9700420a4b1$export$72fdf0e06517287b; }, function (v) { return $dabca9700420a4b1$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $dabca9700420a4b1$export$4b844e58a3e414b4; }, function (v) { return $dabca9700420a4b1$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $dabca9700420a4b1$export$816d2913ae6b83b1; }, function (v) { return $dabca9700420a4b1$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $dabca9700420a4b1$export$61bcfe829111a1d0; }, function (v) { return $dabca9700420a4b1$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $dabca9700420a4b1$export$7ee8c9beb337bc3f; }, function (v) { return $dabca9700420a4b1$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $dabca9700420a4b1$export$b5836b71941fa3ed; }, function (v) { return $dabca9700420a4b1$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $dabca9700420a4b1$export$cf845f2c119da08a; }, function (v) { return $dabca9700420a4b1$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dabca9700420a4b1$export$c4744153514ff05d;
var $dabca9700420a4b1$export$d66a1c1c77bd778b;
var $dabca9700420a4b1$export$3e506c1ccc9cc1a7;
var $dabca9700420a4b1$export$e26fe2ed2fa76875;
var $dabca9700420a4b1$export$502329bbf4b505b1;
var $dabca9700420a4b1$export$6e3807111c4874c4;
var $dabca9700420a4b1$export$c27134553091fb3a;
var $dabca9700420a4b1$export$33ee1acdc04fd2a2;
var $dabca9700420a4b1$export$b00a404bbd5edef2;
var $dabca9700420a4b1$export$8352ce38b91d0c62;
var $dabca9700420a4b1$export$d3dfb8e4810cb555;
var $dabca9700420a4b1$export$839f9183b0465a69;
var $dabca9700420a4b1$export$72fdf0e06517287b;
var $dabca9700420a4b1$export$4b844e58a3e414b4;
var $dabca9700420a4b1$export$816d2913ae6b83b1;
var $dabca9700420a4b1$export$61bcfe829111a1d0;
var $dabca9700420a4b1$export$7ee8c9beb337bc3f;
var $dabca9700420a4b1$export$b5836b71941fa3ed;
var $dabca9700420a4b1$export$cf845f2c119da08a;
'use strict';
var $dabca9700420a4b1$var$f, $dabca9700420a4b1$var$g, $dabca9700420a4b1$var$h, $dabca9700420a4b1$var$k, $dabca9700420a4b1$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $dabca9700420a4b1$var$p = null, $dabca9700420a4b1$var$q = null, $dabca9700420a4b1$var$t = function() {
        if (null !== $dabca9700420a4b1$var$p) try {
            var a = $dabca9700420a4b1$export$c4744153514ff05d();
            $dabca9700420a4b1$var$p(!0, a);
            $dabca9700420a4b1$var$p = null;
        } catch (b) {
            throw setTimeout($dabca9700420a4b1$var$t, 0), b;
        }
    }, $dabca9700420a4b1$var$u = Date.now();
    $dabca9700420a4b1$export$c4744153514ff05d = function() {
        return Date.now() - $dabca9700420a4b1$var$u;
    };
    $dabca9700420a4b1$var$f = function(a) {
        null !== $dabca9700420a4b1$var$p ? setTimeout($dabca9700420a4b1$var$f, 0, a) : ($dabca9700420a4b1$var$p = a, setTimeout($dabca9700420a4b1$var$t, 0));
    };
    $dabca9700420a4b1$var$g = function(a, b) {
        $dabca9700420a4b1$var$q = setTimeout(a, b);
    };
    $dabca9700420a4b1$var$h = function() {
        clearTimeout($dabca9700420a4b1$var$q);
    };
    $dabca9700420a4b1$var$k = function() {
        return !1;
    };
    $dabca9700420a4b1$var$l = $dabca9700420a4b1$export$d66a1c1c77bd778b = function() {};
} else {
    var $dabca9700420a4b1$var$w = window.performance, $dabca9700420a4b1$var$x = window.Date, $dabca9700420a4b1$var$y = window.setTimeout, $dabca9700420a4b1$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $dabca9700420a4b1$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $dabca9700420a4b1$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $dabca9700420a4b1$var$w && "function" === typeof $dabca9700420a4b1$var$w.now) $dabca9700420a4b1$export$c4744153514ff05d = function() {
        return $dabca9700420a4b1$var$w.now();
    };
    else {
        var $dabca9700420a4b1$var$B = $dabca9700420a4b1$var$x.now();
        $dabca9700420a4b1$export$c4744153514ff05d = function() {
            return $dabca9700420a4b1$var$x.now() - $dabca9700420a4b1$var$B;
        };
    }
    var $dabca9700420a4b1$var$C = !1, $dabca9700420a4b1$var$D = null, $dabca9700420a4b1$var$E = -1, $dabca9700420a4b1$var$F = 5, $dabca9700420a4b1$var$G = 0;
    $dabca9700420a4b1$var$k = function() {
        return $dabca9700420a4b1$export$c4744153514ff05d() >= $dabca9700420a4b1$var$G;
    };
    $dabca9700420a4b1$var$l = function() {};
    $dabca9700420a4b1$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $dabca9700420a4b1$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $dabca9700420a4b1$var$H = new MessageChannel, $dabca9700420a4b1$var$I = $dabca9700420a4b1$var$H.port2;
    $dabca9700420a4b1$var$H.port1.onmessage = function() {
        if (null !== $dabca9700420a4b1$var$D) {
            var a = $dabca9700420a4b1$export$c4744153514ff05d();
            $dabca9700420a4b1$var$G = a + $dabca9700420a4b1$var$F;
            try {
                $dabca9700420a4b1$var$D(!0, a) ? $dabca9700420a4b1$var$I.postMessage(null) : ($dabca9700420a4b1$var$C = !1, $dabca9700420a4b1$var$D = null);
            } catch (b) {
                throw $dabca9700420a4b1$var$I.postMessage(null), b;
            }
        } else $dabca9700420a4b1$var$C = !1;
    };
    $dabca9700420a4b1$var$f = function(a) {
        $dabca9700420a4b1$var$D = a;
        $dabca9700420a4b1$var$C || ($dabca9700420a4b1$var$C = !0, $dabca9700420a4b1$var$I.postMessage(null));
    };
    $dabca9700420a4b1$var$g = function(a, b) {
        $dabca9700420a4b1$var$E = $dabca9700420a4b1$var$y(function() {
            a($dabca9700420a4b1$export$c4744153514ff05d());
        }, b);
    };
    $dabca9700420a4b1$var$h = function() {
        $dabca9700420a4b1$var$z($dabca9700420a4b1$var$E);
        $dabca9700420a4b1$var$E = -1;
    };
}
function $dabca9700420a4b1$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $dabca9700420a4b1$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $dabca9700420a4b1$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $dabca9700420a4b1$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $dabca9700420a4b1$var$K(n, c)) void 0 !== r && 0 > $dabca9700420a4b1$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $dabca9700420a4b1$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $dabca9700420a4b1$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $dabca9700420a4b1$var$N = [], $dabca9700420a4b1$var$O = [], $dabca9700420a4b1$var$P = 1, $dabca9700420a4b1$var$Q = null, $dabca9700420a4b1$var$R = 3, $dabca9700420a4b1$var$S = !1, $dabca9700420a4b1$var$T = !1, $dabca9700420a4b1$var$U = !1;
function $dabca9700420a4b1$var$V(a) {
    for(var b = $dabca9700420a4b1$var$L($dabca9700420a4b1$var$O); null !== b;){
        if (null === b.callback) $dabca9700420a4b1$var$M($dabca9700420a4b1$var$O);
        else if (b.startTime <= a) $dabca9700420a4b1$var$M($dabca9700420a4b1$var$O), b.sortIndex = b.expirationTime, $dabca9700420a4b1$var$J($dabca9700420a4b1$var$N, b);
        else break;
        b = $dabca9700420a4b1$var$L($dabca9700420a4b1$var$O);
    }
}
function $dabca9700420a4b1$var$W(a) {
    $dabca9700420a4b1$var$U = !1;
    $dabca9700420a4b1$var$V(a);
    if (!$dabca9700420a4b1$var$T) {
        if (null !== $dabca9700420a4b1$var$L($dabca9700420a4b1$var$N)) $dabca9700420a4b1$var$T = !0, $dabca9700420a4b1$var$f($dabca9700420a4b1$var$X);
        else {
            var b = $dabca9700420a4b1$var$L($dabca9700420a4b1$var$O);
            null !== b && $dabca9700420a4b1$var$g($dabca9700420a4b1$var$W, b.startTime - a);
        }
    }
}
function $dabca9700420a4b1$var$X(a, b) {
    $dabca9700420a4b1$var$T = !1;
    $dabca9700420a4b1$var$U && ($dabca9700420a4b1$var$U = !1, $dabca9700420a4b1$var$h());
    $dabca9700420a4b1$var$S = !0;
    var c = $dabca9700420a4b1$var$R;
    try {
        $dabca9700420a4b1$var$V(b);
        for($dabca9700420a4b1$var$Q = $dabca9700420a4b1$var$L($dabca9700420a4b1$var$N); null !== $dabca9700420a4b1$var$Q && (!($dabca9700420a4b1$var$Q.expirationTime > b) || a && !$dabca9700420a4b1$var$k());){
            var d = $dabca9700420a4b1$var$Q.callback;
            if (null !== d) {
                $dabca9700420a4b1$var$Q.callback = null;
                $dabca9700420a4b1$var$R = $dabca9700420a4b1$var$Q.priorityLevel;
                var e = d($dabca9700420a4b1$var$Q.expirationTime <= b);
                b = $dabca9700420a4b1$export$c4744153514ff05d();
                "function" === typeof e ? $dabca9700420a4b1$var$Q.callback = e : $dabca9700420a4b1$var$Q === $dabca9700420a4b1$var$L($dabca9700420a4b1$var$N) && $dabca9700420a4b1$var$M($dabca9700420a4b1$var$N);
                $dabca9700420a4b1$var$V(b);
            } else $dabca9700420a4b1$var$M($dabca9700420a4b1$var$N);
            $dabca9700420a4b1$var$Q = $dabca9700420a4b1$var$L($dabca9700420a4b1$var$N);
        }
        if (null !== $dabca9700420a4b1$var$Q) var m = !0;
        else {
            var n = $dabca9700420a4b1$var$L($dabca9700420a4b1$var$O);
            null !== n && $dabca9700420a4b1$var$g($dabca9700420a4b1$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $dabca9700420a4b1$var$Q = null, $dabca9700420a4b1$var$R = c, $dabca9700420a4b1$var$S = !1;
    }
}
function $dabca9700420a4b1$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $dabca9700420a4b1$var$Z = $dabca9700420a4b1$var$l;
$dabca9700420a4b1$export$3e506c1ccc9cc1a7 = 5;
$dabca9700420a4b1$export$e26fe2ed2fa76875 = 1;
$dabca9700420a4b1$export$502329bbf4b505b1 = 4;
$dabca9700420a4b1$export$6e3807111c4874c4 = 3;
$dabca9700420a4b1$export$c27134553091fb3a = null;
$dabca9700420a4b1$export$33ee1acdc04fd2a2 = 2;
$dabca9700420a4b1$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$dabca9700420a4b1$export$8352ce38b91d0c62 = function() {
    $dabca9700420a4b1$var$T || $dabca9700420a4b1$var$S || ($dabca9700420a4b1$var$T = !0, $dabca9700420a4b1$var$f($dabca9700420a4b1$var$X));
};
$dabca9700420a4b1$export$d3dfb8e4810cb555 = function() {
    return $dabca9700420a4b1$var$R;
};
$dabca9700420a4b1$export$839f9183b0465a69 = function() {
    return $dabca9700420a4b1$var$L($dabca9700420a4b1$var$N);
};
$dabca9700420a4b1$export$72fdf0e06517287b = function(a) {
    switch($dabca9700420a4b1$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $dabca9700420a4b1$var$R;
    }
    var c = $dabca9700420a4b1$var$R;
    $dabca9700420a4b1$var$R = b;
    try {
        return a();
    } finally{
        $dabca9700420a4b1$var$R = c;
    }
};
$dabca9700420a4b1$export$4b844e58a3e414b4 = function() {};
$dabca9700420a4b1$export$816d2913ae6b83b1 = $dabca9700420a4b1$var$Z;
$dabca9700420a4b1$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $dabca9700420a4b1$var$R;
    $dabca9700420a4b1$var$R = a;
    try {
        return b();
    } finally{
        $dabca9700420a4b1$var$R = c;
    }
};
$dabca9700420a4b1$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $dabca9700420a4b1$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $dabca9700420a4b1$var$Y(a);
    } else c = $dabca9700420a4b1$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $dabca9700420a4b1$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $dabca9700420a4b1$var$J($dabca9700420a4b1$var$O, a), null === $dabca9700420a4b1$var$L($dabca9700420a4b1$var$N) && a === $dabca9700420a4b1$var$L($dabca9700420a4b1$var$O) && ($dabca9700420a4b1$var$U ? $dabca9700420a4b1$var$h() : $dabca9700420a4b1$var$U = !0, $dabca9700420a4b1$var$g($dabca9700420a4b1$var$W, e - d))) : (a.sortIndex = c, $dabca9700420a4b1$var$J($dabca9700420a4b1$var$N, a), $dabca9700420a4b1$var$T || $dabca9700420a4b1$var$S || ($dabca9700420a4b1$var$T = !0, $dabca9700420a4b1$var$f($dabca9700420a4b1$var$X)));
    return a;
};
$dabca9700420a4b1$export$b5836b71941fa3ed = function() {
    var a = $dabca9700420a4b1$export$c4744153514ff05d();
    $dabca9700420a4b1$var$V(a);
    var b = $dabca9700420a4b1$var$L($dabca9700420a4b1$var$N);
    return b !== $dabca9700420a4b1$var$Q && null !== $dabca9700420a4b1$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $dabca9700420a4b1$var$Q.expirationTime || $dabca9700420a4b1$var$k();
};
$dabca9700420a4b1$export$cf845f2c119da08a = function(a) {
    var b = $dabca9700420a4b1$var$R;
    return function() {
        var c = $dabca9700420a4b1$var$R;
        $dabca9700420a4b1$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $dabca9700420a4b1$var$R = c;
        }
    };
};

});



parcelRegister("ePVXJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $acd2ca3a5c9d1761$var$ReactIs, $acd2ca3a5c9d1761$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("l8iAC"))();

});
parcelRegister("l8iAC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $4h7zD = parcelRequire("4h7zD");
function $f628c3d190765fe9$var$emptyFunction() {}
function $f628c3d190765fe9$var$emptyFunctionWithReset() {}
$f628c3d190765fe9$var$emptyFunctionWithReset.resetWarningCache = $f628c3d190765fe9$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $4h7zD) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f628c3d190765fe9$var$emptyFunctionWithReset,
        resetWarningCache: $f628c3d190765fe9$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("4h7zD", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $31ce9fec49f68503$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $31ce9fec49f68503$var$ReactPropTypesSecret;

});



parcelRegister("dBqQ7", function(module, exports) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */ (function(global, factory) {
    module.exports = factory(function() {
        try {
            return (parcelRequire("g8ofX"));
        } catch (e) {}
    }());
})(module.exports, function(moment) {
    'use strict';
    moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    function getCjsExportFromNamespace(n) {
        return n && n['default'] || n;
    }
    var colorName = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    var conversions = createCommonjsModule(function(module1) {
        /* MIT license */ // NOTE: conversions should only return primitive values (i.e. arrays, or
        //       values that give correct `typeof` results).
        //       do not use box values types (i.e. Number(), String(), etc.)
        var reverseKeywords = {};
        for(var key in colorName)if (colorName.hasOwnProperty(key)) reverseKeywords[colorName[key]] = key;
        var convert = module1.exports = {
            rgb: {
                channels: 3,
                labels: 'rgb'
            },
            hsl: {
                channels: 3,
                labels: 'hsl'
            },
            hsv: {
                channels: 3,
                labels: 'hsv'
            },
            hwb: {
                channels: 3,
                labels: 'hwb'
            },
            cmyk: {
                channels: 4,
                labels: 'cmyk'
            },
            xyz: {
                channels: 3,
                labels: 'xyz'
            },
            lab: {
                channels: 3,
                labels: 'lab'
            },
            lch: {
                channels: 3,
                labels: 'lch'
            },
            hex: {
                channels: 1,
                labels: [
                    'hex'
                ]
            },
            keyword: {
                channels: 1,
                labels: [
                    'keyword'
                ]
            },
            ansi16: {
                channels: 1,
                labels: [
                    'ansi16'
                ]
            },
            ansi256: {
                channels: 1,
                labels: [
                    'ansi256'
                ]
            },
            hcg: {
                channels: 3,
                labels: [
                    'h',
                    'c',
                    'g'
                ]
            },
            apple: {
                channels: 3,
                labels: [
                    'r16',
                    'g16',
                    'b16'
                ]
            },
            gray: {
                channels: 1,
                labels: [
                    'gray'
                ]
            }
        };
        // hide .channels and .labels properties
        for(var model in convert)if (convert.hasOwnProperty(model)) {
            if (!('channels' in convert[model])) throw new Error('missing channels property: ' + model);
            if (!('labels' in convert[model])) throw new Error('missing channel labels property: ' + model);
            if (convert[model].labels.length !== convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
            var channels = convert[model].channels;
            var labels = convert[model].labels;
            delete convert[model].channels;
            delete convert[model].labels;
            Object.defineProperty(convert[model], 'channels', {
                value: channels
            });
            Object.defineProperty(convert[model], 'labels', {
                value: labels
            });
        }
        convert.rgb.hsl = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var min = Math.min(r, g, b);
            var max = Math.max(r, g, b);
            var delta = max - min;
            var h;
            var s;
            var l;
            if (max === min) h = 0;
            else if (r === max) h = (g - b) / delta;
            else if (g === max) h = 2 + (b - r) / delta;
            else if (b === max) h = 4 + (r - g) / delta;
            h = Math.min(h * 60, 360);
            if (h < 0) h += 360;
            l = (min + max) / 2;
            if (max === min) s = 0;
            else if (l <= 0.5) s = delta / (max + min);
            else s = delta / (2 - max - min);
            return [
                h,
                s * 100,
                l * 100
            ];
        };
        convert.rgb.hsv = function(rgb) {
            var rdif;
            var gdif;
            var bdif;
            var h;
            var s;
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var v = Math.max(r, g, b);
            var diff = v - Math.min(r, g, b);
            var diffc = function(c) {
                return (v - c) / 6 / diff + 0.5;
            };
            if (diff === 0) h = s = 0;
            else {
                s = diff / v;
                rdif = diffc(r);
                gdif = diffc(g);
                bdif = diffc(b);
                if (r === v) h = bdif - gdif;
                else if (g === v) h = 1 / 3 + rdif - bdif;
                else if (b === v) h = 2 / 3 + gdif - rdif;
                if (h < 0) h += 1;
                else if (h > 1) h -= 1;
            }
            return [
                h * 360,
                s * 100,
                v * 100
            ];
        };
        convert.rgb.hwb = function(rgb) {
            var r = rgb[0];
            var g = rgb[1];
            var b = rgb[2];
            var h = convert.rgb.hsl(rgb)[0];
            var w = 1 / 255 * Math.min(r, Math.min(g, b));
            b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
            return [
                h,
                w * 100,
                b * 100
            ];
        };
        convert.rgb.cmyk = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var c;
            var m;
            var y;
            var k;
            k = Math.min(1 - r, 1 - g, 1 - b);
            c = (1 - r - k) / (1 - k) || 0;
            m = (1 - g - k) / (1 - k) || 0;
            y = (1 - b - k) / (1 - k) || 0;
            return [
                c * 100,
                m * 100,
                y * 100,
                k * 100
            ];
        };
        /**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
            return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
        }
        convert.rgb.keyword = function(rgb) {
            var reversed = reverseKeywords[rgb];
            if (reversed) return reversed;
            var currentClosestDistance = Infinity;
            var currentClosestKeyword;
            for(var keyword in colorName)if (colorName.hasOwnProperty(keyword)) {
                var value = colorName[keyword];
                // Compute comparative distance
                var distance = comparativeDistance(rgb, value);
                // Check if its less, if so set as closest
                if (distance < currentClosestDistance) {
                    currentClosestDistance = distance;
                    currentClosestKeyword = keyword;
                }
            }
            return currentClosestKeyword;
        };
        convert.keyword.rgb = function(keyword) {
            return colorName[keyword];
        };
        convert.rgb.xyz = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            // assume sRGB
            r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
            g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
            b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
            var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
            var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
            var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
            return [
                x * 100,
                y * 100,
                z * 100
            ];
        };
        convert.rgb.lab = function(rgb) {
            var xyz = convert.rgb.xyz(rgb);
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.hsl.rgb = function(hsl) {
            var h = hsl[0] / 360;
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var t1;
            var t2;
            var t3;
            var rgb;
            var val;
            if (s === 0) {
                val = l * 255;
                return [
                    val,
                    val,
                    val
                ];
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            t1 = 2 * l - t2;
            rgb = [
                0,
                0,
                0
            ];
            for(var i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return rgb;
        };
        convert.hsl.hsv = function(hsl) {
            var h = hsl[0];
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var smin = s;
            var lmin = Math.max(l, 0.01);
            var sv;
            var v;
            l *= 2;
            s *= l <= 1 ? l : 2 - l;
            smin *= lmin <= 1 ? lmin : 2 - lmin;
            v = (l + s) / 2;
            sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
            return [
                h,
                sv * 100,
                v * 100
            ];
        };
        convert.hsv.rgb = function(hsv) {
            var h = hsv[0] / 60;
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var hi = Math.floor(h) % 6;
            var f = h - Math.floor(h);
            var p = 255 * v * (1 - s);
            var q = 255 * v * (1 - s * f);
            var t = 255 * v * (1 - s * (1 - f));
            v *= 255;
            switch(hi){
                case 0:
                    return [
                        v,
                        t,
                        p
                    ];
                case 1:
                    return [
                        q,
                        v,
                        p
                    ];
                case 2:
                    return [
                        p,
                        v,
                        t
                    ];
                case 3:
                    return [
                        p,
                        q,
                        v
                    ];
                case 4:
                    return [
                        t,
                        p,
                        v
                    ];
                case 5:
                    return [
                        v,
                        p,
                        q
                    ];
            }
        };
        convert.hsv.hsl = function(hsv) {
            var h = hsv[0];
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var vmin = Math.max(v, 0.01);
            var lmin;
            var sl;
            var l;
            l = (2 - s) * v;
            lmin = (2 - s) * vmin;
            sl = s * vmin;
            sl /= lmin <= 1 ? lmin : 2 - lmin;
            sl = sl || 0;
            l /= 2;
            return [
                h,
                sl * 100,
                l * 100
            ];
        };
        // http://dev.w3.org/csswg/css-color/#hwb-to-rgb
        convert.hwb.rgb = function(hwb) {
            var h = hwb[0] / 360;
            var wh = hwb[1] / 100;
            var bl = hwb[2] / 100;
            var ratio = wh + bl;
            var i;
            var v;
            var f;
            var n;
            // wh + bl cant be > 1
            if (ratio > 1) {
                wh /= ratio;
                bl /= ratio;
            }
            i = Math.floor(6 * h);
            v = 1 - bl;
            f = 6 * h - i;
            if ((i & 0x01) !== 0) f = 1 - f;
            n = wh + f * (v - wh); // linear interpolation
            var r;
            var g;
            var b;
            switch(i){
                default:
                case 6:
                case 0:
                    r = v;
                    g = n;
                    b = wh;
                    break;
                case 1:
                    r = n;
                    g = v;
                    b = wh;
                    break;
                case 2:
                    r = wh;
                    g = v;
                    b = n;
                    break;
                case 3:
                    r = wh;
                    g = n;
                    b = v;
                    break;
                case 4:
                    r = n;
                    g = wh;
                    b = v;
                    break;
                case 5:
                    r = v;
                    g = wh;
                    b = n;
                    break;
            }
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.cmyk.rgb = function(cmyk) {
            var c = cmyk[0] / 100;
            var m = cmyk[1] / 100;
            var y = cmyk[2] / 100;
            var k = cmyk[3] / 100;
            var r;
            var g;
            var b;
            r = 1 - Math.min(1, c * (1 - k) + k);
            g = 1 - Math.min(1, m * (1 - k) + k);
            b = 1 - Math.min(1, y * (1 - k) + k);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.rgb = function(xyz) {
            var x = xyz[0] / 100;
            var y = xyz[1] / 100;
            var z = xyz[2] / 100;
            var r;
            var g;
            var b;
            r = x * 3.2406 + y * -1.5372 + z * -0.4986;
            g = x * -0.9689 + y * 1.8758 + z * 0.0415;
            b = x * 0.0557 + y * -0.204 + z * 1.0570;
            // assume sRGB
            r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
            g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
            b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
            r = Math.min(Math.max(0, r), 1);
            g = Math.min(Math.max(0, g), 1);
            b = Math.min(Math.max(0, b), 1);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.lab = function(xyz) {
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.lab.xyz = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var x;
            var y;
            var z;
            y = (l + 16) / 116;
            x = a / 500 + y;
            z = y - b / 200;
            var y2 = Math.pow(y, 3);
            var x2 = Math.pow(x, 3);
            var z2 = Math.pow(z, 3);
            y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
            x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
            z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
            x *= 95.047;
            y *= 100;
            z *= 108.883;
            return [
                x,
                y,
                z
            ];
        };
        convert.lab.lch = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var hr;
            var h;
            var c;
            hr = Math.atan2(b, a);
            h = hr * 360 / 2 / Math.PI;
            if (h < 0) h += 360;
            c = Math.sqrt(a * a + b * b);
            return [
                l,
                c,
                h
            ];
        };
        convert.lch.lab = function(lch) {
            var l = lch[0];
            var c = lch[1];
            var h = lch[2];
            var a;
            var b;
            var hr;
            hr = h / 360 * 2 * Math.PI;
            a = c * Math.cos(hr);
            b = c * Math.sin(hr);
            return [
                l,
                a,
                b
            ];
        };
        convert.rgb.ansi16 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
            value = Math.round(value / 50);
            if (value === 0) return 30;
            var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
            if (value === 2) ansi += 60;
            return ansi;
        };
        convert.hsv.ansi16 = function(args) {
            // optimization here; we already know the value and don't need to get
            // it converted for us.
            return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
        };
        convert.rgb.ansi256 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            // we use the extended greyscale palette here, with the exception of
            // black and white. normal palette only has 4 greyscale shades.
            if (r === g && g === b) {
                if (r < 8) return 16;
                if (r > 248) return 231;
                return Math.round((r - 8) / 247 * 24) + 232;
            }
            var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
            return ansi;
        };
        convert.ansi16.rgb = function(args) {
            var color = args % 10;
            // handle greyscale
            if (color === 0 || color === 7) {
                if (args > 50) color += 3.5;
                color = color / 10.5 * 255;
                return [
                    color,
                    color,
                    color
                ];
            }
            var mult = (~~(args > 50) + 1) * 0.5;
            var r = (color & 1) * mult * 255;
            var g = (color >> 1 & 1) * mult * 255;
            var b = (color >> 2 & 1) * mult * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.ansi256.rgb = function(args) {
            // handle greyscale
            if (args >= 232) {
                var c = (args - 232) * 10 + 8;
                return [
                    c,
                    c,
                    c
                ];
            }
            args -= 16;
            var rem;
            var r = Math.floor(args / 36) / 5 * 255;
            var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
            var b = rem % 6 / 5 * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hex = function(args) {
            var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
            var string = integer.toString(16).toUpperCase();
            return '000000'.substring(string.length) + string;
        };
        convert.hex.rgb = function(args) {
            var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!match) return [
                0,
                0,
                0
            ];
            var colorString = match[0];
            if (match[0].length === 3) colorString = colorString.split('').map(function(char) {
                return char + char;
            }).join('');
            var integer = parseInt(colorString, 16);
            var r = integer >> 16 & 0xFF;
            var g = integer >> 8 & 0xFF;
            var b = integer & 0xFF;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hcg = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var max = Math.max(Math.max(r, g), b);
            var min = Math.min(Math.min(r, g), b);
            var chroma = max - min;
            var grayscale;
            var hue;
            if (chroma < 1) grayscale = min / (1 - chroma);
            else grayscale = 0;
            if (chroma <= 0) hue = 0;
            else if (max === r) hue = (g - b) / chroma % 6;
            else if (max === g) hue = 2 + (b - r) / chroma;
            else hue = 4 + (r - g) / chroma + 4;
            hue /= 6;
            hue %= 1;
            return [
                hue * 360,
                chroma * 100,
                grayscale * 100
            ];
        };
        convert.hsl.hcg = function(hsl) {
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var c = 1;
            var f = 0;
            if (l < 0.5) c = 2.0 * s * l;
            else c = 2.0 * s * (1.0 - l);
            if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
            return [
                hsl[0],
                c * 100,
                f * 100
            ];
        };
        convert.hsv.hcg = function(hsv) {
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var c = s * v;
            var f = 0;
            if (c < 1.0) f = (v - c) / (1 - c);
            return [
                hsv[0],
                c * 100,
                f * 100
            ];
        };
        convert.hcg.rgb = function(hcg) {
            var h = hcg[0] / 360;
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            if (c === 0.0) return [
                g * 255,
                g * 255,
                g * 255
            ];
            var pure = [
                0,
                0,
                0
            ];
            var hi = h % 1 * 6;
            var v = hi % 1;
            var w = 1 - v;
            var mg = 0;
            switch(Math.floor(hi)){
                case 0:
                    pure[0] = 1;
                    pure[1] = v;
                    pure[2] = 0;
                    break;
                case 1:
                    pure[0] = w;
                    pure[1] = 1;
                    pure[2] = 0;
                    break;
                case 2:
                    pure[0] = 0;
                    pure[1] = 1;
                    pure[2] = v;
                    break;
                case 3:
                    pure[0] = 0;
                    pure[1] = w;
                    pure[2] = 1;
                    break;
                case 4:
                    pure[0] = v;
                    pure[1] = 0;
                    pure[2] = 1;
                    break;
                default:
                    pure[0] = 1;
                    pure[1] = 0;
                    pure[2] = w;
            }
            mg = (1.0 - c) * g;
            return [
                (c * pure[0] + mg) * 255,
                (c * pure[1] + mg) * 255,
                (c * pure[2] + mg) * 255
            ];
        };
        convert.hcg.hsv = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            var f = 0;
            if (v > 0.0) f = c / v;
            return [
                hcg[0],
                f * 100,
                v * 100
            ];
        };
        convert.hcg.hsl = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var l = g * (1.0 - c) + 0.5 * c;
            var s = 0;
            if (l > 0.0 && l < 0.5) s = c / (2 * l);
            else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
            return [
                hcg[0],
                s * 100,
                l * 100
            ];
        };
        convert.hcg.hwb = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            return [
                hcg[0],
                (v - c) * 100,
                (1 - v) * 100
            ];
        };
        convert.hwb.hcg = function(hwb) {
            var w = hwb[1] / 100;
            var b = hwb[2] / 100;
            var v = 1 - b;
            var c = v - w;
            var g = 0;
            if (c < 1) g = (v - c) / (1 - c);
            return [
                hwb[0],
                c * 100,
                g * 100
            ];
        };
        convert.apple.rgb = function(apple) {
            return [
                apple[0] / 65535 * 255,
                apple[1] / 65535 * 255,
                apple[2] / 65535 * 255
            ];
        };
        convert.rgb.apple = function(rgb) {
            return [
                rgb[0] / 255 * 65535,
                rgb[1] / 255 * 65535,
                rgb[2] / 255 * 65535
            ];
        };
        convert.gray.rgb = function(args) {
            return [
                args[0] / 100 * 255,
                args[0] / 100 * 255,
                args[0] / 100 * 255
            ];
        };
        convert.gray.hsl = convert.gray.hsv = function(args) {
            return [
                0,
                0,
                args[0]
            ];
        };
        convert.gray.hwb = function(gray) {
            return [
                0,
                100,
                gray[0]
            ];
        };
        convert.gray.cmyk = function(gray) {
            return [
                0,
                0,
                0,
                gray[0]
            ];
        };
        convert.gray.lab = function(gray) {
            return [
                gray[0],
                0,
                0
            ];
        };
        convert.gray.hex = function(gray) {
            var val = Math.round(gray[0] / 100 * 255) & 0xFF;
            var integer = (val << 16) + (val << 8) + val;
            var string = integer.toString(16).toUpperCase();
            return '000000'.substring(string.length) + string;
        };
        convert.rgb.gray = function(rgb) {
            var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
            return [
                val / 255 * 100
            ];
        };
    });
    var conversions_1 = conversions.rgb;
    var conversions_2 = conversions.hsl;
    var conversions_3 = conversions.hsv;
    var conversions_4 = conversions.hwb;
    var conversions_5 = conversions.cmyk;
    var conversions_6 = conversions.xyz;
    var conversions_7 = conversions.lab;
    var conversions_8 = conversions.lch;
    var conversions_9 = conversions.hex;
    var conversions_10 = conversions.keyword;
    var conversions_11 = conversions.ansi16;
    var conversions_12 = conversions.ansi256;
    var conversions_13 = conversions.hcg;
    var conversions_14 = conversions.apple;
    var conversions_15 = conversions.gray;
    /*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
        var graph = {};
        // https://jsperf.com/object-keys-vs-for-in-with-closure/3
        var models = Object.keys(conversions);
        for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
            // http://jsperf.com/1-vs-infinity
            // micro-opt, but this is simple.
            distance: -1,
            parent: null
        };
        return graph;
    }
    // https://en.wikipedia.org/wiki/Breadth-first_search
    function deriveBFS(fromModel) {
        var graph = buildGraph();
        var queue = [
            fromModel
        ]; // unshift -> queue -> pop
        graph[fromModel].distance = 0;
        while(queue.length){
            var current = queue.pop();
            var adjacents = Object.keys(conversions[current]);
            for(var len = adjacents.length, i = 0; i < len; i++){
                var adjacent = adjacents[i];
                var node = graph[adjacent];
                if (node.distance === -1) {
                    node.distance = graph[current].distance + 1;
                    node.parent = current;
                    queue.unshift(adjacent);
                }
            }
        }
        return graph;
    }
    function link(from, to) {
        return function(args) {
            return to(from(args));
        };
    }
    function wrapConversion(toModel, graph) {
        var path = [
            graph[toModel].parent,
            toModel
        ];
        var fn = conversions[graph[toModel].parent][toModel];
        var cur = graph[toModel].parent;
        while(graph[cur].parent){
            path.unshift(graph[cur].parent);
            fn = link(conversions[graph[cur].parent][cur], fn);
            cur = graph[cur].parent;
        }
        fn.conversion = path;
        return fn;
    }
    var route = function(fromModel) {
        var graph = deriveBFS(fromModel);
        var conversion = {};
        var models = Object.keys(graph);
        for(var len = models.length, i = 0; i < len; i++){
            var toModel = models[i];
            var node = graph[toModel];
            if (node.parent === null) continue;
            conversion[toModel] = wrapConversion(toModel, graph);
        }
        return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            return fn(args);
        };
        // preserve .conversion property if there is one
        if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    function wrapRounded(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            var result = fn(args);
            // we're assuming the result is an array here.
            // see notice in conversions.js; don't use box types
            // in conversion functions.
            if (typeof result === 'object') for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
            return result;
        };
        // preserve .conversion property if there is one
        if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    models.forEach(function(fromModel) {
        convert[fromModel] = {};
        Object.defineProperty(convert[fromModel], 'channels', {
            value: conversions[fromModel].channels
        });
        Object.defineProperty(convert[fromModel], 'labels', {
            value: conversions[fromModel].labels
        });
        var routes = route(fromModel);
        var routeModels = Object.keys(routes);
        routeModels.forEach(function(toModel) {
            var fn = routes[toModel];
            convert[fromModel][toModel] = wrapRounded(fn);
            convert[fromModel][toModel].raw = wrapRaw(fn);
        });
    });
    var colorConvert = convert;
    var colorName$1 = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    /* MIT license */ var colorString = {
        getRgba: getRgba,
        getHsla: getHsla,
        getRgb: getRgb,
        getHsl: getHsl,
        getHwb: getHwb,
        getAlpha: getAlpha,
        hexString: hexString,
        rgbString: rgbString,
        rgbaString: rgbaString,
        percentString: percentString,
        percentaString: percentaString,
        hslString: hslString,
        hslaString: hslaString,
        hwbString: hwbString,
        keyword: keyword
    };
    function getRgba(string) {
        if (!string) return;
        var abbr = /^#([a-fA-F0-9]{3,4})$/i, hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i, rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, keyword = /(\w+)/;
        var rgb = [
            0,
            0,
            0
        ], a = 1, match = string.match(abbr), hexAlpha = "";
        if (match) {
            match = match[1];
            hexAlpha = match[3];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i] + match[i], 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(rgba)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i + 1]);
            a = parseFloat(match[4]);
        } else if (match = string.match(per)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            a = parseFloat(match[4]);
        } else if (match = string.match(keyword)) {
            if (match[1] == "transparent") return [
                0,
                0,
                0,
                0
            ];
            rgb = colorName$1[match[1]];
            if (!rgb) return;
        }
        for(var i = 0; i < rgb.length; i++)rgb[i] = scale(rgb[i], 0, 255);
        if (!a && a != 0) a = 1;
        else a = scale(a, 0, 1);
        rgb[3] = a;
        return rgb;
    }
    function getHsla(string) {
        if (!string) return;
        var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hsl);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), s = scale(parseFloat(match[2]), 0, 100), l = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                s,
                l,
                a
            ];
        }
    }
    function getHwb(string) {
        if (!string) return;
        var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hwb);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), w = scale(parseFloat(match[2]), 0, 100), b = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                w,
                b,
                a
            ];
        }
    }
    function getRgb(string) {
        var rgba = getRgba(string);
        return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
        var hsla = getHsla(string);
        return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
        var vals = getRgba(string);
        if (vals) return vals[3];
        else if (vals = getHsla(string)) return vals[3];
        else if (vals = getHwb(string)) return vals[3];
    }
    // generators
    function hexString(rgba, a) {
        var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
        return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return rgbaString(rgba, alpha);
        return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
        if (alpha === undefined) alpha = rgba[3] !== undefined ? rgba[3] : 1;
        return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return percentaString(rgba, alpha);
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
        if (alpha < 1 || hsla[3] && hsla[3] < 1) return hslaString(hsla, alpha);
        return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
        if (alpha === undefined) alpha = hsla[3] !== undefined ? hsla[3] : 1;
        return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
    // (hwb have alpha optional & 1 is default value)
    function hwbString(hwb, alpha) {
        if (alpha === undefined) alpha = hwb[3] !== undefined ? hwb[3] : 1;
        return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
        return reverseNames[rgb.slice(0, 3)];
    }
    // helpers
    function scale(num, min, max) {
        return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
        var str = num.toString(16).toUpperCase();
        return str.length < 2 ? "0" + str : str;
    }
    //create a list of reverse color names
    var reverseNames = {};
    for(var name in colorName$1)reverseNames[colorName$1[name]] = name;
    /* MIT license */ var Color = function(obj) {
        if (obj instanceof Color) return obj;
        if (!(this instanceof Color)) return new Color(obj);
        this.valid = false;
        this.values = {
            rgb: [
                0,
                0,
                0
            ],
            hsl: [
                0,
                0,
                0
            ],
            hsv: [
                0,
                0,
                0
            ],
            hwb: [
                0,
                0,
                0
            ],
            cmyk: [
                0,
                0,
                0,
                0
            ],
            alpha: 1
        };
        // parse Color() argument
        var vals;
        if (typeof obj === 'string') {
            vals = colorString.getRgba(obj);
            if (vals) this.setValues('rgb', vals);
            else if (vals = colorString.getHsla(obj)) this.setValues('hsl', vals);
            else if (vals = colorString.getHwb(obj)) this.setValues('hwb', vals);
        } else if (typeof obj === 'object') {
            vals = obj;
            if (vals.r !== undefined || vals.red !== undefined) this.setValues('rgb', vals);
            else if (vals.l !== undefined || vals.lightness !== undefined) this.setValues('hsl', vals);
            else if (vals.v !== undefined || vals.value !== undefined) this.setValues('hsv', vals);
            else if (vals.w !== undefined || vals.whiteness !== undefined) this.setValues('hwb', vals);
            else if (vals.c !== undefined || vals.cyan !== undefined) this.setValues('cmyk', vals);
        }
    };
    Color.prototype = {
        isValid: function() {
            return this.valid;
        },
        rgb: function() {
            return this.setSpace('rgb', arguments);
        },
        hsl: function() {
            return this.setSpace('hsl', arguments);
        },
        hsv: function() {
            return this.setSpace('hsv', arguments);
        },
        hwb: function() {
            return this.setSpace('hwb', arguments);
        },
        cmyk: function() {
            return this.setSpace('cmyk', arguments);
        },
        rgbArray: function() {
            return this.values.rgb;
        },
        hslArray: function() {
            return this.values.hsl;
        },
        hsvArray: function() {
            return this.values.hsv;
        },
        hwbArray: function() {
            var values = this.values;
            if (values.alpha !== 1) return values.hwb.concat([
                values.alpha
            ]);
            return values.hwb;
        },
        cmykArray: function() {
            return this.values.cmyk;
        },
        rgbaArray: function() {
            var values = this.values;
            return values.rgb.concat([
                values.alpha
            ]);
        },
        hslaArray: function() {
            var values = this.values;
            return values.hsl.concat([
                values.alpha
            ]);
        },
        alpha: function(val) {
            if (val === undefined) return this.values.alpha;
            this.setValues('alpha', val);
            return this;
        },
        red: function(val) {
            return this.setChannel('rgb', 0, val);
        },
        green: function(val) {
            return this.setChannel('rgb', 1, val);
        },
        blue: function(val) {
            return this.setChannel('rgb', 2, val);
        },
        hue: function(val) {
            if (val) {
                val %= 360;
                val = val < 0 ? 360 + val : val;
            }
            return this.setChannel('hsl', 0, val);
        },
        saturation: function(val) {
            return this.setChannel('hsl', 1, val);
        },
        lightness: function(val) {
            return this.setChannel('hsl', 2, val);
        },
        saturationv: function(val) {
            return this.setChannel('hsv', 1, val);
        },
        whiteness: function(val) {
            return this.setChannel('hwb', 1, val);
        },
        blackness: function(val) {
            return this.setChannel('hwb', 2, val);
        },
        value: function(val) {
            return this.setChannel('hsv', 2, val);
        },
        cyan: function(val) {
            return this.setChannel('cmyk', 0, val);
        },
        magenta: function(val) {
            return this.setChannel('cmyk', 1, val);
        },
        yellow: function(val) {
            return this.setChannel('cmyk', 2, val);
        },
        black: function(val) {
            return this.setChannel('cmyk', 3, val);
        },
        hexString: function() {
            return colorString.hexString(this.values.rgb);
        },
        rgbString: function() {
            return colorString.rgbString(this.values.rgb, this.values.alpha);
        },
        rgbaString: function() {
            return colorString.rgbaString(this.values.rgb, this.values.alpha);
        },
        percentString: function() {
            return colorString.percentString(this.values.rgb, this.values.alpha);
        },
        hslString: function() {
            return colorString.hslString(this.values.hsl, this.values.alpha);
        },
        hslaString: function() {
            return colorString.hslaString(this.values.hsl, this.values.alpha);
        },
        hwbString: function() {
            return colorString.hwbString(this.values.hwb, this.values.alpha);
        },
        keyword: function() {
            return colorString.keyword(this.values.rgb, this.values.alpha);
        },
        rgbNumber: function() {
            var rgb = this.values.rgb;
            return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
        },
        luminosity: function() {
            // http://www.w3.org/TR/WCAG20/#relativeluminancedef
            var rgb = this.values.rgb;
            var lum = [];
            for(var i = 0; i < rgb.length; i++){
                var chan = rgb[i] / 255;
                lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }
            return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
        },
        contrast: function(color2) {
            // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
            var lum1 = this.luminosity();
            var lum2 = color2.luminosity();
            if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
            return (lum2 + 0.05) / (lum1 + 0.05);
        },
        level: function(color2) {
            var contrastRatio = this.contrast(color2);
            if (contrastRatio >= 7.1) return 'AAA';
            return contrastRatio >= 4.5 ? 'AA' : '';
        },
        dark: function() {
            // YIQ equation from http://24ways.org/2010/calculating-color-contrast
            var rgb = this.values.rgb;
            var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
            return yiq < 128;
        },
        light: function() {
            return !this.dark();
        },
        negate: function() {
            var rgb = [];
            for(var i = 0; i < 3; i++)rgb[i] = 255 - this.values.rgb[i];
            this.setValues('rgb', rgb);
            return this;
        },
        lighten: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] += hsl[2] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        darken: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] -= hsl[2] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        saturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] += hsl[1] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        desaturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] -= hsl[1] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        whiten: function(ratio) {
            var hwb = this.values.hwb;
            hwb[1] += hwb[1] * ratio;
            this.setValues('hwb', hwb);
            return this;
        },
        blacken: function(ratio) {
            var hwb = this.values.hwb;
            hwb[2] += hwb[2] * ratio;
            this.setValues('hwb', hwb);
            return this;
        },
        greyscale: function() {
            var rgb = this.values.rgb;
            // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
            var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
            this.setValues('rgb', [
                val,
                val,
                val
            ]);
            return this;
        },
        clearer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues('alpha', alpha - alpha * ratio);
            return this;
        },
        opaquer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues('alpha', alpha + alpha * ratio);
            return this;
        },
        rotate: function(degrees) {
            var hsl = this.values.hsl;
            var hue = (hsl[0] + degrees) % 360;
            hsl[0] = hue < 0 ? 360 + hue : hue;
            this.setValues('hsl', hsl);
            return this;
        },
        /**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */ mix: function(mixinColor, weight) {
            var color1 = this;
            var color2 = mixinColor;
            var p = weight === undefined ? 0.5 : weight;
            var w = 2 * p - 1;
            var a = color1.alpha() - color2.alpha();
            var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            var w2 = 1 - w1;
            return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
        },
        toJSON: function() {
            return this.rgb();
        },
        clone: function() {
            // NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
            // making the final build way to big to embed in Chart.js. So let's do it manually,
            // assuming that values to clone are 1 dimension arrays containing only numbers,
            // except 'alpha' which is a number.
            var result = new Color();
            var source = this.values;
            var target = result.values;
            var value, type;
            for(var prop in source)if (source.hasOwnProperty(prop)) {
                value = source[prop];
                type = ({}).toString.call(value);
                if (type === '[object Array]') target[prop] = value.slice(0);
                else if (type === '[object Number]') target[prop] = value;
                else console.error('unexpected color value:', value);
            }
            return result;
        }
    };
    Color.prototype.spaces = {
        rgb: [
            'red',
            'green',
            'blue'
        ],
        hsl: [
            'hue',
            'saturation',
            'lightness'
        ],
        hsv: [
            'hue',
            'saturation',
            'value'
        ],
        hwb: [
            'hue',
            'whiteness',
            'blackness'
        ],
        cmyk: [
            'cyan',
            'magenta',
            'yellow',
            'black'
        ]
    };
    Color.prototype.maxes = {
        rgb: [
            255,
            255,
            255
        ],
        hsl: [
            360,
            100,
            100
        ],
        hsv: [
            360,
            100,
            100
        ],
        hwb: [
            360,
            100,
            100
        ],
        cmyk: [
            100,
            100,
            100,
            100
        ]
    };
    Color.prototype.getValues = function(space) {
        var values = this.values;
        var vals = {};
        for(var i = 0; i < space.length; i++)vals[space.charAt(i)] = values[space][i];
        if (values.alpha !== 1) vals.a = values.alpha;
        // {r: 255, g: 255, b: 255, a: 0.4}
        return vals;
    };
    Color.prototype.setValues = function(space, vals) {
        var values = this.values;
        var spaces = this.spaces;
        var maxes = this.maxes;
        var alpha = 1;
        var i;
        this.valid = true;
        if (space === 'alpha') alpha = vals;
        else if (vals.length) {
            // [10, 10, 10]
            values[space] = vals.slice(0, space.length);
            alpha = vals[space.length];
        } else if (vals[space.charAt(0)] !== undefined) {
            // {r: 10, g: 10, b: 10}
            for(i = 0; i < space.length; i++)values[space][i] = vals[space.charAt(i)];
            alpha = vals.a;
        } else if (vals[spaces[space][0]] !== undefined) {
            // {red: 10, green: 10, blue: 10}
            var chans = spaces[space];
            for(i = 0; i < space.length; i++)values[space][i] = vals[chans[i]];
            alpha = vals.alpha;
        }
        values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
        if (space === 'alpha') return false;
        var capped;
        // cap values of the space prior converting all values
        for(i = 0; i < space.length; i++){
            capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
            values[space][i] = Math.round(capped);
        }
        // convert to all the other color spaces
        for(var sname in spaces)if (sname !== space) values[sname] = colorConvert[space][sname](values[space]);
        return true;
    };
    Color.prototype.setSpace = function(space, args) {
        var vals = args[0];
        if (vals === undefined) // color.rgb()
        return this.getValues(space);
        // color.rgb(10, 10, 10)
        if (typeof vals === 'number') vals = Array.prototype.slice.call(args);
        this.setValues(space, vals);
        return this;
    };
    Color.prototype.setChannel = function(space, index, val) {
        var svalues = this.values[space];
        if (val === undefined) // color.red()
        return svalues[index];
        else if (val === svalues[index]) // color.red(color.red())
        return this;
        // color.red(100)
        svalues[index] = val;
        this.setValues(space, svalues);
        return this;
    };
    if (typeof window !== 'undefined') window.Color = Color;
    var chartjsColor = Color;
    function isValidKey(key) {
        return [
            '__proto__',
            'prototype',
            'constructor'
        ].indexOf(key) === -1;
    }
    /**
 * @namespace Chart.helpers
 */ var helpers = {
        /**
	 * An empty function that can be used, for example, for optional callback.
	 */ noop: function() {},
        /**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */ uid: function() {
            var id = 0;
            return function() {
                return id++;
            };
        }(),
        /**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isNullOrUndef: function(value) {
            return value === null || typeof value === 'undefined';
        },
        /**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */ isArray: function(value) {
            if (Array.isArray && Array.isArray(value)) return true;
            var type = Object.prototype.toString.call(value);
            if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') return true;
            return false;
        },
        /**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isObject: function(value) {
            return value !== null && Object.prototype.toString.call(value) === '[object Object]';
        },
        /**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */ isFinite: function(value) {
            return (typeof value === 'number' || value instanceof Number) && isFinite(value);
        },
        /**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */ valueOrDefault: function(value, defaultValue) {
            return typeof value === 'undefined' ? defaultValue : value;
        },
        /**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */ valueAtIndexOrDefault: function(value, index, defaultValue) {
            return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
        },
        /**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */ callback: function(fn, args, thisArg) {
            if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
        },
        /**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */ each: function(loopable, fn, thisArg, reverse) {
            var i, len, keys;
            if (helpers.isArray(loopable)) {
                len = loopable.length;
                if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
                else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
            } else if (helpers.isObject(loopable)) {
                keys = Object.keys(loopable);
                len = keys.length;
                for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
            }
        },
        /**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */ arrayEquals: function(a0, a1) {
            var i, ilen, v0, v1;
            if (!a0 || !a1 || a0.length !== a1.length) return false;
            for(i = 0, ilen = a0.length; i < ilen; ++i){
                v0 = a0[i];
                v1 = a1[i];
                if (v0 instanceof Array && v1 instanceof Array) {
                    if (!helpers.arrayEquals(v0, v1)) return false;
                } else if (v0 !== v1) // NOTE: two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
            return true;
        },
        /**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */ clone: function(source) {
            if (helpers.isArray(source)) return source.map(helpers.clone);
            if (helpers.isObject(source)) {
                var target = Object.create(source);
                var keys = Object.keys(source);
                var klen = keys.length;
                var k = 0;
                for(; k < klen; ++k)target[keys[k]] = helpers.clone(source[keys[k]]);
                return target;
            }
            return source;
        },
        /**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */ _merger: function(key, target, source, options) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.merge(tval, sval, options);
            else target[key] = helpers.clone(sval);
        },
        /**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */ _mergerIf: function(key, target, source) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.mergeIf(tval, sval);
            else if (!target.hasOwnProperty(key)) target[key] = helpers.clone(sval);
        },
        /**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */ merge: function(target, source, options) {
            var sources = helpers.isArray(source) ? source : [
                source
            ];
            var ilen = sources.length;
            var merge, i, keys, klen, k;
            if (!helpers.isObject(target)) return target;
            options = options || {};
            merge = options.merger || helpers._merger;
            for(i = 0; i < ilen; ++i){
                source = sources[i];
                if (!helpers.isObject(source)) continue;
                keys = Object.keys(source);
                for(k = 0, klen = keys.length; k < klen; ++k)merge(keys[k], target, source, options);
            }
            return target;
        },
        /**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */ mergeIf: function(target, source) {
            return helpers.merge(target, source, {
                merger: helpers._mergerIf
            });
        },
        /**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */ extend: Object.assign || function(target) {
            return helpers.merge(target, [].slice.call(arguments, 1), {
                merger: function(key, dst, src) {
                    dst[key] = src[key];
                }
            });
        },
        /**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */ inherits: function(extensions) {
            var me = this;
            var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function() {
                return me.apply(this, arguments);
            };
            var Surrogate = function() {
                this.constructor = ChartElement;
            };
            Surrogate.prototype = me.prototype;
            ChartElement.prototype = new Surrogate();
            ChartElement.extend = helpers.inherits;
            if (extensions) helpers.extend(ChartElement.prototype, extensions);
            ChartElement.__super__ = me.prototype;
            return ChartElement;
        },
        _deprecated: function(scope, value, previous, current) {
            if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
    };
    var helpers_core = helpers;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ helpers.callCallback = helpers.callback;
    /**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.indexOf = function(array, item, fromIndex) {
        return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    /**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueOrDefault = helpers.valueOrDefault;
    /**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    /**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */ var effects = {
        linear: function(t) {
            return t;
        },
        easeInQuad: function(t) {
            return t * t;
        },
        easeOutQuad: function(t) {
            return -t * (t - 2);
        },
        easeInOutQuad: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t;
            return -0.5 * (--t * (t - 2) - 1);
        },
        easeInCubic: function(t) {
            return t * t * t;
        },
        easeOutCubic: function(t) {
            return (t = t - 1) * t * t + 1;
        },
        easeInOutCubic: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t;
            return 0.5 * ((t -= 2) * t * t + 2);
        },
        easeInQuart: function(t) {
            return t * t * t * t;
        },
        easeOutQuart: function(t) {
            return -((t = t - 1) * t * t * t - 1);
        },
        easeInOutQuart: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t;
            return -0.5 * ((t -= 2) * t * t * t - 2);
        },
        easeInQuint: function(t) {
            return t * t * t * t * t;
        },
        easeOutQuint: function(t) {
            return (t = t - 1) * t * t * t * t + 1;
        },
        easeInOutQuint: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t * t;
            return 0.5 * ((t -= 2) * t * t * t * t + 2);
        },
        easeInSine: function(t) {
            return -Math.cos(t * (Math.PI / 2)) + 1;
        },
        easeOutSine: function(t) {
            return Math.sin(t * (Math.PI / 2));
        },
        easeInOutSine: function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        },
        easeInExpo: function(t) {
            return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
        },
        easeOutExpo: function(t) {
            return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
        },
        easeInOutExpo: function(t) {
            if (t === 0) return 0;
            if (t === 1) return 1;
            if ((t /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (t - 1));
            return 0.5 * (-Math.pow(2, -10 * --t) + 2);
        },
        easeInCirc: function(t) {
            if (t >= 1) return t;
            return -(Math.sqrt(1 - t * t) - 1);
        },
        easeOutCirc: function(t) {
            return Math.sqrt(1 - (t = t - 1) * t);
        },
        easeInOutCirc: function(t) {
            if ((t /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1);
            return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
        },
        easeInElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        },
        easeOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
        },
        easeInOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if ((t /= 0.5) === 2) return 1;
            if (!p) p = 0.45;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        easeInBack: function(t) {
            var s = 1.70158;
            return t * t * ((s + 1) * t - s);
        },
        easeOutBack: function(t) {
            var s = 1.70158;
            return (t = t - 1) * t * ((s + 1) * t + s) + 1;
        },
        easeInOutBack: function(t) {
            var s = 1.70158;
            if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
            return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
        },
        easeInBounce: function(t) {
            return 1 - effects.easeOutBounce(1 - t);
        },
        easeOutBounce: function(t) {
            if (t < 1 / 2.75) return 7.5625 * t * t;
            if (t < 2 / 2.75) return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
            if (t < 2.5 / 2.75) return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
            return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
        },
        easeInOutBounce: function(t) {
            if (t < 0.5) return effects.easeInBounce(t * 2) * 0.5;
            return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
        }
    };
    var helpers_easing = {
        effects: effects
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    /**
 * @namespace Chart.helpers.canvas
 */ var exports$1 = {
        /**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */ clear: function(chart) {
            chart.ctx.clearRect(0, 0, chart.width, chart.height);
        },
        /**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */ roundedRect: function(ctx, x, y, width, height, radius) {
            if (radius) {
                var r = Math.min(radius, height / 2, width / 2);
                var left = x + r;
                var top = y + r;
                var right = x + width - r;
                var bottom = y + height - r;
                ctx.moveTo(x, top);
                if (left < right && top < bottom) {
                    ctx.arc(left, top, r, -PI, -HALF_PI);
                    ctx.arc(right, top, r, -HALF_PI, 0);
                    ctx.arc(right, bottom, r, 0, HALF_PI);
                    ctx.arc(left, bottom, r, HALF_PI, PI);
                } else if (left < right) {
                    ctx.moveTo(left, y);
                    ctx.arc(right, top, r, -HALF_PI, HALF_PI);
                    ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
                } else if (top < bottom) {
                    ctx.arc(left, top, r, -PI, 0);
                    ctx.arc(left, bottom, r, 0, PI);
                } else ctx.arc(left, top, r, -PI, PI);
                ctx.closePath();
                ctx.moveTo(x, y);
            } else ctx.rect(x, y, width, height);
        },
        drawPoint: function(ctx, style, radius, x, y, rotation) {
            var type, xOffset, yOffset, size, cornerRadius;
            var rad = (rotation || 0) * RAD_PER_DEG;
            if (style && typeof style === 'object') {
                type = style.toString();
                if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(rad);
                    ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
                    ctx.restore();
                    return;
                }
            }
            if (isNaN(radius) || radius <= 0) return;
            ctx.beginPath();
            switch(style){
                // Default includes circle
                default:
                    ctx.arc(x, y, radius, 0, DOUBLE_PI);
                    ctx.closePath();
                    break;
                case 'triangle':
                    ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    ctx.closePath();
                    break;
                case 'rectRounded':
                    // NOTE: the rounded rect implementation changed to use `arc` instead of
                    // `quadraticCurveTo` since it generates better results when rect is
                    // almost a circle. 0.516 (instead of 0.5) produces results with visually
                    // closer proportion to the previous impl and it is inscribed in the
                    // circle with `radius`. For more details, see the following PRs:
                    // https://github.com/chartjs/Chart.js/issues/5597
                    // https://github.com/chartjs/Chart.js/issues/5858
                    cornerRadius = radius * 0.516;
                    size = radius - cornerRadius;
                    xOffset = Math.cos(rad + QUARTER_PI) * size;
                    yOffset = Math.sin(rad + QUARTER_PI) * size;
                    ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
                    ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
                    ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
                    ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
                    ctx.closePath();
                    break;
                case 'rect':
                    if (!rotation) {
                        size = Math.SQRT1_2 * radius;
                        ctx.rect(x - size, y - size, 2 * size, 2 * size);
                        break;
                    }
                    rad += QUARTER_PI;
                /* falls through */ case 'rectRot':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    ctx.closePath();
                    break;
                case 'crossRot':
                    rad += QUARTER_PI;
                /* falls through */ case 'cross':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case 'star':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    rad += QUARTER_PI;
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case 'line':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    break;
                case 'dash':
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
                    break;
            }
            ctx.fill();
            ctx.stroke();
        },
        /**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */ _isPointInArea: function(point, area) {
            var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
            return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
        },
        clipArea: function(ctx, area) {
            ctx.save();
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        },
        unclipArea: function(ctx) {
            ctx.restore();
        },
        lineTo: function(ctx, previous, target, flip) {
            var stepped = target.steppedLine;
            if (stepped) {
                if (stepped === 'middle') {
                    var midpoint = (previous.x + target.x) / 2.0;
                    ctx.lineTo(midpoint, flip ? target.y : previous.y);
                    ctx.lineTo(midpoint, flip ? previous.y : target.y);
                } else if (stepped === 'after' && !flip || stepped !== 'after' && flip) ctx.lineTo(previous.x, target.y);
                else ctx.lineTo(target.x, previous.y);
                ctx.lineTo(target.x, target.y);
                return;
            }
            if (!target.tension) {
                ctx.lineTo(target.x, target.y);
                return;
            }
            ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
        }
    };
    var helpers_canvas = exports$1;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.clear = exports$1.clear;
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.drawRoundedRectangle = function(ctx) {
        ctx.beginPath();
        exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
        /**
	 * @private
	 */ _set: function(scope, values) {
            return helpers_core.merge(this[scope] || (this[scope] = {}), values);
        }
    };
    // TODO(v3): remove 'global' from namespace.  all default are global and
    // there's inconsistency around which options are under 'global'
    defaults._set('global', {
        defaultColor: 'rgba(0,0,0,0.1)',
        defaultFontColor: '#666',
        defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        defaultFontSize: 12,
        defaultFontStyle: 'normal',
        defaultLineHeight: 1.2,
        showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    /**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
        if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) return null;
        return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
    }
    /**
 * @alias Chart.helpers.options
 * @namespace
 */ var helpers_options = {
        /**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */ toLineHeight: function(value, size) {
            var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
            if (!matches || matches[1] === 'normal') return size * 1.2;
            value = +matches[2];
            switch(matches[3]){
                case 'px':
                    return value;
                case '%':
                    value /= 100;
                    break;
            }
            return size * value;
        },
        /**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */ toPadding: function(value) {
            var t, r, b, l;
            if (helpers_core.isObject(value)) {
                t = +value.top || 0;
                r = +value.right || 0;
                b = +value.bottom || 0;
                l = +value.left || 0;
            } else t = r = b = l = +value || 0;
            return {
                top: t,
                right: r,
                bottom: b,
                left: l,
                height: t + b,
                width: l + r
            };
        },
        /**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */ _parseFont: function(options) {
            var globalDefaults = core_defaults.global;
            var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
            var font = {
                family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
                lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
                size: size,
                style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
                weight: null,
                string: ''
            };
            font.string = toFontString(font);
            return font;
        },
        /**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */ resolve: function(inputs, context, index, info) {
            var cacheable = true;
            var i, ilen, value;
            for(i = 0, ilen = inputs.length; i < ilen; ++i){
                value = inputs[i];
                if (value === undefined) continue;
                if (context !== undefined && typeof value === 'function') {
                    value = value(context);
                    cacheable = false;
                }
                if (index !== undefined && helpers_core.isArray(value)) {
                    value = value[index];
                    cacheable = false;
                }
                if (value !== undefined) {
                    if (info && !cacheable) info.cacheable = false;
                    return value;
                }
            }
        }
    };
    /**
 * @alias Chart.helpers.math
 * @namespace
 */ var exports$2 = {
        /**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */ _factorize: function(value) {
            var result = [];
            var sqrt = Math.sqrt(value);
            var i;
            for(i = 1; i < sqrt; i++)if (value % i === 0) {
                result.push(i);
                result.push(value / i);
            }
            if (sqrt === (sqrt | 0)) result.push(sqrt);
            result.sort(function(a, b) {
                return a - b;
            }).pop();
            return result;
        },
        log10: Math.log10 || function(x) {
            var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
            // Check for whole powers of 10,
            // which due to floating point rounding error should be corrected.
            var powerOf10 = Math.round(exponent);
            var isPowerOf10 = x === Math.pow(10, powerOf10);
            return isPowerOf10 ? powerOf10 : exponent;
        }
    };
    var helpers_math = exports$2;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */ helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function(rectX, width) {
        return {
            x: function(x) {
                return rectX + rectX + width - x;
            },
            setWidth: function(w) {
                width = w;
            },
            textAlign: function(align) {
                if (align === 'center') return align;
                return align === 'right' ? 'left' : 'right';
            },
            xPlus: function(x, value) {
                return x - value;
            },
            leftForLtr: function(x, itemWidth) {
                return x - itemWidth;
            }
        };
    };
    var getLtrAdapter = function() {
        return {
            x: function(x) {
                return x;
            },
            setWidth: function(w) {},
            textAlign: function(align) {
                return align;
            },
            xPlus: function(x, value) {
                return x + value;
            },
            leftForLtr: function(x, _itemWidth) {
                return x;
            }
        };
    };
    var getAdapter = function(rtl, rectX, width) {
        return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function(ctx, direction) {
        var style, original;
        if (direction === 'ltr' || direction === 'rtl') {
            style = ctx.canvas.style;
            original = [
                style.getPropertyValue('direction'),
                style.getPropertyPriority('direction')
            ];
            style.setProperty('direction', direction, 'important');
            ctx.prevTextDirection = original;
        }
    };
    var restoreTextDirection = function(ctx) {
        var original = ctx.prevTextDirection;
        if (original !== undefined) {
            delete ctx.prevTextDirection;
            ctx.canvas.style.setProperty('direction', original[0], original[1]);
        }
    };
    var helpers_rtl = {
        getRtlAdapter: getAdapter,
        overrideTextDirection: overrideTextDirection,
        restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
        var keys = Object.keys(model);
        var i, ilen, key, actual, origin, target, type, c0, c1;
        for(i = 0, ilen = keys.length; i < ilen; ++i){
            key = keys[i];
            target = model[key];
            // if a value is added to the model after pivot() has been called, the view
            // doesn't contain it, so let's initialize the view to the target value.
            if (!view.hasOwnProperty(key)) view[key] = target;
            actual = view[key];
            if (actual === target || key[0] === '_') continue;
            if (!start.hasOwnProperty(key)) start[key] = actual;
            origin = start[key];
            type = typeof target;
            if (type === typeof origin) {
                if (type === 'string') {
                    c0 = chartjsColor(origin);
                    if (c0.valid) {
                        c1 = chartjsColor(target);
                        if (c1.valid) {
                            view[key] = c1.mix(c0, ease).rgbString();
                            continue;
                        }
                    }
                } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
                    view[key] = origin + (target - origin) * ease;
                    continue;
                }
            }
            view[key] = target;
        }
    }
    var Element = function(configuration) {
        helpers$1.extend(this, configuration);
        this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
        _type: undefined,
        initialize: function() {
            this.hidden = false;
        },
        pivot: function() {
            var me = this;
            if (!me._view) me._view = helpers$1.extend({}, me._model);
            me._start = {};
            return me;
        },
        transition: function(ease) {
            var me = this;
            var model = me._model;
            var start = me._start;
            var view = me._view;
            // No animation -> No Transition
            if (!model || ease === 1) {
                me._view = helpers$1.extend({}, model);
                me._start = null;
                return me;
            }
            if (!view) view = me._view = {};
            if (!start) start = me._start = {};
            interpolate(start, view, model, ease);
            return me;
        },
        tooltipPosition: function() {
            return {
                x: this._model.x,
                y: this._model.y
            };
        },
        hasValue: function() {
            return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
        }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
        chart: null,
        currentStep: 0,
        numSteps: 60,
        easing: '',
        render: null,
        onAnimationProgress: null,
        onAnimationComplete: null
    });
    var core_animation = exports$3;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, 'animationObject', {
        get: function() {
            return this;
        }
    });
    /**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, 'chartInstance', {
        get: function() {
            return this.chart;
        },
        set: function(value) {
            this.chart = value;
        }
    });
    core_defaults._set('global', {
        animation: {
            duration: 1000,
            easing: 'easeOutQuart',
            onProgress: helpers$1.noop,
            onComplete: helpers$1.noop
        }
    });
    var core_animations = {
        animations: [],
        request: null,
        /**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */ addAnimation: function(chart, animation, duration, lazy) {
            var animations = this.animations;
            var i, ilen;
            animation.chart = chart;
            animation.startTime = Date.now();
            animation.duration = duration;
            if (!lazy) chart.animating = true;
            for(i = 0, ilen = animations.length; i < ilen; ++i)if (animations[i].chart === chart) {
                animations[i] = animation;
                return;
            }
            animations.push(animation);
            // If there are no animations queued, manually kickstart a digest, for lack of a better word
            if (animations.length === 1) this.requestAnimationFrame();
        },
        cancelAnimation: function(chart) {
            var index = helpers$1.findIndex(this.animations, function(animation) {
                return animation.chart === chart;
            });
            if (index !== -1) {
                this.animations.splice(index, 1);
                chart.animating = false;
            }
        },
        requestAnimationFrame: function() {
            var me = this;
            if (me.request === null) // Skip animation frame requests until the active one is executed.
            // This can happen when processing mouse events, e.g. 'mousemove'
            // and 'mouseout' events will trigger multiple renders.
            me.request = helpers$1.requestAnimFrame.call(window, function() {
                me.request = null;
                me.startDigest();
            });
        },
        /**
	 * @private
	 */ startDigest: function() {
            var me = this;
            me.advance();
            // Do we have more stuff to animate?
            if (me.animations.length > 0) me.requestAnimationFrame();
        },
        /**
	 * @private
	 */ advance: function() {
            var animations = this.animations;
            var animation, chart, numSteps, nextStep;
            var i = 0;
            // 1 animation per chart, so we are looping charts here
            while(i < animations.length){
                animation = animations[i];
                chart = animation.chart;
                numSteps = animation.numSteps;
                // Make sure that currentStep starts at 1
                // https://github.com/chartjs/Chart.js/issues/6104
                nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
                animation.currentStep = Math.min(nextStep, numSteps);
                helpers$1.callback(animation.render, [
                    chart,
                    animation
                ], chart);
                helpers$1.callback(animation.onAnimationProgress, [
                    animation
                ], chart);
                if (animation.currentStep >= numSteps) {
                    helpers$1.callback(animation.onAnimationComplete, [
                        animation
                    ], chart);
                    chart.animating = false;
                    animations.splice(i, 1);
                } else ++i;
            }
        }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = [
        'push',
        'pop',
        'shift',
        'splice',
        'unshift'
    ];
    /**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */ function listenArrayEvents(array, listener) {
        if (array._chartjs) {
            array._chartjs.listeners.push(listener);
            return;
        }
        Object.defineProperty(array, '_chartjs', {
            configurable: true,
            enumerable: false,
            value: {
                listeners: [
                    listener
                ]
            }
        });
        arrayEvents.forEach(function(key) {
            var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
            var base = array[key];
            Object.defineProperty(array, key, {
                configurable: true,
                enumerable: false,
                value: function() {
                    var args = Array.prototype.slice.call(arguments);
                    var res = base.apply(this, args);
                    helpers$1.each(array._chartjs.listeners, function(object) {
                        if (typeof object[method] === 'function') object[method].apply(object, args);
                    });
                    return res;
                }
            });
        });
    }
    /**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */ function unlistenArrayEvents(array, listener) {
        var stub = array._chartjs;
        if (!stub) return;
        var listeners = stub.listeners;
        var index = listeners.indexOf(listener);
        if (index !== -1) listeners.splice(index, 1);
        if (listeners.length > 0) return;
        arrayEvents.forEach(function(key) {
            delete array[key];
        });
        delete array._chartjs;
    }
    // Base class for all dataset controllers (line, bar, etc)
    var DatasetController = function(chart, datasetIndex) {
        this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
        /**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */ datasetElementType: null,
        /**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */ dataElementType: null,
        /**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderCapStyle',
            'borderColor',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'borderWidth'
        ],
        /**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'pointStyle'
        ],
        initialize: function(chart, datasetIndex) {
            var me = this;
            me.chart = chart;
            me.index = datasetIndex;
            me.linkScales();
            me.addElements();
            me._type = me.getMeta().type;
        },
        updateIndex: function(datasetIndex) {
            this.index = datasetIndex;
        },
        linkScales: function() {
            var me = this;
            var meta = me.getMeta();
            var chart = me.chart;
            var scales = chart.scales;
            var dataset = me.getDataset();
            var scalesOpts = chart.options.scales;
            if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
            if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        },
        getDataset: function() {
            return this.chart.data.datasets[this.index];
        },
        getMeta: function() {
            return this.chart.getDatasetMeta(this.index);
        },
        getScaleForId: function(scaleID) {
            return this.chart.scales[scaleID];
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().yAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getValueScale: function() {
            return this.getScaleForId(this._getValueScaleId());
        },
        /**
	 * @private
	 */ _getIndexScale: function() {
            return this.getScaleForId(this._getIndexScaleId());
        },
        reset: function() {
            this._update(true);
        },
        /**
	 * @private
	 */ destroy: function() {
            if (this._data) unlistenArrayEvents(this._data, this);
        },
        createMetaDataset: function() {
            var me = this;
            var type = me.datasetElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index
            });
        },
        createMetaData: function(index) {
            var me = this;
            var type = me.dataElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index,
                _index: index
            });
        },
        addElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data || [];
            var metaData = meta.data;
            var i, ilen;
            for(i = 0, ilen = data.length; i < ilen; ++i)metaData[i] = metaData[i] || me.createMetaData(i);
            meta.dataset = meta.dataset || me.createMetaDataset();
        },
        addElementAndReset: function(index) {
            var element = this.createMetaData(index);
            this.getMeta().data.splice(index, 0, element);
            this.updateElement(element, index, true);
        },
        buildOrUpdateElements: function() {
            var me = this;
            var dataset = me.getDataset();
            var data = dataset.data || (dataset.data = []);
            // In order to correctly handle data addition/deletion animation (an thus simulate
            // real-time charts), we need to monitor these data modifications and synchronize
            // the internal meta data accordingly.
            if (me._data !== data) {
                if (me._data) // This case happens when the user replaced the data array instance.
                unlistenArrayEvents(me._data, me);
                if (data && Object.isExtensible(data)) listenArrayEvents(data, me);
                me._data = data;
            }
            // Re-sync meta data in case the user replaced the data array or if we missed
            // any updates and so make sure that we handle number of datapoints changing.
            me.resyncElements();
        },
        /**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */ _configure: function() {
            var me = this;
            me._config = helpers$1.merge(Object.create(null), [
                me.chart.options.datasets[me._type],
                me.getDataset()
            ], {
                merger: function(key, target, source) {
                    if (key !== '_meta' && key !== 'data') helpers$1._merger(key, target, source);
                }
            });
        },
        _update: function(reset) {
            var me = this;
            me._configure();
            me._cachedDataOpts = null;
            me.update(reset);
        },
        update: helpers$1.noop,
        transition: function(easingValue) {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            for(; i < ilen; ++i)elements[i].transition(easingValue);
            if (meta.dataset) meta.dataset.transition(easingValue);
        },
        draw: function() {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            if (meta.dataset) meta.dataset.draw();
            for(; i < ilen; ++i)elements[i].draw();
        },
        /**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */ getStyle: function(index) {
            var me = this;
            var meta = me.getMeta();
            var dataset = meta.dataset;
            var style;
            me._configure();
            if (dataset && index === undefined) style = me._resolveDatasetElementOptions(dataset || {});
            else {
                index = index || 0;
                style = me._resolveDataElementOptions(meta.data[index] || {}, index);
            }
            if (style.fill === false || style.fill === null) style.backgroundColor = style.borderColor;
            return style;
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element, hover) {
            var me = this;
            var chart = me.chart;
            var datasetOpts = me._config;
            var custom = element.custom || {};
            var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
            var elementOptions = me._datasetElementOptions;
            var values = {};
            var i, ilen, key, readKey;
            // Scriptable options
            var context = {
                chart: chart,
                dataset: me.getDataset(),
                datasetIndex: me.index,
                hover: hover
            };
            for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
                values[key] = resolve([
                    custom[readKey],
                    datasetOpts[readKey],
                    options[readKey]
                ], context);
            }
            return values;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(element, index) {
            var me = this;
            var custom = element && element.custom;
            var cached = me._cachedDataOpts;
            if (cached && !custom) return cached;
            var chart = me.chart;
            var datasetOpts = me._config;
            var options = chart.options.elements[me.dataElementType.prototype._type] || {};
            var elementOptions = me._dataElementOptions;
            var values = {};
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: me.getDataset(),
                datasetIndex: me.index
            };
            // `resolve` sets cacheable to `false` if any option is indexed or scripted
            var info = {
                cacheable: !custom
            };
            var keys, i, ilen, key;
            custom = custom || {};
            if (helpers$1.isArray(elementOptions)) for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                values[key] = resolve([
                    custom[key],
                    datasetOpts[key],
                    options[key]
                ], context, index, info);
            }
            else {
                keys = Object.keys(elementOptions);
                for(i = 0, ilen = keys.length; i < ilen; ++i){
                    key = keys[i];
                    values[key] = resolve([
                        custom[key],
                        datasetOpts[elementOptions[key]],
                        datasetOpts[key],
                        options[key]
                    ], context, index, info);
                }
            }
            if (info.cacheable) me._cachedDataOpts = Object.freeze(values);
            return values;
        },
        removeHoverStyle: function(element) {
            helpers$1.merge(element._model, element.$previousStyle || {});
            delete element.$previousStyle;
        },
        setHoverStyle: function(element) {
            var dataset = this.chart.data.datasets[element._datasetIndex];
            var index = element._index;
            var custom = element.custom || {};
            var model = element._model;
            var getHoverColor = helpers$1.getHoverColor;
            element.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = resolve([
                custom.hoverBackgroundColor,
                dataset.hoverBackgroundColor,
                getHoverColor(model.backgroundColor)
            ], undefined, index);
            model.borderColor = resolve([
                custom.hoverBorderColor,
                dataset.hoverBorderColor,
                getHoverColor(model.borderColor)
            ], undefined, index);
            model.borderWidth = resolve([
                custom.hoverBorderWidth,
                dataset.hoverBorderWidth,
                model.borderWidth
            ], undefined, index);
        },
        /**
	 * @private
	 */ _removeDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            if (element) this.removeHoverStyle(element);
        },
        /**
	 * @private
	 */ _setDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            var prev = {};
            var i, ilen, key, keys, hoverOptions, model;
            if (!element) return;
            model = element._model;
            hoverOptions = this._resolveDatasetElementOptions(element, true);
            keys = Object.keys(hoverOptions);
            for(i = 0, ilen = keys.length; i < ilen; ++i){
                key = keys[i];
                prev[key] = model[key];
                model[key] = hoverOptions[key];
            }
            element.$previousStyle = prev;
        },
        /**
	 * @private
	 */ resyncElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data;
            var numMeta = meta.data.length;
            var numData = data.length;
            if (numData < numMeta) meta.data.splice(numData, numMeta - numData);
            else if (numData > numMeta) me.insertElements(numMeta, numData - numMeta);
        },
        /**
	 * @private
	 */ insertElements: function(start, count) {
            for(var i = 0; i < count; ++i)this.addElementAndReset(start + i);
        },
        /**
	 * @private
	 */ onDataPush: function() {
            var count = arguments.length;
            this.insertElements(this.getDataset().data.length - count, count);
        },
        /**
	 * @private
	 */ onDataPop: function() {
            this.getMeta().data.pop();
        },
        /**
	 * @private
	 */ onDataShift: function() {
            this.getMeta().data.shift();
        },
        /**
	 * @private
	 */ onDataSplice: function(start, count) {
            this.getMeta().data.splice(start, count);
            this.insertElements(start, arguments.length - 2);
        },
        /**
	 * @private
	 */ onDataUnshift: function() {
            this.insertElements(0, arguments.length);
        }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set('global', {
        elements: {
            arc: {
                backgroundColor: core_defaults.global.defaultColor,
                borderColor: '#fff',
                borderWidth: 2,
                borderAlign: 'center'
            }
        }
    });
    function clipArc(ctx, arc) {
        var startAngle = arc.startAngle;
        var endAngle = arc.endAngle;
        var pixelMargin = arc.pixelMargin;
        var angleMargin = pixelMargin / arc.outerRadius;
        var x = arc.x;
        var y = arc.y;
        // Draw an inner border by cliping the arc and drawing a double-width border
        // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
        ctx.beginPath();
        ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
        if (arc.innerRadius > pixelMargin) {
            angleMargin = pixelMargin / arc.innerRadius;
            ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
        } else ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
        ctx.closePath();
        ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
        var endAngle = arc.endAngle;
        var i;
        if (inner) {
            arc.endAngle = arc.startAngle + TAU;
            clipArc(ctx, arc);
            arc.endAngle = endAngle;
            if (arc.endAngle === arc.startAngle && arc.fullCircles) {
                arc.endAngle += TAU;
                arc.fullCircles--;
            }
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
    }
    function drawBorder(ctx, vm, arc) {
        var inner = vm.borderAlign === 'inner';
        if (inner) {
            ctx.lineWidth = vm.borderWidth * 2;
            ctx.lineJoin = 'round';
        } else {
            ctx.lineWidth = vm.borderWidth;
            ctx.lineJoin = 'bevel';
        }
        if (arc.fullCircles) drawFullCircleBorders(ctx, vm, arc, inner);
        if (inner) clipArc(ctx, arc);
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.stroke();
    }
    var element_arc = core_element.extend({
        _type: 'arc',
        inLabelRange: function(mouseX) {
            var vm = this._view;
            if (vm) return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
            return false;
        },
        inRange: function(chartX, chartY) {
            var vm = this._view;
            if (vm) {
                var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
                    x: chartX,
                    y: chartY
                });
                var angle = pointRelativePosition.angle;
                var distance = pointRelativePosition.distance;
                // Sanitise angle range
                var startAngle = vm.startAngle;
                var endAngle = vm.endAngle;
                while(endAngle < startAngle)endAngle += TAU;
                while(angle > endAngle)angle -= TAU;
                while(angle < startAngle)angle += TAU;
                // Check if within the range of the open/close angle
                var betweenAngles = angle >= startAngle && angle <= endAngle;
                var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
                return betweenAngles && withinRadius;
            }
            return false;
        },
        getCenterPoint: function() {
            var vm = this._view;
            var halfAngle = (vm.startAngle + vm.endAngle) / 2;
            var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
            return {
                x: vm.x + Math.cos(halfAngle) * halfRadius,
                y: vm.y + Math.sin(halfAngle) * halfRadius
            };
        },
        getArea: function() {
            var vm = this._view;
            return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
        },
        tooltipPosition: function() {
            var vm = this._view;
            var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
            var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
            return {
                x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
                y: vm.y + Math.sin(centreAngle) * rangeFromCentre
            };
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
            var arc = {
                x: vm.x,
                y: vm.y,
                innerRadius: vm.innerRadius,
                outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
                pixelMargin: pixelMargin,
                startAngle: vm.startAngle,
                endAngle: vm.endAngle,
                fullCircles: Math.floor(vm.circumference / TAU)
            };
            var i;
            ctx.save();
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            if (arc.fullCircles) {
                arc.endAngle = arc.startAngle + TAU;
                ctx.beginPath();
                ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
                ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
                ctx.closePath();
                for(i = 0; i < arc.fullCircles; ++i)ctx.fill();
                arc.endAngle = arc.startAngle + vm.circumference % TAU;
            }
            ctx.beginPath();
            ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
            ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth) drawBorder(ctx, vm, arc);
            ctx.restore();
        }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            line: {
                tension: 0.4,
                backgroundColor: defaultColor,
                borderWidth: 3,
                borderColor: defaultColor,
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                capBezierPoints: true,
                fill: true
            }
        }
    });
    var element_line = core_element.extend({
        _type: 'line',
        draw: function() {
            var me = this;
            var vm = me._view;
            var ctx = me._chart.ctx;
            var spanGaps = vm.spanGaps;
            var points = me._children.slice(); // clone array
            var globalDefaults = core_defaults.global;
            var globalOptionLineElements = globalDefaults.elements.line;
            var lastDrawnIndex = -1;
            var closePath = me._loop;
            var index, previous, currentVM;
            if (!points.length) return;
            if (me._loop) {
                for(index = 0; index < points.length; ++index){
                    previous = helpers$1.previousItem(points, index);
                    // If the line has an open path, shift the point array
                    if (!points[index]._view.skip && previous._view.skip) {
                        points = points.slice(index).concat(points.slice(0, index));
                        closePath = spanGaps;
                        break;
                    }
                }
                // If the line has a close path, add the first point again
                if (closePath) points.push(points[0]);
            }
            ctx.save();
            // Stroke Line Options
            ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
            // IE 9 and 10 do not support line dash
            if (ctx.setLineDash) ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
            ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
            ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
            ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
            ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
            // Stroke Line
            ctx.beginPath();
            // First point moves to it's starting position no matter what
            currentVM = points[0]._view;
            if (!currentVM.skip) {
                ctx.moveTo(currentVM.x, currentVM.y);
                lastDrawnIndex = 0;
            }
            for(index = 1; index < points.length; ++index){
                currentVM = points[index]._view;
                previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
                if (!currentVM.skip) {
                    if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) // There was a gap and this is the first point after the gap
                    ctx.moveTo(currentVM.x, currentVM.y);
                    else // Line to next point
                    helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
                    lastDrawnIndex = index;
                }
            }
            if (closePath) ctx.closePath();
            ctx.stroke();
            ctx.restore();
        }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            point: {
                radius: 3,
                pointStyle: 'circle',
                backgroundColor: defaultColor$1,
                borderColor: defaultColor$1,
                borderWidth: 1,
                // Hover
                hitRadius: 1,
                hoverRadius: 4,
                hoverBorderWidth: 1
            }
        }
    });
    function xRange(mouseX) {
        var vm = this._view;
        return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
        var vm = this._view;
        return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
        _type: 'point',
        inRange: function(mouseX, mouseY) {
            var vm = this._view;
            return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
        },
        inLabelRange: xRange,
        inXRange: xRange,
        inYRange: yRange,
        getCenterPoint: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        },
        getArea: function() {
            return Math.PI * Math.pow(this._view.radius, 2);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y,
                padding: vm.radius + vm.borderWidth
            };
        },
        draw: function(chartArea) {
            var vm = this._view;
            var ctx = this._chart.ctx;
            var pointStyle = vm.pointStyle;
            var rotation = vm.rotation;
            var radius = vm.radius;
            var x = vm.x;
            var y = vm.y;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
            if (vm.skip) return;
            // Clipping for Points.
            if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
                ctx.strokeStyle = vm.borderColor || defaultColor;
                ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
                ctx.fillStyle = vm.backgroundColor || defaultColor;
                helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
            }
        }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            rectangle: {
                backgroundColor: defaultColor$2,
                borderColor: defaultColor$2,
                borderSkipped: 'bottom',
                borderWidth: 0
            }
        }
    });
    function isVertical(vm) {
        return vm && vm.width !== undefined;
    }
    /**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */ function getBarBounds(vm) {
        var x1, x2, y1, y2, half;
        if (isVertical(vm)) {
            half = vm.width / 2;
            x1 = vm.x - half;
            x2 = vm.x + half;
            y1 = Math.min(vm.y, vm.base);
            y2 = Math.max(vm.y, vm.base);
        } else {
            half = vm.height / 2;
            x1 = Math.min(vm.x, vm.base);
            x2 = Math.max(vm.x, vm.base);
            y1 = vm.y - half;
            y2 = vm.y + half;
        }
        return {
            left: x1,
            top: y1,
            right: x2,
            bottom: y2
        };
    }
    function swap(orig, v1, v2) {
        return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
        var edge = vm.borderSkipped;
        var res = {};
        if (!edge) return res;
        if (vm.horizontal) {
            if (vm.base > vm.x) edge = swap(edge, 'left', 'right');
        } else if (vm.base < vm.y) edge = swap(edge, 'bottom', 'top');
        res[edge] = true;
        return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
        var value = vm.borderWidth;
        var skip = parseBorderSkipped(vm);
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = +value.top || 0;
            r = +value.right || 0;
            b = +value.bottom || 0;
            l = +value.left || 0;
        } else t = r = b = l = +value || 0;
        return {
            t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
            r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
            b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
            l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
        };
    }
    function boundingRects(vm) {
        var bounds = getBarBounds(vm);
        var width = bounds.right - bounds.left;
        var height = bounds.bottom - bounds.top;
        var border = parseBorderWidth(vm, width / 2, height / 2);
        return {
            outer: {
                x: bounds.left,
                y: bounds.top,
                w: width,
                h: height
            },
            inner: {
                x: bounds.left + border.l,
                y: bounds.top + border.t,
                w: width - border.l - border.r,
                h: height - border.t - border.b
            }
        };
    }
    function inRange(vm, x, y) {
        var skipX = x === null;
        var skipY = y === null;
        var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
        return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
        _type: 'rectangle',
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var rects = boundingRects(vm);
            var outer = rects.outer;
            var inner = rects.inner;
            ctx.fillStyle = vm.backgroundColor;
            ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
            if (outer.w === inner.w && outer.h === inner.h) return;
            ctx.save();
            ctx.beginPath();
            ctx.rect(outer.x, outer.y, outer.w, outer.h);
            ctx.clip();
            ctx.fillStyle = vm.borderColor;
            ctx.rect(inner.x, inner.y, inner.w, inner.h);
            ctx.fill('evenodd');
            ctx.restore();
        },
        height: function() {
            var vm = this._view;
            return vm.base - vm.y;
        },
        inRange: function(mouseX, mouseY) {
            return inRange(this._view, mouseX, mouseY);
        },
        inLabelRange: function(mouseX, mouseY) {
            var vm = this._view;
            return isVertical(vm) ? inRange(vm, mouseX, null) : inRange(vm, null, mouseY);
        },
        inXRange: function(mouseX) {
            return inRange(this._view, mouseX, null);
        },
        inYRange: function(mouseY) {
            return inRange(this._view, null, mouseY);
        },
        getCenterPoint: function() {
            var vm = this._view;
            var x, y;
            if (isVertical(vm)) {
                x = vm.x;
                y = (vm.y + vm.base) / 2;
            } else {
                x = (vm.x + vm.base) / 2;
                y = vm.y;
            }
            return {
                x: x,
                y: y
            };
        },
        getArea: function() {
            var vm = this._view;
            return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set('bar', {
        hover: {
            mode: 'label'
        },
        scales: {
            xAxes: [
                {
                    type: 'category',
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ],
            yAxes: [
                {
                    type: 'linear'
                }
            ]
        }
    });
    core_defaults._set('global', {
        datasets: {
            bar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    /**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */ function computeMinSampleSize(scale, pixels) {
        var min = scale._length;
        var prev, curr, i, ilen;
        for(i = 1, ilen = pixels.length; i < ilen; ++i)min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
        for(i = 0, ilen = scale.getTicks().length; i < ilen; ++i){
            curr = scale.getPixelForTick(i);
            min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
            prev = curr;
        }
        return min;
    }
    /**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */ function computeFitCategoryTraits(index, ruler, options) {
        var thickness = options.barThickness;
        var count = ruler.stackCount;
        var curr = ruler.pixels[index];
        var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
        var size, ratio;
        if (helpers$1.isNullOrUndef(thickness)) {
            size = min * options.categoryPercentage;
            ratio = options.barPercentage;
        } else {
            // When bar thickness is enforced, category and bar percentages are ignored.
            // Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
            // and deprecate barPercentage since this value is ignored when thickness is absolute.
            size = thickness * count;
            ratio = 1;
        }
        return {
            chunk: size / count,
            ratio: ratio,
            start: curr - size / 2
        };
    }
    /**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */ function computeFlexCategoryTraits(index, ruler, options) {
        var pixels = ruler.pixels;
        var curr = pixels[index];
        var prev = index > 0 ? pixels[index - 1] : null;
        var next = index < pixels.length - 1 ? pixels[index + 1] : null;
        var percent = options.categoryPercentage;
        var start, size;
        if (prev === null) // first data: its size is double based on the next point or,
        // if it's also the last data, we use the scale size.
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
        if (next === null) // last data: its size is also double based on the previous point.
        next = curr + curr - prev;
        start = curr - (curr - Math.min(prev, next)) / 2 * percent;
        size = Math.abs(next - prev) / 2 * percent;
        return {
            chunk: size / ruler.stackCount,
            ratio: options.barPercentage,
            start: start
        };
    }
    var controller_bar = core_datasetController.extend({
        dataElementType: elements.Rectangle,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderSkipped',
            'borderWidth',
            'barPercentage',
            'barThickness',
            'categoryPercentage',
            'maxBarThickness',
            'minBarLength'
        ],
        initialize: function() {
            var me = this;
            var meta, scaleOpts;
            core_datasetController.prototype.initialize.apply(me, arguments);
            meta = me.getMeta();
            meta.stack = me.getDataset().stack;
            meta.bar = true;
            scaleOpts = me._getIndexScale().options;
            deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
            deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
            deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
            deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
            deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
        },
        update: function(reset) {
            var me = this;
            var rects = me.getMeta().data;
            var i, ilen;
            me._ruler = me.getRuler();
            for(i = 0, ilen = rects.length; i < ilen; ++i)me.updateElement(rects[i], i, reset);
        },
        updateElement: function(rectangle, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var dataset = me.getDataset();
            var options = me._resolveDataElementOptions(rectangle, index);
            rectangle._xScale = me.getScaleForId(meta.xAxisID);
            rectangle._yScale = me.getScaleForId(meta.yAxisID);
            rectangle._datasetIndex = me.index;
            rectangle._index = index;
            rectangle._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderSkipped: options.borderSkipped,
                borderWidth: options.borderWidth,
                datasetLabel: dataset.label,
                label: me.chart.data.labels[index]
            };
            if (helpers$1.isArray(dataset.data[index])) rectangle._model.borderSkipped = null;
            me._updateElementGeometry(rectangle, index, reset, options);
            rectangle.pivot();
        },
        /**
	 * @private
	 */ _updateElementGeometry: function(rectangle, index, reset, options) {
            var me = this;
            var model = rectangle._model;
            var vscale = me._getValueScale();
            var base = vscale.getBasePixel();
            var horizontal = vscale.isHorizontal();
            var ruler = me._ruler || me.getRuler();
            var vpixels = me.calculateBarValuePixels(me.index, index, options);
            var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
            model.horizontal = horizontal;
            model.base = reset ? base : vpixels.base;
            model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
            model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
            model.height = horizontal ? ipixels.size : undefined;
            model.width = horizontal ? undefined : ipixels.size;
        },
        /**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */ _getStacks: function(last) {
            var me = this;
            var scale = me._getIndexScale();
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var stacked = scale.options.stacked;
            var ilen = metasets.length;
            var stacks = [];
            var i, meta;
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                // stacked   | meta.stack
                //           | found | not found | undefined
                // false     |   x   |     x     |     x
                // true      |       |     x     |
                // undefined |       |     x     |     x
                if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                if (meta.index === last) break;
            }
            return stacks;
        },
        /**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */ getStackCount: function() {
            return this._getStacks().length;
        },
        /**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */ getStackIndex: function(datasetIndex, name) {
            var stacks = this._getStacks(datasetIndex);
            var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present
            return index === -1 ? stacks.length - 1 : index;
        },
        /**
	 * @private
	 */ getRuler: function() {
            var me = this;
            var scale = me._getIndexScale();
            var pixels = [];
            var i, ilen;
            for(i = 0, ilen = me.getMeta().data.length; i < ilen; ++i)pixels.push(scale.getPixelForValue(null, i, me.index));
            return {
                pixels: pixels,
                start: scale._startPixel,
                end: scale._endPixel,
                stackCount: me.getStackCount(),
                scale: scale
            };
        },
        /**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */ calculateBarValuePixels: function(datasetIndex, index, options) {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var isHorizontal = scale.isHorizontal();
            var datasets = chart.data.datasets;
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var value = scale._parseValue(datasets[datasetIndex].data[index]);
            var minBarLength = options.minBarLength;
            var stacked = scale.options.stacked;
            var stack = me.getMeta().stack;
            var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
            var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
            var ilen = metasets.length;
            var i, imeta, ivalue, base, head, size, stackLength;
            if (stacked || stacked === undefined && stack !== undefined) for(i = 0; i < ilen; ++i){
                imeta = metasets[i];
                if (imeta.index === datasetIndex) break;
                if (imeta.stack === stack) {
                    stackLength = scale._parseValue(datasets[imeta.index].data[index]);
                    ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
                    if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) start += ivalue;
                }
            }
            base = scale.getPixelForValue(start);
            head = scale.getPixelForValue(start + length);
            size = head - base;
            if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
                size = minBarLength;
                if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) head = base - minBarLength;
                else head = base + minBarLength;
            }
            return {
                size: size,
                base: base,
                head: head,
                center: head + size / 2
            };
        },
        /**
	 * @private
	 */ calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
            var me = this;
            var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
            var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
            var center = range.start + range.chunk * stackIndex + range.chunk / 2;
            var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
            return {
                base: center - size / 2,
                head: center + size / 2,
                center: center,
                size: size
            };
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var rects = me.getMeta().data;
            var dataset = me.getDataset();
            var ilen = rects.length;
            var i = 0;
            helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
            for(; i < ilen; ++i){
                var val = scale._parseValue(dataset.data[i]);
                if (!isNaN(val.min) && !isNaN(val.max)) rects[i].draw();
            }
            helpers$1.canvas.unclipArea(chart.ctx);
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function() {
            var me = this;
            var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
            var indexOpts = me._getIndexScale().options;
            var valueOpts = me._getValueScale().options;
            values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
            values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
            values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
            values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
            values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
            return values;
        }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set('bubble', {
        hover: {
            mode: 'single'
        },
        scales: {
            xAxes: [
                {
                    type: 'linear',
                    position: 'bottom',
                    id: 'x-axis-0' // need an ID so datasets can reference the scale
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    position: 'left',
                    id: 'y-axis-0'
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    // Title doesn't make sense for scatter since we format the data as a point
                    return '';
                },
                label: function(item, data) {
                    var datasetLabel = data.datasets[item.datasetIndex].label || '';
                    var dataPoint = data.datasets[item.datasetIndex].data[item.index];
                    return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
                }
            }
        }
    });
    var controller_bubble = core_datasetController.extend({
        /**
	 * @protected
	 */ dataElementType: elements.Point,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth',
            'hoverRadius',
            'hitRadius',
            'pointStyle',
            'rotation'
        ],
        /**
	 * @protected
	 */ update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var points = meta.data;
            // Update Points
            helpers$1.each(points, function(point, index) {
                me.updateElement(point, index, reset);
            });
        },
        /**
	 * @protected
	 */ updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var xScale = me.getScaleForId(meta.xAxisID);
            var yScale = me.getScaleForId(meta.yAxisID);
            var options = me._resolveDataElementOptions(point, index);
            var data = me.getDataset().data[index];
            var dsIndex = me.index;
            var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
            var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = dsIndex;
            point._index = index;
            point._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                hitRadius: options.hitRadius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                radius: reset ? 0 : options.radius,
                skip: custom.skip || isNaN(x) || isNaN(y),
                x: x,
                y: y
            };
            point.pivot();
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
            model.radius = options.radius + options.hoverRadius;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(point, index) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var custom = point.custom || {};
            var data = dataset.data[index] || {};
            var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            // In case values were cached (and thus frozen), we need to clone the values
            if (me._cachedDataOpts === values) values = helpers$1.extend({}, values);
            // Custom radius resolution
            values.radius = resolve$1([
                custom.radius,
                data.r,
                me._config.radius,
                chart.options.elements.point.radius
            ], context, index);
            return values;
        }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set('doughnut', {
        animation: {
            // Boolean - Whether we animate the rotation of the Doughnut
            animateRotate: true,
            // Boolean - Whether we animate scaling the Doughnut from the centre
            animateScale: false
        },
        hover: {
            mode: 'single'
        },
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    // toggle visibility of index if exists
                    if (meta.data[index]) meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // The percentage of the chart that we cut out of the middle.
        cutoutPercentage: 50,
        // The rotation of the chart, where the first data arc begins.
        rotation: -HALF_PI$1,
        // The total circumference of the chart.
        circumference: DOUBLE_PI$1,
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return '';
                },
                label: function(tooltipItem, data) {
                    var dataLabel = data.labels[tooltipItem.index];
                    var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    if (helpers$1.isArray(dataLabel)) {
                        // show value on first line of multiline label
                        // need to clone because we are changing the value
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    });
    var controller_doughnut = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'borderAlign',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth'
        ],
        // Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
        getRingIndex: function(datasetIndex) {
            var ringIndex = 0;
            for(var j = 0; j < datasetIndex; ++j)if (this.chart.isDatasetVisible(j)) ++ringIndex;
            return ringIndex;
        },
        update: function(reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var ratioX = 1;
            var ratioY = 1;
            var offsetX = 0;
            var offsetY = 0;
            var meta = me.getMeta();
            var arcs = meta.data;
            var cutout = opts.cutoutPercentage / 100 || 0;
            var circumference = opts.circumference;
            var chartWeight = me._getRingWeight(me.index);
            var maxWidth, maxHeight, i, ilen;
            // If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
            if (circumference < DOUBLE_PI$1) {
                var startAngle = opts.rotation % DOUBLE_PI$1;
                startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
                var endAngle = startAngle + circumference;
                var startX = Math.cos(startAngle);
                var startY = Math.sin(startAngle);
                var endX = Math.cos(endAngle);
                var endY = Math.sin(endAngle);
                var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
                var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
                var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
                var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
                var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
                var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
                var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
                var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
                ratioX = (maxX - minX) / 2;
                ratioY = (maxY - minY) / 2;
                offsetX = -(maxX + minX) / 2;
                offsetY = -(maxY + minY) / 2;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i)arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
            chart.borderWidth = me.getMaxBorderWidth();
            maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
            maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
            chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
            chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
            chart.offsetX = offsetX * chart.outerRadius;
            chart.offsetY = offsetY * chart.outerRadius;
            meta.total = me.calculateTotal();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
            me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
            for(i = 0, ilen = arcs.length; i < ilen; ++i)me.updateElement(arcs[i], i, reset);
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var animationOpts = opts.animation;
            var centerX = (chartArea.left + chartArea.right) / 2;
            var centerY = (chartArea.top + chartArea.bottom) / 2;
            var startAngle = opts.rotation; // non reset case handled later
            var endAngle = opts.rotation; // non reset case handled later
            var dataset = me.getDataset();
            var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
            var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
            var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX + chart.offsetX,
                    y: centerY + chart.offsetY,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    circumference: circumference,
                    outerRadius: outerRadius,
                    innerRadius: innerRadius,
                    label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
                }
            });
            var model = arc._model;
            // Set correct angles if not resetting
            if (!reset || !animationOpts.animateRotate) {
                if (index === 0) model.startAngle = opts.rotation;
                else model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
                model.endAngle = model.startAngle + model.circumference;
            }
            arc.pivot();
        },
        calculateTotal: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var total = 0;
            var value;
            helpers$1.each(meta.data, function(element, index) {
                value = dataset.data[index];
                if (!isNaN(value) && !element.hidden) total += Math.abs(value);
            });
            /* if (total === 0) {
			total = NaN;
		}*/ return total;
        },
        calculateCircumference: function(value) {
            var total = this.getMeta().total;
            if (total > 0 && !isNaN(value)) return DOUBLE_PI$1 * (Math.abs(value) / total);
            return 0;
        },
        // gets the max border or hover width to properly scale pie charts
        getMaxBorderWidth: function(arcs) {
            var me = this;
            var max = 0;
            var chart = me.chart;
            var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
            if (!arcs) {
                // Find the outmost visible dataset
                for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                    meta = chart.getDatasetMeta(i);
                    arcs = meta.data;
                    if (i !== me.index) controller = meta.controller;
                    break;
                }
            }
            if (!arcs) return 0;
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arc = arcs[i];
                if (controller) {
                    controller._configure();
                    options = controller._resolveDataElementOptions(arc, i);
                } else options = arc._options;
                if (options.borderAlign !== 'inner') {
                    borderWidth = options.borderWidth;
                    hoverWidth = options.hoverBorderWidth;
                    max = borderWidth > max ? borderWidth : max;
                    max = hoverWidth > max ? hoverWidth : max;
                }
            }
            return max;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */ _getRingWeightOffset: function(datasetIndex) {
            var ringWeightOffset = 0;
            for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
            return ringWeightOffset;
        },
        /**
	 * @private
	 */ _getRingWeight: function(dataSetIndex) {
            return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
        },
        /**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */ _getVisibleDatasetWeightTotal: function() {
            return this._getRingWeightOffset(this.chart.data.datasets.length);
        }
    });
    core_defaults._set('horizontalBar', {
        hover: {
            mode: 'index',
            axis: 'y'
        },
        scales: {
            xAxes: [
                {
                    type: 'linear',
                    position: 'bottom'
                }
            ],
            yAxes: [
                {
                    type: 'category',
                    position: 'left',
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ]
        },
        elements: {
            rectangle: {
                borderSkipped: 'left'
            }
        },
        tooltips: {
            mode: 'index',
            axis: 'y'
        }
    });
    core_defaults._set('global', {
        datasets: {
            horizontalBar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    var controller_horizontalBar = controller_bar.extend({
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().yAxisID;
        }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set('line', {
        showLines: true,
        spanGaps: false,
        hover: {
            mode: 'label'
        },
        scales: {
            xAxes: [
                {
                    type: 'category',
                    id: 'x-axis-0'
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    id: 'y-axis-0'
                }
            ]
        }
    });
    function scaleClip(scale, halfBorderWidth) {
        var tickOpts = scale && scale.options.ticks || {};
        var reverse = tickOpts.reverse;
        var min = tickOpts.min === undefined ? halfBorderWidth : 0;
        var max = tickOpts.max === undefined ? halfBorderWidth : 0;
        return {
            start: reverse ? max : min,
            end: reverse ? min : max
        };
    }
    function defaultClip(xScale, yScale, borderWidth) {
        var halfBorderWidth = borderWidth / 2;
        var x = scaleClip(xScale, halfBorderWidth);
        var y = scaleClip(yScale, halfBorderWidth);
        return {
            top: y.end,
            right: x.end,
            bottom: y.start,
            left: x.start
        };
    }
    function toClip(value) {
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = value.top;
            r = value.right;
            b = value.bottom;
            l = value.left;
        } else t = r = b = l = value;
        return {
            top: t,
            right: r,
            bottom: b,
            left: l
        };
    }
    var controller_line = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        /**
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderCapStyle',
            'borderColor',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'borderWidth',
            'cubicInterpolationMode',
            'fill'
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: 'pointBackgroundColor',
            borderColor: 'pointBorderColor',
            borderWidth: 'pointBorderWidth',
            hitRadius: 'pointHitRadius',
            hoverBackgroundColor: 'pointHoverBackgroundColor',
            hoverBorderColor: 'pointHoverBorderColor',
            hoverBorderWidth: 'pointHoverBorderWidth',
            hoverRadius: 'pointHoverRadius',
            pointStyle: 'pointStyle',
            radius: 'pointRadius',
            rotation: 'pointRotation'
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var options = me.chart.options;
            var config = me._config;
            var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
            var i, ilen;
            me._xScale = me.getScaleForId(meta.xAxisID);
            me._yScale = me.getScaleForId(meta.yAxisID);
            // Update Line
            if (showLine) {
                // Compatibility: If the properties are defined with only the old name, use those values
                if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
                // Utility
                line._scale = me._yScale;
                line._datasetIndex = me.index;
                // Data
                line._children = points;
                // Model
                line._model = me._resolveDatasetElementOptions(line);
                line.pivot();
            }
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            if (showLine && line._model.tension !== 0) me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var datasetIndex = me.index;
            var value = dataset.data[index];
            var xScale = me._xScale;
            var yScale = me._yScale;
            var lineModel = meta.dataset._model;
            var x, y;
            var options = me._resolveDataElementOptions(point, index);
            x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
            y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
            // Utility
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = datasetIndex;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
                steppedLine: lineModel ? lineModel.steppedLine : false,
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element) {
            var me = this;
            var config = me._config;
            var custom = element.custom || {};
            var options = me.chart.options;
            var lineOptions = options.elements.line;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            // The default behavior of lines is to break at null values, according
            // to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
            // This option gives lines the ability to span gaps
            values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
            values.steppedLine = resolve$2([
                custom.steppedLine,
                config.steppedLine,
                lineOptions.stepped
            ]);
            values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
            return values;
        },
        calculatePointY: function(value, index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            var yScale = me._yScale;
            var sumPos = 0;
            var sumNeg = 0;
            var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
            if (yScale.options.stacked) {
                rightValue = +yScale.getRightValue(value);
                metasets = chart._getSortedVisibleDatasetMetas();
                ilen = metasets.length;
                for(i = 0; i < ilen; ++i){
                    dsMeta = metasets[i];
                    if (dsMeta.index === datasetIndex) break;
                    ds = chart.data.datasets[dsMeta.index];
                    if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
                        stackedRightValue = +yScale.getRightValue(ds.data[index]);
                        if (stackedRightValue < 0) sumNeg += stackedRightValue || 0;
                        else sumPos += stackedRightValue || 0;
                    }
                }
                if (rightValue < 0) return yScale.getPixelForValue(sumNeg + rightValue);
                return yScale.getPixelForValue(sumPos + rightValue);
            }
            return yScale.getPixelForValue(value);
        },
        updateBezierControlPoints: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var lineModel = meta.dataset._model;
            var area = chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (lineModel.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            if (lineModel.cubicInterpolationMode === 'monotone') helpers$1.splineCurveMonotone(points);
            else for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
                model.controlPointPreviousX = controlPoints.previous.x;
                model.controlPointPreviousY = controlPoints.previous.y;
                model.controlPointNextX = controlPoints.next.x;
                model.controlPointNextY = controlPoints.next.y;
            }
            if (chart.options.elements.line.capBezierPoints) for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                if (isPointInArea(model, area)) {
                    if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                        model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                        model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
                    }
                    if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                        model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                        model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
                    }
                }
            }
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var points = meta.data || [];
            var area = chart.chartArea;
            var canvas = chart.canvas;
            var i = 0;
            var ilen = points.length;
            var clip;
            if (me._showLine) {
                clip = meta.dataset._model.clip;
                helpers$1.canvas.clipArea(chart.ctx, {
                    left: clip.left === false ? 0 : area.left - clip.left,
                    right: clip.right === false ? canvas.width : area.right + clip.right,
                    top: clip.top === false ? 0 : area.top - clip.top,
                    bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
                });
                meta.dataset.draw();
                helpers$1.canvas.unclipArea(chart.ctx);
            }
            // Draw the points
            for(; i < ilen; ++i)points[i].draw(area);
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
        }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set('polarArea', {
        scale: {
            type: 'radialLinear',
            angleLines: {
                display: false
            },
            gridLines: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            ticks: {
                beginAtZero: true
            }
        },
        // Boolean - Whether to animate the rotation of the chart
        animation: {
            animateRotate: true,
            animateScale: true
        },
        startAngle: -0.5 * Math.PI,
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return '';
                },
                label: function(item, data) {
                    return data.labels[item.index] + ': ' + item.yLabel;
                }
            }
        }
    });
    var controller_polarArea = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'borderAlign',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth'
        ],
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            var start = me.chart.options.startAngle || 0;
            var starts = me._starts = [];
            var angles = me._angles = [];
            var arcs = meta.data;
            var i, ilen, angle;
            me._updateRadius();
            meta.count = me.countVisibleElements();
            for(i = 0, ilen = dataset.data.length; i < ilen; i++){
                starts[i] = start;
                angle = me._computeAngle(i);
                angles[i] = angle;
                start += angle;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
                me.updateElement(arcs[i], i, reset);
            }
        },
        /**
	 * @private
	 */ _updateRadius: function() {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            chart.outerRadius = Math.max(minSize / 2, 0);
            chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
            me.innerRadius = me.outerRadius - chart.radiusLength;
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var opts = chart.options;
            var animationOpts = opts.animation;
            var scale = chart.scale;
            var labels = chart.data.labels;
            var centerX = scale.xCenter;
            var centerY = scale.yCenter;
            // var negHalfPI = -0.5 * Math.PI;
            var datasetStartAngle = opts.startAngle;
            var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var startAngle = me._starts[index];
            var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
            var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                _scale: scale,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX,
                    y: centerY,
                    innerRadius: 0,
                    outerRadius: reset ? resetRadius : distance,
                    startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
                    endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
                    label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
                }
            });
            arc.pivot();
        },
        countVisibleElements: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var count = 0;
            helpers$1.each(meta.data, function(element, index) {
                if (!isNaN(dataset.data[index]) && !element.hidden) count++;
            });
            return count;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            var valueOrDefault = helpers$1.valueOrDefault;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * @private
	 */ _computeAngle: function(index) {
            var me = this;
            var count = this.getMeta().count;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            if (isNaN(dataset.data[index]) || meta.data[index].hidden) return 0;
            // Scriptable options
            var context = {
                chart: me.chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            return resolve$3([
                me.chart.options.elements.arc.angle,
                2 * Math.PI / count
            ], context, index);
        }
    });
    core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
    core_defaults._set('pie', {
        cutoutPercentage: 0
    });
    // Pie charts are Doughnut chart with different defaults
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set('radar', {
        spanGaps: false,
        scale: {
            type: 'radialLinear'
        },
        elements: {
            line: {
                fill: 'start',
                tension: 0 // no bezier in radar
            }
        }
    });
    var controller_radar = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderWidth',
            'borderColor',
            'borderCapStyle',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'fill'
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: 'pointBackgroundColor',
            borderColor: 'pointBorderColor',
            borderWidth: 'pointBorderWidth',
            hitRadius: 'pointHitRadius',
            hoverBackgroundColor: 'pointHoverBackgroundColor',
            hoverBorderColor: 'pointHoverBorderColor',
            hoverBorderWidth: 'pointHoverBorderWidth',
            hoverRadius: 'pointHoverRadius',
            pointStyle: 'pointStyle',
            radius: 'pointRadius',
            rotation: 'pointRotation'
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var scale = me.chart.scale;
            var config = me._config;
            var i, ilen;
            // Compatibility: If the properties are defined with only the old name, use those values
            if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
            // Utility
            line._scale = scale;
            line._datasetIndex = me.index;
            // Data
            line._children = points;
            line._loop = true;
            // Model
            line._model = me._resolveDatasetElementOptions(line);
            line.pivot();
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            // Update bezier control points
            me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var scale = me.chart.scale;
            var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
            var options = me._resolveDataElementOptions(point, index);
            var lineModel = me.getMeta().dataset._model;
            var x = reset ? scale.xCenter : pointPosition.x;
            var y = reset ? scale.yCenter : pointPosition.y;
            // Utility
            point._scale = scale;
            point._options = options;
            point._datasetIndex = me.index;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function() {
            var me = this;
            var config = me._config;
            var options = me.chart.options;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
            return values;
        },
        updateBezierControlPoints: function() {
            var me = this;
            var meta = me.getMeta();
            var area = me.chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (meta.dataset._model.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
                // Prevent the bezier going outside of the bounds of the graph
                model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
                model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
                model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
            }
        },
        setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
        }
    });
    core_defaults._set('scatter', {
        hover: {
            mode: 'single'
        },
        scales: {
            xAxes: [
                {
                    id: 'x-axis-1',
                    type: 'linear',
                    position: 'bottom'
                }
            ],
            yAxes: [
                {
                    id: 'y-axis-1',
                    type: 'linear',
                    position: 'left'
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    return ''; // doesn't make sense for scatter since data are formatted as a point
                },
                label: function(item) {
                    return '(' + item.xLabel + ', ' + item.yLabel + ')';
                }
            }
        }
    });
    core_defaults._set('global', {
        datasets: {
            scatter: {
                showLine: false
            }
        }
    });
    // Scatter charts use line controllers
    var controller_scatter = controller_line;
    // NOTE export a map in which the key represents the controller type, not
    // the class, and so must be CamelCase in order to be correctly retrieved
    // by the controller in core.controller.js (`controllers[meta.type]`).
    var controllers = {
        bar: controller_bar,
        bubble: controller_bubble,
        doughnut: controller_doughnut,
        horizontalBar: controller_horizontalBar,
        line: controller_line,
        polarArea: controller_polarArea,
        pie: controller_pie,
        radar: controller_radar,
        scatter: controller_scatter
    };
    /**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */ function getRelativePosition(e, chart) {
        if (e.native) return {
            x: e.x,
            y: e.y
        };
        return helpers$1.getRelativePosition(e, chart);
    }
    /**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */ function parseVisibleItems(chart, handler) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var metadata, i, j, ilen, jlen, element;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            metadata = metasets[i].data;
            for(j = 0, jlen = metadata.length; j < jlen; ++j){
                element = metadata[j];
                if (!element._view.skip) handler(element);
            }
        }
    }
    /**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */ function getIntersectItems(chart, position) {
        var elements = [];
        parseVisibleItems(chart, function(element) {
            if (element.inRange(position.x, position.y)) elements.push(element);
        });
        return elements;
    }
    /**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */ function getNearestItems(chart, position, intersect, distanceMetric) {
        var minDistance = Number.POSITIVE_INFINITY;
        var nearestItems = [];
        parseVisibleItems(chart, function(element) {
            if (intersect && !element.inRange(position.x, position.y)) return;
            var center = element.getCenterPoint();
            var distance = distanceMetric(position, center);
            if (distance < minDistance) {
                nearestItems = [
                    element
                ];
                minDistance = distance;
            } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
            nearestItems.push(element);
        });
        return nearestItems;
    }
    /**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */ function getDistanceMetricForAxis(axis) {
        var useX = axis.indexOf('x') !== -1;
        var useY = axis.indexOf('y') !== -1;
        return function(pt1, pt2) {
            var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
            var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
            return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        };
    }
    function indexMode(chart, e, options) {
        var position = getRelativePosition(e, chart);
        // Default axis for index mode is 'x' to match old behaviour
        options.axis = options.axis || 'x';
        var distanceMetric = getDistanceMetricForAxis(options.axis);
        var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
        var elements = [];
        if (!items.length) return [];
        chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
            var element = meta.data[items[0]._index];
            // don't count items that are skipped (null data)
            if (element && !element._view.skip) elements.push(element);
        });
        return elements;
    }
    /**
 * @interface IInteractionOptions
 */ /**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */ /**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */ var core_interaction = {
        // Helper function for different modes
        modes: {
            single: function(chart, e) {
                var position = getRelativePosition(e, chart);
                var elements = [];
                parseVisibleItems(chart, function(element) {
                    if (element.inRange(position.x, position.y)) {
                        elements.push(element);
                        return elements;
                    }
                });
                return elements.slice(0, 1);
            },
            /**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */ label: indexMode,
            /**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ index: indexMode,
            /**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ dataset: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || 'xy';
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
                if (items.length > 0) items = chart.getDatasetMeta(items[0]._datasetIndex).data;
                return items;
            },
            /**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */ 'x-axis': function(chart, e) {
                return indexMode(chart, e, {
                    intersect: false
                });
            },
            /**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ point: function(chart, e) {
                var position = getRelativePosition(e, chart);
                return getIntersectItems(chart, position);
            },
            /**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ nearest: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || 'xy';
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                return getNearestItems(chart, position, options.intersect, distanceMetric);
            },
            /**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ x: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inXRange(position.x)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            },
            /**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ y: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inYRange(position.y)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            }
        }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
        return helpers$1.where(array, function(v) {
            return v.pos === position;
        });
    }
    function sortByWeight(array, reverse) {
        return array.sort(function(a, b) {
            var v0 = reverse ? b : a;
            var v1 = reverse ? a : b;
            return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
        });
    }
    function wrapBoxes(boxes) {
        var layoutBoxes = [];
        var i, ilen, box;
        for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
            box = boxes[i];
            layoutBoxes.push({
                index: i,
                box: box,
                pos: box.position,
                horizontal: box.isHorizontal(),
                weight: box.weight
            });
        }
        return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
        var i, ilen, layout;
        for(i = 0, ilen = layouts.length; i < ilen; ++i){
            layout = layouts[i];
            // store width used instead of chartArea.w in fitBoxes
            layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
            // store height used instead of chartArea.h in fitBoxes
            layout.height = layout.horizontal && params.hBoxMaxHeight;
        }
    }
    function buildLayoutBoxes(boxes) {
        var layoutBoxes = wrapBoxes(boxes);
        var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
        var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
        var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
        var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
        return {
            leftAndTop: left.concat(top),
            rightAndBottom: right.concat(bottom),
            chartArea: filterByPosition(layoutBoxes, 'chartArea'),
            vertical: left.concat(right),
            horizontal: top.concat(bottom)
        };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
        return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
        var box = layout.box;
        var maxPadding = chartArea.maxPadding;
        var newWidth, newHeight;
        if (layout.size) // this layout was already counted for, lets first reduce old size
        chartArea[layout.pos] -= layout.size;
        layout.size = layout.horizontal ? box.height : box.width;
        chartArea[layout.pos] += layout.size;
        if (box.getPadding) {
            var boxPadding = box.getPadding();
            maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
            maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
            maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
            maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
        }
        newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
        newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
        if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
            chartArea.w = newWidth;
            chartArea.h = newHeight;
            // return true if chart area changed in layout's direction
            var sizes = layout.horizontal ? [
                newWidth,
                chartArea.w
            ] : [
                newHeight,
                chartArea.h
            ];
            return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
        }
    }
    function handleMaxPadding(chartArea) {
        var maxPadding = chartArea.maxPadding;
        function updatePos(pos) {
            var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
            chartArea[pos] += change;
            return change;
        }
        chartArea.y += updatePos('top');
        chartArea.x += updatePos('left');
        updatePos('right');
        updatePos('bottom');
    }
    function getMargins(horizontal, chartArea) {
        var maxPadding = chartArea.maxPadding;
        function marginForPositions(positions) {
            var margin = {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            positions.forEach(function(pos) {
                margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
            });
            return margin;
        }
        return horizontal ? marginForPositions([
            'left',
            'right'
        ]) : marginForPositions([
            'top',
            'bottom'
        ]);
    }
    function fitBoxes(boxes, chartArea, params) {
        var refitBoxes = [];
        var i, ilen, layout, box, refit, changed;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
            if (updateDims(chartArea, params, layout)) {
                changed = true;
                if (refitBoxes.length) // Dimensions changed and there were non full width boxes before this
                // -> we have to refit those
                refit = true;
            }
            if (!box.fullWidth) refitBoxes.push(layout);
        }
        return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
        var userPadding = params.padding;
        var x = chartArea.x;
        var y = chartArea.y;
        var i, ilen, layout, box;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            if (layout.horizontal) {
                box.left = box.fullWidth ? userPadding.left : chartArea.left;
                box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
                box.top = y;
                box.bottom = y + box.height;
                box.width = box.right - box.left;
                y = box.bottom;
            } else {
                box.left = x;
                box.right = x + box.width;
                box.top = chartArea.top;
                box.bottom = chartArea.top + chartArea.h;
                box.height = box.bottom - box.top;
                x = box.right;
            }
        }
        chartArea.x = x;
        chartArea.y = y;
    }
    core_defaults._set('global', {
        layout: {
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        }
    });
    /**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */ // The layout service is very self explanatory.  It's responsible for the layout within a chart.
    // Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
    // It is this service's responsibility of carrying out that layout.
    var core_layouts = {
        defaults: {},
        /**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */ addBox: function(chart, item) {
            if (!chart.boxes) chart.boxes = [];
            // initialize item with default values
            item.fullWidth = item.fullWidth || false;
            item.position = item.position || 'top';
            item.weight = item.weight || 0;
            item._layers = item._layers || function() {
                return [
                    {
                        z: 0,
                        draw: function() {
                            item.draw.apply(item, arguments);
                        }
                    }
                ];
            };
            chart.boxes.push(item);
        },
        /**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */ removeBox: function(chart, layoutItem) {
            var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
            if (index !== -1) chart.boxes.splice(index, 1);
        },
        /**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */ configure: function(chart, item, options) {
            var props = [
                'fullWidth',
                'position',
                'weight'
            ];
            var ilen = props.length;
            var i = 0;
            var prop;
            for(; i < ilen; ++i){
                prop = props[i];
                if (options.hasOwnProperty(prop)) item[prop] = options[prop];
            }
        },
        /**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */ update: function(chart, width, height) {
            if (!chart) return;
            var layoutOptions = chart.options.layout || {};
            var padding = helpers$1.options.toPadding(layoutOptions.padding);
            var availableWidth = width - padding.width;
            var availableHeight = height - padding.height;
            var boxes = buildLayoutBoxes(chart.boxes);
            var verticalBoxes = boxes.vertical;
            var horizontalBoxes = boxes.horizontal;
            // Essentially we now have any number of boxes on each of the 4 sides.
            // Our canvas looks like the following.
            // The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
            // B1 is the bottom axis
            // There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
            // These locations are single-box locations only, when trying to register a chartArea location that is already taken,
            // an error will be thrown.
            //
            // |----------------------------------------------------|
            // |                  T1 (Full Width)                   |
            // |----------------------------------------------------|
            // |    |    |                 T2                  |    |
            // |    |----|-------------------------------------|----|
            // |    |    | C1 |                           | C2 |    |
            // |    |    |----|                           |----|    |
            // |    |    |                                     |    |
            // | L1 | L2 |           ChartArea (C0)            | R1 |
            // |    |    |                                     |    |
            // |    |    |----|                           |----|    |
            // |    |    | C3 |                           | C4 |    |
            // |    |----|-------------------------------------|----|
            // |    |    |                 B1                  |    |
            // |----------------------------------------------------|
            // |                  B2 (Full Width)                   |
            // |----------------------------------------------------|
            //
            var params = Object.freeze({
                outerWidth: width,
                outerHeight: height,
                padding: padding,
                availableWidth: availableWidth,
                vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
                hBoxMaxHeight: availableHeight / 2
            });
            var chartArea = extend({
                maxPadding: extend({}, padding),
                w: availableWidth,
                h: availableHeight,
                x: padding.left,
                y: padding.top
            }, padding);
            setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
            // First fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            // Then fit horizontal boxes
            if (fitBoxes(horizontalBoxes, chartArea, params)) // if the area changed, re-fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            handleMaxPadding(chartArea);
            // Finally place the boxes to correct coordinates
            placeBoxes(boxes.leftAndTop, chartArea, params);
            // Move to opposite side of chart
            chartArea.x += chartArea.w;
            chartArea.y += chartArea.h;
            placeBoxes(boxes.rightAndBottom, chartArea, params);
            chart.chartArea = {
                left: chartArea.left,
                top: chartArea.top,
                right: chartArea.left + chartArea.w,
                bottom: chartArea.top + chartArea.h
            };
            // Finally update boxes in chartArea (radial scale for example)
            helpers$1.each(boxes.chartArea, function(layout) {
                var box = layout.box;
                extend(box, chart.chartArea);
                box.update(chartArea.w, chartArea.h);
            });
        }
    };
    /**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */ var platform_basic = {
        acquireContext: function(item) {
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            return item && item.getContext('2d') || null;
        }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        'default': platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = '$chartjs';
    var CSS_PREFIX = 'chartjs-';
    var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
    var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
    var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
    var ANIMATION_START_EVENTS = [
        'animationstart',
        'webkitAnimationStart'
    ];
    /**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */ var EVENT_TYPES = {
        touchstart: 'mousedown',
        touchmove: 'mousemove',
        touchend: 'mouseup',
        pointerenter: 'mouseenter',
        pointerdown: 'mousedown',
        pointermove: 'mousemove',
        pointerup: 'mouseup',
        pointerleave: 'mouseout',
        pointerout: 'mouseout'
    };
    /**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
        var value = helpers$1.getStyle(element, property);
        var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
        return matches ? Number(matches[1]) : undefined;
    }
    /**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */ function initCanvas(canvas, config) {
        var style = canvas.style;
        // NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
        // returns null or '' if no explicit value has been set to the canvas attribute.
        var renderHeight = canvas.getAttribute('height');
        var renderWidth = canvas.getAttribute('width');
        // Chart.js modifies some canvas values that we want to restore on destroy
        canvas[EXPANDO_KEY] = {
            initial: {
                height: renderHeight,
                width: renderWidth,
                style: {
                    display: style.display,
                    height: style.height,
                    width: style.width
                }
            }
        };
        // Force canvas to display as block to avoid extra space caused by inline
        // elements, which would interfere with the responsive resize process.
        // https://github.com/chartjs/Chart.js/issues/2538
        style.display = style.display || 'block';
        if (renderWidth === null || renderWidth === '') {
            var displayWidth = readUsedSize(canvas, 'width');
            if (displayWidth !== undefined) canvas.width = displayWidth;
        }
        if (renderHeight === null || renderHeight === '') {
            if (canvas.style.height === '') // If no explicit render height and style height, let's apply the aspect ratio,
            // which one can be specified by the user but also by charts as default option
            // (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
            canvas.height = canvas.width / (config.options.aspectRatio || 2);
            else {
                var displayHeight = readUsedSize(canvas, 'height');
                if (displayWidth !== undefined) canvas.height = displayHeight;
            }
        }
        return canvas;
    }
    /**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var supportsEventListenerOptions = function() {
        var supports = false;
        try {
            var options = Object.defineProperty({}, 'passive', {
                // eslint-disable-next-line getter-return
                get: function() {
                    supports = true;
                }
            });
            window.addEventListener('e', null, options);
        } catch (e) {
        // continue regardless of error
        }
        return supports;
    }();
    // Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
    // https://github.com/chartjs/Chart.js/issues/4287
    var eventListenerOptions = supportsEventListenerOptions ? {
        passive: true
    } : false;
    function addListener(node, type, listener) {
        node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
        node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
        return {
            type: type,
            chart: chart,
            native: nativeEvent || null,
            x: x !== undefined ? x : null,
            y: y !== undefined ? y : null
        };
    }
    function fromNativeEvent(event, chart) {
        var type = EVENT_TYPES[event.type] || event.type;
        var pos = helpers$1.getRelativePosition(event, chart);
        return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
        var ticking = false;
        var args = [];
        return function() {
            args = Array.prototype.slice.call(arguments);
            thisArg = thisArg || this;
            if (!ticking) {
                ticking = true;
                helpers$1.requestAnimFrame.call(window, function() {
                    ticking = false;
                    fn.apply(thisArg, args);
                });
            }
        };
    }
    function createDiv(cls) {
        var el = document.createElement('div');
        el.className = cls || '';
        return el;
    }
    // Implementation based on https://github.com/marcj/css-element-queries
    function createResizer(handler) {
        var maxSize = 1000000;
        // NOTE(SB) Don't use innerHTML because it could be considered unsafe.
        // https://github.com/chartjs/Chart.js/issues/5902
        var resizer = createDiv(CSS_SIZE_MONITOR);
        var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
        var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
        expand.appendChild(createDiv());
        shrink.appendChild(createDiv());
        resizer.appendChild(expand);
        resizer.appendChild(shrink);
        resizer._reset = function() {
            expand.scrollLeft = maxSize;
            expand.scrollTop = maxSize;
            shrink.scrollLeft = maxSize;
            shrink.scrollTop = maxSize;
        };
        var onScroll = function() {
            resizer._reset();
            handler();
        };
        addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
        addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
        return resizer;
    }
    // https://davidwalsh.name/detect-node-insertion
    function watchForRender(node, handler) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        var proxy = expando.renderProxy = function(e) {
            if (e.animationName === CSS_RENDER_ANIMATION) handler();
        };
        helpers$1.each(ANIMATION_START_EVENTS, function(type) {
            addListener(node, type, proxy);
        });
        // #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
        // is removed then added back immediately (same animation frame?). Accessing the
        // `offsetParent` property will force a reflow and re-evaluate the CSS animation.
        // https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
        // https://github.com/chartjs/Chart.js/issues/4737
        expando.reflow = !!node.offsetParent;
        node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
        var expando = node[EXPANDO_KEY] || {};
        var proxy = expando.renderProxy;
        if (proxy) {
            helpers$1.each(ANIMATION_START_EVENTS, function(type) {
                removeListener(node, type, proxy);
            });
            delete expando.renderProxy;
        }
        node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        // Let's keep track of this added resizer and thus avoid DOM query when removing it.
        var resizer = expando.resizer = createResizer(throttled(function() {
            if (expando.resizer) {
                var container = chart.options.maintainAspectRatio && node.parentNode;
                var w = container ? container.clientWidth : 0;
                listener(createEvent('resize', chart));
                if (container && container.clientWidth < w && chart.canvas) // If the container size shrank during chart resize, let's assume
                // scrollbar appeared. So we resize again with the scrollbar visible -
                // effectively making chart smaller and the scrollbar hidden again.
                // Because we are inside `throttled`, and currently `ticking`, scroll
                // events are ignored during this whole 2 resize process.
                // If we assumed wrong and something else happened, we are resizing
                // twice in a frame (potential performance issue)
                listener(createEvent('resize', chart));
            }
        }));
        // The resizer needs to be attached to the node parent, so we first need to be
        // sure that `node` is attached to the DOM before injecting the resizer element.
        watchForRender(node, function() {
            if (expando.resizer) {
                var container = node.parentNode;
                if (container && container !== resizer.parentNode) container.insertBefore(resizer, container.firstChild);
                // The container size might have changed, let's reset the resizer state.
                resizer._reset();
            }
        });
    }
    function removeResizeListener(node) {
        var expando = node[EXPANDO_KEY] || {};
        var resizer = expando.resizer;
        delete expando.resizer;
        unwatchForRender(node);
        if (resizer && resizer.parentNode) resizer.parentNode.removeChild(resizer);
    }
    /**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */ function injectCSS(rootNode, css) {
        // https://stackoverflow.com/q/3922139
        var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
        if (!expando.containsStyles) {
            expando.containsStyles = true;
            css = '/* Chart.js */\n' + css;
            var style = document.createElement('style');
            style.setAttribute('type', 'text/css');
            style.appendChild(document.createTextNode(css));
            rootNode.appendChild(style);
        }
    }
    var platform_dom$2 = {
        /**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */ disableCSSInjection: false,
        /**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */ _enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
        /**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */ _ensureLoaded: function(canvas) {
            if (!this.disableCSSInjection) {
                // If the canvas is in a shadow DOM, then the styles must also be inserted
                // into the same shadow DOM.
                // https://github.com/chartjs/Chart.js/issues/5763
                var root = canvas.getRootNode ? canvas.getRootNode() : document;
                var targetNode = root.host ? root : document.head;
                injectCSS(targetNode, stylesheet);
            }
        },
        acquireContext: function(item, config) {
            if (typeof item === 'string') item = document.getElementById(item);
            else if (item.length) // Support for array based queries (such as jQuery)
            item = item[0];
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            // To prevent canvas fingerprinting, some add-ons undefine the getContext
            // method, for example: https://github.com/kkapsner/CanvasBlocker
            // https://github.com/chartjs/Chart.js/issues/2807
            var context = item && item.getContext && item.getContext('2d');
            // `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
            // inside an iframe or when running in a protected environment. We could guess the
            // types from their toString() value but let's keep things flexible and assume it's
            // a sufficient condition if the item has a context2D which has item as `canvas`.
            // https://github.com/chartjs/Chart.js/issues/3887
            // https://github.com/chartjs/Chart.js/issues/4102
            // https://github.com/chartjs/Chart.js/issues/4152
            if (context && context.canvas === item) {
                // Load platform resources on first chart creation, to make it possible to
                // import the library before setting platform options.
                this._ensureLoaded(item);
                initCanvas(item, config);
                return context;
            }
            return null;
        },
        releaseContext: function(context) {
            var canvas = context.canvas;
            if (!canvas[EXPANDO_KEY]) return;
            var initial = canvas[EXPANDO_KEY].initial;
            [
                'height',
                'width'
            ].forEach(function(prop) {
                var value = initial[prop];
                if (helpers$1.isNullOrUndef(value)) canvas.removeAttribute(prop);
                else canvas.setAttribute(prop, value);
            });
            helpers$1.each(initial.style || {}, function(value, key) {
                canvas.style[key] = value;
            });
            // The canvas render size might have been changed (and thus the state stack discarded),
            // we can't use save() and restore() to restore the initial state. So make sure that at
            // least the canvas context is reset to the default state by setting the canvas width.
            // https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
            // eslint-disable-next-line no-self-assign
            canvas.width = canvas.width;
            delete canvas[EXPANDO_KEY];
        },
        addEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === 'resize') {
                // Note: the resize event is not supported on all browsers.
                addResizeListener(canvas, listener, chart);
                return;
            }
            var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
            var proxies = expando.proxies || (expando.proxies = {});
            var proxy = proxies[chart.id + '_' + type] = function(event) {
                listener(fromNativeEvent(event, chart));
            };
            addListener(canvas, type, proxy);
        },
        removeEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === 'resize') {
                // Note: the resize event is not supported on all browsers.
                removeResizeListener(canvas);
                return;
            }
            var expando = listener[EXPANDO_KEY] || {};
            var proxies = expando.proxies || {};
            var proxy = proxies[chart.id + '_' + type];
            if (!proxy) return;
            removeListener(canvas, type, proxy);
        }
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.addEvent = addListener;
    /**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.removeEvent = removeListener;
    // @TODO Make possible to select another platform at build time.
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    /**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */ var platform = helpers$1.extend({
        /**
	 * @since 2.7.0
	 */ initialize: function() {},
        /**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */ acquireContext: function() {},
        /**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */ releaseContext: function() {},
        /**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */ addEventListener: function() {},
        /**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */ removeEventListener: function() {}
    }, implementation);
    core_defaults._set('global', {
        plugins: {}
    });
    /**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */ var core_plugins = {
        /**
	 * Globally registered plugins.
	 * @private
	 */ _plugins: [],
        /**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */ _cacheId: 0,
        /**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ register: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                if (p.indexOf(plugin) === -1) p.push(plugin);
            });
            this._cacheId++;
        },
        /**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ unregister: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                var idx = p.indexOf(plugin);
                if (idx !== -1) p.splice(idx, 1);
            });
            this._cacheId++;
        },
        /**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */ clear: function() {
            this._plugins = [];
            this._cacheId++;
        },
        /**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */ count: function() {
            return this._plugins.length;
        },
        /**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */ getAll: function() {
            return this._plugins;
        },
        /**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */ notify: function(chart, hook, args) {
            var descriptors = this.descriptors(chart);
            var ilen = descriptors.length;
            var i, descriptor, plugin, params, method;
            for(i = 0; i < ilen; ++i){
                descriptor = descriptors[i];
                plugin = descriptor.plugin;
                method = plugin[hook];
                if (typeof method === 'function') {
                    params = [
                        chart
                    ].concat(args || []);
                    params.push(descriptor.options);
                    if (method.apply(plugin, params) === false) return false;
                }
            }
            return true;
        },
        /**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */ descriptors: function(chart) {
            var cache = chart.$plugins || (chart.$plugins = {});
            if (cache.id === this._cacheId) return cache.descriptors;
            var plugins = [];
            var descriptors = [];
            var config = chart && chart.config || {};
            var options = config.options && config.options.plugins || {};
            this._plugins.concat(config.plugins || []).forEach(function(plugin) {
                var idx = plugins.indexOf(plugin);
                if (idx !== -1) return;
                var id = plugin.id;
                var opts = options[id];
                if (opts === false) return;
                if (opts === true) opts = helpers$1.clone(core_defaults.global.plugins[id]);
                plugins.push(plugin);
                descriptors.push({
                    plugin: plugin,
                    options: opts || {}
                });
            });
            cache.descriptors = descriptors;
            cache.id = this._cacheId;
            return descriptors;
        },
        /**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */ _invalidate: function(chart) {
            delete chart.$plugins;
        }
    };
    var core_scaleService = {
        // Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
        // use the new chart options to grab the correct scale
        constructors: {},
        // Use a registration function so that we can move to an ES6 map when we no longer need to support
        // old browsers
        // Scale config defaults
        defaults: {},
        registerScaleType: function(type, scaleConstructor, scaleDefaults) {
            this.constructors[type] = scaleConstructor;
            this.defaults[type] = helpers$1.clone(scaleDefaults);
        },
        getScaleConstructor: function(type) {
            return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
        },
        getScaleDefaults: function(type) {
            // Return the scale defaults merged with the global settings so that we always use the latest ones
            return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [
                core_defaults.scale,
                this.defaults[type]
            ]) : {};
        },
        updateScaleDefaults: function(type, additions) {
            var me = this;
            if (me.defaults.hasOwnProperty(type)) me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        },
        addScalesToLayout: function(chart) {
            // Adds each scale to the chart.boxes array to be sized accordingly
            helpers$1.each(chart.scales, function(scale) {
                // Set ILayoutItem parameters for backwards compatibility
                scale.fullWidth = scale.options.fullWidth;
                scale.position = scale.options.position;
                scale.weight = scale.options.weight;
                core_layouts.addBox(chart, scale);
            });
        }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set('global', {
        tooltips: {
            enabled: true,
            custom: null,
            mode: 'nearest',
            position: 'average',
            intersect: true,
            backgroundColor: 'rgba(0,0,0,0.8)',
            titleFontStyle: 'bold',
            titleSpacing: 2,
            titleMarginBottom: 6,
            titleFontColor: '#fff',
            titleAlign: 'left',
            bodySpacing: 2,
            bodyFontColor: '#fff',
            bodyAlign: 'left',
            footerFontStyle: 'bold',
            footerSpacing: 2,
            footerMarginTop: 6,
            footerFontColor: '#fff',
            footerAlign: 'left',
            yPadding: 6,
            xPadding: 6,
            caretPadding: 2,
            caretSize: 5,
            cornerRadius: 6,
            multiKeyBackground: '#fff',
            displayColors: true,
            borderColor: 'rgba(0,0,0,0)',
            borderWidth: 0,
            callbacks: {
                // Args are: (tooltipItems, data)
                beforeTitle: helpers$1.noop,
                title: function(tooltipItems, data) {
                    var title = '';
                    var labels = data.labels;
                    var labelCount = labels ? labels.length : 0;
                    if (tooltipItems.length > 0) {
                        var item = tooltipItems[0];
                        if (item.label) title = item.label;
                        else if (item.xLabel) title = item.xLabel;
                        else if (labelCount > 0 && item.index < labelCount) title = labels[item.index];
                    }
                    return title;
                },
                afterTitle: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeBody: helpers$1.noop,
                // Args are: (tooltipItem, data)
                beforeLabel: helpers$1.noop,
                label: function(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                    if (label) label += ': ';
                    if (!helpers$1.isNullOrUndef(tooltipItem.value)) label += tooltipItem.value;
                    else label += tooltipItem.yLabel;
                    return label;
                },
                labelColor: function(tooltipItem, chart) {
                    var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
                    var activeElement = meta.data[tooltipItem.index];
                    var view = activeElement._view;
                    return {
                        borderColor: view.borderColor,
                        backgroundColor: view.backgroundColor
                    };
                },
                labelTextColor: function() {
                    return this._options.bodyFontColor;
                },
                afterLabel: helpers$1.noop,
                // Args are: (tooltipItems, data)
                afterBody: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeFooter: helpers$1.noop,
                footer: helpers$1.noop,
                afterFooter: helpers$1.noop
            }
        }
    });
    var positioners = {
        /**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */ average: function(elements) {
            if (!elements.length) return false;
            var i, len;
            var x = 0;
            var y = 0;
            var count = 0;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var pos = el.tooltipPosition();
                    x += pos.x;
                    y += pos.y;
                    ++count;
                }
            }
            return {
                x: x / count,
                y: y / count
            };
        },
        /**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */ nearest: function(elements, eventPosition) {
            var x = eventPosition.x;
            var y = eventPosition.y;
            var minDistance = Number.POSITIVE_INFINITY;
            var i, len, nearestElement;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var center = el.getCenterPoint();
                    var d = helpers$1.distanceBetweenPoints(eventPosition, center);
                    if (d < minDistance) {
                        minDistance = d;
                        nearestElement = el;
                    }
                }
            }
            if (nearestElement) {
                var tp = nearestElement.tooltipPosition();
                x = tp.x;
                y = tp.y;
            }
            return {
                x: x,
                y: y
            };
        }
    };
    // Helper to push or concat based on if the 2nd parameter is an array or not
    function pushOrConcat(base, toPush) {
        if (toPush) {
            if (helpers$1.isArray(toPush)) // base = base.concat(toPush);
            Array.prototype.push.apply(base, toPush);
            else base.push(toPush);
        }
        return base;
    }
    /**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */ function splitNewlines(str) {
        if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
        return str;
    }
    /**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */ function createTooltipItem(element) {
        var xScale = element._xScale;
        var yScale = element._yScale || element._scale; // handle radar || polarArea charts
        var index = element._index;
        var datasetIndex = element._datasetIndex;
        var controller = element._chart.getDatasetMeta(datasetIndex).controller;
        var indexScale = controller._getIndexScale();
        var valueScale = controller._getValueScale();
        return {
            xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
            yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
            label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
            value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
            index: index,
            datasetIndex: datasetIndex,
            x: element._model.x,
            y: element._model.y
        };
    }
    /**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */ function getBaseModel(tooltipOpts) {
        var globalDefaults = core_defaults.global;
        return {
            // Positioning
            xPadding: tooltipOpts.xPadding,
            yPadding: tooltipOpts.yPadding,
            xAlign: tooltipOpts.xAlign,
            yAlign: tooltipOpts.yAlign,
            // Drawing direction and text direction
            rtl: tooltipOpts.rtl,
            textDirection: tooltipOpts.textDirection,
            // Body
            bodyFontColor: tooltipOpts.bodyFontColor,
            _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
            _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
            _bodyAlign: tooltipOpts.bodyAlign,
            bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
            bodySpacing: tooltipOpts.bodySpacing,
            // Title
            titleFontColor: tooltipOpts.titleFontColor,
            _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
            _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
            titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
            _titleAlign: tooltipOpts.titleAlign,
            titleSpacing: tooltipOpts.titleSpacing,
            titleMarginBottom: tooltipOpts.titleMarginBottom,
            // Footer
            footerFontColor: tooltipOpts.footerFontColor,
            _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
            _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
            footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
            _footerAlign: tooltipOpts.footerAlign,
            footerSpacing: tooltipOpts.footerSpacing,
            footerMarginTop: tooltipOpts.footerMarginTop,
            // Appearance
            caretSize: tooltipOpts.caretSize,
            cornerRadius: tooltipOpts.cornerRadius,
            backgroundColor: tooltipOpts.backgroundColor,
            opacity: 0,
            legendColorBackground: tooltipOpts.multiKeyBackground,
            displayColors: tooltipOpts.displayColors,
            borderColor: tooltipOpts.borderColor,
            borderWidth: tooltipOpts.borderWidth
        };
    }
    /**
 * Get the size of the tooltip
 */ function getTooltipSize(tooltip, model) {
        var ctx = tooltip._chart.ctx;
        var height = model.yPadding * 2; // Tooltip Padding
        var width = 0;
        // Count of all lines in the body
        var body = model.body;
        var combinedBodyLength = body.reduce(function(count, bodyItem) {
            return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
        }, 0);
        combinedBodyLength += model.beforeBody.length + model.afterBody.length;
        var titleLineCount = model.title.length;
        var footerLineCount = model.footer.length;
        var titleFontSize = model.titleFontSize;
        var bodyFontSize = model.bodyFontSize;
        var footerFontSize = model.footerFontSize;
        height += titleLineCount * titleFontSize; // Title Lines
        height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
        height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
        height += combinedBodyLength * bodyFontSize; // Body Lines
        height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
        height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
        height += footerLineCount * footerFontSize; // Footer Lines
        height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
        // Title width
        var widthPadding = 0;
        var maxLineWidth = function(line) {
            width = Math.max(width, ctx.measureText(line).width + widthPadding);
        };
        ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
        helpers$1.each(model.title, maxLineWidth);
        // Body width
        ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
        helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
        // Body lines may include some extra width due to the color box
        widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
        helpers$1.each(body, function(bodyItem) {
            helpers$1.each(bodyItem.before, maxLineWidth);
            helpers$1.each(bodyItem.lines, maxLineWidth);
            helpers$1.each(bodyItem.after, maxLineWidth);
        });
        // Reset back to 0
        widthPadding = 0;
        // Footer width
        ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
        helpers$1.each(model.footer, maxLineWidth);
        // Add padding
        width += 2 * model.xPadding;
        return {
            width: width,
            height: height
        };
    }
    /**
 * Helper to get the alignment of a tooltip given the size
 */ function determineAlignment(tooltip, size) {
        var model = tooltip._model;
        var chart = tooltip._chart;
        var chartArea = tooltip._chart.chartArea;
        var xAlign = 'center';
        var yAlign = 'center';
        if (model.y < size.height) yAlign = 'top';
        else if (model.y > chart.height - size.height) yAlign = 'bottom';
        var lf, rf; // functions to determine left, right alignment
        var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
        var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
        var midX = (chartArea.left + chartArea.right) / 2;
        var midY = (chartArea.top + chartArea.bottom) / 2;
        if (yAlign === 'center') {
            lf = function(x) {
                return x <= midX;
            };
            rf = function(x) {
                return x > midX;
            };
        } else {
            lf = function(x) {
                return x <= size.width / 2;
            };
            rf = function(x) {
                return x >= chart.width - size.width / 2;
            };
        }
        olf = function(x) {
            return x + size.width + model.caretSize + model.caretPadding > chart.width;
        };
        orf = function(x) {
            return x - size.width - model.caretSize - model.caretPadding < 0;
        };
        yf = function(y) {
            return y <= midY ? 'top' : 'bottom';
        };
        if (lf(model.x)) {
            xAlign = 'left';
            // Is tooltip too wide and goes over the right side of the chart.?
            if (olf(model.x)) {
                xAlign = 'center';
                yAlign = yf(model.y);
            }
        } else if (rf(model.x)) {
            xAlign = 'right';
            // Is tooltip too wide and goes outside left edge of canvas?
            if (orf(model.x)) {
                xAlign = 'center';
                yAlign = yf(model.y);
            }
        }
        var opts = tooltip._options;
        return {
            xAlign: opts.xAlign ? opts.xAlign : xAlign,
            yAlign: opts.yAlign ? opts.yAlign : yAlign
        };
    }
    /**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */ function getBackgroundPoint(vm, size, alignment, chart) {
        // Background Position
        var x = vm.x;
        var y = vm.y;
        var caretSize = vm.caretSize;
        var caretPadding = vm.caretPadding;
        var cornerRadius = vm.cornerRadius;
        var xAlign = alignment.xAlign;
        var yAlign = alignment.yAlign;
        var paddingAndSize = caretSize + caretPadding;
        var radiusAndPadding = cornerRadius + caretPadding;
        if (xAlign === 'right') x -= size.width;
        else if (xAlign === 'center') {
            x -= size.width / 2;
            if (x + size.width > chart.width) x = chart.width - size.width;
            if (x < 0) x = 0;
        }
        if (yAlign === 'top') y += paddingAndSize;
        else if (yAlign === 'bottom') y -= size.height + paddingAndSize;
        else y -= size.height / 2;
        if (yAlign === 'center') {
            if (xAlign === 'left') x += paddingAndSize;
            else if (xAlign === 'right') x -= paddingAndSize;
        } else if (xAlign === 'left') x -= radiusAndPadding;
        else if (xAlign === 'right') x += radiusAndPadding;
        return {
            x: x,
            y: y
        };
    }
    function getAlignedX(vm, align) {
        return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    /**
 * Helper to build before and after body lines
 */ function getBeforeAfterBodyLines(callback) {
        return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
        initialize: function() {
            this._model = getBaseModel(this._options);
            this._lastActive = [];
        },
        // Get the title
        // Args are: (tooltipItem, data)
        getTitle: function() {
            var me = this;
            var opts = me._options;
            var callbacks = opts.callbacks;
            var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
            var title = callbacks.title.apply(me, arguments);
            var afterTitle = callbacks.afterTitle.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeTitle));
            lines = pushOrConcat(lines, splitNewlines(title));
            lines = pushOrConcat(lines, splitNewlines(afterTitle));
            return lines;
        },
        // Args are: (tooltipItem, data)
        getBeforeBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
        },
        // Args are: (tooltipItem, data)
        getBody: function(tooltipItems, data) {
            var me = this;
            var callbacks = me._options.callbacks;
            var bodyItems = [];
            helpers$1.each(tooltipItems, function(tooltipItem) {
                var bodyItem = {
                    before: [],
                    lines: [],
                    after: []
                };
                pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
                pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
                pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
                bodyItems.push(bodyItem);
            });
            return bodyItems;
        },
        // Args are: (tooltipItem, data)
        getAfterBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
        },
        // Get the footer and beforeFooter and afterFooter lines
        // Args are: (tooltipItem, data)
        getFooter: function() {
            var me = this;
            var callbacks = me._options.callbacks;
            var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
            var footer = callbacks.footer.apply(me, arguments);
            var afterFooter = callbacks.afterFooter.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeFooter));
            lines = pushOrConcat(lines, splitNewlines(footer));
            lines = pushOrConcat(lines, splitNewlines(afterFooter));
            return lines;
        },
        update: function(changed) {
            var me = this;
            var opts = me._options;
            // Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
            // that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
            // which breaks any animations.
            var existingModel = me._model;
            var model = me._model = getBaseModel(opts);
            var active = me._active;
            var data = me._data;
            // In the case where active.length === 0 we need to keep these at existing values for good animations
            var alignment = {
                xAlign: existingModel.xAlign,
                yAlign: existingModel.yAlign
            };
            var backgroundPoint = {
                x: existingModel.x,
                y: existingModel.y
            };
            var tooltipSize = {
                width: existingModel.width,
                height: existingModel.height
            };
            var tooltipPosition = {
                x: existingModel.caretX,
                y: existingModel.caretY
            };
            var i, len;
            if (active.length) {
                model.opacity = 1;
                var labelColors = [];
                var labelTextColors = [];
                tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
                var tooltipItems = [];
                for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(active[i]));
                // If the user provided a filter function, use it to modify the tooltip items
                if (opts.filter) tooltipItems = tooltipItems.filter(function(a) {
                    return opts.filter(a, data);
                });
                // If the user provided a sorting function, use it to modify the tooltip items
                if (opts.itemSort) tooltipItems = tooltipItems.sort(function(a, b) {
                    return opts.itemSort(a, b, data);
                });
                // Determine colors for boxes
                helpers$1.each(tooltipItems, function(tooltipItem) {
                    labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
                    labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
                });
                // Build the Text Lines
                model.title = me.getTitle(tooltipItems, data);
                model.beforeBody = me.getBeforeBody(tooltipItems, data);
                model.body = me.getBody(tooltipItems, data);
                model.afterBody = me.getAfterBody(tooltipItems, data);
                model.footer = me.getFooter(tooltipItems, data);
                // Initial positioning and colors
                model.x = tooltipPosition.x;
                model.y = tooltipPosition.y;
                model.caretPadding = opts.caretPadding;
                model.labelColors = labelColors;
                model.labelTextColors = labelTextColors;
                // data points
                model.dataPoints = tooltipItems;
                // We need to determine alignment of the tooltip
                tooltipSize = getTooltipSize(this, model);
                alignment = determineAlignment(this, tooltipSize);
                // Final Size and Position
                backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
            } else model.opacity = 0;
            model.xAlign = alignment.xAlign;
            model.yAlign = alignment.yAlign;
            model.x = backgroundPoint.x;
            model.y = backgroundPoint.y;
            model.width = tooltipSize.width;
            model.height = tooltipSize.height;
            // Point where the caret on the tooltip points to
            model.caretX = tooltipPosition.x;
            model.caretY = tooltipPosition.y;
            me._model = model;
            if (changed && opts.custom) opts.custom.call(me, model);
            return me;
        },
        drawCaret: function(tooltipPoint, size) {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
            ctx.lineTo(caretPosition.x1, caretPosition.y1);
            ctx.lineTo(caretPosition.x2, caretPosition.y2);
            ctx.lineTo(caretPosition.x3, caretPosition.y3);
        },
        getCaretPosition: function(tooltipPoint, size, vm) {
            var x1, x2, x3, y1, y2, y3;
            var caretSize = vm.caretSize;
            var cornerRadius = vm.cornerRadius;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var ptX = tooltipPoint.x;
            var ptY = tooltipPoint.y;
            var width = size.width;
            var height = size.height;
            if (yAlign === 'center') {
                y2 = ptY + height / 2;
                if (xAlign === 'left') {
                    x1 = ptX;
                    x2 = x1 - caretSize;
                    x3 = x1;
                    y1 = y2 + caretSize;
                    y3 = y2 - caretSize;
                } else {
                    x1 = ptX + width;
                    x2 = x1 + caretSize;
                    x3 = x1;
                    y1 = y2 - caretSize;
                    y3 = y2 + caretSize;
                }
            } else {
                if (xAlign === 'left') {
                    x2 = ptX + cornerRadius + caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else if (xAlign === 'right') {
                    x2 = ptX + width - cornerRadius - caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else {
                    x2 = vm.caretX;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                }
                if (yAlign === 'top') {
                    y1 = ptY;
                    y2 = y1 - caretSize;
                    y3 = y1;
                } else {
                    y1 = ptY + height;
                    y2 = y1 + caretSize;
                    y3 = y1;
                    // invert drawing order
                    var tmp = x3;
                    x3 = x1;
                    x1 = tmp;
                }
            }
            return {
                x1: x1,
                x2: x2,
                x3: x3,
                y1: y1,
                y2: y2,
                y3: y3
            };
        },
        drawTitle: function(pt, vm, ctx) {
            var title = vm.title;
            var length = title.length;
            var titleFontSize, titleSpacing, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._titleAlign);
                ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
                ctx.textBaseline = 'middle';
                titleFontSize = vm.titleFontSize;
                titleSpacing = vm.titleSpacing;
                ctx.fillStyle = vm.titleFontColor;
                ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
                    pt.y += titleFontSize + titleSpacing; // Line Height and spacing
                    if (i + 1 === length) pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
                }
            }
        },
        drawBody: function(pt, vm, ctx) {
            var bodyFontSize = vm.bodyFontSize;
            var bodySpacing = vm.bodySpacing;
            var bodyAlign = vm._bodyAlign;
            var body = vm.body;
            var drawColorBoxes = vm.displayColors;
            var xLinePadding = 0;
            var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
            var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
            var fillLineOfText = function(line) {
                ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
                pt.y += bodyFontSize + bodySpacing;
            };
            var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
            var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
            ctx.textAlign = bodyAlign;
            ctx.textBaseline = 'middle';
            ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
            pt.x = getAlignedX(vm, bodyAlignForCalculation);
            // Before body lines
            ctx.fillStyle = vm.bodyFontColor;
            helpers$1.each(vm.beforeBody, fillLineOfText);
            xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
            // Draw body lines now
            for(i = 0, ilen = body.length; i < ilen; ++i){
                bodyItem = body[i];
                textColor = vm.labelTextColors[i];
                labelColors = vm.labelColors[i];
                ctx.fillStyle = textColor;
                helpers$1.each(bodyItem.before, fillLineOfText);
                lines = bodyItem.lines;
                for(j = 0, jlen = lines.length; j < jlen; ++j){
                    // Draw Legend-like boxes if needed
                    if (drawColorBoxes) {
                        var rtlColorX = rtlHelper.x(colorX);
                        // Fill a white rect so that colours merge nicely if the opacity is < 1
                        ctx.fillStyle = vm.legendColorBackground;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Border
                        ctx.lineWidth = 1;
                        ctx.strokeStyle = labelColors.borderColor;
                        ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Inner square
                        ctx.fillStyle = labelColors.backgroundColor;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
                        ctx.fillStyle = textColor;
                    }
                    fillLineOfText(lines[j]);
                }
                helpers$1.each(bodyItem.after, fillLineOfText);
            }
            // Reset back to 0 for after body
            xLinePadding = 0;
            // After body lines
            helpers$1.each(vm.afterBody, fillLineOfText);
            pt.y -= bodySpacing; // Remove last body spacing
        },
        drawFooter: function(pt, vm, ctx) {
            var footer = vm.footer;
            var length = footer.length;
            var footerFontSize, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._footerAlign);
                pt.y += vm.footerMarginTop;
                ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
                ctx.textBaseline = 'middle';
                footerFontSize = vm.footerFontSize;
                ctx.fillStyle = vm.footerFontColor;
                ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
                    pt.y += footerFontSize + vm.footerSpacing;
                }
            }
        },
        drawBackground: function(pt, vm, ctx, tooltipSize) {
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            ctx.lineWidth = vm.borderWidth;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var x = pt.x;
            var y = pt.y;
            var width = tooltipSize.width;
            var height = tooltipSize.height;
            var radius = vm.cornerRadius;
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            if (yAlign === 'top') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            if (yAlign === 'bottom') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth > 0) ctx.stroke();
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            if (vm.opacity === 0) return;
            var tooltipSize = {
                width: vm.width,
                height: vm.height
            };
            var pt = {
                x: vm.x,
                y: vm.y
            };
            // IE11/Edge does not like very small opacities, so snap to 0
            var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
            // Truthy/falsey value for empty tooltip
            var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
            if (this._options.enabled && hasTooltipContent) {
                ctx.save();
                ctx.globalAlpha = opacity;
                // Draw Background
                this.drawBackground(pt, vm, ctx, tooltipSize);
                // Draw Title, Body, and Footer
                pt.y += vm.yPadding;
                helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
                // Titles
                this.drawTitle(pt, vm, ctx);
                // Body
                this.drawBody(pt, vm, ctx);
                // Footer
                this.drawFooter(pt, vm, ctx);
                helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
                ctx.restore();
            }
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */ handleEvent: function(e) {
            var me = this;
            var options = me._options;
            var changed = false;
            me._lastActive = me._lastActive || [];
            // Find Active Elements for tooltips
            if (e.type === 'mouseout') me._active = [];
            else {
                me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
                if (options.reverse) me._active.reverse();
            }
            // Remember Last Actives
            changed = !helpers$1.arrayEquals(me._active, me._lastActive);
            // Only handle target event on tooltip change
            if (changed) {
                me._lastActive = me._active;
                if (options.enabled || options.custom) {
                    me._eventPosition = {
                        x: e.x,
                        y: e.y
                    };
                    me.update(true);
                    me.pivot();
                }
            }
            return changed;
        }
    });
    /**
 * @namespace Chart.Tooltip.positioners
 */ var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set('global', {
        elements: {},
        events: [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ],
        hover: {
            onHover: null,
            mode: 'nearest',
            intersect: true,
            animationDuration: 400
        },
        onClick: null,
        maintainAspectRatio: true,
        responsive: true,
        responsiveAnimationDuration: 0
    });
    /**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */ function mergeScaleConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                if (key === 'xAxes' || key === 'yAxes') {
                    var slen = source[key].length;
                    var i, type, scale;
                    if (!target[key]) target[key] = [];
                    for(i = 0; i < slen; ++i){
                        scale = source[key][i];
                        type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
                        if (i >= target[key].length) target[key].push({});
                        if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) // new/untyped scale or type changed: let's apply the new defaults
                        // then merge source scale to correctly overwrite the defaults.
                        helpers$1.merge(target[key][i], [
                            core_scaleService.getScaleDefaults(type),
                            scale
                        ]);
                        else // scales type are the same
                        helpers$1.merge(target[key][i], scale);
                    }
                } else helpers$1._merger(key, target, source, options);
            }
        });
    }
    /**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */ function mergeConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                var tval = target[key] || Object.create(null);
                var sval = source[key];
                if (key === 'scales') // scale config merging is complex. Add our own function here for that
                target[key] = mergeScaleConfig(tval, sval);
                else if (key === 'scale') // used in polar area & radar charts since there is only one scale
                target[key] = helpers$1.merge(tval, [
                    core_scaleService.getScaleDefaults(sval.type),
                    sval
                ]);
                else helpers$1._merger(key, target, source, options);
            }
        });
    }
    function initConfig(config) {
        config = config || Object.create(null);
        // Do NOT use mergeConfig for the data object because this method merges arrays
        // and so would change references to labels and datasets, preventing data updates.
        var data = config.data = config.data || {};
        data.datasets = data.datasets || [];
        data.labels = data.labels || [];
        config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
        return config;
    }
    function updateConfig(chart) {
        var newOptions = chart.options;
        helpers$1.each(chart.scales, function(scale) {
            core_layouts.removeBox(chart, scale);
        });
        newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
        chart.options = chart.config.options = newOptions;
        chart.ensureScalesHaveIDs();
        chart.buildOrUpdateScales();
        // Tooltip
        chart.tooltip._options = newOptions.tooltips;
        chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
        var id;
        var hasId = function(obj) {
            return obj.id === id;
        };
        do id = prefix + index++;
        while (helpers$1.findIndex(axesOpts, hasId) >= 0);
        return id;
    }
    function positionIsHorizontal(position) {
        return position === 'top' || position === 'bottom';
    }
    function compare2Level(l1, l2) {
        return function(a, b) {
            return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
        };
    }
    var Chart = function(item, config) {
        this.construct(item, config);
        return this;
    };
    helpers$1.extend(Chart.prototype, /** @lends Chart */ {
        /**
	 * @private
	 */ construct: function(item, config) {
            var me = this;
            config = initConfig(config);
            var context = platform.acquireContext(item, config);
            var canvas = context && context.canvas;
            var height = canvas && canvas.height;
            var width = canvas && canvas.width;
            me.id = helpers$1.uid();
            me.ctx = context;
            me.canvas = canvas;
            me.config = config;
            me.width = width;
            me.height = height;
            me.aspectRatio = height ? width / height : null;
            me.options = config.options;
            me._bufferedRender = false;
            me._layers = [];
            /**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */ me.chart = me;
            me.controller = me; // chart.chart.controller #inception
            // Add the chart instance to the global namespace
            Chart.instances[me.id] = me;
            // Define alias to the config data: `chart.data === chart.config.data`
            Object.defineProperty(me, 'data', {
                get: function() {
                    return me.config.data;
                },
                set: function(value) {
                    me.config.data = value;
                }
            });
            if (!context || !canvas) {
                // The given item is not a compatible context2d element, let's return before finalizing
                // the chart initialization but after setting basic chart / controller properties that
                // can help to figure out that the chart is not valid (e.g chart.canvas !== null);
                // https://github.com/chartjs/Chart.js/issues/2807
                console.error("Failed to create chart: can't acquire context from the given item");
                return;
            }
            me.initialize();
            me.update();
        },
        /**
	 * @private
	 */ initialize: function() {
            var me = this;
            // Before init plugin notification
            core_plugins.notify(me, 'beforeInit');
            helpers$1.retinaScale(me, me.options.devicePixelRatio);
            me.bindEvents();
            if (me.options.responsive) // Initial resize before chart draws (must be silent to preserve initial animations).
            me.resize(true);
            me.initToolTip();
            // After init plugin notification
            core_plugins.notify(me, 'afterInit');
            return me;
        },
        clear: function() {
            helpers$1.canvas.clear(this);
            return this;
        },
        stop: function() {
            // Stops any current animation loop occurring
            core_animations.cancelAnimation(this);
            return this;
        },
        resize: function(silent) {
            var me = this;
            var options = me.options;
            var canvas = me.canvas;
            var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
            // the canvas render width and height will be casted to integers so make sure that
            // the canvas display style uses the same integer values to avoid blurring effect.
            // Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
            var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
            var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
            if (me.width === newWidth && me.height === newHeight) return;
            canvas.width = me.width = newWidth;
            canvas.height = me.height = newHeight;
            canvas.style.width = newWidth + 'px';
            canvas.style.height = newHeight + 'px';
            helpers$1.retinaScale(me, options.devicePixelRatio);
            if (!silent) {
                // Notify any plugins about the resize
                var newSize = {
                    width: newWidth,
                    height: newHeight
                };
                core_plugins.notify(me, 'resize', [
                    newSize
                ]);
                // Notify of resize
                if (options.onResize) options.onResize(me, newSize);
                me.stop();
                me.update({
                    duration: options.responsiveAnimationDuration
                });
            }
        },
        ensureScalesHaveIDs: function() {
            var options = this.options;
            var scalesOptions = options.scales || {};
            var scaleOptions = options.scale;
            helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
                if (!xAxisOptions.id) xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
            });
            helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
                if (!yAxisOptions.id) yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
            });
            if (scaleOptions) scaleOptions.id = scaleOptions.id || 'scale';
        },
        /**
	 * Builds a map of scale ID to scale object for future lookup.
	 */ buildOrUpdateScales: function() {
            var me = this;
            var options = me.options;
            var scales = me.scales || {};
            var items = [];
            var updated = Object.keys(scales).reduce(function(obj, id) {
                obj[id] = false;
                return obj;
            }, {});
            if (options.scales) items = items.concat((options.scales.xAxes || []).map(function(xAxisOptions) {
                return {
                    options: xAxisOptions,
                    dtype: 'category',
                    dposition: 'bottom'
                };
            }), (options.scales.yAxes || []).map(function(yAxisOptions) {
                return {
                    options: yAxisOptions,
                    dtype: 'linear',
                    dposition: 'left'
                };
            }));
            if (options.scale) items.push({
                options: options.scale,
                dtype: 'radialLinear',
                isDefault: true,
                dposition: 'chartArea'
            });
            helpers$1.each(items, function(item) {
                var scaleOptions = item.options;
                var id = scaleOptions.id;
                var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
                if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
                updated[id] = true;
                var scale = null;
                if (id in scales && scales[id].type === scaleType) {
                    scale = scales[id];
                    scale.options = scaleOptions;
                    scale.ctx = me.ctx;
                    scale.chart = me;
                } else {
                    var scaleClass = core_scaleService.getScaleConstructor(scaleType);
                    if (!scaleClass) return;
                    scale = new scaleClass({
                        id: id,
                        type: scaleType,
                        options: scaleOptions,
                        ctx: me.ctx,
                        chart: me
                    });
                    scales[scale.id] = scale;
                }
                scale.mergeTicksOptions();
                // TODO(SB): I think we should be able to remove this custom case (options.scale)
                // and consider it as a regular scale part of the "scales"" map only! This would
                // make the logic easier and remove some useless? custom code.
                if (item.isDefault) me.scale = scale;
            });
            // clear up discarded scales
            helpers$1.each(updated, function(hasUpdated, id) {
                if (!hasUpdated) delete scales[id];
            });
            me.scales = scales;
            core_scaleService.addScalesToLayout(this);
        },
        buildOrUpdateControllers: function() {
            var me = this;
            var newControllers = [];
            var datasets = me.data.datasets;
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                var dataset = datasets[i];
                var meta = me.getDatasetMeta(i);
                var type = dataset.type || me.config.type;
                if (meta.type && meta.type !== type) {
                    me.destroyDatasetMeta(i);
                    meta = me.getDatasetMeta(i);
                }
                meta.type = type;
                meta.order = dataset.order || 0;
                meta.index = i;
                if (meta.controller) {
                    meta.controller.updateIndex(i);
                    meta.controller.linkScales();
                } else {
                    var ControllerClass = controllers[meta.type];
                    if (ControllerClass === undefined) throw new Error('"' + meta.type + '" is not a chart type.');
                    meta.controller = new ControllerClass(me, i);
                    newControllers.push(meta.controller);
                }
            }
            return newControllers;
        },
        /**
	 * Reset the elements of all datasets
	 * @private
	 */ resetElements: function() {
            var me = this;
            helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
                me.getDatasetMeta(datasetIndex).controller.reset();
            }, me);
        },
        /**
	* Resets the chart back to it's state before the initial animation
	*/ reset: function() {
            this.resetElements();
            this.tooltip.initialize();
        },
        update: function(config) {
            var me = this;
            var i, ilen;
            if (!config || typeof config !== 'object') // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            updateConfig(me);
            // plugins options references might have change, let's invalidate the cache
            // https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
            core_plugins._invalidate(me);
            if (core_plugins.notify(me, 'beforeUpdate') === false) return;
            // In case the entire data object changed
            me.tooltip._data = me.data;
            // Make sure dataset controllers are updated and new controllers are reset
            var newControllers = me.buildOrUpdateControllers();
            // Make sure all dataset controllers have correct meta data counts
            for(i = 0, ilen = me.data.datasets.length; i < ilen; i++)me.getDatasetMeta(i).controller.buildOrUpdateElements();
            me.updateLayout();
            // Can only reset the new controllers after the scales have been updated
            if (me.options.animation && me.options.animation.duration) helpers$1.each(newControllers, function(controller) {
                controller.reset();
            });
            me.updateDatasets();
            // Need to reset tooltip in case it is displayed with elements that are removed
            // after update.
            me.tooltip.initialize();
            // Last active contains items that were previously in the tooltip.
            // When we reset the tooltip, we need to clear it
            me.lastActive = [];
            // Do this before render so that any plugins that need final scale updates can use it
            core_plugins.notify(me, 'afterUpdate');
            me._layers.sort(compare2Level('z', '_idx'));
            if (me._bufferedRender) me._bufferedRequest = {
                duration: config.duration,
                easing: config.easing,
                lazy: config.lazy
            };
            else me.render(config);
        },
        /**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */ updateLayout: function() {
            var me = this;
            if (core_plugins.notify(me, 'beforeLayout') === false) return;
            core_layouts.update(this, this.width, this.height);
            me._layers = [];
            helpers$1.each(me.boxes, function(box) {
                // _configure is called twice, once in core.scale.update and once here.
                // Here the boxes are fully updated and at their final positions.
                if (box._configure) box._configure();
                me._layers.push.apply(me._layers, box._layers());
            }, me);
            me._layers.forEach(function(item, index) {
                item._idx = index;
            });
            /**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */ core_plugins.notify(me, 'afterScaleUpdate');
            core_plugins.notify(me, 'afterLayout');
        },
        /**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */ updateDatasets: function() {
            var me = this;
            if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) return;
            for(var i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.updateDataset(i);
            core_plugins.notify(me, 'afterDatasetsUpdate');
        },
        /**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */ updateDataset: function(index) {
            var me = this;
            var meta = me.getDatasetMeta(index);
            var args = {
                meta: meta,
                index: index
            };
            if (core_plugins.notify(me, 'beforeDatasetUpdate', [
                args
            ]) === false) return;
            meta.controller._update();
            core_plugins.notify(me, 'afterDatasetUpdate', [
                args
            ]);
        },
        render: function(config) {
            var me = this;
            if (!config || typeof config !== 'object') // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            var animationOptions = me.options.animation;
            var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
            var lazy = config.lazy;
            if (core_plugins.notify(me, 'beforeRender') === false) return;
            var onComplete = function(animation) {
                core_plugins.notify(me, 'afterRender');
                helpers$1.callback(animationOptions && animationOptions.onComplete, [
                    animation
                ], me);
            };
            if (animationOptions && duration) {
                var animation = new core_animation({
                    numSteps: duration / 16.66,
                    easing: config.easing || animationOptions.easing,
                    render: function(chart, animationObject) {
                        var easingFunction = helpers$1.easing.effects[animationObject.easing];
                        var currentStep = animationObject.currentStep;
                        var stepDecimal = currentStep / animationObject.numSteps;
                        chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
                    },
                    onAnimationProgress: animationOptions.onProgress,
                    onAnimationComplete: onComplete
                });
                core_animations.addAnimation(me, animation, duration, lazy);
            } else {
                me.draw();
                // See https://github.com/chartjs/Chart.js/issues/3781
                onComplete(new core_animation({
                    numSteps: 0,
                    chart: me
                }));
            }
            return me;
        },
        draw: function(easingValue) {
            var me = this;
            var i, layers;
            me.clear();
            if (helpers$1.isNullOrUndef(easingValue)) easingValue = 1;
            me.transition(easingValue);
            if (me.width <= 0 || me.height <= 0) return;
            if (core_plugins.notify(me, 'beforeDraw', [
                easingValue
            ]) === false) return;
            // Because of plugin hooks (before/afterDatasetsDraw), datasets can't
            // currently be part of layers. Instead, we draw
            // layers <= 0 before(default, backward compat), and the rest after
            layers = me._layers;
            for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(me.chartArea);
            me.drawDatasets(easingValue);
            // Rest of layers
            for(; i < layers.length; ++i)layers[i].draw(me.chartArea);
            me._drawTooltip(easingValue);
            core_plugins.notify(me, 'afterDraw', [
                easingValue
            ]);
        },
        /**
	 * @private
	 */ transition: function(easingValue) {
            var me = this;
            for(var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i)if (me.isDatasetVisible(i)) me.getDatasetMeta(i).controller.transition(easingValue);
            me.tooltip.transition(easingValue);
        },
        /**
	 * @private
	 */ _getSortedDatasetMetas: function(filterVisible) {
            var me = this;
            var datasets = me.data.datasets || [];
            var result = [];
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; ++i)if (!filterVisible || me.isDatasetVisible(i)) result.push(me.getDatasetMeta(i));
            result.sort(compare2Level('order', 'index'));
            return result;
        },
        /**
	 * @private
	 */ _getSortedVisibleDatasetMetas: function() {
            return this._getSortedDatasetMetas(true);
        },
        /**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */ drawDatasets: function(easingValue) {
            var me = this;
            var metasets, i;
            if (core_plugins.notify(me, 'beforeDatasetsDraw', [
                easingValue
            ]) === false) return;
            metasets = me._getSortedVisibleDatasetMetas();
            for(i = metasets.length - 1; i >= 0; --i)me.drawDataset(metasets[i], easingValue);
            core_plugins.notify(me, 'afterDatasetsDraw', [
                easingValue
            ]);
        },
        /**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */ drawDataset: function(meta, easingValue) {
            var me = this;
            var args = {
                meta: meta,
                index: meta.index,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, 'beforeDatasetDraw', [
                args
            ]) === false) return;
            meta.controller.draw(easingValue);
            core_plugins.notify(me, 'afterDatasetDraw', [
                args
            ]);
        },
        /**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */ _drawTooltip: function(easingValue) {
            var me = this;
            var tooltip = me.tooltip;
            var args = {
                tooltip: tooltip,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, 'beforeTooltipDraw', [
                args
            ]) === false) return;
            tooltip.draw();
            core_plugins.notify(me, 'afterTooltipDraw', [
                args
            ]);
        },
        /**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */ getElementAtEvent: function(e) {
            return core_interaction.modes.single(this, e);
        },
        getElementsAtEvent: function(e) {
            return core_interaction.modes.label(this, e, {
                intersect: true
            });
        },
        getElementsAtXAxis: function(e) {
            return core_interaction.modes['x-axis'](this, e, {
                intersect: true
            });
        },
        getElementsAtEventForMode: function(e, mode, options) {
            var method = core_interaction.modes[mode];
            if (typeof method === 'function') return method(this, e, options);
            return [];
        },
        getDatasetAtEvent: function(e) {
            return core_interaction.modes.dataset(this, e, {
                intersect: true
            });
        },
        getDatasetMeta: function(datasetIndex) {
            var me = this;
            var dataset = me.data.datasets[datasetIndex];
            if (!dataset._meta) dataset._meta = {};
            var meta = dataset._meta[me.id];
            if (!meta) meta = dataset._meta[me.id] = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset.order || 0,
                index: datasetIndex
            };
            return meta;
        },
        getVisibleDatasetCount: function() {
            var count = 0;
            for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)if (this.isDatasetVisible(i)) count++;
            return count;
        },
        isDatasetVisible: function(datasetIndex) {
            var meta = this.getDatasetMeta(datasetIndex);
            // meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
            // the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
            return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
        },
        generateLegend: function() {
            return this.options.legendCallback(this);
        },
        /**
	 * @private
	 */ destroyDatasetMeta: function(datasetIndex) {
            var id = this.id;
            var dataset = this.data.datasets[datasetIndex];
            var meta = dataset._meta && dataset._meta[id];
            if (meta) {
                meta.controller.destroy();
                delete dataset._meta[id];
            }
        },
        destroy: function() {
            var me = this;
            var canvas = me.canvas;
            var i, ilen;
            me.stop();
            // dataset controllers need to cleanup associated data
            for(i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.destroyDatasetMeta(i);
            if (canvas) {
                me.unbindEvents();
                helpers$1.canvas.clear(me);
                platform.releaseContext(me.ctx);
                me.canvas = null;
                me.ctx = null;
            }
            core_plugins.notify(me, 'destroy');
            delete Chart.instances[me.id];
        },
        toBase64Image: function() {
            return this.canvas.toDataURL.apply(this.canvas, arguments);
        },
        initToolTip: function() {
            var me = this;
            me.tooltip = new core_tooltip({
                _chart: me,
                _chartInstance: me,
                _data: me.data,
                _options: me.options.tooltips
            }, me);
        },
        /**
	 * @private
	 */ bindEvents: function() {
            var me = this;
            var listeners = me._listeners = {};
            var listener = function() {
                me.eventHandler.apply(me, arguments);
            };
            helpers$1.each(me.options.events, function(type) {
                platform.addEventListener(me, type, listener);
                listeners[type] = listener;
            });
            // Elements used to detect size change should not be injected for non responsive charts.
            // See https://github.com/chartjs/Chart.js/issues/2210
            if (me.options.responsive) {
                listener = function() {
                    me.resize();
                };
                platform.addEventListener(me, 'resize', listener);
                listeners.resize = listener;
            }
        },
        /**
	 * @private
	 */ unbindEvents: function() {
            var me = this;
            var listeners = me._listeners;
            if (!listeners) return;
            delete me._listeners;
            helpers$1.each(listeners, function(listener, type) {
                platform.removeEventListener(me, type, listener);
            });
        },
        updateHoverStyle: function(elements, mode, enabled) {
            var prefix = enabled ? 'set' : 'remove';
            var element, i, ilen;
            for(i = 0, ilen = elements.length; i < ilen; ++i){
                element = elements[i];
                if (element) this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
            }
            if (mode === 'dataset') this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
        },
        /**
	 * @private
	 */ eventHandler: function(e) {
            var me = this;
            var tooltip = me.tooltip;
            if (core_plugins.notify(me, 'beforeEvent', [
                e
            ]) === false) return;
            // Buffer any update calls so that renders do not occur
            me._bufferedRender = true;
            me._bufferedRequest = null;
            var changed = me.handleEvent(e);
            // for smooth tooltip animations issue #4989
            // the tooltip should be the source of change
            // Animation check workaround:
            // tooltip._start will be null when tooltip isn't animating
            if (tooltip) changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
            core_plugins.notify(me, 'afterEvent', [
                e
            ]);
            var bufferedRequest = me._bufferedRequest;
            if (bufferedRequest) // If we have an update that was triggered, we need to do a normal render
            me.render(bufferedRequest);
            else if (changed && !me.animating) {
                // If entering, leaving, or changing elements, animate the change via pivot
                me.stop();
                // We only need to render at this point. Updating will cause scales to be
                // recomputed generating flicker & using more memory than necessary.
                me.render({
                    duration: me.options.hover.animationDuration,
                    lazy: true
                });
            }
            me._bufferedRender = false;
            me._bufferedRequest = null;
            return me;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */ handleEvent: function(e) {
            var me = this;
            var options = me.options || {};
            var hoverOptions = options.hover;
            var changed = false;
            me.lastActive = me.lastActive || [];
            // Find Active Elements for hover and tooltips
            if (e.type === 'mouseout') me.active = [];
            else me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
            // Invoke onHover hook
            // Need to call with native event here to not break backwards compatibility
            helpers$1.callback(options.onHover || options.hover.onHover, [
                e.native,
                me.active
            ], me);
            if (e.type === 'mouseup' || e.type === 'click') {
                if (options.onClick) // Use e.native here for backwards compatibility
                options.onClick.call(me, e.native, me.active);
            }
            // Remove styling for last active (even if it may still be active)
            if (me.lastActive.length) me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
            // Built in hover styling
            if (me.active.length && hoverOptions.mode) me.updateHoverStyle(me.active, hoverOptions.mode, true);
            changed = !helpers$1.arrayEquals(me.active, me.lastActive);
            // Remember Last Actives
            me.lastActive = me.active;
            return changed;
        }
    });
    /**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */ Chart.instances = {};
    var core_controller = Chart;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */ Chart.Controller = Chart;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ Chart.types = {};
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.configMerge = mergeConfig;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function() {
        // -- Basic js utility methods
        helpers$1.where = function(collection, filterCallback) {
            if (helpers$1.isArray(collection) && Array.prototype.filter) return collection.filter(filterCallback);
            var filtered = [];
            helpers$1.each(collection, function(item) {
                if (filterCallback(item)) filtered.push(item);
            });
            return filtered;
        };
        helpers$1.findIndex = Array.prototype.findIndex ? function(array, callback, scope) {
            return array.findIndex(callback, scope);
        } : function(array, callback, scope) {
            scope = scope === undefined ? array : scope;
            for(var i = 0, ilen = array.length; i < ilen; ++i){
                if (callback.call(scope, array[i], i, array)) return i;
            }
            return -1;
        };
        helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to start of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = -1;
            for(var i = startIndex + 1; i < arrayToSearch.length; i++){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to end of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = arrayToSearch.length;
            for(var i = startIndex - 1; i >= 0; i--){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        // -- Math methods
        helpers$1.isNumber = function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        };
        helpers$1.almostEquals = function(x, y, epsilon) {
            return Math.abs(x - y) < epsilon;
        };
        helpers$1.almostWhole = function(x, epsilon) {
            var rounded = Math.round(x);
            return rounded - epsilon <= x && rounded + epsilon >= x;
        };
        helpers$1.max = function(array) {
            return array.reduce(function(max, value) {
                if (!isNaN(value)) return Math.max(max, value);
                return max;
            }, Number.NEGATIVE_INFINITY);
        };
        helpers$1.min = function(array) {
            return array.reduce(function(min, value) {
                if (!isNaN(value)) return Math.min(min, value);
                return min;
            }, Number.POSITIVE_INFINITY);
        };
        helpers$1.sign = Math.sign ? function(x) {
            return Math.sign(x);
        } : function(x) {
            x = +x; // convert to a number
            if (x === 0 || isNaN(x)) return x;
            return x > 0 ? 1 : -1;
        };
        helpers$1.toRadians = function(degrees) {
            return degrees * (Math.PI / 180);
        };
        helpers$1.toDegrees = function(radians) {
            return radians * (180 / Math.PI);
        };
        /**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */ helpers$1._decimalPlaces = function(x) {
            if (!helpers$1.isFinite(x)) return;
            var e = 1;
            var p = 0;
            while(Math.round(x * e) / e !== x){
                e *= 10;
                p++;
            }
            return p;
        };
        // Gets the angle from vertical upright to the point about a centre.
        helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
            var distanceFromXCenter = anglePoint.x - centrePoint.x;
            var distanceFromYCenter = anglePoint.y - centrePoint.y;
            var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
            var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
            if (angle < -0.5 * Math.PI) angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
            return {
                angle: angle,
                distance: radialDistanceFromCenter
            };
        };
        helpers$1.distanceBetweenPoints = function(pt1, pt2) {
            return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
        };
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ helpers$1.aliasPixel = function(pixelWidth) {
            return pixelWidth % 2 === 0 ? 0 : 0.5;
        };
        /**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */ helpers$1._alignPixel = function(chart, pixel, width) {
            var devicePixelRatio = chart.currentDevicePixelRatio;
            var halfWidth = width / 2;
            return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
        };
        helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
            // Props to Rob Spencer at scaled innovation for his post on splining between points
            // http://scaledinnovation.com/analytics/splines/aboutSplines.html
            // This function must also respect "skipped" points
            var previous = firstPoint.skip ? middlePoint : firstPoint;
            var current = middlePoint;
            var next = afterPoint.skip ? middlePoint : afterPoint;
            var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
            var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
            var s01 = d01 / (d01 + d12);
            var s12 = d12 / (d01 + d12);
            // If all points are the same, s01 & s02 will be inf
            s01 = isNaN(s01) ? 0 : s01;
            s12 = isNaN(s12) ? 0 : s12;
            var fa = t * s01; // scaling factor for triangle Ta
            var fb = t * s12;
            return {
                previous: {
                    x: current.x - fa * (next.x - previous.x),
                    y: current.y - fa * (next.y - previous.y)
                },
                next: {
                    x: current.x + fb * (next.x - previous.x),
                    y: current.y + fb * (next.y - previous.y)
                }
            };
        };
        helpers$1.EPSILON = Number.EPSILON || 1e-14;
        helpers$1.splineCurveMonotone = function(points) {
            // This function calculates Bézier control points in a similar way than |splineCurve|,
            // but preserves monotonicity of the provided data and ensures no local extremums are added
            // between the dataset discrete points due to the interpolation.
            // See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
            var pointsWithTangents = (points || []).map(function(point) {
                return {
                    model: point._model,
                    deltaK: 0,
                    mK: 0
                };
            });
            // Calculate slopes (deltaK) and initialize tangents (mK)
            var pointsLen = pointsWithTangents.length;
            var i, pointBefore, pointCurrent, pointAfter;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointAfter && !pointAfter.model.skip) {
                    var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
                    // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
                    pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
                }
                if (!pointBefore || pointBefore.model.skip) pointCurrent.mK = pointCurrent.deltaK;
                else if (!pointAfter || pointAfter.model.skip) pointCurrent.mK = pointBefore.deltaK;
                else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) pointCurrent.mK = 0;
                else pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
            }
            // Adjust tangents to ensure monotonic properties
            var alphaK, betaK, tauK, squaredMagnitude;
            for(i = 0; i < pointsLen - 1; ++i){
                pointCurrent = pointsWithTangents[i];
                pointAfter = pointsWithTangents[i + 1];
                if (pointCurrent.model.skip || pointAfter.model.skip) continue;
                if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
                    pointCurrent.mK = pointAfter.mK = 0;
                    continue;
                }
                alphaK = pointCurrent.mK / pointCurrent.deltaK;
                betaK = pointAfter.mK / pointCurrent.deltaK;
                squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
                if (squaredMagnitude <= 9) continue;
                tauK = 3 / Math.sqrt(squaredMagnitude);
                pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
                pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
            }
            // Compute control points
            var deltaX;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointBefore && !pointBefore.model.skip) {
                    deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
                    pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
                    pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
                }
                if (pointAfter && !pointAfter.model.skip) {
                    deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
                    pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
                    pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
                }
            }
        };
        helpers$1.nextItem = function(collection, index, loop) {
            if (loop) return index >= collection.length - 1 ? collection[0] : collection[index + 1];
            return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
        };
        helpers$1.previousItem = function(collection, index, loop) {
            if (loop) return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
            return index <= 0 ? collection[0] : collection[index - 1];
        };
        // Implementation of the nice number algorithm used in determining where axis labels will go
        helpers$1.niceNum = function(range, round) {
            var exponent = Math.floor(helpers$1.log10(range));
            var fraction = range / Math.pow(10, exponent);
            var niceFraction;
            if (round) {
                if (fraction < 1.5) niceFraction = 1;
                else if (fraction < 3) niceFraction = 2;
                else if (fraction < 7) niceFraction = 5;
                else niceFraction = 10;
            } else if (fraction <= 1.0) niceFraction = 1;
            else if (fraction <= 2) niceFraction = 2;
            else if (fraction <= 5) niceFraction = 5;
            else niceFraction = 10;
            return niceFraction * Math.pow(10, exponent);
        };
        // Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
        helpers$1.requestAnimFrame = function() {
            if (typeof window === 'undefined') return function(callback) {
                callback();
            };
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
        }();
        // -- DOM methods
        helpers$1.getRelativePosition = function(evt, chart) {
            var mouseX, mouseY;
            var e = evt.originalEvent || evt;
            var canvas = evt.target || evt.srcElement;
            var boundingRect = canvas.getBoundingClientRect();
            var touches = e.touches;
            if (touches && touches.length > 0) {
                mouseX = touches[0].clientX;
                mouseY = touches[0].clientY;
            } else {
                mouseX = e.clientX;
                mouseY = e.clientY;
            }
            // Scale mouse coordinates into canvas coordinates
            // by following the pattern laid out by 'jerryj' in the comments of
            // https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
            var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
            var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
            var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
            var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
            var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
            var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
            // We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
            // the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
            mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
            mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
            return {
                x: mouseX,
                y: mouseY
            };
        };
        // Private helper function to convert max-width/max-height values that may be percentages into a number
        function parseMaxStyle(styleValue, node, parentProperty) {
            var valueInPixels;
            if (typeof styleValue === 'string') {
                valueInPixels = parseInt(styleValue, 10);
                if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
                valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
            } else valueInPixels = styleValue;
            return valueInPixels;
        }
        /**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */ function isConstrainedValue(value) {
            return value !== undefined && value !== null && value !== 'none';
        }
        /**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */ function getConstraintDimension(domNode, maxStyle, percentageProperty) {
            var view = document.defaultView;
            var parentNode = helpers$1._getParentNode(domNode);
            var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
            var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
            var hasCNode = isConstrainedValue(constrainedNode);
            var hasCContainer = isConstrainedValue(constrainedContainer);
            var infinity = Number.POSITIVE_INFINITY;
            if (hasCNode || hasCContainer) return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
            return 'none';
        }
        // returns Number or undefined if no constraint
        helpers$1.getConstraintWidth = function(domNode) {
            return getConstraintDimension(domNode, 'max-width', 'clientWidth');
        };
        // returns Number or undefined if no constraint
        helpers$1.getConstraintHeight = function(domNode) {
            return getConstraintDimension(domNode, 'max-height', 'clientHeight');
        };
        /**
	 * @private
 	 */ helpers$1._calculatePadding = function(container, padding, parentDimension) {
            padding = helpers$1.getStyle(container, padding);
            return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
        };
        /**
	 * @private
	 */ helpers$1._getParentNode = function(domNode) {
            var parent = domNode.parentNode;
            if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
            return parent;
        };
        helpers$1.getMaximumWidth = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientWidth;
            var clientWidth = container.clientWidth;
            var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
            var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
            var w = clientWidth - paddingLeft - paddingRight;
            var cw = helpers$1.getConstraintWidth(domNode);
            return isNaN(cw) ? w : Math.min(w, cw);
        };
        helpers$1.getMaximumHeight = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientHeight;
            var clientHeight = container.clientHeight;
            var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
            var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
            var h = clientHeight - paddingTop - paddingBottom;
            var ch = helpers$1.getConstraintHeight(domNode);
            return isNaN(ch) ? h : Math.min(h, ch);
        };
        helpers$1.getStyle = function(el, property) {
            return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
        };
        helpers$1.retinaScale = function(chart, forceRatio) {
            var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
            if (pixelRatio === 1) return;
            var canvas = chart.canvas;
            var height = chart.height;
            var width = chart.width;
            canvas.height = height * pixelRatio;
            canvas.width = width * pixelRatio;
            chart.ctx.scale(pixelRatio, pixelRatio);
            // If no style has been set on the canvas, the render size is used as display size,
            // making the chart visually bigger, so let's enforce it to the "correct" values.
            // See https://github.com/chartjs/Chart.js/issues/3575
            if (!canvas.style.height && !canvas.style.width) {
                canvas.style.height = height + 'px';
                canvas.style.width = width + 'px';
            }
        };
        // -- Canvas methods
        helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
            return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
        };
        helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
            cache = cache || {};
            var data = cache.data = cache.data || {};
            var gc = cache.garbageCollect = cache.garbageCollect || [];
            if (cache.font !== font) {
                data = cache.data = {};
                gc = cache.garbageCollect = [];
                cache.font = font;
            }
            ctx.font = font;
            var longest = 0;
            var ilen = arrayOfThings.length;
            var i, j, jlen, thing, nestedThing;
            for(i = 0; i < ilen; i++){
                thing = arrayOfThings[i];
                // Undefined strings and arrays should not be measured
                if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) longest = helpers$1.measureText(ctx, data, gc, longest, thing);
                else if (helpers$1.isArray(thing)) // if it is an array lets measure each element
                // to do maybe simplify this function a bit so we can do this more recursively?
                for(j = 0, jlen = thing.length; j < jlen; j++){
                    nestedThing = thing[j];
                    // Undefined strings and arrays should not be measured
                    if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
                }
            }
            var gcLen = gc.length / 2;
            if (gcLen > arrayOfThings.length) {
                for(i = 0; i < gcLen; i++)delete data[gc[i]];
                gc.splice(0, gcLen);
            }
            return longest;
        };
        helpers$1.measureText = function(ctx, data, gc, longest, string) {
            var textWidth = data[string];
            if (!textWidth) {
                textWidth = data[string] = ctx.measureText(string).width;
                gc.push(string);
            }
            if (textWidth > longest) longest = textWidth;
            return longest;
        };
        /**
	 * @deprecated
	 */ helpers$1.numberOfLabelLines = function(arrayOfThings) {
            var numberOfLines = 1;
            helpers$1.each(arrayOfThings, function(thing) {
                if (helpers$1.isArray(thing)) {
                    if (thing.length > numberOfLines) numberOfLines = thing.length;
                }
            });
            return numberOfLines;
        };
        helpers$1.color = !chartjsColor ? function(value) {
            console.error('Color.js not found!');
            return value;
        } : function(value) {
            /* global CanvasGradient */ if (value instanceof CanvasGradient) value = core_defaults.global.defaultColor;
            return chartjsColor(value);
        };
        helpers$1.getHoverColor = function(colorValue) {
            /* global CanvasPattern */ return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
        };
    };
    function abstract() {
        throw new Error("This method is not implemented: either no adapter can be found or an incomplete integration was provided.");
    }
    /**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ /**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */ /**
 * @class
 */ function DateAdapter(options) {
        this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
        /**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */ formats: abstract,
        /**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */ parse: abstract,
        /**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */ format: abstract,
        /**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ add: abstract,
        /**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ diff: abstract,
        /**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */ startOf: abstract,
        /**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */ endOf: abstract,
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(value) {
            return value;
        }
    });
    DateAdapter.override = function(members) {
        helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
        _date: _date
    };
    /**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */ var core_ticks = {
        /**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */ formatters: {
            /**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */ values: function(value) {
                return helpers$1.isArray(value) ? value : '' + value;
            },
            /**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */ linear: function(tickValue, index, ticks) {
                // If we have lots of ticks, don't use the ones
                var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
                // If we have a number like 2.5 as the delta, figure out how many decimal places we need
                if (Math.abs(delta) > 1) {
                    if (tickValue !== Math.floor(tickValue)) // not an integer
                    delta = tickValue - Math.floor(tickValue);
                }
                var logDelta = helpers$1.log10(Math.abs(delta));
                var tickString = '';
                if (tickValue !== 0) {
                    var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
                    if (maxTick < 1e-4) {
                        var logTick = helpers$1.log10(Math.abs(tickValue));
                        var numExponential = Math.floor(logTick) - Math.floor(logDelta);
                        numExponential = Math.max(Math.min(numExponential, 20), 0);
                        tickString = tickValue.toExponential(numExponential);
                    } else {
                        var numDecimal = -1 * Math.floor(logDelta);
                        numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
                        tickString = tickValue.toFixed(numDecimal);
                    }
                } else tickString = '0'; // never show decimal places for 0
                return tickString;
            },
            logarithmic: function(tickValue, index, ticks) {
                var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
                if (tickValue === 0) return '0';
                else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) return tickValue.toExponential();
                return '';
            }
        }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set('scale', {
        display: true,
        position: 'left',
        offset: false,
        // grid line settings
        gridLines: {
            display: true,
            color: 'rgba(0,0,0,0.1)',
            lineWidth: 1,
            drawBorder: true,
            drawOnChartArea: true,
            drawTicks: true,
            tickMarkLength: 10,
            zeroLineWidth: 1,
            zeroLineColor: 'rgba(0,0,0,0.25)',
            zeroLineBorderDash: [],
            zeroLineBorderDashOffset: 0.0,
            offsetGridLines: false,
            borderDash: [],
            borderDashOffset: 0.0
        },
        // scale label
        scaleLabel: {
            // display property
            display: false,
            // actual label
            labelString: '',
            // top/bottom padding
            padding: {
                top: 4,
                bottom: 4
            }
        },
        // label settings
        ticks: {
            beginAtZero: false,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            padding: 0,
            reverse: false,
            display: true,
            autoSkip: true,
            autoSkipPadding: 0,
            labelOffset: 0,
            // We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
            callback: core_ticks.formatters.values,
            minor: {},
            major: {}
        }
    });
    /** Returns a new array containing numItems from arr */ function sample(arr, numItems) {
        var result = [];
        var increment = arr.length / numItems;
        var i = 0;
        var len = arr.length;
        for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
        return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
        var length = scale.getTicks().length;
        var validIndex = Math.min(index, length - 1);
        var lineValue = scale.getPixelForTick(validIndex);
        var start = scale._startPixel;
        var end = scale._endPixel;
        var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
        var offset;
        if (offsetGridLines) {
            if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
            else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
            else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
            lineValue += validIndex < index ? offset : -offset;
            // Return undefined if the pixel is out of the range
            if (lineValue < start - epsilon || lineValue > end + epsilon) return;
        }
        return lineValue;
    }
    function garbageCollect(caches, length) {
        helpers$1.each(caches, function(cache) {
            var gc = cache.gc;
            var gcLen = gc.length / 2;
            var i;
            if (gcLen > length) {
                for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
                gc.splice(0, gcLen);
            }
        });
    }
    /**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */ function computeLabelSizes(ctx, tickFonts, ticks, caches) {
        var length = ticks.length;
        var widths = [];
        var heights = [];
        var offsets = [];
        var widestLabelSize = 0;
        var highestLabelSize = 0;
        var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            // Undefined labels and arrays should not be measured
            if (!isNullOrUndef(label) && !isArray(label)) {
                width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if (isArray(label)) // if it is an array let's measure each element
            for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                // Undefined labels and arrays should not be measured
                if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
                    width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            offsets.push(lineHeight / 2);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        widest = widths.indexOf(widestLabelSize);
        highest = heights.indexOf(highestLabelSize);
        function valueAt(idx) {
            return {
                width: widths[idx] || 0,
                height: heights[idx] || 0,
                offset: offsets[idx] || 0
            };
        }
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest)
        };
    }
    function getTickMarkLength(options) {
        return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
        var font, padding;
        if (!options.display) return 0;
        font = helpers$1.options._parseFont(options);
        padding = helpers$1.options.toPadding(options.padding);
        return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
        return helpers$1.extend(helpers$1.options._parseFont({
            fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
            fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
            fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
            lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
        }), {
            color: helpers$1.options.resolve([
                nestedOpts.fontColor,
                options.fontColor,
                core_defaults.global.defaultFontColor
            ])
        });
    }
    function parseTickFontOptions(options) {
        var minor = parseFontOptions(options, options.minor);
        var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
        return {
            minor: minor,
            major: major
        };
    }
    function nonSkipped(ticksToFilter) {
        var filtered = [];
        var item, index, len;
        for(index = 0, len = ticksToFilter.length; index < len; ++index){
            item = ticksToFilter[index];
            if (typeof item._index !== 'undefined') filtered.push(item);
        }
        return filtered;
    }
    function getEvenSpacing(arr) {
        var len = arr.length;
        var i, diff;
        if (len < 2) return false;
        for(diff = arr[0], i = 1; i < len; ++i){
            if (arr[i] - arr[i - 1] !== diff) return false;
        }
        return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
        var evenMajorSpacing = getEvenSpacing(majorIndices);
        var spacing = (ticks.length - 1) / ticksLimit;
        var factors, factor, i, ilen;
        // If the major ticks are evenly spaced apart, place the minor ticks
        // so that they divide the major ticks into even chunks
        if (!evenMajorSpacing) return Math.max(spacing, 1);
        factors = helpers$1.math._factorize(evenMajorSpacing);
        for(i = 0, ilen = factors.length - 1; i < ilen; i++){
            factor = factors[i];
            if (factor > spacing) return factor;
        }
        return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
        var result = [];
        var i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
        return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
        var count = 0;
        var next = majorIndices[0];
        var i, tick;
        spacing = Math.ceil(spacing);
        for(i = 0; i < ticks.length; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = majorIndices[count * spacing];
            } else delete tick.label;
        }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
        var start = valueOrDefault$a(majorStart, 0);
        var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
        var count = 0;
        var length, i, tick, next;
        spacing = Math.ceil(spacing);
        if (majorEnd) {
            length = majorEnd - majorStart;
            spacing = length / Math.floor(length / spacing);
        }
        next = start;
        while(next < 0){
            count++;
            next = Math.round(start + count * spacing);
        }
        for(i = Math.max(start, 0); i < end; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = Math.round(start + count * spacing);
            } else delete tick.label;
        }
    }
    var Scale = core_element.extend({
        zeroLineIndex: 0,
        /**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */ getPadding: function() {
            var me = this;
            return {
                left: me.paddingLeft || 0,
                top: me.paddingTop || 0,
                right: me.paddingRight || 0,
                bottom: me.paddingBottom || 0
            };
        },
        /**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */ getTicks: function() {
            return this._ticks;
        },
        /**
	* @private
	*/ _getLabels: function() {
            var data = this.chart.data;
            return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
        },
        // These methods are ordered by lifecyle. Utilities then follow.
        // Any function defined here is inherited by all scale types.
        // Any function can be extended by the scale type
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ mergeTicksOptions: function() {
        // noop
        },
        beforeUpdate: function() {
            helpers$1.callback(this.options.beforeUpdate, [
                this
            ]);
        },
        /**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */ update: function(maxWidth, maxHeight, margins) {
            var me = this;
            var tickOpts = me.options.ticks;
            var sampleSize = tickOpts.sampleSize;
            var i, ilen, labels, ticks, samplingEnabled;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = helpers$1.extend({
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, margins);
            me._ticks = null;
            me.ticks = null;
            me._labelSizes = null;
            me._maxLabelLines = 0;
            me.longestLabelWidth = 0;
            me.longestTextCache = me.longestTextCache || {};
            me._gridLineItems = null;
            me._labelItems = null;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Data min/max
            me.beforeDataLimits();
            me.determineDataLimits();
            me.afterDataLimits();
            // Ticks - `this.ticks` is now DEPRECATED!
            // Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
            // and must not be accessed directly from outside this class. `this.ticks` being
            // around for long time and not marked as private, we can't change its structure
            // without unexpected breaking changes. If you need to access the scale ticks,
            // use scale.getTicks() instead.
            me.beforeBuildTicks();
            // New implementations should return an array of objects but for BACKWARD COMPAT,
            // we still support no return (`this.ticks` internally set by calling this method).
            ticks = me.buildTicks() || [];
            // Allow modification of ticks in callback.
            ticks = me.afterBuildTicks(ticks) || ticks;
            // Ensure ticks contains ticks in new tick format
            if ((!ticks || !ticks.length) && me.ticks) {
                ticks = [];
                for(i = 0, ilen = me.ticks.length; i < ilen; ++i)ticks.push({
                    value: me.ticks[i],
                    major: false
                });
            }
            me._ticks = ticks;
            // Compute tick rotation and fit using a sampled subset of labels
            // We generally don't need to compute the size of every single label for determining scale size
            samplingEnabled = sampleSize < ticks.length;
            labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
            // _configure is called twice, once here, once from core.controller.updateLayout.
            // Here we haven't been positioned yet, but dimensions are correct.
            // Variables set in _configure are needed for calculateTickRotation, and
            // it's ok that coordinates are not correct there, only dimensions matter.
            me._configure();
            // Tick Rotation
            me.beforeCalculateTickRotation();
            me.calculateTickRotation();
            me.afterCalculateTickRotation();
            me.beforeFit();
            me.fit();
            me.afterFit();
            // Auto-skip
            me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
            if (samplingEnabled) // Generate labels using all non-skipped ticks
            labels = me._convertTicksToLabels(me._ticksToDraw);
            me.ticks = labels; // BACKWARD COMPATIBILITY
            // IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
            me.afterUpdate();
            // TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
            // make maxWidth and maxHeight private
            return me.minSize;
        },
        /**
	 * @private
	 */ _configure: function() {
            var me = this;
            var reversePixels = me.options.ticks.reverse;
            var startPixel, endPixel;
            if (me.isHorizontal()) {
                startPixel = me.left;
                endPixel = me.right;
            } else {
                startPixel = me.top;
                endPixel = me.bottom;
                // by default vertical scales are from bottom to top, so pixels are reversed
                reversePixels = !reversePixels;
            }
            me._startPixel = startPixel;
            me._endPixel = endPixel;
            me._reversePixels = reversePixels;
            me._length = endPixel - startPixel;
        },
        afterUpdate: function() {
            helpers$1.callback(this.options.afterUpdate, [
                this
            ]);
        },
        //
        beforeSetDimensions: function() {
            helpers$1.callback(this.options.beforeSetDimensions, [
                this
            ]);
        },
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
        },
        afterSetDimensions: function() {
            helpers$1.callback(this.options.afterSetDimensions, [
                this
            ]);
        },
        // Data limits
        beforeDataLimits: function() {
            helpers$1.callback(this.options.beforeDataLimits, [
                this
            ]);
        },
        determineDataLimits: helpers$1.noop,
        afterDataLimits: function() {
            helpers$1.callback(this.options.afterDataLimits, [
                this
            ]);
        },
        //
        beforeBuildTicks: function() {
            helpers$1.callback(this.options.beforeBuildTicks, [
                this
            ]);
        },
        buildTicks: helpers$1.noop,
        afterBuildTicks: function(ticks) {
            var me = this;
            // ticks is empty for old axis implementations here
            if (isArray(ticks) && ticks.length) return helpers$1.callback(me.options.afterBuildTicks, [
                me,
                ticks
            ]);
            // Support old implementations (that modified `this.ticks` directly in buildTicks)
            me.ticks = helpers$1.callback(me.options.afterBuildTicks, [
                me,
                me.ticks
            ]) || me.ticks;
            return ticks;
        },
        beforeTickToLabelConversion: function() {
            helpers$1.callback(this.options.beforeTickToLabelConversion, [
                this
            ]);
        },
        convertTicksToLabels: function() {
            var me = this;
            // Convert ticks to strings
            var tickOpts = me.options.ticks;
            me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
        },
        afterTickToLabelConversion: function() {
            helpers$1.callback(this.options.afterTickToLabelConversion, [
                this
            ]);
        },
        //
        beforeCalculateTickRotation: function() {
            helpers$1.callback(this.options.beforeCalculateTickRotation, [
                this
            ]);
        },
        calculateTickRotation: function() {
            var me = this;
            var options = me.options;
            var tickOpts = options.ticks;
            var numTicks = me.getTicks().length;
            var minRotation = tickOpts.minRotation || 0;
            var maxRotation = tickOpts.maxRotation;
            var labelRotation = minRotation;
            var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
            if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
                me.labelRotation = minRotation;
                return;
            }
            labelSizes = me._getLabelSizes();
            maxLabelWidth = labelSizes.widest.width;
            maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
            // Estimate the width of each grid based on the canvas width, the maximum
            // label width and the number of tick intervals
            maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
            tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
            // Allow 3 pixels x2 padding either side for label readability
            if (maxLabelWidth + 6 > tickWidth) {
                tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
                maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
                maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
                labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
                labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
            }
            me.labelRotation = labelRotation;
        },
        afterCalculateTickRotation: function() {
            helpers$1.callback(this.options.afterCalculateTickRotation, [
                this
            ]);
        },
        //
        beforeFit: function() {
            helpers$1.callback(this.options.beforeFit, [
                this
            ]);
        },
        fit: function() {
            var me = this;
            // Reset
            var minSize = me.minSize = {
                width: 0,
                height: 0
            };
            var chart = me.chart;
            var opts = me.options;
            var tickOpts = opts.ticks;
            var scaleLabelOpts = opts.scaleLabel;
            var gridLineOpts = opts.gridLines;
            var display = me._isVisible();
            var isBottom = opts.position === 'bottom';
            var isHorizontal = me.isHorizontal();
            // Width
            if (isHorizontal) minSize.width = me.maxWidth;
            else if (display) minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // height
            if (!isHorizontal) minSize.height = me.maxHeight; // fill all the height
            else if (display) minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // Don't bother fitting the ticks if we are not showing the labels
            if (tickOpts.display && display) {
                var tickFonts = parseTickFontOptions(tickOpts);
                var labelSizes = me._getLabelSizes();
                var firstLabelSize = labelSizes.first;
                var lastLabelSize = labelSizes.last;
                var widestLabelSize = labelSizes.widest;
                var highestLabelSize = labelSizes.highest;
                var lineSpace = tickFonts.minor.lineHeight * 0.4;
                var tickPadding = tickOpts.padding;
                if (isHorizontal) {
                    // A horizontal axis is more constrained by the height.
                    var isRotated = me.labelRotation !== 0;
                    var angleRadians = helpers$1.toRadians(me.labelRotation);
                    var cosRotation = Math.cos(angleRadians);
                    var sinRotation = Math.sin(angleRadians);
                    var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace); // padding
                    minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
                    var offsetLeft = me.getPixelForTick(0) - me.left;
                    var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
                    var paddingLeft, paddingRight;
                    // Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
                    // which means that the right padding is dominated by the font height
                    if (isRotated) {
                        paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
                        paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
                    } else {
                        paddingLeft = firstLabelSize.width / 2;
                        paddingRight = lastLabelSize.width / 2;
                    }
                    // Adjust padding taking into account changes in offsets
                    // and add 3 px to move away from canvas edges
                    me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
                    me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
                } else {
                    // A vertical axis is more constrained by the width. Labels are the
                    // dominant factor here, so get that length first and account for padding
                    var labelWidth = tickOpts.mirror ? 0 : // use lineSpace for consistency with horizontal axis
                    // tickPadding is not implemented for horizontal
                    widestLabelSize.width + tickPadding + lineSpace;
                    minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
                    me.paddingTop = firstLabelSize.height / 2;
                    me.paddingBottom = lastLabelSize.height / 2;
                }
            }
            me.handleMargins();
            if (isHorizontal) {
                me.width = me._length = chart.width - me.margins.left - me.margins.right;
                me.height = minSize.height;
            } else {
                me.width = minSize.width;
                me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
            }
        },
        /**
	 * Handle margins and padding interactions
	 * @private
	 */ handleMargins: function() {
            var me = this;
            if (me.margins) {
                me.margins.left = Math.max(me.paddingLeft, me.margins.left);
                me.margins.top = Math.max(me.paddingTop, me.margins.top);
                me.margins.right = Math.max(me.paddingRight, me.margins.right);
                me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
            }
        },
        afterFit: function() {
            helpers$1.callback(this.options.afterFit, [
                this
            ]);
        },
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === 'top' || pos === 'bottom';
        },
        isFullWidth: function() {
            return this.options.fullWidth;
        },
        // Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
        getRightValue: function(rawValue) {
            // Null and undefined values first
            if (isNullOrUndef(rawValue)) return NaN;
            // isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
            if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) return NaN;
            // If it is in fact an object, dive in one more level
            if (rawValue) {
                if (this.isHorizontal()) {
                    if (rawValue.x !== undefined) return this.getRightValue(rawValue.x);
                } else if (rawValue.y !== undefined) return this.getRightValue(rawValue.y);
            }
            // Value is good, return it
            return rawValue;
        },
        _convertTicksToLabels: function(ticks) {
            var me = this;
            var labels, i, ilen;
            me.ticks = ticks.map(function(tick) {
                return tick.value;
            });
            me.beforeTickToLabelConversion();
            // New implementations should return the formatted tick labels but for BACKWARD
            // COMPAT, we still support no return (`this.ticks` internally changed by calling
            // this method and supposed to contain only string values).
            labels = me.convertTicksToLabels(ticks) || me.ticks;
            me.afterTickToLabelConversion();
            // BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
            for(i = 0, ilen = ticks.length; i < ilen; ++i)ticks[i].label = labels[i];
            return labels;
        },
        /**
	 * @private
	 */ _getLabelSizes: function() {
            var me = this;
            var labelSizes = me._labelSizes;
            if (!labelSizes) {
                me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
                me.longestLabelWidth = labelSizes.widest.width;
            }
            return labelSizes;
        },
        /**
	 * @private
	 */ _parseValue: function(value) {
            var start, end, min, max;
            if (isArray(value)) {
                start = +this.getRightValue(value[0]);
                end = +this.getRightValue(value[1]);
                min = Math.min(start, end);
                max = Math.max(start, end);
            } else {
                value = +this.getRightValue(value);
                start = undefined;
                end = value;
                min = value;
                max = value;
            }
            return {
                min: min,
                max: max,
                start: start,
                end: end
            };
        },
        /**
	* @private
	*/ _getScaleLabel: function(rawValue) {
            var v = this._parseValue(rawValue);
            if (v.start !== undefined) return '[' + v.start + ', ' + v.end + ']';
            return +this.getRightValue(rawValue);
        },
        /**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */ getLabelForIndex: helpers$1.noop,
        /**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */ getPixelForValue: helpers$1.noop,
        /**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */ getValueForPixel: helpers$1.noop,
        /**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForTick: function(index) {
            var me = this;
            var offset = me.options.offset;
            var numTicks = me._ticks.length;
            var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
            return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
        },
        /**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForDecimal: function(decimal) {
            var me = this;
            if (me._reversePixels) decimal = 1 - decimal;
            return me._startPixel + decimal * me._length;
        },
        getDecimalForPixel: function(pixel) {
            var decimal = (pixel - this._startPixel) / this._length;
            return this._reversePixels ? 1 - decimal : decimal;
        },
        /**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getBasePixel: function() {
            return this.getPixelForValue(this.getBaseValue());
        },
        getBaseValue: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
        },
        /**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */ _autoSkip: function(ticks) {
            var me = this;
            var tickOpts = me.options.ticks;
            var axisLength = me._length;
            var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
            var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
            var numMajorIndices = majorIndices.length;
            var first = majorIndices[0];
            var last = majorIndices[numMajorIndices - 1];
            var i, ilen, spacing, avgMajorSpacing;
            // If there are too many major ticks to display them all
            if (numMajorIndices > ticksLimit) {
                skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
                return nonSkipped(ticks);
            }
            spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
            if (numMajorIndices > 0) {
                for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
                avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
                skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
                skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
                return nonSkipped(ticks);
            }
            skip(ticks, spacing);
            return nonSkipped(ticks);
        },
        /**
	 * @private
	 */ _tickSize: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            // Calculate space needed by label in axis direction.
            var rot = helpers$1.toRadians(me.labelRotation);
            var cos = Math.abs(Math.cos(rot));
            var sin = Math.abs(Math.sin(rot));
            var labelSizes = me._getLabelSizes();
            var padding = optionTicks.autoSkipPadding || 0;
            var w = labelSizes ? labelSizes.widest.width + padding : 0;
            var h = labelSizes ? labelSizes.highest.height + padding : 0;
            // Calculate space needed for 1 tick in axis direction.
            return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
        },
        /**
	 * @private
	 */ _isVisible: function() {
            var me = this;
            var chart = me.chart;
            var display = me.options.display;
            var i, ilen, meta;
            if (display !== 'auto') return !!display;
            // When 'auto', the scale is visible if at least one associated dataset is visible.
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                if (meta.xAxisID === me.id || meta.yAxisID === me.id) return true;
            }
            return false;
        },
        /**
	 * @private
	 */ _computeGridLineItems: function(chartArea) {
            var me = this;
            var chart = me.chart;
            var options = me.options;
            var gridLines = options.gridLines;
            var position = options.position;
            var offsetGridLines = gridLines.offsetGridLines;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
            var tl = getTickMarkLength(gridLines);
            var items = [];
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var axisHalfWidth = axisWidth / 2;
            var alignPixel = helpers$1._alignPixel;
            var alignBorderValue = function(pixel) {
                return alignPixel(chart, pixel, axisWidth);
            };
            var borderValue, i, tick, lineValue, alignedLineValue;
            var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
            if (position === 'top') {
                borderValue = alignBorderValue(me.bottom);
                ty1 = me.bottom - tl;
                ty2 = borderValue - axisHalfWidth;
                y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
                y2 = chartArea.bottom;
            } else if (position === 'bottom') {
                borderValue = alignBorderValue(me.top);
                y1 = chartArea.top;
                y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
                ty1 = borderValue + axisHalfWidth;
                ty2 = me.top + tl;
            } else if (position === 'left') {
                borderValue = alignBorderValue(me.right);
                tx1 = me.right - tl;
                tx2 = borderValue - axisHalfWidth;
                x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
                x2 = chartArea.right;
            } else {
                borderValue = alignBorderValue(me.left);
                x1 = chartArea.left;
                x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
                tx1 = borderValue + axisHalfWidth;
                tx2 = me.left + tl;
            }
            for(i = 0; i < ticksLength; ++i){
                tick = ticks[i] || {};
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(tick.label) && i < ticks.length) continue;
                if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
                    // Draw the first index specially
                    lineWidth = gridLines.zeroLineWidth;
                    lineColor = gridLines.zeroLineColor;
                    borderDash = gridLines.zeroLineBorderDash || [];
                    borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
                } else {
                    lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
                    lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
                    borderDash = gridLines.borderDash || [];
                    borderDashOffset = gridLines.borderDashOffset || 0.0;
                }
                lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
                // Skip if the pixel is out of the range
                if (lineValue === undefined) continue;
                alignedLineValue = alignPixel(chart, lineValue, lineWidth);
                if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
                else ty1 = ty2 = y1 = y2 = alignedLineValue;
                items.push({
                    tx1: tx1,
                    ty1: ty1,
                    tx2: tx2,
                    ty2: ty2,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    width: lineWidth,
                    color: lineColor,
                    borderDash: borderDash,
                    borderDashOffset: borderDashOffset
                });
            }
            items.ticksLength = ticksLength;
            items.borderValue = borderValue;
            return items;
        },
        /**
	 * @private
	 */ _computeLabelItems: function() {
            var me = this;
            var options = me.options;
            var optionTicks = options.ticks;
            var position = options.position;
            var isMirrored = optionTicks.mirror;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var fonts = parseTickFontOptions(optionTicks);
            var tickPadding = optionTicks.padding;
            var tl = getTickMarkLength(options.gridLines);
            var rotation = -helpers$1.toRadians(me.labelRotation);
            var items = [];
            var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
            if (position === 'top') {
                y = me.bottom - tl - tickPadding;
                textAlign = !rotation ? 'center' : 'left';
            } else if (position === 'bottom') {
                y = me.top + tl + tickPadding;
                textAlign = !rotation ? 'center' : 'right';
            } else if (position === 'left') {
                x = me.right - (isMirrored ? 0 : tl) - tickPadding;
                textAlign = isMirrored ? 'left' : 'right';
            } else {
                x = me.left + (isMirrored ? 0 : tl) + tickPadding;
                textAlign = isMirrored ? 'right' : 'left';
            }
            for(i = 0, ilen = ticks.length; i < ilen; ++i){
                tick = ticks[i];
                label = tick.label;
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(label)) continue;
                pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
                font = tick.major ? fonts.major : fonts.minor;
                lineHeight = font.lineHeight;
                lineCount = isArray(label) ? label.length : 1;
                if (isHorizontal) {
                    x = pixel;
                    textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
                } else {
                    y = pixel;
                    textOffset = (1 - lineCount) * lineHeight / 2;
                }
                items.push({
                    x: x,
                    y: y,
                    rotation: rotation,
                    label: label,
                    font: font,
                    textOffset: textOffset,
                    textAlign: textAlign
                });
            }
            return items;
        },
        /**
	 * @private
	 */ _drawGrid: function(chartArea) {
            var me = this;
            var gridLines = me.options.gridLines;
            if (!gridLines.display) return;
            var ctx = me.ctx;
            var chart = me.chart;
            var alignPixel = helpers$1._alignPixel;
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
            var width, color, i, ilen, item;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                width = item.width;
                color = item.color;
                if (width && color) {
                    ctx.save();
                    ctx.lineWidth = width;
                    ctx.strokeStyle = color;
                    if (ctx.setLineDash) {
                        ctx.setLineDash(item.borderDash);
                        ctx.lineDashOffset = item.borderDashOffset;
                    }
                    ctx.beginPath();
                    if (gridLines.drawTicks) {
                        ctx.moveTo(item.tx1, item.ty1);
                        ctx.lineTo(item.tx2, item.ty2);
                    }
                    if (gridLines.drawOnChartArea) {
                        ctx.moveTo(item.x1, item.y1);
                        ctx.lineTo(item.x2, item.y2);
                    }
                    ctx.stroke();
                    ctx.restore();
                }
            }
            if (axisWidth) {
                // Draw the line at the edge of the axis
                var firstLineWidth = axisWidth;
                var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
                var borderValue = items.borderValue;
                var x1, x2, y1, y2;
                if (me.isHorizontal()) {
                    x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
                    x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
                    y1 = y2 = borderValue;
                } else {
                    y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
                    y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
                    x1 = x2 = borderValue;
                }
                ctx.lineWidth = axisWidth;
                ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            if (!optionTicks.display) return;
            var ctx = me.ctx;
            var items = me._labelItems || (me._labelItems = me._computeLabelItems());
            var i, j, ilen, jlen, item, tickFont, label, y;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                tickFont = item.font;
                // Make sure we draw text in the correct color and font
                ctx.save();
                ctx.translate(item.x, item.y);
                ctx.rotate(item.rotation);
                ctx.font = tickFont.string;
                ctx.fillStyle = tickFont.color;
                ctx.textBaseline = 'middle';
                ctx.textAlign = item.textAlign;
                label = item.label;
                y = item.textOffset;
                if (isArray(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                    // We just make sure the multiline element is a string here..
                    ctx.fillText('' + label[j], 0, y);
                    y += tickFont.lineHeight;
                }
                else ctx.fillText(label, 0, y);
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawTitle: function() {
            var me = this;
            var ctx = me.ctx;
            var options = me.options;
            var scaleLabel = options.scaleLabel;
            if (!scaleLabel.display) return;
            var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
            var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
            var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
            var halfLineHeight = scaleLabelFont.lineHeight / 2;
            var position = options.position;
            var rotation = 0;
            var scaleLabelX, scaleLabelY;
            if (me.isHorizontal()) {
                scaleLabelX = me.left + me.width / 2; // midpoint of the width
                scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
            } else {
                var isLeft = position === 'left';
                scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
                scaleLabelY = me.top + me.height / 2;
                rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
            }
            ctx.save();
            ctx.translate(scaleLabelX, scaleLabelY);
            ctx.rotate(rotation);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = scaleLabelFontColor; // render in correct colour
            ctx.font = scaleLabelFont.string;
            ctx.fillText(scaleLabel.labelString, 0, 0);
            ctx.restore();
        },
        draw: function(chartArea) {
            var me = this;
            if (!me._isVisible()) return;
            me._drawGrid(chartArea);
            me._drawTitle();
            me._drawLabels();
        },
        /**
	 * @private
	 */ _layers: function() {
            var me = this;
            var opts = me.options;
            var tz = opts.ticks && opts.ticks.z || 0;
            var gz = opts.gridLines && opts.gridLines.z || 0;
            if (!me._isVisible() || tz === gz || me.draw !== me._draw) // backward compatibility: draw has been overridden by custom scale
            return [
                {
                    z: tz,
                    draw: function() {
                        me.draw.apply(me, arguments);
                    }
                }
            ];
            return [
                {
                    z: gz,
                    draw: function() {
                        me._drawGrid.apply(me, arguments);
                        me._drawTitle.apply(me, arguments);
                    }
                },
                {
                    z: tz,
                    draw: function() {
                        me._drawLabels.apply(me, arguments);
                    }
                }
            ];
        },
        /**
	 * @private
	 */ _getMatchingVisibleMetas: function(type) {
            var me = this;
            var isHorizontal = me.isHorizontal();
            return me.chart._getSortedVisibleDatasetMetas().filter(function(meta) {
                return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
            });
        }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
        position: 'bottom'
    };
    var scale_category = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var labels = me._getLabels();
            var ticksOpts = me.options.ticks;
            var min = ticksOpts.min;
            var max = ticksOpts.max;
            var minIndex = 0;
            var maxIndex = labels.length - 1;
            var findIndex;
            if (min !== undefined) {
                // user specified min value
                findIndex = labels.indexOf(min);
                if (findIndex >= 0) minIndex = findIndex;
            }
            if (max !== undefined) {
                // user specified max value
                findIndex = labels.indexOf(max);
                if (findIndex >= 0) maxIndex = findIndex;
            }
            me.minIndex = minIndex;
            me.maxIndex = maxIndex;
            me.min = labels[minIndex];
            me.max = labels[maxIndex];
        },
        buildTicks: function() {
            var me = this;
            var labels = me._getLabels();
            var minIndex = me.minIndex;
            var maxIndex = me.maxIndex;
            // If we are viewing some subset of labels, slice the original array
            me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
            return me._getLabels()[index];
        },
        _configure: function() {
            var me = this;
            var offset = me.options.offset;
            var ticks = me.ticks;
            core_scale.prototype._configure.call(me);
            if (!me.isHorizontal()) // For backward compatibility, vertical category scale reverse is inverted.
            me._reversePixels = !me._reversePixels;
            if (!ticks) return;
            me._startValue = me.minIndex - (offset ? 0.5 : 0);
            me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
        },
        // Used to get data value locations.  Value can either be an index or a numerical value
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var valueCategory, labels, idx;
            if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) value = me.chart.data.datasets[datasetIndex].data[index];
            // If value is a data object, then index is the index in the data array,
            // not the index of the scale. We need to change that.
            if (!isNullOrUndef$1(value)) valueCategory = me.isHorizontal() ? value.x : value.y;
            if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
                labels = me._getLabels();
                value = helpers$1.valueOrDefault(valueCategory, value);
                idx = labels.indexOf(value);
                index = idx !== -1 ? idx : index;
                if (isNaN(index)) index = value;
            }
            return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
        },
        getPixelForTick: function(index) {
            var ticks = this.ticks;
            return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
            return Math.min(Math.max(value, 0), me.ticks.length - 1);
        },
        getBasePixel: function() {
            return this.bottom;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    /**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks(generationOptions, dataRange) {
        var ticks = [];
        // To get a "nice" value for the tick spacing, we will use the appropriately named
        // "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
        // for details.
        var MIN_SPACING = 1e-14;
        var stepSize = generationOptions.stepSize;
        var unit = stepSize || 1;
        var maxNumSpaces = generationOptions.maxTicks - 1;
        var min = generationOptions.min;
        var max = generationOptions.max;
        var precision = generationOptions.precision;
        var rmin = dataRange.min;
        var rmax = dataRange.max;
        var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
        var factor, niceMin, niceMax, numSpaces;
        // Beyond MIN_SPACING floating point numbers being to lose precision
        // such that we can't do the math necessary to generate ticks
        if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) return [
            rmin,
            rmax
        ];
        numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
        if (numSpaces > maxNumSpaces) // If the calculated num of spaces exceeds maxNumSpaces, recalculate it
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
        if (stepSize || isNullOrUndef$2(precision)) // If a precision is not specified, calculate factor based on spacing
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
        else {
            // If the user specified a precision, round to that number of decimal places
            factor = Math.pow(10, precision);
            spacing = Math.ceil(spacing * factor) / factor;
        }
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
        // If min, max and stepSize is set and they make an evenly spaced scale use it.
        if (stepSize) {
            // If very close to our whole number, use it.
            if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) niceMin = min;
            if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) niceMax = max;
        }
        numSpaces = (niceMax - niceMin) / spacing;
        // If very close to our rounded value, use it.
        if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
        niceMin = Math.round(niceMin * factor) / factor;
        niceMax = Math.round(niceMax * factor) / factor;
        ticks.push(isNullOrUndef$2(min) ? niceMin : min);
        for(var j = 1; j < numSpaces; ++j)ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
        ticks.push(isNullOrUndef$2(max) ? niceMax : max);
        return ticks;
    }
    var scale_linearbase = core_scale.extend({
        getRightValue: function(value) {
            if (typeof value === 'string') return +value;
            return core_scale.prototype.getRightValue.call(this, value);
        },
        handleTickRangeOptions: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
            // do nothing since that would make the chart weird. If the user really wants a weird chart
            // axis, they can manually override it
            if (tickOpts.beginAtZero) {
                var minSign = helpers$1.sign(me.min);
                var maxSign = helpers$1.sign(me.max);
                if (minSign < 0 && maxSign < 0) // move the top up to 0
                me.max = 0;
                else if (minSign > 0 && maxSign > 0) // move the bottom down to 0
                me.min = 0;
            }
            var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
            var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
            if (tickOpts.min !== undefined) me.min = tickOpts.min;
            else if (tickOpts.suggestedMin !== undefined) {
                if (me.min === null) me.min = tickOpts.suggestedMin;
                else me.min = Math.min(me.min, tickOpts.suggestedMin);
            }
            if (tickOpts.max !== undefined) me.max = tickOpts.max;
            else if (tickOpts.suggestedMax !== undefined) {
                if (me.max === null) me.max = tickOpts.suggestedMax;
                else me.max = Math.max(me.max, tickOpts.suggestedMax);
            }
            if (setMin !== setMax) // We set the min or the max but not both.
            // So ensure that our range is good
            // Inverted or 0 length range can happen when
            // ticks.min is set, and no datasets are visible
            {
                if (me.min >= me.max) {
                    if (setMin) me.max = me.min + 1;
                    else me.min = me.max - 1;
                }
            }
            if (me.min === me.max) {
                me.max++;
                if (!tickOpts.beginAtZero) me.min--;
            }
        },
        getTickLimit: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var stepSize = tickOpts.stepSize;
            var maxTicksLimit = tickOpts.maxTicksLimit;
            var maxTicks;
            if (stepSize) maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
            else {
                maxTicks = me._computeTickLimit();
                maxTicksLimit = maxTicksLimit || 11;
            }
            if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
            return maxTicks;
        },
        _computeTickLimit: function() {
            return Number.POSITIVE_INFINITY;
        },
        handleDirectionalChanges: noop,
        buildTicks: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // Figure out what the max number of ticks we can support it is based on the size of
            // the axis area. For now, we say that the minimum tick spacing in pixels must be 40
            // We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
            // the graph. Make sure we always have at least 2 ticks
            var maxTicks = me.getTickLimit();
            maxTicks = Math.max(2, maxTicks);
            var numericGeneratorOptions = {
                maxTicks: maxTicks,
                min: tickOpts.min,
                max: tickOpts.max,
                precision: tickOpts.precision,
                stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
            };
            var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
            me.handleDirectionalChanges();
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                ticks.reverse();
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
        },
        convertTicksToLabels: function() {
            var me = this;
            me.ticksAsNumbers = me.ticks.slice();
            me.zeroLineIndex = me.ticks.indexOf(0);
            core_scale.prototype.convertTicksToLabels.call(me);
        },
        _configure: function() {
            var me = this;
            var ticks = me.getTicks();
            var start = me.min;
            var end = me.max;
            var offset;
            core_scale.prototype._configure.call(me);
            if (me.options.offset && ticks.length) {
                offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
                start -= offset;
                end += offset;
            }
            me._startValue = start;
            me._endValue = end;
            me._valueRange = end - start;
        }
    });
    var defaultConfig$1 = {
        position: 'left',
        ticks: {
            callback: core_ticks.formatters.linear
        }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
        var key = [
            meta.type,
            // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
            stacked === undefined && meta.stack === undefined ? meta.index : '',
            meta.stack
        ].join('.');
        if (stacks[key] === undefined) stacks[key] = {
            pos: [],
            neg: []
        };
        return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
        var opts = scale.options;
        var stacked = opts.stacked;
        var stack = getOrCreateStack(stacks, stacked, meta);
        var pos = stack.pos;
        var neg = stack.neg;
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            pos[i] = pos[i] || 0;
            neg[i] = neg[i] || 0;
            if (opts.relativePoints) pos[i] = 100;
            else if (value.min < 0 || value.max < 0) neg[i] += value.min;
            else pos[i] += value.max;
        }
    }
    function updateMinMax(scale, meta, data) {
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            scale.min = Math.min(scale.min, value.min);
            scale.max = Math.max(scale.max, value.max);
        }
    }
    var scale_linear = scale_linearbase.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var metasets = me._getMatchingVisibleMetas();
            var hasStacks = opts.stacked;
            var stacks = {};
            var ilen = metasets.length;
            var i, meta, data, values;
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            if (hasStacks === undefined) for(i = 0; !hasStacks && i < ilen; ++i){
                meta = metasets[i];
                hasStacks = meta.stack !== undefined;
            }
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                data = datasets[meta.index].data;
                if (hasStacks) stackData(me, stacks, meta, data);
                else updateMinMax(me, meta, data);
            }
            helpers$1.each(stacks, function(stackValues) {
                values = stackValues.pos.concat(stackValues.neg);
                me.min = Math.min(me.min, helpers$1.min(values));
                me.max = Math.max(me.max, helpers$1.max(values));
            });
            me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
            me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            var me = this;
            var tickFont;
            if (me.isHorizontal()) return Math.ceil(me.width / 40);
            tickFont = helpers$1.options._parseFont(me.options.ticks);
            return Math.ceil(me.height / tickFont.lineHeight);
        },
        // Called after the ticks are built. We need
        handleDirectionalChanges: function() {
            if (!this.isHorizontal()) // We are in a vertical orientation. The top value is the highest. So reverse the array
            this.ticks.reverse();
        },
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        // Utils
        getPixelForValue: function(value) {
            var me = this;
            return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
        },
        getValueForPixel: function(pixel) {
            return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
        },
        getPixelForTick: function(index) {
            var ticks = this.ticksAsNumbers;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    /**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks$1(generationOptions, dataRange) {
        var ticks = [];
        var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
        var endExp = Math.floor(log10(dataRange.max));
        var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
        var exp, significand;
        if (tickVal === 0) {
            exp = Math.floor(log10(dataRange.minNotZero));
            significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
            ticks.push(tickVal);
            tickVal = significand * Math.pow(10, exp);
        } else {
            exp = Math.floor(log10(tickVal));
            significand = Math.floor(tickVal / Math.pow(10, exp));
        }
        var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
        do {
            ticks.push(tickVal);
            ++significand;
            if (significand === 10) {
                significand = 1;
                ++exp;
                precision = exp >= 0 ? 1 : precision;
            }
            tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
        }while (exp < endExp || exp === endExp && significand < endSignificand);
        var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
        ticks.push(lastTick);
        return ticks;
    }
    var defaultConfig$2 = {
        position: 'left',
        // label settings
        ticks: {
            callback: core_ticks.formatters.logarithmic
        }
    };
    // TODO(v3): change this to positiveOrDefault
    function nonNegativeOrDefault(value, defaultValue) {
        return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var isHorizontal = me.isHorizontal();
            function IDMatches(meta) {
                return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
            }
            var datasetIndex, meta, value, data, i, ilen;
            // Calculate Range
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            me.minNotZero = Number.POSITIVE_INFINITY;
            var hasStacks = opts.stacked;
            if (hasStacks === undefined) for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
                    hasStacks = true;
                    break;
                }
            }
            if (opts.stacked || hasStacks) {
                var valuesPerStack = {};
                for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                    meta = chart.getDatasetMeta(datasetIndex);
                    var key = [
                        meta.type,
                        // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
                        opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '',
                        meta.stack
                    ].join('.');
                    if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                        if (valuesPerStack[key] === undefined) valuesPerStack[key] = [];
                        data = datasets[datasetIndex].data;
                        for(i = 0, ilen = data.length; i < ilen; i++){
                            var values = valuesPerStack[key];
                            value = me._parseValue(data[i]);
                            // invalid, hidden and negative values are ignored
                            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                            values[i] = values[i] || 0;
                            values[i] += value.max;
                        }
                    }
                }
                helpers$1.each(valuesPerStack, function(valuesForType) {
                    if (valuesForType.length > 0) {
                        var minVal = helpers$1.min(valuesForType);
                        var maxVal = helpers$1.max(valuesForType);
                        me.min = Math.min(me.min, minVal);
                        me.max = Math.max(me.max, maxVal);
                    }
                });
            } else for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                    data = datasets[datasetIndex].data;
                    for(i = 0, ilen = data.length; i < ilen; i++){
                        value = me._parseValue(data[i]);
                        // invalid, hidden and negative values are ignored
                        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                        me.min = Math.min(value.min, me.min);
                        me.max = Math.max(value.max, me.max);
                        if (value.min !== 0) me.minNotZero = Math.min(value.min, me.minNotZero);
                    }
                }
            }
            me.min = helpers$1.isFinite(me.min) ? me.min : null;
            me.max = helpers$1.isFinite(me.max) ? me.max : null;
            me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
            // Common base implementation to handle ticks.min, ticks.max
            this.handleTickRangeOptions();
        },
        handleTickRangeOptions: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var DEFAULT_MIN = 1;
            var DEFAULT_MAX = 10;
            me.min = nonNegativeOrDefault(tickOpts.min, me.min);
            me.max = nonNegativeOrDefault(tickOpts.max, me.max);
            if (me.min === me.max) {
                if (me.min !== 0 && me.min !== null) {
                    me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
                    me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
                } else {
                    me.min = DEFAULT_MIN;
                    me.max = DEFAULT_MAX;
                }
            }
            if (me.min === null) me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
            if (me.max === null) me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
            if (me.minNotZero === null) {
                if (me.min > 0) me.minNotZero = me.min;
                else if (me.max < 1) me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
                else me.minNotZero = DEFAULT_MIN;
            }
        },
        buildTicks: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var reverse = !me.isHorizontal();
            var generationOptions = {
                min: nonNegativeOrDefault(tickOpts.min),
                max: nonNegativeOrDefault(tickOpts.max)
            };
            var ticks = me.ticks = generateTicks$1(generationOptions, me);
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                reverse = !reverse;
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
            if (reverse) ticks.reverse();
        },
        convertTicksToLabels: function() {
            this.tickValues = this.ticks.slice();
            core_scale.prototype.convertTicksToLabels.call(this);
        },
        // Get the correct tooltip label
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        getPixelForTick: function(index) {
            var ticks = this.tickValues;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        },
        /**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */ _getFirstTickValue: function(value) {
            var exp = Math.floor(log10(value));
            var significand = Math.floor(value / Math.pow(10, exp));
            return significand * Math.pow(10, exp);
        },
        _configure: function() {
            var me = this;
            var start = me.min;
            var offset = 0;
            core_scale.prototype._configure.call(me);
            if (start === 0) {
                start = me._getFirstTickValue(me.minNotZero);
                offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
            }
            me._startValue = log10(start);
            me._valueOffset = offset;
            me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
        },
        getPixelForValue: function(value) {
            var me = this;
            var decimal = 0;
            value = +me.getRightValue(value);
            if (value > me.min && value > 0) decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
            return me.getPixelForDecimal(decimal);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var decimal = me.getDecimalForPixel(pixel);
            return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
        display: true,
        // Boolean - Whether to animate scaling the chart from the centre
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            color: 'rgba(0,0,0,0.1)',
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        gridLines: {
            circular: false
        },
        // label settings
        ticks: {
            // Boolean - Show a backdrop to the scale label
            showLabelBackdrop: true,
            // String - The colour of the label backdrop
            backdropColor: 'rgba(255,255,255,0.75)',
            // Number - The backdrop padding above & below the label in pixels
            backdropPaddingY: 2,
            // Number - The backdrop padding to the side of the label in pixels
            backdropPaddingX: 2,
            callback: core_ticks.formatters.linear
        },
        pointLabels: {
            // Boolean - if true, show point labels
            display: true,
            // Number - Point label font size in pixels
            fontSize: 10,
            // Function - Used to convert point labels
            callback: function(label) {
                return label;
            }
        }
    };
    function getTickBackdropHeight(opts) {
        var tickOpts = opts.ticks;
        if (tickOpts.display && opts.display) return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
        return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
        if (helpers$1.isArray(label)) return {
            w: helpers$1.longestText(ctx, ctx.font, label),
            h: label.length * lineHeight
        };
        return {
            w: ctx.measureText(label).width,
            h: lineHeight
        };
    }
    function determineLimits(angle, pos, size, min, max) {
        if (angle === min || angle === max) return {
            start: pos - size / 2,
            end: pos + size / 2
        };
        else if (angle < min || angle > max) return {
            start: pos - size,
            end: pos
        };
        return {
            start: pos,
            end: pos + size
        };
    }
    /**
 * Helper function to fit a radial linear scale with point labels
 */ function fitWithPointLabels(scale) {
        // Right, this is really confusing and there is a lot of maths going on here
        // The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
        //
        // Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
        //
        // Solution:
        //
        // We assume the radius of the polygon is half the size of the canvas at first
        // at each index we check if the text overlaps.
        //
        // Where it does, we store that angle and that index.
        //
        // After finding the largest index and angle we calculate how much we need to remove
        // from the shape radius to move the point inwards by that x.
        //
        // We average the left and right distances to get the maximum shape radius that can fit in the box
        // along with labels.
        //
        // Once we have that, we can find the centre point for the chart, by taking the x text protrusion
        // on each side, removing that from the size, halving it and adding the left x protrusion width.
        //
        // This will mean we have a shape fitted to the canvas, as large as it can be with the labels
        // and position it in the most space efficient manner
        //
        // https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
        var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
        // Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
        // Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
        var furthestLimits = {
            l: 0,
            r: scale.width,
            t: 0,
            b: scale.height - scale.paddingTop
        };
        var furthestAngles = {};
        var i, textSize, pointPosition;
        scale.ctx.font = plFont.string;
        scale._pointLabelSizes = [];
        var valueCount = scale.chart.data.labels.length;
        for(i = 0; i < valueCount; i++){
            pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
            textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
            scale._pointLabelSizes[i] = textSize;
            // Add quarter circle to make degree 0 mean top of circle
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians) % 360;
            var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
            var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
            if (hLimits.start < furthestLimits.l) {
                furthestLimits.l = hLimits.start;
                furthestAngles.l = angleRadians;
            }
            if (hLimits.end > furthestLimits.r) {
                furthestLimits.r = hLimits.end;
                furthestAngles.r = angleRadians;
            }
            if (vLimits.start < furthestLimits.t) {
                furthestLimits.t = vLimits.start;
                furthestAngles.t = angleRadians;
            }
            if (vLimits.end > furthestLimits.b) {
                furthestLimits.b = vLimits.end;
                furthestAngles.b = angleRadians;
            }
        }
        scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
        if (angle === 0 || angle === 180) return 'center';
        else if (angle < 180) return 'left';
        return 'right';
    }
    function fillText(ctx, text, position, lineHeight) {
        var y = position.y + lineHeight / 2;
        var i, ilen;
        if (helpers$1.isArray(text)) for(i = 0, ilen = text.length; i < ilen; ++i){
            ctx.fillText(text[i], position.x, y);
            y += lineHeight;
        }
        else ctx.fillText(text, position.x, y);
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
        if (angle === 90 || angle === 270) position.y -= textSize.h / 2;
        else if (angle > 270 || angle < 90) position.y -= textSize.h;
    }
    function drawPointLabels(scale) {
        var ctx = scale.ctx;
        var opts = scale.options;
        var pointLabelOpts = opts.pointLabels;
        var tickBackdropHeight = getTickBackdropHeight(opts);
        var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
        var plFont = helpers$1.options._parseFont(pointLabelOpts);
        ctx.save();
        ctx.font = plFont.string;
        ctx.textBaseline = 'middle';
        for(var i = scale.chart.data.labels.length - 1; i >= 0; i--){
            // Extra pixels out for some label spacing
            var extra = i === 0 ? tickBackdropHeight / 2 : 0;
            var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
            // Keep this in loop since we may support array properties here
            var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
            ctx.fillStyle = pointLabelFontColor;
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians);
            ctx.textAlign = getTextAlignForAngle(angle);
            adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
            fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
        }
        ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
        var ctx = scale.ctx;
        var circular = gridLineOpts.circular;
        var valueCount = scale.chart.data.labels.length;
        var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
        var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
        var pointPosition;
        if (!circular && !valueCount || !lineColor || !lineWidth) return;
        ctx.save();
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = lineWidth;
        if (ctx.setLineDash) {
            ctx.setLineDash(gridLineOpts.borderDash || []);
            ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
        }
        ctx.beginPath();
        if (circular) // Draw circular arcs between the points
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
        else {
            // Draw straight lines connecting each index
            pointPosition = scale.getPointPosition(0, radius);
            ctx.moveTo(pointPosition.x, pointPosition.y);
            for(var i = 1; i < valueCount; i++){
                pointPosition = scale.getPointPosition(i, radius);
                ctx.lineTo(pointPosition.x, pointPosition.y);
            }
        }
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
    function numberOrZero(param) {
        return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            me.width = me.maxWidth;
            me.height = me.maxHeight;
            me.paddingTop = getTickBackdropHeight(me.options) / 2;
            me.xCenter = Math.floor(me.width / 2);
            me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
            me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var min = Number.POSITIVE_INFINITY;
            var max = Number.NEGATIVE_INFINITY;
            helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
                if (chart.isDatasetVisible(datasetIndex)) {
                    var meta = chart.getDatasetMeta(datasetIndex);
                    helpers$1.each(dataset.data, function(rawValue, index) {
                        var value = +me.getRightValue(rawValue);
                        if (isNaN(value) || meta.data[index].hidden) return;
                        min = Math.min(value, min);
                        max = Math.max(value, max);
                    });
                }
            });
            me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
            me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
        },
        convertTicksToLabels: function() {
            var me = this;
            scale_linearbase.prototype.convertTicksToLabels.call(me);
            // Point labels
            me.pointLabels = me.chart.data.labels.map(function() {
                var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
                return label || label === 0 ? label : '';
            });
        },
        getLabelForIndex: function(index, datasetIndex) {
            return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
        },
        fit: function() {
            var me = this;
            var opts = me.options;
            if (opts.display && opts.pointLabels.display) fitWithPointLabels(me);
            else me.setCenterPoint(0, 0, 0, 0);
        },
        /**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */ setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
            var me = this;
            var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
            var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
            var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
            var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
            radiusReductionLeft = numberOrZero(radiusReductionLeft);
            radiusReductionRight = numberOrZero(radiusReductionRight);
            radiusReductionTop = numberOrZero(radiusReductionTop);
            radiusReductionBottom = numberOrZero(radiusReductionBottom);
            me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
            me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
        },
        setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
            var me = this;
            var maxRight = me.width - rightMovement - me.drawingArea;
            var maxLeft = leftMovement + me.drawingArea;
            var maxTop = topMovement + me.drawingArea;
            var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
            me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
            me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
        },
        getIndexAngle: function(index) {
            var chart = this.chart;
            var angleMultiplier = 360 / chart.data.labels.length;
            var options = chart.options || {};
            var startAngle = options.startAngle || 0;
            // Start from the top instead of right, so remove a quarter of the circle
            var angle = (index * angleMultiplier + startAngle) % 360;
            return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
        },
        getDistanceFromCenterForValue: function(value) {
            var me = this;
            if (helpers$1.isNullOrUndef(value)) return NaN;
            // Take into account half font size + the yPadding of the top value
            var scalingFactor = me.drawingArea / (me.max - me.min);
            if (me.options.ticks.reverse) return (me.max - value) * scalingFactor;
            return (value - me.min) * scalingFactor;
        },
        getPointPosition: function(index, distanceFromCenter) {
            var me = this;
            var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
            return {
                x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
                y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
            };
        },
        getPointPositionForValue: function(index, value) {
            return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
        },
        getBasePosition: function(index) {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
        },
        /**
	 * @private
	 */ _drawGrid: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var gridLineOpts = opts.gridLines;
            var angleLineOpts = opts.angleLines;
            var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
            var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
            var i, offset, position;
            if (opts.pointLabels.display) drawPointLabels(me);
            if (gridLineOpts.display) helpers$1.each(me.ticks, function(label, index) {
                if (index !== 0) {
                    offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                    drawRadiusLine(me, gridLineOpts, offset, index);
                }
            });
            if (angleLineOpts.display && lineWidth && lineColor) {
                ctx.save();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = lineColor;
                if (ctx.setLineDash) {
                    ctx.setLineDash(resolve$4([
                        angleLineOpts.borderDash,
                        gridLineOpts.borderDash,
                        []
                    ]));
                    ctx.lineDashOffset = resolve$4([
                        angleLineOpts.borderDashOffset,
                        gridLineOpts.borderDashOffset,
                        0.0
                    ]);
                }
                for(i = me.chart.data.labels.length - 1; i >= 0; i--){
                    offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
                    position = me.getPointPosition(i, offset);
                    ctx.beginPath();
                    ctx.moveTo(me.xCenter, me.yCenter);
                    ctx.lineTo(position.x, position.y);
                    ctx.stroke();
                }
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var tickOpts = opts.ticks;
            if (!tickOpts.display) return;
            var startAngle = me.getIndexAngle(0);
            var tickFont = helpers$1.options._parseFont(tickOpts);
            var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
            var offset, width;
            ctx.save();
            ctx.font = tickFont.string;
            ctx.translate(me.xCenter, me.yCenter);
            ctx.rotate(startAngle);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            helpers$1.each(me.ticks, function(label, index) {
                if (index === 0 && !tickOpts.reverse) return;
                offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                if (tickOpts.showLabelBackdrop) {
                    width = ctx.measureText(label).width;
                    ctx.fillStyle = tickOpts.backdropColor;
                    ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
                }
                ctx.fillStyle = tickFontColor;
                ctx.fillText(label, 0, -offset);
            });
            ctx.restore();
        },
        /**
	 * @private
	 */ _drawTitle: helpers$1.noop
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    // Integer constants are from the ES6 spec.
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
        millisecond: {
            common: true,
            size: 1,
            steps: 1000
        },
        second: {
            common: true,
            size: 1000,
            steps: 60
        },
        minute: {
            common: true,
            size: 60000,
            steps: 60
        },
        hour: {
            common: true,
            size: 3600000,
            steps: 24
        },
        day: {
            common: true,
            size: 86400000,
            steps: 30
        },
        week: {
            common: false,
            size: 604800000,
            steps: 4
        },
        month: {
            common: true,
            size: 2.628e9,
            steps: 12
        },
        quarter: {
            common: false,
            size: 7.884e9,
            steps: 4
        },
        year: {
            common: true,
            size: 3.154e10
        }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
        return a - b;
    }
    function arrayUnique(items) {
        var hash = {};
        var out = [];
        var i, ilen, item;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            if (!hash[item]) {
                hash[item] = true;
                out.push(item);
            }
        }
        return out;
    }
    function getMin(options) {
        return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
        return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    /**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */ function buildLookupTable(timestamps, min, max, distribution) {
        if (distribution === 'linear' || !timestamps.length) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        var table = [];
        var items = [
            min
        ];
        var i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr > min && curr < max) items.push(curr);
        }
        items.push(max);
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            // only add points that breaks the scale linearity
            if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    // @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
    function lookup(table, key, value) {
        var lo = 0;
        var hi = table.length - 1;
        var mid, i0, i1;
        while(lo >= 0 && lo <= hi){
            mid = lo + hi >> 1;
            i0 = table[mid - 1] || null;
            i1 = table[mid];
            if (!i0) // given value is outside table (before first item)
            return {
                lo: null,
                hi: i1
            };
            else if (i1[key] < value) lo = mid + 1;
            else if (i0[key] > value) hi = mid - 1;
            else return {
                lo: i0,
                hi: i1
            };
        }
        // given value is outside table (after last item)
        return {
            lo: i1,
            hi: null
        };
    }
    /**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */ function interpolate$1(table, skey, sval, tkey) {
        var range = lookup(table, skey, sval);
        // Note: the lookup table ALWAYS contains at least 2 items (min and max)
        var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
        var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
        var span = next[skey] - prev[skey];
        var ratio = span ? (sval - prev[skey]) / span : 0;
        var offset = (next[tkey] - prev[tkey]) * ratio;
        return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
        var adapter = scale._adapter;
        var options = scale.options.time;
        var parser = options.parser;
        var format = parser || options.format;
        var value = input;
        if (typeof parser === 'function') value = parser(value);
        // Only parse if its not a timestamp already
        if (!helpers$1.isFinite(value)) value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
        if (value !== null) return +value;
        // Labels are in an incompatible format and no `parser` has been provided.
        // The user might still use the deprecated `format` option for parsing.
        if (!parser && typeof format === 'function') {
            value = format(input);
            // `format` could return something else than a timestamp, if so, parse it
            if (!helpers$1.isFinite(value)) value = adapter.parse(value);
        }
        return value;
    }
    function parse(scale, input) {
        if (helpers$1.isNullOrUndef(input)) return null;
        var options = scale.options.time;
        var value = toTimestamp(scale, scale.getRightValue(input));
        if (value === null) return value;
        if (options.round) value = +scale._adapter.startOf(value, options.round);
        return value;
    }
    /**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */ function determineUnitForAutoTicks(minUnit, min, max, capacity) {
        var ilen = UNITS.length;
        var i, interval, factor;
        for(i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
            interval = INTERVALS[UNITS[i]];
            factor = interval.steps ? interval.steps : MAX_INTEGER;
            if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
        }
        return UNITS[ilen - 1];
    }
    /**
 * Figures out what unit to format a set of ticks with
 */ function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
        var i, unit;
        for(i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
            unit = UNITS[i];
            if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
        }
        return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
        for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
            if (INTERVALS[UNITS[i]].common) return UNITS[i];
        }
    }
    /**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */ function generate(scale, min, max, capacity) {
        var adapter = scale._adapter;
        var options = scale.options;
        var timeOpts = options.time;
        var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
        var stepSize = resolve$5([
            timeOpts.stepSize,
            timeOpts.unitStepSize,
            1
        ]);
        var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        var first = min;
        var ticks = [];
        var time;
        // For 'week' unit, handle the first day of week option
        if (weekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        // Align first ticks on unit
        first = +adapter.startOf(first, weekday ? 'day' : minor);
        // Prevent browser from freezing in case user options request millions of milliseconds
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
        for(time = first; time < max; time = +adapter.add(time, stepSize, minor))ticks.push(time);
        if (time === max || options.bounds === 'ticks') ticks.push(time);
        return ticks;
    }
    /**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */ function computeOffsets(table, ticks, min, max, options) {
        var start = 0;
        var end = 0;
        var first, last;
        if (options.offset && ticks.length) {
            first = interpolate$1(table, 'time', ticks[0], 'pos');
            if (ticks.length === 1) start = 1 - first;
            else start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
            last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
            if (ticks.length === 1) end = last;
            else end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
        }
        return {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
        var adapter = scale._adapter;
        var first = +adapter.startOf(ticks[0].value, majorUnit);
        var last = ticks[ticks.length - 1].value;
        var major, index;
        for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
            index = map[major];
            if (index >= 0) ticks[index].major = true;
        }
        return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
        var ticks = [];
        var map = {};
        var ilen = values.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = values[i];
            map[value] = i;
            ticks.push({
                value: value,
                major: false
            });
        }
        // We set the major ticks separately from the above loop because calling startOf for every tick
        // is expensive when there is a large number of ticks
        return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
        position: 'bottom',
        /**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */ distribution: 'linear',
        /**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */ bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            displayFormat: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            autoSkip: false,
            /**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */ source: 'auto',
            major: {
                enabled: false
            }
        }
    };
    var scale_time = core_scale.extend({
        initialize: function() {
            this.mergeTicksOptions();
            core_scale.prototype.initialize.call(this);
        },
        update: function() {
            var me = this;
            var options = me.options;
            var time = options.time || (options.time = {});
            var adapter = me._adapter = new core_adapters._date(options.adapters.date);
            // DEPRECATIONS: output a message only one time per update
            deprecated$1('time scale', time.format, 'time.format', 'time.parser');
            deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
            deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
            // Backward compatibility: before introducing adapter, `displayFormats` was
            // supposed to contain *all* unit/string pairs but this can't be resolved
            // when loading the scale (adapters are loaded afterward), so let's populate
            // missing formats on update
            helpers$1.mergeIf(time.displayFormats, adapter.formats());
            return core_scale.prototype.update.apply(me, arguments);
        },
        /**
	 * Allows data to be referenced via 't' attribute
	 */ getRightValue: function(rawValue) {
            if (rawValue && rawValue.t !== undefined) rawValue = rawValue.t;
            return core_scale.prototype.getRightValue.call(this, rawValue);
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var adapter = me._adapter;
            var options = me.options;
            var unit = options.time.unit || 'day';
            var min = MAX_INTEGER;
            var max = MIN_INTEGER;
            var timestamps = [];
            var datasets = [];
            var labels = [];
            var i, j, ilen, jlen, data, timestamp, labelsAdded;
            var dataLabels = me._getLabels();
            for(i = 0, ilen = dataLabels.length; i < ilen; ++i)labels.push(parse(me, dataLabels[i]));
            for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                data = chart.data.datasets[i].data;
                // Let's consider that all data have the same format.
                if (helpers$1.isObject(data[0])) {
                    datasets[i] = [];
                    for(j = 0, jlen = data.length; j < jlen; ++j){
                        timestamp = parse(me, data[j]);
                        timestamps.push(timestamp);
                        datasets[i][j] = timestamp;
                    }
                } else {
                    datasets[i] = labels.slice(0);
                    if (!labelsAdded) {
                        timestamps = timestamps.concat(labels);
                        labelsAdded = true;
                    }
                }
            } else datasets[i] = [];
            if (labels.length) {
                min = Math.min(min, labels[0]);
                max = Math.max(max, labels[labels.length - 1]);
            }
            if (timestamps.length) {
                timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
                min = Math.min(min, timestamps[0]);
                max = Math.max(max, timestamps[timestamps.length - 1]);
            }
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // In case there is no valid min/max, set limits based on unit time option
            min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
            max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
            // Make sure that max is strictly higher than min (required by the lookup table)
            me.min = Math.min(min, max);
            me.max = Math.max(min + 1, max);
            // PRIVATE
            me._table = [];
            me._timestamps = {
                data: timestamps,
                datasets: datasets,
                labels: labels
            };
        },
        buildTicks: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            var options = me.options;
            var tickOpts = options.ticks;
            var timeOpts = options.time;
            var timestamps = me._timestamps;
            var ticks = [];
            var capacity = me.getLabelCapacity(min);
            var source = tickOpts.source;
            var distribution = options.distribution;
            var i, ilen, timestamp;
            if (source === 'data' || source === 'auto' && distribution === 'series') timestamps = timestamps.data;
            else if (source === 'labels') timestamps = timestamps.labels;
            else timestamps = generate(me, min, max, capacity);
            if (options.bounds === 'ticks' && timestamps.length) {
                min = timestamps[0];
                max = timestamps[timestamps.length - 1];
            }
            // Enforce limits with user min/max options
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // Remove ticks outside the min/max range
            for(i = 0, ilen = timestamps.length; i < ilen; ++i){
                timestamp = timestamps[i];
                if (timestamp >= min && timestamp <= max) ticks.push(timestamp);
            }
            me.min = min;
            me.max = max;
            // PRIVATE
            // determineUnitForFormatting relies on the number of ticks so we don't use it when
            // autoSkip is enabled because we don't yet know what the final number of ticks will be
            me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
            me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
            me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
            me._offsets = computeOffsets(me._table, ticks, min, max, options);
            if (tickOpts.reverse) ticks.reverse();
            return ticksFromTimestamps(me, ticks, me._majorUnit);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var adapter = me._adapter;
            var data = me.chart.data;
            var timeOpts = me.options.time;
            var label = data.labels && index < data.labels.length ? data.labels[index] : '';
            var value = data.datasets[datasetIndex].data[index];
            if (helpers$1.isObject(value)) label = me.getRightValue(value);
            if (timeOpts.tooltipFormat) return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
            if (typeof label === 'string') return label;
            return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
        },
        /**
	 * Function to format an individual tick mark
	 * @private
	 */ tickFormatFunction: function(time, index, ticks, format) {
            var me = this;
            var adapter = me._adapter;
            var options = me.options;
            var formats = options.time.displayFormats;
            var minorFormat = formats[me._unit];
            var majorUnit = me._majorUnit;
            var majorFormat = formats[majorUnit];
            var tick = ticks[index];
            var tickOpts = options.ticks;
            var major = majorUnit && majorFormat && tick && tick.major;
            var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
            var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
            var formatter = resolve$5([
                nestedTickOpts.callback,
                nestedTickOpts.userCallback,
                tickOpts.callback,
                tickOpts.userCallback
            ]);
            return formatter ? formatter(label, index, ticks) : label;
        },
        convertTicksToLabels: function(ticks) {
            var labels = [];
            var i, ilen;
            for(i = 0, ilen = ticks.length; i < ilen; ++i)labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
            return labels;
        },
        /**
	 * @private
	 */ getPixelForOffset: function(time) {
            var me = this;
            var offsets = me._offsets;
            var pos = interpolate$1(me._table, 'time', time, 'pos');
            return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
        },
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var time = null;
            if (index !== undefined && datasetIndex !== undefined) time = me._timestamps.datasets[datasetIndex][index];
            if (time === null) time = parse(me, value);
            if (time !== null) return me.getPixelForOffset(time);
        },
        getPixelForTick: function(index) {
            var ticks = this.getTicks();
            return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var offsets = me._offsets;
            var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
            var time = interpolate$1(me._table, 'pos', pos, 'time');
            // DEPRECATION, we should return time directly
            return me._adapter._create(time);
        },
        /**
	 * @private
	 */ _getLabelSize: function(label) {
            var me = this;
            var ticksOpts = me.options.ticks;
            var tickLabelWidth = me.ctx.measureText(label).width;
            var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
            var cosRotation = Math.cos(angle);
            var sinRotation = Math.sin(angle);
            var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
            return {
                w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
                h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
            };
        },
        /**
	 * Crude approximation of what the label width might be
	 * @private
	 */ getLabelWidth: function(label) {
            return this._getLabelSize(label).w;
        },
        /**
	 * @private
	 */ getLabelCapacity: function(exampleTime) {
            var me = this;
            var timeOpts = me.options.time;
            var displayFormats = timeOpts.displayFormats;
            // pick the longest format (milliseconds) for guestimation
            var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
            var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [
                exampleTime
            ], me._majorUnit), format);
            var size = me._getLabelSize(exampleLabel);
            var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
            if (me.options.offset) capacity--;
            return capacity > 0 ? capacity : 1;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
        category: scale_category,
        linear: scale_linear,
        logarithmic: scale_logarithmic,
        radialLinear: scale_radialLinear,
        time: scale_time
    };
    var FORMATS = {
        datetime: 'MMM D, YYYY, h:mm:ss a',
        millisecond: 'h:mm:ss.SSS a',
        second: 'h:mm:ss a',
        minute: 'h:mm a',
        hour: 'hA',
        day: 'MMM D',
        week: 'll',
        month: 'MMM YYYY',
        quarter: '[Q]Q - YYYY',
        year: 'YYYY'
    };
    core_adapters._date.override(typeof moment === 'function' ? {
        _id: 'moment',
        formats: function() {
            return FORMATS;
        },
        parse: function(value, format) {
            if (typeof value === 'string' && typeof format === 'string') value = moment(value, format);
            else if (!(value instanceof moment)) value = moment(value);
            return value.isValid() ? value.valueOf() : null;
        },
        format: function(time, format) {
            return moment(time).format(format);
        },
        add: function(time, amount, unit) {
            return moment(time).add(amount, unit).valueOf();
        },
        diff: function(max, min, unit) {
            return moment(max).diff(moment(min), unit);
        },
        startOf: function(time, unit, weekday) {
            time = moment(time);
            if (unit === 'isoWeek') return time.isoWeekday(weekday).valueOf();
            return time.startOf(unit).valueOf();
        },
        endOf: function(time, unit) {
            return moment(time).endOf(unit).valueOf();
        },
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(time) {
            return moment(time);
        }
    } : {});
    core_defaults._set('global', {
        plugins: {
            filler: {
                propagate: true
            }
        }
    });
    var mappers = {
        dataset: function(source) {
            var index = source.fill;
            var chart = source.chart;
            var meta = chart.getDatasetMeta(index);
            var visible = meta && chart.isDatasetVisible(index);
            var points = visible && meta.dataset._children || [];
            var length = points.length || 0;
            return !length ? null : function(point, i) {
                return i < length && points[i]._view || null;
            };
        },
        boundary: function(source) {
            var boundary = source.boundary;
            var x = boundary ? boundary.x : null;
            var y = boundary ? boundary.y : null;
            if (helpers$1.isArray(boundary)) return function(point, i) {
                return boundary[i];
            };
            return function(point) {
                return {
                    x: x === null ? point.x : x,
                    y: y === null ? point.y : y
                };
            };
        }
    };
    // @todo if (fill[0] === '#')
    function decodeFill(el, index, count) {
        var model = el._model || {};
        var fill = model.fill;
        var target;
        if (fill === undefined) fill = !!model.backgroundColor;
        if (fill === false || fill === null) return false;
        if (fill === true) return 'origin';
        target = parseFloat(fill, 10);
        if (isFinite(target) && Math.floor(target) === target) {
            if (fill[0] === '-' || fill[0] === '+') target = index + target;
            if (target === index || target < 0 || target >= count) return false;
            return target;
        }
        switch(fill){
            // compatibility
            case 'bottom':
                return 'start';
            case 'top':
                return 'end';
            case 'zero':
                return 'origin';
            // supported boundaries
            case 'origin':
            case 'start':
            case 'end':
                return fill;
            // invalid fill values
            default:
                return false;
        }
    }
    function computeLinearBoundary(source) {
        var model = source.el._model || {};
        var scale = source.el._scale || {};
        var fill = source.fill;
        var target = null;
        var horizontal;
        if (isFinite(fill)) return null;
        // Backward compatibility: until v3, we still need to support boundary values set on
        // the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
        // controllers might still use it (e.g. the Smith chart).
        if (fill === 'start') target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
        else if (fill === 'end') target = model.scaleTop === undefined ? scale.top : model.scaleTop;
        else if (model.scaleZero !== undefined) target = model.scaleZero;
        else if (scale.getBasePixel) target = scale.getBasePixel();
        if (target !== undefined && target !== null) {
            if (target.x !== undefined && target.y !== undefined) return target;
            if (helpers$1.isFinite(target)) {
                horizontal = scale.isHorizontal();
                return {
                    x: horizontal ? target : null,
                    y: horizontal ? null : target
                };
            }
        }
        return null;
    }
    function computeCircularBoundary(source) {
        var scale = source.el._scale;
        var options = scale.options;
        var length = scale.chart.data.labels.length;
        var fill = source.fill;
        var target = [];
        var start, end, center, i, point;
        if (!length) return null;
        start = options.ticks.reverse ? scale.max : scale.min;
        end = options.ticks.reverse ? scale.min : scale.max;
        center = scale.getPointPositionForValue(0, start);
        for(i = 0; i < length; ++i){
            point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
            if (options.gridLines.circular) {
                point.cx = center.x;
                point.cy = center.y;
                point.angle = scale.getIndexAngle(i) - Math.PI / 2;
            }
            target.push(point);
        }
        return target;
    }
    function computeBoundary(source) {
        var scale = source.el._scale || {};
        if (scale.getPointPositionForValue) return computeCircularBoundary(source);
        return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
        var source = sources[index];
        var fill = source.fill;
        var visited = [
            index
        ];
        var target;
        if (!propagate) return fill;
        while(fill !== false && visited.indexOf(fill) === -1){
            if (!isFinite(fill)) return fill;
            target = sources[fill];
            if (!target) return false;
            if (target.visible) return fill;
            visited.push(fill);
            fill = target.fill;
        }
        return false;
    }
    function createMapper(source) {
        var fill = source.fill;
        var type = 'dataset';
        if (fill === false) return null;
        if (!isFinite(fill)) type = 'boundary';
        return mappers[type](source);
    }
    function isDrawable(point) {
        return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
        var i, cx, cy, r;
        if (!len0 || !len1) return;
        // building first area curve (normal)
        ctx.moveTo(curve0[0].x, curve0[0].y);
        for(i = 1; i < len0; ++i)helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
        if (curve1[0].angle !== undefined) {
            cx = curve1[0].cx;
            cy = curve1[0].cy;
            r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
            for(i = len1 - 1; i > 0; --i)ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
            return;
        }
        // joining the two area curves
        ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
        // building opposite area curve (reverse)
        for(i = len1 - 1; i > 0; --i)helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
    }
    function doFill(ctx, points, mapper, view, color, loop) {
        var count = points.length;
        var span = view.spanGaps;
        var curve0 = [];
        var curve1 = [];
        var len0 = 0;
        var len1 = 0;
        var i, ilen, index, p0, p1, d0, d1, loopOffset;
        ctx.beginPath();
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i % count;
            p0 = points[index]._view;
            p1 = mapper(p0, index, view);
            d0 = isDrawable(p0);
            d1 = isDrawable(p1);
            if (loop && loopOffset === undefined && d0) {
                loopOffset = i + 1;
                ilen = count + loopOffset;
            }
            if (d0 && d1) {
                len0 = curve0.push(p0);
                len1 = curve1.push(p1);
            } else if (len0 && len1) {
                if (!span) {
                    drawArea(ctx, curve0, curve1, len0, len1);
                    len0 = len1 = 0;
                    curve0 = [];
                    curve1 = [];
                } else {
                    if (d0) curve0.push(p0);
                    if (d1) curve1.push(p1);
                }
            }
        }
        drawArea(ctx, curve0, curve1, len0, len1);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
    }
    var plugin_filler = {
        id: 'filler',
        afterDatasetsUpdate: function(chart, options) {
            var count = (chart.data.datasets || []).length;
            var propagate = options.propagate;
            var sources = [];
            var meta, i, el, source;
            for(i = 0; i < count; ++i){
                meta = chart.getDatasetMeta(i);
                el = meta.dataset;
                source = null;
                if (el && el._model && el instanceof elements.Line) source = {
                    visible: chart.isDatasetVisible(i),
                    fill: decodeFill(el, i, count),
                    chart: chart,
                    el: el
                };
                meta.$filler = source;
                sources.push(source);
            }
            for(i = 0; i < count; ++i){
                source = sources[i];
                if (!source) continue;
                source.fill = resolveTarget(sources, i, propagate);
                source.boundary = computeBoundary(source);
                source.mapper = createMapper(source);
            }
        },
        beforeDatasetsDraw: function(chart) {
            var metasets = chart._getSortedVisibleDatasetMetas();
            var ctx = chart.ctx;
            var meta, i, el, view, points, mapper, color;
            for(i = metasets.length - 1; i >= 0; --i){
                meta = metasets[i].$filler;
                if (!meta || !meta.visible) continue;
                el = meta.el;
                view = el._view;
                points = el._children || [];
                mapper = meta.mapper;
                color = view.backgroundColor || core_defaults.global.defaultColor;
                if (mapper && color && points.length) {
                    helpers$1.canvas.clipArea(ctx, chart.chartArea);
                    doFill(ctx, points, mapper, view, color, el._loop);
                    helpers$1.canvas.unclipArea(ctx);
                }
            }
        }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set('global', {
        legend: {
            display: true,
            position: 'top',
            align: 'center',
            fullWidth: true,
            reverse: false,
            weight: 1000,
            // a callback that will handle
            onClick: function(e, legendItem) {
                var index = legendItem.datasetIndex;
                var ci = this.chart;
                var meta = ci.getDatasetMeta(index);
                // See controller.isDatasetVisible comment
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                // We hid a dataset ... rerender the chart
                ci.update();
            },
            onHover: null,
            onLeave: null,
            labels: {
                boxWidth: 40,
                padding: 10,
                // Generates labels shown in the legend
                // Valid properties to return:
                // text : text to display
                // fillStyle : fill of coloured box
                // strokeStyle: stroke of coloured box
                // hidden : if this legend item refers to a hidden item
                // lineCap : cap style for line
                // lineDash
                // lineDashOffset :
                // lineJoin :
                // lineWidth :
                generateLabels: function(chart) {
                    var datasets = chart.data.datasets;
                    var options = chart.options.legend || {};
                    var usePointStyle = options.labels && options.labels.usePointStyle;
                    return chart._getSortedDatasetMetas().map(function(meta) {
                        var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                        return {
                            text: datasets[meta.index].label,
                            fillStyle: style.backgroundColor,
                            hidden: !chart.isDatasetVisible(meta.index),
                            lineCap: style.borderCapStyle,
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            pointStyle: style.pointStyle,
                            rotation: style.rotation,
                            // Below is extra data used for toggling the datasets
                            datasetIndex: meta.index
                        };
                    }, this);
                }
            }
        },
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var datasets = chart.data.datasets;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
                if (datasets[i].label) listItem.appendChild(document.createTextNode(datasets[i].label));
            }
            return list.outerHTML;
        }
    });
    /**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */ function getBoxWidth(labelOpts, fontSize) {
        return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Legend = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
            /**
 		 * @private
 		 */ me._hoveredItem = null;
            // Are we in doughnut mode which has a different data type
            me.doughnutMode = false;
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        // Any function defined here is inherited by all legend types.
        // Any function can be extended by the legend type
        beforeUpdate: noop$1,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$1,
        //
        beforeSetDimensions: noop$1,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$1,
        //
        beforeBuildLabels: noop$1,
        buildLabels: function() {
            var me = this;
            var labelOpts = me.options.labels || {};
            var legendItems = helpers$1.callback(labelOpts.generateLabels, [
                me.chart
            ], me) || [];
            if (labelOpts.filter) legendItems = legendItems.filter(function(item) {
                return labelOpts.filter(item, me.chart.data);
            });
            if (me.options.reverse) legendItems.reverse();
            me.legendItems = legendItems;
        },
        afterBuildLabels: noop$1,
        //
        beforeFit: noop$1,
        fit: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var display = opts.display;
            var ctx = me.ctx;
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            // Reset hit boxes
            var hitboxes = me.legendHitBoxes = [];
            var minSize = me.minSize;
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) {
                minSize.width = me.maxWidth; // fill all the width
                minSize.height = display ? 10 : 0;
            } else {
                minSize.width = display ? 10 : 0;
                minSize.height = me.maxHeight; // fill all the height
            }
            // Increase sizes here
            if (!display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            ctx.font = labelFont.string;
            if (isHorizontal) {
                // Labels
                // Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
                var lineWidths = me.lineWidths = [
                    0
                ];
                var totalHeight = 0;
                ctx.textAlign = 'left';
                ctx.textBaseline = 'middle';
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
                        totalHeight += fontSize + labelOpts.padding;
                        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                    }
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: width,
                        height: fontSize
                    };
                    lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
                });
                minSize.height += totalHeight;
            } else {
                var vPadding = labelOpts.padding;
                var columnWidths = me.columnWidths = [];
                var columnHeights = me.columnHeights = [];
                var totalWidth = labelOpts.padding;
                var currentColWidth = 0;
                var currentColHeight = 0;
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    // If too tall, go to new column
                    if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
                        totalWidth += currentColWidth + labelOpts.padding;
                        columnWidths.push(currentColWidth); // previous column width
                        columnHeights.push(currentColHeight);
                        currentColWidth = 0;
                        currentColHeight = 0;
                    }
                    // Get max width
                    currentColWidth = Math.max(currentColWidth, itemWidth);
                    currentColHeight += fontSize + vPadding;
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: itemWidth,
                        height: fontSize
                    };
                });
                totalWidth += currentColWidth;
                columnWidths.push(currentColWidth);
                columnHeights.push(currentColHeight);
                minSize.width += totalWidth;
            }
            me.width = minSize.width;
            me.height = minSize.height;
        },
        afterFit: noop$1,
        // Shared Methods
        isHorizontal: function() {
            return this.options.position === 'top' || this.options.position === 'bottom';
        },
        // Actually draw the legend on the canvas
        draw: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor;
            var lineDefault = globalDefaults.elements.line;
            var legendHeight = me.height;
            var columnHeights = me.columnHeights;
            var legendWidth = me.width;
            var lineWidths = me.lineWidths;
            if (!opts.display) return;
            var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
            var ctx = me.ctx;
            var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            var cursor;
            // Canvas setup
            ctx.textAlign = rtlHelper.textAlign('left');
            ctx.textBaseline = 'middle';
            ctx.lineWidth = 0.5;
            ctx.strokeStyle = fontColor; // for strikethrough effect
            ctx.fillStyle = fontColor; // render in correct colour
            ctx.font = labelFont.string;
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var hitboxes = me.legendHitBoxes;
            // current position
            var drawLegendBox = function(x, y, legendItem) {
                if (isNaN(boxWidth) || boxWidth <= 0) return;
                // Set the ctx for the box
                ctx.save();
                var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
                ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
                ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
                ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
                ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
                if (ctx.setLineDash) // IE 9 and 10 do not support line dash
                ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
                if (labelOpts && labelOpts.usePointStyle) {
                    // Recalculate x and y for drawPoint() because its expecting
                    // x and y to be center of figure (instead of top left)
                    var radius = boxWidth * Math.SQRT2 / 2;
                    var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                    var centerY = y + fontSize / 2;
                    // Draw pointStyle as legend symbol
                    helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
                } else {
                    // Draw box as legend symbol
                    ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                    if (lineWidth !== 0) ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                }
                ctx.restore();
            };
            var fillText = function(x, y, legendItem, textWidth) {
                var halfFontSize = fontSize / 2;
                var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
                var yMiddle = y + halfFontSize;
                ctx.fillText(legendItem.text, xLeft, yMiddle);
                if (legendItem.hidden) {
                    // Strikethrough the text if hidden
                    ctx.beginPath();
                    ctx.lineWidth = 2;
                    ctx.moveTo(xLeft, yMiddle);
                    ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
                    ctx.stroke();
                }
            };
            var alignmentOffset = function(dimension, blockSize) {
                switch(opts.align){
                    case 'start':
                        return labelOpts.padding;
                    case 'end':
                        return dimension - blockSize;
                    default:
                        return (dimension - blockSize + labelOpts.padding) / 2;
                }
            };
            // Horizontal
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) cursor = {
                x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
                y: me.top + labelOpts.padding,
                line: 0
            };
            else cursor = {
                x: me.left + labelOpts.padding,
                y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
                line: 0
            };
            helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
            var itemHeight = fontSize + labelOpts.padding;
            helpers$1.each(me.legendItems, function(legendItem, i) {
                var textWidth = ctx.measureText(legendItem.text).width;
                var width = boxWidth + fontSize / 2 + textWidth;
                var x = cursor.x;
                var y = cursor.y;
                rtlHelper.setWidth(me.minSize.width);
                // Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
                // instead of me.right and me.bottom because me.width and me.height
                // may have been changed since me.minSize was calculated
                if (isHorizontal) {
                    if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
                        y = cursor.y += itemHeight;
                        cursor.line++;
                        x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
                    }
                } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
                    x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
                    cursor.line++;
                    y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
                }
                var realX = rtlHelper.x(x);
                drawLegendBox(realX, y, legendItem);
                hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
                hitboxes[i].top = y;
                // Fill the actual label
                fillText(realX, y, legendItem, textWidth);
                if (isHorizontal) cursor.x += width + labelOpts.padding;
                else cursor.y += itemHeight;
            });
            helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
        },
        /**
	 * @private
	 */ _getLegendItemAt: function(x, y) {
            var me = this;
            var i, hitBox, lh;
            if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
                // See if we are touching one of the dataset boxes
                lh = me.legendHitBoxes;
                for(i = 0; i < lh.length; ++i){
                    hitBox = lh[i];
                    if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) // Touching an element
                    return me.legendItems[i];
                }
            }
            return null;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */ handleEvent: function(e) {
            var me = this;
            var opts = me.options;
            var type = e.type === 'mouseup' ? 'click' : e.type;
            var hoveredItem;
            if (type === 'mousemove') {
                if (!opts.onHover && !opts.onLeave) return;
            } else if (type === 'click') {
                if (!opts.onClick) return;
            } else return;
            // Chart event already has relative position in it
            hoveredItem = me._getLegendItemAt(e.x, e.y);
            if (type === 'click') {
                if (hoveredItem && opts.onClick) // use e.native for backwards compatibility
                opts.onClick.call(me, e.native, hoveredItem);
            } else {
                if (opts.onLeave && hoveredItem !== me._hoveredItem) {
                    if (me._hoveredItem) opts.onLeave.call(me, e.native, me._hoveredItem);
                    me._hoveredItem = hoveredItem;
                }
                if (opts.onHover && hoveredItem) // use e.native for backwards compatibility
                opts.onHover.call(me, e.native, hoveredItem);
            }
        }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
        var legend = new Legend({
            ctx: chart.ctx,
            options: legendOpts,
            chart: chart
        });
        core_layouts.configure(chart, legend, legendOpts);
        core_layouts.addBox(chart, legend);
        chart.legend = legend;
    }
    var plugin_legend = {
        id: 'legend',
        /**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Legend,
        beforeInit: function(chart) {
            var legendOpts = chart.options.legend;
            if (legendOpts) createNewLegendAndAttach(chart, legendOpts);
        },
        beforeUpdate: function(chart) {
            var legendOpts = chart.options.legend;
            var legend = chart.legend;
            if (legendOpts) {
                helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
                if (legend) {
                    core_layouts.configure(chart, legend, legendOpts);
                    legend.options = legendOpts;
                } else createNewLegendAndAttach(chart, legendOpts);
            } else if (legend) {
                core_layouts.removeBox(chart, legend);
                delete chart.legend;
            }
        },
        afterEvent: function(chart, e) {
            var legend = chart.legend;
            if (legend) legend.handleEvent(e);
        }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set('global', {
        title: {
            display: false,
            fontStyle: 'bold',
            fullWidth: true,
            padding: 10,
            position: 'top',
            text: '',
            weight: 2000 // by default greater than legend (1000) to be above
        }
    });
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Title = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        beforeUpdate: noop$2,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$2,
        //
        beforeSetDimensions: noop$2,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$2,
        //
        beforeBuildLabels: noop$2,
        buildLabels: noop$2,
        afterBuildLabels: noop$2,
        //
        beforeFit: noop$2,
        fit: function() {
            var me = this;
            var opts = me.options;
            var minSize = me.minSize = {};
            var isHorizontal = me.isHorizontal();
            var lineCount, textSize;
            if (!opts.display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
            textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
            me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
            me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
        },
        afterFit: noop$2,
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === 'top' || pos === 'bottom';
        },
        // Actually draw the title block on the canvas
        draw: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            if (!opts.display) return;
            var fontOpts = helpers$1.options._parseFont(opts);
            var lineHeight = fontOpts.lineHeight;
            var offset = lineHeight / 2 + opts.padding;
            var rotation = 0;
            var top = me.top;
            var left = me.left;
            var bottom = me.bottom;
            var right = me.right;
            var maxWidth, titleX, titleY;
            ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
            ctx.font = fontOpts.string;
            // Horizontal
            if (me.isHorizontal()) {
                titleX = left + (right - left) / 2; // midpoint of the width
                titleY = top + offset;
                maxWidth = right - left;
            } else {
                titleX = opts.position === 'left' ? left + offset : right - offset;
                titleY = top + (bottom - top) / 2;
                maxWidth = bottom - top;
                rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
            }
            ctx.save();
            ctx.translate(titleX, titleY);
            ctx.rotate(rotation);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var text = opts.text;
            if (helpers$1.isArray(text)) {
                var y = 0;
                for(var i = 0; i < text.length; ++i){
                    ctx.fillText(text[i], 0, y, maxWidth);
                    y += lineHeight;
                }
            } else ctx.fillText(text, 0, 0, maxWidth);
            ctx.restore();
        }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
        var title = new Title({
            ctx: chart.ctx,
            options: titleOpts,
            chart: chart
        });
        core_layouts.configure(chart, title, titleOpts);
        core_layouts.addBox(chart, title);
        chart.titleBlock = title;
    }
    var plugin_title = {
        id: 'title',
        /**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Title,
        beforeInit: function(chart) {
            var titleOpts = chart.options.title;
            if (titleOpts) createNewTitleBlockAndAttach(chart, titleOpts);
        },
        beforeUpdate: function(chart) {
            var titleOpts = chart.options.title;
            var titleBlock = chart.titleBlock;
            if (titleOpts) {
                helpers$1.mergeIf(titleOpts, core_defaults.global.title);
                if (titleBlock) {
                    core_layouts.configure(chart, titleBlock, titleOpts);
                    titleBlock.options = titleOpts;
                } else createNewTitleBlockAndAttach(chart, titleOpts);
            } else if (titleBlock) {
                core_layouts.removeBox(chart, titleBlock);
                delete chart.titleBlock;
            }
        }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    /**
 * @namespace Chart
 */ core_controller.helpers = helpers$1;
    // @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    // Register built-in scales
    core_controller.helpers.each(scales, function(scale, type) {
        core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    // Load to register built-in adapters (as side effects)
    // Loading built-in plugins
    for(var k in plugins)if (plugins.hasOwnProperty(k)) core_controller.plugins.register(plugins[k]);
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== 'undefined') window.Chart = core_controller;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ core_controller.Chart = core_controller;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Legend = plugins.legend._element;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Title = plugins.title._element;
    /**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.pluginService = core_controller.plugins;
    /**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */ core_controller.PluginBase = core_controller.Element.extend({});
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ core_controller.canvasHelpers = core_controller.helpers.canvas;
    /**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */ core_controller.layoutService = core_controller.layouts;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ core_controller.LinearScaleBase = scale_linearbase;
    /**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */ core_controller.helpers.each([
        'Bar',
        'Bubble',
        'Doughnut',
        'Line',
        'PolarArea',
        'Radar',
        'Scatter'
    ], function(klass) {
        core_controller[klass] = function(ctx, cfg) {
            return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
                type: klass.charAt(0).toLowerCase() + klass.slice(1)
            }));
        };
    });
    return src;
});

});
parcelRegister("g8ofX", function(module, exports) {
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias('month', 'M');
    // PRIORITY
    addUnitPriority('month', 8);
    // PARSING
    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // ALIASES
    addUnitAlias('year', 'y');
    // PRIORITIES
    addUnitPriority('year', 1);
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // ALIASES
    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');
    // PRIORITIES
    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);
    // PARSING
    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // ALIASES
    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');
    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // ALIASES
    addUnitAlias('hour', 'h');
    // PRIORITY
    addUnitPriority('hour', 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');
    // PRIORITY
    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // ALIASES
    addUnitAlias('quarter', 'Q');
    // PRIORITY
    addUnitPriority('quarter', 7);
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // ALIASES
    addUnitAlias('date', 'D');
    // PRIORITY
    addUnitPriority('date', 9);
    // PARSING
    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // ALIASES
    addUnitAlias('dayOfYear', 'DDD');
    // PRIORITY
    addUnitPriority('dayOfYear', 4);
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // ALIASES
    addUnitAlias('minute', 'm');
    // PRIORITY
    addUnitPriority('minute', 14);
    // PARSING
    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // ALIASES
    addUnitAlias('second', 's');
    // PRIORITY
    addUnitPriority('second', 15);
    // PARSING
    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias('millisecond', 'ms');
    // PRIORITY
    addUnitPriority('millisecond', 16);
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y');
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.29.4';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});


parcelRegister("gjhmZ", function(module, exports) {

var $iuoc7 = parcelRequire("iuoc7");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $0310732d5e9cf3b7$var$isEqual(value, other) {
    return $iuoc7(value, other);
}
module.exports = $0310732d5e9cf3b7$var$isEqual;

});
parcelRegister("iuoc7", function(module, exports) {

var $1wRNr = parcelRequire("1wRNr");

var $3QXiR = parcelRequire("3QXiR");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $d75dcbdbcb1cd97a$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$3QXiR(value) && !$3QXiR(other)) return value !== value && other !== other;
    return $1wRNr(value, other, bitmask, customizer, $d75dcbdbcb1cd97a$var$baseIsEqual, stack);
}
module.exports = $d75dcbdbcb1cd97a$var$baseIsEqual;

});
parcelRegister("1wRNr", function(module, exports) {

var $dcnjY = parcelRequire("dcnjY");

var $hucwe = parcelRequire("hucwe");

var $9NjJG = parcelRequire("9NjJG");

var $hh6fJ = parcelRequire("hh6fJ");

var $lEt5c = parcelRequire("lEt5c");

var $eDxI3 = parcelRequire("eDxI3");

var $cgpOl = parcelRequire("cgpOl");

var $3BgbH = parcelRequire("3BgbH");
/** Used to compose bitmasks for value comparisons. */ var $11d282705bacd274$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $11d282705bacd274$var$argsTag = '[object Arguments]', $11d282705bacd274$var$arrayTag = '[object Array]', $11d282705bacd274$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $11d282705bacd274$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $11d282705bacd274$var$hasOwnProperty = $11d282705bacd274$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $11d282705bacd274$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $eDxI3(object), othIsArr = $eDxI3(other), objTag = objIsArr ? $11d282705bacd274$var$arrayTag : $lEt5c(object), othTag = othIsArr ? $11d282705bacd274$var$arrayTag : $lEt5c(other);
    objTag = objTag == $11d282705bacd274$var$argsTag ? $11d282705bacd274$var$objectTag : objTag;
    othTag = othTag == $11d282705bacd274$var$argsTag ? $11d282705bacd274$var$objectTag : othTag;
    var objIsObj = objTag == $11d282705bacd274$var$objectTag, othIsObj = othTag == $11d282705bacd274$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $cgpOl(object)) {
        if (!$cgpOl(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $dcnjY);
        return objIsArr || $3BgbH(object) ? $hucwe(object, other, bitmask, customizer, equalFunc, stack) : $9NjJG(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $11d282705bacd274$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $11d282705bacd274$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $11d282705bacd274$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $dcnjY);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $dcnjY);
    return $hh6fJ(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $11d282705bacd274$var$baseIsEqualDeep;

});
parcelRegister("dcnjY", function(module, exports) {

var $kCvOH = parcelRequire("kCvOH");

var $9AyaM = parcelRequire("9AyaM");

var $6qFN3 = parcelRequire("6qFN3");

var $34kwZ = parcelRequire("34kwZ");

var $bHdTu = parcelRequire("bHdTu");

var $en1k1 = parcelRequire("en1k1");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $99be7c713d19a495$var$Stack(entries) {
    var data = this.__data__ = new $kCvOH(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$99be7c713d19a495$var$Stack.prototype.clear = $9AyaM;
$99be7c713d19a495$var$Stack.prototype['delete'] = $6qFN3;
$99be7c713d19a495$var$Stack.prototype.get = $34kwZ;
$99be7c713d19a495$var$Stack.prototype.has = $bHdTu;
$99be7c713d19a495$var$Stack.prototype.set = $en1k1;
module.exports = $99be7c713d19a495$var$Stack;

});
parcelRegister("kCvOH", function(module, exports) {

var $jPAyB = parcelRequire("jPAyB");

var $1nomV = parcelRequire("1nomV");

var $ioLnh = parcelRequire("ioLnh");

var $fP9uO = parcelRequire("fP9uO");

var $cwFGv = parcelRequire("cwFGv");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f030096663f19f57$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f030096663f19f57$var$ListCache.prototype.clear = $jPAyB;
$f030096663f19f57$var$ListCache.prototype['delete'] = $1nomV;
$f030096663f19f57$var$ListCache.prototype.get = $ioLnh;
$f030096663f19f57$var$ListCache.prototype.has = $fP9uO;
$f030096663f19f57$var$ListCache.prototype.set = $cwFGv;
module.exports = $f030096663f19f57$var$ListCache;

});
parcelRegister("jPAyB", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $e6ff233da6fa7110$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $e6ff233da6fa7110$var$listCacheClear;

});

parcelRegister("1nomV", function(module, exports) {

var $iGI8b = parcelRequire("iGI8b");
/** Used for built-in method references. */ var $100ad7919e7abf2c$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $100ad7919e7abf2c$var$splice = $100ad7919e7abf2c$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $100ad7919e7abf2c$var$listCacheDelete(key) {
    var data = this.__data__, index = $iGI8b(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $100ad7919e7abf2c$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $100ad7919e7abf2c$var$listCacheDelete;

});
parcelRegister("iGI8b", function(module, exports) {

var $dtDa7 = parcelRequire("dtDa7");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d9ae61bf047b4bee$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($dtDa7(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $d9ae61bf047b4bee$var$assocIndexOf;

});
parcelRegister("dtDa7", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $9cfc5c99b5603f1d$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $9cfc5c99b5603f1d$var$eq;

});



parcelRegister("ioLnh", function(module, exports) {

var $iGI8b = parcelRequire("iGI8b");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d64f377419462001$var$listCacheGet(key) {
    var data = this.__data__, index = $iGI8b(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $d64f377419462001$var$listCacheGet;

});

parcelRegister("fP9uO", function(module, exports) {

var $iGI8b = parcelRequire("iGI8b");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b852fc2469a2862c$var$listCacheHas(key) {
    return $iGI8b(this.__data__, key) > -1;
}
module.exports = $b852fc2469a2862c$var$listCacheHas;

});

parcelRegister("cwFGv", function(module, exports) {

var $iGI8b = parcelRequire("iGI8b");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $91e8cedec130617e$var$listCacheSet(key, value) {
    var data = this.__data__, index = $iGI8b(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $91e8cedec130617e$var$listCacheSet;

});


parcelRegister("9AyaM", function(module, exports) {

var $kCvOH = parcelRequire("kCvOH");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $6fb1fbde2b18adca$var$stackClear() {
    this.__data__ = new $kCvOH;
    this.size = 0;
}
module.exports = $6fb1fbde2b18adca$var$stackClear;

});

parcelRegister("6qFN3", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4ae5967858666359$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $4ae5967858666359$var$stackDelete;

});

parcelRegister("34kwZ", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $23c1abdcda93d08d$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $23c1abdcda93d08d$var$stackGet;

});

parcelRegister("bHdTu", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $883e7cec6d5cd9ea$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $883e7cec6d5cd9ea$var$stackHas;

});

parcelRegister("en1k1", function(module, exports) {

var $kCvOH = parcelRequire("kCvOH");

var $4xUue = parcelRequire("4xUue");

var $3AbE3 = parcelRequire("3AbE3");
/** Used as the size to enable large array optimizations. */ var $a7643d2a8bcffb08$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $a7643d2a8bcffb08$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $kCvOH) {
        var pairs = data.__data__;
        if (!$4xUue || pairs.length < $a7643d2a8bcffb08$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $3AbE3(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $a7643d2a8bcffb08$var$stackSet;

});
parcelRegister("4xUue", function(module, exports) {

var $6wce3 = parcelRequire("6wce3");

var $iX8FQ = parcelRequire("iX8FQ");
/* Built-in method references that are verified to be native. */ var $34f60f9298f2d732$var$Map = $6wce3($iX8FQ, 'Map');
module.exports = $34f60f9298f2d732$var$Map;

});
parcelRegister("6wce3", function(module, exports) {

var $bNTJ8 = parcelRequire("bNTJ8");

var $ctG8m = parcelRequire("ctG8m");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $4bef37002d460743$var$getNative(object, key) {
    var value = $ctG8m(object, key);
    return $bNTJ8(value) ? value : undefined;
}
module.exports = $4bef37002d460743$var$getNative;

});
parcelRegister("bNTJ8", function(module, exports) {

var $cRBs5 = parcelRequire("cRBs5");

var $bFcak = parcelRequire("bFcak");

var $6oQC7 = parcelRequire("6oQC7");

var $biRZH = parcelRequire("biRZH");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $897f7f89de0e0498$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $897f7f89de0e0498$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $897f7f89de0e0498$var$funcProto = Function.prototype, $897f7f89de0e0498$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $897f7f89de0e0498$var$funcToString = $897f7f89de0e0498$var$funcProto.toString;
/** Used to check objects for own properties. */ var $897f7f89de0e0498$var$hasOwnProperty = $897f7f89de0e0498$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $897f7f89de0e0498$var$reIsNative = RegExp('^' + $897f7f89de0e0498$var$funcToString.call($897f7f89de0e0498$var$hasOwnProperty).replace($897f7f89de0e0498$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $897f7f89de0e0498$var$baseIsNative(value) {
    if (!$6oQC7(value) || $bFcak(value)) return false;
    var pattern = $cRBs5(value) ? $897f7f89de0e0498$var$reIsNative : $897f7f89de0e0498$var$reIsHostCtor;
    return pattern.test($biRZH(value));
}
module.exports = $897f7f89de0e0498$var$baseIsNative;

});
parcelRegister("cRBs5", function(module, exports) {

var $lMPeG = parcelRequire("lMPeG");

var $6oQC7 = parcelRequire("6oQC7");
/** `Object#toString` result references. */ var $95d77c725b29eea4$var$asyncTag = '[object AsyncFunction]', $95d77c725b29eea4$var$funcTag = '[object Function]', $95d77c725b29eea4$var$genTag = '[object GeneratorFunction]', $95d77c725b29eea4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $95d77c725b29eea4$var$isFunction(value) {
    if (!$6oQC7(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $lMPeG(value);
    return tag == $95d77c725b29eea4$var$funcTag || tag == $95d77c725b29eea4$var$genTag || tag == $95d77c725b29eea4$var$asyncTag || tag == $95d77c725b29eea4$var$proxyTag;
}
module.exports = $95d77c725b29eea4$var$isFunction;

});
parcelRegister("lMPeG", function(module, exports) {

var $2ECfn = parcelRequire("2ECfn");

var $h3Rmk = parcelRequire("h3Rmk");

var $2h5az = parcelRequire("2h5az");
/** `Object#toString` result references. */ var $fdc5d30926f01725$var$nullTag = '[object Null]', $fdc5d30926f01725$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $fdc5d30926f01725$var$symToStringTag = $2ECfn ? $2ECfn.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $fdc5d30926f01725$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $fdc5d30926f01725$var$undefinedTag : $fdc5d30926f01725$var$nullTag;
    return $fdc5d30926f01725$var$symToStringTag && $fdc5d30926f01725$var$symToStringTag in Object(value) ? $h3Rmk(value) : $2h5az(value);
}
module.exports = $fdc5d30926f01725$var$baseGetTag;

});
parcelRegister("2ECfn", function(module, exports) {

var $iX8FQ = parcelRequire("iX8FQ");
/** Built-in value references. */ var $1eecfc3f993eaf48$var$Symbol = $iX8FQ.Symbol;
module.exports = $1eecfc3f993eaf48$var$Symbol;

});
parcelRegister("iX8FQ", function(module, exports) {

var $baR0X = parcelRequire("baR0X");
/** Detect free variable `self`. */ var $dcc47725fe431e04$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $dcc47725fe431e04$var$root = $baR0X || $dcc47725fe431e04$var$freeSelf || Function('return this')();
module.exports = $dcc47725fe431e04$var$root;

});
parcelRegister("baR0X", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $8229c06cdd74689c$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $8229c06cdd74689c$var$freeGlobal;

});



parcelRegister("h3Rmk", function(module, exports) {

var $2ECfn = parcelRequire("2ECfn");
/** Used for built-in method references. */ var $c6bc1b7c1676dd6e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c6bc1b7c1676dd6e$var$hasOwnProperty = $c6bc1b7c1676dd6e$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c6bc1b7c1676dd6e$var$nativeObjectToString = $c6bc1b7c1676dd6e$var$objectProto.toString;
/** Built-in value references. */ var $c6bc1b7c1676dd6e$var$symToStringTag = $2ECfn ? $2ECfn.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $c6bc1b7c1676dd6e$var$getRawTag(value) {
    var isOwn = $c6bc1b7c1676dd6e$var$hasOwnProperty.call(value, $c6bc1b7c1676dd6e$var$symToStringTag), tag = value[$c6bc1b7c1676dd6e$var$symToStringTag];
    try {
        value[$c6bc1b7c1676dd6e$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $c6bc1b7c1676dd6e$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$c6bc1b7c1676dd6e$var$symToStringTag] = tag;
        else delete value[$c6bc1b7c1676dd6e$var$symToStringTag];
    }
    return result;
}
module.exports = $c6bc1b7c1676dd6e$var$getRawTag;

});

parcelRegister("2h5az", function(module, exports) {
/** Used for built-in method references. */ var $1a812de160c3ca23$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1a812de160c3ca23$var$nativeObjectToString = $1a812de160c3ca23$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $1a812de160c3ca23$var$objectToString(value) {
    return $1a812de160c3ca23$var$nativeObjectToString.call(value);
}
module.exports = $1a812de160c3ca23$var$objectToString;

});


parcelRegister("6oQC7", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4a8dcbfcd7d0edbe$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $4a8dcbfcd7d0edbe$var$isObject;

});


parcelRegister("bFcak", function(module, exports) {

var $9hwgr = parcelRequire("9hwgr");
/** Used to detect methods masquerading as native. */ var $87dcf5e0ab7db23c$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($9hwgr && $9hwgr.keys && $9hwgr.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $87dcf5e0ab7db23c$var$isMasked(func) {
    return !!$87dcf5e0ab7db23c$var$maskSrcKey && $87dcf5e0ab7db23c$var$maskSrcKey in func;
}
module.exports = $87dcf5e0ab7db23c$var$isMasked;

});
parcelRegister("9hwgr", function(module, exports) {

var $iX8FQ = parcelRequire("iX8FQ");
/** Used to detect overreaching core-js shims. */ var $6c1eba934e62f020$var$coreJsData = $iX8FQ["__core-js_shared__"];
module.exports = $6c1eba934e62f020$var$coreJsData;

});


parcelRegister("biRZH", function(module, exports) {
/** Used for built-in method references. */ var $83ab4246f8e50522$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $83ab4246f8e50522$var$funcToString = $83ab4246f8e50522$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $83ab4246f8e50522$var$toSource(func) {
    if (func != null) {
        try {
            return $83ab4246f8e50522$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $83ab4246f8e50522$var$toSource;

});


parcelRegister("ctG8m", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $9158e06088e48b24$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $9158e06088e48b24$var$getValue;

});



parcelRegister("3AbE3", function(module, exports) {

var $a2I90 = parcelRequire("a2I90");

var $47u4e = parcelRequire("47u4e");

var $234jL = parcelRequire("234jL");

var $g70mw = parcelRequire("g70mw");

var $4esNY = parcelRequire("4esNY");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $29bdc45acc135e73$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$29bdc45acc135e73$var$MapCache.prototype.clear = $a2I90;
$29bdc45acc135e73$var$MapCache.prototype['delete'] = $47u4e;
$29bdc45acc135e73$var$MapCache.prototype.get = $234jL;
$29bdc45acc135e73$var$MapCache.prototype.has = $g70mw;
$29bdc45acc135e73$var$MapCache.prototype.set = $4esNY;
module.exports = $29bdc45acc135e73$var$MapCache;

});
parcelRegister("a2I90", function(module, exports) {

var $jppS3 = parcelRequire("jppS3");

var $kCvOH = parcelRequire("kCvOH");

var $4xUue = parcelRequire("4xUue");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $74fc556eb0da4e83$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $jppS3,
        'map': new ($4xUue || $kCvOH),
        'string': new $jppS3
    };
}
module.exports = $74fc556eb0da4e83$var$mapCacheClear;

});
parcelRegister("jppS3", function(module, exports) {

var $8rJL7 = parcelRequire("8rJL7");

var $f9Wzr = parcelRequire("f9Wzr");

var $lYed7 = parcelRequire("lYed7");

var $dImY1 = parcelRequire("dImY1");

var $6NZ22 = parcelRequire("6NZ22");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e2146b8d643161ad$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$e2146b8d643161ad$var$Hash.prototype.clear = $8rJL7;
$e2146b8d643161ad$var$Hash.prototype['delete'] = $f9Wzr;
$e2146b8d643161ad$var$Hash.prototype.get = $lYed7;
$e2146b8d643161ad$var$Hash.prototype.has = $dImY1;
$e2146b8d643161ad$var$Hash.prototype.set = $6NZ22;
module.exports = $e2146b8d643161ad$var$Hash;

});
parcelRegister("8rJL7", function(module, exports) {

var $k3Wxb = parcelRequire("k3Wxb");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $62645719df3bd529$var$hashClear() {
    this.__data__ = $k3Wxb ? $k3Wxb(null) : {};
    this.size = 0;
}
module.exports = $62645719df3bd529$var$hashClear;

});
parcelRegister("k3Wxb", function(module, exports) {

var $6wce3 = parcelRequire("6wce3");
/* Built-in method references that are verified to be native. */ var $e9b17e1d945af58d$var$nativeCreate = $6wce3(Object, 'create');
module.exports = $e9b17e1d945af58d$var$nativeCreate;

});


parcelRegister("f9Wzr", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b09521338a0a67ed$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $b09521338a0a67ed$var$hashDelete;

});

parcelRegister("lYed7", function(module, exports) {

var $k3Wxb = parcelRequire("k3Wxb");
/** Used to stand-in for `undefined` hash values. */ var $ffea397f03a20d00$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $ffea397f03a20d00$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ffea397f03a20d00$var$hasOwnProperty = $ffea397f03a20d00$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ffea397f03a20d00$var$hashGet(key) {
    var data = this.__data__;
    if ($k3Wxb) {
        var result = data[key];
        return result === $ffea397f03a20d00$var$HASH_UNDEFINED ? undefined : result;
    }
    return $ffea397f03a20d00$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $ffea397f03a20d00$var$hashGet;

});

parcelRegister("dImY1", function(module, exports) {

var $k3Wxb = parcelRequire("k3Wxb");
/** Used for built-in method references. */ var $9fc1333bda6aa6ae$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9fc1333bda6aa6ae$var$hasOwnProperty = $9fc1333bda6aa6ae$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9fc1333bda6aa6ae$var$hashHas(key) {
    var data = this.__data__;
    return $k3Wxb ? data[key] !== undefined : $9fc1333bda6aa6ae$var$hasOwnProperty.call(data, key);
}
module.exports = $9fc1333bda6aa6ae$var$hashHas;

});

parcelRegister("6NZ22", function(module, exports) {

var $k3Wxb = parcelRequire("k3Wxb");
/** Used to stand-in for `undefined` hash values. */ var $4f46a95ad6933ac8$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $4f46a95ad6933ac8$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k3Wxb && value === undefined ? $4f46a95ad6933ac8$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $4f46a95ad6933ac8$var$hashSet;

});



parcelRegister("47u4e", function(module, exports) {

var $5NNaF = parcelRequire("5NNaF");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2fff239f532c7fbe$var$mapCacheDelete(key) {
    var result = $5NNaF(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $2fff239f532c7fbe$var$mapCacheDelete;

});
parcelRegister("5NNaF", function(module, exports) {

var $coZPE = parcelRequire("coZPE");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $4397abb20cd32921$var$getMapData(map, key) {
    var data = map.__data__;
    return $coZPE(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $4397abb20cd32921$var$getMapData;

});
parcelRegister("coZPE", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $9077b07b4c848f6f$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $9077b07b4c848f6f$var$isKeyable;

});



parcelRegister("234jL", function(module, exports) {

var $5NNaF = parcelRequire("5NNaF");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $17df36057b0b1208$var$mapCacheGet(key) {
    return $5NNaF(this, key).get(key);
}
module.exports = $17df36057b0b1208$var$mapCacheGet;

});

parcelRegister("g70mw", function(module, exports) {

var $5NNaF = parcelRequire("5NNaF");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bbad94b3ebfa52a4$var$mapCacheHas(key) {
    return $5NNaF(this, key).has(key);
}
module.exports = $bbad94b3ebfa52a4$var$mapCacheHas;

});

parcelRegister("4esNY", function(module, exports) {

var $5NNaF = parcelRequire("5NNaF");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $314ed04feaee1328$var$mapCacheSet(key, value) {
    var data = $5NNaF(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $314ed04feaee1328$var$mapCacheSet;

});




parcelRegister("hucwe", function(module, exports) {

var $geruL = parcelRequire("geruL");

var $gjwFf = parcelRequire("gjwFf");

var $94W1a = parcelRequire("94W1a");
/** Used to compose bitmasks for value comparisons. */ var $cbaef2fcbbe9056a$var$COMPARE_PARTIAL_FLAG = 1, $cbaef2fcbbe9056a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $cbaef2fcbbe9056a$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $cbaef2fcbbe9056a$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $cbaef2fcbbe9056a$var$COMPARE_UNORDERED_FLAG ? new $geruL : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$gjwFf(other, function(othValue, othIndex) {
                if (!$94W1a(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $cbaef2fcbbe9056a$var$equalArrays;

});
parcelRegister("geruL", function(module, exports) {

var $3AbE3 = parcelRequire("3AbE3");

var $feRWT = parcelRequire("feRWT");

var $5JafM = parcelRequire("5JafM");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $bd13481f54a3b03b$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $3AbE3;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$bd13481f54a3b03b$var$SetCache.prototype.add = $bd13481f54a3b03b$var$SetCache.prototype.push = $feRWT;
$bd13481f54a3b03b$var$SetCache.prototype.has = $5JafM;
module.exports = $bd13481f54a3b03b$var$SetCache;

});
parcelRegister("feRWT", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $b18202ecd8002e35$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $b18202ecd8002e35$var$setCacheAdd(value) {
    this.__data__.set(value, $b18202ecd8002e35$var$HASH_UNDEFINED);
    return this;
}
module.exports = $b18202ecd8002e35$var$setCacheAdd;

});

parcelRegister("5JafM", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $42b91bd54d89d230$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $42b91bd54d89d230$var$setCacheHas;

});


parcelRegister("gjwFf", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $0310a429e6e7ca37$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $0310a429e6e7ca37$var$arraySome;

});

parcelRegister("94W1a", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $69c17de26790db39$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $69c17de26790db39$var$cacheHas;

});


parcelRegister("9NjJG", function(module, exports) {

var $2ECfn = parcelRequire("2ECfn");

var $bOdEc = parcelRequire("bOdEc");

var $dtDa7 = parcelRequire("dtDa7");

var $hucwe = parcelRequire("hucwe");

var $3PiUC = parcelRequire("3PiUC");

var $hi9vi = parcelRequire("hi9vi");
/** Used to compose bitmasks for value comparisons. */ var $7217ffc5222ebc49$var$COMPARE_PARTIAL_FLAG = 1, $7217ffc5222ebc49$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $7217ffc5222ebc49$var$boolTag = '[object Boolean]', $7217ffc5222ebc49$var$dateTag = '[object Date]', $7217ffc5222ebc49$var$errorTag = '[object Error]', $7217ffc5222ebc49$var$mapTag = '[object Map]', $7217ffc5222ebc49$var$numberTag = '[object Number]', $7217ffc5222ebc49$var$regexpTag = '[object RegExp]', $7217ffc5222ebc49$var$setTag = '[object Set]', $7217ffc5222ebc49$var$stringTag = '[object String]', $7217ffc5222ebc49$var$symbolTag = '[object Symbol]';
var $7217ffc5222ebc49$var$arrayBufferTag = '[object ArrayBuffer]', $7217ffc5222ebc49$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $7217ffc5222ebc49$var$symbolProto = $2ECfn ? $2ECfn.prototype : undefined, $7217ffc5222ebc49$var$symbolValueOf = $7217ffc5222ebc49$var$symbolProto ? $7217ffc5222ebc49$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $7217ffc5222ebc49$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $7217ffc5222ebc49$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $7217ffc5222ebc49$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $bOdEc(object), new $bOdEc(other))) return false;
            return true;
        case $7217ffc5222ebc49$var$boolTag:
        case $7217ffc5222ebc49$var$dateTag:
        case $7217ffc5222ebc49$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $dtDa7(+object, +other);
        case $7217ffc5222ebc49$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $7217ffc5222ebc49$var$regexpTag:
        case $7217ffc5222ebc49$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $7217ffc5222ebc49$var$mapTag:
            var convert = $3PiUC;
        case $7217ffc5222ebc49$var$setTag:
            var isPartial = bitmask & $7217ffc5222ebc49$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $hi9vi);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $7217ffc5222ebc49$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $hucwe(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $7217ffc5222ebc49$var$symbolTag:
            if ($7217ffc5222ebc49$var$symbolValueOf) return $7217ffc5222ebc49$var$symbolValueOf.call(object) == $7217ffc5222ebc49$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $7217ffc5222ebc49$var$equalByTag;

});
parcelRegister("bOdEc", function(module, exports) {

var $iX8FQ = parcelRequire("iX8FQ");
/** Built-in value references. */ var $898ef34d3fbc4218$var$Uint8Array = $iX8FQ.Uint8Array;
module.exports = $898ef34d3fbc4218$var$Uint8Array;

});

parcelRegister("3PiUC", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $2c94ce1a9fa40aad$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $2c94ce1a9fa40aad$var$mapToArray;

});

parcelRegister("hi9vi", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $c96b7d5971c9922c$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $c96b7d5971c9922c$var$setToArray;

});


parcelRegister("hh6fJ", function(module, exports) {

var $43ynW = parcelRequire("43ynW");
/** Used to compose bitmasks for value comparisons. */ var $c938dfdb0809d0b0$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $c938dfdb0809d0b0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c938dfdb0809d0b0$var$hasOwnProperty = $c938dfdb0809d0b0$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c938dfdb0809d0b0$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $c938dfdb0809d0b0$var$COMPARE_PARTIAL_FLAG, objProps = $43ynW(object), objLength = objProps.length, othProps = $43ynW(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $c938dfdb0809d0b0$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $c938dfdb0809d0b0$var$equalObjects;

});
parcelRegister("43ynW", function(module, exports) {

var $cX5Wu = parcelRequire("cX5Wu");

var $hKL9p = parcelRequire("hKL9p");

var $7VA6m = parcelRequire("7VA6m");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2f421d69ece2815e$var$getAllKeys(object) {
    return $cX5Wu(object, $7VA6m, $hKL9p);
}
module.exports = $2f421d69ece2815e$var$getAllKeys;

});
parcelRegister("cX5Wu", function(module, exports) {

var $2PDig = parcelRequire("2PDig");

var $eDxI3 = parcelRequire("eDxI3");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $96df9ac3fa6b4d3a$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $eDxI3(object) ? result : $2PDig(result, symbolsFunc(object));
}
module.exports = $96df9ac3fa6b4d3a$var$baseGetAllKeys;

});
parcelRegister("2PDig", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $20fed30d9af6611f$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $20fed30d9af6611f$var$arrayPush;

});

parcelRegister("eDxI3", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $aa7edb3eab5f2949$var$isArray = Array.isArray;
module.exports = $aa7edb3eab5f2949$var$isArray;

});


parcelRegister("hKL9p", function(module, exports) {

var $5kTtj = parcelRequire("5kTtj");

var $4j4Yf = parcelRequire("4j4Yf");
/** Used for built-in method references. */ var $cecb4eaf29b06cc9$var$objectProto = Object.prototype;
/** Built-in value references. */ var $cecb4eaf29b06cc9$var$propertyIsEnumerable = $cecb4eaf29b06cc9$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cecb4eaf29b06cc9$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $cecb4eaf29b06cc9$var$getSymbols = !$cecb4eaf29b06cc9$var$nativeGetSymbols ? $4j4Yf : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $5kTtj($cecb4eaf29b06cc9$var$nativeGetSymbols(object), function(symbol) {
        return $cecb4eaf29b06cc9$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $cecb4eaf29b06cc9$var$getSymbols;

});
parcelRegister("5kTtj", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $3e29d9900d8ee3cc$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $3e29d9900d8ee3cc$var$arrayFilter;

});

parcelRegister("4j4Yf", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $322ccae08060181d$var$stubArray() {
    return [];
}
module.exports = $322ccae08060181d$var$stubArray;

});


parcelRegister("7VA6m", function(module, exports) {

var $aqzcj = parcelRequire("aqzcj");

var $4QjgQ = parcelRequire("4QjgQ");

var $iUT0t = parcelRequire("iUT0t");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $017d520123e64dde$var$keys(object) {
    return $iUT0t(object) ? $aqzcj(object) : $4QjgQ(object);
}
module.exports = $017d520123e64dde$var$keys;

});
parcelRegister("aqzcj", function(module, exports) {

var $cPRBX = parcelRequire("cPRBX");

var $hvlFI = parcelRequire("hvlFI");

var $eDxI3 = parcelRequire("eDxI3");

var $cgpOl = parcelRequire("cgpOl");

var $b9vc6 = parcelRequire("b9vc6");

var $3BgbH = parcelRequire("3BgbH");
/** Used for built-in method references. */ var $7977a29f3dbb6109$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7977a29f3dbb6109$var$hasOwnProperty = $7977a29f3dbb6109$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $7977a29f3dbb6109$var$arrayLikeKeys(value, inherited) {
    var isArr = $eDxI3(value), isArg = !isArr && $hvlFI(value), isBuff = !isArr && !isArg && $cgpOl(value), isType = !isArr && !isArg && !isBuff && $3BgbH(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $cPRBX(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $7977a29f3dbb6109$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $b9vc6(key, length)))) result.push(key);
    return result;
}
module.exports = $7977a29f3dbb6109$var$arrayLikeKeys;

});
parcelRegister("cPRBX", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $9583d583516a7399$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $9583d583516a7399$var$baseTimes;

});

parcelRegister("hvlFI", function(module, exports) {

var $7kXKN = parcelRequire("7kXKN");

var $3QXiR = parcelRequire("3QXiR");
/** Used for built-in method references. */ var $cbe624836b9b9b6c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cbe624836b9b9b6c$var$hasOwnProperty = $cbe624836b9b9b6c$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $cbe624836b9b9b6c$var$propertyIsEnumerable = $cbe624836b9b9b6c$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $cbe624836b9b9b6c$var$isArguments = $7kXKN(function() {
    return arguments;
}()) ? $7kXKN : function(value) {
    return $3QXiR(value) && $cbe624836b9b9b6c$var$hasOwnProperty.call(value, 'callee') && !$cbe624836b9b9b6c$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $cbe624836b9b9b6c$var$isArguments;

});
parcelRegister("7kXKN", function(module, exports) {

var $lMPeG = parcelRequire("lMPeG");

var $3QXiR = parcelRequire("3QXiR");
/** `Object#toString` result references. */ var $5578c089cbaf48a5$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $5578c089cbaf48a5$var$baseIsArguments(value) {
    return $3QXiR(value) && $lMPeG(value) == $5578c089cbaf48a5$var$argsTag;
}
module.exports = $5578c089cbaf48a5$var$baseIsArguments;

});
parcelRegister("3QXiR", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2ce43acee9ada2cb$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $2ce43acee9ada2cb$var$isObjectLike;

});



parcelRegister("cgpOl", function(module, exports) {

var $iX8FQ = parcelRequire("iX8FQ");

var $e13FC = parcelRequire("e13FC");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $iX8FQ.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $e13FC;
module.exports = isBuffer;

});
parcelRegister("e13FC", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $a34401863db78918$var$stubFalse() {
    return false;
}
module.exports = $a34401863db78918$var$stubFalse;

});


parcelRegister("b9vc6", function(module, exports) {
/** Used as references for various `Number` constants. */ var $81e8bb7e15ccb64b$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $81e8bb7e15ccb64b$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $81e8bb7e15ccb64b$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $81e8bb7e15ccb64b$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $81e8bb7e15ccb64b$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $81e8bb7e15ccb64b$var$isIndex;

});

parcelRegister("3BgbH", function(module, exports) {

var $8bJCi = parcelRequire("8bJCi");

var $cxIgW = parcelRequire("cxIgW");

var $4Zhkb = parcelRequire("4Zhkb");
/* Node.js helper references. */ var $29f1625648711e06$var$nodeIsTypedArray = $4Zhkb && $4Zhkb.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $29f1625648711e06$var$isTypedArray = $29f1625648711e06$var$nodeIsTypedArray ? $cxIgW($29f1625648711e06$var$nodeIsTypedArray) : $8bJCi;
module.exports = $29f1625648711e06$var$isTypedArray;

});
parcelRegister("8bJCi", function(module, exports) {

var $lMPeG = parcelRequire("lMPeG");

var $kblKQ = parcelRequire("kblKQ");

var $3QXiR = parcelRequire("3QXiR");
/** `Object#toString` result references. */ var $5f62bc51e9794221$var$argsTag = '[object Arguments]', $5f62bc51e9794221$var$arrayTag = '[object Array]', $5f62bc51e9794221$var$boolTag = '[object Boolean]', $5f62bc51e9794221$var$dateTag = '[object Date]', $5f62bc51e9794221$var$errorTag = '[object Error]', $5f62bc51e9794221$var$funcTag = '[object Function]', $5f62bc51e9794221$var$mapTag = '[object Map]', $5f62bc51e9794221$var$numberTag = '[object Number]', $5f62bc51e9794221$var$objectTag = '[object Object]', $5f62bc51e9794221$var$regexpTag = '[object RegExp]', $5f62bc51e9794221$var$setTag = '[object Set]', $5f62bc51e9794221$var$stringTag = '[object String]', $5f62bc51e9794221$var$weakMapTag = '[object WeakMap]';
var $5f62bc51e9794221$var$arrayBufferTag = '[object ArrayBuffer]', $5f62bc51e9794221$var$dataViewTag = '[object DataView]', $5f62bc51e9794221$var$float32Tag = '[object Float32Array]', $5f62bc51e9794221$var$float64Tag = '[object Float64Array]', $5f62bc51e9794221$var$int8Tag = '[object Int8Array]', $5f62bc51e9794221$var$int16Tag = '[object Int16Array]', $5f62bc51e9794221$var$int32Tag = '[object Int32Array]', $5f62bc51e9794221$var$uint8Tag = '[object Uint8Array]', $5f62bc51e9794221$var$uint8ClampedTag = '[object Uint8ClampedArray]', $5f62bc51e9794221$var$uint16Tag = '[object Uint16Array]', $5f62bc51e9794221$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $5f62bc51e9794221$var$typedArrayTags = {};
$5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$float32Tag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$float64Tag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$int8Tag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$int16Tag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$int32Tag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$uint8Tag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$uint8ClampedTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$uint16Tag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$uint32Tag] = true;
$5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$argsTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$arrayTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$arrayBufferTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$boolTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$dataViewTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$dateTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$errorTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$funcTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$mapTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$numberTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$objectTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$regexpTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$setTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$stringTag] = $5f62bc51e9794221$var$typedArrayTags[$5f62bc51e9794221$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $5f62bc51e9794221$var$baseIsTypedArray(value) {
    return $3QXiR(value) && $kblKQ(value.length) && !!$5f62bc51e9794221$var$typedArrayTags[$lMPeG(value)];
}
module.exports = $5f62bc51e9794221$var$baseIsTypedArray;

});
parcelRegister("kblKQ", function(module, exports) {
/** Used as references for various `Number` constants. */ var $eb15b5b5670da5e7$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $eb15b5b5670da5e7$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $eb15b5b5670da5e7$var$MAX_SAFE_INTEGER;
}
module.exports = $eb15b5b5670da5e7$var$isLength;

});


parcelRegister("cxIgW", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $921ae8a2e407bf65$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $921ae8a2e407bf65$var$baseUnary;

});

parcelRegister("4Zhkb", function(module, exports) {

var $baR0X = parcelRequire("baR0X");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $baR0X.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("4QjgQ", function(module, exports) {

var $iH5Ei = parcelRequire("iH5Ei");

var $kLpTM = parcelRequire("kLpTM");
/** Used for built-in method references. */ var $386af77f1a91082a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $386af77f1a91082a$var$hasOwnProperty = $386af77f1a91082a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $386af77f1a91082a$var$baseKeys(object) {
    if (!$iH5Ei(object)) return $kLpTM(object);
    var result = [];
    for(var key in Object(object))if ($386af77f1a91082a$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $386af77f1a91082a$var$baseKeys;

});
parcelRegister("iH5Ei", function(module, exports) {
/** Used for built-in method references. */ var $d9c09fe5a84875fd$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $d9c09fe5a84875fd$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $d9c09fe5a84875fd$var$objectProto;
    return value === proto;
}
module.exports = $d9c09fe5a84875fd$var$isPrototype;

});

parcelRegister("kLpTM", function(module, exports) {

var $7DPol = parcelRequire("7DPol");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f1dc495b56b4b8d6$var$nativeKeys = $7DPol(Object.keys, Object);
module.exports = $f1dc495b56b4b8d6$var$nativeKeys;

});
parcelRegister("7DPol", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $59040a4208f702bb$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $59040a4208f702bb$var$overArg;

});



parcelRegister("iUT0t", function(module, exports) {

var $cRBs5 = parcelRequire("cRBs5");

var $kblKQ = parcelRequire("kblKQ");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $dc582022bbb38ce4$var$isArrayLike(value) {
    return value != null && $kblKQ(value.length) && !$cRBs5(value);
}
module.exports = $dc582022bbb38ce4$var$isArrayLike;

});




parcelRegister("lEt5c", function(module, exports) {

var $iC01Z = parcelRequire("iC01Z");

var $4xUue = parcelRequire("4xUue");

var $c5Yho = parcelRequire("c5Yho");

var $ZCjrY = parcelRequire("ZCjrY");

var $83K1Q = parcelRequire("83K1Q");

var $lMPeG = parcelRequire("lMPeG");

var $biRZH = parcelRequire("biRZH");
/** `Object#toString` result references. */ var $fc33e4a82c9a8ddc$var$mapTag = '[object Map]', $fc33e4a82c9a8ddc$var$objectTag = '[object Object]', $fc33e4a82c9a8ddc$var$promiseTag = '[object Promise]', $fc33e4a82c9a8ddc$var$setTag = '[object Set]', $fc33e4a82c9a8ddc$var$weakMapTag = '[object WeakMap]';
var $fc33e4a82c9a8ddc$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $fc33e4a82c9a8ddc$var$dataViewCtorString = $biRZH($iC01Z), $fc33e4a82c9a8ddc$var$mapCtorString = $biRZH($4xUue), $fc33e4a82c9a8ddc$var$promiseCtorString = $biRZH($c5Yho), $fc33e4a82c9a8ddc$var$setCtorString = $biRZH($ZCjrY), $fc33e4a82c9a8ddc$var$weakMapCtorString = $biRZH($83K1Q);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $fc33e4a82c9a8ddc$var$getTag = $lMPeG;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($iC01Z && $fc33e4a82c9a8ddc$var$getTag(new $iC01Z(new ArrayBuffer(1))) != $fc33e4a82c9a8ddc$var$dataViewTag || $4xUue && $fc33e4a82c9a8ddc$var$getTag(new $4xUue) != $fc33e4a82c9a8ddc$var$mapTag || $c5Yho && $fc33e4a82c9a8ddc$var$getTag($c5Yho.resolve()) != $fc33e4a82c9a8ddc$var$promiseTag || $ZCjrY && $fc33e4a82c9a8ddc$var$getTag(new $ZCjrY) != $fc33e4a82c9a8ddc$var$setTag || $83K1Q && $fc33e4a82c9a8ddc$var$getTag(new $83K1Q) != $fc33e4a82c9a8ddc$var$weakMapTag) $fc33e4a82c9a8ddc$var$getTag = function(value) {
    var result = $lMPeG(value), Ctor = result == $fc33e4a82c9a8ddc$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $biRZH(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $fc33e4a82c9a8ddc$var$dataViewCtorString:
            return $fc33e4a82c9a8ddc$var$dataViewTag;
        case $fc33e4a82c9a8ddc$var$mapCtorString:
            return $fc33e4a82c9a8ddc$var$mapTag;
        case $fc33e4a82c9a8ddc$var$promiseCtorString:
            return $fc33e4a82c9a8ddc$var$promiseTag;
        case $fc33e4a82c9a8ddc$var$setCtorString:
            return $fc33e4a82c9a8ddc$var$setTag;
        case $fc33e4a82c9a8ddc$var$weakMapCtorString:
            return $fc33e4a82c9a8ddc$var$weakMapTag;
    }
    return result;
};
module.exports = $fc33e4a82c9a8ddc$var$getTag;

});
parcelRegister("iC01Z", function(module, exports) {

var $6wce3 = parcelRequire("6wce3");

var $iX8FQ = parcelRequire("iX8FQ");
/* Built-in method references that are verified to be native. */ var $d8cbccc524c2eab1$var$DataView = $6wce3($iX8FQ, 'DataView');
module.exports = $d8cbccc524c2eab1$var$DataView;

});

parcelRegister("c5Yho", function(module, exports) {

var $6wce3 = parcelRequire("6wce3");

var $iX8FQ = parcelRequire("iX8FQ");
/* Built-in method references that are verified to be native. */ var $8ce4b5f117c3af23$var$Promise = $6wce3($iX8FQ, 'Promise');
module.exports = $8ce4b5f117c3af23$var$Promise;

});

parcelRegister("ZCjrY", function(module, exports) {

var $6wce3 = parcelRequire("6wce3");

var $iX8FQ = parcelRequire("iX8FQ");
/* Built-in method references that are verified to be native. */ var $0b936ab9ec293137$var$Set = $6wce3($iX8FQ, 'Set');
module.exports = $0b936ab9ec293137$var$Set;

});

parcelRegister("83K1Q", function(module, exports) {

var $6wce3 = parcelRequire("6wce3");

var $iX8FQ = parcelRequire("iX8FQ");
/* Built-in method references that are verified to be native. */ var $5de24ee8a09b8381$var$WeakMap = $6wce3($iX8FQ, 'WeakMap');
module.exports = $5de24ee8a09b8381$var$WeakMap;

});





parcelRegister("epOIy", function(module, exports) {

var $15HMR = parcelRequire("15HMR");

var $h4DMC = parcelRequire("h4DMC");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $a7eabdf262875e4c$var$keyBy = $h4DMC(function(result, value, key) {
    $15HMR(result, key, value);
});
module.exports = $a7eabdf262875e4c$var$keyBy;

});
parcelRegister("15HMR", function(module, exports) {

var $dfWV9 = parcelRequire("dfWV9");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $0cb839486159b2ae$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $dfWV9) $dfWV9(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $0cb839486159b2ae$var$baseAssignValue;

});
parcelRegister("dfWV9", function(module, exports) {

var $6wce3 = parcelRequire("6wce3");
var $9a6a617fca3d06e7$var$defineProperty = function() {
    try {
        var func = $6wce3(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $9a6a617fca3d06e7$var$defineProperty;

});


parcelRegister("h4DMC", function(module, exports) {

var $a5Zjr = parcelRequire("a5Zjr");

var $aGvP0 = parcelRequire("aGvP0");

var $lC9cI = parcelRequire("lC9cI");

var $eDxI3 = parcelRequire("eDxI3");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $c6e1ab7e0b743ffd$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $eDxI3(collection) ? $a5Zjr : $aGvP0, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $lC9cI(iteratee, 2), accumulator);
    };
}
module.exports = $c6e1ab7e0b743ffd$var$createAggregator;

});
parcelRegister("a5Zjr", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $7599ee67da313b03$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $7599ee67da313b03$var$arrayAggregator;

});

parcelRegister("aGvP0", function(module, exports) {

var $lghbe = parcelRequire("lghbe");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $7c7682c5e7649aea$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $lghbe(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $7c7682c5e7649aea$var$baseAggregator;

});
parcelRegister("lghbe", function(module, exports) {

var $5fuBH = parcelRequire("5fuBH");

var $6QMis = parcelRequire("6QMis");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $f7a86b35b889f457$var$baseEach = $6QMis($5fuBH);
module.exports = $f7a86b35b889f457$var$baseEach;

});
parcelRegister("5fuBH", function(module, exports) {

var $1p231 = parcelRequire("1p231");

var $7VA6m = parcelRequire("7VA6m");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $3d26185e279632a6$var$baseForOwn(object, iteratee) {
    return object && $1p231(object, iteratee, $7VA6m);
}
module.exports = $3d26185e279632a6$var$baseForOwn;

});
parcelRegister("1p231", function(module, exports) {

var $bmz0V = parcelRequire("bmz0V");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $1059b6dbb6584211$var$baseFor = $bmz0V();
module.exports = $1059b6dbb6584211$var$baseFor;

});
parcelRegister("bmz0V", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $845ce8cfb8307eda$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $845ce8cfb8307eda$var$createBaseFor;

});



parcelRegister("6QMis", function(module, exports) {

var $iUT0t = parcelRequire("iUT0t");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $4fcd101cda77cafd$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$iUT0t(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $4fcd101cda77cafd$var$createBaseEach;

});



parcelRegister("lC9cI", function(module, exports) {

var $81Ebi = parcelRequire("81Ebi");

var $7bnki = parcelRequire("7bnki");

var $4XIoj = parcelRequire("4XIoj");

var $eDxI3 = parcelRequire("eDxI3");

var $2mDMl = parcelRequire("2mDMl");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $fbc44954ece19e13$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $4XIoj;
    if (typeof value == 'object') return $eDxI3(value) ? $7bnki(value[0], value[1]) : $81Ebi(value);
    return $2mDMl(value);
}
module.exports = $fbc44954ece19e13$var$baseIteratee;

});
parcelRegister("81Ebi", function(module, exports) {

var $1J7Ei = parcelRequire("1J7Ei");

var $2XrLl = parcelRequire("2XrLl");

var $dcxj6 = parcelRequire("dcxj6");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $5d7d95dcaf1ad617$var$baseMatches(source) {
    var matchData = $2XrLl(source);
    if (matchData.length == 1 && matchData[0][2]) return $dcxj6(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $1J7Ei(object, source, matchData);
    };
}
module.exports = $5d7d95dcaf1ad617$var$baseMatches;

});
parcelRegister("1J7Ei", function(module, exports) {

var $dcnjY = parcelRequire("dcnjY");

var $iuoc7 = parcelRequire("iuoc7");
/** Used to compose bitmasks for value comparisons. */ var $141fed55e889422b$var$COMPARE_PARTIAL_FLAG = 1, $141fed55e889422b$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $141fed55e889422b$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $dcnjY;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $iuoc7(srcValue, objValue, $141fed55e889422b$var$COMPARE_PARTIAL_FLAG | $141fed55e889422b$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $141fed55e889422b$var$baseIsMatch;

});

parcelRegister("2XrLl", function(module, exports) {

var $bvfa4 = parcelRequire("bvfa4");

var $7VA6m = parcelRequire("7VA6m");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $2276a089a53126bb$var$getMatchData(object) {
    var result = $7VA6m(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $bvfa4(value)
        ];
    }
    return result;
}
module.exports = $2276a089a53126bb$var$getMatchData;

});
parcelRegister("bvfa4", function(module, exports) {

var $6oQC7 = parcelRequire("6oQC7");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $85fe59ae7967bbe0$var$isStrictComparable(value) {
    return value === value && !$6oQC7(value);
}
module.exports = $85fe59ae7967bbe0$var$isStrictComparable;

});


parcelRegister("dcxj6", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $99c63b741439cb07$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $99c63b741439cb07$var$matchesStrictComparable;

});


parcelRegister("7bnki", function(module, exports) {

var $iuoc7 = parcelRequire("iuoc7");

var $gxEW5 = parcelRequire("gxEW5");

var $1glAN = parcelRequire("1glAN");

var $2qC2G = parcelRequire("2qC2G");

var $bvfa4 = parcelRequire("bvfa4");

var $dcxj6 = parcelRequire("dcxj6");

var $fRCMc = parcelRequire("fRCMc");
/** Used to compose bitmasks for value comparisons. */ var $53aba7a23d29332e$var$COMPARE_PARTIAL_FLAG = 1, $53aba7a23d29332e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $53aba7a23d29332e$var$baseMatchesProperty(path, srcValue) {
    if ($2qC2G(path) && $bvfa4(srcValue)) return $dcxj6($fRCMc(path), srcValue);
    return function(object) {
        var objValue = $gxEW5(object, path);
        return objValue === undefined && objValue === srcValue ? $1glAN(object, path) : $iuoc7(srcValue, objValue, $53aba7a23d29332e$var$COMPARE_PARTIAL_FLAG | $53aba7a23d29332e$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $53aba7a23d29332e$var$baseMatchesProperty;

});
parcelRegister("gxEW5", function(module, exports) {

var $WtCLd = parcelRequire("WtCLd");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $c0af7b6c1c34691e$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $WtCLd(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $c0af7b6c1c34691e$var$get;

});
parcelRegister("WtCLd", function(module, exports) {

var $ashpP = parcelRequire("ashpP");

var $fRCMc = parcelRequire("fRCMc");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $0afc65a3493ad00c$var$baseGet(object, path) {
    path = $ashpP(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$fRCMc(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $0afc65a3493ad00c$var$baseGet;

});
parcelRegister("ashpP", function(module, exports) {

var $eDxI3 = parcelRequire("eDxI3");

var $2qC2G = parcelRequire("2qC2G");

var $bQdre = parcelRequire("bQdre");

var $ltaB9 = parcelRequire("ltaB9");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $79ca074265625b26$var$castPath(value, object) {
    if ($eDxI3(value)) return value;
    return $2qC2G(value, object) ? [
        value
    ] : $bQdre($ltaB9(value));
}
module.exports = $79ca074265625b26$var$castPath;

});
parcelRegister("2qC2G", function(module, exports) {

var $eDxI3 = parcelRequire("eDxI3");

var $guOOX = parcelRequire("guOOX");
/** Used to match property names within property paths. */ var $1c4b84deeb49c788$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $1c4b84deeb49c788$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $1c4b84deeb49c788$var$isKey(value, object) {
    if ($eDxI3(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $guOOX(value)) return true;
    return $1c4b84deeb49c788$var$reIsPlainProp.test(value) || !$1c4b84deeb49c788$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $1c4b84deeb49c788$var$isKey;

});
parcelRegister("guOOX", function(module, exports) {

var $lMPeG = parcelRequire("lMPeG");

var $3QXiR = parcelRequire("3QXiR");
/** `Object#toString` result references. */ var $c026dea5a15ffede$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $c026dea5a15ffede$var$isSymbol(value) {
    return typeof value == 'symbol' || $3QXiR(value) && $lMPeG(value) == $c026dea5a15ffede$var$symbolTag;
}
module.exports = $c026dea5a15ffede$var$isSymbol;

});


parcelRegister("bQdre", function(module, exports) {

var $9s3No = parcelRequire("9s3No");
/** Used to match property names within property paths. */ var $89eef991cab69ba9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $89eef991cab69ba9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $89eef991cab69ba9$var$stringToPath = $9s3No(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($89eef991cab69ba9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($89eef991cab69ba9$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $89eef991cab69ba9$var$stringToPath;

});
parcelRegister("9s3No", function(module, exports) {

var $4oKwN = parcelRequire("4oKwN");
/** Used as the maximum memoize cache size. */ var $6e19ac4d0e01d1aa$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6e19ac4d0e01d1aa$var$memoizeCapped(func) {
    var result = $4oKwN(func, function(key) {
        if (cache.size === $6e19ac4d0e01d1aa$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $6e19ac4d0e01d1aa$var$memoizeCapped;

});
parcelRegister("4oKwN", function(module, exports) {

var $3AbE3 = parcelRequire("3AbE3");
/** Error message constants. */ var $333d7ece470dab97$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $333d7ece470dab97$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($333d7ece470dab97$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($333d7ece470dab97$var$memoize.Cache || $3AbE3);
    return memoized;
}
// Expose `MapCache`.
$333d7ece470dab97$var$memoize.Cache = $3AbE3;
module.exports = $333d7ece470dab97$var$memoize;

});



parcelRegister("ltaB9", function(module, exports) {

var $knT43 = parcelRequire("knT43");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $fa148701f2c71914$var$toString(value) {
    return value == null ? '' : $knT43(value);
}
module.exports = $fa148701f2c71914$var$toString;

});
parcelRegister("knT43", function(module, exports) {

var $2ECfn = parcelRequire("2ECfn");

var $dacmY = parcelRequire("dacmY");

var $eDxI3 = parcelRequire("eDxI3");

var $guOOX = parcelRequire("guOOX");
/** Used as references for various `Number` constants. */ var $ed70ab45f961f3cd$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $ed70ab45f961f3cd$var$symbolProto = $2ECfn ? $2ECfn.prototype : undefined, $ed70ab45f961f3cd$var$symbolToString = $ed70ab45f961f3cd$var$symbolProto ? $ed70ab45f961f3cd$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $ed70ab45f961f3cd$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($eDxI3(value)) // Recursively convert values (susceptible to call stack limits).
    return $dacmY(value, $ed70ab45f961f3cd$var$baseToString) + '';
    if ($guOOX(value)) return $ed70ab45f961f3cd$var$symbolToString ? $ed70ab45f961f3cd$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$ed70ab45f961f3cd$var$INFINITY ? '-0' : result;
}
module.exports = $ed70ab45f961f3cd$var$baseToString;

});
parcelRegister("dacmY", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $9955cddd232b8603$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $9955cddd232b8603$var$arrayMap;

});




parcelRegister("fRCMc", function(module, exports) {

var $guOOX = parcelRequire("guOOX");
/** Used as references for various `Number` constants. */ var $b8c9e2761c8d7199$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b8c9e2761c8d7199$var$toKey(value) {
    if (typeof value == 'string' || $guOOX(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$b8c9e2761c8d7199$var$INFINITY ? '-0' : result;
}
module.exports = $b8c9e2761c8d7199$var$toKey;

});



parcelRegister("1glAN", function(module, exports) {

var $4DY04 = parcelRequire("4DY04");

var $ech4h = parcelRequire("ech4h");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $0eb808e1b9b21cd0$var$hasIn(object, path) {
    return object != null && $ech4h(object, path, $4DY04);
}
module.exports = $0eb808e1b9b21cd0$var$hasIn;

});
parcelRegister("4DY04", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $361958b5dec65f0e$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $361958b5dec65f0e$var$baseHasIn;

});

parcelRegister("ech4h", function(module, exports) {

var $ashpP = parcelRequire("ashpP");

var $hvlFI = parcelRequire("hvlFI");

var $eDxI3 = parcelRequire("eDxI3");

var $b9vc6 = parcelRequire("b9vc6");

var $kblKQ = parcelRequire("kblKQ");

var $fRCMc = parcelRequire("fRCMc");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $a55f6d0477083f87$var$hasPath(object, path, hasFunc) {
    path = $ashpP(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $fRCMc(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $kblKQ(length) && $b9vc6(key, length) && ($eDxI3(object) || $hvlFI(object));
}
module.exports = $a55f6d0477083f87$var$hasPath;

});



parcelRegister("4XIoj", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $39cf1b44a0c78ac0$var$identity(value) {
    return value;
}
module.exports = $39cf1b44a0c78ac0$var$identity;

});

parcelRegister("2mDMl", function(module, exports) {

var $9tNqM = parcelRequire("9tNqM");

var $6Ef7Y = parcelRequire("6Ef7Y");

var $2qC2G = parcelRequire("2qC2G");

var $fRCMc = parcelRequire("fRCMc");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $1b8c7e17ab0255a0$var$property(path) {
    return $2qC2G(path) ? $9tNqM($fRCMc(path)) : $6Ef7Y(path);
}
module.exports = $1b8c7e17ab0255a0$var$property;

});
parcelRegister("9tNqM", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $6e6d2a6da6e73420$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $6e6d2a6da6e73420$var$baseProperty;

});

parcelRegister("6Ef7Y", function(module, exports) {

var $WtCLd = parcelRequire("WtCLd");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4d723687b76523c3$var$basePropertyDeep(path) {
    return function(object) {
        return $WtCLd(object, path);
    };
}
module.exports = $4d723687b76523c3$var$basePropertyDeep;

});





parcelRegister("9T9vB", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $7330a0593fac965e$export$306c0aa65ff9ec16; }, function (v) { return $7330a0593fac965e$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7330a0593fac965e$export$306c0aa65ff9ec16;
'use strict';

var $jiXHd = parcelRequire("jiXHd");
function $7330a0593fac965e$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $7330a0593fac965e$var$k = "function" === typeof Object.is ? Object.is : $7330a0593fac965e$var$h, $7330a0593fac965e$var$l = $jiXHd.useState, $7330a0593fac965e$var$m = $jiXHd.useEffect, $7330a0593fac965e$var$n = $jiXHd.useLayoutEffect, $7330a0593fac965e$var$p = $jiXHd.useDebugValue;
function $7330a0593fac965e$var$q(a, b) {
    var d = b(), f = $7330a0593fac965e$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $7330a0593fac965e$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $7330a0593fac965e$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $7330a0593fac965e$var$m(function() {
        $7330a0593fac965e$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $7330a0593fac965e$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $7330a0593fac965e$var$p(d);
    return d;
}
function $7330a0593fac965e$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$7330a0593fac965e$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $7330a0593fac965e$var$t(a, b) {
    return b();
}
var $7330a0593fac965e$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $7330a0593fac965e$var$t : $7330a0593fac965e$var$q;
$7330a0593fac965e$export$306c0aa65ff9ec16 = void 0 !== $jiXHd.useSyncExternalStore ? $jiXHd.useSyncExternalStore : $7330a0593fac965e$var$u;

});

var $537cfa8954b01156$exports = {};
$parcel$extendImportMap({
    "fzraq": "logoT-top.725935bd.png",
    "8CawB": "logoT-circle.07b65e83.png",
    "kUzIq": "blackwing-logo.42b2b735.png",
    "8MkNG": "bg.16696aa9.jpg",
    "cmWZg": "STX-S.48f67827.png",
    "7KXrq": "STX-T.6d6ca458.png",
    "6eio2": "STX-X.b60b79ee.png",
    "4Na36": "STX-S-crop.6e139836.png",
    "6A5tu": "STX-T-crop.7b0ff5cd.png",
    "i7jca": "STX-X-crop.1f65683b.png",
    "fWVzQ": "F17.2a634719.png",
    "l7K4W": "F207.2d8b55cc.png",
    "4WFCh": "F237.887b3f2e.png",
    "ka6xu": "F27.15d23308.png",
    "2s1iv": "F37.f0b87795.png",
    "1G8JQ": "F47.fe1586d6.png",
    "fdY6i": "F57.d21b0515.png",
    "23NbK": "F77.7c94c7cf.png",
    "8kVOU": "F107.44510ed7.png",
    "3bt0H": "F137.d7f35000.png",
    "e5tFV": "specs-diagram-1.f51122bd.png",
    "5nphD": "specs-diagram-2.8c2d1fa0.png",
    "6F8OB": "logoT-top-inquire.633781cc.png",
    "dOLao": "logoT-circle-inquire.aad0fc26.png",
    "gFVvo": "bg-obscura37-big.30a6352d.jpg"
});

// Global Style



var $6b0da32843b21c29$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b0da32843b21c29$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $6b0da32843b21c29$exports));
try {
    regeneratorRuntime = $6b0da32843b21c29$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $6b0da32843b21c29$var$runtime;
    else Function("r", "regeneratorRuntime = r")($6b0da32843b21c29$var$runtime);
}



var $jiXHd = parcelRequire("jiXHd");
var $d5c398fad52d3d9a$exports = {};
'use strict';
function $d5c398fad52d3d9a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d5c398fad52d3d9a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d5c398fad52d3d9a$var$checkDCE();

$d5c398fad52d3d9a$exports = (parcelRequire("aYihZ"));


function $6ce9701a9155b1d5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6ce9701a9155b1d5$export$39b482c5e57630a8(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6ce9701a9155b1d5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6ce9701a9155b1d5$export$71511d61b312f219(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6ce9701a9155b1d5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6ce9701a9155b1d5$export$407448d2b89b1813(obj) {
    "@babel/helpers - typeof";
    return $6ce9701a9155b1d5$export$407448d2b89b1813 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6ce9701a9155b1d5$export$407448d2b89b1813(obj);
}
function $6ce9701a9155b1d5$export$f1e1789686576879(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6ce9701a9155b1d5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6ce9701a9155b1d5$export$4368d992c4eafac0(Constructor, protoProps, staticProps) {
    if (protoProps) $6ce9701a9155b1d5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6ce9701a9155b1d5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6ce9701a9155b1d5$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ce9701a9155b1d5$export$8b22cf2602fb60ce(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6ce9701a9155b1d5$var$_setPrototypeOf(subClass, superClass);
}
function $6ce9701a9155b1d5$var$_getPrototypeOf(o) {
    $6ce9701a9155b1d5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6ce9701a9155b1d5$var$_getPrototypeOf(o);
}
function $6ce9701a9155b1d5$var$_setPrototypeOf(o, p) {
    $6ce9701a9155b1d5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6ce9701a9155b1d5$var$_setPrototypeOf(o, p);
}
function $6ce9701a9155b1d5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6ce9701a9155b1d5$export$2d1720544b23b823(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6ce9701a9155b1d5$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6ce9701a9155b1d5$export$2d1720544b23b823(self);
}
function $6ce9701a9155b1d5$export$db3b6bfb95261072(Derived) {
    var hasNativeReflectConstruct = $6ce9701a9155b1d5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6ce9701a9155b1d5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6ce9701a9155b1d5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6ce9701a9155b1d5$var$_possibleConstructorReturn(this, result);
    };
}



var $jiXHd = parcelRequire("jiXHd");

var $ePVXJ = parcelRequire("ePVXJ");
var $ccb4cb530ae69b84$var$isProduction = true;
var $ccb4cb530ae69b84$var$prefix = 'Invariant failed';
function $ccb4cb530ae69b84$export$23f2a1d2818174ef(condition, message) {
    if (condition) return;
    if ($ccb4cb530ae69b84$var$isProduction) throw new Error($ccb4cb530ae69b84$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? $ccb4cb530ae69b84$var$prefix + ": " + provided : $ccb4cb530ae69b84$var$prefix;
    throw new Error(value);
}



var $d81b72f3d24fa945$var$_LEVEL_DEBUG$LEVEL_IN;
var $d81b72f3d24fa945$export$594c4746b5c054d9 = 'debug';
var $d81b72f3d24fa945$export$c4fd8dd43addbba9 = 'info';
var $d81b72f3d24fa945$export$316845e2cb9db53d = 'warn';
var $d81b72f3d24fa945$export$eb4268f7d11f382e = 'error';
var $d81b72f3d24fa945$export$94181bfe08d41cda = 'critical';
var $d81b72f3d24fa945$export$2e2bcd8739ae039 = ($d81b72f3d24fa945$var$_LEVEL_DEBUG$LEVEL_IN = {}, (0, $6ce9701a9155b1d5$export$71511d61b312f219)($d81b72f3d24fa945$var$_LEVEL_DEBUG$LEVEL_IN, $d81b72f3d24fa945$export$594c4746b5c054d9, 1), (0, $6ce9701a9155b1d5$export$71511d61b312f219)($d81b72f3d24fa945$var$_LEVEL_DEBUG$LEVEL_IN, $d81b72f3d24fa945$export$c4fd8dd43addbba9, 2), (0, $6ce9701a9155b1d5$export$71511d61b312f219)($d81b72f3d24fa945$var$_LEVEL_DEBUG$LEVEL_IN, $d81b72f3d24fa945$export$316845e2cb9db53d, 3), (0, $6ce9701a9155b1d5$export$71511d61b312f219)($d81b72f3d24fa945$var$_LEVEL_DEBUG$LEVEL_IN, $d81b72f3d24fa945$export$eb4268f7d11f382e, 4), (0, $6ce9701a9155b1d5$export$71511d61b312f219)($d81b72f3d24fa945$var$_LEVEL_DEBUG$LEVEL_IN, $d81b72f3d24fa945$export$94181bfe08d41cda, 5), $d81b72f3d24fa945$var$_LEVEL_DEBUG$LEVEL_IN);




var $jiXHd = parcelRequire("jiXHd");

var $ePVXJ = parcelRequire("ePVXJ");
var $03ba84f01a1505a8$exports = {};
!function(t, e) {
    $03ba84f01a1505a8$exports = e();
}($03ba84f01a1505a8$exports, function() {
    return function(t) {
        var e = {};
        function r(n) {
            if (e[n]) return e[n].exports;
            var o = e[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
        }
        return r.m = t, r.c = e, r.d = function(t, e, n) {
            r.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, r.t = function(t, e) {
            if (1 & e && (t = r(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var o in t)r.d(n, o, (function(e) {
                return t[e];
            }).bind(null, o));
            return n;
        }, r.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return r.d(e, "a", e), e;
        }, r.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, r.p = "", r(r.s = 6);
    }([
        function(t, e, r) {
            "use strict";
            var n = r(12), o = {};
            function i(t, e) {
                return e === s(t);
            }
            function s(t) {
                var e = typeof t;
                return "object" !== e ? e : t ? t instanceof Error ? "error" : ({}).toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase() : "null";
            }
            function a(t) {
                return i(t, "function");
            }
            function u(t) {
                var e = Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?"), r = RegExp("^" + e + "$");
                return c(t) && r.test(t);
            }
            function c(t) {
                var e = typeof t;
                return null != t && ("object" == e || "function" == e);
            }
            function l() {
                var t = y();
                return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
                    var r = (t + 16 * Math.random()) % 16 | 0;
                    return t = Math.floor(t / 16), ("x" === e ? r : 7 & r | 8).toString(16);
                });
            }
            var p = {
                strictMode: !1,
                key: [
                    "source",
                    "protocol",
                    "authority",
                    "userInfo",
                    "user",
                    "password",
                    "host",
                    "port",
                    "relative",
                    "path",
                    "directory",
                    "file",
                    "query",
                    "anchor"
                ],
                q: {
                    name: "queryKey",
                    parser: /(?:^|&)([^&=]*)=?([^&]*)/g
                },
                parser: {
                    strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                    loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
                }
            };
            function f(t, e) {
                var r, n;
                try {
                    r = o.stringify(t);
                } catch (o) {
                    if (e && a(e)) try {
                        r = e(t);
                    } catch (t) {
                        n = t;
                    }
                    else n = o;
                }
                return {
                    error: n,
                    value: r
                };
            }
            function h(t, e) {
                return function(r, n) {
                    try {
                        e(r, n);
                    } catch (e) {
                        t.error(e);
                    }
                };
            }
            function d(t) {
                return function t(e, r) {
                    var n, o, a, u = {};
                    try {
                        for(o in e)(n = e[o]) && (i(n, "object") || i(n, "array")) ? r.includes(n) ? u[o] = "Removed circular reference: " + s(n) : ((a = r.slice()).push(n), u[o] = t(n, a)) : u[o] = n;
                    } catch (t) {
                        u = "Failed cloning custom data: " + t.message;
                    }
                    return u;
                }(t, [
                    t
                ]);
            }
            var m = [
                "log",
                "network",
                "dom",
                "navigation",
                "error",
                "manual"
            ], g = [
                "critical",
                "error",
                "warning",
                "info",
                "debug"
            ];
            function v(t, e) {
                for(var r = 0; r < t.length; ++r)if (t[r] === e) return !0;
                return !1;
            }
            function y() {
                return Date.now ? +Date.now() : +new Date;
            }
            t.exports = {
                addParamsAndAccessTokenToPath: function(t, e, r) {
                    (r = r || {}).access_token = t;
                    var n, o = [];
                    for(n in r)Object.prototype.hasOwnProperty.call(r, n) && o.push([
                        n,
                        r[n]
                    ].join("="));
                    var i = "?" + o.sort().join("&");
                    (e = e || {}).path = e.path || "";
                    var s, a = e.path.indexOf("?"), u = e.path.indexOf("#");
                    -1 !== a && (-1 === u || u > a) ? (s = e.path, e.path = s.substring(0, a) + i + "&" + s.substring(a + 1)) : -1 !== u ? (s = e.path, e.path = s.substring(0, u) + i + s.substring(u)) : e.path = e.path + i;
                },
                createItem: function(t, e, r, n, o) {
                    for(var i, a, u, c, p, f, m = [], g = [], v = 0, b = t.length; v < b; ++v){
                        var w = s(f = t[v]);
                        switch(g.push(w), w){
                            case "undefined":
                                break;
                            case "string":
                                i ? m.push(f) : i = f;
                                break;
                            case "function":
                                c = h(e, f);
                                break;
                            case "date":
                                m.push(f);
                                break;
                            case "error":
                            case "domexception":
                            case "exception":
                                a ? m.push(f) : a = f;
                                break;
                            case "object":
                            case "array":
                                if (f instanceof Error || "undefined" != typeof DOMException && f instanceof DOMException) {
                                    a ? m.push(f) : a = f;
                                    break;
                                }
                                if (n && "object" === w && !p) {
                                    for(var _ = 0, x = n.length; _ < x; ++_)if (void 0 !== f[n[_]]) {
                                        p = f;
                                        break;
                                    }
                                    if (p) break;
                                }
                                u ? m.push(f) : u = f;
                                break;
                            default:
                                if (f instanceof Error || "undefined" != typeof DOMException && f instanceof DOMException) {
                                    a ? m.push(f) : a = f;
                                    break;
                                }
                                m.push(f);
                        }
                    }
                    u && (u = d(u)), m.length > 0 && (u || (u = d({})), u.extraArgs = d(m));
                    var k = {
                        message: i,
                        err: a,
                        custom: u,
                        timestamp: y(),
                        callback: c,
                        notifier: r,
                        diagnostic: {},
                        uuid: l()
                    };
                    return function(t, e) {
                        e && void 0 !== e.level && (t.level = e.level, delete e.level);
                        e && void 0 !== e.skipFrames && (t.skipFrames = e.skipFrames, delete e.skipFrames);
                    }(k, u), n && p && (k.request = p), o && (k.lambdaContext = o), k._originalArgs = t, k.diagnostic.original_arg_types = g, k;
                },
                addErrorContext: function(t, e) {
                    var r = t.data.custom || {}, o = !1;
                    try {
                        for(var i = 0; i < e.length; ++i)e[i].hasOwnProperty("rollbarContext") && (r = n(r, d(e[i].rollbarContext)), o = !0);
                        o && (t.data.custom = r);
                    } catch (e) {
                        t.diagnostic.error_context = "Failed: " + e.message;
                    }
                },
                createTelemetryEvent: function(t) {
                    for(var e, r, n, o, i = 0, a = t.length; i < a; ++i)switch(s(o = t[i])){
                        case "string":
                            !e && v(m, o) ? e = o : !n && v(g, o) && (n = o);
                            break;
                        case "object":
                            r = o;
                    }
                    return {
                        type: e || "manual",
                        metadata: r || {},
                        level: n
                    };
                },
                filterIp: function(t, e) {
                    if (t && t.user_ip && !0 !== e) {
                        var r = t.user_ip;
                        if (e) try {
                            var n;
                            if (-1 !== r.indexOf(".")) (n = r.split(".")).pop(), n.push("0"), r = n.join(".");
                            else if (-1 !== r.indexOf(":")) {
                                if ((n = r.split(":")).length > 2) {
                                    var o = n.slice(0, 3), i = o[2].indexOf("/");
                                    -1 !== i && (o[2] = o[2].substring(0, i));
                                    r = o.concat("0000:0000:0000:0000:0000").join(":");
                                }
                            } else r = null;
                        } catch (t) {
                            r = null;
                        }
                        else r = null;
                        t.user_ip = r;
                    }
                },
                formatArgsAsString: function(t) {
                    var e, r, n, o = [];
                    for(e = 0, r = t.length; e < r; ++e){
                        switch(s(n = t[e])){
                            case "object":
                                (n = (n = f(n)).error || n.value).length > 500 && (n = n.substr(0, 497) + "...");
                                break;
                            case "null":
                                n = "null";
                                break;
                            case "undefined":
                                n = "undefined";
                                break;
                            case "symbol":
                                n = n.toString();
                        }
                        o.push(n);
                    }
                    return o.join(" ");
                },
                formatUrl: function(t, e) {
                    if (!(e = e || t.protocol) && t.port && (80 === t.port ? e = "http:" : 443 === t.port && (e = "https:")), e = e || "https:", !t.hostname) return null;
                    var r = e + "//" + t.hostname;
                    return t.port && (r = r + ":" + t.port), t.path && (r += t.path), r;
                },
                get: function(t, e) {
                    if (t) {
                        var r = e.split("."), n = t;
                        try {
                            for(var o = 0, i = r.length; o < i; ++o)n = n[r[o]];
                        } catch (t) {
                            n = void 0;
                        }
                        return n;
                    }
                },
                handleOptions: function(t, e, r, o) {
                    var i = n(t, e, r);
                    return i = function(t, e) {
                        t.hostWhiteList && !t.hostSafeList && (t.hostSafeList = t.hostWhiteList, t.hostWhiteList = void 0, e && e.log("hostWhiteList is deprecated. Use hostSafeList."));
                        t.hostBlackList && !t.hostBlockList && (t.hostBlockList = t.hostBlackList, t.hostBlackList = void 0, e && e.log("hostBlackList is deprecated. Use hostBlockList."));
                        return t;
                    }(i, o), !e || e.overwriteScrubFields || e.scrubFields && (i.scrubFields = (t.scrubFields || []).concat(e.scrubFields)), i;
                },
                isError: function(t) {
                    return i(t, "error") || i(t, "exception");
                },
                isFiniteNumber: function(t) {
                    return Number.isFinite(t);
                },
                isFunction: a,
                isIterable: function(t) {
                    var e = s(t);
                    return "object" === e || "array" === e;
                },
                isNativeFunction: u,
                isObject: c,
                isString: function(t) {
                    return "string" == typeof t || t instanceof String;
                },
                isType: i,
                isPromise: function(t) {
                    return c(t) && i(t.then, "function");
                },
                jsonParse: function(t) {
                    var e, r;
                    try {
                        e = o.parse(t);
                    } catch (t) {
                        r = t;
                    }
                    return {
                        error: r,
                        value: e
                    };
                },
                LEVELS: {
                    debug: 0,
                    info: 1,
                    warning: 2,
                    error: 3,
                    critical: 4
                },
                makeUnhandledStackInfo: function(t, e, r, n, o, i, s, a) {
                    var u = {
                        url: e || "",
                        line: r,
                        column: n
                    };
                    u.func = a.guessFunctionName(u.url, u.line), u.context = a.gatherContext(u.url, u.line);
                    var c = "undefined" != typeof document && document && document.location && document.location.href, l = "undefined" != typeof window && window && window.navigator && window.navigator.userAgent;
                    return {
                        mode: i,
                        message: o ? String(o) : t || s,
                        url: c,
                        stack: [
                            u
                        ],
                        useragent: l
                    };
                },
                merge: n,
                now: y,
                redact: function() {
                    return "********";
                },
                RollbarJSON: o,
                sanitizeUrl: function(t) {
                    var e = function(t) {
                        if (!i(t, "string")) return;
                        for(var e = p, r = e.parser[e.strictMode ? "strict" : "loose"].exec(t), n = {}, o = 0, s = e.key.length; o < s; ++o)n[e.key[o]] = r[o] || "";
                        return n[e.q.name] = {}, n[e.key[12]].replace(e.q.parser, function(t, r, o) {
                            r && (n[e.q.name][r] = o);
                        }), n;
                    }(t);
                    return e ? ("" === e.anchor && (e.source = e.source.replace("#", "")), t = e.source.replace("?" + e.query, "")) : "(unknown)";
                },
                set: function(t, e, r) {
                    if (t) {
                        var n = e.split("."), o = n.length;
                        if (!(o < 1)) {
                            if (1 !== o) try {
                                for(var i = t[n[0]] || {}, s = i, a = 1; a < o - 1; ++a)i[n[a]] = i[n[a]] || {}, i = i[n[a]];
                                i[n[o - 1]] = r, t[n[0]] = s;
                            } catch (t) {
                                return;
                            }
                            else t[n[0]] = r;
                        }
                    }
                },
                setupJSON: function(t) {
                    a(o.stringify) && a(o.parse) || (i(JSON, "undefined") || (t ? (u(JSON.stringify) && (o.stringify = JSON.stringify), u(JSON.parse) && (o.parse = JSON.parse)) : (a(JSON.stringify) && (o.stringify = JSON.stringify), a(JSON.parse) && (o.parse = JSON.parse))), a(o.stringify) && a(o.parse) || t && t(o));
                },
                stringify: f,
                maxByteSize: function(t) {
                    for(var e = 0, r = t.length, n = 0; n < r; n++){
                        var o = t.charCodeAt(n);
                        o < 128 ? e += 1 : o < 2048 ? e += 2 : o < 65536 && (e += 3);
                    }
                    return e;
                },
                typeName: s,
                uuid4: l
            };
        },
        function(t, e, r) {
            "use strict";
            r(17);
            var n = r(18), o = r(0);
            t.exports = {
                error: function() {
                    var t = Array.prototype.slice.call(arguments, 0);
                    t.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.error(o.formatArgsAsString(t)) : console.error.apply(console, t);
                },
                info: function() {
                    var t = Array.prototype.slice.call(arguments, 0);
                    t.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.info(o.formatArgsAsString(t)) : console.info.apply(console, t);
                },
                log: function() {
                    var t = Array.prototype.slice.call(arguments, 0);
                    t.unshift("Rollbar:"), n.ieVersion() <= 8 ? console.log(o.formatArgsAsString(t)) : console.log.apply(console, t);
                }
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = {
                parse: function(t) {
                    var e, r, n = {
                        protocol: null,
                        auth: null,
                        host: null,
                        path: null,
                        hash: null,
                        href: t,
                        hostname: null,
                        port: null,
                        pathname: null,
                        search: null,
                        query: null
                    };
                    if (-1 !== (e = t.indexOf("//")) ? (n.protocol = t.substring(0, e), r = e + 2) : r = 0, -1 !== (e = t.indexOf("@", r)) && (n.auth = t.substring(r, e), r = e + 1), -1 === (e = t.indexOf("/", r))) {
                        if (-1 === (e = t.indexOf("?", r))) return -1 === (e = t.indexOf("#", r)) ? n.host = t.substring(r) : (n.host = t.substring(r, e), n.hash = t.substring(e)), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), n;
                        n.host = t.substring(r, e), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = e;
                    } else n.host = t.substring(r, e), n.hostname = n.host.split(":")[0], n.port = n.host.split(":")[1], n.port && (n.port = parseInt(n.port, 10)), r = e;
                    if (-1 === (e = t.indexOf("#", r)) ? n.path = t.substring(r) : (n.path = t.substring(r, e), n.hash = t.substring(e)), n.path) {
                        var o = n.path.split("?");
                        n.pathname = o[0], n.query = o[1], n.search = n.query ? "?" + n.query : null;
                    }
                    return n;
                }
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(24), o = new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");
            function i() {
                return null;
            }
            function s(t) {
                var e = {};
                return e._stackFrame = t, e.url = t.fileName, e.line = t.lineNumber, e.func = t.functionName, e.column = t.columnNumber, e.args = t.args, e.context = null, e;
            }
            function a(t, e) {
                return {
                    stack: function() {
                        var r = [];
                        e = e || 0;
                        try {
                            r = n.parse(t);
                        } catch (t) {
                            r = [];
                        }
                        for(var o = [], i = e; i < r.length; i++)o.push(new s(r[i]));
                        return o;
                    }(),
                    message: t.message,
                    name: u(t),
                    rawStack: t.stack,
                    rawException: t
                };
            }
            function u(t) {
                var e = t.name && t.name.length && t.name, r = t.constructor.name && t.constructor.name.length && t.constructor.name;
                return e && r ? "Error" === e ? r : e : e || r;
            }
            t.exports = {
                guessFunctionName: function() {
                    return "?";
                },
                guessErrorClass: function(t) {
                    if (!t || !t.match) return [
                        "Unknown error. There was no error message to display.",
                        ""
                    ];
                    var e = t.match(o), r = "(unknown)";
                    return e && (r = e[e.length - 1], t = (t = t.replace((e[e.length - 2] || "") + r + ":", "")).replace(/(^[\s]+|[\s]+$)/g, "")), [
                        r,
                        t
                    ];
                },
                gatherContext: i,
                parse: function(t, e) {
                    var r = t;
                    if (r.nested || r.cause) {
                        for(var n = []; r;)n.push(new a(r, e)), r = r.nested || r.cause, e = 0;
                        return n[0].traceChain = n, n[0];
                    }
                    return new a(r, e);
                },
                Stack: a,
                Frame: s
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(5);
            function i(t, e) {
                var r = e.split("."), o = r.length - 1;
                try {
                    for(var i = 0; i <= o; ++i)i < o ? t = t[r[i]] : t[r[i]] = n.redact();
                } catch (t) {}
            }
            t.exports = function(t, e, r) {
                if (e = e || [], r) for(var s = 0; s < r.length; ++s)i(t, r[s]);
                var a = function(t) {
                    for(var e, r = [], n = 0; n < t.length; ++n)e = "^\\[?(%5[bB])?" + t[n] + "\\[?(%5[bB])?\\]?(%5[dD])?$", r.push(new RegExp(e, "i"));
                    return r;
                }(e), u = function(t) {
                    for(var e, r = [], n = 0; n < t.length; ++n)e = "\\[?(%5[bB])?" + t[n] + "\\[?(%5[bB])?\\]?(%5[dD])?", r.push(new RegExp("(" + e + "=)([^&\\n]+)", "igm"));
                    return r;
                }(e);
                function c(t, e) {
                    return e + n.redact();
                }
                return o(t, function t(e, r, i) {
                    var s = function(t, e) {
                        var r;
                        for(r = 0; r < a.length; ++r)if (a[r].test(t)) {
                            e = n.redact();
                            break;
                        }
                        return e;
                    }(e, r);
                    return s === r ? n.isType(r, "object") || n.isType(r, "array") ? o(r, t, i) : function(t) {
                        var e;
                        if (n.isType(t, "string")) for(e = 0; e < u.length; ++e)t = t.replace(u[e], c);
                        return t;
                    }(s) : s;
                });
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(0);
            t.exports = function(t, e, r) {
                var o, i, s, a, u = n.isType(t, "object"), c = n.isType(t, "array"), l = [];
                if (r = r || {
                    obj: [],
                    mapped: []
                }, u) {
                    if (a = r.obj.indexOf(t), u && -1 !== a) return r.mapped[a] || r.obj[a];
                    r.obj.push(t), a = r.obj.length - 1;
                }
                if (u) for(o in t)Object.prototype.hasOwnProperty.call(t, o) && l.push(o);
                else if (c) for(s = 0; s < t.length; ++s)l.push(s);
                var p = u ? {} : [], f = !0;
                for(s = 0; s < l.length; ++s)i = t[o = l[s]], p[o] = e(o, i, r), f = f && p[o] === t[o];
                return u && !f && (r.mapped[a] = p), f ? t : p;
            };
        },
        function(t, e, r) {
            t.exports = r(7);
        },
        function(t, e, r) {
            "use strict";
            var n = r(8), o = "undefined" != typeof window && window._rollbarConfig, i = o && o.globalAlias || "Rollbar", s = "undefined" != typeof window && window[i] && "function" == typeof window[i].shimId && void 0 !== window[i].shimId();
            if ("undefined" == typeof window || window._rollbarStartTime || (window._rollbarStartTime = (new Date).getTime()), !s && o) {
                var a = new n(o);
                window[i] = a;
            } else "undefined" != typeof window ? (window.rollbar = n, window._rollbarDidLoad = !0) : "undefined" != typeof self && (self.rollbar = n, self._rollbarDidLoad = !0);
            t.exports = n;
        },
        function(t, e, r) {
            "use strict";
            var n = r(9), o = r(31), i = r(32), s = r(35), a = r(37), u = r(4), c = r(38);
            n.setComponents({
                telemeter: o,
                instrumenter: i,
                polyfillJSON: s,
                wrapGlobals: a,
                scrub: u,
                truncation: c
            }), t.exports = n;
        },
        function(t, e, r) {
            "use strict";
            var n = r(10), o = r(0), i = r(15), s = r(1), a = r(19), u = r(20), c = r(2), l = r(23), p = r(26), f = r(27), h = r(28), d = r(3);
            function m(t, e) {
                this.options = o.handleOptions(x, t, null, s), this.options._configuredOptions = t;
                var r = this.components.telemeter, a = this.components.instrumenter, d = this.components.polyfillJSON;
                this.wrapGlobals = this.components.wrapGlobals, this.scrub = this.components.scrub;
                var m = this.components.truncation, g = new u(m), v = new i(this.options, g, c, m);
                r && (this.telemeter = new r(this.options)), this.client = e || new n(this.options, v, s, this.telemeter, "browser");
                var y = b(), w = "undefined" != typeof document && document;
                this.isChrome = y.chrome && y.chrome.runtime, this.anonymousErrorsPending = 0, function(t, e, r) {
                    t.addTransform(l.handleDomException).addTransform(l.handleItemWithError).addTransform(l.ensureItemHasSomethingToSay).addTransform(l.addBaseInfo).addTransform(l.addRequestInfo(r)).addTransform(l.addClientInfo(r)).addTransform(l.addPluginInfo(r)).addTransform(l.addBody).addTransform(p.addMessageWithError).addTransform(p.addTelemetryData).addTransform(p.addConfigToPayload).addTransform(l.addScrubber(e.scrub)).addTransform(p.addPayloadOptions).addTransform(p.userTransform(s)).addTransform(p.addConfiguredOptions).addTransform(p.addDiagnosticKeys).addTransform(p.itemToPayload);
                }(this.client.notifier, this, y), this.client.queue.addPredicate(h.checkLevel).addPredicate(f.checkIgnore).addPredicate(h.userCheckIgnore(s)).addPredicate(h.urlIsNotBlockListed(s)).addPredicate(h.urlIsSafeListed(s)).addPredicate(h.messageIsIgnored(s)), this.setupUnhandledCapture(), a && (this.instrumenter = new a(this.options, this.client.telemeter, this, y, w), this.instrumenter.instrument()), o.setupJSON(d), this.rollbar = this;
            }
            var g = null;
            function v(t) {
                var e = "Rollbar is not initialized";
                s.error(e), t && t(new Error(e));
            }
            function y(t) {
                for(var e = 0, r = t.length; e < r; ++e)if (o.isFunction(t[e])) return t[e];
            }
            function b() {
                return "undefined" != typeof window && window || "undefined" != typeof self && self;
            }
            m.init = function(t, e) {
                return g ? g.global(t).configure(t) : g = new m(t, e);
            }, m.prototype.components = {}, m.setComponents = function(t) {
                m.prototype.components = t;
            }, m.prototype.global = function(t) {
                return this.client.global(t), this;
            }, m.global = function(t) {
                if (g) return g.global(t);
                v();
            }, m.prototype.configure = function(t, e) {
                var r = this.options, n = {};
                return e && (n = {
                    payload: e
                }), this.options = o.handleOptions(r, t, n, s), this.options._configuredOptions = o.handleOptions(r._configuredOptions, t, n), this.client.configure(this.options, e), this.instrumenter && this.instrumenter.configure(this.options), this.setupUnhandledCapture(), this;
            }, m.configure = function(t, e) {
                if (g) return g.configure(t, e);
                v();
            }, m.prototype.lastError = function() {
                return this.client.lastError;
            }, m.lastError = function() {
                if (g) return g.lastError();
                v();
            }, m.prototype.log = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.log(t), {
                    uuid: e
                };
            }, m.log = function() {
                if (g) return g.log.apply(g, arguments);
                var t = y(arguments);
                v(t);
            }, m.prototype.debug = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.debug(t), {
                    uuid: e
                };
            }, m.debug = function() {
                if (g) return g.debug.apply(g, arguments);
                var t = y(arguments);
                v(t);
            }, m.prototype.info = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.info(t), {
                    uuid: e
                };
            }, m.info = function() {
                if (g) return g.info.apply(g, arguments);
                var t = y(arguments);
                v(t);
            }, m.prototype.warn = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.warn(t), {
                    uuid: e
                };
            }, m.warn = function() {
                if (g) return g.warn.apply(g, arguments);
                var t = y(arguments);
                v(t);
            }, m.prototype.warning = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.warning(t), {
                    uuid: e
                };
            }, m.warning = function() {
                if (g) return g.warning.apply(g, arguments);
                var t = y(arguments);
                v(t);
            }, m.prototype.error = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.error(t), {
                    uuid: e
                };
            }, m.error = function() {
                if (g) return g.error.apply(g, arguments);
                var t = y(arguments);
                v(t);
            }, m.prototype.critical = function() {
                var t = this._createItem(arguments), e = t.uuid;
                return this.client.critical(t), {
                    uuid: e
                };
            }, m.critical = function() {
                if (g) return g.critical.apply(g, arguments);
                var t = y(arguments);
                v(t);
            }, m.prototype.buildJsonPayload = function(t) {
                return this.client.buildJsonPayload(t);
            }, m.buildJsonPayload = function() {
                if (g) return g.buildJsonPayload.apply(g, arguments);
                v();
            }, m.prototype.sendJsonPayload = function(t) {
                return this.client.sendJsonPayload(t);
            }, m.sendJsonPayload = function() {
                if (g) return g.sendJsonPayload.apply(g, arguments);
                v();
            }, m.prototype.setupUnhandledCapture = function() {
                var t = b();
                this.unhandledExceptionsInitialized || (this.options.captureUncaught || this.options.handleUncaughtExceptions) && (a.captureUncaughtExceptions(t, this), this.wrapGlobals && this.options.wrapGlobalEventHandlers && this.wrapGlobals(t, this), this.unhandledExceptionsInitialized = !0), this.unhandledRejectionsInitialized || (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) && (a.captureUnhandledRejections(t, this), this.unhandledRejectionsInitialized = !0);
            }, m.prototype.handleUncaughtException = function(t, e, r, n, i, s) {
                if (this.options.captureUncaught || this.options.handleUncaughtExceptions) {
                    if (this.options.inspectAnonymousErrors && this.isChrome && null === i && "" === e) return "anonymous";
                    var a, u = o.makeUnhandledStackInfo(t, e, r, n, i, "onerror", "uncaught exception", d);
                    o.isError(i) ? (a = this._createItem([
                        t,
                        i,
                        s
                    ]))._unhandledStackInfo = u : o.isError(e) ? (a = this._createItem([
                        t,
                        e,
                        s
                    ]))._unhandledStackInfo = u : (a = this._createItem([
                        t,
                        s
                    ])).stackInfo = u, a.level = this.options.uncaughtErrorLevel, a._isUncaught = !0, this.client.log(a);
                }
            }, m.prototype.handleAnonymousErrors = function() {
                if (this.options.inspectAnonymousErrors && this.isChrome) {
                    var t = this;
                    try {
                        Error.prepareStackTrace = function(e, r) {
                            if (t.options.inspectAnonymousErrors && t.anonymousErrorsPending) {
                                if (t.anonymousErrorsPending -= 1, !e) return;
                                e._isAnonymous = !0, t.handleUncaughtException(e.message, null, null, null, e);
                            }
                            return e.stack;
                        };
                    } catch (t) {
                        this.options.inspectAnonymousErrors = !1, this.error("anonymous error handler failed", t);
                    }
                }
            }, m.prototype.handleUnhandledRejection = function(t, e) {
                if (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) {
                    var r = "unhandled rejection was null or undefined!";
                    if (t) {
                        if (t.message) r = t.message;
                        else {
                            var n = o.stringify(t);
                            n.value && (r = n.value);
                        }
                    }
                    var i, s = t && t._rollbarContext || e && e._rollbarContext;
                    o.isError(t) ? i = this._createItem([
                        r,
                        t,
                        s
                    ]) : (i = this._createItem([
                        r,
                        t,
                        s
                    ])).stackInfo = o.makeUnhandledStackInfo(r, "", 0, 0, null, "unhandledrejection", "", d), i.level = this.options.uncaughtErrorLevel, i._isUncaught = !0, i._originalArgs = i._originalArgs || [], i._originalArgs.push(e), this.client.log(i);
                }
            }, m.prototype.wrap = function(t, e, r) {
                try {
                    var n;
                    if (n = o.isFunction(e) ? e : function() {
                        return e || {};
                    }, !o.isFunction(t)) return t;
                    if (t._isWrap) return t;
                    if (!t._rollbar_wrapped && (t._rollbar_wrapped = function() {
                        r && o.isFunction(r) && r.apply(this, arguments);
                        try {
                            return t.apply(this, arguments);
                        } catch (r) {
                            var e = r;
                            throw e && window._rollbarWrappedError !== e && (o.isType(e, "string") && (e = new String(e)), e._rollbarContext = n() || {}, e._rollbarContext._wrappedSource = t.toString(), window._rollbarWrappedError = e), e;
                        }
                    }, t._rollbar_wrapped._isWrap = !0, t.hasOwnProperty)) for(var i in t)t.hasOwnProperty(i) && "_rollbar_wrapped" !== i && (t._rollbar_wrapped[i] = t[i]);
                    return t._rollbar_wrapped;
                } catch (e) {
                    return t;
                }
            }, m.wrap = function(t, e) {
                if (g) return g.wrap(t, e);
                v();
            }, m.prototype.captureEvent = function() {
                var t = o.createTelemetryEvent(arguments);
                return this.client.captureEvent(t.type, t.metadata, t.level);
            }, m.captureEvent = function() {
                if (g) return g.captureEvent.apply(g, arguments);
                v();
            }, m.prototype.captureDomContentLoaded = function(t, e) {
                return e || (e = new Date), this.client.captureDomContentLoaded(e);
            }, m.prototype.captureLoad = function(t, e) {
                return e || (e = new Date), this.client.captureLoad(e);
            }, m.prototype.loadFull = function() {
                s.info("Unexpected Rollbar.loadFull() called on a Notifier instance. This can happen when Rollbar is loaded multiple times.");
            }, m.prototype._createItem = function(t) {
                return o.createItem(t, s, this);
            };
            var w = r(29), _ = r(30), x = {
                version: w.version,
                scrubFields: _.scrubFields,
                logLevel: w.logLevel,
                reportLevel: w.reportLevel,
                uncaughtErrorLevel: w.uncaughtErrorLevel,
                endpoint: w.endpoint,
                verbose: !1,
                enabled: !0,
                transmit: !0,
                sendConfig: !1,
                includeItemsInTelemetry: !0,
                captureIp: !0,
                inspectAnonymousErrors: !0,
                ignoreDuplicateErrors: !0,
                wrapGlobalEventHandlers: !1
            };
            t.exports = m;
        },
        function(t, e, r) {
            "use strict";
            var n = r(11), o = r(13), i = r(14), s = r(0);
            function a(t, e, r, n, l) {
                this.options = s.merge(t), this.logger = r, a.rateLimiter.configureGlobal(this.options), a.rateLimiter.setPlatformOptions(l, this.options), this.api = e, this.queue = new o(a.rateLimiter, e, r, this.options);
                var p = this.options.tracer || null;
                c(p) ? (this.tracer = p, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier = new i(this.queue, this.options), this.telemeter = n, u(t), this.lastError = null, this.lastErrorHash = "none";
            }
            function u(t) {
                t.stackTraceLimit && (Error.stackTraceLimit = t.stackTraceLimit);
            }
            function c(t) {
                if (!t) return !1;
                if (!t.scope || "function" != typeof t.scope) return !1;
                var e = t.scope();
                return !(!e || !e.active || "function" != typeof e.active);
            }
            a.rateLimiter = new n({
                maxItems: 0,
                itemsPerMinute: 60
            }), a.prototype.global = function(t) {
                return a.rateLimiter.configureGlobal(t), this;
            }, a.prototype.configure = function(t, e) {
                var r = this.options, n = {};
                e && (n = {
                    payload: e
                }), this.options = s.merge(r, t, n);
                var o = this.options.tracer || null;
                return c(o) ? (this.tracer = o, this.options.tracer = "opentracing-tracer-enabled", this.options._configuredOptions.tracer = "opentracing-tracer-enabled") : this.tracer = null, this.notifier && this.notifier.configure(this.options), this.telemeter && this.telemeter.configure(this.options), u(t), this.global(this.options), c(t.tracer) && (this.tracer = t.tracer), this;
            }, a.prototype.log = function(t) {
                var e = this._defaultLogLevel();
                return this._log(e, t);
            }, a.prototype.debug = function(t) {
                this._log("debug", t);
            }, a.prototype.info = function(t) {
                this._log("info", t);
            }, a.prototype.warn = function(t) {
                this._log("warning", t);
            }, a.prototype.warning = function(t) {
                this._log("warning", t);
            }, a.prototype.error = function(t) {
                this._log("error", t);
            }, a.prototype.critical = function(t) {
                this._log("critical", t);
            }, a.prototype.wait = function(t) {
                this.queue.wait(t);
            }, a.prototype.captureEvent = function(t, e, r) {
                return this.telemeter && this.telemeter.captureEvent(t, e, r);
            }, a.prototype.captureDomContentLoaded = function(t) {
                return this.telemeter && this.telemeter.captureDomContentLoaded(t);
            }, a.prototype.captureLoad = function(t) {
                return this.telemeter && this.telemeter.captureLoad(t);
            }, a.prototype.buildJsonPayload = function(t) {
                return this.api.buildJsonPayload(t);
            }, a.prototype.sendJsonPayload = function(t) {
                this.api.postJsonPayload(t);
            }, a.prototype._log = function(t, e) {
                var r;
                if (e.callback && (r = e.callback, delete e.callback), this.options.ignoreDuplicateErrors && this._sameAsLastError(e)) {
                    if (r) {
                        var n = new Error("ignored identical item");
                        n.item = e, r(n);
                    }
                } else try {
                    this._addTracingInfo(e), e.level = e.level || t, this.telemeter && this.telemeter._captureRollbarItem(e), e.telemetryEvents = this.telemeter && this.telemeter.copyEvents() || [], this.notifier.log(e, r);
                } catch (t) {
                    r && r(t), this.logger.error(t);
                }
            }, a.prototype._defaultLogLevel = function() {
                return this.options.logLevel || "debug";
            }, a.prototype._sameAsLastError = function(t) {
                if (!t._isUncaught) return !1;
                var e = function(t) {
                    var e = t.message || "", r = (t.err || {}).stack || String(t.err);
                    return e + "::" + r;
                }(t);
                return this.lastErrorHash === e || (this.lastError = t.err, this.lastErrorHash = e, !1);
            }, a.prototype._addTracingInfo = function(t) {
                if (this.tracer) {
                    var e = this.tracer.scope().active();
                    if (function(t) {
                        if (!t || !t.context || "function" != typeof t.context) return !1;
                        var e = t.context();
                        if (!e || !e.toSpanId || !e.toTraceId || "function" != typeof e.toSpanId || "function" != typeof e.toTraceId) return !1;
                        return !0;
                    }(e)) {
                        e.setTag("rollbar.error_uuid", t.uuid), e.setTag("rollbar.has_error", !0), e.setTag("error", !0), e.setTag("rollbar.item_url", "https://rollbar.com/item/uuid/?uuid=" + t.uuid), e.setTag("rollbar.occurrence_url", "https://rollbar.com/occurrence/uuid/?uuid=" + t.uuid);
                        var r = e.context().toSpanId(), n = e.context().toTraceId();
                        t.custom ? (t.custom.opentracing_span_id = r, t.custom.opentracing_trace_id = n) : t.custom = {
                            opentracing_span_id: r,
                            opentracing_trace_id: n
                        };
                    }
                }
            }, t.exports = a;
        },
        function(t, e, r) {
            "use strict";
            var n = r(0);
            function o(t) {
                this.startTime = n.now(), this.counter = 0, this.perMinCounter = 0, this.platform = null, this.platformOptions = {}, this.configureGlobal(t);
            }
            function i(t, e, r) {
                return !t.ignoreRateLimit && e >= 1 && r > e;
            }
            function s(t, e, r, n, o, i, s) {
                var a = null;
                return r && (r = new Error(r)), r || n || (a = function(t, e, r, n, o) {
                    var i, s = e.environment || e.payload && e.payload.environment;
                    i = o ? "item per minute limit reached, ignoring errors until timeout" : "maxItems has been hit, ignoring errors until reset.";
                    var a = {
                        body: {
                            message: {
                                body: i,
                                extra: {
                                    maxItems: r,
                                    itemsPerMinute: n
                                }
                            }
                        },
                        language: "javascript",
                        environment: s,
                        notifier: {
                            version: e.notifier && e.notifier.version || e.version
                        }
                    };
                    "browser" === t ? (a.platform = "browser", a.framework = "browser-js", a.notifier.name = "rollbar-browser-js") : "server" === t ? (a.framework = e.framework || "node-js", a.notifier.name = e.notifier.name) : "react-native" === t && (a.framework = e.framework || "react-native", a.notifier.name = e.notifier.name);
                    return a;
                }(t, e, o, i, s)), {
                    error: r,
                    shouldSend: n,
                    payload: a
                };
            }
            o.globalSettings = {
                startTime: n.now(),
                maxItems: void 0,
                itemsPerMinute: void 0
            }, o.prototype.configureGlobal = function(t) {
                void 0 !== t.startTime && (o.globalSettings.startTime = t.startTime), void 0 !== t.maxItems && (o.globalSettings.maxItems = t.maxItems), void 0 !== t.itemsPerMinute && (o.globalSettings.itemsPerMinute = t.itemsPerMinute);
            }, o.prototype.shouldSend = function(t, e) {
                var r = (e = e || n.now()) - this.startTime;
                (r < 0 || r >= 6e4) && (this.startTime = e, this.perMinCounter = 0);
                var a = o.globalSettings.maxItems, u = o.globalSettings.itemsPerMinute;
                if (i(t, a, this.counter)) return s(this.platform, this.platformOptions, a + " max items reached", !1);
                if (i(t, u, this.perMinCounter)) return s(this.platform, this.platformOptions, u + " items per minute reached", !1);
                this.counter++, this.perMinCounter++;
                var c = !i(t, a, this.counter), l = c;
                return c = c && !i(t, u, this.perMinCounter), s(this.platform, this.platformOptions, null, c, a, u, l);
            }, o.prototype.setPlatformOptions = function(t, e) {
                this.platform = t, this.platformOptions = e;
            }, t.exports = o;
        },
        function(t, e, r) {
            "use strict";
            var n = Object.prototype.hasOwnProperty, o = Object.prototype.toString, i = function(t) {
                if (!t || "[object Object]" !== o.call(t)) return !1;
                var e, r = n.call(t, "constructor"), i = t.constructor && t.constructor.prototype && n.call(t.constructor.prototype, "isPrototypeOf");
                if (t.constructor && !r && !i) return !1;
                for(e in t);
                return void 0 === e || n.call(t, e);
            };
            t.exports = function t() {
                var e, r, n, o, s, a = {}, u = null, c = arguments.length;
                for(e = 0; e < c; e++)if (null != (u = arguments[e])) for(s in u)r = a[s], a !== (n = u[s]) && (n && i(n) ? (o = r && i(r) ? r : {}, a[s] = t(o, n)) : void 0 !== n && (a[s] = n));
                return a;
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(0);
            function o(t, e, r, n) {
                this.rateLimiter = t, this.api = e, this.logger = r, this.options = n, this.predicates = [], this.pendingItems = [], this.pendingRequests = [], this.retryQueue = [], this.retryHandle = null, this.waitCallback = null, this.waitIntervalID = null;
            }
            o.prototype.configure = function(t) {
                this.api && this.api.configure(t);
                var e = this.options;
                return this.options = n.merge(e, t), this;
            }, o.prototype.addPredicate = function(t) {
                return n.isFunction(t) && this.predicates.push(t), this;
            }, o.prototype.addPendingItem = function(t) {
                this.pendingItems.push(t);
            }, o.prototype.removePendingItem = function(t) {
                var e = this.pendingItems.indexOf(t);
                -1 !== e && this.pendingItems.splice(e, 1);
            }, o.prototype.addItem = function(t, e, r, o) {
                e && n.isFunction(e) || (e = function() {});
                var i = this._applyPredicates(t);
                if (i.stop) return this.removePendingItem(o), void e(i.err);
                if (this._maybeLog(t, r), this.removePendingItem(o), this.options.transmit) {
                    this.pendingRequests.push(t);
                    try {
                        this._makeApiRequest(t, (function(r, n) {
                            this._dequeuePendingRequest(t), e(r, n);
                        }).bind(this));
                    } catch (r) {
                        this._dequeuePendingRequest(t), e(r);
                    }
                } else e(new Error("Transmit disabled"));
            }, o.prototype.wait = function(t) {
                n.isFunction(t) && (this.waitCallback = t, this._maybeCallWait() || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitIntervalID = setInterval((function() {
                    this._maybeCallWait();
                }).bind(this), 500)));
            }, o.prototype._applyPredicates = function(t) {
                for(var e = null, r = 0, n = this.predicates.length; r < n; r++)if (!(e = this.predicates[r](t, this.options)) || void 0 !== e.err) return {
                    stop: !0,
                    err: e.err
                };
                return {
                    stop: !1,
                    err: null
                };
            }, o.prototype._makeApiRequest = function(t, e) {
                var r = this.rateLimiter.shouldSend(t);
                r.shouldSend ? this.api.postItem(t, (function(r, n) {
                    r ? this._maybeRetry(r, t, e) : e(r, n);
                }).bind(this)) : r.error ? e(r.error) : this.api.postItem(r.payload, e);
            };
            var i = [
                "ECONNRESET",
                "ENOTFOUND",
                "ESOCKETTIMEDOUT",
                "ETIMEDOUT",
                "ECONNREFUSED",
                "EHOSTUNREACH",
                "EPIPE",
                "EAI_AGAIN"
            ];
            o.prototype._maybeRetry = function(t, e, r) {
                var o = !1;
                if (this.options.retryInterval) {
                    for(var s = 0, a = i.length; s < a; s++)if (t.code === i[s]) {
                        o = !0;
                        break;
                    }
                    o && n.isFiniteNumber(this.options.maxRetries) && (e.retries = e.retries ? e.retries + 1 : 1, e.retries > this.options.maxRetries && (o = !1));
                }
                o ? this._retryApiRequest(e, r) : r(t);
            }, o.prototype._retryApiRequest = function(t, e) {
                this.retryQueue.push({
                    item: t,
                    callback: e
                }), this.retryHandle || (this.retryHandle = setInterval((function() {
                    for(; this.retryQueue.length;){
                        var t = this.retryQueue.shift();
                        this._makeApiRequest(t.item, t.callback);
                    }
                }).bind(this), this.options.retryInterval));
            }, o.prototype._dequeuePendingRequest = function(t) {
                var e = this.pendingRequests.indexOf(t);
                -1 !== e && (this.pendingRequests.splice(e, 1), this._maybeCallWait());
            }, o.prototype._maybeLog = function(t, e) {
                if (this.logger && this.options.verbose) {
                    var r = e;
                    if (r = (r = r || n.get(t, "body.trace.exception.message")) || n.get(t, "body.trace_chain.0.exception.message")) return void this.logger.error(r);
                    (r = n.get(t, "body.message.body")) && this.logger.log(r);
                }
            }, o.prototype._maybeCallWait = function() {
                return !(!n.isFunction(this.waitCallback) || 0 !== this.pendingItems.length || 0 !== this.pendingRequests.length) && (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitCallback(), !0);
            }, t.exports = o;
        },
        function(t, e, r) {
            "use strict";
            var n = r(0);
            function o(t, e) {
                this.queue = t, this.options = e, this.transforms = [], this.diagnostic = {};
            }
            o.prototype.configure = function(t) {
                this.queue && this.queue.configure(t);
                var e = this.options;
                return this.options = n.merge(e, t), this;
            }, o.prototype.addTransform = function(t) {
                return n.isFunction(t) && this.transforms.push(t), this;
            }, o.prototype.log = function(t, e) {
                if (e && n.isFunction(e) || (e = function() {}), !this.options.enabled) return e(new Error("Rollbar is not enabled"));
                this.queue.addPendingItem(t);
                var r = t.err;
                this._applyTransforms(t, (function(n, o) {
                    if (n) return this.queue.removePendingItem(t), e(n, null);
                    this.queue.addItem(o, e, r, t);
                }).bind(this));
            }, o.prototype._applyTransforms = function(t, e) {
                var r = -1, n = this.transforms.length, o = this.transforms, i = this.options, s = function(t, a) {
                    t ? e(t, null) : ++r !== n ? o[r](a, i, s) : e(null, a);
                };
                s(null, t);
            }, t.exports = o;
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(16), i = {
                hostname: "api.rollbar.com",
                path: "/api/1/item/",
                search: null,
                version: "1",
                protocol: "https:",
                port: 443
            };
            function s(t, e, r, n, o) {
                this.options = t, this.transport = e, this.url = r, this.truncation = n, this.jsonBackup = o, this.accessToken = t.accessToken, this.transportOptions = a(t, r);
            }
            function a(t, e) {
                return o.getTransportFromOptions(t, i, e);
            }
            s.prototype.postItem = function(t, e) {
                var r = o.transportOptions(this.transportOptions, "POST"), n = o.buildPayload(this.accessToken, t, this.jsonBackup), i = this;
                setTimeout(function() {
                    i.transport.post(i.accessToken, r, n, e);
                }, 0);
            }, s.prototype.buildJsonPayload = function(t, e) {
                var r, i = o.buildPayload(this.accessToken, t, this.jsonBackup);
                return (r = this.truncation ? this.truncation.truncate(i) : n.stringify(i)).error ? (e && e(r.error), null) : r.value;
            }, s.prototype.postJsonPayload = function(t, e) {
                var r = o.transportOptions(this.transportOptions, "POST");
                this.transport.postJsonPayload(this.accessToken, r, t, e);
            }, s.prototype.configure = function(t) {
                var e = this.oldOptions;
                return this.options = n.merge(e, t), this.transportOptions = a(this.options, this.url), void 0 !== this.options.accessToken && (this.accessToken = this.options.accessToken), this;
            }, t.exports = s;
        },
        function(t, e, r) {
            "use strict";
            var n = r(0);
            t.exports = {
                buildPayload: function(t, e, r) {
                    if (!n.isType(e.context, "string")) {
                        var o = n.stringify(e.context, r);
                        o.error ? e.context = "Error: could not serialize 'context'" : e.context = o.value || "", e.context.length > 255 && (e.context = e.context.substr(0, 255));
                    }
                    return {
                        access_token: t,
                        data: e
                    };
                },
                getTransportFromOptions: function(t, e, r) {
                    var n = e.hostname, o = e.protocol, i = e.port, s = e.path, a = e.search, u = t.timeout, c = function(t) {
                        var e = "undefined" != typeof window && window || "undefined" != typeof self && self, r = t.defaultTransport || "xhr";
                        void 0 === e.fetch && (r = "xhr");
                        void 0 === e.XMLHttpRequest && (r = "fetch");
                        return r;
                    }(t), l = t.proxy;
                    if (t.endpoint) {
                        var p = r.parse(t.endpoint);
                        n = p.hostname, o = p.protocol, i = p.port, s = p.pathname, a = p.search;
                    }
                    return {
                        timeout: u,
                        hostname: n,
                        protocol: o,
                        port: i,
                        path: s,
                        search: a,
                        proxy: l,
                        transport: c
                    };
                },
                transportOptions: function(t, e) {
                    var r = t.protocol || "https:", n = t.port || ("http:" === r ? 80 : "https:" === r ? 443 : void 0), o = t.hostname, i = t.path, s = t.timeout, a = t.transport;
                    return t.search && (i += t.search), t.proxy && (i = r + "//" + o + i, o = t.proxy.host || t.proxy.hostname, n = t.proxy.port, r = t.proxy.protocol || r), {
                        timeout: s,
                        protocol: r,
                        hostname: o,
                        path: i,
                        port: n,
                        method: e,
                        transport: a
                    };
                },
                appendPathToPath: function(t, e) {
                    var r = /\/$/.test(t), n = /^\//.test(e);
                    return r && n ? e = e.substring(1) : r || n || (e = "/" + e), t + e;
                }
            };
        },
        function(t, e) {
            !function(t) {
                "use strict";
                t.console || (t.console = {});
                for(var e, r, n = t.console, o = function() {}, i = [
                    "memory"
                ], s = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); e = i.pop();)n[e] || (n[e] = {});
                for(; r = s.pop();)n[r] || (n[r] = o);
            }("undefined" == typeof window ? this : window);
        },
        function(t, e, r) {
            "use strict";
            var n = {
                ieVersion: function() {
                    if ("undefined" != typeof document) {
                        for(var t = 3, e = document.createElement("div"), r = e.getElementsByTagName("i"); e.innerHTML = "\x3c!--[if gt IE " + ++t + "]><i></i><![endif]--\x3e", r[0];);
                        return t > 4 ? t : void 0;
                    }
                }
            };
            t.exports = n;
        },
        function(t, e, r) {
            "use strict";
            function n(t, e, r, n) {
                t._rollbarWrappedError && (n[4] || (n[4] = t._rollbarWrappedError), n[5] || (n[5] = t._rollbarWrappedError._rollbarContext), t._rollbarWrappedError = null);
                var o = e.handleUncaughtException.apply(e, n);
                r && r.apply(t, n), "anonymous" === o && (e.anonymousErrorsPending += 1);
            }
            t.exports = {
                captureUncaughtExceptions: function(t, e, r) {
                    if (t) {
                        var o;
                        if ("function" == typeof e._rollbarOldOnError) o = e._rollbarOldOnError;
                        else if (t.onerror) {
                            for(o = t.onerror; o._rollbarOldOnError;)o = o._rollbarOldOnError;
                            e._rollbarOldOnError = o;
                        }
                        e.handleAnonymousErrors();
                        var i = function() {
                            var r = Array.prototype.slice.call(arguments, 0);
                            n(t, e, o, r);
                        };
                        r && (i._rollbarOldOnError = o), t.onerror = i;
                    }
                },
                captureUnhandledRejections: function(t, e, r) {
                    if (t) {
                        "function" == typeof t._rollbarURH && t._rollbarURH.belongsToShim && t.removeEventListener("unhandledrejection", t._rollbarURH);
                        var n = function(t) {
                            var r, n, o;
                            try {
                                r = t.reason;
                            } catch (t) {
                                r = void 0;
                            }
                            try {
                                n = t.promise;
                            } catch (t) {
                                n = "[unhandledrejection] error getting `promise` from event";
                            }
                            try {
                                o = t.detail, !r && o && (r = o.reason, n = o.promise);
                            } catch (t) {}
                            r || (r = "[unhandledrejection] error getting `reason` from event"), e && e.handleUnhandledRejection && e.handleUnhandledRejection(r, n);
                        };
                        n.belongsToShim = r, t._rollbarURH = n, t.addEventListener("unhandledrejection", n);
                    }
                }
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(21), i = r(22);
            function s(t) {
                this.truncation = t;
            }
            s.prototype.get = function(t, e, r, o, i) {
                o && n.isFunction(o) || (o = function() {}), n.addParamsAndAccessTokenToPath(t, e, r);
                var s = n.formatUrl(e);
                this._makeZoneRequest(t, s, "GET", null, o, i, e.timeout, e.transport);
            }, s.prototype.post = function(t, e, r, o, i) {
                if (o && n.isFunction(o) || (o = function() {}), !r) return o(new Error("Cannot send empty request"));
                var s;
                if ((s = this.truncation ? this.truncation.truncate(r) : n.stringify(r)).error) return o(s.error);
                var a = s.value, u = n.formatUrl(e);
                this._makeZoneRequest(t, u, "POST", a, o, i, e.timeout, e.transport);
            }, s.prototype.postJsonPayload = function(t, e, r, o, i) {
                o && n.isFunction(o) || (o = function() {});
                var s = n.formatUrl(e);
                this._makeZoneRequest(t, s, "POST", r, o, i, e.timeout, e.transport);
            }, s.prototype._makeZoneRequest = function() {
                var t = "undefined" != typeof window && window || void 0 !== o && o, e = t && t.Zone && t.Zone.current, r = Array.prototype.slice.call(arguments);
                if (e && "angular" === e._name) {
                    var n = e._parent, o = this;
                    n.run(function() {
                        o._makeRequest.apply(void 0, r);
                    });
                } else this._makeRequest.apply(void 0, r);
            }, s.prototype._makeRequest = function(t, e, r, n, s, a, u, c) {
                if ("undefined" != typeof RollbarProxy) return function(t, e) {
                    (new RollbarProxy).sendJsonPayload(t, function(t) {}, function(t) {
                        e(new Error(t));
                    });
                }(n, s);
                "fetch" === c ? o(t, e, r, n, s, u) : i(t, e, r, n, s, a, u);
            }, t.exports = s;
        },
        function(t, e, r) {
            "use strict";
            var n = r(1), o = r(0);
            t.exports = function(t, e, r, i, s, a) {
                var u, c;
                o.isFiniteNumber(a) && (u = new AbortController, c = setTimeout(function() {
                    u.abort();
                }, a)), fetch(e, {
                    method: r,
                    headers: {
                        "Content-Type": "application/json",
                        "X-Rollbar-Access-Token": t,
                        signal: u && u.signal
                    },
                    body: i
                }).then(function(t) {
                    return c && clearTimeout(c), t.json();
                }).then(function(t) {
                    s(null, t);
                }).catch(function(t) {
                    n.error(t.message), s(t);
                });
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(1);
            function i(t, e) {
                var r = new Error(t);
                return r.code = e || "ENOTFOUND", r;
            }
            t.exports = function(t, e, r, s, a, u, c) {
                var l;
                if (!(l = u ? u() : function() {
                    var t, e, r = [
                        function() {
                            return new XMLHttpRequest;
                        },
                        function() {
                            return new ActiveXObject("Msxml2.XMLHTTP");
                        },
                        function() {
                            return new ActiveXObject("Msxml3.XMLHTTP");
                        },
                        function() {
                            return new ActiveXObject("Microsoft.XMLHTTP");
                        }
                    ], n = r.length;
                    for(e = 0; e < n; e++)try {
                        t = r[e]();
                        break;
                    } catch (t) {}
                    return t;
                }())) return a(new Error("No way to send a request"));
                try {
                    try {
                        var p = function() {
                            try {
                                if (p && 4 === l.readyState) {
                                    p = void 0;
                                    var t = n.jsonParse(l.responseText);
                                    if ((s = l) && s.status && 200 === s.status) return void a(t.error, t.value);
                                    if (function(t) {
                                        return t && n.isType(t.status, "number") && t.status >= 400 && t.status < 600;
                                    }(l)) {
                                        if (403 === l.status) {
                                            var e = t.value && t.value.message;
                                            o.error(e);
                                        }
                                        a(new Error(String(l.status)));
                                    } else a(i("XHR response had no status code (likely connection failure)"));
                                }
                            } catch (t) {
                                var r;
                                r = t && t.stack ? t : new Error(t), a(r);
                            }
                            var s;
                        };
                        l.open(r, e, !0), l.setRequestHeader && (l.setRequestHeader("Content-Type", "application/json"), l.setRequestHeader("X-Rollbar-Access-Token", t)), n.isFiniteNumber(c) && (l.timeout = c), l.onreadystatechange = p, l.send(s);
                    } catch (t) {
                        if ("undefined" != typeof XDomainRequest) {
                            if (!window || !window.location) return a(new Error("No window available during request, unknown environment"));
                            "http:" === window.location.href.substring(0, 5) && "https" === e.substring(0, 5) && (e = "http" + e.substring(5));
                            var f = new XDomainRequest;
                            f.onprogress = function() {}, f.ontimeout = function() {
                                a(i("Request timed out", "ETIMEDOUT"));
                            }, f.onerror = function() {
                                a(new Error("Error during request"));
                            }, f.onload = function() {
                                var t = n.jsonParse(f.responseText);
                                a(t.error, t.value);
                            }, f.open(r, e, !0), f.send(s);
                        } else a(new Error("Cannot find a method to transport a request"));
                    }
                } catch (t) {
                    a(t);
                }
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(3), i = r(1);
            function s(t, e, r) {
                var o = t.message, i = t.custom;
                o || (o = "Item sent with null or missing arguments.");
                var s = {
                    body: o
                };
                i && (s.extra = n.merge(i)), n.set(t, "data.body", {
                    message: s
                }), r(null, t);
            }
            function a(t) {
                var e = t.stackInfo.stack;
                return e && 0 === e.length && t._unhandledStackInfo && t._unhandledStackInfo.stack && (e = t._unhandledStackInfo.stack), e;
            }
            function u(t, e, r) {
                var i = t && t.data.description, s = t && t.custom, u = a(t), l = o.guessErrorClass(e.message), p = {
                    exception: {
                        class: c(e, l[0], r),
                        message: l[1]
                    }
                };
                if (i && (p.exception.description = i), u) {
                    var f, h, d, m, g, v, y, b;
                    for(0 === u.length && (p.exception.stack = e.rawStack, p.exception.raw = String(e.rawException)), p.frames = [], y = 0; y < u.length; ++y)h = {
                        filename: (f = u[y]).url ? n.sanitizeUrl(f.url) : "(unknown)",
                        lineno: f.line || null,
                        method: f.func && "?" !== f.func ? f.func : "[anonymous]",
                        colno: f.column
                    }, r.sendFrameUrl && (h.url = f.url), h.method && h.method.endsWith && h.method.endsWith("_rollbar_wrapped") || (d = m = g = null, (v = f.context ? f.context.length : 0) && (b = Math.floor(v / 2), m = f.context.slice(0, b), d = f.context[b], g = f.context.slice(b)), d && (h.code = d), (m || g) && (h.context = {}, m && m.length && (h.context.pre = m), g && g.length && (h.context.post = g)), f.args && (h.args = f.args), p.frames.push(h));
                    p.frames.reverse(), s && (p.extra = n.merge(s));
                }
                return p;
            }
            function c(t, e, r) {
                return t.name ? t.name : r.guessErrorClass ? e : "(unknown)";
            }
            t.exports = {
                handleDomException: function(t, e, r) {
                    if (t.err && "DOMException" === o.Stack(t.err).name) {
                        var n = new Error;
                        n.name = t.err.name, n.message = t.err.message, n.stack = t.err.stack, n.nested = t.err, t.err = n;
                    }
                    r(null, t);
                },
                handleItemWithError: function(t, e, r) {
                    if (t.data = t.data || {}, t.err) try {
                        t.stackInfo = t.err._savedStackTrace || o.parse(t.err, t.skipFrames), e.addErrorContext && function(t) {
                            var e = [], r = t.err;
                            e.push(r);
                            for(; r.nested || r.cause;)r = r.nested || r.cause, e.push(r);
                            n.addErrorContext(t, e);
                        }(t);
                    } catch (e) {
                        i.error("Error while parsing the error object.", e);
                        try {
                            t.message = t.err.message || t.err.description || t.message || String(t.err);
                        } catch (e) {
                            t.message = String(t.err) || String(e);
                        }
                        delete t.err;
                    }
                    r(null, t);
                },
                ensureItemHasSomethingToSay: function(t, e, r) {
                    t.message || t.stackInfo || t.custom || r(new Error("No message, stack info, or custom data"), null), r(null, t);
                },
                addBaseInfo: function(t, e, r) {
                    var o = e.payload && e.payload.environment || e.environment;
                    t.data = n.merge(t.data, {
                        environment: o,
                        level: t.level,
                        endpoint: e.endpoint,
                        platform: "browser",
                        framework: "browser-js",
                        language: "javascript",
                        server: {},
                        uuid: t.uuid,
                        notifier: {
                            name: "rollbar-browser-js",
                            version: e.version
                        },
                        custom: t.custom
                    }), r(null, t);
                },
                addRequestInfo: function(t) {
                    return function(e, r, o) {
                        var i = {};
                        t && t.location && (i.url = t.location.href, i.query_string = t.location.search);
                        var s = "$remote_ip";
                        r.captureIp ? !0 !== r.captureIp && (s += "_anonymize") : s = null, s && (i.user_ip = s), Object.keys(i).length > 0 && n.set(e, "data.request", i), o(null, e);
                    };
                },
                addClientInfo: function(t) {
                    return function(e, r, o) {
                        if (!t) return o(null, e);
                        var i = t.navigator || {}, s = t.screen || {};
                        n.set(e, "data.client", {
                            runtime_ms: e.timestamp - t._rollbarStartTime,
                            timestamp: Math.round(e.timestamp / 1e3),
                            javascript: {
                                browser: i.userAgent,
                                language: i.language,
                                cookie_enabled: i.cookieEnabled,
                                screen: {
                                    width: s.width,
                                    height: s.height
                                }
                            }
                        }), o(null, e);
                    };
                },
                addPluginInfo: function(t) {
                    return function(e, r, o) {
                        if (!t || !t.navigator) return o(null, e);
                        for(var i, s = [], a = t.navigator.plugins || [], u = 0, c = a.length; u < c; ++u)i = a[u], s.push({
                            name: i.name,
                            description: i.description
                        });
                        n.set(e, "data.client.javascript.plugins", s), o(null, e);
                    };
                },
                addBody: function(t, e, r) {
                    t.stackInfo ? t.stackInfo.traceChain ? function(t, e, r) {
                        for(var o = t.stackInfo.traceChain, i = [], s = o.length, a = 0; a < s; a++){
                            var c = u(t, o[a], e);
                            i.push(c);
                        }
                        n.set(t, "data.body", {
                            trace_chain: i
                        }), r(null, t);
                    }(t, e, r) : function(t, e, r) {
                        if (a(t)) {
                            var i = u(t, t.stackInfo, e);
                            n.set(t, "data.body", {
                                trace: i
                            }), r(null, t);
                        } else {
                            var l = t.stackInfo, p = o.guessErrorClass(l.message), f = c(l, p[0], e), h = p[1];
                            t.message = f + ": " + h, s(t, e, r);
                        }
                    }(t, e, r) : s(t, e, r);
                },
                addScrubber: function(t) {
                    return function(e, r, n) {
                        if (t) {
                            var o = r.scrubFields || [], i = r.scrubPaths || [];
                            e.data = t(e.data, o, i);
                        }
                        n(null, e);
                    };
                }
            };
        },
        function(t, e, r) {
            var n, o, i;
            !function(s, a) {
                "use strict";
                o = [
                    r(25)
                ], void 0 === (i = "function" == typeof (n = function(t) {
                    var e = /(^|@)\S+:\d+/, r = /^\s*at .*(\S+:\d+|\(native\))/m, n = /^(eval@)?(\[native code])?$/;
                    return {
                        parse: function(t) {
                            if (void 0 !== t.stacktrace || void 0 !== t["opera#sourceloc"]) return this.parseOpera(t);
                            if (t.stack && t.stack.match(r)) return this.parseV8OrIE(t);
                            if (t.stack) return this.parseFFOrSafari(t);
                            throw new Error("Cannot parse given Error object");
                        },
                        extractLocation: function(t) {
                            if (-1 === t.indexOf(":")) return [
                                t
                            ];
                            var e = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(t.replace(/[()]/g, ""));
                            return [
                                e[1],
                                e[2] || void 0,
                                e[3] || void 0
                            ];
                        },
                        parseV8OrIE: function(e) {
                            return e.stack.split("\n").filter(function(t) {
                                return !!t.match(r);
                            }, this).map(function(e) {
                                e.indexOf("(eval ") > -1 && (e = e.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, ""));
                                var r = e.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, ""), n = r.match(/ (\(.+\)$)/);
                                r = n ? r.replace(n[0], "") : r;
                                var o = this.extractLocation(n ? n[1] : r), i = n && r || void 0, s = [
                                    "eval",
                                    "<anonymous>"
                                ].indexOf(o[0]) > -1 ? void 0 : o[0];
                                return new t({
                                    functionName: i,
                                    fileName: s,
                                    lineNumber: o[1],
                                    columnNumber: o[2],
                                    source: e
                                });
                            }, this);
                        },
                        parseFFOrSafari: function(e) {
                            return e.stack.split("\n").filter(function(t) {
                                return !t.match(n);
                            }, this).map(function(e) {
                                if (e.indexOf(" > eval") > -1 && (e = e.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), -1 === e.indexOf("@") && -1 === e.indexOf(":")) return new t({
                                    functionName: e
                                });
                                var r = /((.*".+"[^@]*)?[^@]*)(?:@)/, n = e.match(r), o = n && n[1] ? n[1] : void 0, i = this.extractLocation(e.replace(r, ""));
                                return new t({
                                    functionName: o,
                                    fileName: i[0],
                                    lineNumber: i[1],
                                    columnNumber: i[2],
                                    source: e
                                });
                            }, this);
                        },
                        parseOpera: function(t) {
                            return !t.stacktrace || t.message.indexOf("\n") > -1 && t.message.split("\n").length > t.stacktrace.split("\n").length ? this.parseOpera9(t) : t.stack ? this.parseOpera11(t) : this.parseOpera10(t);
                        },
                        parseOpera9: function(e) {
                            for(var r = /Line (\d+).*script (?:in )?(\S+)/i, n = e.message.split("\n"), o = [], i = 2, s = n.length; i < s; i += 2){
                                var a = r.exec(n[i]);
                                a && o.push(new t({
                                    fileName: a[2],
                                    lineNumber: a[1],
                                    source: n[i]
                                }));
                            }
                            return o;
                        },
                        parseOpera10: function(e) {
                            for(var r = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, n = e.stacktrace.split("\n"), o = [], i = 0, s = n.length; i < s; i += 2){
                                var a = r.exec(n[i]);
                                a && o.push(new t({
                                    functionName: a[3] || void 0,
                                    fileName: a[2],
                                    lineNumber: a[1],
                                    source: n[i]
                                }));
                            }
                            return o;
                        },
                        parseOpera11: function(r) {
                            return r.stack.split("\n").filter(function(t) {
                                return !!t.match(e) && !t.match(/^Error created at/);
                            }, this).map(function(e) {
                                var r, n = e.split("@"), o = this.extractLocation(n.pop()), i = n.shift() || "", s = i.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
                                i.match(/\(([^)]*)\)/) && (r = i.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
                                var a = void 0 === r || "[arguments not available]" === r ? void 0 : r.split(",");
                                return new t({
                                    functionName: s,
                                    args: a,
                                    fileName: o[0],
                                    lineNumber: o[1],
                                    columnNumber: o[2],
                                    source: e
                                });
                            }, this);
                        }
                    };
                }) ? n.apply(e, o) : n) || (t.exports = i);
            }();
        },
        function(t, e, r) {
            var n, o, i;
            !function(r, s) {
                "use strict";
                o = [], void 0 === (i = "function" == typeof (n = function() {
                    function t(t) {
                        return t.charAt(0).toUpperCase() + t.substring(1);
                    }
                    function e(t) {
                        return function() {
                            return this[t];
                        };
                    }
                    var r = [
                        "isConstructor",
                        "isEval",
                        "isNative",
                        "isToplevel"
                    ], n = [
                        "columnNumber",
                        "lineNumber"
                    ], o = [
                        "fileName",
                        "functionName",
                        "source"
                    ], i = r.concat(n, o, [
                        "args"
                    ], [
                        "evalOrigin"
                    ]);
                    function s(e) {
                        if (e) for(var r = 0; r < i.length; r++)void 0 !== e[i[r]] && this["set" + t(i[r])](e[i[r]]);
                    }
                    s.prototype = {
                        getArgs: function() {
                            return this.args;
                        },
                        setArgs: function(t) {
                            if ("[object Array]" !== Object.prototype.toString.call(t)) throw new TypeError("Args must be an Array");
                            this.args = t;
                        },
                        getEvalOrigin: function() {
                            return this.evalOrigin;
                        },
                        setEvalOrigin: function(t) {
                            if (t instanceof s) this.evalOrigin = t;
                            else {
                                if (!(t instanceof Object)) throw new TypeError("Eval Origin must be an Object or StackFrame");
                                this.evalOrigin = new s(t);
                            }
                        },
                        toString: function() {
                            var t = this.getFileName() || "", e = this.getLineNumber() || "", r = this.getColumnNumber() || "", n = this.getFunctionName() || "";
                            return this.getIsEval() ? t ? "[eval] (" + t + ":" + e + ":" + r + ")" : "[eval]:" + e + ":" + r : n ? n + " (" + t + ":" + e + ":" + r + ")" : t + ":" + e + ":" + r;
                        }
                    }, s.fromString = function(t) {
                        var e = t.indexOf("("), r = t.lastIndexOf(")"), n = t.substring(0, e), o = t.substring(e + 1, r).split(","), i = t.substring(r + 1);
                        if (0 === i.indexOf("@")) var a = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(i, ""), u = a[1], c = a[2], l = a[3];
                        return new s({
                            functionName: n,
                            args: o || void 0,
                            fileName: u,
                            lineNumber: c || void 0,
                            columnNumber: l || void 0
                        });
                    };
                    for(var a = 0; a < r.length; a++)s.prototype["get" + t(r[a])] = e(r[a]), s.prototype["set" + t(r[a])] = function(t) {
                        return function(e) {
                            this[t] = Boolean(e);
                        };
                    }(r[a]);
                    for(var u = 0; u < n.length; u++)s.prototype["get" + t(n[u])] = e(n[u]), s.prototype["set" + t(n[u])] = function(t) {
                        return function(e) {
                            if (r = e, isNaN(parseFloat(r)) || !isFinite(r)) throw new TypeError(t + " must be a Number");
                            var r;
                            this[t] = Number(e);
                        };
                    }(n[u]);
                    for(var c = 0; c < o.length; c++)s.prototype["get" + t(o[c])] = e(o[c]), s.prototype["set" + t(o[c])] = function(t) {
                        return function(e) {
                            this[t] = String(e);
                        };
                    }(o[c]);
                    return s;
                }) ? n.apply(e, o) : n) || (t.exports = i);
            }();
        },
        function(t, e, r) {
            "use strict";
            var n = r(0);
            function o(t, e) {
                n.isFunction(t[e]) && (t[e] = t[e].toString());
            }
            t.exports = {
                itemToPayload: function(t, e, r) {
                    var n = t.data;
                    t._isUncaught && (n._isUncaught = !0), t._originalArgs && (n._originalArgs = t._originalArgs), r(null, n);
                },
                addPayloadOptions: function(t, e, r) {
                    var o = e.payload || {};
                    o.body && delete o.body, t.data = n.merge(t.data, o), r(null, t);
                },
                addTelemetryData: function(t, e, r) {
                    t.telemetryEvents && n.set(t, "data.body.telemetry", t.telemetryEvents), r(null, t);
                },
                addMessageWithError: function(t, e, r) {
                    if (t.message) {
                        var o = "data.body.trace_chain.0", i = n.get(t, o);
                        if (i || (o = "data.body.trace", i = n.get(t, o)), i) {
                            if (!i.exception || !i.exception.description) return n.set(t, o + ".exception.description", t.message), void r(null, t);
                            var s = n.get(t, o + ".extra") || {}, a = n.merge(s, {
                                message: t.message
                            });
                            n.set(t, o + ".extra", a);
                        }
                        r(null, t);
                    } else r(null, t);
                },
                userTransform: function(t) {
                    return function(e, r, o) {
                        var i = n.merge(e), s = null;
                        try {
                            n.isFunction(r.transform) && (s = r.transform(i.data, e));
                        } catch (n) {
                            return r.transform = null, t.error("Error while calling custom transform() function. Removing custom transform().", n), void o(null, e);
                        }
                        n.isPromise(s) ? s.then(function(t) {
                            t && (i.data = t), o(null, i);
                        }, function(t) {
                            o(t, e);
                        }) : o(null, i);
                    };
                },
                addConfigToPayload: function(t, e, r) {
                    if (!e.sendConfig) return r(null, t);
                    var o = n.get(t, "data.custom") || {};
                    o._rollbarConfig = e, t.data.custom = o, r(null, t);
                },
                addConfiguredOptions: function(t, e, r) {
                    var n = e._configuredOptions;
                    o(n, "transform"), o(n, "checkIgnore"), o(n, "onSendCallback"), delete n.accessToken, t.data.notifier.configured_options = n, r(null, t);
                },
                addDiagnosticKeys: function(t, e, r) {
                    var o = n.merge(t.notifier.client.notifier.diagnostic, t.diagnostic);
                    if (n.get(t, "err._isAnonymous") && (o.is_anonymous = !0), t._isUncaught && (o.is_uncaught = t._isUncaught), t.err) try {
                        o.raw_error = {
                            message: t.err.message,
                            name: t.err.name,
                            constructor_name: t.err.constructor && t.err.constructor.name,
                            filename: t.err.fileName,
                            line: t.err.lineNumber,
                            column: t.err.columnNumber,
                            stack: t.err.stack
                        };
                    } catch (t) {
                        o.raw_error = {
                            failed: String(t)
                        };
                    }
                    t.data.notifier.diagnostic = n.merge(t.data.notifier.diagnostic, o), r(null, t);
                }
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(0);
            t.exports = {
                checkIgnore: function(t, e) {
                    return !n.get(e, "plugins.jquery.ignoreAjaxErrors") || !n.get(t, "body.message.extra.isAjax");
                }
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(0);
            function o(t, e, r) {
                if (!t) return !r;
                var o, i, s = t.frames;
                if (!s || 0 === s.length) return !r;
                for(var a = e.length, u = s.length, c = 0; c < u; c++){
                    if (o = s[c].filename, !n.isType(o, "string")) return !r;
                    for(var l = 0; l < a; l++)if (i = e[l], new RegExp(i).test(o)) return !0;
                }
                return !1;
            }
            function i(t, e, r, i) {
                var s, a, u = !1;
                "blocklist" === r && (u = !0);
                try {
                    if (s = u ? e.hostBlockList : e.hostSafeList, a = n.get(t, "body.trace_chain") || [
                        n.get(t, "body.trace")
                    ], !s || 0 === s.length) return !u;
                    if (0 === a.length || !a[0]) return !u;
                    for(var c = a.length, l = 0; l < c; l++)if (o(a[l], s, u)) return !0;
                } catch (t) {
                    u ? e.hostBlockList = null : e.hostSafeList = null;
                    var p = u ? "hostBlockList" : "hostSafeList";
                    return i.error("Error while reading your configuration's " + p + " option. Removing custom " + p + ".", t), !u;
                }
                return !1;
            }
            t.exports = {
                checkLevel: function(t, e) {
                    var r = t.level, o = n.LEVELS[r] || 0, i = e.reportLevel;
                    return !(o < (n.LEVELS[i] || 0));
                },
                userCheckIgnore: function(t) {
                    return function(e, r) {
                        var o = !!e._isUncaught;
                        delete e._isUncaught;
                        var i = e._originalArgs;
                        delete e._originalArgs;
                        try {
                            n.isFunction(r.onSendCallback) && r.onSendCallback(o, i, e);
                        } catch (e) {
                            r.onSendCallback = null, t.error("Error while calling onSendCallback, removing", e);
                        }
                        try {
                            if (n.isFunction(r.checkIgnore) && r.checkIgnore(o, i, e)) return !1;
                        } catch (e) {
                            r.checkIgnore = null, t.error("Error while calling custom checkIgnore(), removing", e);
                        }
                        return !0;
                    };
                },
                urlIsNotBlockListed: function(t) {
                    return function(e, r) {
                        return !i(e, r, "blocklist", t);
                    };
                },
                urlIsSafeListed: function(t) {
                    return function(e, r) {
                        return i(e, r, "safelist", t);
                    };
                },
                messageIsIgnored: function(t) {
                    return function(e, r) {
                        var o, i, s, a, u, c;
                        try {
                            if (!(s = r.ignoredMessages) || 0 === s.length) return !0;
                            if (0 === (c = function(t) {
                                var e = t.body, r = [];
                                if (e.trace_chain) for(var o = e.trace_chain, i = 0; i < o.length; i++){
                                    var s = o[i];
                                    r.push(n.get(s, "exception.message"));
                                }
                                e.trace && r.push(n.get(e, "trace.exception.message"));
                                e.message && r.push(n.get(e, "message.body"));
                                return r;
                            }(e)).length) return !0;
                            for(a = s.length, o = 0; o < a; o++)for(u = new RegExp(s[o], "gi"), i = 0; i < c.length; i++)if (u.test(c[i])) return !1;
                        } catch (e) {
                            r.ignoredMessages = null, t.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.");
                        }
                        return !0;
                    };
                }
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = {
                version: "2.26.2",
                endpoint: "api.rollbar.com/api/1/item/",
                logLevel: "debug",
                reportLevel: "debug",
                uncaughtErrorLevel: "error",
                maxItems: 0,
                itemsPerMin: 60
            };
        },
        function(t, e, r) {
            "use strict";
            t.exports = {
                scrubFields: [
                    "pw",
                    "pass",
                    "passwd",
                    "password",
                    "secret",
                    "confirm_password",
                    "confirmPassword",
                    "password_confirmation",
                    "passwordConfirmation",
                    "access_token",
                    "accessToken",
                    "X-Rollbar-Access-Token",
                    "secret_key",
                    "secretKey",
                    "secretToken",
                    "cc-number",
                    "card number",
                    "cardnumber",
                    "cardnum",
                    "ccnum",
                    "ccnumber",
                    "cc num",
                    "creditcardnumber",
                    "credit card number",
                    "newcreditcardnumber",
                    "new credit card",
                    "creditcardno",
                    "credit card no",
                    "card#",
                    "card #",
                    "cc-csc",
                    "cvc",
                    "cvc2",
                    "cvv2",
                    "ccv2",
                    "security code",
                    "card verification",
                    "name on credit card",
                    "name on card",
                    "nameoncard",
                    "cardholder",
                    "card holder",
                    "name des karteninhabers",
                    "ccname",
                    "card type",
                    "cardtype",
                    "cc type",
                    "cctype",
                    "payment type",
                    "expiration date",
                    "expirationdate",
                    "expdate",
                    "cc-exp",
                    "ccmonth",
                    "ccyear"
                ]
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(0);
            function o(t) {
                this.queue = [], this.options = n.merge(t);
                var e = this.options.maxTelemetryEvents || 100;
                this.maxQueueSize = Math.max(0, Math.min(e, 100));
            }
            function i(t, e) {
                if (e) return e;
                return ({
                    error: "error",
                    manual: "info"
                })[t] || "info";
            }
            o.prototype.configure = function(t) {
                var e = this.options;
                this.options = n.merge(e, t);
                var r = this.options.maxTelemetryEvents || 100, o = Math.max(0, Math.min(r, 100)), i = 0;
                this.queue.length > o && (i = this.queue.length - o), this.maxQueueSize = o, this.queue.splice(0, i);
            }, o.prototype.copyEvents = function() {
                var t = Array.prototype.slice.call(this.queue, 0);
                if (n.isFunction(this.options.filterTelemetry)) try {
                    for(var e = t.length; e--;)this.options.filterTelemetry(t[e]) && t.splice(e, 1);
                } catch (t) {
                    this.options.filterTelemetry = null;
                }
                return t;
            }, o.prototype.capture = function(t, e, r, o, s) {
                var a = {
                    level: i(t, r),
                    type: t,
                    timestamp_ms: s || n.now(),
                    body: e,
                    source: "client"
                };
                o && (a.uuid = o);
                try {
                    if (n.isFunction(this.options.filterTelemetry) && this.options.filterTelemetry(a)) return !1;
                } catch (t) {
                    this.options.filterTelemetry = null;
                }
                return this.push(a), a;
            }, o.prototype.captureEvent = function(t, e, r, n) {
                return this.capture(t, e, r, n);
            }, o.prototype.captureError = function(t, e, r, n) {
                var o = {
                    message: t.message || String(t)
                };
                return t.stack && (o.stack = t.stack), this.capture("error", o, e, r, n);
            }, o.prototype.captureLog = function(t, e, r, n) {
                return this.capture("log", {
                    message: t
                }, e, r, n);
            }, o.prototype.captureNetwork = function(t, e, r, n) {
                e = e || "xhr", t.subtype = t.subtype || e, n && (t.request = n);
                var o = this.levelFromStatus(t.status_code);
                return this.capture("network", t, o, r);
            }, o.prototype.levelFromStatus = function(t) {
                return t >= 200 && t < 400 ? "info" : 0 === t || t >= 400 ? "error" : "info";
            }, o.prototype.captureDom = function(t, e, r, n, o) {
                var i = {
                    subtype: t,
                    element: e
                };
                return void 0 !== r && (i.value = r), void 0 !== n && (i.checked = n), this.capture("dom", i, "info", o);
            }, o.prototype.captureNavigation = function(t, e, r) {
                return this.capture("navigation", {
                    from: t,
                    to: e
                }, "info", r);
            }, o.prototype.captureDomContentLoaded = function(t) {
                return this.capture("navigation", {
                    subtype: "DOMContentLoaded"
                }, "info", void 0, t && t.getTime());
            }, o.prototype.captureLoad = function(t) {
                return this.capture("navigation", {
                    subtype: "load"
                }, "info", void 0, t && t.getTime());
            }, o.prototype.captureConnectivityChange = function(t, e) {
                return this.captureNetwork({
                    change: t
                }, "connectivity", e);
            }, o.prototype._captureRollbarItem = function(t) {
                if (this.options.includeItemsInTelemetry) return t.err ? this.captureError(t.err, t.level, t.uuid, t.timestamp) : t.message ? this.captureLog(t.message, t.level, t.uuid, t.timestamp) : t.custom ? this.capture("log", t.custom, t.level, t.uuid, t.timestamp) : void 0;
            }, o.prototype.push = function(t) {
                this.queue.push(t), this.queue.length > this.maxQueueSize && this.queue.shift();
            }, t.exports = o;
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(33), i = r(4), s = r(2), a = r(34), u = {
                network: !0,
                networkResponseHeaders: !1,
                networkResponseBody: !1,
                networkRequestHeaders: !1,
                networkRequestBody: !1,
                networkErrorOnHttp5xx: !1,
                networkErrorOnHttp4xx: !1,
                networkErrorOnHttp0: !1,
                log: !0,
                dom: !0,
                navigation: !0,
                connectivity: !0,
                contentSecurityPolicy: !0,
                errorOnContentSecurityPolicy: !1
            };
            function c(t, e, r, n, o) {
                var i = t[e];
                t[e] = r(i), n && n[o].push([
                    t,
                    e,
                    i
                ]);
            }
            function l(t, e) {
                for(var r; t[e].length;)(r = t[e].shift())[0][r[1]] = r[2];
            }
            function p(t, e, r, o, i) {
                this.options = t;
                var s = t.autoInstrument;
                !1 === t.enabled || !1 === s ? this.autoInstrument = {} : (n.isType(s, "object") || (s = u), this.autoInstrument = n.merge(u, s)), this.scrubTelemetryInputs = !!t.scrubTelemetryInputs, this.telemetryScrubber = t.telemetryScrubber, this.defaultValueScrubber = function(t) {
                    for(var e = [], r = 0; r < t.length; ++r)e.push(new RegExp(t[r], "i"));
                    return function(t) {
                        var r = function(t) {
                            if (!t || !t.attributes) return null;
                            for(var e = t.attributes, r = 0; r < e.length; ++r)if ("name" === e[r].key) return e[r].value;
                            return null;
                        }(t);
                        if (!r) return !1;
                        for(var n = 0; n < e.length; ++n)if (e[n].test(r)) return !0;
                        return !1;
                    };
                }(t.scrubFields), this.telemeter = e, this.rollbar = r, this.diagnostic = r.client.notifier.diagnostic, this._window = o || {}, this._document = i || {}, this.replacements = {
                    network: [],
                    log: [],
                    navigation: [],
                    connectivity: []
                }, this.eventRemovers = {
                    dom: [],
                    connectivity: [],
                    contentsecuritypolicy: []
                }, this._location = this._window.location, this._lastHref = this._location && this._location.href;
            }
            p.prototype.configure = function(t) {
                this.options = n.merge(this.options, t);
                var e = t.autoInstrument, r = n.merge(this.autoInstrument);
                !1 === t.enabled || !1 === e ? this.autoInstrument = {} : (n.isType(e, "object") || (e = u), this.autoInstrument = n.merge(u, e)), this.instrument(r), void 0 !== t.scrubTelemetryInputs && (this.scrubTelemetryInputs = !!t.scrubTelemetryInputs), void 0 !== t.telemetryScrubber && (this.telemetryScrubber = t.telemetryScrubber);
            }, p.prototype.instrument = function(t) {
                !this.autoInstrument.network || t && t.network ? !this.autoInstrument.network && t && t.network && this.deinstrumentNetwork() : this.instrumentNetwork(), !this.autoInstrument.log || t && t.log ? !this.autoInstrument.log && t && t.log && this.deinstrumentConsole() : this.instrumentConsole(), !this.autoInstrument.dom || t && t.dom ? !this.autoInstrument.dom && t && t.dom && this.deinstrumentDom() : this.instrumentDom(), !this.autoInstrument.navigation || t && t.navigation ? !this.autoInstrument.navigation && t && t.navigation && this.deinstrumentNavigation() : this.instrumentNavigation(), !this.autoInstrument.connectivity || t && t.connectivity ? !this.autoInstrument.connectivity && t && t.connectivity && this.deinstrumentConnectivity() : this.instrumentConnectivity(), !this.autoInstrument.contentSecurityPolicy || t && t.contentSecurityPolicy ? !this.autoInstrument.contentSecurityPolicy && t && t.contentSecurityPolicy && this.deinstrumentContentSecurityPolicy() : this.instrumentContentSecurityPolicy();
            }, p.prototype.deinstrumentNetwork = function() {
                l(this.replacements, "network");
            }, p.prototype.instrumentNetwork = function() {
                var t = this;
                function e(e, r) {
                    e in r && n.isFunction(r[e]) && c(r, e, function(e) {
                        return t.rollbar.wrap(e);
                    });
                }
                if ("XMLHttpRequest" in this._window) {
                    var r = this._window.XMLHttpRequest.prototype;
                    c(r, "open", function(t) {
                        return function(e, r) {
                            return n.isType(r, "string") && (this.__rollbar_xhr ? (this.__rollbar_xhr.method = e, this.__rollbar_xhr.url = r, this.__rollbar_xhr.status_code = null, this.__rollbar_xhr.start_time_ms = n.now(), this.__rollbar_xhr.end_time_ms = null) : this.__rollbar_xhr = {
                                method: e,
                                url: r,
                                status_code: null,
                                start_time_ms: n.now(),
                                end_time_ms: null
                            }), t.apply(this, arguments);
                        };
                    }, this.replacements, "network"), c(r, "setRequestHeader", function(e) {
                        return function(r, o) {
                            return this.__rollbar_xhr || (this.__rollbar_xhr = {}), n.isType(r, "string") && n.isType(o, "string") && (t.autoInstrument.networkRequestHeaders && (this.__rollbar_xhr.request_headers || (this.__rollbar_xhr.request_headers = {}), this.__rollbar_xhr.request_headers[r] = o), "content-type" === r.toLowerCase() && (this.__rollbar_xhr.request_content_type = o)), e.apply(this, arguments);
                        };
                    }, this.replacements, "network"), c(r, "send", function(r) {
                        return function(o) {
                            var i = this;
                            function s() {
                                if (i.__rollbar_xhr && (null === i.__rollbar_xhr.status_code && (i.__rollbar_xhr.status_code = 0, t.autoInstrument.networkRequestBody && (i.__rollbar_xhr.request = o), i.__rollbar_event = t.captureNetwork(i.__rollbar_xhr, "xhr", void 0)), i.readyState < 2 && (i.__rollbar_xhr.start_time_ms = n.now()), i.readyState > 3)) {
                                    i.__rollbar_xhr.end_time_ms = n.now();
                                    var e = null;
                                    if (i.__rollbar_xhr.response_content_type = i.getResponseHeader("Content-Type"), t.autoInstrument.networkResponseHeaders) {
                                        var r = t.autoInstrument.networkResponseHeaders;
                                        e = {};
                                        try {
                                            var s, a;
                                            if (!0 === r) {
                                                var u = i.getAllResponseHeaders();
                                                if (u) {
                                                    var c, l, p = u.trim().split(/[\r\n]+/);
                                                    for(a = 0; a < p.length; a++)s = (c = p[a].split(": ")).shift(), l = c.join(": "), e[s] = l;
                                                }
                                            } else for(a = 0; a < r.length; a++)e[s = r[a]] = i.getResponseHeader(s);
                                        } catch (t) {}
                                    }
                                    var f = null;
                                    if (t.autoInstrument.networkResponseBody) try {
                                        f = i.responseText;
                                    } catch (t) {}
                                    var h = null;
                                    (f || e) && (h = {}, f && (t.isJsonContentType(i.__rollbar_xhr.response_content_type) ? h.body = t.scrubJson(f) : h.body = f), e && (h.headers = e)), h && (i.__rollbar_xhr.response = h);
                                    try {
                                        var d = i.status;
                                        d = 1223 === d ? 204 : d, i.__rollbar_xhr.status_code = d, i.__rollbar_event.level = t.telemeter.levelFromStatus(d), t.errorOnHttpStatus(i.__rollbar_xhr);
                                    } catch (t) {}
                                }
                            }
                            return e("onload", i), e("onerror", i), e("onprogress", i), "onreadystatechange" in i && n.isFunction(i.onreadystatechange) ? c(i, "onreadystatechange", function(e) {
                                return t.rollbar.wrap(e, void 0, s);
                            }) : i.onreadystatechange = s, i.__rollbar_xhr && t.trackHttpErrors() && (i.__rollbar_xhr.stack = (new Error).stack), r.apply(this, arguments);
                        };
                    }, this.replacements, "network");
                }
                "fetch" in this._window && c(this._window, "fetch", function(e) {
                    return function(r, i) {
                        for(var s = new Array(arguments.length), a = 0, u = s.length; a < u; a++)s[a] = arguments[a];
                        var c, l = s[0], p = "GET";
                        n.isType(l, "string") ? c = l : l && (c = l.url, l.method && (p = l.method)), s[1] && s[1].method && (p = s[1].method);
                        var f = {
                            method: p,
                            url: c,
                            status_code: null,
                            start_time_ms: n.now(),
                            end_time_ms: null
                        };
                        if (s[1] && s[1].headers) {
                            var h = o(s[1].headers);
                            f.request_content_type = h.get("Content-Type"), t.autoInstrument.networkRequestHeaders && (f.request_headers = t.fetchHeaders(h, t.autoInstrument.networkRequestHeaders));
                        }
                        return t.autoInstrument.networkRequestBody && (s[1] && s[1].body ? f.request = s[1].body : s[0] && !n.isType(s[0], "string") && s[0].body && (f.request = s[0].body)), t.captureNetwork(f, "fetch", void 0), t.trackHttpErrors() && (f.stack = (new Error).stack), e.apply(this, s).then(function(e) {
                            f.end_time_ms = n.now(), f.status_code = e.status, f.response_content_type = e.headers.get("Content-Type");
                            var r = null;
                            t.autoInstrument.networkResponseHeaders && (r = t.fetchHeaders(e.headers, t.autoInstrument.networkResponseHeaders));
                            var o = null;
                            return t.autoInstrument.networkResponseBody && "function" == typeof e.text && (o = e.clone().text()), (r || o) && (f.response = {}, o && ("function" == typeof o.then ? o.then(function(e) {
                                e && t.isJsonContentType(f.response_content_type) ? f.response.body = t.scrubJson(e) : f.response.body = e;
                            }) : f.response.body = o), r && (f.response.headers = r)), t.errorOnHttpStatus(f), e;
                        });
                    };
                }, this.replacements, "network");
            }, p.prototype.captureNetwork = function(t, e, r) {
                return t.request && this.isJsonContentType(t.request_content_type) && (t.request = this.scrubJson(t.request)), this.telemeter.captureNetwork(t, e, r);
            }, p.prototype.isJsonContentType = function(t) {
                return !!(t && n.isType(t, "string") && t.toLowerCase().includes("json"));
            }, p.prototype.scrubJson = function(t) {
                return JSON.stringify(i(JSON.parse(t), this.options.scrubFields));
            }, p.prototype.fetchHeaders = function(t, e) {
                var r = {};
                try {
                    var n;
                    if (!0 === e) {
                        if ("function" == typeof t.entries) for(var o = t.entries(), i = o.next(); !i.done;)r[i.value[0]] = i.value[1], i = o.next();
                    } else for(n = 0; n < e.length; n++){
                        var s = e[n];
                        r[s] = t.get(s);
                    }
                } catch (t) {}
                return r;
            }, p.prototype.trackHttpErrors = function() {
                return this.autoInstrument.networkErrorOnHttp5xx || this.autoInstrument.networkErrorOnHttp4xx || this.autoInstrument.networkErrorOnHttp0;
            }, p.prototype.errorOnHttpStatus = function(t) {
                var e = t.status_code;
                if (e >= 500 && this.autoInstrument.networkErrorOnHttp5xx || e >= 400 && this.autoInstrument.networkErrorOnHttp4xx || 0 === e && this.autoInstrument.networkErrorOnHttp0) {
                    var r = new Error("HTTP request failed with Status " + e);
                    r.stack = t.stack, this.rollbar.error(r, {
                        skipFrames: 1
                    });
                }
            }, p.prototype.deinstrumentConsole = function() {
                if ("console" in this._window && this._window.console.log) for(var t; this.replacements.log.length;)t = this.replacements.log.shift(), this._window.console[t[0]] = t[1];
            }, p.prototype.instrumentConsole = function() {
                if ("console" in this._window && this._window.console.log) {
                    var t = this, e = this._window.console, r = [
                        "debug",
                        "info",
                        "warn",
                        "error",
                        "log"
                    ];
                    try {
                        for(var o = 0, i = r.length; o < i; o++)s(r[o]);
                    } catch (t) {
                        this.diagnostic.instrumentConsole = {
                            error: t.message
                        };
                    }
                }
                function s(r) {
                    var o = e[r], i = e, s = "warn" === r ? "warning" : r;
                    e[r] = function() {
                        var e = Array.prototype.slice.call(arguments), r = n.formatArgsAsString(e);
                        t.telemeter.captureLog(r, s), o && Function.prototype.apply.call(o, i, e);
                    }, t.replacements.log.push([
                        r,
                        o
                    ]);
                }
            }, p.prototype.deinstrumentDom = function() {
                ("addEventListener" in this._window || "attachEvent" in this._window) && this.removeListeners("dom");
            }, p.prototype.instrumentDom = function() {
                if ("addEventListener" in this._window || "attachEvent" in this._window) {
                    var t = this.handleClick.bind(this), e = this.handleBlur.bind(this);
                    this.addListener("dom", this._window, "click", "onclick", t, !0), this.addListener("dom", this._window, "blur", "onfocusout", e, !0);
                }
            }, p.prototype.handleClick = function(t) {
                try {
                    var e = a.getElementFromEvent(t, this._document), r = e && e.tagName, n = a.isDescribedElement(e, "a") || a.isDescribedElement(e, "button");
                    r && (n || a.isDescribedElement(e, "input", [
                        "button",
                        "submit"
                    ])) ? this.captureDomEvent("click", e) : a.isDescribedElement(e, "input", [
                        "checkbox",
                        "radio"
                    ]) && this.captureDomEvent("input", e, e.value, e.checked);
                } catch (t) {}
            }, p.prototype.handleBlur = function(t) {
                try {
                    var e = a.getElementFromEvent(t, this._document);
                    e && e.tagName && (a.isDescribedElement(e, "textarea") ? this.captureDomEvent("input", e, e.value) : a.isDescribedElement(e, "select") && e.options && e.options.length ? this.handleSelectInputChanged(e) : a.isDescribedElement(e, "input") && !a.isDescribedElement(e, "input", [
                        "button",
                        "submit",
                        "hidden",
                        "checkbox",
                        "radio"
                    ]) && this.captureDomEvent("input", e, e.value));
                } catch (t) {}
            }, p.prototype.handleSelectInputChanged = function(t) {
                if (t.multiple) for(var e = 0; e < t.options.length; e++)t.options[e].selected && this.captureDomEvent("input", t, t.options[e].value);
                else t.selectedIndex >= 0 && t.options[t.selectedIndex] && this.captureDomEvent("input", t, t.options[t.selectedIndex].value);
            }, p.prototype.captureDomEvent = function(t, e, r, n) {
                if (void 0 !== r) {
                    if (this.scrubTelemetryInputs || "password" === a.getElementType(e)) r = "[scrubbed]";
                    else {
                        var o = a.describeElement(e);
                        this.telemetryScrubber ? this.telemetryScrubber(o) && (r = "[scrubbed]") : this.defaultValueScrubber(o) && (r = "[scrubbed]");
                    }
                }
                var i = a.elementArrayToString(a.treeToArray(e));
                this.telemeter.captureDom(t, i, r, n);
            }, p.prototype.deinstrumentNavigation = function() {
                var t = this._window.chrome;
                !(t && t.app && t.app.runtime) && this._window.history && this._window.history.pushState && l(this.replacements, "navigation");
            }, p.prototype.instrumentNavigation = function() {
                var t = this._window.chrome;
                if (!(t && t.app && t.app.runtime) && this._window.history && this._window.history.pushState) {
                    var e = this;
                    c(this._window, "onpopstate", function(t) {
                        return function() {
                            var r = e._location.href;
                            e.handleUrlChange(e._lastHref, r), t && t.apply(this, arguments);
                        };
                    }, this.replacements, "navigation"), c(this._window.history, "pushState", function(t) {
                        return function() {
                            var r = arguments.length > 2 ? arguments[2] : void 0;
                            return r && e.handleUrlChange(e._lastHref, r + ""), t.apply(this, arguments);
                        };
                    }, this.replacements, "navigation");
                }
            }, p.prototype.handleUrlChange = function(t, e) {
                var r = s.parse(this._location.href), n = s.parse(e), o = s.parse(t);
                this._lastHref = e, r.protocol === n.protocol && r.host === n.host && (e = n.path + (n.hash || "")), r.protocol === o.protocol && r.host === o.host && (t = o.path + (o.hash || "")), this.telemeter.captureNavigation(t, e);
            }, p.prototype.deinstrumentConnectivity = function() {
                ("addEventListener" in this._window || "body" in this._document) && (this._window.addEventListener ? this.removeListeners("connectivity") : l(this.replacements, "connectivity"));
            }, p.prototype.instrumentConnectivity = function() {
                if ("addEventListener" in this._window || "body" in this._document) {
                    if (this._window.addEventListener) this.addListener("connectivity", this._window, "online", void 0, (function() {
                        this.telemeter.captureConnectivityChange("online");
                    }).bind(this), !0), this.addListener("connectivity", this._window, "offline", void 0, (function() {
                        this.telemeter.captureConnectivityChange("offline");
                    }).bind(this), !0);
                    else {
                        var t = this;
                        c(this._document.body, "ononline", function(e) {
                            return function() {
                                t.telemeter.captureConnectivityChange("online"), e && e.apply(this, arguments);
                            };
                        }, this.replacements, "connectivity"), c(this._document.body, "onoffline", function(e) {
                            return function() {
                                t.telemeter.captureConnectivityChange("offline"), e && e.apply(this, arguments);
                            };
                        }, this.replacements, "connectivity");
                    }
                }
            }, p.prototype.handleCspEvent = function(t) {
                var e = "Security Policy Violation: blockedURI: " + t.blockedURI + ", violatedDirective: " + t.violatedDirective + ", effectiveDirective: " + t.effectiveDirective + ", ";
                t.sourceFile && (e += "location: " + t.sourceFile + ", line: " + t.lineNumber + ", col: " + t.columnNumber + ", "), e += "originalPolicy: " + t.originalPolicy, this.telemeter.captureLog(e, "error"), this.handleCspError(e);
            }, p.prototype.handleCspError = function(t) {
                this.autoInstrument.errorOnContentSecurityPolicy && this.rollbar.error(t);
            }, p.prototype.deinstrumentContentSecurityPolicy = function() {
                "addEventListener" in this._document && this.removeListeners("contentsecuritypolicy");
            }, p.prototype.instrumentContentSecurityPolicy = function() {
                if ("addEventListener" in this._document) {
                    var t = this.handleCspEvent.bind(this);
                    this.addListener("contentsecuritypolicy", this._document, "securitypolicyviolation", null, t, !1);
                }
            }, p.prototype.addListener = function(t, e, r, n, o, i) {
                e.addEventListener ? (e.addEventListener(r, o, i), this.eventRemovers[t].push(function() {
                    e.removeEventListener(r, o, i);
                })) : n && (e.attachEvent(n, o), this.eventRemovers[t].push(function() {
                    e.detachEvent(n, o);
                }));
            }, p.prototype.removeListeners = function(t) {
                for(; this.eventRemovers[t].length;)this.eventRemovers[t].shift()();
            }, t.exports = p;
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return "string" != typeof t && (t = String(t)), t.toLowerCase();
            }
            function o(t) {
                this.map = {}, t instanceof o ? t.forEach(function(t, e) {
                    this.append(e, t);
                }, this) : Array.isArray(t) ? t.forEach(function(t) {
                    this.append(t[0], t[1]);
                }, this) : t && Object.getOwnPropertyNames(t).forEach(function(e) {
                    this.append(e, t[e]);
                }, this);
            }
            o.prototype.append = function(t, e) {
                t = n(t), e = function(t) {
                    return "string" != typeof t && (t = String(t)), t;
                }(e);
                var r = this.map[t];
                this.map[t] = r ? r + ", " + e : e;
            }, o.prototype.get = function(t) {
                return t = n(t), this.has(t) ? this.map[t] : null;
            }, o.prototype.has = function(t) {
                return this.map.hasOwnProperty(n(t));
            }, o.prototype.forEach = function(t, e) {
                for(var r in this.map)this.map.hasOwnProperty(r) && t.call(e, this.map[r], r, this);
            }, o.prototype.entries = function() {
                var t = [];
                return this.forEach(function(e, r) {
                    t.push([
                        r,
                        e
                    ]);
                }), function(t) {
                    return {
                        next: function() {
                            var e = t.shift();
                            return {
                                done: void 0 === e,
                                value: e
                            };
                        }
                    };
                }(t);
            }, t.exports = function(t) {
                return "undefined" == typeof Headers ? new o(t) : new Headers(t);
            };
        },
        function(t, e, r) {
            "use strict";
            function n(t) {
                return (t.getAttribute("type") || "").toLowerCase();
            }
            function o(t) {
                if (!t || !t.tagName) return "";
                var e = [
                    t.tagName
                ];
                t.id && e.push("#" + t.id), t.classes && e.push("." + t.classes.join("."));
                for(var r = 0; r < t.attributes.length; r++)e.push("[" + t.attributes[r].key + '="' + t.attributes[r].value + '"]');
                return e.join("");
            }
            function i(t) {
                if (!t || !t.tagName) return null;
                var e, r, n, o, i = {};
                i.tagName = t.tagName.toLowerCase(), t.id && (i.id = t.id), (e = t.className) && "string" == typeof e && (i.classes = e.split(/\s+/));
                var s = [
                    "type",
                    "name",
                    "title",
                    "alt"
                ];
                for(i.attributes = [], o = 0; o < s.length; o++)r = s[o], (n = t.getAttribute(r)) && i.attributes.push({
                    key: r,
                    value: n
                });
                return i;
            }
            t.exports = {
                describeElement: i,
                descriptionToString: o,
                elementArrayToString: function(t) {
                    for(var e, r, n = 3, i = [], s = 0, a = t.length - 1; a >= 0; a--){
                        if (e = o(t[a]), r = s + i.length * n + e.length, a < t.length - 1 && r >= 83) {
                            i.unshift("...");
                            break;
                        }
                        i.unshift(e), s += e.length;
                    }
                    return i.join(" > ");
                },
                treeToArray: function(t) {
                    for(var e, r = [], n = 0; t && n < 5 && "html" !== (e = i(t)).tagName; n++)r.unshift(e), t = t.parentNode;
                    return r;
                },
                getElementFromEvent: function(t, e) {
                    return t.target ? t.target : e && e.elementFromPoint ? e.elementFromPoint(t.clientX, t.clientY) : void 0;
                },
                isDescribedElement: function(t, e, r) {
                    if (t.tagName.toLowerCase() !== e.toLowerCase()) return !1;
                    if (!r) return !0;
                    t = n(t);
                    for(var o = 0; o < r.length; o++)if (r[o] === t) return !0;
                    return !1;
                },
                getElementType: n
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(36);
            t.exports = n;
        },
        function(t, e) {
            t.exports = function(t) {
                var e, r, n, o, i, s, a, u, c, l, p, f, h, d = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
                function m(t) {
                    return t < 10 ? "0" + t : t;
                }
                function g() {
                    return this.valueOf();
                }
                function v(t) {
                    return d.lastIndex = 0, d.test(t) ? '"' + t.replace(d, function(t) {
                        var e = n[t];
                        return "string" == typeof e ? e : "\\u" + ("0000" + t.charCodeAt(0).toString(16)).slice(-4);
                    }) + '"' : '"' + t + '"';
                }
                "function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function() {
                    return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + m(this.getUTCMonth() + 1) + "-" + m(this.getUTCDate()) + "T" + m(this.getUTCHours()) + ":" + m(this.getUTCMinutes()) + ":" + m(this.getUTCSeconds()) + "Z" : null;
                }, Boolean.prototype.toJSON = g, Number.prototype.toJSON = g, String.prototype.toJSON = g), "function" != typeof t.stringify && (n = {
                    "\b": "\\b",
                    "\t": "\\t",
                    "\n": "\\n",
                    "\f": "\\f",
                    "\r": "\\r",
                    '"': '\\"',
                    "\\": "\\\\"
                }, t.stringify = function(t, n, i) {
                    var s;
                    if (e = "", r = "", "number" == typeof i) for(s = 0; s < i; s += 1)r += " ";
                    else "string" == typeof i && (r = i);
                    if (o = n, n && "function" != typeof n && ("object" != typeof n || "number" != typeof n.length)) throw new Error("JSON.stringify");
                    return function t(n, i) {
                        var s, a, u, c, l, p = e, f = i[n];
                        switch(f && "object" == typeof f && "function" == typeof f.toJSON && (f = f.toJSON(n)), "function" == typeof o && (f = o.call(i, n, f)), typeof f){
                            case "string":
                                return v(f);
                            case "number":
                                return isFinite(f) ? String(f) : "null";
                            case "boolean":
                            case "null":
                                return String(f);
                            case "object":
                                if (!f) return "null";
                                if (e += r, l = [], "[object Array]" === Object.prototype.toString.apply(f)) {
                                    for(c = f.length, s = 0; s < c; s += 1)l[s] = t(s, f) || "null";
                                    return u = 0 === l.length ? "[]" : e ? "[\n" + e + l.join(",\n" + e) + "\n" + p + "]" : "[" + l.join(",") + "]", e = p, u;
                                }
                                if (o && "object" == typeof o) for(c = o.length, s = 0; s < c; s += 1)"string" == typeof o[s] && (u = t(a = o[s], f)) && l.push(v(a) + (e ? ": " : ":") + u);
                                else for(a in f)Object.prototype.hasOwnProperty.call(f, a) && (u = t(a, f)) && l.push(v(a) + (e ? ": " : ":") + u);
                                return u = 0 === l.length ? "{}" : e ? "{\n" + e + l.join(",\n" + e) + "\n" + p + "}" : "{" + l.join(",") + "}", e = p, u;
                        }
                    }("", {
                        "": t
                    });
                }), "function" != typeof t.parse && (t.parse = (l = {
                    "\\": "\\",
                    '"': '"',
                    "/": "/",
                    t: "\t",
                    n: "\n",
                    r: "\r",
                    f: "\f",
                    b: "\b"
                }, p = {
                    go: function() {
                        i = "ok";
                    },
                    firstokey: function() {
                        u = c, i = "colon";
                    },
                    okey: function() {
                        u = c, i = "colon";
                    },
                    ovalue: function() {
                        i = "ocomma";
                    },
                    firstavalue: function() {
                        i = "acomma";
                    },
                    avalue: function() {
                        i = "acomma";
                    }
                }, f = {
                    go: function() {
                        i = "ok";
                    },
                    ovalue: function() {
                        i = "ocomma";
                    },
                    firstavalue: function() {
                        i = "acomma";
                    },
                    avalue: function() {
                        i = "acomma";
                    }
                }, h = {
                    "{": {
                        go: function() {
                            s.push({
                                state: "ok"
                            }), a = {}, i = "firstokey";
                        },
                        ovalue: function() {
                            s.push({
                                container: a,
                                state: "ocomma",
                                key: u
                            }), a = {}, i = "firstokey";
                        },
                        firstavalue: function() {
                            s.push({
                                container: a,
                                state: "acomma"
                            }), a = {}, i = "firstokey";
                        },
                        avalue: function() {
                            s.push({
                                container: a,
                                state: "acomma"
                            }), a = {}, i = "firstokey";
                        }
                    },
                    "}": {
                        firstokey: function() {
                            var t = s.pop();
                            c = a, a = t.container, u = t.key, i = t.state;
                        },
                        ocomma: function() {
                            var t = s.pop();
                            a[u] = c, c = a, a = t.container, u = t.key, i = t.state;
                        }
                    },
                    "[": {
                        go: function() {
                            s.push({
                                state: "ok"
                            }), a = [], i = "firstavalue";
                        },
                        ovalue: function() {
                            s.push({
                                container: a,
                                state: "ocomma",
                                key: u
                            }), a = [], i = "firstavalue";
                        },
                        firstavalue: function() {
                            s.push({
                                container: a,
                                state: "acomma"
                            }), a = [], i = "firstavalue";
                        },
                        avalue: function() {
                            s.push({
                                container: a,
                                state: "acomma"
                            }), a = [], i = "firstavalue";
                        }
                    },
                    "]": {
                        firstavalue: function() {
                            var t = s.pop();
                            c = a, a = t.container, u = t.key, i = t.state;
                        },
                        acomma: function() {
                            var t = s.pop();
                            a.push(c), c = a, a = t.container, u = t.key, i = t.state;
                        }
                    },
                    ":": {
                        colon: function() {
                            if (Object.hasOwnProperty.call(a, u)) throw new SyntaxError("Duplicate key '" + u + '"');
                            i = "ovalue";
                        }
                    },
                    ",": {
                        ocomma: function() {
                            a[u] = c, i = "okey";
                        },
                        acomma: function() {
                            a.push(c), i = "avalue";
                        }
                    },
                    true: {
                        go: function() {
                            c = !0, i = "ok";
                        },
                        ovalue: function() {
                            c = !0, i = "ocomma";
                        },
                        firstavalue: function() {
                            c = !0, i = "acomma";
                        },
                        avalue: function() {
                            c = !0, i = "acomma";
                        }
                    },
                    false: {
                        go: function() {
                            c = !1, i = "ok";
                        },
                        ovalue: function() {
                            c = !1, i = "ocomma";
                        },
                        firstavalue: function() {
                            c = !1, i = "acomma";
                        },
                        avalue: function() {
                            c = !1, i = "acomma";
                        }
                    },
                    null: {
                        go: function() {
                            c = null, i = "ok";
                        },
                        ovalue: function() {
                            c = null, i = "ocomma";
                        },
                        firstavalue: function() {
                            c = null, i = "acomma";
                        },
                        avalue: function() {
                            c = null, i = "acomma";
                        }
                    }
                }, function(t, e) {
                    var r, n, o = /^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;
                    i = "go", s = [];
                    try {
                        for(; r = o.exec(t);)r[1] ? h[r[1]][i]() : r[2] ? (c = +r[2], f[i]()) : (n = r[3], c = n.replace(/\\(?:u(.{4})|([^u]))/g, function(t, e, r) {
                            return e ? String.fromCharCode(parseInt(e, 16)) : l[r];
                        }), p[i]()), t = t.slice(r[0].length);
                    } catch (t) {
                        i = t;
                    }
                    if ("ok" !== i || /[^\u0020\t\n\r]/.test(t)) throw i instanceof SyntaxError ? i : new SyntaxError("JSON");
                    return "function" == typeof e ? function t(r, n) {
                        var o, i, s = r[n];
                        if (s && "object" == typeof s) for(o in c)Object.prototype.hasOwnProperty.call(s, o) && (void 0 !== (i = t(s, o)) ? s[o] = i : delete s[o]);
                        return e.call(r, n, s);
                    }({
                        "": c
                    }, "") : c;
                }));
            };
        },
        function(t, e, r) {
            "use strict";
            function n(t, e, r) {
                if (e.hasOwnProperty && e.hasOwnProperty("addEventListener")) {
                    for(var n = e.addEventListener; n._rollbarOldAdd && n.belongsToShim;)n = n._rollbarOldAdd;
                    var o = function(e, r, o) {
                        n.call(this, e, t.wrap(r), o);
                    };
                    o._rollbarOldAdd = n, o.belongsToShim = r, e.addEventListener = o;
                    for(var i = e.removeEventListener; i._rollbarOldRemove && i.belongsToShim;)i = i._rollbarOldRemove;
                    var s = function(t, e, r) {
                        i.call(this, t, e && e._rollbar_wrapped || e, r);
                    };
                    s._rollbarOldRemove = i, s.belongsToShim = r, e.removeEventListener = s;
                }
            }
            t.exports = function(t, e, r) {
                if (t) {
                    var o, i, s = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
                    for(o = 0; o < s.length; ++o)t[i = s[o]] && t[i].prototype && n(e, t[i].prototype, r);
                }
            };
        },
        function(t, e, r) {
            "use strict";
            var n = r(0), o = r(5);
            function i(t, e) {
                return [
                    t,
                    n.stringify(t, e)
                ];
            }
            function s(t, e) {
                var r = t.length;
                return r > 2 * e ? t.slice(0, e).concat(t.slice(r - e)) : t;
            }
            function a(t, e, r) {
                r = void 0 === r ? 30 : r;
                var o, i = t.data.body;
                if (i.trace_chain) for(var a = i.trace_chain, u = 0; u < a.length; u++)o = s(o = a[u].frames, r), a[u].frames = o;
                else i.trace && (o = s(o = i.trace.frames, r), i.trace.frames = o);
                return [
                    t,
                    n.stringify(t, e)
                ];
            }
            function u(t, e) {
                return e && e.length > t ? e.slice(0, t - 3).concat("...") : e;
            }
            function c(t, e, r) {
                return [
                    e = o(e, function e(r, i, s) {
                        switch(n.typeName(i)){
                            case "string":
                                return u(t, i);
                            case "object":
                            case "array":
                                return o(i, e, s);
                            default:
                                return i;
                        }
                    }),
                    n.stringify(e, r)
                ];
            }
            function l(t) {
                return t.exception && (delete t.exception.description, t.exception.message = u(255, t.exception.message)), t.frames = s(t.frames, 1), t;
            }
            function p(t, e) {
                var r = t.data.body;
                if (r.trace_chain) for(var o = r.trace_chain, i = 0; i < o.length; i++)o[i] = l(o[i]);
                else r.trace && (r.trace = l(r.trace));
                return [
                    t,
                    n.stringify(t, e)
                ];
            }
            function f(t, e) {
                return n.maxByteSize(t) > e;
            }
            t.exports = {
                truncate: function(t, e, r) {
                    r = void 0 === r ? 524288 : r;
                    for(var n, o, s, u = [
                        i,
                        a,
                        c.bind(null, 1024),
                        c.bind(null, 512),
                        c.bind(null, 256),
                        p
                    ]; n = u.shift();)if (t = (o = n(t, e))[0], (s = o[1]).error || !f(s.value, r)) return s;
                    return s;
                },
                raw: i,
                truncateFrames: a,
                truncateStrings: c,
                maybeTruncateValue: u
            };
        }
    ]);
});




var $755f8773177e6dc1$var$VALID_LEVELS = (0, $d81b72f3d24fa945$export$2e2bcd8739ae039);
function $755f8773177e6dc1$export$90a7f3efeed30595(val, defaultTo) {
    if (typeof val === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return val.apply(void 0, args);
    }
    return val;
}
function $755f8773177e6dc1$export$23f2a1d2818174ef(level) {
    return $755f8773177e6dc1$var$VALID_LEVELS[level] >= $755f8773177e6dc1$var$VALID_LEVELS[0, $d81b72f3d24fa945$export$594c4746b5c054d9] && $755f8773177e6dc1$var$VALID_LEVELS[level] <= $755f8773177e6dc1$var$VALID_LEVELS[0, $d81b72f3d24fa945$export$94181bfe08d41cda];
}
function $755f8773177e6dc1$var$isRollbarInstance(instance) {
    var _instance$options;
    return !!(instance !== null && instance !== void 0 && (_instance$options = instance.options) !== null && _instance$options !== void 0 && _instance$options.accessToken);
}
var $755f8773177e6dc1$export$e7094788287c5e9b = /*#__PURE__*/ (0, $jiXHd.createContext)();
$755f8773177e6dc1$export$e7094788287c5e9b.displayName = 'Rollbar';
var $755f8773177e6dc1$export$db202ddc8be9136 = Symbol('RollbarInstance');
var $755f8773177e6dc1$export$ef35774e6d314e91 = Symbol('BaseOptions');
var $755f8773177e6dc1$export$407448d2b89b1813 = Symbol('RollbarCtor');
function $755f8773177e6dc1$export$39b482c5e57630a8(context) {
    var rollbar = context[$755f8773177e6dc1$export$db202ddc8be9136];
    return rollbar;
}
function $755f8773177e6dc1$export$8b22cf2602fb60ce(context) {
    var ctor = context[$755f8773177e6dc1$export$407448d2b89b1813];
    return ctor;
}
var $755f8773177e6dc1$export$56c0d5a1e737357d = /*#__PURE__*/ function(_Component) {
    (0, $6ce9701a9155b1d5$export$8b22cf2602fb60ce)(Provider, _Component);
    var _super = (0, $6ce9701a9155b1d5$export$db3b6bfb95261072)(Provider);
    function Provider(props) {
        var _this;
        (0, $6ce9701a9155b1d5$export$f1e1789686576879)(this, Provider);
        _this = _super.call(this, props);
        var _this$props = _this.props, config = _this$props.config, _this$props$Rollbar = _this$props.Rollbar, ctor = _this$props$Rollbar === void 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($03ba84f01a1505a8$exports))) : _this$props$Rollbar, instance = _this$props.instance;
        (0, $ccb4cb530ae69b84$export$23f2a1d2818174ef)(!instance || $755f8773177e6dc1$var$isRollbarInstance(instance), '`instance` must be a configured instance of Rollbar');
        var options = typeof config === 'function' ? config() : config;
        var rollbar = instance || new ctor(options); // TODO: use isUncaught to filter if this is 2nd Provider added
        // unless customer wants that
        _this.state = {
            rollbar: rollbar,
            options: options
        };
        return _this;
    } // componentDidUpdate()
    (0, $6ce9701a9155b1d5$export$4368d992c4eafac0)(Provider, [
        {
            key: "render",
            value: function render() {
                var _ref;
                var _this$props2 = this.props, children = _this$props2.children, _this$props2$Rollbar = _this$props2.Rollbar, ctor = _this$props2$Rollbar === void 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($03ba84f01a1505a8$exports))) : _this$props2$Rollbar;
                var _this$state = this.state, rollbar = _this$state.rollbar, options = _this$state.options;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement($755f8773177e6dc1$export$e7094788287c5e9b.Provider, {
                    value: (_ref = {}, (0, $6ce9701a9155b1d5$export$71511d61b312f219)(_ref, $755f8773177e6dc1$export$db202ddc8be9136, rollbar), (0, $6ce9701a9155b1d5$export$71511d61b312f219)(_ref, $755f8773177e6dc1$export$ef35774e6d314e91, options), (0, $6ce9701a9155b1d5$export$71511d61b312f219)(_ref, $755f8773177e6dc1$export$407448d2b89b1813, ctor), _ref)
                }, children);
            }
        }
    ]);
    return Provider;
}((0, $jiXHd.Component));
(0, $6ce9701a9155b1d5$export$71511d61b312f219)($755f8773177e6dc1$export$56c0d5a1e737357d, "propTypes", {
    Rollbar: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func,
    config: function config(props, propName, componentName) {
        if (!props.config && !props.instance) return new Error("One of the required props 'config' or 'instance' must be set for ".concat(componentName, "."));
        if (props.config) {
            var configType = (0, $6ce9701a9155b1d5$export$407448d2b89b1813)(props.config);
            if (configType === 'function' || configType === 'object' && !Array.isArray(configType)) return;
            return new Error("".concat(propName, " must be either an Object or a Function"));
        }
    },
    instance: function instance(props, propName, componentName) {
        if (!props.config && !props.instance) return new Error("One of the required props 'config' or 'instance' must be set for ".concat(componentName, "."));
        if (props.instance && !$755f8773177e6dc1$var$isRollbarInstance(props.instance)) return new Error("".concat(propName, " must be a configured instance of Rollbar"));
    },
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).node
});



var $8840d96c4e9442b9$var$INITIAL_ERROR_STATE = {
    hasError: false,
    error: null
};
var $8840d96c4e9442b9$export$e926676385687eaf = /*#__PURE__*/ function(_Component) {
    (0, $6ce9701a9155b1d5$export$8b22cf2602fb60ce)(ErrorBoundary, _Component);
    var _super = (0, $6ce9701a9155b1d5$export$db3b6bfb95261072)(ErrorBoundary);
    function ErrorBoundary(props) {
        var _this;
        (0, $6ce9701a9155b1d5$export$f1e1789686576879)(this, ErrorBoundary);
        _this = _super.call(this, props);
        (0, $6ce9701a9155b1d5$export$71511d61b312f219)((0, $6ce9701a9155b1d5$export$2d1720544b23b823)(_this), "resetError", function() {
            _this.setState($8840d96c4e9442b9$var$INITIAL_ERROR_STATE);
        });
        (0, $ccb4cb530ae69b84$export$23f2a1d2818174ef)((0, $755f8773177e6dc1$export$23f2a1d2818174ef)(props.level), "".concat(props.level, " is not a valid level setting for Rollbar"));
        _this.state = (0, $6ce9701a9155b1d5$export$39b482c5e57630a8)({}, $8840d96c4e9442b9$var$INITIAL_ERROR_STATE);
        return _this;
    }
    (0, $6ce9701a9155b1d5$export$4368d992c4eafac0)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                var _this$props = this.props, errorMessage = _this$props.errorMessage, extra = _this$props.extra, targetLevel = _this$props.level, callback = _this$props.callback;
                var custom = (0, $755f8773177e6dc1$export$90a7f3efeed30595)(extra, {}, error, info);
                var data = (0, $6ce9701a9155b1d5$export$39b482c5e57630a8)((0, $6ce9701a9155b1d5$export$39b482c5e57630a8)({}, info), custom);
                var level = (0, $755f8773177e6dc1$export$90a7f3efeed30595)(targetLevel, (0, $d81b72f3d24fa945$export$eb4268f7d11f382e), error, info);
                var rollbar = (0, $755f8773177e6dc1$export$39b482c5e57630a8)(this.context);
                if (!errorMessage) rollbar[level](error, data, callback);
                else {
                    var logMessage = (0, $755f8773177e6dc1$export$90a7f3efeed30595)(errorMessage, '', error, info);
                    rollbar[level](logMessage, error, data, callback);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, hasError = _this$state.hasError, error = _this$state.error;
                var _this$props2 = this.props, FallbackUI = _this$props2.fallbackUI, children = _this$props2.children;
                if (!hasError) return children;
                if (!FallbackUI) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement(FallbackUI, {
                    error: error,
                    resetError: this.resetError
                });
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    hasError: true,
                    error: error
                };
            }
        }
    ]);
    return ErrorBoundary;
}((0, $jiXHd.Component));
(0, $6ce9701a9155b1d5$export$71511d61b312f219)($8840d96c4e9442b9$export$e926676385687eaf, "contextType", (0, $755f8773177e6dc1$export$e7094788287c5e9b));
(0, $6ce9701a9155b1d5$export$71511d61b312f219)($8840d96c4e9442b9$export$e926676385687eaf, "propTypes", {
    fallbackUI: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).elementType,
    errorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func
    ]),
    extra: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func
    ]),
    level: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func
    ]),
    callback: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).node
});
(0, $6ce9701a9155b1d5$export$71511d61b312f219)($8840d96c4e9442b9$export$e926676385687eaf, "defaultProps", {
    level: (0, $d81b72f3d24fa945$export$eb4268f7d11f382e)
});


var $50f828fb99a2700d$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $50f828fb99a2700d$var$__DEV__ = false;
var $50f828fb99a2700d$var$warning = function() {};
if ($50f828fb99a2700d$var$__DEV__) {
    var $50f828fb99a2700d$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $50f828fb99a2700d$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $50f828fb99a2700d$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$50f828fb99a2700d$exports = $50f828fb99a2700d$var$warning;



var $jiXHd = parcelRequire("jiXHd");

var $ePVXJ = parcelRequire("ePVXJ");
function $0b5b028962974662$export$2e2bcd8739ae039() {
    $0b5b028962974662$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0b5b028962974662$export$2e2bcd8739ae039.apply(this, arguments);
}


function $c7fe3173210b633a$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $c7fe3173210b633a$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $c7fe3173210b633a$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $c7fe3173210b633a$var$isAbsolute(to);
    var isFromAbs = from && $c7fe3173210b633a$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $c7fe3173210b633a$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $c7fe3173210b633a$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $c7fe3173210b633a$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $c7fe3173210b633a$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$c7fe3173210b633a$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $c7fe3173210b633a$export$2e2bcd8739ae039 = $c7fe3173210b633a$var$resolvePathname;


function $4b3446ceeef048a9$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $4b3446ceeef048a9$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $4b3446ceeef048a9$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $4b3446ceeef048a9$var$valueOf(a);
        var bValue = $4b3446ceeef048a9$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $4b3446ceeef048a9$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $4b3446ceeef048a9$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $4b3446ceeef048a9$export$2e2bcd8739ae039 = $4b3446ceeef048a9$var$valueEqual;



var $ccbe94ab24e99d17$var$isProduction = true;
var $ccbe94ab24e99d17$var$prefix = 'Invariant failed';
function $ccbe94ab24e99d17$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($ccbe94ab24e99d17$var$isProduction) throw new Error($ccbe94ab24e99d17$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($ccbe94ab24e99d17$var$prefix, ": ").concat(provided) : $ccbe94ab24e99d17$var$prefix;
    throw new Error(value);
}


function $18d2ccbe4875bc55$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $18d2ccbe4875bc55$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $18d2ccbe4875bc55$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $18d2ccbe4875bc55$var$stripBasename(path, prefix) {
    return $18d2ccbe4875bc55$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $18d2ccbe4875bc55$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $18d2ccbe4875bc55$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $18d2ccbe4875bc55$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $18d2ccbe4875bc55$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $18d2ccbe4875bc55$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $0b5b028962974662$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $c7fe3173210b633a$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $18d2ccbe4875bc55$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $4b3446ceeef048a9$export$2e2bcd8739ae039)(a.state, b.state);
}
function $18d2ccbe4875bc55$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $18d2ccbe4875bc55$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $18d2ccbe4875bc55$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $18d2ccbe4875bc55$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $18d2ccbe4875bc55$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $18d2ccbe4875bc55$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $18d2ccbe4875bc55$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $18d2ccbe4875bc55$var$PopStateEvent = 'popstate';
var $18d2ccbe4875bc55$var$HashChangeEvent = 'hashchange';
function $18d2ccbe4875bc55$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $18d2ccbe4875bc55$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$18d2ccbe4875bc55$var$canUseDOM && (0, $ccbe94ab24e99d17$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $18d2ccbe4875bc55$var$supportsHistory();
    var needsHashChangeListener = !$18d2ccbe4875bc55$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $18d2ccbe4875bc55$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $18d2ccbe4875bc55$var$stripTrailingSlash($18d2ccbe4875bc55$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $18d2ccbe4875bc55$var$stripBasename(path, basename);
        return $18d2ccbe4875bc55$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $18d2ccbe4875bc55$var$createTransitionManager();
    function setState(nextState) {
        (0, $0b5b028962974662$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($18d2ccbe4875bc55$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($18d2ccbe4875bc55$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($18d2ccbe4875bc55$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $18d2ccbe4875bc55$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $18d2ccbe4875bc55$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $18d2ccbe4875bc55$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($18d2ccbe4875bc55$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($18d2ccbe4875bc55$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($18d2ccbe4875bc55$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($18d2ccbe4875bc55$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $18d2ccbe4875bc55$var$HashChangeEvent$1 = 'hashchange';
var $18d2ccbe4875bc55$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $18d2ccbe4875bc55$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $18d2ccbe4875bc55$var$stripLeadingSlash,
        decodePath: $18d2ccbe4875bc55$var$addLeadingSlash
    },
    slash: {
        encodePath: $18d2ccbe4875bc55$var$addLeadingSlash,
        decodePath: $18d2ccbe4875bc55$var$addLeadingSlash
    }
};
function $18d2ccbe4875bc55$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $18d2ccbe4875bc55$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $18d2ccbe4875bc55$var$pushHashPath(path) {
    window.location.hash = path;
}
function $18d2ccbe4875bc55$var$replaceHashPath(path) {
    window.location.replace($18d2ccbe4875bc55$var$stripHash(window.location.href) + '#' + path);
}
function $18d2ccbe4875bc55$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$18d2ccbe4875bc55$var$canUseDOM && (0, $ccbe94ab24e99d17$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $18d2ccbe4875bc55$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $18d2ccbe4875bc55$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $18d2ccbe4875bc55$var$stripTrailingSlash($18d2ccbe4875bc55$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $18d2ccbe4875bc55$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($18d2ccbe4875bc55$var$getHashPath());
        if (basename) path = $18d2ccbe4875bc55$var$stripBasename(path, basename);
        return $18d2ccbe4875bc55$export$90c043f1c57770b8(path);
    }
    var transitionManager = $18d2ccbe4875bc55$var$createTransitionManager();
    function setState(nextState) {
        (0, $0b5b028962974662$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $18d2ccbe4875bc55$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $18d2ccbe4875bc55$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $18d2ccbe4875bc55$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($18d2ccbe4875bc55$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($18d2ccbe4875bc55$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $18d2ccbe4875bc55$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $18d2ccbe4875bc55$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $18d2ccbe4875bc55$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $18d2ccbe4875bc55$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $18d2ccbe4875bc55$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $18d2ccbe4875bc55$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $18d2ccbe4875bc55$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $18d2ccbe4875bc55$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $18d2ccbe4875bc55$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($18d2ccbe4875bc55$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $18d2ccbe4875bc55$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $18d2ccbe4875bc55$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $18d2ccbe4875bc55$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $18d2ccbe4875bc55$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($18d2ccbe4875bc55$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($18d2ccbe4875bc55$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($18d2ccbe4875bc55$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $18d2ccbe4875bc55$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $18d2ccbe4875bc55$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $18d2ccbe4875bc55$var$createTransitionManager();
    function setState(nextState) {
        (0, $0b5b028962974662$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $18d2ccbe4875bc55$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $18d2ccbe4875bc55$export$90c043f1c57770b8(entry, undefined, createKey()) : $18d2ccbe4875bc55$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $18d2ccbe4875bc55$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $18d2ccbe4875bc55$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $18d2ccbe4875bc55$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $18d2ccbe4875bc55$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}


// Written in this round about way for babel-transform-imports

var $1595ade849514d51$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $1595ade849514d51$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$1595ade849514d51$exports = $1595ade849514d51$var$invariant;



var $jiXHd = parcelRequire("jiXHd");

var $ePVXJ = parcelRequire("ePVXJ");
var $71df177bae68c730$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $71df177bae68c730$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $71df177bae68c730$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $71df177bae68c730$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $71df177bae68c730$var$Router = function(_React$Component) {
    $71df177bae68c730$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $71df177bae68c730$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $71df177bae68c730$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $71df177bae68c730$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $71df177bae68c730$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($1595ade849514d51$exports)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($50f828fb99a2700d$exports)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component);
$71df177bae68c730$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).node
};
$71df177bae68c730$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object
};
$71df177bae68c730$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object.isRequired
};
var $71df177bae68c730$export$2e2bcd8739ae039 = $71df177bae68c730$var$Router;


var $08f46742ade1c486$export$2e2bcd8739ae039 = (0, $71df177bae68c730$export$2e2bcd8739ae039);


function $e6284243182d7c7d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e6284243182d7c7d$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e6284243182d7c7d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $e6284243182d7c7d$var$BrowserRouter = function(_React$Component) {
    $e6284243182d7c7d$var$_inherits(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _temp, _this, _ret;
        $e6284243182d7c7d$var$_classCallCheck(this, BrowserRouter);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $e6284243182d7c7d$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.history = (0, $18d2ccbe4875bc55$export$719fc203c4e16dee)(_this.props), _temp), $e6284243182d7c7d$var$_possibleConstructorReturn(_this, _ret);
    }
    BrowserRouter.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($50f828fb99a2700d$exports)))(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { BrowserRouter as Router }`.");
    };
    BrowserRouter.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $08f46742ade1c486$export$2e2bcd8739ae039), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component);
$e6284243182d7c7d$var$BrowserRouter.propTypes = {
    basename: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
    forceRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).bool,
    getUserConfirmation: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func,
    keyLength: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).number,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).node
};
var $e6284243182d7c7d$export$2e2bcd8739ae039 = $e6284243182d7c7d$var$BrowserRouter;



var $jiXHd = parcelRequire("jiXHd");
// Written in this round about way for babel-transform-imports

var $jiXHd = parcelRequire("jiXHd");

var $ePVXJ = parcelRequire("ePVXJ");



var $144a018fe7d9ff1d$exports = {};
var $20606223719481a8$exports = {};
$20606223719481a8$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $144a018fe7d9ff1d$exports = $144a018fe7d9ff1d$var$pathToRegexp;
$144a018fe7d9ff1d$exports.parse = $144a018fe7d9ff1d$var$parse;
$144a018fe7d9ff1d$exports.compile = $144a018fe7d9ff1d$var$compile;
$144a018fe7d9ff1d$exports.tokensToFunction = $144a018fe7d9ff1d$var$tokensToFunction;
$144a018fe7d9ff1d$exports.tokensToRegExp = $144a018fe7d9ff1d$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $144a018fe7d9ff1d$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $144a018fe7d9ff1d$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $144a018fe7d9ff1d$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $144a018fe7d9ff1d$var$escapeGroup(pattern) : asterisk ? '.*' : '[^' + $144a018fe7d9ff1d$var$escapeString(delimiter) + ']+?'
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $144a018fe7d9ff1d$var$compile(str, options) {
    return $144a018fe7d9ff1d$var$tokensToFunction($144a018fe7d9ff1d$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $144a018fe7d9ff1d$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $144a018fe7d9ff1d$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $144a018fe7d9ff1d$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $144a018fe7d9ff1d$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $144a018fe7d9ff1d$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($20606223719481a8$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $144a018fe7d9ff1d$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $144a018fe7d9ff1d$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $144a018fe7d9ff1d$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $144a018fe7d9ff1d$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $144a018fe7d9ff1d$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $144a018fe7d9ff1d$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $144a018fe7d9ff1d$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $144a018fe7d9ff1d$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($144a018fe7d9ff1d$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $144a018fe7d9ff1d$var$flags(options));
    return $144a018fe7d9ff1d$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $144a018fe7d9ff1d$var$stringToRegexp(path, keys, options) {
    return $144a018fe7d9ff1d$var$tokensToRegExp($144a018fe7d9ff1d$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $144a018fe7d9ff1d$var$tokensToRegExp(tokens, keys, options) {
    if (!$20606223719481a8$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $144a018fe7d9ff1d$var$escapeString(token);
        else {
            var prefix = $144a018fe7d9ff1d$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $144a018fe7d9ff1d$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $144a018fe7d9ff1d$var$attachKeys(new RegExp('^' + route, $144a018fe7d9ff1d$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $144a018fe7d9ff1d$var$pathToRegexp(path, keys, options) {
    if (!$20606223719481a8$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $144a018fe7d9ff1d$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($20606223719481a8$exports(path)) return $144a018fe7d9ff1d$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $144a018fe7d9ff1d$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $323e6cfabb70c42a$var$patternCache = {};
var $323e6cfabb70c42a$var$cacheLimit = 10000;
var $323e6cfabb70c42a$var$cacheCount = 0;
var $323e6cfabb70c42a$var$compileGenerator = function compileGenerator(pattern) {
    var cacheKey = pattern;
    var cache = $323e6cfabb70c42a$var$patternCache[cacheKey] || ($323e6cfabb70c42a$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var compiledGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($144a018fe7d9ff1d$exports))).compile(pattern);
    if ($323e6cfabb70c42a$var$cacheCount < $323e6cfabb70c42a$var$cacheLimit) {
        cache[pattern] = compiledGenerator;
        $323e6cfabb70c42a$var$cacheCount++;
    }
    return compiledGenerator;
};
/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */ var $323e6cfabb70c42a$var$generatePath = function generatePath() {
    var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (pattern === "/") return pattern;
    var generator = $323e6cfabb70c42a$var$compileGenerator(pattern);
    return generator(params, {
        pretty: true
    });
};
var $323e6cfabb70c42a$export$2e2bcd8739ae039 = $323e6cfabb70c42a$var$generatePath;


var $b2dcd82f04ca5542$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $b2dcd82f04ca5542$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b2dcd82f04ca5542$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b2dcd82f04ca5542$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for updating the location programmatically
 * with a component.
 */ var $b2dcd82f04ca5542$var$Redirect = function(_React$Component) {
    $b2dcd82f04ca5542$var$_inherits(Redirect, _React$Component);
    function Redirect() {
        $b2dcd82f04ca5542$var$_classCallCheck(this, Redirect);
        return $b2dcd82f04ca5542$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Redirect.prototype.isStatic = function isStatic() {
        return this.context.router && this.context.router.staticContext;
    };
    Redirect.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($1595ade849514d51$exports)))(this.context.router, "You should not use <Redirect> outside a <Router>");
        if (this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidMount = function componentDidMount() {
        if (!this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var prevTo = (0, $18d2ccbe4875bc55$export$90c043f1c57770b8)(prevProps.to);
        var nextTo = (0, $18d2ccbe4875bc55$export$90c043f1c57770b8)(this.props.to);
        if ((0, $18d2ccbe4875bc55$export$c3e8bb440bd55b18)(prevTo, nextTo)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($50f828fb99a2700d$exports)))(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
            return;
        }
        this.perform();
    };
    Redirect.prototype.computeTo = function computeTo(_ref) {
        var computedMatch = _ref.computedMatch, to = _ref.to;
        if (computedMatch) {
            if (typeof to === "string") return (0, $323e6cfabb70c42a$export$2e2bcd8739ae039)(to, computedMatch.params);
            else return $b2dcd82f04ca5542$var$_extends({}, to, {
                pathname: (0, $323e6cfabb70c42a$export$2e2bcd8739ae039)(to.pathname, computedMatch.params)
            });
        }
        return to;
    };
    Redirect.prototype.perform = function perform() {
        var history = this.context.router.history;
        var push = this.props.push;
        var to = this.computeTo(this.props);
        if (push) history.push(to);
        else history.replace(to);
    };
    Redirect.prototype.render = function render() {
        return null;
    };
    return Redirect;
}((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component);
$b2dcd82f04ca5542$var$Redirect.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).bool,
    from: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object
    ]).isRequired
};
$b2dcd82f04ca5542$var$Redirect.defaultProps = {
    push: false
};
$b2dcd82f04ca5542$var$Redirect.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func.isRequired
        }).isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object
    }).isRequired
};
var $b2dcd82f04ca5542$export$2e2bcd8739ae039 = $b2dcd82f04ca5542$var$Redirect;


var $20adb9c38480af55$export$2e2bcd8739ae039 = (0, $b2dcd82f04ca5542$export$2e2bcd8739ae039);

// Written in this round about way for babel-transform-imports



var $jiXHd = parcelRequire("jiXHd");

var $ePVXJ = parcelRequire("ePVXJ");

var $40930b9ab7f73ffd$var$patternCache = {};
var $40930b9ab7f73ffd$var$cacheLimit = 10000;
var $40930b9ab7f73ffd$var$cacheCount = 0;
var $40930b9ab7f73ffd$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $40930b9ab7f73ffd$var$patternCache[cacheKey] || ($40930b9ab7f73ffd$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($144a018fe7d9ff1d$exports)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($40930b9ab7f73ffd$var$cacheCount < $40930b9ab7f73ffd$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $40930b9ab7f73ffd$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $40930b9ab7f73ffd$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $40930b9ab7f73ffd$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $40930b9ab7f73ffd$export$2e2bcd8739ae039 = $40930b9ab7f73ffd$var$matchPath;


var $fc910df057240de3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $fc910df057240de3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fc910df057240de3$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $fc910df057240de3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $fc910df057240de3$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $fc910df057240de3$var$Route = function(_React$Component) {
    $fc910df057240de3$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $fc910df057240de3$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $fc910df057240de3$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $fc910df057240de3$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $fc910df057240de3$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($1595ade849514d51$exports)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $40930b9ab7f73ffd$export$2e2bcd8739ae039)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($50f828fb99a2700d$exports)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($50f828fb99a2700d$exports)))(!(this.props.component && this.props.children && !$fc910df057240de3$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($50f828fb99a2700d$exports)))(!(this.props.render && this.props.children && !$fc910df057240de3$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($50f828fb99a2700d$exports)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($50f828fb99a2700d$exports)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$fc910df057240de3$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component);
$fc910df057240de3$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object
};
$fc910df057240de3$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object
    })
};
$fc910df057240de3$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object.isRequired
};
var $fc910df057240de3$export$2e2bcd8739ae039 = $fc910df057240de3$var$Route;


var $adca9692c2edcaaa$export$2e2bcd8739ae039 = (0, $fc910df057240de3$export$2e2bcd8739ae039);

// Written in this round about way for babel-transform-imports

var $jiXHd = parcelRequire("jiXHd");

var $ePVXJ = parcelRequire("ePVXJ");



function $b4ec41751bec2c6b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b4ec41751bec2c6b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b4ec41751bec2c6b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var $b4ec41751bec2c6b$var$Switch = function(_React$Component) {
    $b4ec41751bec2c6b$var$_inherits(Switch, _React$Component);
    function Switch() {
        $b4ec41751bec2c6b$var$_classCallCheck(this, Switch);
        return $b4ec41751bec2c6b$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($1595ade849514d51$exports)))(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($50f828fb99a2700d$exports)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($50f828fb99a2700d$exports)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Children.forEach(children, function(element) {
            if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, $40930b9ab7f73ffd$export$2e2bcd8739ae039)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component);
$b4ec41751bec2c6b$var$Switch.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).shape({
        route: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object.isRequired
    }).isRequired
};
$b4ec41751bec2c6b$var$Switch.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object
};
var $b4ec41751bec2c6b$export$2e2bcd8739ae039 = $b4ec41751bec2c6b$var$Switch;


var $fc0bff407010a116$export$2e2bcd8739ae039 = (0, $b4ec41751bec2c6b$export$2e2bcd8739ae039);

// Written in this round about way for babel-transform-imports

var $jiXHd = parcelRequire("jiXHd");

var $ePVXJ = parcelRequire("ePVXJ");
var $b0611660191a01bc$exports = {};
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $b0611660191a01bc$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $b0611660191a01bc$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $b0611660191a01bc$var$defineProperty = Object.defineProperty;
var $b0611660191a01bc$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $b0611660191a01bc$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $b0611660191a01bc$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $b0611660191a01bc$var$getPrototypeOf = Object.getPrototypeOf;
var $b0611660191a01bc$var$objectPrototype = $b0611660191a01bc$var$getPrototypeOf && $b0611660191a01bc$var$getPrototypeOf(Object);
function $b0611660191a01bc$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($b0611660191a01bc$var$objectPrototype) {
            var inheritedComponent = $b0611660191a01bc$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $b0611660191a01bc$var$objectPrototype) $b0611660191a01bc$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $b0611660191a01bc$var$getOwnPropertyNames(sourceComponent);
        if ($b0611660191a01bc$var$getOwnPropertySymbols) keys = keys.concat($b0611660191a01bc$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$b0611660191a01bc$var$REACT_STATICS[key] && !$b0611660191a01bc$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $b0611660191a01bc$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $b0611660191a01bc$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
$b0611660191a01bc$exports = $b0611660191a01bc$var$hoistNonReactStatics;



var $ed267febb6bd714d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $ed267febb6bd714d$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/**
 * A public higher-order component to access the imperative API
 */ var $ed267febb6bd714d$var$withRouter = function withRouter(Component) {
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = $ed267febb6bd714d$var$_objectWithoutProperties(props, [
            "wrappedComponentRef"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fc910df057240de3$export$2e2bcd8739ae039), {
            children: function children(routeComponentProps) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement(Component, $ed267febb6bd714d$var$_extends({}, remainingProps, routeComponentProps, {
                    ref: wrappedComponentRef
                }));
            }
        });
    };
    C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    C.WrappedComponent = Component;
    C.propTypes = {
        wrappedComponentRef: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($b0611660191a01bc$exports)))(C, Component);
};
var $ed267febb6bd714d$export$2e2bcd8739ae039 = $ed267febb6bd714d$var$withRouter;


var $29c0cf2e84800dc5$export$2e2bcd8739ae039 = (0, $ed267febb6bd714d$export$2e2bcd8739ae039);


var $ddc83218ad96e131$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = '[native code]';
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if ($ddc83218ad96e131$exports) {
        classNames.default = classNames;
        $ddc83218ad96e131$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $0bb83cf2583d18f7$exports = {};

$parcel$export($0bb83cf2583d18f7$exports, "wrap", function () { return $0bb83cf2583d18f7$export$4997ffc0176396a6; }, function (v) { return $0bb83cf2583d18f7$export$4997ffc0176396a6 = v; });
$parcel$export($0bb83cf2583d18f7$exports, "descOpen", function () { return $0bb83cf2583d18f7$export$62b658b38c8b223e; }, function (v) { return $0bb83cf2583d18f7$export$62b658b38c8b223e = v; });
$parcel$export($0bb83cf2583d18f7$exports, "daysContainer", function () { return $0bb83cf2583d18f7$export$7bf9eadaf2f019fb; }, function (v) { return $0bb83cf2583d18f7$export$7bf9eadaf2f019fb = v; });
var $0bb83cf2583d18f7$export$4997ffc0176396a6;
var $0bb83cf2583d18f7$export$62b658b38c8b223e;
var $0bb83cf2583d18f7$export$7bf9eadaf2f019fb;
$0bb83cf2583d18f7$export$4997ffc0176396a6 = "_app-views-_styles__wrap";
$0bb83cf2583d18f7$export$62b658b38c8b223e = "_app-views-_styles__descOpen";
$0bb83cf2583d18f7$export$7bf9eadaf2f019fb = "_app-views-_styles__daysContainer";



var $jiXHd = parcelRequire("jiXHd");

var $061aca2e1fe74638$exports = {};

$parcel$export($061aca2e1fe74638$exports, "logoArea", function () { return $061aca2e1fe74638$export$109a06d8b89cba0; }, function (v) { return $061aca2e1fe74638$export$109a06d8b89cba0 = v; });
$parcel$export($061aca2e1fe74638$exports, "hidden", function () { return $061aca2e1fe74638$export$73920f18ca706874; }, function (v) { return $061aca2e1fe74638$export$73920f18ca706874 = v; });
$parcel$export($061aca2e1fe74638$exports, "logoAreaCaption", function () { return $061aca2e1fe74638$export$6b80430f3b64348a; }, function (v) { return $061aca2e1fe74638$export$6b80430f3b64348a = v; });
var $061aca2e1fe74638$export$109a06d8b89cba0;
var $061aca2e1fe74638$export$73920f18ca706874;
var $061aca2e1fe74638$export$6b80430f3b64348a;
$061aca2e1fe74638$export$109a06d8b89cba0 = "_app-views-Lensed-_styles__logoArea";
$061aca2e1fe74638$export$73920f18ca706874 = "_app-views-Lensed-_styles__hidden";
$061aca2e1fe74638$export$6b80430f3b64348a = "_app-views-Lensed-_styles__logoAreaCaption";



var $jiXHd = parcelRequire("jiXHd");

var $8a5710a8ac500127$exports = {};

$parcel$export($8a5710a8ac500127$exports, "logo", function () { return $8a5710a8ac500127$export$db3c28d99448dcff; }, function (v) { return $8a5710a8ac500127$export$db3c28d99448dcff = v; });
$parcel$export($8a5710a8ac500127$exports, "topPath", function () { return $8a5710a8ac500127$export$1e80c203db7bfaf0; }, function (v) { return $8a5710a8ac500127$export$1e80c203db7bfaf0 = v; });
$parcel$export($8a5710a8ac500127$exports, "circlePath", function () { return $8a5710a8ac500127$export$f3ea4332080b36fb; }, function (v) { return $8a5710a8ac500127$export$f3ea4332080b36fb = v; });
$parcel$export($8a5710a8ac500127$exports, "hidden", function () { return $8a5710a8ac500127$export$73920f18ca706874; }, function (v) { return $8a5710a8ac500127$export$73920f18ca706874 = v; });
$parcel$export($8a5710a8ac500127$exports, "topAnimating", function () { return $8a5710a8ac500127$export$6533b2ee733d741b; }, function (v) { return $8a5710a8ac500127$export$6533b2ee733d741b = v; });
$parcel$export($8a5710a8ac500127$exports, "circleAnimating", function () { return $8a5710a8ac500127$export$1253a914f93acef5; }, function (v) { return $8a5710a8ac500127$export$1253a914f93acef5 = v; });
var $8a5710a8ac500127$export$db3c28d99448dcff;
var $8a5710a8ac500127$export$1e80c203db7bfaf0;
var $8a5710a8ac500127$export$f3ea4332080b36fb;
var $8a5710a8ac500127$export$73920f18ca706874;
var $8a5710a8ac500127$export$6533b2ee733d741b;
var $8a5710a8ac500127$export$1253a914f93acef5;
$8a5710a8ac500127$export$db3c28d99448dcff = "_app-components-LogoTRaster-_styles__logo";
$8a5710a8ac500127$export$1e80c203db7bfaf0 = "_app-components-LogoTRaster-_styles__topPath";
$8a5710a8ac500127$export$f3ea4332080b36fb = "_app-components-LogoTRaster-_styles__circlePath";
$8a5710a8ac500127$export$73920f18ca706874 = "_app-components-LogoTRaster-_styles__hidden";
$8a5710a8ac500127$export$6533b2ee733d741b = "_app-components-LogoTRaster-_styles__topAnimating";
$8a5710a8ac500127$export$1253a914f93acef5 = "_app-components-LogoTRaster-_styles__circleAnimating";


function $ca3732035d8ae2ec$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ca3732035d8ae2ec$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.0.4
 * https://greensock.com
 *
 * @license Copyright 2008-2019, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $ca3732035d8ae2ec$export$4922bee768729a77 = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, $ca3732035d8ae2ec$var$_defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, $ca3732035d8ae2ec$var$_bigNum = 1e8, $ca3732035d8ae2ec$var$_tinyNum = 1 / $ca3732035d8ae2ec$var$_bigNum, $ca3732035d8ae2ec$var$_2PI = Math.PI * 2, $ca3732035d8ae2ec$var$_HALF_PI = $ca3732035d8ae2ec$var$_2PI / 4, $ca3732035d8ae2ec$var$_gsID = 0, $ca3732035d8ae2ec$var$_sqrt = Math.sqrt, $ca3732035d8ae2ec$var$_cos = Math.cos, $ca3732035d8ae2ec$var$_sin = Math.sin, $ca3732035d8ae2ec$export$f664476fd67145ca = function _isString(value) {
    return typeof value === "string";
}, $ca3732035d8ae2ec$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $ca3732035d8ae2ec$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $ca3732035d8ae2ec$export$a8178c063a9fd3a1 = function _isUndefined(value) {
    return typeof value === "undefined";
}, $ca3732035d8ae2ec$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $ca3732035d8ae2ec$var$_isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, $ca3732035d8ae2ec$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $ca3732035d8ae2ec$var$_isFuncOrString = function _isFuncOrString(value) {
    return $ca3732035d8ae2ec$var$_isFunction(value) || $ca3732035d8ae2ec$export$f664476fd67145ca(value);
}, $ca3732035d8ae2ec$var$_isArray = Array.isArray, $ca3732035d8ae2ec$var$_strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
$ca3732035d8ae2ec$export$b9d44bb6523120d6 = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$ca3732035d8ae2ec$var$_complexStringNumExp = /[-+=\.]*\d+(?:\.|e-|e)*\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
$ca3732035d8ae2ec$var$_parenthesesExp = /\(([^()]+)\)/i, //finds the string between parentheses.
$ca3732035d8ae2ec$export$5a680e28b0b61bc = /[\+-]=-?[\.\d]+/, $ca3732035d8ae2ec$var$_delimitedValueExp = /[#\-+\.]*\b[a-z\d-=+%.]+/gi, $ca3732035d8ae2ec$var$_globalTimeline, $ca3732035d8ae2ec$var$_win, $ca3732035d8ae2ec$var$_coreInitted, $ca3732035d8ae2ec$var$_doc, $ca3732035d8ae2ec$var$_globals = {}, $ca3732035d8ae2ec$var$_installScope = {}, $ca3732035d8ae2ec$var$_coreReady, $ca3732035d8ae2ec$var$_install = function _install(scope) {
    return ($ca3732035d8ae2ec$var$_installScope = $ca3732035d8ae2ec$var$_merge(scope, $ca3732035d8ae2ec$var$_globals)) && $ca3732035d8ae2ec$export$99ee26438460406a;
}, $ca3732035d8ae2ec$export$7fb54635790b59a5 = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, $ca3732035d8ae2ec$var$_warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, $ca3732035d8ae2ec$var$_addGlobal = function _addGlobal(name, obj) {
    return name && ($ca3732035d8ae2ec$var$_globals[name] = obj) && $ca3732035d8ae2ec$var$_installScope && ($ca3732035d8ae2ec$var$_installScope[name] = obj) || $ca3732035d8ae2ec$var$_globals;
}, $ca3732035d8ae2ec$var$_emptyFunc = function _emptyFunc() {
    return 0;
}, $ca3732035d8ae2ec$var$_reservedProps = {}, $ca3732035d8ae2ec$var$_lazyTweens = [], $ca3732035d8ae2ec$var$_lazyLookup = {}, $ca3732035d8ae2ec$export$d305d8ec5d7c26b8 = {}, $ca3732035d8ae2ec$var$_effects = {}, $ca3732035d8ae2ec$var$_nextGCFrame = 30, $ca3732035d8ae2ec$var$_harnessPlugins = [], $ca3732035d8ae2ec$var$_callbackNames = "onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", $ca3732035d8ae2ec$var$_harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    if (!$ca3732035d8ae2ec$var$_isObject(target) && !$ca3732035d8ae2ec$var$_isFunction(target)) targets = [
        targets
    ];
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        i = $ca3732035d8ae2ec$var$_harnessPlugins.length;
        while(i-- && !$ca3732035d8ae2ec$var$_harnessPlugins[i].targetTest(target));
        harnessPlugin = $ca3732035d8ae2ec$var$_harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new $ca3732035d8ae2ec$export$cf10981d5419cad5(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, $ca3732035d8ae2ec$export$8b9be379d2de2a39 = function _getCache(target) {
    return target._gsap || $ca3732035d8ae2ec$var$_harness($ca3732035d8ae2ec$export$45b10814cc054894(target))[0]._gsap;
}, $ca3732035d8ae2ec$export$51d6bbe898aef1f9 = function _getProperty(target, property) {
    var currentValue = target[property];
    return $ca3732035d8ae2ec$var$_isFunction(currentValue) ? target[property]() : $ca3732035d8ae2ec$export$a8178c063a9fd3a1(currentValue) && target.getAttribute(property) || currentValue;
}, $ca3732035d8ae2ec$export$f9000b814859f126 = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
$ca3732035d8ae2ec$export$9c8d725d65e13f94 = function _round(value) {
    return Math.round(value * 10000) / 10000;
}, $ca3732035d8ae2ec$var$_arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, $ca3732035d8ae2ec$var$_parseVars = function _parseVars(params, type, parent) {
    //reads the arguments passed to one of the key methods and figures out if the user is defining things with the OLD/legacy syntax where the duration is the 2nd parameter, and then it adjusts things accordingly and spits back the corrected vars object (with the duration added if necessary, as well as runBackwards or startAt or immediateRender). type 0 = to()/staggerTo(), 1 = from()/staggerFrom(), 2 = fromTo()/staggerFromTo()
    var isLegacy = $ca3732035d8ae2ec$var$_isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], i;
    if (isLegacy) vars.duration = params[1];
    if (type === 1) {
        vars.runBackwards = 1;
        vars.immediateRender = $ca3732035d8ae2ec$var$_isNotFalse(vars.immediateRender);
    } else if (type === 2) {
        i = params[varsIndex - 1]; //"from" vars
        vars.startAt = i;
        vars.immediateRender = $ca3732035d8ae2ec$var$_isNotFalse(vars.immediateRender);
    }
    vars.parent = parent;
    return vars;
}, $ca3732035d8ae2ec$var$_lazyRender = function _lazyRender() {
    var l = $ca3732035d8ae2ec$var$_lazyTweens.length, a = $ca3732035d8ae2ec$var$_lazyTweens.slice(0), i, tween;
    $ca3732035d8ae2ec$var$_lazyLookup = {};
    $ca3732035d8ae2ec$var$_lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        if (tween && tween._lazy) tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0;
    }
}, $ca3732035d8ae2ec$var$_lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    if ($ca3732035d8ae2ec$var$_lazyTweens.length) $ca3732035d8ae2ec$var$_lazyRender();
    animation.render(time, suppressEvents, force);
    if ($ca3732035d8ae2ec$var$_lazyTweens.length) //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
    $ca3732035d8ae2ec$var$_lazyRender();
}, $ca3732035d8ae2ec$var$_numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return n || n === 0 ? n : value;
}, $ca3732035d8ae2ec$var$_passThrough = function _passThrough(p) {
    return p;
}, $ca3732035d8ae2ec$export$dc2b19673bb53610 = function _setDefaults(obj, defaults) {
    for(var p in defaults)if (!(p in obj)) obj[p] = defaults[p];
    return obj;
}, $ca3732035d8ae2ec$var$_setKeyframeDefaults = function _setKeyframeDefaults(obj, defaults) {
    for(var p in defaults)if (!(p in obj) && p !== "duration" && p !== "ease") obj[p] = defaults[p];
}, $ca3732035d8ae2ec$var$_merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, $ca3732035d8ae2ec$var$_mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)base[p] = $ca3732035d8ae2ec$var$_isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p];
    return base;
}, $ca3732035d8ae2ec$var$_copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)if (!(p in excluding)) copy[p] = obj[p];
    return copy;
}, $ca3732035d8ae2ec$var$_inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || $ca3732035d8ae2ec$var$_globalTimeline, func = vars.keyframes ? $ca3732035d8ae2ec$var$_setKeyframeDefaults : $ca3732035d8ae2ec$export$dc2b19673bb53610;
    if ($ca3732035d8ae2ec$var$_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent;
    }
    return vars;
}, $ca3732035d8ae2ec$var$_arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, $ca3732035d8ae2ec$var$_addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = parent;
    return child;
}, $ca3732035d8ae2ec$export$cd008aa6cd8844e3 = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._dp = parent; //record the parent as _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
    child._next = child._prev = child.parent = null;
}, $ca3732035d8ae2ec$var$_removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    if (child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren)) child.parent.remove(child);
    child._act = 0;
}, $ca3732035d8ae2ec$var$_uncache = function _uncache(animation) {
    var a = animation;
    while(a){
        a._dirty = 1;
        a = a.parent;
    }
    return animation;
}, $ca3732035d8ae2ec$var$_recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, $ca3732035d8ae2ec$var$_hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, $ca3732035d8ae2ec$var$_elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? $ca3732035d8ae2ec$var$_animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
$ca3732035d8ae2ec$var$_animationCycle = function _animationCycle(tTime, cycleDuration) {
    return (tTime /= cycleDuration) && ~~tTime === tTime ? ~~tTime - 1 : ~~tTime;
}, $ca3732035d8ae2ec$var$_parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return child._ts > 0 ? (parentTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (parentTime - child._start) * child._ts;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ $ca3732035d8ae2ec$var$_addToTimeline = function _addToTimeline(timeline, child, position) {
    child.parent && $ca3732035d8ae2ec$var$_removeFromParent(child);
    child._start = position + child._delay;
    child._end = child._start + (child.totalDuration() / child._ts || 0);
    $ca3732035d8ae2ec$var$_addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    timeline._recent = child;
    if (child._time || !child._dur && child._initted) {
        //in case, for example, the _start is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
        var curTime = (timeline.rawTime() - child._start) * child._ts;
        if (!child._dur || $ca3732035d8ae2ec$var$_clamp(0, child.totalDuration(), curTime) - child._tTime > $ca3732035d8ae2ec$var$_tinyNum) child.render(curTime, true);
    }
    $ca3732035d8ae2ec$var$_uncache(timeline); //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (timeline._dp && timeline._time >= timeline._dur && timeline._ts && timeline._dur < timeline.duration()) {
        //in case any of the ancestors had completed but should now be enabled...
        var tl = timeline;
        while(tl._dp){
            tl.totalTime(tl._tTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
            tl = tl._dp;
        }
    }
    return timeline;
}, $ca3732035d8ae2ec$var$_attemptInitTween = function _attemptInitTween(tween, totalTime, force, suppressEvents) {
    $ca3732035d8ae2ec$var$_initTween(tween, totalTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy)) {
        $ca3732035d8ae2ec$var$_lazyTweens.push(tween);
        tween._lazy = [
            totalTime,
            suppressEvents
        ];
        return 1;
    }
}, $ca3732035d8ae2ec$var$_renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween._zTime < 0 ? 0 : 1, ratio = totalTime < 0 ? 0 : 1, repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        //in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = $ca3732035d8ae2ec$var$_clamp(0, tween._tDur, totalTime);
        iteration = $ca3732035d8ae2ec$var$_animationCycle(tTime, repeatDelay);
        prevIteration = $ca3732035d8ae2ec$var$_animationCycle(tween._tTime, repeatDelay);
        if (iteration !== prevIteration) {
            prevRatio = 1 - ratio;
            if (tween.vars.repeatRefresh && tween._initted) tween.invalidate();
        }
    }
    if (!tween._initted && $ca3732035d8ae2ec$var$_attemptInitTween(tween, totalTime, force, suppressEvents)) //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
    return;
    if (ratio !== prevRatio || force || tween._zTime === $ca3732035d8ae2ec$var$_tinyNum || !totalTime && tween._zTime) {
        tween._zTime = totalTime || (suppressEvents ? $ca3732035d8ae2ec$var$_tinyNum : 0); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        tween.ratio = ratio;
        if (tween._from) ratio = 1 - ratio;
        tween._time = 0;
        tween._tTime = tTime;
        if (!suppressEvents) $ca3732035d8ae2ec$var$_callback(tween, "onStart");
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        if (!ratio && tween._startAt && !tween._onUpdate && tween._start) //if the tween is positioned at the VERY beginning (_start 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
        tween._startAt.render(totalTime, true, force);
        if (tween._onUpdate && !suppressEvents) $ca3732035d8ae2ec$var$_callback(tween, "onUpdate");
        if (tTime && tween._repeat && !suppressEvents && tween.parent) $ca3732035d8ae2ec$var$_callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            tween.ratio && $ca3732035d8ae2ec$var$_removeFromParent(tween, 1);
            if (!suppressEvents) {
                $ca3732035d8ae2ec$var$_callback(tween, tween.ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    }
}, $ca3732035d8ae2ec$var$_findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (!child._dur && child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (!child._dur && child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, $ca3732035d8ae2ec$var$_onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    if (animation instanceof $ca3732035d8ae2ec$export$e6a97ba2cae5bb94) return $ca3732035d8ae2ec$var$_uncache(animation);
    var repeat = animation._repeat;
    animation._tDur = !repeat ? animation._dur : repeat < 0 ? 1e20 : $ca3732035d8ae2ec$export$9c8d725d65e13f94(animation._dur * (repeat + 1) + animation._rDelay * repeat);
    $ca3732035d8ae2ec$var$_uncache(animation.parent); //if the tween's duration changed, the parent timeline's duration may have changed, so flag it as "dirty"
    return animation;
}, $ca3732035d8ae2ec$var$_zeroPosition = {
    _start: 0,
    endTime: $ca3732035d8ae2ec$var$_emptyFunc
}, $ca3732035d8ae2ec$var$_parsePosition = function _parsePosition(animation, position, useBuildFrom) {
    var labels = animation.labels, recent = animation._recent || $ca3732035d8ae2ec$var$_zeroPosition, clippedDuration = animation.duration() >= $ca3732035d8ae2ec$var$_bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    //buildFrom = useBuildFrom ? animation._build : "auto",
    i, offset;
    if ($ca3732035d8ae2ec$export$f664476fd67145ca(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        i = position.charAt(0);
        if (i === "<" || i === ">") return (i === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0);
        i = position.indexOf("=");
        if (i < 0) {
            if (!(position in labels)) labels[position] = clippedDuration;
            return labels[position];
        }
        offset = +(position.charAt(i - 1) + position.substr(i + 1));
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1)) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position; //return (position == null) ? (isNaN(buildFrom) ? clippedDuration : buildFrom) : (buildFrom === ">>" ? clippedDuration : +buildFrom || 0) + (+position);
}, $ca3732035d8ae2ec$var$_conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, $ca3732035d8ae2ec$var$_clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, $ca3732035d8ae2ec$export$65f2564e9a9b9222 = function getUnit(value) {
    return (value + "").substr((parseFloat(value) + "").length);
}, $ca3732035d8ae2ec$export$7d15b64cf5a3a4c4 = function clamp(min, max, value) {
    return $ca3732035d8ae2ec$var$_conditionalReturn(value, function(v) {
        return $ca3732035d8ae2ec$var$_clamp(min, max, v);
    });
}, $ca3732035d8ae2ec$var$_slice = [].slice, $ca3732035d8ae2ec$var$_isArrayLike = function _isArrayLike(value) {
    return value && $ca3732035d8ae2ec$var$_isObject(value) && "length" in value && value.length - 1 in value && $ca3732035d8ae2ec$var$_isObject(value[0]) && !value.nodeType && value !== $ca3732035d8ae2ec$var$_win;
}, $ca3732035d8ae2ec$var$_flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return $ca3732035d8ae2ec$export$f664476fd67145ca(value) && !leaveStrings || $ca3732035d8ae2ec$var$_isArrayLike(value) ? (_accumulator = accumulator).push.apply(_accumulator, $ca3732035d8ae2ec$export$45b10814cc054894(value)) : accumulator.push(value);
    }) || accumulator;
}, $ca3732035d8ae2ec$export$45b10814cc054894 = function toArray(value, leaveStrings) {
    //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
    return $ca3732035d8ae2ec$export$f664476fd67145ca(value) && !leaveStrings && ($ca3732035d8ae2ec$var$_coreInitted || !$ca3732035d8ae2ec$var$_wake()) ? $ca3732035d8ae2ec$var$_slice.call($ca3732035d8ae2ec$var$_doc.querySelectorAll(value), 0) : $ca3732035d8ae2ec$var$_isArray(value) ? $ca3732035d8ae2ec$var$_flatten(value, leaveStrings) : $ca3732035d8ae2ec$var$_isArrayLike(value) ? $ca3732035d8ae2ec$var$_slice.call(value, 0) : value ? [
        value
    ] : [];
}, //for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
$ca3732035d8ae2ec$export$f02a9ddbe4480f19 = function distribute(v) {
    if ($ca3732035d8ae2ec$var$_isFunction(v)) return v;
    var vars = $ca3732035d8ae2ec$var$_isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = $ca3732035d8ae2ec$var$_parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if ($ca3732035d8ae2ec$export$f664476fd67145ca(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                $ca3732035d8ae2ec$var$_bigNum
            ])[1];
            if (!wrapAt) {
                max = -$ca3732035d8ae2ec$var$_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = $ca3732035d8ae2ec$var$_bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? $ca3732035d8ae2ec$var$_sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                if (d > max) max = d;
                if (d < min) min = d;
            }
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = $ca3732035d8ae2ec$export$65f2564e9a9b9222(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? $ca3732035d8ae2ec$var$_invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return $ca3732035d8ae2ec$export$9c8d725d65e13f94(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, $ca3732035d8ae2ec$export$dd12390e6b265a17 = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = v < 1 ? Math.pow(10, (v + "").length - 2) : 1; //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed()
    return function(raw) {
        return ~~(Math.round(parseFloat(raw) / v) * v * p) / p + ($ca3732035d8ae2ec$var$_isNumber(raw) ? 0 : $ca3732035d8ae2ec$export$65f2564e9a9b9222(raw));
    };
}, $ca3732035d8ae2ec$export$51a0620f7a28532b = function snap(snapTo, value) {
    var isArray = $ca3732035d8ae2ec$var$_isArray(snapTo), radius, is2D;
    if (!isArray && $ca3732035d8ae2ec$var$_isObject(snapTo)) {
        radius = isArray = snapTo.radius || $ca3732035d8ae2ec$var$_bigNum;
        snapTo = $ca3732035d8ae2ec$export$45b10814cc054894(snapTo.values);
        if (is2D = !$ca3732035d8ae2ec$var$_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
    }
    return $ca3732035d8ae2ec$var$_conditionalReturn(value, !isArray ? $ca3732035d8ae2ec$export$dd12390e6b265a17(snapTo) : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = $ca3732035d8ae2ec$var$_bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || $ca3732035d8ae2ec$var$_isNumber(raw) ? closest : closest + $ca3732035d8ae2ec$export$65f2564e9a9b9222(raw);
    });
}, $ca3732035d8ae2ec$export$4385e60b38654f68 = function random(min, max, roundingIncrement, returnFunction) {
    return $ca3732035d8ae2ec$var$_conditionalReturn($ca3732035d8ae2ec$var$_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return $ca3732035d8ae2ec$var$_isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && ~~(Math.round((min + Math.random() * (max - min)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, $ca3732035d8ae2ec$export$a4627e546088548d = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, $ca3732035d8ae2ec$export$d7502930aa5492de = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || $ca3732035d8ae2ec$export$65f2564e9a9b9222(value));
    };
}, $ca3732035d8ae2ec$export$a3295358bff77e = function normalize(min, max, value) {
    return $ca3732035d8ae2ec$export$f65a7599bbc6b121(min, max, 0, 1, value);
}, $ca3732035d8ae2ec$var$_wrapArray = function _wrapArray(a, wrapper, value) {
    return $ca3732035d8ae2ec$var$_conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, $ca3732035d8ae2ec$export$4997ffc0176396a6 = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return $ca3732035d8ae2ec$var$_isArray(min) ? $ca3732035d8ae2ec$var$_wrapArray(min, wrap(0, min.length), max) : $ca3732035d8ae2ec$var$_conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, $ca3732035d8ae2ec$export$cfc0b067273edc55 = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return $ca3732035d8ae2ec$var$_isArray(min) ? $ca3732035d8ae2ec$var$_wrapArray(min, wrapYoyo(0, min.length - 1), max) : $ca3732035d8ae2ec$var$_conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total;
        return min + (value > range ? total - value : value);
    });
}, $ca3732035d8ae2ec$export$d5962a97e3cde94d = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? $ca3732035d8ae2ec$var$_delimitedValueExp : $ca3732035d8ae2ec$var$_strictNumExp);
        s += value.substr(prev, i - prev) + $ca3732035d8ae2ec$export$4385e60b38654f68(isArray ? nums : +nums[0], +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, $ca3732035d8ae2ec$export$f65a7599bbc6b121 = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return $ca3732035d8ae2ec$var$_conditionalReturn(value, function(value) {
        return outMin + (value - inMin) / inRange * outRange;
    });
}, $ca3732035d8ae2ec$export$89e29e4ab65e70a9 = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = $ca3732035d8ae2ec$export$f664476fd67145ca(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if ($ca3732035d8ae2ec$var$_isArray(start) && !$ca3732035d8ae2ec$var$_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = $ca3732035d8ae2ec$var$_merge($ca3732035d8ae2ec$var$_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)$ca3732035d8ae2ec$var$_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return $ca3732035d8ae2ec$var$_renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return $ca3732035d8ae2ec$var$_conditionalReturn(progress, func);
}, $ca3732035d8ae2ec$var$_getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = $ca3732035d8ae2ec$var$_bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, $ca3732035d8ae2ec$var$_callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], params, scope;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    if (executeLazyFirst && $ca3732035d8ae2ec$var$_lazyTweens.length) //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    $ca3732035d8ae2ec$var$_lazyRender();
    return params ? callback.apply(scope, params) : callback.call(scope);
}, $ca3732035d8ae2ec$var$_interrupt = function _interrupt(animation) {
    $ca3732035d8ae2ec$var$_removeFromParent(animation);
    if (animation.progress() < 1) $ca3732035d8ae2ec$var$_callback(animation, "onInterrupt");
    return animation;
}, $ca3732035d8ae2ec$var$_quickTween, $ca3732035d8ae2ec$var$_createPlugin = function _createPlugin(config) {
    config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    var name = config.name, isFunc = $ca3732035d8ae2ec$var$_isFunction(config), Plugin = name && !isFunc && config.init ? function() {
        this._props = [];
    } : config, //in case someone passes in an object that's not a plugin, like CustomEase
    instanceDefaults = {
        init: $ca3732035d8ae2ec$var$_emptyFunc,
        render: $ca3732035d8ae2ec$var$_renderPropTweens,
        add: $ca3732035d8ae2ec$var$_addPropTween,
        kill: $ca3732035d8ae2ec$var$_killPropTweensOf,
        modifier: $ca3732035d8ae2ec$var$_addPluginModifier,
        rawVars: 0
    }, statics = {
        targetTest: 0,
        get: 0,
        getSetter: $ca3732035d8ae2ec$export$d60fbc1e0278aaf0,
        aliases: {},
        register: 0
    };
    $ca3732035d8ae2ec$var$_wake();
    if (config !== Plugin) {
        if ($ca3732035d8ae2ec$export$d305d8ec5d7c26b8[name]) return;
        $ca3732035d8ae2ec$export$dc2b19673bb53610(Plugin, $ca3732035d8ae2ec$export$dc2b19673bb53610($ca3732035d8ae2ec$var$_copyExcluding(config, instanceDefaults), statics)); //static methods
        $ca3732035d8ae2ec$var$_merge(Plugin.prototype, $ca3732035d8ae2ec$var$_merge(instanceDefaults, $ca3732035d8ae2ec$var$_copyExcluding(config, statics))); //instance methods
        $ca3732035d8ae2ec$export$d305d8ec5d7c26b8[Plugin.prop = name] = Plugin;
        if (config.targetTest) {
            $ca3732035d8ae2ec$var$_harnessPlugins.push(Plugin);
            $ca3732035d8ae2ec$var$_reservedProps[name] = 1;
        }
        name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
    }
    $ca3732035d8ae2ec$var$_addGlobal(name, Plugin);
    if (config.register) config.register($ca3732035d8ae2ec$export$99ee26438460406a, Plugin, $ca3732035d8ae2ec$export$3a67f7f44b1e838a);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ $ca3732035d8ae2ec$var$_255 = 255, $ca3732035d8ae2ec$var$_colorLookup = {
    aqua: [
        0,
        $ca3732035d8ae2ec$var$_255,
        $ca3732035d8ae2ec$var$_255
    ],
    lime: [
        0,
        $ca3732035d8ae2ec$var$_255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        $ca3732035d8ae2ec$var$_255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        $ca3732035d8ae2ec$var$_255,
        $ca3732035d8ae2ec$var$_255,
        $ca3732035d8ae2ec$var$_255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        $ca3732035d8ae2ec$var$_255,
        $ca3732035d8ae2ec$var$_255,
        0
    ],
    orange: [
        $ca3732035d8ae2ec$var$_255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        $ca3732035d8ae2ec$var$_255,
        0,
        0
    ],
    pink: [
        $ca3732035d8ae2ec$var$_255,
        192,
        203
    ],
    cyan: [
        0,
        $ca3732035d8ae2ec$var$_255,
        $ca3732035d8ae2ec$var$_255
    ],
    transparent: [
        $ca3732035d8ae2ec$var$_255,
        $ca3732035d8ae2ec$var$_255,
        $ca3732035d8ae2ec$var$_255,
        0
    ]
}, $ca3732035d8ae2ec$var$_hue = function _hue(h, m1, m2) {
    h = h < 0 ? h + 1 : h > 1 ? h - 1 : h;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * $ca3732035d8ae2ec$var$_255 + .5 | 0;
}, $ca3732035d8ae2ec$export$73d6f35be992df24 = function splitColor(v, toHSL) {
    var a = !v ? $ca3732035d8ae2ec$var$_colorLookup.black : $ca3732035d8ae2ec$var$_isNumber(v) ? [
        v >> 16,
        v >> 8 & $ca3732035d8ae2ec$var$_255,
        v & $ca3732035d8ae2ec$var$_255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if ($ca3732035d8ae2ec$var$_colorLookup[v]) a = $ca3732035d8ae2ec$var$_colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length === 4) {
                //for shorthand like #9F0
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b;
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & $ca3732035d8ae2ec$var$_255,
                v & $ca3732035d8ae2ec$var$_255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match($ca3732035d8ae2ec$var$_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                if (a.length > 3) a[3] *= 1; //cast as number
                a[0] = $ca3732035d8ae2ec$var$_hue(h + 1 / 3, r, g);
                a[1] = $ca3732035d8ae2ec$var$_hue(h, r, g);
                a[2] = $ca3732035d8ae2ec$var$_hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) //if relative values are found, just return the raw strings with the relative prefixes in place.
            return v.match($ca3732035d8ae2ec$export$b9d44bb6523120d6);
        } else a = v.match($ca3732035d8ae2ec$var$_strictNumExp) || $ca3732035d8ae2ec$var$_colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / $ca3732035d8ae2ec$var$_255;
        g = a[1] / $ca3732035d8ae2ec$var$_255;
        b = a[2] / $ca3732035d8ae2ec$var$_255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = h + .5 | 0;
        a[1] = s * 100 + .5 | 0;
        a[2] = l * 100 + .5 | 0;
    }
    return a;
}, $ca3732035d8ae2ec$var$_formatColors = function _formatColors(s, toHSL) {
    var colors = (s + "").match($ca3732035d8ae2ec$var$_colorExp), charIndex = 0, parsed = "", i, color, temp;
    if (!colors) return s;
    for(i = 0; i < colors.length; i++){
        color = colors[i];
        temp = s.substr(charIndex, s.indexOf(color, charIndex) - charIndex);
        charIndex += temp.length + color.length;
        color = $ca3732035d8ae2ec$export$73d6f35be992df24(color, toHSL);
        if (color.length === 3) color.push(1);
        parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
    }
    return parsed + s.substr(charIndex);
}, $ca3732035d8ae2ec$var$_colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in $ca3732035d8ae2ec$var$_colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), $ca3732035d8ae2ec$var$_hslExp = /hsl[a]?\(/, $ca3732035d8ae2ec$export$7eb2e5eb5eeb96a4 = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    $ca3732035d8ae2ec$var$_colorExp.lastIndex = 0;
    if ($ca3732035d8ae2ec$var$_colorExp.test(combined)) {
        toHSL = $ca3732035d8ae2ec$var$_hslExp.test(combined);
        a[0] = $ca3732035d8ae2ec$var$_formatColors(a[0], toHSL);
        a[1] = $ca3732035d8ae2ec$var$_formatColors(a[1], toHSL);
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ $ca3732035d8ae2ec$var$_tickerActive, $ca3732035d8ae2ec$export$762ed8fbedb691e3 = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1 / 60, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch;
        if (elapsed > _lagThreshold) _startTime += elapsed - _adjustedLag;
        _lastUpdate += elapsed;
        _self.time = (_lastUpdate - _startTime) / 1000;
        overlap = _self.time - _nextTime;
        if (overlap > 0 || manual) {
            _self.frame++;
            _nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
            dispatch = 1;
        }
        if (!manual) //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        _id = _req(_tick);
        if (dispatch) _listeners.forEach(function(l) {
            return l(_self.time, elapsed, _self.frame, v);
        });
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        wake: function wake() {
            if ($ca3732035d8ae2ec$var$_coreReady) {
                if (!$ca3732035d8ae2ec$var$_coreInitted && $ca3732035d8ae2ec$var$_windowExists()) {
                    $ca3732035d8ae2ec$var$_win = $ca3732035d8ae2ec$var$_coreInitted = window;
                    $ca3732035d8ae2ec$var$_doc = $ca3732035d8ae2ec$var$_win.document || {};
                    $ca3732035d8ae2ec$var$_globals.gsap = $ca3732035d8ae2ec$export$99ee26438460406a;
                    ($ca3732035d8ae2ec$var$_win.gsapVersions || ($ca3732035d8ae2ec$var$_win.gsapVersions = [])).push($ca3732035d8ae2ec$export$99ee26438460406a.version);
                    $ca3732035d8ae2ec$var$_install($ca3732035d8ae2ec$var$_installScope || $ca3732035d8ae2ec$var$_win.GreenSockGlobals || !$ca3732035d8ae2ec$var$_win.gsap && $ca3732035d8ae2ec$var$_win || {});
                    _raf = $ca3732035d8ae2ec$var$_win.requestAnimationFrame;
                }
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, (_nextTime - _self.time) * 1000 + 1 | 0);
                };
                $ca3732035d8ae2ec$var$_tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? $ca3732035d8ae2ec$var$_win.cancelAnimationFrame : clearTimeout)(_id);
            $ca3732035d8ae2ec$var$_tickerActive = 0;
            _req = $ca3732035d8ae2ec$var$_emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || 1 / $ca3732035d8ae2ec$var$_tinyNum; //zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
        },
        fps: function fps(_fps) {
            _gap = 1 / (_fps || 60);
            _nextTime = _self.time + _gap;
        },
        add: function add(callback) {
            _listeners.indexOf(callback) < 0 && _listeners.push(callback);
            $ca3732035d8ae2ec$var$_wake();
        },
        remove: function remove(callback) {
            var i;
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1);
        },
        _listeners: _listeners
    };
    return _self;
}(), $ca3732035d8ae2ec$var$_wake = function _wake() {
    return !$ca3732035d8ae2ec$var$_tickerActive && $ca3732035d8ae2ec$export$762ed8fbedb691e3.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ $ca3732035d8ae2ec$var$_easeMap = {}, $ca3732035d8ae2ec$var$_customEaseExp = /^[\d.\-M][\d.\-,\s]/, $ca3732035d8ae2ec$var$_quotesExp = /["']/g, $ca3732035d8ae2ec$var$_parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace($ca3732035d8ae2ec$var$_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, $ca3732035d8ae2ec$var$_configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = $ca3732035d8ae2ec$var$_easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        $ca3732035d8ae2ec$var$_parseObjectInString(split[1])
    ] : $ca3732035d8ae2ec$var$_parenthesesExp.exec(name)[1].split(",").map($ca3732035d8ae2ec$var$_numericIfPossible)) : $ca3732035d8ae2ec$var$_easeMap._CE && $ca3732035d8ae2ec$var$_customEaseExp.test(name) ? $ca3732035d8ae2ec$var$_easeMap._CE("", name) : ease;
}, $ca3732035d8ae2ec$var$_invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // potential future feature - allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos. Not sure it's worth the kb.
// _propagateYoyoEase = (timeline, isYoyo) => {
// 	let child = timeline._first, ease;
// 	while (child) {
// 		if (child instanceof Timeline) {
// 			_propagateYoyoEase(child, isYoyo);
// 		} else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
// 			if (child.timeline) {
// 				_propagateYoyoEase(child.timeline, isYoyo);
// 			} else {
// 				ease = child._ease;
// 				child._ease = child._yEase;
// 				child._yEase = ease;
// 				child._yoyo = isYoyo;
// 			}
// 		}
// 		child = child._next;
// 	}
// },
$ca3732035d8ae2ec$var$_parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : ($ca3732035d8ae2ec$var$_isFunction(ease) ? ease : $ca3732035d8ae2ec$var$_easeMap[ease] || $ca3732035d8ae2ec$var$_configEaseFromString(ease)) || defaultEase;
}, $ca3732035d8ae2ec$var$_insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    $ca3732035d8ae2ec$export$f9000b814859f126(names, function(name) {
        $ca3732035d8ae2ec$var$_easeMap[name] = $ca3732035d8ae2ec$var$_globals[name] = ease;
        $ca3732035d8ae2ec$var$_easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)$ca3732035d8ae2ec$var$_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = $ca3732035d8ae2ec$var$_easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, $ca3732035d8ae2ec$var$_easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, $ca3732035d8ae2ec$var$_configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / $ca3732035d8ae2ec$var$_2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * $ca3732035d8ae2ec$var$_sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $ca3732035d8ae2ec$var$_easeInOutFromOut(easeOut);
    p2 = $ca3732035d8ae2ec$var$_2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, $ca3732035d8ae2ec$var$_configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return --p * p * ((overshoot + 1) * p + overshoot) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $ca3732035d8ae2ec$var$_easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
$ca3732035d8ae2ec$export$f9000b814859f126("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    $ca3732035d8ae2ec$var$_insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
$ca3732035d8ae2ec$var$_easeMap.Linear.easeNone = $ca3732035d8ae2ec$var$_easeMap.none = $ca3732035d8ae2ec$var$_easeMap.Linear.easeIn;
$ca3732035d8ae2ec$var$_insertEase("Elastic", $ca3732035d8ae2ec$var$_configElastic("in"), $ca3732035d8ae2ec$var$_configElastic("out"), $ca3732035d8ae2ec$var$_configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    $ca3732035d8ae2ec$var$_insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
$ca3732035d8ae2ec$var$_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
$ca3732035d8ae2ec$var$_insertEase("Circ", function(p) {
    return -($ca3732035d8ae2ec$var$_sqrt(1 - p * p) - 1);
});
$ca3732035d8ae2ec$var$_insertEase("Sine", function(p) {
    return -$ca3732035d8ae2ec$var$_cos(p * $ca3732035d8ae2ec$var$_HALF_PI) + 1;
});
$ca3732035d8ae2ec$var$_insertEase("Back", $ca3732035d8ae2ec$var$_configBack("in"), $ca3732035d8ae2ec$var$_configBack("out"), $ca3732035d8ae2ec$var$_configBack());
$ca3732035d8ae2ec$var$_easeMap.SteppedEase = $ca3732035d8ae2ec$var$_easeMap.steps = $ca3732035d8ae2ec$var$_globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - $ca3732035d8ae2ec$var$_tinyNum;
        return function(p) {
            return ((p2 * $ca3732035d8ae2ec$var$_clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
$ca3732035d8ae2ec$var$_defaults.ease = $ca3732035d8ae2ec$var$_easeMap["quad.out"];
var $ca3732035d8ae2ec$export$cf10981d5419cad5 = function GSCache(target, harness) {
    this.id = $ca3732035d8ae2ec$var$_gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : $ca3732035d8ae2ec$export$51d6bbe898aef1f9;
    this.set = harness ? harness.getSetter : $ca3732035d8ae2ec$export$d60fbc1e0278aaf0;
};
var $ca3732035d8ae2ec$export$c35d437ae5945fcd = /*#__PURE__*/ function() {
    function Animation(vars, time) {
        var parent = vars.parent || $ca3732035d8ae2ec$var$_globalTimeline;
        this.vars = vars;
        this._dur = this._tDur = +vars.duration || 0;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat || 0) {
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
            $ca3732035d8ae2ec$var$_onUpdateTotalDuration(this);
        }
        this._ts = 1;
        this.data = vars.data;
        if (!$ca3732035d8ae2ec$var$_tickerActive) $ca3732035d8ae2ec$export$762ed8fbedb691e3.wake();
        if (parent) $ca3732035d8ae2ec$var$_addToTimeline(parent, this, time || time === 0 ? time : parent._time);
        if (vars.reversed) this.reversed(true);
        if (vars.paused) this.paused(true);
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        var isSetter = arguments.length, repeat = this._repeat, repeatCycles = repeat > 0 ? repeat * ((isSetter ? value : this._dur) + this._rDelay) : 0;
        return isSetter ? this.totalDuration(repeat < 0 ? value : value + repeatCycles) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        var repeat = this._repeat, isInfinite = (value || this._rDelay) && repeat < 0;
        this._tDur = isInfinite ? 1e20 : value;
        this._dur = isInfinite ? value : (value - repeat * this._rDelay) / (repeat + 1);
        this._dirty = 0;
        $ca3732035d8ae2ec$var$_uncache(this.parent);
        return this;
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        $ca3732035d8ae2ec$var$_wake();
        if (!arguments.length) return this._tTime;
        var parent = this.parent || this._dp, start;
        if (parent && parent.smoothChildTiming && this._ts) {
            start = this._start; // if (!parent._dp && parent._time === parent._dur) { // if a root timeline completes...and then a while later one of its children resumes, we must shoot the playhead forward to where it should be raw-wise, otherwise the child will jump to the end. Down side: this assumes it's using the _ticker.time as a reference.
            // 	parent._time = _ticker.time - parent._start;
            // }
            this._start = parent._time - (this._ts > 0 ? _totalTime / this._ts : ((this._dirty ? this.totalDuration() : this._tDur) - _totalTime) / -this._ts);
            this._end += this._start - start;
            if (!parent._dirty) //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
            $ca3732035d8ae2ec$var$_uncache(parent);
             //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts > 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this).
            $ca3732035d8ae2ec$var$_addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur) {
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            $ca3732035d8ae2ec$var$_lazySafeRender(this, _totalTime, suppressEvents);
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime((value + $ca3732035d8ae2ec$var$_elapsedCycleDuration(this)) % this.duration() || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this._tTime / this.totalDuration();
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + $ca3732035d8ae2ec$var$_elapsedCycleDuration(this), suppressEvents) : this.duration() ? this._time / this._dur : this.ratio;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? $ca3732035d8ae2ec$var$_animationCycle(this._tTime, cycleDuration) + 1 : 1;
    };
    _proto.timeScale = function timeScale(value) {
        if (!arguments.length) return this._ts || this._pauseTS || 0;
        if (this._pauseTS !== null) {
            this._pauseTS = value;
            return this;
        }
        this._ts = value;
        return $ca3732035d8ae2ec$var$_recacheAncestors(this).totalTime(this._tTime, true);
    };
    _proto.paused = function paused(value) {
        var isPaused = !this._ts;
        if (!arguments.length) return isPaused;
        if (isPaused !== value) {
            if (value) {
                this._pauseTS = this._ts;
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; //we use a timeScale of 0 to indicate a paused state, but we record the old "real" timeScale as _pauseTS so we can revert when unpaused.
            } else {
                this._ts = this._pauseTS || 1;
                this._pauseTS = null;
                value = this._tTime || this._pTime; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume().
                if (this.progress() === 1) // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course).
                this._tTime -= $ca3732035d8ae2ec$var$_tinyNum;
                this.totalTime(value, true);
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            if (this.parent && this.parent._sort) $ca3732035d8ae2ec$var$_addToTimeline(this.parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + ($ca3732035d8ae2ec$var$_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detatched parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : $ca3732035d8ae2ec$var$_parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    } // globalTime(rawTime) {
    ;
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value;
            return $ca3732035d8ae2ec$var$_onUpdateTotalDuration(this);
        }
        return this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            this._rDelay = value;
            return $ca3732035d8ae2ec$var$_onUpdateTotalDuration(this);
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime($ca3732035d8ae2ec$var$_parsePosition(this, position), $ca3732035d8ae2ec$var$_isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, $ca3732035d8ae2ec$var$_isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        if (from != null) this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        if (from != null) this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        if (atTime != null) this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        var ts = this._ts || this._pauseTS || 0;
        if (arguments.length) {
            if (value !== this.reversed()) {
                this[this._pauseTS === null ? "_ts" : "_pauseTS"] = Math.abs(ts) * (value ? -1 : 1);
                this.totalTime(this._tTime, true);
            }
            return this;
        }
        return ts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = 0;
        return this;
    };
    _proto.isActive = function isActive(hasStarted) {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !parent || this._ts && (this._initted || !hasStarted) && parent.isActive(hasStarted) && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - $ca3732035d8ae2ec$var$_tinyNum;
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                if (params) vars[type + "Params"] = params;
                if (type === "onUpdate") this._onUpdate = callback;
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var _this = this;
        return new Promise(function(resolve) {
            var f = onFulfilled || $ca3732035d8ae2ec$var$_passThrough, _resolve = function _resolve() {
                var _then = _this.then;
                _this.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                f = f(_this);
                if (f && (f.then || f === _this)) {
                    _this._prom = f;
                    _this.then = _then;
                }
                resolve(f);
                _this.then = _then;
            };
            if (_this._initted && _this.totalProgress() === 1 && _this._ts >= 0 || !_this._tTime && _this._ts < 0) _resolve();
            else _this._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        $ca3732035d8ae2ec$var$_interrupt(this);
    };
    return Animation;
}();
$ca3732035d8ae2ec$export$dc2b19673bb53610($ca3732035d8ae2ec$export$c35d437ae5945fcd.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: 0,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -$ca3732035d8ae2ec$var$_tinyNum,
    _prom: 0,
    _pauseTS: null
});
var $ca3732035d8ae2ec$export$e6a97ba2cae5bb94 = /*#__PURE__*/ function(_Animation) {
    $ca3732035d8ae2ec$var$_inheritsLoose(Timeline, _Animation);
    function Timeline(vars, time) {
        var _this2;
        if (vars === void 0) vars = {};
        _this2 = _Animation.call(this, vars, time) || this;
        _this2.labels = {};
        _this2.smoothChildTiming = $ca3732035d8ae2ec$var$_isNotFalse(vars.smoothChildTiming);
        _this2.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this2._sort = $ca3732035d8ae2ec$var$_isNotFalse(vars.sortChildren);
        return _this2;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        new $ca3732035d8ae2ec$export$208a41d6b4e37b97(targets, $ca3732035d8ae2ec$var$_parseVars(arguments, 0, this), $ca3732035d8ae2ec$var$_parsePosition(this, $ca3732035d8ae2ec$var$_isNumber(vars) ? arguments[3] : position));
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        new $ca3732035d8ae2ec$export$208a41d6b4e37b97(targets, $ca3732035d8ae2ec$var$_parseVars(arguments, 1, this), $ca3732035d8ae2ec$var$_parsePosition(this, $ca3732035d8ae2ec$var$_isNumber(vars) ? arguments[3] : position));
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        new $ca3732035d8ae2ec$export$208a41d6b4e37b97(targets, $ca3732035d8ae2ec$var$_parseVars(arguments, 2, this), $ca3732035d8ae2ec$var$_parsePosition(this, $ca3732035d8ae2ec$var$_isNumber(fromVars) ? arguments[4] : position));
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        if (!vars.repeatDelay) vars.repeat = 0;
        vars.immediateRender = !!vars.immediateRender;
        new $ca3732035d8ae2ec$export$208a41d6b4e37b97(targets, vars, $ca3732035d8ae2ec$var$_parsePosition(this, position));
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return $ca3732035d8ae2ec$var$_addToTimeline(this, $ca3732035d8ae2ec$export$208a41d6b4e37b97.delayedCall(0, callback, params), $ca3732035d8ae2ec$var$_parsePosition(this, position));
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new $ca3732035d8ae2ec$export$208a41d6b4e37b97(targets, vars, $ca3732035d8ae2ec$var$_parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        vars.immediateRender = $ca3732035d8ae2ec$var$_isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        toVars.immediateRender = $ca3732035d8ae2ec$var$_isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime > tDur - $ca3732035d8ae2ec$var$_tinyNum && totalTime >= 0 && this !== $ca3732035d8ae2ec$var$_globalTimeline ? tDur : totalTime < $ca3732035d8ae2ec$var$_tinyNum ? 0 : totalTime, crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        if (tTime !== this._tTime || force || crossingStart) {
            if (crossingStart) {
                if (!dur) prevTime = this._zTime;
                if (totalTime || !suppressEvents) //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                this._zTime = totalTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = timeScale === 0;
            if (prevTime !== this._time && dur) //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
            time += this._time - prevTime;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                time = $ca3732035d8ae2ec$export$9c8d725d65e13f94(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (time > dur || tDur === tTime) time = dur;
                iteration = ~~(tTime / cycleDuration);
                if (iteration && iteration === tTime / cycleDuration) {
                    time = dur;
                    iteration--;
                }
                prevIteration = $ca3732035d8ae2ec$var$_animationCycle(this._tTime, cycleDuration);
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    if (iteration < prevIteration) rewinding = !rewinding;
                    prevTime = rewinding ? 0 : dur;
                    this._lock = 1;
                    this.render(prevTime, suppressEvents, !dur)._lock = 0;
                    if (!suppressEvents && this.parent) $ca3732035d8ae2ec$var$_callback(this, "onRepeat");
                    if (prevTime !== this._time || prevPaused !== !this._ts) return this;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur + 0.0001 : -0.0001;
                        this.render(prevTime, true);
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                //_propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = $ca3732035d8ae2ec$var$_findNextPauseTween(this, $ca3732035d8ae2ec$export$9c8d725d65e13f94(prevTime), $ca3732035d8ae2ec$export$9c8d725d65e13f94(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
            }
            if (!prevTime && time && !suppressEvents) $ca3732035d8ae2ec$var$_callback(this, "onStart");
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -$ca3732035d8ae2ec$var$_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            if (this._onUpdate && !suppressEvents) $ca3732035d8ae2ec$var$_callback(this, "onUpdate", true);
            if (tTime === tDur || !tTime && this._ts < 0) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!time || tDur >= this.totalDuration()) {
                        (totalTime || !dur) && $ca3732035d8ae2ec$var$_removeFromParent(this, 1);
                        if (!suppressEvents && !(totalTime < 0 && !prevTime)) {
                            $ca3732035d8ae2ec$var$_callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                            this._prom && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this3 = this;
        if (!$ca3732035d8ae2ec$var$_isNumber(position)) position = $ca3732035d8ae2ec$var$_parsePosition(this, position);
        if (!(child instanceof $ca3732035d8ae2ec$export$c35d437ae5945fcd)) {
            if ($ca3732035d8ae2ec$var$_isArray(child)) {
                child.forEach(function(obj) {
                    return _this3.add(obj, position);
                });
                return $ca3732035d8ae2ec$var$_uncache(this);
            }
            if ($ca3732035d8ae2ec$export$f664476fd67145ca(child)) return this.addLabel(child, position);
            if ($ca3732035d8ae2ec$var$_isFunction(child)) child = $ca3732035d8ae2ec$export$208a41d6b4e37b97.delayedCall(0, child);
            else return this;
        }
        return this !== child ? $ca3732035d8ae2ec$var$_addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    } // buildFrom(position, absolute) {
    ;
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -$ca3732035d8ae2ec$var$_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof $ca3732035d8ae2ec$export$208a41d6b4e37b97) {
                    if (tweens) a.push(child);
                } else {
                    if (timelines) a.push(child);
                    if (nested) a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if ($ca3732035d8ae2ec$export$f664476fd67145ca(child)) return this.removeLabel(child);
        if ($ca3732035d8ae2ec$var$_isFunction(child)) return this.killTweensOf(child);
        $ca3732035d8ae2ec$export$cd008aa6cd8844e3(this, child);
        if (child === this._recent) this._recent = this._last;
        return $ca3732035d8ae2ec$var$_uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this.parent && !this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = $ca3732035d8ae2ec$export$762ed8fbedb691e3.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts);
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = $ca3732035d8ae2ec$var$_parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = $ca3732035d8ae2ec$export$208a41d6b4e37b97.delayedCall(0, callback || $ca3732035d8ae2ec$var$_emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return $ca3732035d8ae2ec$var$_addToTimeline(this, t, $ca3732035d8ae2ec$var$_parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = $ca3732035d8ae2ec$var$_parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") $ca3732035d8ae2ec$var$_removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)$ca3732035d8ae2ec$var$_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = $ca3732035d8ae2ec$export$45b10814cc054894(targets), child = this._first, children;
        while(child){
            if (child instanceof $ca3732035d8ae2ec$export$208a41d6b4e37b97) {
                if ($ca3732035d8ae2ec$var$_arrayContainsAny(child._targets, parsedTargets) && (!onlyActive || child.isActive(onlyActive === "started"))) a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    };
    _proto2.tweenTo = function tweenTo(position, vars) {
        var tl = this, endTime = $ca3732035d8ae2ec$var$_parsePosition(tl, position), startAt = vars && vars.startAt, tween = $ca3732035d8ae2ec$export$208a41d6b4e37b97.to(tl, $ca3732035d8ae2ec$export$dc2b19673bb53610({
            ease: "none",
            lazy: false,
            time: endTime,
            duration: Math.abs(endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale() || $ca3732035d8ae2ec$var$_tinyNum,
            onStart: function onStart() {
                tl.pause();
                var duration = Math.abs(endTime - tl._time) / tl.timeScale();
                if (tween._dur !== duration) {
                    tween._dur = duration;
                    tween.render(tween._time, true, true);
                }
                if (vars && vars.onStart) //in case the user had an onStart in the vars - we don't want to overwrite it.
                vars.onStart.apply(tween, vars.onStartParams || []);
            }
        }, vars));
        return tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, $ca3732035d8ae2ec$export$dc2b19673bb53610({
            startAt: {
                time: $ca3732035d8ae2ec$var$_parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return $ca3732035d8ae2ec$var$_getLabelInDirection(this, $ca3732035d8ae2ec$var$_parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return $ca3732035d8ae2ec$var$_getLabelInDirection(this, $ca3732035d8ae2ec$var$_parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + $ca3732035d8ae2ec$var$_tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) child._start += amount;
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return $ca3732035d8ae2ec$var$_uncache(this);
    };
    _proto2.invalidate = function invalidate() {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate();
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._time = this._tTime = 0;
        if (includeLabels) this.labels = {};
        return $ca3732035d8ae2ec$var$_uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = $ca3732035d8ae2ec$var$_bigNum, repeat = self._repeat, repeatCycles = repeat * self._rDelay || 0, isInfinite = repeat < 0, prev, end;
        if (!arguments.length) {
            if (self._dirty) {
                while(child){
                    prev = child._prev; //record it here in case the tween changes position in the sequence...
                    if (child._dirty) child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                    if (child._start > prevStart && self._sort && child._ts && !self._lock) {
                        //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                        self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                        $ca3732035d8ae2ec$var$_addToTimeline(self, child, child._start - child._delay);
                        self._lock = 0;
                    } else prevStart = child._start;
                    if (child._start < 0 && child._ts) {
                        //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                        max -= child._start;
                        if (!self.parent && !self._dp || self.parent && self.parent.smoothChildTiming) {
                            self._start += child._start / self._ts;
                            self._time -= child._start;
                            self._tTime -= child._start;
                        }
                        self.shiftChildren(-child._start, false, -$ca3732035d8ae2ec$var$_bigNum);
                        prevStart = 0;
                    }
                    end = child._end = child._start + child._tDur / Math.abs(child._ts || child._pauseTS || $ca3732035d8ae2ec$var$_tinyNum);
                    if (end > max && child._ts) max = $ca3732035d8ae2ec$export$9c8d725d65e13f94(end);
                    child = prev;
                }
                self._dur = self === $ca3732035d8ae2ec$var$_globalTimeline && self._time > max ? self._time : Math.min($ca3732035d8ae2ec$var$_bigNum, max);
                self._tDur = isInfinite && (self._dur || repeatCycles) ? 1e20 : Math.min($ca3732035d8ae2ec$var$_bigNum, max * (repeat + 1) + repeatCycles);
                self._end = self._start + (self._tDur / Math.abs(self._ts || self._pauseTS || $ca3732035d8ae2ec$var$_tinyNum) || 0);
                self._dirty = 0;
            }
            return self._tDur;
        }
        return isInfinite ? self : self.timeScale(self.totalDuration() / value);
    };
    Timeline.updateRoot = function updateRoot(time) {
        if ($ca3732035d8ae2ec$var$_globalTimeline._ts) $ca3732035d8ae2ec$var$_lazySafeRender($ca3732035d8ae2ec$var$_globalTimeline, $ca3732035d8ae2ec$var$_parentToChildTotalTime(time, $ca3732035d8ae2ec$var$_globalTimeline));
        if ($ca3732035d8ae2ec$export$762ed8fbedb691e3.frame >= $ca3732035d8ae2ec$var$_nextGCFrame) {
            $ca3732035d8ae2ec$var$_nextGCFrame += $ca3732035d8ae2ec$export$4922bee768729a77.autoSleep || 120;
            var child = $ca3732035d8ae2ec$var$_globalTimeline._first;
            if (!child || !child._ts) {
                if ($ca3732035d8ae2ec$export$4922bee768729a77.autoSleep && $ca3732035d8ae2ec$export$762ed8fbedb691e3._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    if (!child) $ca3732035d8ae2ec$export$762ed8fbedb691e3.sleep();
                }
            }
        }
    };
    return Timeline;
}($ca3732035d8ae2ec$export$c35d437ae5945fcd);
$ca3732035d8ae2ec$export$dc2b19673bb53610($ca3732035d8ae2ec$export$e6a97ba2cae5bb94.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var $ca3732035d8ae2ec$var$_addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new $ca3732035d8ae2ec$export$3a67f7f44b1e838a(this._pt, target, prop, 0, 1, $ca3732035d8ae2ec$export$c5bc8e04394ecb2, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = $ca3732035d8ae2ec$export$d5962a97e3cde94d(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match($ca3732035d8ae2ec$var$_complexStringNumExp) || [];
    while(result = $ca3732035d8ae2ec$var$_complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? parseFloat(endNum.substr(2)) * (endNum.charAt(0) === "-" ? -1 : 1) : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = $ca3732035d8ae2ec$var$_complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if ($ca3732035d8ae2ec$export$5a680e28b0b61bc.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, $ca3732035d8ae2ec$var$_addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam) {
    if ($ca3732035d8ae2ec$var$_isFunction(end)) end = end(index || 0, target, targets);
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !$ca3732035d8ae2ec$var$_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !$ca3732035d8ae2ec$var$_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !$ca3732035d8ae2ec$var$_isFunction(currentValue) ? $ca3732035d8ae2ec$var$_setterPlain : funcParam ? $ca3732035d8ae2ec$var$_setterFuncWithParam : $ca3732035d8ae2ec$var$_setterFunc, pt;
    if ($ca3732035d8ae2ec$export$f664476fd67145ca(end)) {
        if (~end.indexOf("random(")) end = $ca3732035d8ae2ec$export$d5962a97e3cde94d(end);
        if (end.charAt(1) === "=") end = parseFloat(parsedStart) + parseFloat(end.substr(2)) * (end.charAt(0) === "-" ? -1 : 1) + ($ca3732035d8ae2ec$export$65f2564e9a9b9222(parsedStart) || 0);
    }
    if (parsedStart !== end) {
        if (!isNaN(parsedStart + end)) {
            pt = new $ca3732035d8ae2ec$export$3a67f7f44b1e838a(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? $ca3732035d8ae2ec$var$_renderBoolean : $ca3732035d8ae2ec$var$_renderPlain, 0, setter);
            if (funcParam) pt.fp = funcParam;
            if (modifier) pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && $ca3732035d8ae2ec$export$7fb54635790b59a5(prop, end);
        return $ca3732035d8ae2ec$var$_addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || $ca3732035d8ae2ec$export$4922bee768729a77.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
$ca3732035d8ae2ec$var$_processVars = function _processVars(vars, index, target, targets, tween) {
    if ($ca3732035d8ae2ec$var$_isFunction(vars)) vars = $ca3732035d8ae2ec$var$_parseFuncOrString(vars, tween, index, target, targets);
    if (!$ca3732035d8ae2ec$var$_isObject(vars) || vars.style && vars.nodeType || $ca3732035d8ae2ec$var$_isArray(vars)) return $ca3732035d8ae2ec$export$f664476fd67145ca(vars) ? $ca3732035d8ae2ec$var$_parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = $ca3732035d8ae2ec$var$_parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, $ca3732035d8ae2ec$export$5c457b74208010cf = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if ($ca3732035d8ae2ec$export$d305d8ec5d7c26b8[property] && (plugin = new $ca3732035d8ae2ec$export$d305d8ec5d7c26b8[property]()).init(target, plugin.rawVars ? vars[property] : $ca3732035d8ae2ec$var$_processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new $ca3732035d8ae2ec$export$3a67f7f44b1e838a(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== $ca3732035d8ae2ec$var$_quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, $ca3732035d8ae2ec$var$_overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
$ca3732035d8ae2ec$var$_initTween = function _initTween(tween, time) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, onUpdateParams = vars.onUpdateParams, callbackScope = vars.callbackScope, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.parent._targets : targets, autoOverwrite = tween._overwrite === "auto", tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars;
    if (tl && (!keyframes || !ease)) ease = "none";
    tween._ease = $ca3732035d8ae2ec$var$_parseEase(ease, $ca3732035d8ae2ec$var$_defaults.ease);
    tween._yEase = yoyoEase ? $ca3732035d8ae2ec$var$_invertEase($ca3732035d8ae2ec$var$_parseEase(yoyoEase === true ? ease : yoyoEase, $ca3732035d8ae2ec$var$_defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    if (!tl) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        if (prevStartAt) prevStartAt.render(-1, true).kill();
        if (startAt) {
            $ca3732035d8ae2ec$var$_removeFromParent(tween._startAt = $ca3732035d8ae2ec$export$208a41d6b4e37b97.set(targets, $ca3732035d8ae2ec$export$dc2b19673bb53610({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: $ca3732035d8ae2ec$var$_isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate,
                onUpdateParams: onUpdateParams,
                callbackScope: callbackScope,
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            if (immediateRender) {
                if (time > 0) !autoRevert && (tween._startAt = 0); //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in Timeline instances where immediateRender was false or when autoRevert is explicitly set to true.
                else if (dur) return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
            }
        } else if (runBackwards && dur) {
            //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
            if (prevStartAt) !autoRevert && (tween._startAt = 0);
            else {
                if (time) //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                immediateRender = false;
                $ca3732035d8ae2ec$var$_removeFromParent(tween._startAt = $ca3732035d8ae2ec$export$208a41d6b4e37b97.set(targets, $ca3732035d8ae2ec$var$_merge($ca3732035d8ae2ec$var$_copyExcluding(vars, $ca3732035d8ae2ec$var$_reservedProps), {
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && $ca3732035d8ae2ec$var$_isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y:gsap.utils.wrap([-100,100])})
                })));
                if (!immediateRender) _initTween(tween._startAt, $ca3732035d8ae2ec$var$_tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        cleanVars = $ca3732035d8ae2ec$var$_copyExcluding(vars, $ca3732035d8ae2ec$var$_reservedProps);
        tween._pt = 0;
        harness = targets[0] ? $ca3732035d8ae2ec$export$8b9be379d2de2a39(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        lazy = dur && $ca3732035d8ae2ec$var$_isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || $ca3732035d8ae2ec$var$_harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            if ($ca3732035d8ae2ec$var$_lazyLookup[gsData.id]) $ca3732035d8ae2ec$var$_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new $ca3732035d8ae2ec$export$3a67f7f44b1e838a(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                if (plugin.priority) hasPriority = 1;
            }
            if (!harness || harnessVars) for(p in cleanVars){
                if ($ca3732035d8ae2ec$export$d305d8ec5d7c26b8[p] && (plugin = $ca3732035d8ae2ec$export$5c457b74208010cf(p, cleanVars, tween, index, target, fullTargets))) {
                    if (plugin.priority) hasPriority = 1;
                } else ptLookup[p] = pt = $ca3732035d8ae2ec$var$_addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            if (tween._op && tween._op[i]) tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                $ca3732035d8ae2ec$var$_overwritingTween = tween;
                $ca3732035d8ae2ec$var$_globalTimeline.killTweensOf(target, ptLookup, "started"); //Also make sure the overwriting doesn't overwrite THIS tween!!!
                $ca3732035d8ae2ec$var$_overwritingTween = 0;
            }
            if (tween._pt && lazy) $ca3732035d8ae2ec$var$_lazyLookup[gsData.id] = 1;
        }
        if (hasPriority) $ca3732035d8ae2ec$export$eed5824f53346d57(tween);
        if (tween._onInit) //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
        tween._onInit(tween);
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    tween._onUpdate = onUpdate;
    tween._initted = 1;
}, $ca3732035d8ae2ec$var$_addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? $ca3732035d8ae2ec$export$8b9be379d2de2a39(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = $ca3732035d8ae2ec$var$_merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, $ca3732035d8ae2ec$var$_parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return $ca3732035d8ae2ec$var$_isFunction(value) ? value.call(tween, i, target, targets) : $ca3732035d8ae2ec$export$f664476fd67145ca(value) && ~value.indexOf("random(") ? $ca3732035d8ae2ec$export$d5962a97e3cde94d(value) : value;
}, $ca3732035d8ae2ec$var$_staggerTweenProps = $ca3732035d8ae2ec$var$_callbackNames + ",repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase", $ca3732035d8ae2ec$var$_staggerPropsToSkip = ($ca3732035d8ae2ec$var$_staggerTweenProps + ",id,stagger,delay,duration,paused").split(",");
var $ca3732035d8ae2ec$export$208a41d6b4e37b97 = /*#__PURE__*/ function(_Animation2) {
    $ca3732035d8ae2ec$var$_inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, time) {
        var _this4;
        if (typeof vars === "number") {
            time.duration = vars;
            vars = time;
            time = null;
        }
        _this4 = _Animation2.call(this, $ca3732035d8ae2ec$var$_inheritDefaults(vars), time) || this;
        var _this4$vars = _this4.vars, duration = _this4$vars.duration, delay = _this4$vars.delay, immediateRender = _this4$vars.immediateRender, stagger = _this4$vars.stagger, overwrite = _this4$vars.overwrite, keyframes = _this4$vars.keyframes, defaults = _this4$vars.defaults, parsedTargets = $ca3732035d8ae2ec$var$_isArray(targets) && $ca3732035d8ae2ec$var$_isNumber(targets[0]) ? [
            targets
        ] : $ca3732035d8ae2ec$export$45b10814cc054894(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this4._targets = parsedTargets.length ? $ca3732035d8ae2ec$var$_harness(parsedTargets) : $ca3732035d8ae2ec$var$_warn("GSAP target " + targets + " not found. https://greensock.com", !$ca3732035d8ae2ec$export$4922bee768729a77.nullTargetWarn) || [];
        _this4._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this4._overwrite = overwrite;
        if (keyframes || stagger || $ca3732035d8ae2ec$var$_isFuncOrString(duration) || $ca3732035d8ae2ec$var$_isFuncOrString(delay)) {
            vars = _this4.vars;
            tl = _this4.timeline = new $ca3732035d8ae2ec$export$e6a97ba2cae5bb94({
                data: "nested",
                defaults: defaults || {}
            });
            tl.kill();
            tl.parent = $ca3732035d8ae2ec$var$_assertThisInitialized(_this4);
            if (keyframes) {
                $ca3732035d8ae2ec$export$dc2b19673bb53610(tl.vars.defaults, {
                    ease: "none"
                });
                keyframes.forEach(function(frame) {
                    return tl.to(parsedTargets, frame, ">");
                });
            } else {
                l = parsedTargets.length;
                staggerFunc = stagger ? $ca3732035d8ae2ec$export$f02a9ddbe4480f19(stagger) : $ca3732035d8ae2ec$var$_emptyFunc;
                if ($ca3732035d8ae2ec$var$_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~$ca3732035d8ae2ec$var$_staggerTweenProps.indexOf(p)) {
                        if (!staggerVarsToMerge) staggerVarsToMerge = {};
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = {};
                    for(p in vars)if ($ca3732035d8ae2ec$var$_staggerPropsToSkip.indexOf(p) < 0) copy[p] = vars[p];
                    copy.stagger = 0;
                    if (staggerVarsToMerge) $ca3732035d8ae2ec$var$_merge(copy, staggerVarsToMerge);
                    if (vars.yoyoEase && !vars.repeat) //so that propagation works properly when a ancestor timeline yoyos
                    copy.yoyoEase = vars.yoyoEase;
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +$ca3732035d8ae2ec$var$_parseFuncOrString(duration, $ca3732035d8ae2ec$var$_assertThisInitialized(_this4), i, curTarget, parsedTargets);
                    copy.delay = (+$ca3732035d8ae2ec$var$_parseFuncOrString(delay, $ca3732035d8ae2ec$var$_assertThisInitialized(_this4), i, curTarget, parsedTargets) || 0) - _this4._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this4._delay = delay = copy.delay;
                        _this4._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc(i, curTarget, parsedTargets));
                }
                duration = delay = 0;
            }
            duration || _this4.duration(duration = tl.duration());
        } else _this4.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true) {
            $ca3732035d8ae2ec$var$_overwritingTween = $ca3732035d8ae2ec$var$_assertThisInitialized(_this4);
            $ca3732035d8ae2ec$var$_globalTimeline.killTweensOf(parsedTargets);
            $ca3732035d8ae2ec$var$_overwritingTween = 0;
        }
        if (immediateRender || !duration && !keyframes && _this4._start === _this4.parent._time && $ca3732035d8ae2ec$var$_isNotFalse(immediateRender) && $ca3732035d8ae2ec$var$_hasNoPausedAncestors($ca3732035d8ae2ec$var$_assertThisInitialized(_this4)) && _this4.parent.data !== "nested") {
            _this4._tTime = -$ca3732035d8ae2ec$var$_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this4.render(Math.max(0, -delay)); //in case delay is negative
        }
        return _this4;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, tTime = totalTime > tDur - $ca3732035d8ae2ec$var$_tinyNum && totalTime >= 0 ? tDur : totalTime < $ca3732035d8ae2ec$var$_tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) $ca3732035d8ae2ec$var$_renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || this._startAt && this._zTime < 0 !== totalTime < 0) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                time = $ca3732035d8ae2ec$export$9c8d725d65e13f94(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (time > dur) time = dur;
                iteration = ~~(tTime / cycleDuration);
                if (iteration && iteration === tTime / cycleDuration) {
                    time = dur;
                    iteration--;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = $ca3732035d8ae2ec$var$_animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted) //could be during the repeatDelay part. No need to render and fire callbacks.
                return this;
                if (iteration !== prevIteration) //timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo);
                //repeatRefresh functionality
                {
                    if (this.vars.repeatRefresh && !this._lock) {
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(cycleDuration * iteration, true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted && $ca3732035d8ae2ec$var$_attemptInitTween(this, time, force, suppressEvents)) return this;
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (!prevTime && time && !suppressEvents) $ca3732035d8ae2ec$var$_callback(this, "onStart");
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -$ca3732035d8ae2ec$var$_tinyNum : timeline._dur * ratio, suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                if (totalTime < 0 && this._startAt) this._startAt.render(totalTime, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                $ca3732035d8ae2ec$var$_callback(this, "onUpdate");
            }
            if (this._repeat) {
                if (iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent) $ca3732035d8ae2ec$var$_callback(this, "onRepeat");
            }
            if ((tTime === tDur || !tTime) && this._tTime === tTime) {
                if (totalTime < 0 && this._startAt && !this._onUpdate) this._startAt.render(totalTime, true, force);
                (totalTime || !dur) && (tTime || this._ts < 0) && $ca3732035d8ae2ec$var$_removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime).
                if (!suppressEvents && !(totalTime < 0 && !prevTime)) {
                    $ca3732035d8ae2ec$var$_callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate() {
        this._pt = this._op = this._startAt = this._onUpdate = this._act = this._lazy = 0;
        this._ptLookup = [];
        if (this.timeline) this.timeline.invalidate();
        return _Animation2.prototype.invalidate.call(this);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = 0;
            if (this.parent) return $ca3732035d8ae2ec$var$_interrupt(this);
        }
        if (this.timeline) {
            this.timeline.killTweensOf(targets, vars, $ca3732035d8ae2ec$var$_overwritingTween && $ca3732035d8ae2ec$var$_overwritingTween.vars.overwrite !== true);
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? $ca3732035d8ae2ec$export$45b10814cc054894(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && $ca3732035d8ae2ec$var$_arraysMatch(parsedTargets, killingTargets)) return $ca3732035d8ae2ec$var$_interrupt(this);
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if ($ca3732035d8ae2ec$export$f664476fd67145ca(vars)) {
                p = {};
                $ca3732035d8ae2ec$export$f9000b814859f126(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = $ca3732035d8ae2ec$var$_addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) $ca3732035d8ae2ec$export$cd008aa6cd8844e3(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        if (this._initted && !this._pt && firstPT) //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        $ca3732035d8ae2ec$var$_interrupt(this);
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return new Tween(targets, $ca3732035d8ae2ec$var$_parseVars(arguments, 1));
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        });
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return new Tween(targets, $ca3732035d8ae2ec$var$_parseVars(arguments, 2));
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        if (!vars.repeatDelay) vars.repeat = 0;
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return $ca3732035d8ae2ec$var$_globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}($ca3732035d8ae2ec$export$c35d437ae5945fcd);
$ca3732035d8ae2ec$export$dc2b19673bb53610($ca3732035d8ae2ec$export$208a41d6b4e37b97.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
$ca3732035d8ae2ec$export$f9000b814859f126("staggerTo,staggerFrom,staggerFromTo", function(name) {
    $ca3732035d8ae2ec$export$208a41d6b4e37b97[name] = function() {
        var tl = new $ca3732035d8ae2ec$export$e6a97ba2cae5bb94(), params = $ca3732035d8ae2ec$export$45b10814cc054894(arguments);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var $ca3732035d8ae2ec$var$_setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, $ca3732035d8ae2ec$var$_setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, $ca3732035d8ae2ec$var$_setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, $ca3732035d8ae2ec$var$_setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, $ca3732035d8ae2ec$export$d60fbc1e0278aaf0 = function _getSetter(target, property) {
    return $ca3732035d8ae2ec$var$_isFunction(target[property]) ? $ca3732035d8ae2ec$var$_setterFunc : $ca3732035d8ae2ec$export$a8178c063a9fd3a1(target[property]) && target.setAttribute ? $ca3732035d8ae2ec$var$_setterAttribute : $ca3732035d8ae2ec$var$_setterPlain;
}, $ca3732035d8ae2ec$var$_renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000, data);
}, $ca3732035d8ae2ec$var$_renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, $ca3732035d8ae2ec$export$c5bc8e04394ecb2 = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, $ca3732035d8ae2ec$var$_renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, $ca3732035d8ae2ec$var$_addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        if (pt.p === property) pt.modifier(modifier, tween, target);
        pt = next;
    }
}, $ca3732035d8ae2ec$var$_killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) $ca3732035d8ae2ec$export$cd008aa6cd8844e3(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, $ca3732035d8ae2ec$var$_setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, $ca3732035d8ae2ec$export$eed5824f53346d57 = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var $ca3732035d8ae2ec$export$3a67f7f44b1e838a = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || $ca3732035d8ae2ec$var$_renderPlain;
        this.d = data || this;
        this.set = setter || $ca3732035d8ae2ec$var$_setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = $ca3732035d8ae2ec$var$_setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
$ca3732035d8ae2ec$export$f9000b814859f126($ca3732035d8ae2ec$var$_callbackNames + ",parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert", function(name) {
    $ca3732035d8ae2ec$var$_reservedProps[name] = 1;
    if (name.substr(0, 2) === "on") $ca3732035d8ae2ec$var$_reservedProps[name + "Params"] = 1;
});
$ca3732035d8ae2ec$var$_globals.TweenMax = $ca3732035d8ae2ec$var$_globals.TweenLite = $ca3732035d8ae2ec$export$208a41d6b4e37b97;
$ca3732035d8ae2ec$var$_globals.TimelineLite = $ca3732035d8ae2ec$var$_globals.TimelineMax = $ca3732035d8ae2ec$export$e6a97ba2cae5bb94;
$ca3732035d8ae2ec$var$_globalTimeline = new $ca3732035d8ae2ec$export$e6a97ba2cae5bb94({
    sortChildren: false,
    defaults: $ca3732035d8ae2ec$var$_defaults,
    autoRemoveChildren: true,
    id: "root"
});
$ca3732035d8ae2ec$export$4922bee768729a77.stringFilter = $ca3732035d8ae2ec$export$7eb2e5eb5eeb96a4;
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var $ca3732035d8ae2ec$var$_gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return $ca3732035d8ae2ec$var$_createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new $ca3732035d8ae2ec$export$e6a97ba2cae5bb94(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return $ca3732035d8ae2ec$var$_globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        if ($ca3732035d8ae2ec$export$f664476fd67145ca(target)) //in case selector text or an array is passed in
        target = $ca3732035d8ae2ec$export$45b10814cc054894(target)[0];
        var getter = $ca3732035d8ae2ec$export$8b9be379d2de2a39(target || {}).get, format = unit ? $ca3732035d8ae2ec$var$_passThrough : $ca3732035d8ae2ec$var$_numericIfPossible;
        if (unit === "native") unit = "";
        return !target ? target : !property ? function(property, unit, uncache) {
            return format(($ca3732035d8ae2ec$export$d305d8ec5d7c26b8[property] && $ca3732035d8ae2ec$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
        } : format(($ca3732035d8ae2ec$export$d305d8ec5d7c26b8[property] && $ca3732035d8ae2ec$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = $ca3732035d8ae2ec$export$45b10814cc054894(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return $ca3732035d8ae2ec$export$99ee26438460406a.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = $ca3732035d8ae2ec$export$d305d8ec5d7c26b8[property], cache = $ca3732035d8ae2ec$export$8b9be379d2de2a39(target), setter = Plugin ? function(value) {
            var p = new Plugin();
            $ca3732035d8ae2ec$var$_quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, $ca3732035d8ae2ec$var$_quickTween, 0, [
                target
            ]);
            p.render(1, p);
            $ca3732035d8ae2ec$var$_quickTween._pt && $ca3732035d8ae2ec$var$_renderPropTweens(1, $ca3732035d8ae2ec$var$_quickTween);
        } : cache.set(target, property);
        return Plugin ? setter : function(value) {
            return setter(target, property, unit ? value + unit : value, cache, 1);
        };
    },
    isTweening: function isTweening(targets) {
        return $ca3732035d8ae2ec$var$_globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        if (value && value.ease) value.ease = $ca3732035d8ae2ec$var$_parseEase(value.ease, $ca3732035d8ae2ec$var$_defaults.ease);
        return $ca3732035d8ae2ec$var$_mergeDeep($ca3732035d8ae2ec$var$_defaults, value || {});
    },
    config: function config(value) {
        return $ca3732035d8ae2ec$var$_mergeDeep($ca3732035d8ae2ec$export$4922bee768729a77, value || {});
    },
    registerEffect: function registerEffect(_ref) {
        var name = _ref.name, effect = _ref.effect, plugins = _ref.plugins, defaults = _ref.defaults, extendTimeline = _ref.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !$ca3732035d8ae2ec$export$d305d8ec5d7c26b8[pluginName] && !$ca3732035d8ae2ec$var$_globals[pluginName] && $ca3732035d8ae2ec$var$_warn(name + " effect requires " + pluginName + " plugin.");
        });
        $ca3732035d8ae2ec$var$_effects[name] = function(targets, vars) {
            return effect($ca3732035d8ae2ec$export$45b10814cc054894(targets), $ca3732035d8ae2ec$export$dc2b19673bb53610(vars || {}, defaults));
        };
        if (extendTimeline) $ca3732035d8ae2ec$export$e6a97ba2cae5bb94.prototype[name] = function(targets, vars, position) {
            return this.add($ca3732035d8ae2ec$var$_effects[name](targets, $ca3732035d8ae2ec$var$_isObject(vars) ? vars : (position = vars) && {}), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        $ca3732035d8ae2ec$var$_easeMap[name] = $ca3732035d8ae2ec$var$_parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? $ca3732035d8ae2ec$var$_parseEase(ease, defaultEase) : $ca3732035d8ae2ec$var$_easeMap;
    },
    getById: function getById(id) {
        return $ca3732035d8ae2ec$var$_globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new $ca3732035d8ae2ec$export$e6a97ba2cae5bb94(vars), child, next;
        tl.smoothChildTiming = $ca3732035d8ae2ec$var$_isNotFalse(vars.smoothChildTiming);
        $ca3732035d8ae2ec$var$_globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = $ca3732035d8ae2ec$var$_globalTimeline._time;
        child = $ca3732035d8ae2ec$var$_globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof $ca3732035d8ae2ec$export$208a41d6b4e37b97 && child.vars.onComplete === child._targets[0])) $ca3732035d8ae2ec$var$_addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        $ca3732035d8ae2ec$var$_addToTimeline($ca3732035d8ae2ec$var$_globalTimeline, tl, 0);
        return tl;
    },
    utils: {
        wrap: $ca3732035d8ae2ec$export$4997ffc0176396a6,
        wrapYoyo: $ca3732035d8ae2ec$export$cfc0b067273edc55,
        distribute: $ca3732035d8ae2ec$export$f02a9ddbe4480f19,
        random: $ca3732035d8ae2ec$export$4385e60b38654f68,
        snap: $ca3732035d8ae2ec$export$51a0620f7a28532b,
        normalize: $ca3732035d8ae2ec$export$a3295358bff77e,
        getUnit: $ca3732035d8ae2ec$export$65f2564e9a9b9222,
        clamp: $ca3732035d8ae2ec$export$7d15b64cf5a3a4c4,
        splitColor: $ca3732035d8ae2ec$export$73d6f35be992df24,
        toArray: $ca3732035d8ae2ec$export$45b10814cc054894,
        mapRange: $ca3732035d8ae2ec$export$f65a7599bbc6b121,
        pipe: $ca3732035d8ae2ec$export$a4627e546088548d,
        unitize: $ca3732035d8ae2ec$export$d7502930aa5492de,
        interpolate: $ca3732035d8ae2ec$export$89e29e4ab65e70a9
    },
    install: $ca3732035d8ae2ec$var$_install,
    effects: $ca3732035d8ae2ec$var$_effects,
    ticker: $ca3732035d8ae2ec$export$762ed8fbedb691e3,
    updateRoot: $ca3732035d8ae2ec$export$e6a97ba2cae5bb94.updateRoot,
    plugins: $ca3732035d8ae2ec$export$d305d8ec5d7c26b8,
    globalTimeline: $ca3732035d8ae2ec$var$_globalTimeline,
    core: {
        PropTween: $ca3732035d8ae2ec$export$3a67f7f44b1e838a,
        globals: $ca3732035d8ae2ec$var$_addGlobal,
        Tween: $ca3732035d8ae2ec$export$208a41d6b4e37b97,
        Timeline: $ca3732035d8ae2ec$export$e6a97ba2cae5bb94,
        Animation: $ca3732035d8ae2ec$export$c35d437ae5945fcd,
        getCache: $ca3732035d8ae2ec$export$8b9be379d2de2a39
    }
};
$ca3732035d8ae2ec$export$f9000b814859f126("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return $ca3732035d8ae2ec$var$_gsap[name] = $ca3732035d8ae2ec$export$208a41d6b4e37b97[name];
});
$ca3732035d8ae2ec$export$762ed8fbedb691e3.add($ca3732035d8ae2ec$export$e6a97ba2cae5bb94.updateRoot);
$ca3732035d8ae2ec$var$_quickTween = $ca3732035d8ae2ec$var$_gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var $ca3732035d8ae2ec$var$_getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, $ca3732035d8ae2ec$var$_addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = $ca3732035d8ae2ec$var$_getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, $ca3732035d8ae2ec$var$_buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if ($ca3732035d8ae2ec$export$f664476fd67145ca(vars)) {
                    temp = {};
                    $ca3732035d8ae2ec$export$f9000b814859f126(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                $ca3732035d8ae2ec$var$_addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var $ca3732035d8ae2ec$export$99ee26438460406a = $ca3732035d8ae2ec$var$_gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        for(var p in vars){
            this.add(target, "setAttribute", (target.getAttribute(p) || 0) + "", vars[p], index, targets, 0, 0, p); //this.add(target, "setAttribute", (target.getAttribute((p in target.dataset ? (p = "data-" + p) : p)) || 0) + "", vars[p], index, targets, 0, 0, p);
            this._props.push(p);
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i]);
    }
}, $ca3732035d8ae2ec$var$_buildModifierPlugin("roundProps", $ca3732035d8ae2ec$export$dd12390e6b265a17), $ca3732035d8ae2ec$var$_buildModifierPlugin("modifiers"), $ca3732035d8ae2ec$var$_buildModifierPlugin("snap", $ca3732035d8ae2ec$export$51a0620f7a28532b)) || $ca3732035d8ae2ec$var$_gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
$ca3732035d8ae2ec$export$208a41d6b4e37b97.version = $ca3732035d8ae2ec$export$e6a97ba2cae5bb94.version = $ca3732035d8ae2ec$export$99ee26438460406a.version = "3.0.4";
$ca3732035d8ae2ec$var$_coreReady = 1;
if ($ca3732035d8ae2ec$var$_windowExists()) $ca3732035d8ae2ec$var$_wake();
var $ca3732035d8ae2ec$export$2fae1e8613537d5f = $ca3732035d8ae2ec$var$_easeMap.Power0, $ca3732035d8ae2ec$export$5d84ab4efbecec39 = $ca3732035d8ae2ec$var$_easeMap.Power1, $ca3732035d8ae2ec$export$d8c694b7490ad65d = $ca3732035d8ae2ec$var$_easeMap.Power2, $ca3732035d8ae2ec$export$acebdf2b184a0b6f = $ca3732035d8ae2ec$var$_easeMap.Power3, $ca3732035d8ae2ec$export$42e40a141003d2f0 = $ca3732035d8ae2ec$var$_easeMap.Power4, $ca3732035d8ae2ec$export$cff00ccf6e2392de = $ca3732035d8ae2ec$var$_easeMap.Linear, $ca3732035d8ae2ec$export$7005c9eb6671414d = $ca3732035d8ae2ec$var$_easeMap.Quad, $ca3732035d8ae2ec$export$755261d5a1567778 = $ca3732035d8ae2ec$var$_easeMap.Cubic, $ca3732035d8ae2ec$export$daf531446cad3d2a = $ca3732035d8ae2ec$var$_easeMap.Quart, $ca3732035d8ae2ec$export$4c407d38ce8ad8cc = $ca3732035d8ae2ec$var$_easeMap.Quint, $ca3732035d8ae2ec$export$f301627d437cff88 = $ca3732035d8ae2ec$var$_easeMap.Strong, $ca3732035d8ae2ec$export$56ebabebb04a9ca9 = $ca3732035d8ae2ec$var$_easeMap.Elastic, $ca3732035d8ae2ec$export$25e48ac541203d4a = $ca3732035d8ae2ec$var$_easeMap.Back, $ca3732035d8ae2ec$export$f7a11c7543d81853 = $ca3732035d8ae2ec$var$_easeMap.SteppedEase, $ca3732035d8ae2ec$export$d20e79fdc3899e95 = $ca3732035d8ae2ec$var$_easeMap.Bounce, $ca3732035d8ae2ec$export$bed2d20ad96b784c = $ca3732035d8ae2ec$var$_easeMap.Sine, $ca3732035d8ae2ec$export$41e9d1ff1a2fb15a = $ca3732035d8ae2ec$var$_easeMap.Expo, $ca3732035d8ae2ec$export$ce49a57dd865b86c = $ca3732035d8ae2ec$var$_easeMap.Circ;


/*!
 * CSSPlugin 3.0.4
 * https://greensock.com
 *
 * Copyright 2008-2019, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $adc76b20b0fd5402$var$_win, $adc76b20b0fd5402$var$_doc, $adc76b20b0fd5402$var$_docElement, $adc76b20b0fd5402$var$_pluginInitted, $adc76b20b0fd5402$var$_tempDiv, $adc76b20b0fd5402$var$_tempDivStyler, $adc76b20b0fd5402$var$_recentSetterPlugin, $adc76b20b0fd5402$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $adc76b20b0fd5402$var$_transformProps = {}, $adc76b20b0fd5402$var$_RAD2DEG = 180 / Math.PI, $adc76b20b0fd5402$var$_DEG2RAD = Math.PI / 180, $adc76b20b0fd5402$var$_atan2 = Math.atan2, $adc76b20b0fd5402$var$_bigNum = 1e8, $adc76b20b0fd5402$var$_capsExp = /([A-Z])/g, $adc76b20b0fd5402$var$_numWithUnitExp = /[-+=\.]*\d+[\.e-]*\d*[a-z%]*/g, $adc76b20b0fd5402$var$_horizontalExp = /(?:left|right|width|margin|padding|x)/i, $adc76b20b0fd5402$var$_complexExp = /[\s,\(]\S/, $adc76b20b0fd5402$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $adc76b20b0fd5402$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, ~~((data.s + data.c * ratio) * 1000) / 1000 + data.u, data);
}, $adc76b20b0fd5402$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : ~~((data.s + data.c * ratio) * 1000) / 1000 + data.u, data);
}, $adc76b20b0fd5402$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? ~~((data.s + data.c * ratio) * 1000) / 1000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$adc76b20b0fd5402$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $adc76b20b0fd5402$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $adc76b20b0fd5402$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $adc76b20b0fd5402$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $adc76b20b0fd5402$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $adc76b20b0fd5402$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $adc76b20b0fd5402$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $adc76b20b0fd5402$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $adc76b20b0fd5402$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $adc76b20b0fd5402$var$_transformProp = "transform", $adc76b20b0fd5402$var$_transformOriginProp = $adc76b20b0fd5402$var$_transformProp + "Origin", $adc76b20b0fd5402$var$_supports3D, $adc76b20b0fd5402$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $adc76b20b0fd5402$var$_doc.createElementNS ? $adc76b20b0fd5402$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $adc76b20b0fd5402$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $adc76b20b0fd5402$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $adc76b20b0fd5402$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($adc76b20b0fd5402$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $adc76b20b0fd5402$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $adc76b20b0fd5402$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $adc76b20b0fd5402$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element) {
    var e = element || $adc76b20b0fd5402$var$_tempDiv, s = e.style, i = 5;
    if (property in s) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($adc76b20b0fd5402$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $adc76b20b0fd5402$var$_prefixes[i] : "") + property;
}, $adc76b20b0fd5402$var$_initCore = function _initCore() {
    if ($adc76b20b0fd5402$var$_windowExists()) {
        $adc76b20b0fd5402$var$_win = window;
        $adc76b20b0fd5402$var$_doc = $adc76b20b0fd5402$var$_win.document;
        $adc76b20b0fd5402$var$_docElement = $adc76b20b0fd5402$var$_doc.documentElement;
        $adc76b20b0fd5402$var$_tempDiv = $adc76b20b0fd5402$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $adc76b20b0fd5402$var$_tempDivStyler = $adc76b20b0fd5402$export$a232bb0480ae674a("div");
        $adc76b20b0fd5402$var$_transformProp = $adc76b20b0fd5402$export$8cbef5dd49a09c8b($adc76b20b0fd5402$var$_transformProp);
        $adc76b20b0fd5402$var$_transformOriginProp = $adc76b20b0fd5402$export$8cbef5dd49a09c8b($adc76b20b0fd5402$var$_transformOriginProp);
        $adc76b20b0fd5402$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $adc76b20b0fd5402$var$_supports3D = !!$adc76b20b0fd5402$export$8cbef5dd49a09c8b("perspective");
        $adc76b20b0fd5402$var$_pluginInitted = 1;
    }
}, $adc76b20b0fd5402$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $adc76b20b0fd5402$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $adc76b20b0fd5402$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldSibling) oldParent.insertBefore(this, oldSibling);
    else oldParent.appendChild(this);
    $adc76b20b0fd5402$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $adc76b20b0fd5402$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $adc76b20b0fd5402$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $adc76b20b0fd5402$var$_getBBoxHack.call(target, true);
    } //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$adc76b20b0fd5402$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$adc76b20b0fd5402$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $adc76b20b0fd5402$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $adc76b20b0fd5402$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$adc76b20b0fd5402$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style;
        if (property in $adc76b20b0fd5402$var$_transformProps) property = $adc76b20b0fd5402$var$_transformProp;
        if (style.removeProperty) {
            if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(property.replace($adc76b20b0fd5402$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $adc76b20b0fd5402$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $ca3732035d8ae2ec$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $adc76b20b0fd5402$var$_renderNonTweeningValueOnlyAtEnd : $adc76b20b0fd5402$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $adc76b20b0fd5402$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$adc76b20b0fd5402$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value), curUnit = (value + "").substr((curValue + "").length) || "px", style = $adc76b20b0fd5402$var$_tempDiv.style, horizontal = $adc76b20b0fd5402$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", px, parent, cache, isSVG;
    if (unit === curUnit || $adc76b20b0fd5402$var$_nonConvertibleUnits[unit] || $adc76b20b0fd5402$var$_nonConvertibleUnits[curUnit]) return curValue;
    isSVG = target.getCTM && $adc76b20b0fd5402$var$_isSVG(target);
    if (unit === "%" && $adc76b20b0fd5402$var$_transformProps[property]) //transforms are relative to the size of the element itself!
    return (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(curValue / (isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty]) * amount);
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $adc76b20b0fd5402$var$_doc || !parent.appendChild) parent = $adc76b20b0fd5402$var$_doc.body;
    cache = parent._gsap;
    if (cache && unit === "%" && cache.width && horizontal && cache.time === (0, $ca3732035d8ae2ec$export$762ed8fbedb691e3).time) return (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(curValue / cache.width * amount);
    else {
        parent.appendChild($adc76b20b0fd5402$var$_tempDiv);
        px = $adc76b20b0fd5402$var$_tempDiv[measureProperty];
        parent.removeChild($adc76b20b0fd5402$var$_tempDiv);
        if (horizontal && unit === "%") {
            cache = (0, $ca3732035d8ae2ec$export$8b9be379d2de2a39)(parent);
            cache.time = (0, $ca3732035d8ae2ec$export$762ed8fbedb691e3).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(toPixels ? px * curValue / amount : amount / px * curValue);
}, $adc76b20b0fd5402$var$_get = function _get(target, property, unit, uncache) {
    var value;
    if (!$adc76b20b0fd5402$var$_pluginInitted) $adc76b20b0fd5402$var$_initCore();
    if (property in $adc76b20b0fd5402$var$_propertyAliases && property !== "transform") {
        property = $adc76b20b0fd5402$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($adc76b20b0fd5402$var$_transformProps[property] && property !== "transform") {
        value = $adc76b20b0fd5402$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : $adc76b20b0fd5402$var$_firstTwoOnly($adc76b20b0fd5402$var$_getComputedProperty(target, $adc76b20b0fd5402$var$_transformOriginProp)) + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~value.indexOf("calc(")) value = $adc76b20b0fd5402$var$_getComputedProperty(target, property) || (0, $ca3732035d8ae2ec$export$51d6bbe898aef1f9)(target, property) || (property === "opacity" ? 1 : 0);
    }
    return unit ? $adc76b20b0fd5402$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $adc76b20b0fd5402$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    //note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new (0, $ca3732035d8ae2ec$export$3a67f7f44b1e838a)(this._pt, target.style, prop, 0, 1, (0, $ca3732035d8ae2ec$export$c5bc8e04394ecb2)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, relative, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (end === "auto") {
        target.style[prop] = end;
        end = $adc76b20b0fd5402$var$_getComputedProperty(target, prop) || end;
        target.style[prop] = start;
    }
    a = [
        start,
        end
    ];
    (0, $ca3732035d8ae2ec$export$7eb2e5eb5eeb96a4)(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
    start = a[0];
    end = a[1];
    startValue = start.indexOf("rgba(");
    endValue = end.indexOf("rgba(");
    if (!!startValue !== !!endValue) {
        // for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary.
        if (startValue) start = start.substr(startValue) + " " + start.substr(0, startValue - 1);
        else end = end.substr(endValue) + " " + end.substr(0, endValue - 1);
    }
    startValues = start.match($adc76b20b0fd5402$var$_numWithUnitExp) || [];
    endValues = end.match($adc76b20b0fd5402$var$_numWithUnitExp) || [];
    if (endValues.length) {
        while(result = $adc76b20b0fd5402$var$_numWithUnitExp.exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                relative = endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
                if (relative) endValue = endValue.substr(2);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = $adc76b20b0fd5402$var$_numWithUnitExp.lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $ca3732035d8ae2ec$export$4922bee768729a77).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $adc76b20b0fd5402$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: relative ? relative * endNum : endNum - startNum,
                    m: color && color < 4 ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $adc76b20b0fd5402$var$_renderNonTweeningValueOnlyAtEnd : $adc76b20b0fd5402$var$_renderNonTweeningValue;
    if ((0, $ca3732035d8ae2ec$export$5a680e28b0b61bc).test(end)) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $adc76b20b0fd5402$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $adc76b20b0fd5402$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $adc76b20b0fd5402$var$_keywordToPercent[x] || x;
    split[1] = $adc76b20b0fd5402$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $adc76b20b0fd5402$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($adc76b20b0fd5402$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $adc76b20b0fd5402$var$_transformOriginProp : $adc76b20b0fd5402$var$_transformProp;
                }
                $adc76b20b0fd5402$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $adc76b20b0fd5402$var$_removeProperty(target, $adc76b20b0fd5402$var$_transformProp);
            clearTransforms = target._gsap;
            if (clearTransforms) {
                if (clearTransforms.svg) target.removeAttribute("transform");
                $adc76b20b0fd5402$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$adc76b20b0fd5402$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $ca3732035d8ae2ec$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 0, $adc76b20b0fd5402$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $adc76b20b0fd5402$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $adc76b20b0fd5402$var$_rotationalProperties = {}, $adc76b20b0fd5402$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $adc76b20b0fd5402$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $adc76b20b0fd5402$var$_getComputedProperty(target, $adc76b20b0fd5402$var$_transformProp);
    return $adc76b20b0fd5402$var$_isNullTransform(matrixString) ? $adc76b20b0fd5402$var$_identity2DMatrix : matrixString.substr(7).match((0, $ca3732035d8ae2ec$export$b9d44bb6523120d6)).map((0, $ca3732035d8ae2ec$export$9c8d725d65e13f94));
}, $adc76b20b0fd5402$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap, style = target.style, matrix = $adc76b20b0fd5402$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $adc76b20b0fd5402$var$_identity2DMatrix : matrix;
    } else if (matrix === $adc76b20b0fd5402$var$_identity2DMatrix && !target.offsetParent && target !== $adc76b20b0fd5402$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            addedToDOM = 1; //flag
            nextSibling = target.nextSibling;
            $adc76b20b0fd5402$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $adc76b20b0fd5402$var$_getComputedTransformMatrixAsArray(target);
        if (temp) style.display = temp;
        else $adc76b20b0fd5402$var$_removeProperty(target, "display");
        if (addedToDOM) {
            if (nextSibling) parent.insertBefore(target, nextSibling);
            else if (parent) parent.appendChild(target);
            else $adc76b20b0fd5402$var$_docElement.removeChild(target);
        }
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $adc76b20b0fd5402$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $adc76b20b0fd5402$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $adc76b20b0fd5402$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== $adc76b20b0fd5402$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y;
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$adc76b20b0fd5402$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $adc76b20b0fd5402$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $adc76b20b0fd5402$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $adc76b20b0fd5402$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $adc76b20b0fd5402$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
}, $adc76b20b0fd5402$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $ca3732035d8ae2ec$export$cf10981d5419cad5)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, xOrigin = cache.xOrigin || 0, yOrigin = cache.yOrigin || 0, px = "px", deg = "deg", origin = $adc76b20b0fd5402$var$_getComputedProperty(target, $adc76b20b0fd5402$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $adc76b20b0fd5402$var$_isSVG(target));
    matrix = $adc76b20b0fd5402$var$_getMatrix(target, cache.svg);
    if (cache.svg) $adc76b20b0fd5402$var$_applySVGOrigin(target, origin, cache.originIsAbsolute, cache.smooth !== false, matrix);
    if (matrix !== $adc76b20b0fd5402$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $adc76b20b0fd5402$var$_atan2(b, a) * $adc76b20b0fd5402$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $adc76b20b0fd5402$var$_atan2(c, d) * $adc76b20b0fd5402$var$_RAD2DEG + rotation : 0;
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $adc76b20b0fd5402$var$_atan2(a32, a33);
            rotationX = angle * $adc76b20b0fd5402$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $adc76b20b0fd5402$var$_atan2(-c, a33);
            rotationY = angle * $adc76b20b0fd5402$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $adc76b20b0fd5402$var$_atan2(b, a);
            rotation = angle * $adc76b20b0fd5402$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $adc76b20b0fd5402$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $adc76b20b0fd5402$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            matrix = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$adc76b20b0fd5402$var$_isNullTransform($adc76b20b0fd5402$var$_getComputedProperty(target, $adc76b20b0fd5402$var$_transformProp));
            matrix && target.setAttribute("transform", matrix);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    cache.x = ((cache.xPercent = x && Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0) ? 0 : x) + px;
    cache.y = ((cache.yPercent = y && Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0) ? 0 : y) + px;
    cache.z = z + px;
    cache.scaleX = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(scaleX);
    cache.scaleY = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(scaleY);
    cache.rotation = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(rotation) + deg;
    cache.rotationX = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(rotationX) + deg;
    cache.rotationY = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) style[$adc76b20b0fd5402$var$_transformOriginProp] = $adc76b20b0fd5402$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $ca3732035d8ae2ec$export$4922bee768729a77).force3D;
    cache.renderTransform = cache.svg ? $adc76b20b0fd5402$var$_renderSVGTransforms : $adc76b20b0fd5402$var$_supports3D ? $adc76b20b0fd5402$var$_renderCSSTransforms : $adc76b20b0fd5402$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $adc76b20b0fd5402$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$adc76b20b0fd5402$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $ca3732035d8ae2ec$export$65f2564e9a9b9222)(start);
    return (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(parseFloat(start) + parseFloat($adc76b20b0fd5402$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $adc76b20b0fd5402$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $adc76b20b0fd5402$var$_renderCSSTransforms(ratio, cache);
}, $adc76b20b0fd5402$var$_zeroDeg = "0deg", $adc76b20b0fd5402$var$_zeroPx = "0px", $adc76b20b0fd5402$var$_endParenthesis = ") ", $adc76b20b0fd5402$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $adc76b20b0fd5402$var$_zeroDeg || rotationY !== $adc76b20b0fd5402$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $adc76b20b0fd5402$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $adc76b20b0fd5402$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $adc76b20b0fd5402$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $adc76b20b0fd5402$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $adc76b20b0fd5402$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (xPercent || yPercent) transforms = "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $adc76b20b0fd5402$var$_zeroPx || y !== $adc76b20b0fd5402$var$_zeroPx || z !== $adc76b20b0fd5402$var$_zeroPx) transforms += z !== $adc76b20b0fd5402$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $adc76b20b0fd5402$var$_endParenthesis;
    if (transformPerspective !== $adc76b20b0fd5402$var$_zeroPx) transforms += "perspective(" + transformPerspective + $adc76b20b0fd5402$var$_endParenthesis;
    if (rotation !== $adc76b20b0fd5402$var$_zeroDeg) transforms += "rotate(" + rotation + $adc76b20b0fd5402$var$_endParenthesis;
    if (rotationY !== $adc76b20b0fd5402$var$_zeroDeg) transforms += "rotateY(" + rotationY + $adc76b20b0fd5402$var$_endParenthesis;
    if (rotationX !== $adc76b20b0fd5402$var$_zeroDeg) transforms += "rotateX(" + rotationX + $adc76b20b0fd5402$var$_endParenthesis;
    if (skewX !== $adc76b20b0fd5402$var$_zeroDeg || skewY !== $adc76b20b0fd5402$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $adc76b20b0fd5402$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $adc76b20b0fd5402$var$_endParenthesis;
    target.style[$adc76b20b0fd5402$var$_transformProp] = transforms || "translate(0, 0)";
}, $adc76b20b0fd5402$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $adc76b20b0fd5402$var$_DEG2RAD;
        skewX *= $adc76b20b0fd5402$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $adc76b20b0fd5402$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(a11);
        a21 = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(a21);
        a12 = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(a12);
        a22 = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $adc76b20b0fd5402$var$_convertToUnit(target, "x", x, "px");
        ty = $adc76b20b0fd5402$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(tx + xPercent / 100 * temp.width);
        ty = (0, $ca3732035d8ae2ec$export$9c8d725d65e13f94)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    if (forceCSS) //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the  transform attribute changes!)
    target.style[$adc76b20b0fd5402$var$_transformProp] = temp;
}, $adc76b20b0fd5402$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue, relative) {
    var cap = 360, isString = (0, $ca3732035d8ae2ec$export$f664476fd67145ca)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $adc76b20b0fd5402$var$_RAD2DEG : 1), change = relative ? endNum * relative : endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $adc76b20b0fd5402$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $adc76b20b0fd5402$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $ca3732035d8ae2ec$export$3a67f7f44b1e838a)(plugin._pt, target, property, startNum, change, $adc76b20b0fd5402$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $adc76b20b0fd5402$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var style = $adc76b20b0fd5402$var$_tempDivStyler.style, startCache = target._gsap, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    style.cssText = getComputedStyle(target).cssText + ";position:absolute;display:block;"; //%-based translations will fail unless we set the width/height to match the original target (and padding/borders can affect it)
    style[$adc76b20b0fd5402$var$_transformProp] = transforms;
    $adc76b20b0fd5402$var$_doc.body.appendChild($adc76b20b0fd5402$var$_tempDivStyler);
    endCache = $adc76b20b0fd5402$var$_parseTransform($adc76b20b0fd5402$var$_tempDivStyler, 1);
    for(p in $adc76b20b0fd5402$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && p !== "perspective") {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $ca3732035d8ae2ec$export$65f2564e9a9b9222)(startValue);
            endUnit = (0, $ca3732035d8ae2ec$export$65f2564e9a9b9222)(endValue);
            startNum = startUnit !== endUnit ? $adc76b20b0fd5402$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $ca3732035d8ae2ec$export$3a67f7f44b1e838a)(plugin._pt, startCache, p, startNum, endNum - startNum, $adc76b20b0fd5402$var$_renderCSSProp);
            plugin._pt.u = endUnit;
            plugin._props.push(p);
        }
    }
    $adc76b20b0fd5402$var$_doc.body.removeChild($adc76b20b0fd5402$var$_tempDivStyler);
};
var $adc76b20b0fd5402$export$855822f522f18eef = {
    name: "css",
    register: $adc76b20b0fd5402$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority;
        if (!$adc76b20b0fd5402$var$_pluginInitted) $adc76b20b0fd5402$var$_initCore();
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $ca3732035d8ae2ec$export$d305d8ec5d7c26b8)[p] && (0, $ca3732035d8ae2ec$export$5c457b74208010cf)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $adc76b20b0fd5402$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $ca3732035d8ae2ec$export$d5962a97e3cde94d)(endValue);
            if (specialProp) {
                if (specialProp(this, target, p, endValue, tween)) hasPriority = 1;
            } else if (p.substr(0, 2) === "--") //CSS variable
            this.add(style, "setProperty", getComputedStyle(target).getPropertyValue(p) + "", endValue + "", index, targets, 0, 0, p);
            else {
                startValue = $adc76b20b0fd5402$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
                if (relative) endValue = endValue.substr(2);
                endNum = parseFloat(endValue);
                if (p in $adc76b20b0fd5402$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $adc76b20b0fd5402$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        $adc76b20b0fd5402$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $adc76b20b0fd5402$var$_propertyAliases[p];
                        if (~p.indexOf(",")) p = p.split(",")[0];
                    }
                }
                isTransformRelated = p in $adc76b20b0fd5402$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    if (!transformPropTween) {
                        cache = target._gsap;
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $ca3732035d8ae2ec$export$3a67f7f44b1e838a)(this._pt, style, $adc76b20b0fd5402$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $ca3732035d8ae2ec$export$3a67f7f44b1e838a)(this._pt, cache, "scaleY", cache.scaleY, relative ? relative * endNum : endNum - cache.scaleY);
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        endValue = $adc76b20b0fd5402$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $adc76b20b0fd5402$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]); //handle the zOrigin separately!
                            if (endUnit !== cache.zOrigin) $adc76b20b0fd5402$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $adc76b20b0fd5402$var$_addNonTweeningPT(this, style, p, $adc76b20b0fd5402$var$_firstTwoOnly(startValue), $adc76b20b0fd5402$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $adc76b20b0fd5402$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $adc76b20b0fd5402$var$_rotationalProperties) {
                        $adc76b20b0fd5402$var$_addRotationalPropTween(this, cache, p, startNum, endValue, relative);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $adc76b20b0fd5402$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $adc76b20b0fd5402$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $adc76b20b0fd5402$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$adc76b20b0fd5402$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endUnit = (endValue + "").substr((endNum + "").length) || (p in (0, $ca3732035d8ae2ec$export$4922bee768729a77).units ? (0, $ca3732035d8ae2ec$export$4922bee768729a77).units[p] : startUnit);
                    if (startUnit !== endUnit) startNum = $adc76b20b0fd5402$var$_convertToUnit(target, p, startValue, endUnit);
                    this._pt = new (0, $ca3732035d8ae2ec$export$3a67f7f44b1e838a)(this._pt, isTransformRelated ? cache : style, p, startNum, relative ? relative * endNum : endNum - startNum, endUnit === "px" && vars.autoRound !== false && !isTransformRelated ? $adc76b20b0fd5402$var$_renderRoundedCSSProp : $adc76b20b0fd5402$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit) {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $adc76b20b0fd5402$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, target[p], endValue, index, targets);
                    else {
                        (0, $ca3732035d8ae2ec$export$7fb54635790b59a5)(p, endValue);
                        continue;
                    }
                } else $adc76b20b0fd5402$var$_tweenComplexCSSString.call(this, target, p, startValue, endValue);
                props.push(p);
            }
        }
        if (hasPriority) (0, $ca3732035d8ae2ec$export$eed5824f53346d57)(this);
    },
    get: $adc76b20b0fd5402$var$_get,
    aliases: $adc76b20b0fd5402$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        return property in $adc76b20b0fd5402$var$_transformProps && property !== $adc76b20b0fd5402$var$_transformOriginProp && (target._gsap.x || $adc76b20b0fd5402$var$_get(target, "x")) ? plugin && $adc76b20b0fd5402$var$_recentSetterPlugin === plugin ? property === "scale" ? $adc76b20b0fd5402$var$_setterScale : $adc76b20b0fd5402$var$_setterTransform : ($adc76b20b0fd5402$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $adc76b20b0fd5402$var$_setterScaleWithRender : $adc76b20b0fd5402$var$_setterTransformWithRender) : target.style && !(0, $ca3732035d8ae2ec$export$a8178c063a9fd3a1)(target.style[property]) ? $adc76b20b0fd5402$var$_setterCSSStyle : ~property.indexOf("-") ? $adc76b20b0fd5402$var$_setterCSSProp : (0, $ca3732035d8ae2ec$export$d60fbc1e0278aaf0)(target, property);
    }
};
(0, $ca3732035d8ae2ec$export$99ee26438460406a).utils.checkPrefix = $adc76b20b0fd5402$export$8cbef5dd49a09c8b;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $ca3732035d8ae2ec$export$f9000b814859f126)(positionAndScale + "," + rotation + "," + others, function(name) {
        $adc76b20b0fd5402$var$_transformProps[name] = 1;
    });
    (0, $ca3732035d8ae2ec$export$f9000b814859f126)(rotation, function(name) {
        (0, $ca3732035d8ae2ec$export$4922bee768729a77).units[name] = "deg";
        $adc76b20b0fd5402$var$_rotationalProperties[name] = 1;
    });
    $adc76b20b0fd5402$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $ca3732035d8ae2ec$export$f9000b814859f126)(aliases, function(name) {
        var split = name.split(":");
        $adc76b20b0fd5402$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,9:rotateX,10:rotateY");
(0, $ca3732035d8ae2ec$export$f9000b814859f126)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $ca3732035d8ae2ec$export$4922bee768729a77).units[name] = "px";
});
(0, $ca3732035d8ae2ec$export$99ee26438460406a).registerPlugin($adc76b20b0fd5402$export$855822f522f18eef);


var $36b3090cb6608e8f$export$99ee26438460406a = (0, $ca3732035d8ae2ec$export$99ee26438460406a).registerPlugin((0, $adc76b20b0fd5402$export$855822f522f18eef)) || (0, $ca3732035d8ae2ec$export$99ee26438460406a); // to protect from tree shaking


var $4e10c0f01f501b44$exports = {};
$4e10c0f01f501b44$exports = $parcel$resolve("fzraq");


const $aca3e5e588c79778$var$LogoTTopUrl = new URL($4e10c0f01f501b44$exports);
var $57684b6e85893921$exports = {};
$57684b6e85893921$exports = $parcel$resolve("8CawB");


const $aca3e5e588c79778$var$LogoTCircleUrl = new URL($57684b6e85893921$exports);
class $aca3e5e588c79778$var$LogoTRaster extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {
        let tl = (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline();
        if (this.props.animated) {
            tl.to(this._topPath, {
                scaleX: 1,
                duration: 1.2,
                delay: .8
            });
            tl.to(this._circlePath, {
                scale: 1,
                duration: 1.2,
                delay: "-1.2"
            });
            if (!this.props.persist) {
                tl.to(this._topPath, {
                    scaleX: 0,
                    duration: 1.2,
                    delay: 1.5
                });
                tl.to(this._circlePath, {
                    scale: 0,
                    duration: 1.2,
                    delay: "-1.2",
                    onComplete: this.props.logoAnimationsComplete
                });
            }
        }
    }
    topAnimate(el) {
        el.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8a5710a8ac500127$exports))).topAnimating));
    }
    topAnimateOut(el) {
        el.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8a5710a8ac500127$exports))).topAnimating));
    }
    circleAnimate(el) {
        el.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8a5710a8ac500127$exports))).circleAnimating));
    }
    circleAnimateOut(el) {
        el.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8a5710a8ac500127$exports))).circleAnimating));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8a5710a8ac500127$exports))).logo, this.props.className, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($8a5710a8ac500127$exports))).hidden]: this.props.animated || this.props.inquireAnimation
            }),
            ref: (c)=>{
                this._el = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            ref: (c)=>{
                this._topPath = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8a5710a8ac500127$exports))).topPath),
            src: $aca3e5e588c79778$var$LogoTTopUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            ref: (c)=>{
                this._circlePath = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8a5710a8ac500127$exports))).circlePath),
            src: $aca3e5e588c79778$var$LogoTCircleUrl
        }));
    }
}
var $aca3e5e588c79778$export$2e2bcd8739ae039 = $aca3e5e588c79778$var$LogoTRaster;



var $jiXHd = parcelRequire("jiXHd");

var $4ddd4bb3bef74219$exports = {};

$parcel$export($4ddd4bb3bef74219$exports, "logo", function () { return $4ddd4bb3bef74219$export$db3c28d99448dcff; }, function (v) { return $4ddd4bb3bef74219$export$db3c28d99448dcff = v; });
var $4ddd4bb3bef74219$export$db3c28d99448dcff;
$4ddd4bb3bef74219$export$db3c28d99448dcff = "_app-components-Logo-_styles__logo";



// these should be the same as the breakpoints defined at the bottom of mq.scss
const $e5aa747dbfb4ff26$var$breakpoints = {
    desktop: 980,
    mobile: 320,
    mobileWide: 375,
    tablet: 740,
    desktopWide: 1327,
    wide: 1300
};
function $e5aa747dbfb4ff26$export$a5d4d60be2a7d682(aspect, win_w, win_h) {
    let width, height, offset_left, offset_top, win_a = win_w / win_h;
    if (win_a < aspect) {
        width = win_h * aspect;
        height = win_h;
        offset_left = (win_w - width) * 0.5;
        offset_top = 0;
    } else {
        width = win_w;
        height = win_w / aspect;
        offset_top = (win_h - height) * 0.5;
        offset_left = 0;
    }
    return [
        width,
        height,
        offset_left,
        offset_top
    ];
}
function $e5aa747dbfb4ff26$export$cab8c345dc6d78ad(aspect, win_w, win_h) {
    let width, height, offset_left, offset_top, win_a = win_w / win_h;
    if (win_a < aspect) {
        width = win_w;
        height = win_w / aspect;
        offset_top = (win_h - height) * 0.5;
        offset_left = 0;
    } else {
        width = win_h * aspect;
        height = win_h;
        offset_left = (win_w - width) * 0.5;
        offset_top = 0;
    }
    return [
        width,
        height,
        offset_left,
        offset_top
    ];
}
function $e5aa747dbfb4ff26$export$971e5333ff27c622() {
    return !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch);
}
if ($e5aa747dbfb4ff26$export$971e5333ff27c622()) document.documentElement.classList.add("touch");
else document.documentElement.classList.add("no-touch");
function $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc() {
    return window.innerWidth < $e5aa747dbfb4ff26$var$breakpoints["tablet"] || window.innerHeight < 420;
}
function $e5aa747dbfb4ff26$export$5cd843239dff6e53() {
    return Math.abs(window.orientation) === 90;
}


var $ca6f29c324da36b4$exports = {};
$ca6f29c324da36b4$exports = $parcel$resolve("kUzIq");


const $e6a04f3734eaac1b$var$blackwingLogoUrl = new URL($ca6f29c324da36b4$exports);
class $e6a04f3734eaac1b$var$Logo extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {
        let tl = (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline();
        tl.to(this._el, {
            opacity: 1,
            duration: 1.8,
            delay: .7
        });
        if (!this.props.persist) tl.to(this._el, {
            opacity: 0,
            duration: 1.2,
            delay: 1
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            ref: (c)=>{
                this._el = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))('logo', (0, (/*@__PURE__*/$parcel$interopDefault($4ddd4bb3bef74219$exports))).logo),
            alt: "Blackwing7 logo",
            src: $e6a04f3734eaac1b$var$blackwingLogoUrl
        });
    }
}
var $e6a04f3734eaac1b$export$2e2bcd8739ae039 = $e6a04f3734eaac1b$var$Logo;


/* eslint-disable react/jsx-no-bind */ 
var $jiXHd = parcelRequire("jiXHd");

var $7565755634e5a3f9$exports = {};

/*!
 * @fullpage/react-fullpage 0.1.40
 * https://github.com/alvarotrigo/react-fullpage
 * @license https://github.com/alvarotrigo/react-fullpage#license
 *
 * Copyright (C) 2018 alvarotrigo.com - A project by Alvaro Trigo & Michael Walker
 */ /******/ (()=>{
    /******/ var __webpack_modules__ = {
        /***/ 271: /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
            "use strict";
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ "Z": ()=>__WEBPACK_DEFAULT_EXPORT__
            });
            /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (debug, compName)=>{
                return debug ? function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return console.log(...[
                        `<${compName}/> Debug Log: `,
                        ...args
                    ]);
                } : ()=>{};
            };
        /***/ },
        /***/ 88: /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
            "use strict";
            // EXPORTS
            __webpack_require__.d(__webpack_exports__, {
                "Z": ()=>/* binding */ components_ReactFullpage
            });
            // EXTERNAL MODULE: external "react"
            var external_react_ = __webpack_require__(497);
            var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_);
            // EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
            var injectStylesIntoStyleTag = __webpack_require__(379);
            var injectStylesIntoStyleTag_default = /*#__PURE__*/ __webpack_require__.n(injectStylesIntoStyleTag);
            // EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
            var styleDomAPI = __webpack_require__(795);
            var styleDomAPI_default = /*#__PURE__*/ __webpack_require__.n(styleDomAPI);
            // EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
            var insertBySelector = __webpack_require__(569);
            var insertBySelector_default = /*#__PURE__*/ __webpack_require__.n(insertBySelector);
            // EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
            var setAttributesWithoutAttributes = __webpack_require__(565);
            var setAttributesWithoutAttributes_default = /*#__PURE__*/ __webpack_require__.n(setAttributesWithoutAttributes);
            // EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
            var insertStyleElement = __webpack_require__(216);
            var insertStyleElement_default = /*#__PURE__*/ __webpack_require__.n(insertStyleElement);
            // EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
            var styleTagTransform = __webpack_require__(589);
            var styleTagTransform_default = /*#__PURE__*/ __webpack_require__.n(styleTagTransform);
            // EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./node_modules/fullpage.js/dist/fullpage.min.css
            var fullpage_min = __webpack_require__(563);
            var options = {};
            options.styleTagTransform = styleTagTransform_default();
            options.setAttributes = setAttributesWithoutAttributes_default();
            options.insert = insertBySelector_default().bind(null, "head");
            options.domAPI = styleDomAPI_default();
            options.insertStyleElement = insertStyleElement_default();
            var update = injectStylesIntoStyleTag_default()(fullpage_min /* default */ .Z, options);
            /* harmony default export */ const dist_fullpage_min = fullpage_min /* default */ .Z && fullpage_min /* default.locals */ .Z.locals ? fullpage_min /* default.locals */ .Z.locals : undefined;
            // EXTERNAL MODULE: ./components/Logger/index.js
            var Logger = __webpack_require__(271);
            // EXTERNAL MODULE: ./components/selectors.js
            var selectors = __webpack_require__(542);
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    })), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                        _defineProperty(target, key, source[key]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    });
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            } /* eslint-disable import/no-extraneous-dependencies */  /* eslint-disable react/prop-types */  // eslint-disable-line no-unused-vars
            let Fullpage;
            const isFunc = (val)=>typeof val === 'function';
            const isEqualArray = (firstArr, secondArr)=>{
                if (firstArr.length !== secondArr.length) return false;
                return firstArr.find((el)=>!secondArr.includes(el)) == null;
            };
            const fullpageCallbacks = [
                'afterLoad',
                'afterRender',
                'afterResize',
                'afterResponsive',
                'afterSlideLoad',
                'onLeave',
                'onSlideLeave'
            ];
            class ReactFullpage extends external_react_default().Component {
                constructor(props){
                    super(props);
                    const { render: render, pluginWrapper: pluginWrapper } = this.props;
                    if (!isFunc(render)) throw new Error('must provide render prop to <ReactFullpage />');
                    this.log = (0, Logger /* default */ .Z)(this.props.debug, 'ReactFullpage');
                    this.log('Building component');
                    this.log('Importing vendor files');
                    this.importVendors();
                    if (pluginWrapper) {
                        this.log('Calling plugin wrapper');
                        pluginWrapper();
                    }
                    this.log('Requiring fullpage.js');
                    Fullpage = __webpack_require__(933);
                    this.state = {
                        initialized: false,
                        sectionCount: 0,
                        slideCount: 0
                    };
                }
                componentDidMount() {
                    const opts = this.buildOptions();
                    this.log('React Lifecycle: componentDidMount()');
                    if (Fullpage) {
                        this.init(opts);
                        this.markInitialized();
                    }
                }
                isReRenderNecessary(prevProps) {
                    const newSectionCount = this.getSectionCount();
                    const newSlideCount = this.getSlideCount();
                    const { sectionCount: sectionCount, slideCount: slideCount } = this.state;
                    let isReRenderNecessary = sectionCount !== newSectionCount || slideCount !== newSlideCount;
                    const propertiesThatNeedReRender = [
                        'sectionsColor',
                        'navigationTooltips',
                        'navigationPosition',
                        'navigation',
                        'scrollBar'
                    ];
                    propertiesThatNeedReRender.forEach((property)=>{
                        if (typeof prevProps[property] !== 'undefined') {
                            if (Array.isArray(prevProps[property])) isReRenderNecessary = isReRenderNecessary || !isEqualArray(prevProps[property], this.props[property]);
                            else isReRenderNecessary = isReRenderNecessary || prevProps[property] !== this.props[property];
                        }
                    });
                    return isReRenderNecessary;
                }
                componentDidUpdate(prevProps) {
                    this.log('React Lifecycle: componentDidUpdate()'); // NOTE: if fullpage props have changed we need to rebuild
                    if (this.isReRenderNecessary(prevProps)) {
                        this.log('rebuilding due to a change in fullpage.js props or num sections/slides');
                        this.reRender();
                        return;
                    }
                }
                componentWillUnmount() {
                    this.destroy();
                }
                getSectionCount() {
                    const { sectionSelector: sectionSelector = selectors /* DEFAULT_SECTION */ .uS } = this.props;
                    const { length: length } = document.querySelectorAll(sectionSelector);
                    return length;
                }
                getSlideCount() {
                    const { slideSelector: slideSelector = selectors /* DEFAULT_SLIDE */ .xH } = this.props;
                    const { length: length } = document.querySelectorAll(slideSelector);
                    return length;
                }
                importVendors() {
                    const { easing: easing, css3: css3 } = this.props;
                    if (easing && !css3) __webpack_require__(239);
                }
                init(opts) {
                    this.log('Reinitializing fullpage with options', opts);
                    const originalAnimateAnchor = opts.animateAnchor;
                    opts.animateAnchor = false;
                    new Fullpage(selectors /* ID_SELECTOR */ .Km, opts); // eslint-disable-line
                    this.fullpageApi = window.fullpage_api;
                    this.fpUtils = window.fp_utils;
                    this.fpEasings = window.fp_easings;
                    window.fullpage_api.getFullpageData().options.animateAnchor = originalAnimateAnchor;
                }
                destroy() {
                    this.log('Destroying fullpage instance');
                    this.fullpageApi.destroy('all');
                }
                reRender() {
                    const slideSelector = this.props.slideSelector || '.slide';
                    const sectionSelector = this.props.sectionSelector || '.section';
                    const activeSection = document.querySelector(sectionSelector + '.active');
                    const activeSectionIndex = activeSection ? this.fpUtils.index(activeSection) : this.state.destination ? this.state.destination.index - 1 : 0;
                    const activeSlide = document.querySelector(sectionSelector + '.active ' + slideSelector + '.active');
                    const activeSlideIndex = activeSlide ? this.fpUtils.index(activeSlide) : -1;
                    this.destroy();
                    if (activeSectionIndex > -1) this.fpUtils.addClass(document.querySelectorAll(sectionSelector)[activeSectionIndex], 'active');
                    if (activeSlideIndex > -1) this.fpUtils.addClass(activeSlide, 'active');
                    this.init(this.buildOptions());
                }
                markInitialized() {
                    this.log('Marking initialized');
                    this.setState({
                        initialized: true,
                        sectionCount: this.getSectionCount(),
                        slideCount: this.getSlideCount()
                    });
                }
                buildOptions() {
                    var _this = this;
                    let listeners = null;
                    if (!this.state.initialized) {
                        const filterCb = (key)=>!!Object.keys(this.props).find((cb)=>{
                                return cb === key;
                            });
                        const registered = fullpageCallbacks.filter(filterCb);
                        listeners = registered.reduce((result, key)=>{
                            return _objectSpread(_objectSpread({}, result), {}, {
                                [key]: function() {
                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                    return _this.update(...[
                                        key,
                                        ...args
                                    ]);
                                }
                            });
                        }, {});
                    } // NOTE: override passed in callbacks w/  wrapped listeners
                    const options = _objectSpread(_objectSpread({}, this.props), listeners);
                    this.log('Building fullpage.js options: ', options);
                    return options;
                }
                update(lastEvent) {
                    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                    this.log('Event trigger: ', lastEvent);
                    let state = _objectSpread(_objectSpread({}, this.state), {}, {
                        sectionCount: this.getSectionCount(),
                        slideCount: this.getSlideCount()
                    });
                    const makeState = (callbackParameters)=>_objectSpread(_objectSpread(_objectSpread({}, state), callbackParameters), {}, {
                            lastEvent: lastEvent
                        });
                    const fromArgs = (argList)=>argList.reduce((result, key, i)=>{
                            const value = args[i];
                            result[key] = value; // eslint-disable-line
                            return result;
                        }, {}); // NOTE: remapping callback args to v3
                    // https://github.com/alvarotrigo/fullPage.js#callbacks
                    switch(lastEvent){
                        case 'afterLoad':
                            state = makeState(fromArgs([
                                'origin',
                                'destination',
                                'direction'
                            ]));
                            break;
                        case 'afterResize':
                            state = makeState(fromArgs([
                                ''
                            ]));
                            break;
                        case 'afterResponsive':
                            state = makeState(fromArgs([
                                'isResponsive'
                            ]));
                            break;
                        case 'afterSlideLoad':
                            state = makeState(fromArgs([
                                'section',
                                'origin',
                                'destination',
                                'direction'
                            ]));
                            break; // On-*
                        case 'onLeave':
                            state = makeState(fromArgs([
                                'origin',
                                'destination',
                                'direction'
                            ]));
                            break;
                        case 'onSlideLeave':
                            state = makeState(fromArgs([
                                'section',
                                'origin',
                                'slideIndex',
                                'destination',
                                'direction'
                            ]));
                            break;
                        default:
                            break;
                    }
                    const returned = this.props[lastEvent](...args);
                    this.log('Called callback: Returning => ', returned);
                    this.log('Updating State => ', state);
                    this.setState(state);
                    return returned;
                }
                render() {
                    this.log('<== Rendering ==>');
                    return /*#__PURE__*/ external_react_default().createElement("div", {
                        id: selectors /* MAIN_SELECTOR */ .W1
                    }, this.props.render(this));
                }
            }
            ReactFullpage.defaultProps = {
                sectionsColor: []
            }; /* harmony default export */ 
            const components_ReactFullpage = ReactFullpage;
        /***/ },
        /***/ 882: /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
            "use strict";
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ "Z": ()=>__WEBPACK_DEFAULT_EXPORT__
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(497);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(271);
            /* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(542);
            /* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable react/prop-types */ // NOTE: SSR support
            class ReactFullpageShell extends react__WEBPACK_IMPORTED_MODULE_0___default().Component {
                constructor(props){
                    super(props);
                    this.state = {};
                    this.log = (0, _Logger__WEBPACK_IMPORTED_MODULE_2__ /* ["default"] */ .Z)(this.props.debug, 'ReactFullpageShell');
                    this.log('Building component');
                }
                render() {
                    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
                        id: _selectors__WEBPACK_IMPORTED_MODULE_1__ /* .MAIN_SELECTOR */ .W1
                    }, this.props.render(this));
                }
            } /* harmony default export */ 
            const __WEBPACK_DEFAULT_EXPORT__ = ReactFullpageShell;
        /***/ },
        /***/ 542: /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
            "use strict";
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ "W1": ()=>/* binding */ MAIN_SELECTOR,
                /* harmony export */ "Km": ()=>/* binding */ ID_SELECTOR,
                /* harmony export */ "uS": ()=>/* binding */ DEFAULT_SECTION,
                /* harmony export */ "xH": ()=>/* binding */ DEFAULT_SLIDE
            });
            const MAIN_SELECTOR = 'fullpage';
            const ID_SELECTOR = `#${MAIN_SELECTOR}`;
            const DEFAULT_SECTION = '.section';
            const DEFAULT_SLIDE = '.SLIDE';
        /***/ },
        /***/ 563: /***/ (module1, __webpack_exports__, __webpack_require__)=>{
            "use strict";
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ "Z": ()=>__WEBPACK_DEFAULT_EXPORT__
            });
            /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(645);
            /* harmony import */ var _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
            // Imports
            var ___CSS_LOADER_EXPORT___ = _css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i) {
                return i[1];
            });
            // Module
            ___CSS_LOADER_EXPORT___.push([
                module1.id,
                "/*!\r\n * fullPage 4.0.20\r\n * https://github.com/alvarotrigo/fullPage.js\r\n *\r\n * @license GPLv3 for open source use only\r\n * or Fullpage Commercial License for commercial use\r\n * http://alvarotrigo.com/fullPage/pricing/\r\n *\r\n * Copyright (C) 2021 http://alvarotrigo.com/fullPage - A project by Alvaro Trigo\r\n */.fp-enabled body,html.fp-enabled{margin:0;padding:0;overflow:hidden;-webkit-tap-highlight-color:rgba(0,0,0,0)}.fp-section{position:relative;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;height:100%;display:block}.fp-slide{float:left}.fp-slide,.fp-slidesContainer{height:100%;display:block}.fp-slides{z-index:1;height:100%;overflow:hidden;position:relative;-webkit-transition:all .3s ease-out;transition:all .3s ease-out}.fp-table{display:flex;flex-direction:column;justify-content:center;width:100%}.fp-slidesContainer{float:left;position:relative}.fp-controlArrow{-webkit-user-select:none;-moz-user-select:none;-khtml-user-select:none;-ms-user-select:none;position:absolute;z-index:4;top:50%;cursor:pointer;margin-top:-38px;-webkit-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.fp-prev{left:15px}.fp-next{right:15px}.fp-arrow{width:0;height:0;border-style:solid}.fp-arrow.fp-prev{border-width:38.5px 34px 38.5px 0;border-color:transparent #fff transparent transparent}.fp-arrow.fp-next{border-width:38.5px 0 38.5px 34px;border-color:transparent transparent transparent #fff}.fp-notransition{-webkit-transition:none!important;transition:none!important}#fp-nav{position:fixed;z-index:100;top:50%;opacity:1;transform:translateY(-50%);-ms-transform:translateY(-50%);-webkit-transform:translate3d(0,-50%,0)}#fp-nav.fp-right{right:17px}#fp-nav.fp-left{left:17px}.fp-slidesNav{position:absolute;z-index:4;opacity:1;-webkit-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);transform:translate3d(0,0,0);left:0!important;right:0;margin:0 auto!important}.fp-slidesNav.fp-bottom{bottom:17px}.fp-slidesNav.fp-top{top:17px}#fp-nav ul,.fp-slidesNav ul{margin:0;padding:0}#fp-nav ul li,.fp-slidesNav ul li{display:block;width:14px;height:13px;margin:7px;position:relative}.fp-slidesNav ul li{display:inline-block}#fp-nav ul li a,.fp-slidesNav ul li a{display:block;position:relative;z-index:1;width:100%;height:100%;cursor:pointer;text-decoration:none}#fp-nav ul li a.active span,#fp-nav ul li:hover a.active span,.fp-slidesNav ul li a.active span,.fp-slidesNav ul li:hover a.active span{height:12px;width:12px;margin:-6px 0 0 -6px;border-radius:100%}#fp-nav ul li a span,.fp-slidesNav ul li a span{border-radius:50%;position:absolute;z-index:1;height:4px;width:4px;border:0;background:#333;left:50%;top:50%;margin:-2px 0 0 -2px;-webkit-transition:all .1s ease-in-out;-moz-transition:all .1s ease-in-out;-o-transition:all .1s ease-in-out;transition:all .1s ease-in-out}#fp-nav ul li:hover a span,.fp-slidesNav ul li:hover a span{width:10px;height:10px;margin:-5px 0 0 -5px}#fp-nav ul li .fp-tooltip{position:absolute;top:-2px;color:#fff;font-size:14px;font-family:arial,helvetica,sans-serif;white-space:nowrap;max-width:220px;overflow:hidden;display:block;opacity:0;width:0;cursor:pointer}#fp-nav ul li:hover .fp-tooltip,#fp-nav.fp-show-active a.active+.fp-tooltip{-webkit-transition:opacity .2s ease-in;transition:opacity .2s ease-in;width:auto;opacity:1}#fp-nav ul li .fp-tooltip.fp-right{right:20px}#fp-nav ul li .fp-tooltip.fp-left{left:20px}.fp-auto-height .fp-slide,.fp-auto-height.fp-section{height:auto!important}.fp-responsive .fp-is-overflow.fp-section{height:auto!important}.fp-scrollable .fp-section,.fp-scrollable .fp-slide,.fp-scrollable.fp-responsive .fp-is-overflow.fp-section{height:100vh;height:calc(var(--vh,1vh) * 100)}.fp-scrollable .fp-section:not(.fp-auto-height):not([data-percentage]),.fp-scrollable .fp-slide:not(.fp-auto-height):not([data-percentage]),.fp-scrollable.fp-responsive .fp-is-overflow.fp-section:not(.fp-auto-height):not([data-percentage]){min-height:100vh;min-height:calc(var(--vh,1vh) * 100)}.fp-overflow{justify-content:flex-start;max-height:100vh}.fp-scrollable .fp-auto-height .fp-overflow{max-height:none}.fp-is-overflow .fp-overflow.fp-auto-height,.fp-is-overflow .fp-overflow.fp-auto-height-responsive,.fp-is-overflow>.fp-overflow{overflow-y:auto}.fp-overflow{outline:0}.fp-overflow.fp-table{display:block}.fp-responsive .fp-auto-height-responsive .fp-slide,.fp-responsive .fp-auto-height-responsive.fp-section{height:auto!important;min-height:auto!important}.fp-sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.fp-scroll-mac .fp-overflow::-webkit-scrollbar{background-color:transparent;width:9px}.fp-scroll-mac .fp-overflow::-webkit-scrollbar-track{background-color:transparent}.fp-scroll-mac .fp-overflow::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.4);border-radius:16px;border:4px solid transparent}.fp-warning,.fp-watermark{z-index:9999999;position:absolute;bottom:0}.fp-warning,.fp-watermark a{text-decoration:none;color:#000;background:rgba(255,255,255,.6);padding:5px 8px;font-size:14px;font-family:arial;color:#000;display:inline-block;border-radius:3px;margin:12px}.fp-noscroll .fp-overflow{overflow:hidden}\r\n",
                ""
            ]);
            // Exports
            /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ___CSS_LOADER_EXPORT___;
        /***/ },
        /***/ 645: /***/ (module1)=>{
            "use strict";
            /*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/ // css base code, injected by the css-loader
            // eslint-disable-next-line func-names
            module1.exports = function(cssWithMappingToString) {
                var list = []; // return the list of modules as css string
                list.toString = function toString() {
                    return this.map(function(item) {
                        var content = cssWithMappingToString(item);
                        if (item[2]) return "@media ".concat(item[2], " {").concat(content, "}");
                        return content;
                    }).join("");
                }; // import a list of modules into the list
                // eslint-disable-next-line func-names
                list.i = function(modules, mediaQuery, dedupe) {
                    if (typeof modules === "string") // eslint-disable-next-line no-param-reassign
                    modules = [
                        [
                            null,
                            modules,
                            ""
                        ]
                    ];
                    var alreadyImportedModules = {};
                    if (dedupe) for(var i = 0; i < this.length; i++){
                        // eslint-disable-next-line prefer-destructuring
                        var id = this[i][0];
                        if (id != null) alreadyImportedModules[id] = true;
                    }
                    for(var _i = 0; _i < modules.length; _i++){
                        var item = [].concat(modules[_i]);
                        if (dedupe && alreadyImportedModules[item[0]]) continue;
                        if (mediaQuery) {
                            if (!item[2]) item[2] = mediaQuery;
                            else item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
                        }
                        list.push(item);
                    }
                };
                return list;
            };
        /***/ },
        /***/ 933: /***/ function(module1) {
            /*!
* fullPage 4.0.20
* https://github.com/alvarotrigo/fullPage.js
*
* @license GPLv3 for open source use only
* or Fullpage Commercial License for commercial use
* http://alvarotrigo.com/fullPage/pricing/
*
* Copyright (C) 2018 http://alvarotrigo.com/fullPage/ - A project by Alvaro Trigo
*/ !function(n, t) {
                module1.exports = t();
            }(this, function() {
                "use strict";
                var n, t, e, i;
                Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
                    value: function(n) {
                        if (null == this) throw new TypeError('"this" is null or not defined');
                        var t = Object(this), e = t.length >>> 0;
                        if ("function" != typeof n) throw new TypeError("predicate must be a function");
                        for(var i = arguments[1], o = 0; o < e;){
                            var r = t[o];
                            if (n.call(i, r, o, t)) return r;
                            o++;
                        }
                    }
                }), Array.from || (Array.from = (n = Object.prototype.toString, t = function(t) {
                    return "function" == typeof t || "[object Function]" === n.call(t);
                }, e = Math.pow(2, 53) - 1, i = function(n) {
                    var t = function(n) {
                        var t = Number(n);
                        return isNaN(t) ? 0 : 0 !== t && isFinite(t) ? (t > 0 ? 1 : -1) * Math.floor(Math.abs(t)) : t;
                    }(n);
                    return Math.min(Math.max(t, 0), e);
                }, function(n) {
                    var e = this, o = Object(n);
                    if (null == n) throw new TypeError("Array.from requires an array-like object - not null or undefined");
                    var r, a = arguments.length > 1 ? arguments[1] : void 0;
                    if (void 0 !== a) {
                        if (!t(a)) throw new TypeError("Array.from: when provided, the second argument must be a function");
                        arguments.length > 2 && (r = arguments[2]);
                    }
                    for(var l, u = i(o.length), c = t(e) ? Object(new e(u)) : new Array(u), s = 0; s < u;)l = o[s], c[s] = a ? void 0 === r ? a(l, s) : a.call(r, l, s) : l, s += 1;
                    return c.length = u, c;
                }));
                var o = window, r = document, a = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/), l = /(Mac|iPhone|iPod|iPad)/i.test(o.navigator.userAgent), u = "ontouchstart" in o || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints, c = !!window.MSInputMethodContext && !!document.documentMode, s = {
                    test: {},
                    shared: {}
                };
                function f(n, t) {
                    o.console && o.console[n] && o.console[n]("fullPage: " + t);
                }
                function d(n) {
                    return "none" !== o.getComputedStyle(n).display;
                }
                function v(n) {
                    return Array.from(n).filter(function(n) {
                        return d(n);
                    });
                }
                function p(n, t) {
                    return (t = arguments.length > 1 ? t : document) ? t.querySelectorAll(n) : null;
                }
                function h(n) {
                    n = n || {};
                    for(var t = 1, e = arguments.length; t < e; ++t){
                        var i = arguments[t];
                        if (i) for(var o in i)i.hasOwnProperty(o) && "__proto__" != o && "constructor" != o && ("[object Object]" !== Object.prototype.toString.call(i[o]) ? n[o] = i[o] : n[o] = h(n[o], i[o]));
                    }
                    return n;
                }
                function g(n, t) {
                    return null != n && n.classList.contains(t);
                }
                function m() {
                    return "innerHeight" in o ? o.innerHeight : r.documentElement.offsetHeight;
                }
                function w() {
                    return o.innerWidth;
                }
                function b(n, t) {
                    var e;
                    for(e in n = A(n), t)if (t.hasOwnProperty(e) && null !== e) for(var i = 0; i < n.length; i++)n[i].style[e] = t[e];
                    return n;
                }
                function S(n, t) {
                    if (!n) return null;
                    if (null == t) return n.previousElementSibling;
                    var e = S(n);
                    return e && Q(e, t) ? e : null;
                }
                function y(n, t) {
                    if (!n) return null;
                    if (null == t) return n.nextElementSibling;
                    var e = y(n);
                    return e && Q(e, t) ? e : null;
                }
                function M(n) {
                    return n[n.length - 1];
                }
                function T(n, t) {
                    n = k(n) ? n[0] : n;
                    for(var e = null != t ? p(t, n.parentNode) : n.parentNode.childNodes, i = 0, o = 0; o < e.length; o++){
                        if (e[o] == n) return i;
                        1 == e[o].nodeType && i++;
                    }
                    return -1;
                }
                function A(n) {
                    return k(n) ? n : [
                        n
                    ];
                }
                function x(n) {
                    n = A(n);
                    for(var t = 0; t < n.length; t++)n[t].style.display = "none";
                    return n;
                }
                function O(n) {
                    n = A(n);
                    for(var t = 0; t < n.length; t++)n[t].style.display = "block";
                    return n;
                }
                function k(n) {
                    return "[object Array]" === Object.prototype.toString.call(n) || "[object NodeList]" === Object.prototype.toString.call(n);
                }
                function E(n, t) {
                    n = A(n);
                    for(var e = 0; e < n.length; e++)n[e].classList.add(t);
                    return n;
                }
                function R(n, t) {
                    n = A(n);
                    for(var e = t.split(" "), i = 0; i < e.length; i++){
                        t = e[i];
                        for(var o = 0; o < n.length; o++)n[o].classList.remove(t);
                    }
                    return n;
                }
                function L(n, t) {
                    t.appendChild(n);
                }
                function j(n, t, e) {
                    var i;
                    t = t || r.createElement("div");
                    for(var o = 0; o < n.length; o++){
                        var a = n[o];
                        (e && !o || !e) && (i = t.cloneNode(!0), a.parentNode.insertBefore(i, a)), i.appendChild(a);
                    }
                    return n;
                }
                function z(n, t) {
                    j(n, t, !0);
                }
                function D(n, t) {
                    for("string" == typeof t && (t = K(t)), n.appendChild(t); n.firstChild !== t;)t.appendChild(n.firstChild);
                }
                function N(n) {
                    for(var t = r.createDocumentFragment(); n.firstChild;)t.appendChild(n.firstChild);
                    n.parentNode.replaceChild(t, n);
                }
                function P(n, t) {
                    return n && 1 === n.nodeType ? Q(n, t) ? n : P(n.parentNode, t) : null;
                }
                function H(n, t) {
                    I(n, n.nextSibling, t);
                }
                function C(n, t) {
                    I(n, n, t);
                }
                function I(n, t, e) {
                    k(e) || ("string" == typeof e && (e = K(e)), e = [
                        e
                    ]);
                    for(var i = 0; i < e.length; i++)n.parentNode.insertBefore(e[i], t);
                }
                function W() {
                    var n = r.documentElement;
                    return (o.pageYOffset || n.scrollTop) - (n.clientTop || 0);
                }
                function F(n) {
                    return Array.prototype.filter.call(n.parentNode.children, function(t) {
                        return t !== n;
                    });
                }
                function V(n) {
                    n.preventDefault();
                }
                function Z(n, t) {
                    return n.getAttribute(t);
                }
                function B(n, t, e) {
                    r.addEventListener(n, t, "undefined" === e ? null : e);
                }
                function G(n, t, e) {
                    o.addEventListener(n, t, "undefined" === e ? null : e);
                }
                function Y(n, t, e) {
                    r.removeEventListener(n, t, "undefined" === e ? null : e);
                }
                function U(n, t, e) {
                    o.removeEventListener(n, t, "undefined" === e ? null : e);
                }
                function X(n) {
                    if ("function" == typeof n) return !0;
                    var t = Object.prototype.toString.call(n);
                    return "[object Function]" === t || "[object GeneratorFunction]" === t;
                }
                function _(n, t, e) {
                    var i;
                    e = void 0 === e ? {} : e, "function" == typeof o.CustomEvent ? i = new CustomEvent(t, {
                        detail: e
                    }) : (i = r.createEvent("CustomEvent")).initCustomEvent(t, !0, !0, e), n.dispatchEvent(i);
                }
                function Q(n, t) {
                    return (n.matches || n.t || n.msMatchesSelector || n.mozMatchesSelector || n.webkitMatchesSelector || n.oMatchesSelector).call(n, t);
                }
                function J(n, t) {
                    if ("boolean" == typeof t) for(var e = 0; e < n.length; e++)n[e].style.display = t ? "block" : "none";
                    return n;
                }
                function K(n) {
                    var t = r.createElement("div");
                    return t.innerHTML = n.trim(), t.firstChild;
                }
                function q(n) {
                    n = A(n);
                    for(var t = 0; t < n.length; t++){
                        var e = n[t];
                        e && e.parentElement && e.parentNode.removeChild(e);
                    }
                }
                function $(n, t) {
                    Array.prototype.filter.call(n, t);
                }
                function nn(n, t, e) {
                    for(var i = n[e], o = []; i;)(Q(i, t) || null == t) && o.push(i), i = i[e];
                    return o;
                }
                function tn(n, t) {
                    return nn(n, t, "nextElementSibling");
                }
                function en(n, t) {
                    return nn(n, t, "previousElementSibling");
                }
                function on(n) {
                    return Object.keys(n).map(function(t) {
                        return n[t];
                    });
                }
                function rn(n) {
                    return n[n.length - 1];
                }
                function an(n, t) {
                    for(var e = 0, i = n.slice(Math.max(n.length - t, 1)), o = 0; o < i.length; o++)e += i[o];
                    return Math.ceil(e / t);
                }
                function ln(n, t) {
                    n.setAttribute(t, Z(n, "data-" + t)), n.removeAttribute("data-" + t);
                }
                function un(n, t) {
                    var e = [
                        n
                    ];
                    do n = n.parentNode, e.push(n);
                    while (!Q(n, t));
                    return e;
                }
                function cn() {
                    var n = r.activeElement;
                    return Q(n, "textarea") || Q(n, "input") || Q(n, "select") || "true" == Z(n, "contentEditable") || "" == Z(n, "contentEditable");
                }
                o.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = function(n, t) {
                    t = t || window;
                    for(var e = 0; e < this.length; e++)n.call(t, this[e], e, this);
                }), "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
                    value: function(n, t) {
                        if (null == n) throw new TypeError("Cannot convert undefined or null to object");
                        for(var e = Object(n), i = 1; i < arguments.length; i++){
                            var o = arguments[i];
                            if (null != o) for(var r in o)Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
                        }
                        return e;
                    },
                    writable: !0,
                    i: !0
                }), window.fp_utils = {
                    $: p,
                    deepExtend: h,
                    hasClass: g,
                    getWindowHeight: m,
                    css: b,
                    prev: S,
                    next: y,
                    last: M,
                    index: T,
                    getList: A,
                    hide: x,
                    show: O,
                    isArrayOrList: k,
                    addClass: E,
                    removeClass: R,
                    appendTo: L,
                    wrap: j,
                    wrapAll: z,
                    wrapInner: D,
                    unwrap: N,
                    closest: P,
                    after: H,
                    before: C,
                    insertBefore: I,
                    getScrollTop: W,
                    siblings: F,
                    preventDefault: V,
                    isFunction: X,
                    trigger: _,
                    matches: Q,
                    toggle: J,
                    createElementFromHTML: K,
                    remove: q,
                    filter: $,
                    untilAll: nn,
                    nextAll: tn,
                    prevAll: en,
                    showError: f
                };
                var sn = Object.freeze({
                    __proto__: null,
                    showError: f,
                    isVisible: d,
                    getVisible: v,
                    $: p,
                    deepExtend: h,
                    hasClass: g,
                    getWindowHeight: m,
                    o: w,
                    css: b,
                    prev: S,
                    next: y,
                    last: M,
                    index: T,
                    getList: A,
                    hide: x,
                    show: O,
                    isArrayOrList: k,
                    addClass: E,
                    removeClass: R,
                    appendTo: L,
                    wrap: j,
                    wrapAll: z,
                    wrapInner: D,
                    unwrap: N,
                    closest: P,
                    after: H,
                    before: C,
                    insertBefore: I,
                    getScrollTop: W,
                    siblings: F,
                    preventDefault: V,
                    l: Z,
                    u: B,
                    v: G,
                    p: Y,
                    h: U,
                    isFunction: X,
                    trigger: _,
                    matches: Q,
                    toggle: J,
                    createElementFromHTML: K,
                    remove: q,
                    filter: $,
                    untilAll: nn,
                    nextAll: tn,
                    prevAll: en,
                    toArray: on,
                    g: rn,
                    S: an,
                    M: ln,
                    T: un,
                    A: cn
                });
                function fn(n) {
                    return fn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(n) {
                        return typeof n;
                    } : function(n) {
                        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
                    }, fn(n);
                }
                var dn = {
                    O: {},
                    R: function(n, t) {
                        var e = this;
                        return "object" !== fn(this.O[n]) && (this.O[n] = []), this.O[n].push(t), function() {
                            return e.removeListener(n, t);
                        };
                    },
                    removeListener: function(n, t) {
                        if ("object" === fn(this.O[n])) {
                            var e = this.O[n].indexOf(t);
                            e > -1 && this.O[n].splice(e, 1);
                        }
                    },
                    L: function(n) {
                        for(var t = this, e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), o = 1; o < e; o++)i[o - 1] = arguments[o];
                        "object" === fn(this.O[n]) && this.O[n].forEach(function(n) {
                            return n.apply(t, i);
                        });
                    },
                    once: function(n, t) {
                        var e = this, i = this.R(n, function() {
                            i();
                            for(var n = arguments.length, o = new Array(n), r = 0; r < n; r++)o[r] = arguments[r];
                            t.apply(e, o);
                        });
                    }
                }, vn = {
                    j: 0,
                    D: 0,
                    slides: [],
                    N: [],
                    P: null,
                    H: null,
                    C: !1,
                    I: !1,
                    W: !1,
                    F: !1,
                    V: !1,
                    Z: void 0,
                    B: void 0,
                    G: !1,
                    canScroll: !0,
                    Y: "none",
                    U: "none",
                    X: !1,
                    _: !1,
                    J: !0,
                    K: 0,
                    q: m(),
                    nn: !1,
                    tn: {}
                };
                function pn(n) {
                    Object.assign(vn, n);
                }
                function hn() {
                    return vn;
                }
                o.state = vn;
                var gn = "onAfterRenderNoAnchor", mn = "onClickOrTouch", wn = "moveSlideLeft", bn = "moveSlideRight", Sn = "onInitialise", yn = "bindEvents", Mn = "onDestroy", Tn = "contentChanged", An = "onScrollOverflowScrolled", xn = "onScrollPageAndSlide", On = "onKeyDown", kn = "onMenuClick", En = "scrollPage", Rn = "landscapeScroll", Ln = "scrollBeyondFullpage", jn = "onPerformMovement", zn = "onSlideLeave", Dn = "onLeave", Nn = "afterSectionLoads", Pn = "afterSlideLoads";
                function Hn(n) {
                    dn.L(mn, {
                        e: n,
                        target: n.target
                    });
                }
                function Cn() {
                    [
                        "click",
                        "touchstart"
                    ].forEach(function(n) {
                        Y(n, Hn, {
                            passive: !1
                        });
                    });
                }
                function In() {
                    pn({
                        J: !0
                    });
                }
                dn.R(yn, function() {
                    [
                        "click",
                        "touchstart"
                    ].forEach(function(n) {
                        B(n, Hn, {
                            passive: !1
                        });
                    }), G("focus", In), dn.R(Mn, Cn);
                });
                var Wn = "fullpage-wrapper", Fn = "." + Wn, Vn = "fp-responsive", Zn = "fp-notransition", Bn = "fp-destroyed", Gn = "fp-enabled", Yn = "active", Un = ".active", Xn = "fp-completely", _n = "fp-section", Qn = "." + _n, Jn = ".fp-tableCell", Kn = "#fp-nav", qn = "fp-slide", $n = "." + qn, nt = ".fp-slide.active", tt = "fp-slides", et = ".fp-slides", it = "fp-slidesContainer", ot = "." + it, rt = "fp-table", at = "fp-overflow", lt = "." + at, ut = "fp-is-overflow", ct = ".fp-slidesNav", st = ".fp-slidesNav a", ft = "fp-controlArrow", dt = "." + ft, vt = "fp-prev", pt = ".fp-controlArrow.fp-prev", ht = ".fp-controlArrow.fp-next", gt = {
                    menu: !1,
                    anchors: [],
                    lockAnchors: !1,
                    navigation: !1,
                    navigationPosition: "right",
                    navigationTooltips: [],
                    showActiveTooltip: !1,
                    slidesNavigation: !1,
                    slidesNavPosition: "bottom",
                    scrollBar: !1,
                    hybrid: !1,
                    licenseKey: "",
                    credits: {
                        enabled: !0,
                        label: "Made with fullPage.js",
                        position: "right"
                    },
                    css3: !0,
                    scrollingSpeed: 700,
                    autoScrolling: !0,
                    fitToSection: !0,
                    en: 600,
                    easing: "easeInOutCubic",
                    easingcss3: "ease",
                    loopBottom: !1,
                    loopTop: !1,
                    loopHorizontal: !0,
                    continuousVertical: !1,
                    continuousHorizontal: !1,
                    scrollHorizontally: !1,
                    interlockedSlides: !1,
                    dragAndMove: !1,
                    offsetSections: !1,
                    resetSliders: !1,
                    fadingEffect: !1,
                    normalScrollElements: null,
                    scrollOverflow: !0,
                    scrollOverflowReset: !1,
                    touchSensitivity: 5,
                    touchWrapper: null,
                    bigSectionsDestination: null,
                    keyboardScrolling: !0,
                    animateAnchor: !0,
                    recordHistory: !0,
                    allowCorrectDirection: !1,
                    scrollOverflowMacStyle: !0,
                    controlArrows: !0,
                    controlArrowsHTML: [
                        '<div class="fp-arrow"></div>',
                        '<div class="fp-arrow"></div>'
                    ],
                    controlArrowColor: "#fff",
                    verticalCentered: !0,
                    sectionsColor: [],
                    paddingTop: 0,
                    paddingBottom: 0,
                    fixedElements: null,
                    responsive: 0,
                    responsiveWidth: 0,
                    responsiveHeight: 0,
                    responsiveSlides: !1,
                    parallax: !1,
                    parallaxOptions: {
                        type: "reveal",
                        percentage: 62,
                        property: "translate"
                    },
                    cards: !1,
                    cardsOptions: {
                        perspective: 100,
                        fadeContent: !0,
                        fadeBackground: !0
                    },
                    sectionSelector: ".section",
                    slideSelector: ".slide",
                    afterLoad: null,
                    beforeLeave: null,
                    onLeave: null,
                    afterRender: null,
                    afterResize: null,
                    afterReBuild: null,
                    afterSlideLoad: null,
                    onSlideLeave: null,
                    afterResponsive: null,
                    onScrollOverflow: null,
                    lazyLoading: !0,
                    observer: !0
                }, mt = null, wt = !1, bt = h({}, gt), St = null;
                function yt(n) {
                    return mt;
                }
                function Mt() {
                    return St || gt;
                }
                function Tt() {
                    return bt;
                }
                function At(n, t, e) {
                    St[n] = t, "internal" !== e && (bt[n] = t);
                }
                function xt() {
                    if (!Mt().anchors.length) {
                        var n = p(Mt().sectionSelector.split(",").join("[data-anchor],") + "[data-anchor]", mt);
                        n.length && n.length === p(Mt().sectionSelector, mt).length && (wt = !0, n.forEach(function(n) {
                            Mt().anchors.push(Z(n, "data-anchor").toString());
                        }));
                    }
                    if (!Mt().navigationTooltips.length) {
                        var t = p(Mt().sectionSelector.split(",").join("[data-tooltip],") + "[data-tooltip]", mt);
                        t.length && t.forEach(function(n) {
                            Mt().navigationTooltips.push(Z(n, "data-tooltip").toString());
                        });
                    }
                }
                function Ot(n) {
                    return void 0 !== window["fp_" + n + "Extension"];
                }
                function kt(n) {
                    var t = Mt();
                    return null !== t[n] && "[object Array]" === Object.prototype.toString.call(t[n]) ? t[n].length && s[n] : t[n] && s[n];
                }
                function Et(n, t, e) {
                    if (kt(n)) return X(s[n][t]) ? s[n][t](e) : s[n][t];
                }
                function Rt() {
                    return Et("dragAndMove", "isAnimating");
                }
                function Lt() {
                    return Et("dragAndMove", "isGrabbing");
                }
                function jt(n) {
                    if (Mt().offsetSections && s.offsetSections) {
                        var t = Et("offsetSections", "getWindowHeight", n);
                        return "" !== t ? Math.round(t) + "px" : t;
                    }
                    return m() + "px";
                }
                function zt(n, t) {
                    n.insertBefore(t, n.firstChild);
                }
                function Dt(n) {
                    var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    function e(n) {
                        var e, i, o, r, a, l, u = "", c = 0;
                        for(n = n.replace(/[^A-Za-z0-9+/=]/g, ""); c < n.length;)e = t.indexOf(n.charAt(c++)) << 2 | (r = t.indexOf(n.charAt(c++))) >> 4, i = (15 & r) << 4 | (a = t.indexOf(n.charAt(c++))) >> 2, o = (3 & a) << 6 | (l = t.indexOf(n.charAt(c++))), u += String.fromCharCode(e), 64 != a && (u += String.fromCharCode(i)), 64 != l && (u += String.fromCharCode(o));
                        return u = function(n) {
                            for(var t, e = "", i = 0, o = 0, r = 0; i < n.length;)(o = n.charCodeAt(i)) < 128 ? (e += String.fromCharCode(o), i++) : o > 191 && o < 224 ? (r = n.charCodeAt(i + 1), e += String.fromCharCode((31 & o) << 6 | 63 & r), i += 2) : (r = n.charCodeAt(i + 1), t = n.charCodeAt(i + 2), e += String.fromCharCode((15 & o) << 12 | (63 & r) << 6 | 63 & t), i += 3);
                            return e;
                        }(u), u;
                    }
                    function i(n) {
                        return n.slice(3).slice(0, -3);
                    }
                    return function(n) {
                        var t = n.split("_");
                        if (t.length > 1) {
                            var o = t[1];
                            return e(n.replace(i(t[1]), "").split("_")[0].slice(2).slice(0, -2)) + "_" + e(o.slice(3).slice(0, -3));
                        }
                        return i(n);
                    }(e(n));
                }
                o.fp_utils = o.fp_utils || {}, Object.assign(o.fp_utils, {
                    prependTo: zt,
                    toggleClass: function(n, t, e) {
                        if (n.classList && null == e) n.classList.toggle(t);
                        else {
                            var i = g(n, t);
                            i && null == e || !e ? R(n, t) : (!i && null == e || e) && E(n, t);
                        }
                    }
                });
                var Nt = function(n) {
                    this.anchor = n.anchor, this.item = n.item, this.index = n.index(), this.isLast = this.index === n.item.parentElement.querySelectorAll(n.selector).length - 1, this.isFirst = !this.index, this.isActive = n.isActive;
                }, Pt = function(n, t) {
                    this.parent = this.parent || null, this.selector = t, this.anchor = Z(n, "data-anchor") || Mt().anchors[T(n, Mt().sectionSelector)], this.item = n, this.isVisible = d(n), this.isActive = g(n, Yn), this.on = g(n, at) || null != p(lt, n)[0], this.rn = t === Mt().sectionSelector, this.container = P(n, ot) || P(n, Fn), this.index = function() {
                        return this.siblings().indexOf(this);
                    };
                };
                function Ht(n) {
                    return n.map(function(n) {
                        return n.item;
                    });
                }
                function Ct(n, t) {
                    return n.find(function(n) {
                        return n.item === t;
                    });
                }
                Pt.prototype.siblings = function() {
                    return this.rn ? this.isVisible ? vn.N : vn.an : this.parent ? this.parent.slides : 0;
                }, Pt.prototype.prev = function() {
                    var n = this.siblings(), t = (this.rn ? n.indexOf(this) : this.parent.slides.indexOf(this)) - 1;
                    return t >= 0 ? n[t] : null;
                }, Pt.prototype.next = function() {
                    var n = this.siblings(), t = (this.rn ? n.indexOf(this) : this.parent.slides.indexOf(this)) + 1;
                    return t < n.length ? n[t] : null;
                }, Pt.prototype.prevPanel = function() {
                    return this === this.prev() ? this.parent ? this.parent.prev() : null : this.prev() || (this.parent ? this.parent.prev() : null);
                }, Pt.prototype.nextPanel = function() {
                    return this === this.next() ? this.parent ? this.parent.next() : null : this.next() || (this.parent ? this.parent.next() : null);
                }, Pt.prototype.ln = function() {
                    return this.rn ? vn.N : vn.un;
                };
                var It, Wt = function(n) {
                    Nt.call(this, n);
                }, Ft = function(n) {
                    Nt.call(this, n);
                };
                function Vt(n) {
                    var t = p(nt, n);
                    return t.length && (n = t[0]), n;
                }
                function Zt(n) {
                    return n ? n.activeSlide ? n.activeSlide : n : null;
                }
                function Bt(n) {
                    var t, e, i = Mt();
                    return i.autoScrolling && !i.scrollBar ? (t = -n, e = p(Fn)[0]) : (t = n, e = window), {
                        options: t,
                        element: e
                    };
                }
                function Gt(n, t) {
                    !Mt().autoScrolling || Mt().scrollBar || n.self != window && g(n, tt) ? n.self != window && g(n, tt) ? n.scrollLeft = t : n.scrollTo(0, t) : n.style.top = t + "px";
                }
                function Yt(n) {
                    var t = "transform " + Mt().scrollingSpeed + "ms " + Mt().easingcss3;
                    return R(n, Zn), b(n, {
                        "-webkit-transition": t,
                        transition: t
                    });
                }
                function Ut(n, t) {
                    var e = n.index(), i = T(t, Qn);
                    return e == i ? "none" : e > i ? "up" : "down";
                }
                function Xt(n) {
                    return E(n, Zn);
                }
                function _t(n) {
                    return {
                        "-webkit-transform": n,
                        "-moz-transform": n,
                        "-ms-transform": n,
                        transform: n
                    };
                }
                function Qt(n, t) {
                    t ? Yt(yt()) : Xt(yt()), clearTimeout(It), b(yt(), _t(n)), s.test.cn = n, It = setTimeout(function() {
                        R(yt(), Zn);
                    }, 10);
                }
                function Jt(n) {
                    var t = Math.round(n);
                    if (Mt().css3 && Mt().autoScrolling && !Mt().scrollBar) Qt("translate3d(0px, -" + t + "px, 0px)", !1);
                    else if (Mt().autoScrolling && !Mt().scrollBar) b(yt(), {
                        top: -t + "px"
                    }), s.test.top = -t + "px";
                    else {
                        var e = Bt(t);
                        Gt(e.element, e.options);
                    }
                }
                function Kt(n, t) {
                    "internal" !== t && Et("fadingEffect", "update", n), Et("cards", "update_", n), At("scrollingSpeed", n, t);
                }
                s.setScrollingSpeed = Kt;
                var qt, $t = null, ne = null, te = null;
                function ee(n, t, e, i) {
                    var r, a = function(n) {
                        return n.self != o && g(n, tt) ? n.scrollLeft : !Mt().autoScrolling || Mt().scrollBar ? W() : n.offsetTop;
                    }(n), l = t - a, u = !1, c = vn.G;
                    pn({
                        G: !0
                    }), qt && window.cancelAnimationFrame(qt), qt = function(s) {
                        r || (r = s);
                        var f = Math.floor(s - r);
                        if (vn.G) {
                            var d = t;
                            e && (d = o.fp_easings[Mt().easing](f, a, l, e)), f <= e && Gt(n, d), f < e ? window.requestAnimationFrame(qt) : void 0 === i || u || (i(), pn({
                                G: !1
                            }), u = !0);
                        } else u || c || (i(), pn({
                            G: !1
                        }), u = !0);
                    }, window.requestAnimationFrame(qt);
                }
                function ie(n) {
                    return n && !n.item ? new Wt(new pi(n)) : n ? new Wt(n) : null;
                }
                function oe(n) {
                    return n ? new Ft(n) : null;
                }
                function re(n, t) {
                    var e = function(n, t) {
                        var e = {
                            afterRender: function() {
                                return {
                                    section: ie(hn().P),
                                    sn: oe(hn().P.activeSlide)
                                };
                            },
                            onLeave: function() {
                                return {
                                    origin: ie(t.items.origin),
                                    destination: ie(t.items.destination),
                                    direction: t.direction,
                                    trigger: hn().H
                                };
                            },
                            afterLoad: function() {
                                return e.onLeave();
                            },
                            afterSlideLoad: function() {
                                return {
                                    section: ie(t.items.section),
                                    origin: ie(t.items.origin),
                                    destination: ie(t.items.destination),
                                    direction: t.direction,
                                    trigger: hn().H
                                };
                            },
                            onSlideLeave: function() {
                                return e.afterSlideLoad();
                            },
                            beforeLeave: function() {
                                return e.onLeave();
                            },
                            onScrollOverflow: function() {
                                return {
                                    section: ie(hn().P),
                                    sn: oe(hn().P.activeSlide),
                                    position: t.position,
                                    direction: t.direction
                                };
                            }
                        };
                        return e[n]();
                    }(n, t);
                    return _(yt(), n, e), !1 !== Mt()[n].apply(e[Object.keys(e)[0]], on(e));
                }
                function ae(n) {
                    var t = Vt(n);
                    p("video, audio", t).forEach(function(n) {
                        n.hasAttribute("data-autoplay") && "function" == typeof n.play && n.play();
                    }), p('iframe[src*="youtube.com/embed/"]', t).forEach(function(n) {
                        n.hasAttribute("data-autoplay") && le(n), n.onload = function() {
                            n.hasAttribute("data-autoplay") && le(n);
                        };
                    });
                }
                function le(n) {
                    n.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
                }
                function ue(n) {
                    var t = Vt(n);
                    p("video, audio", t).forEach(function(n) {
                        n.hasAttribute("data-keepplaying") || "function" != typeof n.pause || n.pause();
                    }), p('iframe[src*="youtube.com/embed/"]', t).forEach(function(n) {
                        /youtube\.com\/embed\//.test(Z(n, "src")) && !n.hasAttribute("data-keepplaying") && n.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
                    });
                }
                function ce(n) {
                    Mt().lazyLoading && p("img[data-src], img[data-srcset], source[data-src], source[data-srcset], video[data-src], audio[data-src], iframe[data-src]", Vt(n)).forEach(function(n) {
                        if ([
                            "src",
                            "srcset"
                        ].forEach(function(t) {
                            var e = Z(n, "data-" + t);
                            null != e && e && (ln(n, t), n.addEventListener("load", function() {}));
                        }), Q(n, "source")) {
                            var t = P(n, "video, audio");
                            t && (t.load(), t.onloadeddata = function() {});
                        }
                    });
                }
                function se() {
                    var n = hn().P.item, t = hn().P.activeSlide, e = fe(n), i = String(e);
                    t && (i = i + "-" + fe(t.item)), i = i.replace("/", "-").replace("#", "");
                    var o = new RegExp("\\b\\s?fp-viewing-[^\\s]+\\b", "g");
                    $t.className = $t.className.replace(o, ""), E($t, "fp-viewing-" + i);
                }
                function fe(n) {
                    if (!n) return null;
                    var t = Z(n, "data-anchor"), e = T(n);
                    return null == t && (t = e), t;
                }
                function de(n, t, e) {
                    var i = "";
                    Mt().anchors.length && !Mt().lockAnchors && (n ? (null != e && (i = e), null == t && (t = n), pn({
                        B: t
                    }), ve(i + "/" + t)) : null != n ? (pn({
                        B: t
                    }), ve(e)) : ve(e)), se();
                }
                function ve(n) {
                    if (Mt().recordHistory) location.hash = n;
                    else if (a || u) o.history.replaceState(void 0, void 0, "#" + n);
                    else {
                        var t = o.location.href.split("#")[0];
                        o.location.replace(t + "#" + n);
                    }
                }
                function pe(n, t, e) {
                    var i = "Section" === t ? Mt().anchors[n] : Z(e, "data-anchor");
                    return encodeURI(Mt().navigationTooltips[n] || i || t + " " + (n + 1));
                }
                function he(n) {
                    n.cancelable && V(n), pn({
                        H: "horizontalNav"
                    });
                    var t = P(this, Qn), e = p(et, P(this, Qn))[0], i = Ct(hn().N, t).slides[T(P(this, "li"))];
                    dn.L(Rn, {
                        slides: e,
                        destination: i.item
                    });
                }
                function ge(n, t) {
                    Mt().slidesNavigation && null != n && (R(p(Un, n), Yn), E(p("a", p("li", n)[t]), Yn));
                }
                var me, we = {};
                function be(n, t, e) {
                    "all" !== t ? we[e][t] = n : Object.keys(we[e]).forEach(function(t) {
                        we[e][t] = n;
                    });
                }
                function Se() {
                    return we;
                }
                function ye() {
                    var n = P(this, Qn);
                    g(this, vt) ? Se().m.left && (pn({
                        H: "slideArrow"
                    }), dn.L(wn, {
                        section: n
                    })) : Se().m.right && (pn({
                        H: "slideArrow"
                    }), dn.L(bn, {
                        section: n
                    }));
                }
                function Me(n) {
                    !Mt().loopHorizontal && Mt().controlArrows && (J(p(pt, n.section), 0 !== n.slideIndex), J(p(ht, n.section), null != y(n.destiny)));
                }
                function Te() {
                    clearTimeout(me), pn({
                        W: !1
                    });
                }
                function Ae(n, t, e) {
                    var i = P(n, Qn), o = hn().N.filter(function(n) {
                        return n.item == i;
                    })[0], r = o.slides.filter(function(n) {
                        return n.item == t;
                    })[0], a = {
                        slides: n,
                        destiny: t,
                        direction: e,
                        destinyPos: {
                            left: t.offsetLeft
                        },
                        slideIndex: r.index(),
                        section: i,
                        sectionIndex: o.index(),
                        anchorLink: o.anchor,
                        slidesNav: p(ct, i)[0],
                        slideAnchor: r.anchor,
                        prevSlide: o.activeSlide.item,
                        prevSlideIndex: o.activeSlide.index(),
                        items: {
                            section: o,
                            origin: o.activeSlide,
                            destination: r
                        },
                        localIsResizing: vn.F
                    };
                    a.xMovement = Oe(a.prevSlideIndex, a.slideIndex), a.direction = a.direction ? a.direction : a.xMovement, a.localIsResizing || pn({
                        canScroll: !1
                    }), Et("parallax", "applyHorizontal", a), Et("cards", "apply", a), Et("dropEffect", "apply", a), Et("waterEffect", "apply", a), Mt().onSlideLeave && !a.localIsResizing && "none" !== a.xMovement && X(Mt().onSlideLeave) && !1 === re("onSlideLeave", a) ? pn({
                        W: !1
                    }) : (kt("dropEffect") && Mt().dropEffect || (E(t, Yn), R(F(t), Yn)), si(), a.localIsResizing || (ue(a.prevSlide), ce(t)), Me(a), o.isActive && !a.localIsResizing && de(a.slideIndex, a.slideAnchor, a.anchorLink), Et("continuousHorizontal", "apply", a), dn.L(zn, a), Lt() ? Ee(a) : xe(n, a, !0), Mt().interlockedSlides && s.interlockedSlides && (kt("continuousHorizontal") && void 0 !== e && e !== a.xMovement || Et("interlockedSlides", "apply", a)));
                }
                function xe(n, t, e) {
                    var i = t.destinyPos;
                    if (ge(t.slidesNav, t.slideIndex), pn({
                        scrollX: Math.round(i.left)
                    }), Mt().css3) {
                        var o = "translate3d(-" + Math.round(i.left) + "px, 0px, 0px)";
                        s.test.dn[t.sectionIndex] = o, kt("dragAndMove") && void 0 !== t.vn || Yt(p(ot, n)), b(p(ot, n), _t(o)), kt("interlockedSlides") || clearTimeout(me), me = setTimeout(function() {
                            e && Ee(t);
                        }, Mt().scrollingSpeed);
                    } else s.test.left[t.sectionIndex] = Math.round(i.left), ee(n, Math.round(i.left), Mt().scrollingSpeed, function() {
                        e && Ee(t);
                    });
                }
                function Oe(n, t) {
                    return n == t ? "none" : n > t ? "left" : "right";
                }
                function ke() {
                    clearTimeout(me);
                }
                function Ee(n) {
                    Et("continuousHorizontal", "afterSlideLoads", n), Et("dragAndMove", "afterSlideLoads", n), n.localIsResizing || (Et("parallax", "afterSlideLoads"), Et("scrollOverflowReset", "setPrevious", n.prevSlide), Et("scrollOverflowReset", "reset"), X(Mt().afterSlideLoad) && re("afterSlideLoad", n), pn({
                        canScroll: !0
                    }), ae(n.destiny), dn.L(Pn, n)), pn({
                        W: !1
                    }), Et("interlockedSlides", "interlockedSlides", n);
                }
                function Re(n, t) {
                    Kt(0, "internal"), void 0 !== t && pn({
                        F: !0
                    }), Ae(P(n, et), n), void 0 !== t && pn({
                        F: !1
                    }), Kt(Tt().scrollingSpeed, "internal");
                }
                function Le(n, t) {
                    At("recordHistory", n, t);
                }
                function je(n, t) {
                    n || Jt(0), At("autoScrolling", n, t);
                    var e = hn().P.item;
                    if (Mt().autoScrolling && !Mt().scrollBar) b(te, {
                        overflow: "hidden",
                        height: "100%"
                    }), R($t, "fp-scrollable"), Le(Tt().recordHistory, "internal"), b(yt(), {
                        "-ms-touch-action": "none",
                        "touch-action": "none"
                    }), null != e && Jt(e.offsetTop);
                    else if (b(te, {
                        overflow: "visible",
                        height: "initial"
                    }), E($t, "fp-scrollable"), Le(!!Mt().autoScrolling && Tt().recordHistory, "internal"), b(yt(), {
                        "-ms-touch-action": "",
                        "touch-action": ""
                    }), Xt(yt()), null != e) {
                        var i = Bt(e.offsetTop);
                        i.element.scrollTo(0, i.options);
                    }
                    _(yt(), "setAutoScrolling", n);
                }
                function ze() {
                    for(var n = p(nt), t = 0; t < n.length; t++)Re(n[t], "internal");
                }
                function De() {
                    var n = p(".fp-auto-height")[0] || $e() && p(".fp-auto-height-responsive")[0];
                    Mt().lazyLoading && n && p(".fp-section:not(.active)").forEach(function(n) {
                        var t, e, i, o, r;
                        e = (t = n.getBoundingClientRect()).top, i = t.bottom, o = e + 2 < vn.q && e > 0, r = i > 2 && i < vn.q, (o || r) && ce(n);
                    });
                }
                function Ne() {
                    _(S(this), "click");
                }
                function Pe() {
                    q(p(Kn));
                    var n = r.createElement("div");
                    n.setAttribute("id", "fp-nav");
                    var t = r.createElement("ul");
                    n.appendChild(t), L(n, $t);
                    var e = p(Kn)[0];
                    E(e, "fp-" + Mt().navigationPosition), Mt().showActiveTooltip && E(e, "fp-show-active");
                    for(var i = "", o = 0; o < hn().N.length; o++){
                        var a = hn().N[o], l = "";
                        Mt().anchors.length && (l = a.anchor), i += '<li><a href="#' + encodeURI(l) + '"><span class="fp-sr-only">' + pe(a.index(), "Section") + "</span><span></span></a>";
                        var u = Mt().navigationTooltips[a.index()];
                        void 0 !== u && "" !== u && (i += '<div class="fp-tooltip fp-' + Mt().navigationPosition + '">' + u + "</div>"), i += "</li>";
                    }
                    p("ul", e)[0].innerHTML = i;
                    var c = p("li", p(Kn)[0])[hn().P.index()];
                    E(p("a", c), Yn);
                }
                function He(n) {
                    n.preventDefault && V(n), pn({
                        H: "verticalNav"
                    });
                    var t = T(P(this, "#fp-nav li"));
                    dn.L(En, {
                        destination: hn().N[t]
                    });
                }
                function Ce(n, t) {
                    var e;
                    e = n, Mt().menu && Mt().menu.length && p(Mt().menu).forEach(function(n) {
                        null != n && (R(p(Un, n), Yn), E(p('[data-menuanchor="' + e + '"]', n), Yn));
                    }), function(n, t) {
                        var e = p(Kn)[0];
                        Mt().navigation && null != e && "none" !== e.style.display && (R(p(Un, e), Yn), E(n ? p('a[href="#' + n + '"]', e) : p("a", p("li", e)[t]), Yn));
                    }(n, t);
                }
                we.m = {
                    up: !0,
                    down: !0,
                    left: !0,
                    right: !0
                }, we.k = h({}, we.m), dn.R(mn, function(n) {
                    var t = n.target;
                    (Q(t, dt) || P(t, dt)) && ye.call(t, n);
                }), s.landscapeScroll = Ae, dn.R(yn, function() {
                    dn.R(jn, Te);
                }), s.setRecordHistory = Le, s.setAutoScrolling = je, s.test.setAutoScrolling = je, (new Date).getTime();
                var Ie, We, Fe, Ve, Ze, Be, Ge = (We = !0, Fe = (new Date).getTime(), Ve = !o.fullpage_api, function(n, t) {
                    var e = (new Date).getTime(), i = "wheel" === n ? Mt().scrollingSpeed : 100;
                    return We = Ve || e - Fe >= i, Ve = !o.fullpage_api, We && (Ie = t(), Fe = e), void 0 === Ie || Ie;
                });
                function Ye(n, t) {
                    if (X(Mt().beforeLeave)) return Ge(hn().H, function() {
                        return re(n, t);
                    });
                }
                function Ue(n, t, e) {
                    var i = n.item;
                    if (null != i) {
                        var o, r, a = {
                            element: i,
                            callback: t,
                            isMovementUp: e,
                            dtop: Xe(i),
                            yMovement: Ut(hn().P, i),
                            anchorLink: n.anchor,
                            sectionIndex: n.index(),
                            activeSlide: n.activeSlide ? n.activeSlide.item : null,
                            leavingSection: hn().P.index() + 1,
                            localIsResizing: vn.F,
                            items: {
                                origin: hn().P,
                                destination: n
                            },
                            direction: null
                        };
                        if (!(hn().P.item == i && !vn.F || Mt().scrollBar && W() === a.dtop && !g(i, "fp-auto-height"))) {
                            if (null != a.activeSlide && (o = Z(a.activeSlide, "data-anchor"), r = T(a.activeSlide, null)), !a.localIsResizing) {
                                var l = a.yMovement;
                                if (void 0 !== e && (l = e ? "up" : "down"), a.direction = l, Ot("dropEffect") && s.dropEffect.onLeave_(a), Ot("waterEffect") && s.waterEffect.onLeave_(a), X(Mt().beforeLeave) && !1 === Ye("beforeLeave", a)) return;
                                if (X(Mt().onLeave) && !re("onLeave", a)) return;
                            }
                            Et("parallax", "apply", a), Et("cards", "apply", a), Et("dropEffect", "apply", a), Et("waterEffect", "apply", a), Mt().autoScrolling && Mt().continuousVertical && void 0 !== a.isMovementUp && (!a.isMovementUp && "up" == a.yMovement || a.isMovementUp && "down" == a.yMovement) && (a = function(n) {
                                pn({
                                    nn: !0
                                });
                                var t = hn().P.item;
                                return n.isMovementUp ? C(t, tn(t, Qn)) : H(t, en(t, Qn).reverse()), Jt(hn().P.item.offsetTop), ze(), n.pn = t, n.dtop = n.element.offsetTop, n.yMovement = Ut(hn().P, n.element), n.leavingSection = n.items.origin.index() + 1, n.sectionIndex = n.items.destination.index(), _(yt(), "onContinuousVertical", n), n;
                            }(a)), Et("scrollOverflowReset", "setPrevious", hn().P.item), a.localIsResizing || ue(hn().P.item), kt("dropEffect") && Mt().dropEffect || (E(i, Yn), R(F(i), Yn)), si(), ce(i), pn({
                                canScroll: s.test.hn
                            }), de(r, o, a.anchorLink), dn.L(Dn, a), function(n) {
                                var t = Mt().scrollingSpeed < 700, e = t ? 700 : Mt().scrollingSpeed;
                                if (pn({
                                    Y: "none",
                                    scrollY: Math.round(n.dtop)
                                }), dn.L(jn), Mt().css3 && Mt().autoScrolling && !Mt().scrollBar) Qt("translate3d(0px, -" + Math.round(n.dtop) + "px, 0px)", !0), kt("waterEffect") && ze(), Mt().scrollingSpeed ? (clearTimeout(Ze), Ze = setTimeout(function() {
                                    _e(n), pn({
                                        canScroll: !t || s.test.hn
                                    });
                                }, Mt().scrollingSpeed)) : _e(n);
                                else {
                                    var i = Bt(n.dtop);
                                    s.test.top = -n.dtop + "px", clearTimeout(Ze), ee(i.element, i.options, Mt().scrollingSpeed, function() {
                                        Mt().scrollBar ? Ze = setTimeout(function() {
                                            _e(n);
                                        }, 30) : (_e(n), pn({
                                            canScroll: !t || s.test.hn
                                        }));
                                    });
                                }
                                t && (clearTimeout(Be), Be = setTimeout(function() {
                                    pn({
                                        canScroll: !0
                                    });
                                }, e));
                            }(a), pn({
                                Z: a.anchorLink
                            }), Ce(a.anchorLink, function(n) {
                                return null != n.pn ? n.isMovementUp ? vn.j - 1 : 0 : n.sectionIndex;
                            }(a));
                        }
                    }
                }
                function Xe(n) {
                    var t = n.offsetHeight, e = n.offsetTop, i = e, o = kt("dragAndMove") && Et("dragAndMove", "isGrabbing") ? Et("dragAndMove", "isScrollingDown") : e > vn.K, r = i - m() + t, a = Mt().bigSectionsDestination;
                    return t > m() ? (o || a) && "bottom" !== a || (i = r) : (o || vn.F && null == y(n)) && (i = r), kt("offsetSections") && (i = s.offsetSections.getSectionPosition_(o, i, n)), pn({
                        K: i
                    }), i;
                }
                function _e(n) {
                    pn({
                        C: !1
                    }), function(n) {
                        null != n.pn && (n.isMovementUp ? C(p(Qn)[0], n.pn) : H(p(Qn)[hn().N.length - 1], n.pn), Jt(hn().P.item.offsetTop), function() {
                            for(var n = p(nt), t = 0; t < n.length; t++)Re(n[t], "internal");
                        }(), n.sectionIndex = n.items.destination.index(), n.leavingSection = n.items.origin.index() + 1, pn({
                            nn: !1
                        }));
                    }(n), X(Mt().afterLoad) && !n.localIsResizing && re("afterLoad", n), Et("parallax", "afterLoad"), Et("waterEffect", "afterLoad"), Et("dropEffect", "afterLoad"), Et("scrollOverflowReset", "reset"), Et("resetSliders", "apply", n), si(), n.localIsResizing || ae(n.element), E(n.element, Xn), R(F(n.element), Xn), De(), pn({
                        canScroll: !0
                    }), dn.L(Nn, n), X(n.callback) && n.callback();
                }
                function Qe(n, t) {
                    At("fitToSection", n, t);
                }
                function Je() {
                    vn.canScroll && (pn({
                        F: !0
                    }), Ue(vn.P), pn({
                        F: !1
                    }));
                }
                function Ke() {
                    var n = Mt().responsive || Mt().responsiveWidth, t = Mt().responsiveHeight, e = n && o.innerWidth < n, i = t && o.innerHeight < t;
                    n && t ? qe(e || i) : n ? qe(e) : t && qe(i);
                }
                function qe(n) {
                    var t = $e();
                    n ? t || (je(!1, "internal"), Qe(!1, "internal"), x(p(Kn)), E($t, Vn), X(Mt().afterResponsive) && Mt().afterResponsive.call(yt(), n), Et("responsiveSlides", "toSections"), _(yt(), "afterResponsive", n)) : t && (je(Tt().autoScrolling, "internal"), Qe(Tt().autoScrolling, "internal"), O(p(Kn)), R($t, Vn), X(Mt().afterResponsive) && Mt().afterResponsive.call(yt(), n), Et("responsiveSlides", "toSlides"), _(yt(), "afterResponsive", n));
                }
                function $e() {
                    return g($t, Vn);
                }
                function ni(n) {
                    Mt().verticalCentered && (!Mt().scrollOverflow && li.gn(n.item) || li.mn(n) || g(n.item, rt) || E(n.item, rt));
                }
                s.moveTo = moveTo, s.getScrollY = function() {
                    return vn.scrollY;
                }, dn.R(Mn, function() {
                    clearTimeout(Ze), clearTimeout(Be);
                }), s.setFitToSection = Qe, s.fitToSection = Je, s.setResponsive = qe;
                var ti, ei = null;
                function ii(n) {
                    var t = n.item, e = n.wn.length, i = n.index();
                    !hn().P && n.isVisible && (E(t, Yn), si(), ei = hn().P.item), kt("offsetSections") && b(t, {
                        height: jt(t)
                    }), Mt().paddingTop && b(t, {
                        "padding-top": Mt().paddingTop
                    }), Mt().paddingBottom && b(t, {
                        "padding-bottom": Mt().paddingBottom
                    }), void 0 !== Mt().sectionsColor[i] && b(t, {
                        "background-color": Mt().sectionsColor[i]
                    }), void 0 !== Mt().anchors[i] && t.setAttribute("data-anchor", n.anchor), e || ni(n);
                }
                function oi() {
                    Mt().scrollOverflow && !Mt().scrollBar && (li.bn(), li.Sn());
                }
                function ri() {
                    dn.removeListener(gn, oi), Y("keyup", li.yn);
                }
                s.getActiveSection = function() {
                    return hn().P;
                }, dn.R(yn, function() {
                    dn.R(gn, oi), dn.R(Dn, li.onLeave), dn.R(zn, li.onLeave), dn.R(Pn, li.afterLoad), dn.R(Nn, li.afterLoad), dn.R(Mn, ri), B("keyup", li.yn);
                });
                var ai, li = {
                    Mn: null,
                    Tn: !0,
                    An: !0,
                    xn: null,
                    On: null,
                    kn: function(n) {
                        if (!vn.canScroll) return V(n), !1;
                    },
                    En: function(n) {
                        if (!cn() && Mt().keyboardScrolling && [
                            38,
                            33,
                            32,
                            40,
                            34,
                            36,
                            35
                        ].indexOf(n.keyCode) > -1 && !li.An) return V(n), !1;
                    },
                    yn: function() {
                        li.Tn = vn.canScroll;
                    },
                    onLeave: function() {
                        clearTimeout(ti), li.An = !1;
                    },
                    afterLoad: function() {
                        li.An = !1, clearTimeout(ti), ti = setTimeout(function() {
                            li.Tn = vn.canScroll;
                        }, 200);
                    },
                    Rn: function() {
                        r.activeElement === this.Mn && (this.Mn.blur(), li.An = !1);
                    },
                    Sn: function() {
                        if (Mt().scrollOverflow && li.Tn) {
                            li.Rn();
                            var n = li.Ln(hn().P.item);
                            !n || a || u || (this.Mn = n, requestAnimationFrame(function() {
                                n.focus(), li.An = !0;
                            })), li.Tn = !1;
                        }
                    },
                    bn: function() {
                        Mt().scrollOverflowMacStyle && !l && E($t, "fp-scroll-mac"), hn().un.forEach(function(n) {
                            if (!(n.slides && n.slides.length || g(n.item, "fp-auto-height-responsive") && $e())) {
                                var t, e = Vt(n.item), i = li.gn(n.item), o = (t = n).rn ? t : t.parent;
                                if (c) {
                                    var r = i ? "addClass" : "removeClass";
                                    sn[r](o.item, ut), sn[r](n.item, ut);
                                } else E(o.item, ut), E(n.item, ut);
                                n.on || (li.jn(e), li.zn(e)), n.on = !0;
                            }
                        });
                    },
                    zn: function(n) {
                        li.Ln(n).addEventListener("scroll", li.Dn), n.addEventListener("wheel", li.kn, {
                            passive: !1
                        }), n.addEventListener("keydown", li.En, {
                            passive: !1
                        });
                    },
                    jn: function(n) {
                        var t = document.createElement("div");
                        t.className = at, D(n, t), t.setAttribute("tabindex", "-1");
                    },
                    Nn: function(n) {
                        var t = p(lt, n)[0];
                        t && (N(t), n.removeAttribute("tabindex"));
                    },
                    Ln: function(n) {
                        var t = Vt(n);
                        return p(lt, t)[0] || t;
                    },
                    on: function(n) {
                        return g(n, at) || null != p(lt, n)[0];
                    },
                    mn: function(n) {
                        return n.rn && n.activeSlide ? n.activeSlide.on : n.on;
                    },
                    gn: function(n) {
                        return li.Ln(n).scrollHeight > o.innerHeight;
                    },
                    Pn: function(n, t) {
                        if (!vn.canScroll) return !1;
                        if (Mt().scrollBar) return !0;
                        var e = li.Ln(t);
                        if (!Mt().scrollOverflow || !g(e, at) || g(t, "fp-noscroll") || g(Vt(t), "fp-noscroll")) return !0;
                        var i = c ? 1 : 0, o = e.scrollTop, r = "up" === n && o <= 0, a = "down" === n && e.scrollHeight <= Math.ceil(e.offsetHeight + o) + i, l = r || a;
                        return l || (this.xn = (new Date).getTime()), l;
                    },
                    Hn: function() {
                        this.On = (new Date).getTime();
                        var n = this.On - li.xn, t = (a || u) && vn.X, e = vn._ && n > 600;
                        return t && n > 400 || e;
                    },
                    Dn: (ai = 0, function(n) {
                        var t = n.target.scrollTop, e = "none" !== vn.Y ? vn.Y : ai < t ? "down" : "up";
                        ai = t, X(Mt().onScrollOverflow) && re("onScrollOverflow", {
                            position: t,
                            direction: e
                        }), g(n.target, at) && vn.canScroll && li.Pn(e, n.target) && li.Hn() && li.gn(hn().P.item) && dn.L(An, {
                            direction: e
                        });
                    })
                }, ui = null, ci = null;
                function si() {
                    vn.P = null, vn.N.map(function(n) {
                        var t = g(n.item, Yn);
                        n.isActive = t, n.on = li.on(n.item), t && (vn.P = n), n.slides.length && (n.activeSlide = null, n.slides.map(function(t) {
                            var e = g(t.item, Yn);
                            t.on = li.on(n.item), t.isActive = e, e && (n.activeSlide = t);
                        }));
                    }), function() {
                        var n = vn.P, t = !!vn.P && vn.P.slides.length, e = vn.P ? vn.P.activeSlide : null;
                        if (!n && vn.N.length && !hn().C) {
                            if (ui) {
                                var i = vi(ui, vn.N);
                                i && (vn.P = i, vn.P.isActive = !0, E(vn.P.item, Yn)), vn.P && Jt(vn.P.item.offsetTop);
                            }
                            if (t && !e && ci) {
                                var o = vi(ci, vn.P.slides);
                                o && (vn.P.activeSlide = o, vn.P.activeSlide.isActive = !0, E(vn.P.activeSlide.item, Yn)), vn.P.activeSlide && Re(vn.P.activeSlide.item, "internal");
                            }
                        }
                    }(), _(yt(), "onUpdateStateDone");
                }
                function fi() {
                    var n = p(Mt().sectionSelector + ", " + Qn, yt()), t = v(n), e = Array.from(n).map(function(n) {
                        return new pi(n);
                    }), i = e.filter(function(n) {
                        return n.isVisible;
                    }), o = i.reduce(function(n, t) {
                        return n.concat(t.slides);
                    }, []);
                    ui = di(vn.P), ci = di(vn.P ? vn.P.activeSlide : null), vn.j = t.length, vn.D = i.reduce(function(n, t) {
                        return n + t.slides.length;
                    }, 0), vn.N = i, vn.an = e, vn.slides = o, vn.un = vn.N.concat(vn.slides);
                }
                function di(n) {
                    if (!n) return null;
                    var t = n ? n.item : null, e = n.rn ? vn.an : vn.P.Cn;
                    if (t) {
                        var i = Ct(e, t);
                        return i ? i.index() : null;
                    }
                    return null;
                }
                function vi(n, t) {
                    var e, i = n - 1, o = n;
                    do {
                        if (e = t[i] || t[o]) break;
                        i -= 1, o += 1;
                    }while (i >= 0 || o < t.length);
                    return e;
                }
                var pi = function(n) {
                    var t = this;
                    [].push.call(arguments, Mt().sectionSelector), Pt.apply(this, arguments), this.wn = p(Mt().slideSelector, n), this.Cn = Array.from(this.wn).map(function(n) {
                        return new gi(n, t);
                    }), this.slides = this.Cn.filter(function(n) {
                        return n.isVisible;
                    }), this.activeSlide = this.slides.length ? this.slides.filter(function(n) {
                        return n.isActive;
                    })[0] || this.slides[0] : null;
                };
                pi.prototype = Pt.prototype, pi.prototype.constructor = pi;
                var hi, gi = function(n, t) {
                    this.parent = t, Pt.call(this, n, Mt().slideSelector);
                };
                function mi() {
                    E(p(Mt().sectionSelector, yt()), _n), E(p(Mt().slideSelector, yt()), qn);
                }
                function wi(n) {
                    var t = n.slides.length, e = n.wn, i = n.slides, o = 100 * t, a = 100 / t;
                    if (!p(et, n.item)[0]) {
                        var l = r.createElement("div");
                        l.className = tt, z(e, l);
                        var u = r.createElement("div");
                        u.className = it, z(e, u);
                    }
                    b(p(ot, n.item), {
                        width: o + "%"
                    }), t > 1 && (Mt().controlArrows && function(n) {
                        var t = n.item, e = [
                            K(Mt().controlArrowsHTML[0]),
                            K(Mt().controlArrowsHTML[1])
                        ];
                        H(p(et, t)[0], e), E(e, ft), E(e[0], vt), E(e[1], "fp-next"), "#fff" !== Mt().controlArrowColor && (b(p(ht, t), {
                            "border-color": "transparent transparent transparent " + Mt().controlArrowColor
                        }), b(p(pt, t), {
                            "border-color": "transparent " + Mt().controlArrowColor + " transparent transparent"
                        })), Mt().loopHorizontal || x(p(pt, t));
                    }(n), Mt().slidesNavigation && function(n) {
                        var t = n.item, e = n.slides.length;
                        L(K('<div class="fp-slidesNav"><ul></ul></div>'), t);
                        var i = p(ct, t)[0];
                        E(i, "fp-" + Mt().slidesNavPosition);
                        for(var o = 0; o < e; o++)L(K('<li><a href="#"><span class="fp-sr-only">' + pe(o, "Slide", p($n, t)[o]) + "</span><span></span></a></li>"), p("ul", i)[0]);
                        b(i, {
                            "margin-left": "-" + i.innerWidth / 2 + "px"
                        });
                        var r = n.activeSlide ? n.activeSlide.index() : 0;
                        E(p("a", p("li", i)[r]), Yn);
                    }(n)), i.forEach(function(n) {
                        b(n.item, {
                            width: a + "%"
                        }), Mt().verticalCentered && ni(n);
                    });
                    var c = kt("responsiveSlides") ? null : n.activeSlide || null;
                    null != c && vn.P && (0 !== vn.P.index() || 0 === vn.P.index() && 0 !== c.index()) ? (Re(c.item, "internal"), E(c.item, "fp-initial")) : E(e[0], Yn);
                }
                gi.prototype = Pt.prototype, gi.prototype.constructor = pi;
                var bi = {
                    attributes: !1,
                    subtree: !0,
                    childList: !0,
                    characterData: !0
                };
                function Si() {
                    return Et("responsiveSlides", "isResponsiveSlidesChanging") || v(p(Mt().slideSelector, yt())).length !== hn().D;
                }
                function yi(n) {
                    var t = Si();
                    (Si() || Et("responsiveSlides", "isResponsiveSlidesChanging") || v(p(Mt().sectionSelector, yt())).length !== hn().j) && !vn.nn && (Mt().observer && hi && hi.disconnect(), fi(), si(), Mt().anchors = [], q(p(Kn)), Et("responsiveSlides", "isResponsiveSlidesChanging") || mi(), xt(), Mt().navigation && Pe(), t && (q(p(ct)), q(p(dt))), hn().N.forEach(function(n) {
                        n.slides.length ? t && wi(n) : ii(n);
                    })), Mt().observer && hi && p(Fn)[0] && hi.observe(p(Fn)[0], bi);
                }
                dn.R(yn, function() {
                    var n, t, e;
                    Mt().observer && "MutationObserver" in window && p(Fn)[0] && (n = p(Fn)[0], t = bi, (e = new MutationObserver(yi)).observe(n, t), hi = e), dn.R(Tn, yi);
                }), s.render = yi;
                var Mi = function() {
                    var n = !1;
                    try {
                        var t = Object.defineProperty({}, "passive", {
                            get: function() {
                                n = !0;
                            }
                        });
                        G("testPassive", null, t), U("testPassive", null, t);
                    } catch (n) {}
                    return function() {
                        return n;
                    };
                }();
                function Ti() {
                    return !!Mi() && {
                        passive: !1
                    };
                }
                var Ai, xi, Oi, ki, Ei = (Oi = (new Date).getTime(), ki = [], {
                    In: function(n) {
                        var t = (n = n || o.event).wheelDelta || -n.deltaY || -n.detail, e = Math.max(-1, Math.min(1, t)), i = void 0 !== n.wheelDeltaX || void 0 !== n.deltaX;
                        Ai = Math.abs(n.wheelDeltaX) < Math.abs(n.wheelDelta) || Math.abs(n.deltaX) < Math.abs(n.deltaY) || !i;
                        var r = (new Date).getTime();
                        xi = e < 0 ? "down" : "up", ki.length > 149 && ki.shift(), ki.push(Math.abs(t));
                        var a = r - Oi;
                        Oi = r, a > 200 && (ki = []);
                    },
                    Wn: function() {
                        var n = an(ki, 10) >= an(ki, 70);
                        return !!ki.length && n && Ai;
                    },
                    Fn: function() {
                        return xi;
                    }
                });
                function Ri() {
                    var n = Mt().css3 ? W() + m() : rn(hn().N).item.offsetTop + rn(hn().N).item.offsetHeight, t = Bt(n);
                    s.test.top = -n + "px", pn({
                        canScroll: !1
                    }), ee(t.element, t.options, Mt().scrollingSpeed, function() {
                        setTimeout(function() {
                            pn({
                                C: !0
                            }), pn({
                                canScroll: !0
                            });
                        }, 30);
                    });
                }
                function Li() {
                    yt().getBoundingClientRect().bottom >= 0 && ji();
                }
                function ji() {
                    var n = Bt(rn(hn().N).item.offsetTop);
                    pn({
                        canScroll: !1
                    }), ee(n.element, n.options, Mt().scrollingSpeed, function() {
                        pn({
                            canScroll: !0
                        }), pn({
                            C: !1
                        }), pn({
                            Vn: !1
                        });
                    });
                }
                var zi, Di, Ni, Pi = (zi = !1, Di = {}, Ni = {}, function(n, t, e) {
                    switch(n){
                        case "set":
                            Di[t] = (new Date).getTime(), Ni[t] = e;
                            break;
                        case "isNewKeyframe":
                            var i = (new Date).getTime();
                            zi = i - Di[t] > Ni[t];
                    }
                    return zi;
                });
                function Hi() {
                    var n = hn().P.next();
                    n || !Mt().loopBottom && !Mt().continuousVertical || (n = hn().N[0]), null != n ? Ue(n, null, !1) : yt().scrollHeight < $t.scrollHeight && Mt().scrollBar && Mt().Zn && dn.L(Ln);
                }
                function Ci() {
                    var n = hn().P.prev();
                    n || !Mt().loopTop && !Mt().continuousVertical || (n = rn(hn().N)), null != n && Ue(n, null, !0);
                }
                s.moveSectionDown = Hi, s.moveSectionUp = Ci;
                var Ii = 0;
                function Wi(n) {
                    Mt().autoScrolling && (vn.canScroll && (n.pageY < Ii && Se().m.up ? Ci() : n.pageY > Ii && Se().m.down && Hi()), Ii = n.pageY);
                }
                function Fi(n) {
                    if (Se().m[n]) {
                        var t = "down" === n ? Hi : Ci;
                        kt("scrollHorizontally") && (t = Et("scrollHorizontally", "getScrollSection", {
                            type: n,
                            scrollSection: t
                        })), Mt().scrollOverflow && li.mn(hn().P) ? li.Pn(n, hn().P.item) && li.Hn() && t() : t();
                    }
                }
                var Vi, Zi, Bi, Gi = 0, Yi = 0, Ui = 0, Xi = 0, _i = to(), Qi = {
                    Bn: "ontouchmove" in window ? "touchmove" : _i ? _i.move : null,
                    Gn: "ontouchstart" in window ? "touchstart" : _i ? _i.down : null
                };
                function Ji(n) {
                    var t = P(n.target, Qn) || hn().P.item, e = li.mn(hn().P);
                    if (Ki(n)) {
                        pn({
                            X: !0,
                            _: !1
                        }), Mt().autoScrolling && (e && !vn.canScroll || Mt().scrollBar) && V(n);
                        var i = no(n);
                        Ui = i.y, Xi = i.x;
                        var r = Math.abs(Gi - Ui) > o.innerHeight / 100 * Mt().touchSensitivity, a = Math.abs(Yi - Xi) > w() / 100 * Mt().touchSensitivity, l = p(et, t).length && Math.abs(Yi - Xi) > Math.abs(Gi - Ui), u = Gi > Ui ? "down" : "up";
                        pn({
                            Y: l ? Yi > Xi ? "right" : "left" : u
                        }), l ? !vn.W && a && (Yi > Xi ? Se().m.right && dn.L(bn, {
                            section: t
                        }) : Se().m.left && dn.L(wn, {
                            section: t
                        })) : Mt().autoScrolling && vn.canScroll && r && Fi(u);
                    }
                }
                function Ki(n) {
                    return void 0 === n.pointerType || "mouse" != n.pointerType;
                }
                function qi(n) {
                    if (Mt().fitToSection && pn({
                        G: !1
                    }), Ki(n)) {
                        var t = no(n);
                        Gi = t.y, Yi = t.x;
                    }
                    G("touchend", $i);
                }
                function $i() {
                    U("touchend", $i), pn({
                        X: !1
                    });
                }
                function no(n) {
                    var t = {};
                    return t.y = void 0 !== n.pageY && (n.pageY || n.pageX) ? n.pageY : n.touches[0].pageY, t.x = void 0 !== n.pageX && (n.pageY || n.pageX) ? n.pageX : n.touches[0].pageX, u && Ki(n) && Mt().scrollBar && void 0 !== n.touches && (t.y = n.touches[0].pageY, t.x = n.touches[0].pageX), t;
                }
                function to() {
                    var n;
                    return o.PointerEvent && (n = {
                        down: "pointerdown",
                        move: "pointermove"
                    }), n;
                }
                function eo(n) {
                    Mt().autoScrolling && Ki(n) && Se().m.up && (vn.canScroll || V(n));
                }
                function io(n, t) {
                    var e = null == t ? hn().P.item : t, i = Ct(vn.N, e), o = p(et, e)[0];
                    if (!(null == o || Rt() || vn.W || i.slides.length < 2)) {
                        var r = i.activeSlide, a = "left" === n ? r.prev() : r.next();
                        if (!a) {
                            if (!Mt().loopHorizontal) return;
                            a = "left" === n ? rn(i.slides) : i.slides[0];
                        }
                        pn({
                            W: !s.test.hn
                        }), Ae(o, a.item, n);
                    }
                }
                function oo(n) {
                    io("left", n);
                }
                function ro(n) {
                    io("right", n);
                }
                function ao(n) {
                    var t = hn().N.filter(function(t) {
                        return t.anchor === n;
                    })[0];
                    if (!t) {
                        var e = void 0 !== n ? n - 1 : 0;
                        t = hn().N[e];
                    }
                    return t;
                }
                function lo(n) {
                    null != n && Ae(P(n, et), n);
                }
                function uo(n, t) {
                    var e = ao(n);
                    if (null != e) {
                        var i = function(n, t) {
                            var e = t.slides.filter(function(t) {
                                return t.anchor === n;
                            })[0];
                            return null == e && (n = void 0 !== n ? n : 0, e = t.slides[n]), e ? e.item : null;
                        }(t, e);
                        e.anchor && e.anchor === vn.Z || g(e.item, Yn) ? lo(i) : Ue(e, function() {
                            lo(i);
                        });
                    }
                }
                function co(n, t) {
                    var e = ao(n);
                    void 0 !== t ? uo(n, t) : null != e && Ue(e);
                }
                function so() {
                    clearTimeout(Zi), Y("keydown", fo), Y("keyup", vo);
                }
                function fo(n) {
                    clearTimeout(Zi);
                    var t = n.keyCode, e = [
                        37,
                        39
                    ].indexOf(t) > -1, i = Mt().autoScrolling || Mt().fitToSection || e;
                    9 === t ? function(n) {
                        var t = n.shiftKey, e = r.activeElement, i = wo(Vt(hn().P.item));
                        function o(n) {
                            return V(n), i[0] ? i[0].focus() : null;
                        }
                        if (vn.canScroll) {
                            if (!function(n) {
                                var t = wo(r), e = t.indexOf(r.activeElement), i = t[n.shiftKey ? e - 1 : e + 1], o = P(i, $n), a = P(i, Qn);
                                return !o && !a;
                            }(n)) {
                                e ? null == P(e, ".fp-section.active,.fp-section.active .fp-slide.active") && (e = o(n)) : o(n);
                                var a = e == i[0], l = e == i[i.length - 1], u = t && a;
                                if (u || !t && l) {
                                    V(n);
                                    var c = function(n) {
                                        var t, e = n ? "prevPanel" : "nextPanel", i = [], o = Zt((vn.P && vn.P.activeSlide ? vn.P.activeSlide : vn.P)[e]());
                                        do (i = wo(o.item)).length && (t = {
                                            Yn: o,
                                            Un: i[n ? i.length - 1 : 0]
                                        }), o = Zt(o[e]());
                                        while (o && 0 === i.length);
                                        return t;
                                    }(u), s = c ? c.Yn : null;
                                    if (s) {
                                        var f = s.rn ? s : s.parent;
                                        dn.L(xn, {
                                            Xn: f.index() + 1,
                                            slideAnchor: s.rn ? 0 : s.index()
                                        }), Bi = c.Un, V(n);
                                    }
                                }
                            }
                        } else V(n);
                    }(n) : !cn() && Mt().keyboardScrolling && i && (Vi = n.ctrlKey, Zi = setTimeout(function() {
                        !function(n) {
                            var t = n.shiftKey, e = r.activeElement, i = Q(e, "video") || Q(e, "audio"), o = li.Pn("up", hn().P.item), a = li.Pn("down", hn().P.item), l = [
                                37,
                                39
                            ].indexOf(n.keyCode) > -1;
                            if (function(n) {
                                (function(n) {
                                    return [
                                        40,
                                        38,
                                        32,
                                        33,
                                        34
                                    ].indexOf(n.keyCode) > -1 && !vn.C;
                                })(n) && !P(n.target, lt) && n.preventDefault();
                            }(n), vn.canScroll || l) switch(pn({
                                H: "keydown"
                            }), n.keyCode){
                                case 38:
                                case 33:
                                    Se().k.up && o ? vn.C ? dn.L(On, {
                                        e: n
                                    }) : Ci() : li.Sn();
                                    break;
                                case 32:
                                    if (t && Se().k.up && !i && o) {
                                        Ci();
                                        break;
                                    }
                                case 40:
                                case 34:
                                    if (Se().k.down && a) {
                                        if (vn.C) return;
                                        32 === n.keyCode && i || Hi();
                                    } else li.Sn();
                                    break;
                                case 36:
                                    Se().k.up && co(1);
                                    break;
                                case 35:
                                    Se().k.down && co(hn().N.length);
                                    break;
                                case 37:
                                    Se().k.left && oo();
                                    break;
                                case 39:
                                    Se().k.right && ro();
                            }
                        }(n);
                    }, 0));
                }
                function vo(n) {
                    vn.J && (Vi = n.ctrlKey);
                }
                function po() {
                    pn({
                        J: !1
                    }), Vi = !1;
                }
                function ho(n) {
                    mo();
                }
                function go(n) {
                    P(Bi, $n) && !P(Bi, nt) || mo();
                }
                function mo() {
                    Bi && (Bi.focus(), Bi = null);
                }
                function wo(n) {
                    return [].slice.call(p('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]', n)).filter(function(n) {
                        return "-1" !== Z(n, "tabindex") && null !== n.offsetParent;
                    });
                }
                s.moveSlideLeft = oo, s.moveSlideRight = ro, s.moveTo = co, dn.R(yn, function() {
                    G("blur", po), B("keydown", fo), B("keyup", vo), dn.R(Mn, so), dn.R(Pn, ho), dn.R(Nn, go);
                });
                var bo = (new Date).getTime(), So = [];
                function yo(n) {
                    n ? (function() {
                        var n, t = "";
                        o.addEventListener ? n = "addEventListener" : (n = "attachEvent", t = "on");
                        var e = "onwheel" in r.createElement("div") ? "wheel" : void 0 !== r.onmousewheel ? "mousewheel" : "DOMMouseScroll", i = Ti();
                        "DOMMouseScroll" == e ? r[n](t + "MozMousePixelScroll", Mo, i) : r[n](t + e, Mo, i);
                    }(), yt().addEventListener("mousedown", To), yt().addEventListener("mouseup", Ao)) : (r.addEventListener ? (Y("mousewheel", Mo, !1), Y("wheel", Mo, !1), Y("MozMousePixelScroll", Mo, !1)) : r.detachEvent("onmousewheel", Mo), yt().removeEventListener("mousedown", To), yt().removeEventListener("mouseup", Ao));
                }
                function Mo(n) {
                    var t = (new Date).getTime(), e = g(p(".fp-completely")[0], "fp-normal-scroll"), i = function(n, t) {
                        (new Date).getTime();
                        var e = hn().C && n.getBoundingClientRect().bottom >= 0 && "up" === Ei.Fn(), i = hn().Vn;
                        if (i) return V(t), !1;
                        if (hn().C) {
                            if (e) {
                                var o;
                                if (!(i || Pi("isNewKeyframe", "beyondFullpage") && Ei.Wn())) return (o = Bt(rn(hn().N).item.offsetTop + rn(hn().N).item.offsetHeight)).element.scrollTo(0, o.options), pn({
                                    Vn: !1
                                }), V(t), !1;
                                if (Ei.Wn()) return e = !1, pn({
                                    Vn: !0
                                }), pn({
                                    H: "wheel"
                                }), ji(), V(t), !1;
                            } else Pi("set", "beyondFullpage", 1e3);
                            if (!i && !e) return !0;
                        }
                    }(yt(), n);
                    if (vn._ || pn({
                        X: !1,
                        _: !0,
                        Y: "none"
                    }), !Se().m.down && !Se().m.up) return V(n), !1;
                    if (i) return !0;
                    if (!1 === i) return V(n), !1;
                    if (Mt().autoScrolling && !Vi && !e) {
                        var r = (n = n || o.event).wheelDelta || -n.deltaY || -n.detail, a = Math.max(-1, Math.min(1, r)), l = void 0 !== n.wheelDeltaX || void 0 !== n.deltaX, u = Math.abs(n.wheelDeltaX) < Math.abs(n.wheelDelta) || Math.abs(n.deltaX) < Math.abs(n.deltaY) || !l, c = a < 0 ? "down" : a > 0 ? "up" : "none";
                        So.length > 149 && So.shift(), So.push(Math.abs(r)), Mt().scrollBar && V(n);
                        var s = t - bo;
                        return bo = t, s > 200 && (So = []), pn({
                            U: c
                        }), vn.canScroll && !Rt() && an(So, 10) >= an(So, 70) && u && (pn({
                            H: "wheel"
                        }), Fi(a < 0 ? "down" : "up")), !1;
                    }
                    Mt().fitToSection && pn({
                        G: !1
                    });
                }
                function To(n) {
                    var t;
                    2 == n.which && (t = n.pageY, Ii = t, yt().addEventListener("mousemove", Wi));
                }
                function Ao(n) {
                    2 == n.which && yt().removeEventListener("mousemove", Wi);
                }
                function xo(n) {
                    n ? (yo(!0), function() {
                        if (Qi.Bn && (a || u) && (!kt("dragAndMove") || "mouseonly" === Mt().dragAndMove)) {
                            Mt().autoScrolling && ($t.removeEventListener(Qi.Bn, eo, {
                                passive: !1
                            }), $t.addEventListener(Qi.Bn, eo, {
                                passive: !1
                            }));
                            var n = Mt().touchWrapper;
                            n.removeEventListener(Qi.Gn, qi), n.removeEventListener(Qi.Bn, Ji, {
                                passive: !1
                            }), n.addEventListener(Qi.Gn, qi), n.addEventListener(Qi.Bn, Ji, {
                                passive: !1
                            });
                        }
                    }()) : (yo(!1), function() {
                        if (Qi.Bn && (a || u)) {
                            Mt().autoScrolling && ($t.removeEventListener(Qi.Bn, Ji, {
                                passive: !1
                            }), $t.removeEventListener(Qi.Bn, eo, {
                                passive: !1
                            }));
                            var n = Mt().touchWrapper;
                            n.removeEventListener(Qi.Gn, qi), n.removeEventListener(Qi.Bn, Ji, {
                                passive: !1
                            });
                        }
                    }());
                }
                s.setMouseWheelScrolling = yo;
                var Oo = !0;
                function ko() {
                    [
                        "mouseenter",
                        "touchstart",
                        "mouseleave",
                        "touchend"
                    ].forEach(function(n) {
                        Y(n, Ro, !0);
                    });
                }
                function Eo(n, t) {
                    document["fp_" + n] = t, B(n, Ro, !0);
                }
                function Ro(n) {
                    var t = n.type, e = !1, i = "mouseleave" === t ? n.toElement || n.relatedTarget : n.target;
                    i != document && i ? ("touchend" === t && (Oo = !1, setTimeout(function() {
                        Oo = !0;
                    }, 800)), ("mouseenter" !== t || Oo) && (Mt().normalScrollElements.split(",").forEach(function(n) {
                        if (!e) {
                            var t = Q(i, n), o = P(i, n);
                            (t || o) && (s.shared._n || xo(!1), s.shared._n = !0, e = !0);
                        }
                    }), !e && s.shared._n && (xo(!0), s.shared._n = !1))) : xo(!0);
                }
                function Lo(n, t) {
                    Kt(0, "internal"), co(n, t), Kt(Tt().scrollingSpeed, "internal");
                }
                dn.R(yn, function() {
                    Mt().normalScrollElements && ([
                        "mouseenter",
                        "touchstart"
                    ].forEach(function(n) {
                        Eo(n, !1);
                    }), [
                        "mouseleave",
                        "touchend"
                    ].forEach(function(n) {
                        Eo(n, !0);
                    })), dn.R(Mn, ko);
                }), s.silentMoveTo = Lo;
                var jo, zo, Do = m(), No = w(), Po = !1;
                function Ho() {
                    clearTimeout(jo), clearTimeout(zo), U("resize", Co);
                }
                function Co() {
                    Po || (Mt().autoScrolling && !Mt().scrollBar || !Mt().fitToSection) && Wo(m()), function() {
                        if (a) for(var n = 0; n < 4; n++)zo = setTimeout(function() {
                            window.requestAnimationFrame(function() {
                                Mt().autoScrolling && !Mt().scrollBar && (pn({
                                    F: !0
                                }), Lo(vn.P.index() + 1), pn({
                                    F: !1
                                }));
                            });
                        }, 200 * n);
                    }(), Po = !0, clearTimeout(jo), jo = setTimeout(function() {
                        !function() {
                            if (pn({
                                F: !0
                            }), Wo(""), _(yt(), "onResize"), Mt().autoScrolling || vn.C || function() {
                                if (!Mt().autoScrolling || Mt().scrollBar) {
                                    var n = .01 * o.innerHeight;
                                    r.documentElement.style.setProperty("--vh", "".concat(n, "px"));
                                }
                            }(), dn.L(Tn), si(), Ke(), a) {
                                var n = r.activeElement;
                                if (!Q(n, "textarea") && !Q(n, "input") && !Q(n, "select")) {
                                    var t = m();
                                    Math.abs(t - Do) > 20 * Math.max(Do, t) / 100 && (Io(!0), Do = t);
                                }
                            } else e = m(), i = w(), vn.q === e && No === i || (pn({
                                q: e
                            }), No = i, Io(!0));
                            var e, i;
                            _(yt(), "onResizeEnds"), pn({
                                F: !1
                            });
                        }(), Po = !1;
                    }, 400);
                }
                function Io(n) {
                    if (!g(yt(), Bn)) {
                        pn({
                            F: !0,
                            q: m(),
                            Qn: w()
                        });
                        for(var t = hn().N, e = 0; e < t.length; ++e){
                            var i = t[e], r = p(et, i.item)[0], a = i.slides;
                            kt("offsetSections") && b(i.item, {
                                height: jt(i.item)
                            }), a.length > 1 && Ae(r, i.activeSlide.item);
                        }
                        Mt().scrollOverflow && li.bn();
                        var l = hn().P.index();
                        vn.C || !l || kt("fadingEffect") || kt("dropEffect") || kt("waterEffect") || Lo(l + 1), pn({
                            F: !1
                        }), X(Mt().afterResize) && n && Mt().afterResize.call(yt(), o.innerWidth, o.innerHeight), X(Mt().afterReBuild) && !n && Mt().afterReBuild.call(yt()), _(yt(), "afterRebuild");
                    }
                }
                function Wo(n) {
                    hn().N.forEach(function(t) {
                        var e = "" !== n || kt("offsetSections") ? jt(t.item) : "";
                        b(t.item, {
                            height: e
                        });
                    });
                }
                function Fo() {
                    var n, t, e = o.location.hash;
                    if (e.length) {
                        var i = e.replace("#", "").split("/"), r = e.indexOf("#/") > -1;
                        n = r ? "/" + i[1] : decodeURIComponent(i[0]);
                        var a = r ? i[2] : i[1];
                        a && a.length && (t = decodeURIComponent(a));
                    }
                    return {
                        section: n,
                        sn: t
                    };
                }
                function Vo() {
                    U("hashchange", Zo);
                }
                function Zo() {
                    if (!vn.V && !Mt().lockAnchors) {
                        var n = Fo(), t = n.section, e = n.sn, i = void 0 === vn.Z, o = void 0 === vn.Z && void 0 === e && !vn.W;
                        t && t.length && (t && t !== vn.Z && !i || o && !Rt() || !vn.W && vn.B != e && !Rt()) && dn.L(xn, {
                            Xn: t,
                            slideAnchor: e
                        });
                    }
                }
                function Bo(n) {
                    var t = n.target;
                    P(t, Mt().menu + " [data-menuanchor]") && Go.call(t, n);
                }
                function Go(n) {
                    pn({
                        H: "menu"
                    }), !p(Mt().menu)[0] || !Mt().lockAnchors && Mt().anchors.length || (V(n), dn.L(kn, {
                        anchor: Z(this, "data-menuanchor")
                    }));
                }
                function Yo(n) {
                    var t = n.target;
                    t && P(t, "#fp-nav a") ? He.call(t, n.e) : Q(t, ".fp-tooltip") ? Ne.call(t) : (Q(t, st) || null != P(t, st)) && he.call(t, n.e);
                }
                s.reBuild = Io, dn.R(yn, function() {
                    Co(), G("resize", Co), dn.R(Mn, Ho);
                }), s.setLockAnchors = function(n) {
                    Mt().lockAnchors = n;
                }, dn.R(yn, function() {
                    G("hashchange", Zo), dn.R(Mn, Vo);
                }), dn.R(yn, function() {
                    B("wheel", Ei.In, Ti()), dn.R(Ln, Ri), dn.R(On, Li);
                }), dn.R(yn, function() {
                    dn.R(mn, Bo);
                }), dn.R(yn, function() {
                    dn.R(mn, Yo);
                });
                var Uo, Xo, _o = 0;
                function Qo(n) {
                    var t, e, i, o, r;
                    if (_(yt(), "onScroll"), !vn.F && hn().P && (rn(hn().N), !hn().C && !hn().Vn && (!Mt().autoScrolling || Mt().scrollBar || kt("dragAndMove")) && !Lt())) {
                        var a = kt("dragAndMove") ? Math.abs(Et("dragAndMove", "getCurrentScroll")) : W(), l = function(n) {
                            var t = n > _o ? "down" : "up";
                            return _o = n, pn({
                                K: n
                            }), t;
                        }(a), u = 0, c = a + m() / 2, s = (kt("dragAndMove") ? Et("dragAndMove", "getDocumentHeight") : $t.scrollHeight - m()) === a, f = hn().N;
                        if (pn({
                            scrollY: a
                        }), s) u = f.length - 1;
                        else if (a) for(var d = 0; d < f.length; ++d)(P(f[d].item, Qn) || f[d].item).offsetTop <= c && (u = d);
                        else u = 0;
                        if (i = l, o = hn().P.item.offsetTop, r = o + m(), ("up" == i ? r >= W() + m() : o <= W()) && (g(hn().P.item, Xn) || (E(hn().P.item, Xn), R(F(hn().P.item), Xn))), e = (t = f[u]).item, !t.isActive) {
                            pn({
                                V: !0
                            });
                            var v, p, h = hn().P.item, w = hn().P.index() + 1, b = Ut(hn().P, e), S = t.anchor, y = t.index() + 1, M = t.activeSlide, T = {
                                P: h,
                                sectionIndex: y - 1,
                                anchorLink: S,
                                element: e,
                                leavingSection: w,
                                direction: b,
                                items: {
                                    origin: hn().P,
                                    destination: t
                                }
                            };
                            if (M && (p = M.anchor, v = M.index()), vn.canScroll) R(f.filter(function(n) {
                                return n.index() !== t.index();
                            }).map(function(n) {
                                return n.item;
                            }), Yn), E(e, Yn), Et("parallax", "afterLoad"), X(Mt().beforeLeave) && Ye("beforeLeave", T), X(Mt().onLeave) && re("onLeave", T), X(Mt().afterLoad) && re("afterLoad", T), Et("resetSliders", "apply", {
                                localIsResizing: vn.F,
                                leavingSection: w
                            }), ue(h), ce(e), ae(e), Ce(S, y - 1), Mt().anchors.length && pn({
                                Z: S
                            }), si(), de(v, p, S);
                            clearTimeout(Uo), Uo = setTimeout(function() {
                                pn({
                                    V: !1
                                });
                            }, 100);
                        }
                        Mt().fitToSection && vn.canScroll && (clearTimeout(Xo), Xo = setTimeout(function() {
                            vn.N.filter(function(n) {
                                var t = n.item.getBoundingClientRect();
                                return Math.round(t.bottom) === Math.round(m()) || 0 === Math.round(t.top);
                            }).length || Je();
                        }, Mt().en));
                    }
                }
                function Jo(n, t) {
                    void 0 !== t ? (t = t.replace(/ /g, "").split(",")).forEach(function(t) {
                        be(n, t, "k");
                    }) : (be(n, "all", "k"), Mt().keyboardScrolling = n);
                }
                function Ko(n) {
                    var t = n.index();
                    void 0 !== Mt().anchors[t] && n.isActive && Ce(Mt().anchors[t], t), Mt().menu && Mt().css3 && null != P(p(Mt().menu)[0], Fn) && p(Mt().menu).forEach(function(n) {
                        $t.appendChild(n);
                    });
                }
                function qo() {
                    var n, t, e = hn().P, i = hn().P.item;
                    E(i, Xn), ce(i), De(), ae(i), t = ao((n = Fo()).section), n.section && t && (void 0 === t || t.index() !== T(ei)) || !X(Mt().afterLoad) || re("afterLoad", {
                        P: i,
                        element: i,
                        direction: null,
                        anchorLink: e.anchor,
                        sectionIndex: e.index(),
                        items: {
                            origin: hn().P,
                            destination: hn().P
                        }
                    }), X(Mt().afterRender) && re("afterRender"), _(yt(), "afterRender");
                }
                function $o(n, t) {
                    void 0 !== t ? (t = t.replace(/ /g, "").split(",")).forEach(function(t) {
                        be(n, t, "m");
                    }) : be(n, "all", "m"), _(yt(), "setAllowScrolling", {
                        value: n,
                        Jn: t
                    });
                }
                function nr() {
                    var n = Fo(), t = n.section, e = n.sn;
                    t ? Mt().animateAnchor ? uo(t, e) : Lo(t, e) : dn.L(gn, null);
                }
                dn.R(Mn, function() {
                    clearTimeout(Uo), clearTimeout(Xo);
                }), dn.R(yn, function() {
                    G("scroll", Qo), r.body.addEventListener("scroll", Qo), dn.R(xn, function(n) {
                        uo(n.Xn, n.slideAnchor);
                    }), dn.R(kn, function(n) {
                        co(n.anchor, void 0);
                    }), dn.R(An, function(n) {
                        ("down" === n.direction ? Hi : Ci)();
                    }), dn.R(En, function(n) {
                        Ue(n.destination);
                    });
                }), dn.R(Mn, function() {
                    U("scroll", Qo);
                }), s.getActiveSlide = function() {
                    return oe(hn().P.activeSlide);
                }, s.getScrollX = function() {
                    return vn.scrollX;
                }, dn.R(yn, function() {
                    dn.R(Mn, ke), dn.R(Rn, function(n) {
                        Ae(n.slides, n.destination);
                    }), dn.R(bn, function(n) {
                        ro(n.section);
                    }), dn.R(wn, function(n) {
                        oo(n.section);
                    });
                }), dn.R(yn, function() {
                    var n = Mt().credits.position, t = [
                        "left",
                        "right"
                    ].indexOf(n) > -1 ? "".concat(n, ": 0;") : "", e = '\n        <div class="fp-watermark" style="'.concat(t, '">\n            <a href="https://alvarotrigo.com/fullPage/" \n                rel="nofollow noopener" \n                target="_blank" \n                style="text-decoration:none; color: #000;">\n                    ').concat(Mt().credits.label, "\n            </a>\n        </div>\n    "), i = rn(vn.N), o = !vn.Kn || Mt().credits.enabled;
                    i && i.item && o && i.item.insertAdjacentHTML("beforeend", e);
                }), function() {
                    dn.R(Sn, function() {
                        var t, l, u;
                        pn({
                            Kn: (Mt().licenseKey, t = Mt().licenseKey, l = function(t) {
                                var e = parseInt("514").toString(16);
                                if (!t || t.length < 29 || 4 === t.split(n[0]).length) return null;
                                var i = [
                                    "Each",
                                    "for"
                                ][o()]().join(""), l = t[[
                                    "split"
                                ]]("-"), u = [];
                                l[i](function(n, t) {
                                    if (t < 4) {
                                        var i = function(n) {
                                            var t = n[n.length - 1], e = [
                                                "NaN",
                                                "is"
                                            ][o()]().join("");
                                            return window[e](t) ? r(t) : function(n) {
                                                return n - Yn.length;
                                            }(t);
                                        }(n);
                                        u.push(i);
                                        var a = r(n[i]);
                                        if (1 === t) {
                                            var l = [
                                                "pa",
                                                "dS",
                                                "t",
                                                "art"
                                            ].join("");
                                            a = a.toString()[l](2, "0");
                                        }
                                        e += a, 0 !== t && 1 !== t || (e += "-");
                                    }
                                });
                                var c = 0, s = "";
                                return t.split("-").forEach(function(n, t) {
                                    if (t < 4) {
                                        for(var e = 0, i = 0; i < 4; i++)i !== u[t] && (e += Math.abs(r(n[i])), isNaN(n[i]) || c++);
                                        var o = a(e);
                                        s += o;
                                    }
                                }), s += a(c), {
                                    qn: new Date(e + "T00:00"),
                                    $n: e.split("-")[2] === 8 * (Yn.length - 2) + "",
                                    nt: s
                                };
                            }(t), u = function(n) {
                                var t = i[o()]().join("");
                                return n && 0 === t.indexOf(n) && n.length === t.length;
                            }(t), (l || u) && (l && e <= l.qn && l.nt === t.split(n[0])[4] || u || l.$n) || !1)
                        });
                    });
                    var n = [
                        "-"
                    ], t = "2023-4-29".split("-"), e = new Date(t[0], t[1], t[2]), i = [
                        "se",
                        "licen",
                        "-",
                        "v3",
                        "l",
                        "gp"
                    ];
                    function o() {
                        return [
                            "re",
                            "verse"
                        ].join("");
                    }
                    function r(n) {
                        return n ? isNaN(n) ? n.charCodeAt(0) - 72 : n : "";
                    }
                    function a(n) {
                        var t = 72 + n;
                        return t > 90 && t < 97 && (t += 15), String.fromCharCode(t).toUpperCase();
                    }
                }(), s.setKeyboardScrolling = Jo, s.shared.tt = qo, s.setAllowScrolling = $o;
                var tr = {};
                function er() {
                    return tr;
                }
                var ir, or, rr, ar, lr = !g($t, Dt("OHNsd3AtZnVsbHBhZ2UtanM5T20="));
                function ur(n) {
                    if (or = r.createElement("div"), ir = Dt("MTIzPGRpdj48YSBocmVmPSJodHRwOi8vYWx2YXJvdHJpZ28uY29tL2Z1bGxQYWdlL2V4dGVuc2lvbnMvIiBzdHlsZT0iY29sb3I6ICNmZmYgIWltcG9ydGFudDsgdGV4dC1kZWNvcmF0aW9uOm5vbmUgIWltcG9ydGFudDsiPlVubGljZW5zZWQgZnVsbFBhZ2UuanMgRXh0ZW5zaW9uPC9hPjwvZGl2PjEyMw=="), lr || (ir = ir.replace("extensions/", "").replace("Extension", "")), or.innerHTML = ir, or = or.firstChild, "MutationObserver" in window && new MutationObserver(sr).observe(r.body, {
                        childList: !0,
                        subtree: !1
                    }), (!lr || kt(n) && s[n]) && (!function(n) {
                        var t = void 0 !== er()[n] && er()[n].length, e = [], i = !1;
                        return k(er()[n]) ? e = er()[n] : e.push(er()[n]), e.forEach(function(e) {
                            var o = function() {
                                if (r.domain.length) {
                                    for(var n = r.domain.replace(/^(www\.)/, "").split("."); n.length > 2;)n.shift();
                                    return n.join(".").replace(/(^\.*)|(\.*$)/g, "");
                                }
                                return "";
                            }(), a = [
                                "MTM0bG9jYWxob3N0MjM0",
                                "MTM0MC4xMjM0",
                                "MTM0anNoZWxsLm5ldDIzNA==",
                                "UDdDQU5ZNlNN",
                                "NTY3YnVuZGxlNzg5",
                                "NTU1S2V5Nzc3",
                                "NDU2dGVzdDQ1Ng=="
                            ], l = Dt(a[0]), u = Dt(a[1]), c = Dt(a[2]), s = Dt(a[6]), f = Dt(a[3]), d = Dt(a[4]), v = Dt(a[5]), p = void 0 !== Mt()[d + v];
                            t = t || p;
                            var h = [
                                l,
                                u,
                                c,
                                s
                            ].indexOf(o) < 0 && 0 !== o.length;
                            if (!t && !p && h) return !1;
                            var g = t ? Dt(e) : "", m = (g = g.split("_")).length > 1 && g[1].indexOf(n, g[1].length - n.length) > -1, w = g.length > 1 && g[1].toLowerCase().indexOf(d) > -1, b = g[0].indexOf(o, g[0].length - o.length) < 0, S = m || w;
                            i = i || !(b && h && f != g[0]) && S || !h;
                        }), i;
                    }(n) || !lr)) {
                        cr();
                        var t = Dt("MzQ1c2V0SW50ZXJ2YWwxMjM=");
                        window[t](cr, 2e3);
                    }
                }
                function cr() {
                    or && (ar || (Math.random() < .5 ? zt($t, or) : L(or, $t), ar = !0), or.setAttribute("style", Dt("MTIzei1pbmRleDo5OTk5OTk5O3Bvc2l0aW9uOmZpeGVkO3RvcDoyMHB4O2JvdHRvbTphdXRvO2xlZnQ6MjBweDtyaWdodDphdXRvO2JhY2tncm91bmQ6cmVkO3BhZGRpbmc6N3B4IDE1cHg7Zm9udC1zaXplOjE0cHg7Zm9udC1mYW1pbHk6YXJpYWw7Y29sb3I6I2ZmZjtkaXNwbGF5OmlubGluZS1ibG9jazt0cmFuc2Zvcm06dHJhbnNsYXRlM2QoMCwwLDApO29wYWNpdHk6MTtoZWlnaHQ6YXV0bzt3aWR0aDphdXRvO3pvb206MTttYXJnaW46YXV0bztib3JkZXI6bm9uZTt2aXNpYmlsaXR5OnZpc2libGU7Y2xpcC1wYXRoOm5vbmU7MTIz").replace(/;/g, Dt("MTIzICFpbXBvcnRhbnQ7MzQ1"))));
                }
                function sr(n) {
                    n.forEach(function(n) {
                        if (n.removedNodes[0] && n.removedNodes[0].isEqualNode(or)) {
                            clearTimeout(rr);
                            var t = Dt("bDIwc2V0VGltZW91dDAzbA==");
                            rr = window[t](fr, 900);
                        }
                    });
                }
                function fr() {
                    ar = !1;
                }
                function dr() {
                    fi(), si(), Mt().scrollBar = Mt().scrollBar || Mt().hybrid, xt(), function() {
                        b(un(yt(), "body"), {
                            height: "100%",
                            position: "relative"
                        }), E(yt(), Wn), E(ne, Gn), pn({
                            q: m()
                        }), R(yt(), Bn), mi(), Et("parallax", "init");
                        for(var n = hn().an, t = 0; t < n.length; t++){
                            var e = n[t], i = e.wn, o = Z(e.item, "style");
                            o && e.item.setAttribute("data-fp-styles", o), ii(e), Ko(e), i.length > 0 && wi(e);
                        }
                        Mt().fixedElements && Mt().css3 && p(Mt().fixedElements).forEach(function(n) {
                            $t.appendChild(n);
                        }), Mt().navigation && Pe(), p('iframe[src*="youtube.com/embed/"]', yt()).forEach(function(n) {
                            var t, e;
                            e = Z(t = n, "src"), t.setAttribute("src", e + (/\?/.test(e) ? "&" : "?") + "enablejsapi=1");
                        }), Et("fadingEffect", "apply"), Et("waterEffect", "init"), Et("dropEffect", "init"), Et("cards", "init"), Mt().scrollOverflow && li.bn();
                    }(), $o(!0), xo(!0), je(Mt().autoScrolling, "internal"), Ke(), se(), "complete" === r.readyState && nr(), G("load", nr), qo(), lr || ur("l"), fi(), si();
                }
                function vr() {
                    var n = Mt().licenseKey;
                    "" === Mt().licenseKey.trim() ? (f("error", "Fullpage.js requires a `licenseKey` option. Read about it on the following URL:"), f("error", "https://github.com/alvarotrigo/fullPage.js#options")) : Mt() && vn.Kn || r.domain.indexOf("alvarotrigo.com") > -1 ? n && n.length : (f("error", "Incorrect `licenseKey`. Get one for fullPage.js version 4 here:"), f("error", "https://alvarotrigo.com/fullPage/pricing")), g(ne, Gn) ? f("error", "Fullpage.js can only be initialized once and you are doing it multiple times!") : (Mt().continuousVertical && (Mt().loopTop || Mt().loopBottom) && (Mt().continuousVertical = !1, f("warn", "Option `loopTop/loopBottom` is mutually exclusive with `continuousVertical`; `continuousVertical` disabled")), !Mt().scrollOverflow || !Mt().scrollBar && Mt().autoScrolling || f("warn", "Options scrollBar:true and autoScrolling:false are mutually exclusive with scrollOverflow:true. Sections with scrollOverflow might not work well in Firefox"), !Mt().continuousVertical || !Mt().scrollBar && Mt().autoScrolling || (Mt().continuousVertical = !1, f("warn", "Scroll bars (`scrollBar:true` or `autoScrolling:false`) are mutually exclusive with `continuousVertical`; `continuousVertical` disabled")), Mt().anchors.forEach(function(n) {
                        var t = [].slice.call(p("[name]")).filter(function(t) {
                            return Z(t, "name") && Z(t, "name").toLowerCase() == n.toLowerCase();
                        }), e = [].slice.call(p("[id]")).filter(function(t) {
                            return Z(t, "id") && Z(t, "id").toLowerCase() == n.toLowerCase();
                        });
                        if (e.length || t.length) {
                            f("error", "data-anchor tags can not have the same value as any `id` element on the site (or `name` element for IE).");
                            var i = e.length ? "id" : "name";
                            (e.length || t.length) && f("error", '"' + n + '" is is being used by another element `' + i + "` property");
                        }
                    }));
                }
                function pr() {
                    return {
                        options: Mt(),
                        internals: {
                            container: yt(),
                            canScroll: vn.canScroll,
                            isScrollAllowed: Se(),
                            getDestinationPosition: Xe,
                            isTouch: u,
                            c: ur,
                            getXmovement: Oe,
                            removeAnimation: Xt,
                            getTransforms: _t,
                            lazyLoad: ce,
                            addAnimation: Yt,
                            performHorizontalMove: xe,
                            landscapeScroll: Ae,
                            silentLandscapeScroll: Re,
                            keepSlidesPosition: ze,
                            silentScroll: Jt,
                            styleSlides: wi,
                            styleSection: ii,
                            scrollHandler: Qo,
                            getEventsPage: no,
                            getMSPointer: to,
                            isReallyTouch: Ki,
                            usingExtension: kt,
                            toggleControlArrows: Me,
                            touchStartHandler: qi,
                            touchMoveHandler: Ji,
                            nullOrSection: ie,
                            items: {
                                SectionPanel: pi,
                                SlidePanel: gi,
                                Item: Pt
                            },
                            getVisible: v,
                            getState: hn,
                            updateState: si,
                            updateStructuralState: fi,
                            activeSlidesNavigation: ge,
                            getPanels: function() {
                                return vn.un;
                            },
                            getSections: function() {
                                return vn.N;
                            },
                            setActiveSection: function(n) {
                                vn.P = n;
                            }
                        }
                    };
                }
                function hr(n) {
                    var t = [
                        "NTY3YnVuZGxlNzg5",
                        "NTU1S2V5Nzc3"
                    ], e = Dt(t[0]), i = Dt(t[1]), o = void 0 !== Mt()[e + i], r = "fp_" + n + "Extension";
                    er()[n] = o ? Mt()[e + i] : Mt()[n + i], s[n] = void 0 !== window[r] ? new window[r] : null, s[n] && s[n].c(n);
                }
                function gr(n, t) {
                    var e;
                    if ($t = p("body")[0], ne = p("html")[0], te = p("html, body"), !g(ne, Gn)) return e = "string" == typeof n ? p(n)[0] : n, gt.touchWrapper = e, function(n) {
                        St = h({}, gt, n), bt = Object.assign({}, St);
                    }(t), function(n) {
                        mt = n;
                    }("string" == typeof n ? p(n)[0] : n), dn.L(Sn), vr(), s.getFullpageData = pr, s.version = "4.0.20", s.test = Object.assign(s.test, {
                        top: "0px",
                        cn: "translate3d(0px, 0px, 0px)",
                        dn: function() {
                            for(var n = [], t = 0; t < p(Mt().sectionSelector, yt()).length; t++)n.push("translate3d(0px, 0px, 0px)");
                            return n;
                        }(),
                        left: function() {
                            for(var n = [], t = 0; t < p(Mt().sectionSelector, yt()).length; t++)n.push(0);
                            return n;
                        }(),
                        options: Mt(),
                        setAutoScrolling: null
                    }), s.shared = Object.assign(s.shared, {
                        tt: null,
                        _n: !1
                    }), o.fullpage_api = s, o.fullpage_extensions = !0, yt() && (dn.L("beforeInit"), hr("continuousHorizontal"), hr("scrollHorizontally"), hr("resetSliders"), hr("interlockedSlides"), hr("responsiveSlides"), hr("fadingEffect"), hr("dragAndMove"), hr("offsetSections"), hr("scrollOverflowReset"), hr("parallax"), hr("cards"), hr("dropEffect"), hr("waterEffect"), Et("dragAndMove", "init"), Et("responsiveSlides", "init"), dr(), dn.L(yn), Et("dragAndMove", "turnOffTouch")), o.fullpage_api;
                    vr();
                }
                return s.destroy = function(n) {
                    _(yt(), "destroy", n), je(!1, "internal"), $o(!0), xo(!1), Jo(!1), E(yt(), Bn), dn.L(Mn), Et("dragAndMove", "destroy"), n && (Jt(0), p("img[data-src], source[data-src], audio[data-src], iframe[data-src]", yt()).forEach(function(n) {
                        ln(n, "src");
                    }), p("img[data-srcset]").forEach(function(n) {
                        ln(n, "srcset");
                    }), q(p("#fp-nav, .fp-slidesNav, .fp-controlArrow")), b(Ht(hn().N), {
                        height: "",
                        "background-color": "",
                        padding: ""
                    }), b(Ht(hn().slides), {
                        width: ""
                    }), b(yt(), {
                        height: "",
                        position: "",
                        "-ms-touch-action": "",
                        "touch-action": ""
                    }), b(te, {
                        overflow: "",
                        height: ""
                    }), R(ne, Gn), R($t, Vn + " fp-scrollable"), $t.className.split(/\s+/).forEach(function(n) {
                        0 === n.indexOf("fp-viewing") && R($t, n);
                    }), Ht(hn().un).forEach(function(n) {
                        Mt().scrollOverflow && li.Nn(n), R(n, "fp-table active fp-completely " + ut);
                        var t = Z(n, "data-fp-styles");
                        t && n.setAttribute("style", t), g(n, _n) && !wt && n.removeAttribute("data-anchor");
                    }), Xt(yt()), [
                        Jn,
                        ot,
                        et
                    ].forEach(function(n) {
                        p(n, yt()).forEach(function(n) {
                            N(n);
                        });
                    }), b(yt(), {
                        "-webkit-transition": "none",
                        transition: "none"
                    }), R(yt(), Wn), o.scrollTo(0, 0), [
                        _n,
                        qn,
                        it
                    ].forEach(function(n) {
                        R(p("." + n), n);
                    }));
                }, o.fp_easings = h(o.fp_easings, {
                    easeInOutCubic: function(n, t, e, i) {
                        return (n /= i / 2) < 1 ? e / 2 * n * n * n + t : e / 2 * ((n -= 2) * n * n + 2) + t;
                    }
                }), o.jQuery && function(n, t) {
                    n && t ? n.fn.fullpage = function(e) {
                        e = n.extend({}, e, {
                            $: n
                        }), new t(this[0], e), Object.keys(s).forEach(function(n) {
                            Mt().$.fn.fullpage[n] = s[n];
                        });
                    } : f("error", "jQuery is required to use the jQuery fullpage adapter!");
                }(o.jQuery, gr), gr;
            });
        /***/ },
        /***/ 239: /***/ ()=>{
            window.fp_easings = {
                def: "easeOutQuad",
                linear: function(n, t, e, u) {
                    return e * n / u + t;
                },
                swing: function(n, t, e, u) {
                    return window.fp_easings[window.fp_easings.def](n, t, e, u);
                },
                easeInQuad: function(n, t, e, u) {
                    return e * (n /= u) * n + t;
                },
                easeOutQuad: function(n, t, e, u) {
                    return -e * (n /= u) * (n - 2) + t;
                },
                easeInOutQuad: function(n, t, e, u) {
                    return (n /= u / 2) < 1 ? e / 2 * n * n + t : -e / 2 * (--n * (n - 2) - 1) + t;
                },
                easeInCubic: function(n, t, e, u) {
                    return e * (n /= u) * n * n + t;
                },
                easeOutCubic: function(n, t, e, u) {
                    return e * ((n = n / u - 1) * n * n + 1) + t;
                },
                easeInOutCubic: function(n, t, e, u) {
                    return (n /= u / 2) < 1 ? e / 2 * n * n * n + t : e / 2 * ((n -= 2) * n * n + 2) + t;
                },
                easeInQuart: function(n, t, e, u) {
                    return e * (n /= u) * n * n * n + t;
                },
                easeOutQuart: function(n, t, e, u) {
                    return -e * ((n = n / u - 1) * n * n * n - 1) + t;
                },
                easeInOutQuart: function(n, t, e, u) {
                    return (n /= u / 2) < 1 ? e / 2 * n * n * n * n + t : -e / 2 * ((n -= 2) * n * n * n - 2) + t;
                },
                easeInQuint: function(n, t, e, u) {
                    return e * (n /= u) * n * n * n * n + t;
                },
                easeOutQuint: function(n, t, e, u) {
                    return e * ((n = n / u - 1) * n * n * n * n + 1) + t;
                },
                easeInOutQuint: function(n, t, e, u) {
                    return (n /= u / 2) < 1 ? e / 2 * n * n * n * n * n + t : e / 2 * ((n -= 2) * n * n * n * n + 2) + t;
                },
                easeInSine: function(n, t, e, u) {
                    return -e * Math.cos(n / u * (Math.PI / 2)) + e + t;
                },
                easeOutSine: function(n, t, e, u) {
                    return e * Math.sin(n / u * (Math.PI / 2)) + t;
                },
                easeInOutSine: function(n, t, e, u) {
                    return -e / 2 * (Math.cos(Math.PI * n / u) - 1) + t;
                },
                easeInExpo: function(n, t, e, u) {
                    return 0 == n ? t : e * Math.pow(2, 10 * (n / u - 1)) + t;
                },
                easeOutExpo: function(n, t, e, u) {
                    return n == u ? t + e : e * (1 - Math.pow(2, -10 * n / u)) + t;
                },
                easeInOutExpo: function(n, t, e, u) {
                    return 0 == n ? t : n == u ? t + e : (n /= u / 2) < 1 ? e / 2 * Math.pow(2, 10 * (n - 1)) + t : e / 2 * (2 - Math.pow(2, -10 * --n)) + t;
                },
                easeInCirc: function(n, t, e, u) {
                    return -e * (Math.sqrt(1 - (n /= u) * n) - 1) + t;
                },
                easeOutCirc: function(n, t, e, u) {
                    return e * Math.sqrt(1 - (n = n / u - 1) * n) + t;
                },
                easeInOutCirc: function(n, t, e, u) {
                    return (n /= u / 2) < 1 ? -e / 2 * (Math.sqrt(1 - n * n) - 1) + t : e / 2 * (Math.sqrt(1 - (n -= 2) * n) + 1) + t;
                },
                easeInElastic: function(n, t, e, u) {
                    var a = 1.70158, r = 0, i = e;
                    if (0 == n) return t;
                    if (1 == (n /= u)) return t + e;
                    if (r || (r = .3 * u), i < Math.abs(e)) {
                        i = e;
                        a = r / 4;
                    } else a = r / (2 * Math.PI) * Math.asin(e / i);
                    return -i * Math.pow(2, 10 * (n -= 1)) * Math.sin((n * u - a) * (2 * Math.PI) / r) + t;
                },
                easeOutElastic: function(n, t, e, u) {
                    var a = 1.70158, r = 0, i = e;
                    if (0 == n) return t;
                    if (1 == (n /= u)) return t + e;
                    if (r || (r = .3 * u), i < Math.abs(e)) {
                        i = e;
                        a = r / 4;
                    } else a = r / (2 * Math.PI) * Math.asin(e / i);
                    return i * Math.pow(2, -10 * n) * Math.sin((n * u - a) * (2 * Math.PI) / r) + e + t;
                },
                easeInOutElastic: function(n, t, e, u) {
                    var a = 1.70158, r = 0, i = e;
                    if (0 == n) return t;
                    if (2 == (n /= u / 2)) return t + e;
                    if (r || (r = u * (.3 * 1.5)), i < Math.abs(e)) {
                        i = e;
                        a = r / 4;
                    } else a = r / (2 * Math.PI) * Math.asin(e / i);
                    return n < 1 ? i * Math.pow(2, 10 * (n -= 1)) * Math.sin((n * u - a) * (2 * Math.PI) / r) * -0.5 + t : i * Math.pow(2, -10 * (n -= 1)) * Math.sin((n * u - a) * (2 * Math.PI) / r) * .5 + e + t;
                },
                easeInBack: function(n, t, e, u, a) {
                    return null == a && (a = 1.70158), e * (n /= u) * n * ((a + 1) * n - a) + t;
                },
                easeOutBack: function(n, t, e, u, a) {
                    return null == a && (a = 1.70158), e * ((n = n / u - 1) * n * ((a + 1) * n + a) + 1) + t;
                },
                easeInOutBack: function(n, t, e, u, a) {
                    return null == a && (a = 1.70158), (n /= u / 2) < 1 ? e / 2 * (n * n * ((1 + (a *= 1.525)) * n - a)) + t : e / 2 * ((n -= 2) * n * ((1 + (a *= 1.525)) * n + a) + 2) + t;
                },
                easeInBounce: function(n, t, e, u) {
                    return e - window.fp_easings.easeOutBounce(u - n, 0, e, u) + t;
                },
                easeOutBounce: function(n, t, e, u) {
                    return (n /= u) < 1 / 2.75 ? e * (7.5625 * n * n) + t : n < 2 / 2.75 ? e * (7.5625 * (n -= 1.5 / 2.75) * n + .75) + t : n < 2.5 / 2.75 ? e * (7.5625 * (n -= 2.25 / 2.75) * n + .9375) + t : e * (7.5625 * (n -= 2.625 / 2.75) * n + .984375) + t;
                },
                easeInOutBounce: function(n, t, e, u) {
                    return n < u / 2 ? .5 * window.fp_easings.easeInBounce(2 * n, 0, e, u) + t : .5 * window.fp_easings.easeOutBounce(2 * n - u, 0, e, u) + .5 * e + t;
                }
            };
        //# sourceMappingURL=easings.min.js.map
        /***/ },
        /***/ 379: /***/ (module1)=>{
            "use strict";
            var stylesInDom = [];
            function getIndexByIdentifier(identifier) {
                var result = -1;
                for(var i = 0; i < stylesInDom.length; i++)if (stylesInDom[i].identifier === identifier) {
                    result = i;
                    break;
                }
                return result;
            }
            function modulesToDom(list, options) {
                var idCountMap = {};
                var identifiers = [];
                for(var i = 0; i < list.length; i++){
                    var item = list[i];
                    var id = options.base ? item[0] + options.base : item[0];
                    var count = idCountMap[id] || 0;
                    var identifier = "".concat(id, " ").concat(count);
                    idCountMap[id] = count + 1;
                    var index = getIndexByIdentifier(identifier);
                    var obj = {
                        css: item[1],
                        media: item[2],
                        sourceMap: item[3]
                    };
                    if (index !== -1) {
                        stylesInDom[index].references++;
                        stylesInDom[index].updater(obj);
                    } else stylesInDom.push({
                        identifier: identifier,
                        updater: addStyle(obj, options),
                        references: 1
                    });
                    identifiers.push(identifier);
                }
                return identifiers;
            }
            function addStyle(obj, options) {
                var api = options.domAPI(options);
                api.update(obj);
                return function updateStyle(newObj) {
                    if (newObj) {
                        if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                        api.update(obj = newObj);
                    } else api.remove();
                };
            }
            module1.exports = function(list, options) {
                options = options || {};
                list = list || [];
                var lastIdentifiers = modulesToDom(list, options);
                return function update(newList) {
                    newList = newList || [];
                    for(var i = 0; i < lastIdentifiers.length; i++){
                        var identifier = lastIdentifiers[i];
                        var index = getIndexByIdentifier(identifier);
                        stylesInDom[index].references--;
                    }
                    var newLastIdentifiers = modulesToDom(newList, options);
                    for(var _i = 0; _i < lastIdentifiers.length; _i++){
                        var _identifier = lastIdentifiers[_i];
                        var _index = getIndexByIdentifier(_identifier);
                        if (stylesInDom[_index].references === 0) {
                            stylesInDom[_index].updater();
                            stylesInDom.splice(_index, 1);
                        }
                    }
                    lastIdentifiers = newLastIdentifiers;
                };
            };
        /***/ },
        /***/ 569: /***/ (module1)=>{
            "use strict";
            var memo = {};
            /* istanbul ignore next  */ function getTarget(target) {
                if (typeof memo[target] === "undefined") {
                    var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself
                    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) try {
                        // This will throw an exception if access to iframe is blocked
                        // due to cross-origin restrictions
                        styleTarget = styleTarget.contentDocument.head;
                    } catch (e) {
                        // istanbul ignore next
                        styleTarget = null;
                    }
                    memo[target] = styleTarget;
                }
                return memo[target];
            }
            /* istanbul ignore next  */ function insertBySelector(insert, style) {
                var target = getTarget(insert);
                if (!target) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                target.appendChild(style);
            }
            module1.exports = insertBySelector;
        /***/ },
        /***/ 216: /***/ (module1)=>{
            "use strict";
            /* istanbul ignore next  */ function insertStyleElement(options) {
                var style = document.createElement("style");
                options.setAttributes(style, options.attributes);
                options.insert(style);
                return style;
            }
            module1.exports = insertStyleElement;
        /***/ },
        /***/ 565: /***/ (module1, __unused_webpack_exports, __webpack_require__)=>{
            "use strict";
            /* istanbul ignore next  */ function setAttributesWithoutAttributes(style) {
                var nonce = (0, __webpack_require__.nc);
                if (nonce) style.setAttribute("nonce", nonce);
            }
            module1.exports = setAttributesWithoutAttributes;
        /***/ },
        /***/ 795: /***/ (module1)=>{
            "use strict";
            /* istanbul ignore next  */ function apply(style, options, obj) {
                var css = obj.css;
                var media = obj.media;
                var sourceMap = obj.sourceMap;
                if (media) style.setAttribute("media", media);
                else style.removeAttribute("media");
                if (sourceMap && typeof btoa !== "undefined") css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
                 // For old IE
                /* istanbul ignore if  */ options.styleTagTransform(css, style);
            }
            function removeStyleElement(style) {
                // istanbul ignore if
                if (style.parentNode === null) return false;
                style.parentNode.removeChild(style);
            }
            /* istanbul ignore next  */ function domAPI(options) {
                var style = options.insertStyleElement(options);
                return {
                    update: function update(obj) {
                        apply(style, options, obj);
                    },
                    remove: function remove() {
                        removeStyleElement(style);
                    }
                };
            }
            module1.exports = domAPI;
        /***/ },
        /***/ 589: /***/ (module1)=>{
            "use strict";
            /* istanbul ignore next  */ function styleTagTransform(css, style) {
                if (style.styleSheet) style.styleSheet.cssText = css;
                else {
                    while(style.firstChild)style.removeChild(style.firstChild);
                    style.appendChild(document.createTextNode(css));
                }
            }
            module1.exports = styleTagTransform;
        /***/ },
        /***/ 497: /***/ (module1)=>{
            "use strict";
            module1.exports = (parcelRequire("jiXHd"));
        /***/ }
    };
    /************************************************************************/ /******/ // The module cache
    /******/ var __webpack_module_cache__ = {};
    /******/ /******/ // The require function
    /******/ function __webpack_require__(moduleId) {
        /******/ // Check if module is in cache
        /******/ var cachedModule = __webpack_module_cache__[moduleId];
        /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
        /******/ // Create a new module (and put it into the cache)
        /******/ var module1 = __webpack_module_cache__[moduleId] = {
            /******/ id: moduleId,
            /******/ // no module.loaded needed
            /******/ exports: {}
        };
        /******/ /******/ // Execute the module function
        /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
        /******/ /******/ // Return the exports of the module
        /******/ return module1.exports;
    /******/ }
    /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ (()=>{
        /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = (module1)=>{
            /******/ var getter = module1 && module1.__esModule ? /******/ ()=>module1['default'] : /******/ ()=>module1;
            /******/ __webpack_require__.d(getter, {
                a: getter
            });
            /******/ return getter;
        /******/ };
    /******/ })();
    /******/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
        /******/ // define getter functions for harmony exports
        /******/ __webpack_require__.d = (exports, definition)=>{
            /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                enumerable: true,
                get: definition[key]
            });
        /******/ };
    /******/ })();
    /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
        /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
    /******/ })();
    /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
        /******/ // define __esModule on exports
        /******/ __webpack_require__.r = (exports)=>{
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
    /******/ })();
    /******/ /************************************************************************/ var __webpack_exports__ = {};
    // This entry need to be wrapped in an IIFE because it need to be in strict mode.
    (()=>{
        "use strict";
        // ESM COMPAT FLAG
        __webpack_require__.r(__webpack_exports__);
        // EXPORTS
        __webpack_require__.d(__webpack_exports__, {
            "default": ()=>/* binding */ components
        });
        // EXTERNAL MODULE: external "react"
        var external_react_ = __webpack_require__(497);
        var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_);
        /* eslint-disable import/no-extraneous-dependencies */ const Wrapper = (_ref)=>{
            let { children: children } = _ref;
            return /*#__PURE__*/ external_react_default().createElement(external_react_.Fragment, null, children);
        }; /* harmony default export */ 
        const components_Wrapper = Wrapper;
        /* eslint-disable */ const windowExists = ()=>{
            if (typeof window === 'undefined') return false;
            try {
                const env = "production".toLowerCase();
                return !env.match(/test/);
            } catch (e) {
                return true;
            }
        }; /* harmony default export */ 
        const components = (()=>{
            let exported;
            if (windowExists()) exported = __webpack_require__(88)/* ["default"] */ .Z;
            else exported = __webpack_require__(882)/* ["default"] */ .Z;
            exported.Wrapper = components_Wrapper;
            return exported;
        })();
    })();
    $7565755634e5a3f9$exports = __webpack_exports__;
/******/ })();




var $23a6f697c7f6d205$exports = {};

$parcel$export($23a6f697c7f6d205$exports, "videosWrapper", function () { return $23a6f697c7f6d205$export$4e25d76aab2d94e6; }, function (v) { return $23a6f697c7f6d205$export$4e25d76aab2d94e6 = v; });
$parcel$export($23a6f697c7f6d205$exports, "videosWrapperInner", function () { return $23a6f697c7f6d205$export$188beace617be6ba; }, function (v) { return $23a6f697c7f6d205$export$188beace617be6ba = v; });
$parcel$export($23a6f697c7f6d205$exports, "container", function () { return $23a6f697c7f6d205$export$34e0f9847d4c02dd; }, function (v) { return $23a6f697c7f6d205$export$34e0f9847d4c02dd = v; });
$parcel$export($23a6f697c7f6d205$exports, "containerRef", function () { return $23a6f697c7f6d205$export$a11e710e11611b11; }, function (v) { return $23a6f697c7f6d205$export$a11e710e11611b11 = v; });
$parcel$export($23a6f697c7f6d205$exports, "arrowWrap", function () { return $23a6f697c7f6d205$export$f47a18c8bbf2941e; }, function (v) { return $23a6f697c7f6d205$export$f47a18c8bbf2941e = v; });
$parcel$export($23a6f697c7f6d205$exports, "arrowFadeIn", function () { return $23a6f697c7f6d205$export$b94d4519e46d48b2; }, function (v) { return $23a6f697c7f6d205$export$b94d4519e46d48b2 = v; });
$parcel$export($23a6f697c7f6d205$exports, "arrow", function () { return $23a6f697c7f6d205$export$f2120bbfa5450bd2; }, function (v) { return $23a6f697c7f6d205$export$f2120bbfa5450bd2 = v; });
var $23a6f697c7f6d205$export$4e25d76aab2d94e6;
var $23a6f697c7f6d205$export$188beace617be6ba;
var $23a6f697c7f6d205$export$34e0f9847d4c02dd;
var $23a6f697c7f6d205$export$a11e710e11611b11;
var $23a6f697c7f6d205$export$f47a18c8bbf2941e;
var $23a6f697c7f6d205$export$b94d4519e46d48b2;
var $23a6f697c7f6d205$export$f2120bbfa5450bd2;
$23a6f697c7f6d205$export$4e25d76aab2d94e6 = "_app-views-Lensed-Videos-_styles__videosWrapper";
$23a6f697c7f6d205$export$188beace617be6ba = "_app-views-Lensed-Videos-_styles__videosWrapperInner";
$23a6f697c7f6d205$export$34e0f9847d4c02dd = "_app-views-Lensed-Videos-_styles__container";
$23a6f697c7f6d205$export$a11e710e11611b11 = "_app-views-Lensed-Videos-_styles__containerRef";
$23a6f697c7f6d205$export$f47a18c8bbf2941e = "_app-views-Lensed-Videos-_styles__arrowWrap";
$23a6f697c7f6d205$export$b94d4519e46d48b2 = "_app-views-Lensed-Videos-_styles__arrowFadeIn";
$23a6f697c7f6d205$export$f2120bbfa5450bd2 = "_app-views-Lensed-Videos-_styles__arrow";



var $jiXHd = parcelRequire("jiXHd");

var $f3ec22ee18c5e765$exports = {};

$parcel$export($f3ec22ee18c5e765$exports, "container", function () { return $f3ec22ee18c5e765$export$34e0f9847d4c02dd; }, function (v) { return $f3ec22ee18c5e765$export$34e0f9847d4c02dd = v; });
$parcel$export($f3ec22ee18c5e765$exports, "videoWrapper", function () { return $f3ec22ee18c5e765$export$b82b8842228620ec; }, function (v) { return $f3ec22ee18c5e765$export$b82b8842228620ec = v; });
$parcel$export($f3ec22ee18c5e765$exports, "ready", function () { return $f3ec22ee18c5e765$export$28ee1007e174a2a6; }, function (v) { return $f3ec22ee18c5e765$export$28ee1007e174a2a6 = v; });
$parcel$export($f3ec22ee18c5e765$exports, "isSkippingMoreThanOneSlide", function () { return $f3ec22ee18c5e765$export$6350555723e7078d; }, function (v) { return $f3ec22ee18c5e765$export$6350555723e7078d = v; });
$parcel$export($f3ec22ee18c5e765$exports, "coverCropReposition", function () { return $f3ec22ee18c5e765$export$d6ec84f534bec45; }, function (v) { return $f3ec22ee18c5e765$export$d6ec84f534bec45 = v; });
$parcel$export($f3ec22ee18c5e765$exports, "hideSecondSlideOnLoop", function () { return $f3ec22ee18c5e765$export$9cbb169b824369ed; }, function (v) { return $f3ec22ee18c5e765$export$9cbb169b824369ed = v; });
$parcel$export($f3ec22ee18c5e765$exports, "hidden", function () { return $f3ec22ee18c5e765$export$73920f18ca706874; }, function (v) { return $f3ec22ee18c5e765$export$73920f18ca706874 = v; });
$parcel$export($f3ec22ee18c5e765$exports, "visible", function () { return $f3ec22ee18c5e765$export$664c6d24e3175067; }, function (v) { return $f3ec22ee18c5e765$export$664c6d24e3175067 = v; });
$parcel$export($f3ec22ee18c5e765$exports, "overlay", function () { return $f3ec22ee18c5e765$export$29dd17c7f3c81c36; }, function (v) { return $f3ec22ee18c5e765$export$29dd17c7f3c81c36 = v; });
$parcel$export($f3ec22ee18c5e765$exports, "active", function () { return $f3ec22ee18c5e765$export$89da14300d534261; }, function (v) { return $f3ec22ee18c5e765$export$89da14300d534261 = v; });
$parcel$export($f3ec22ee18c5e765$exports, "playContainer", function () { return $f3ec22ee18c5e765$export$b0530aae77224e77; }, function (v) { return $f3ec22ee18c5e765$export$b0530aae77224e77 = v; });
$parcel$export($f3ec22ee18c5e765$exports, "playBttn", function () { return $f3ec22ee18c5e765$export$c728575c3797e22d; }, function (v) { return $f3ec22ee18c5e765$export$c728575c3797e22d = v; });
$parcel$export($f3ec22ee18c5e765$exports, "fadeIn", function () { return $f3ec22ee18c5e765$export$82e6205b15e6c637; }, function (v) { return $f3ec22ee18c5e765$export$82e6205b15e6c637 = v; });
var $f3ec22ee18c5e765$export$34e0f9847d4c02dd;
var $f3ec22ee18c5e765$export$b82b8842228620ec;
var $f3ec22ee18c5e765$export$28ee1007e174a2a6;
var $f3ec22ee18c5e765$export$6350555723e7078d;
var $f3ec22ee18c5e765$export$d6ec84f534bec45;
var $f3ec22ee18c5e765$export$9cbb169b824369ed;
var $f3ec22ee18c5e765$export$73920f18ca706874;
var $f3ec22ee18c5e765$export$664c6d24e3175067;
var $f3ec22ee18c5e765$export$29dd17c7f3c81c36;
var $f3ec22ee18c5e765$export$89da14300d534261;
var $f3ec22ee18c5e765$export$b0530aae77224e77;
var $f3ec22ee18c5e765$export$c728575c3797e22d;
var $f3ec22ee18c5e765$export$82e6205b15e6c637;
$f3ec22ee18c5e765$export$34e0f9847d4c02dd = "_app-components-Video-_styles__container";
$f3ec22ee18c5e765$export$b82b8842228620ec = "_app-components-Video-_styles__videoWrapper";
$f3ec22ee18c5e765$export$28ee1007e174a2a6 = "_app-components-Video-_styles__ready";
$f3ec22ee18c5e765$export$6350555723e7078d = "_app-components-Video-_styles__isSkippingMoreThanOneSlide";
$f3ec22ee18c5e765$export$d6ec84f534bec45 = "_app-components-Video-_styles__coverCropReposition";
$f3ec22ee18c5e765$export$9cbb169b824369ed = "_app-components-Video-_styles__hideSecondSlideOnLoop";
$f3ec22ee18c5e765$export$73920f18ca706874 = "_app-components-Video-_styles__hidden";
$f3ec22ee18c5e765$export$664c6d24e3175067 = "_app-components-Video-_styles__visible";
$f3ec22ee18c5e765$export$29dd17c7f3c81c36 = "_app-components-Video-_styles__overlay";
$f3ec22ee18c5e765$export$89da14300d534261 = "_app-components-Video-_styles__active";
$f3ec22ee18c5e765$export$b0530aae77224e77 = "_app-components-Video-_styles__playContainer";
$f3ec22ee18c5e765$export$c728575c3797e22d = "_app-components-Video-_styles__playBttn";
$f3ec22ee18c5e765$export$82e6205b15e6c637 = "_app-components-Video-_styles__fadeIn";



var $jiXHd = parcelRequire("jiXHd");

var $af8515e03594d28d$exports = {};

$parcel$export($af8515e03594d28d$exports, "wrapper", function () { return $af8515e03594d28d$export$cc74dcc53cfce4eb; }, function (v) { return $af8515e03594d28d$export$cc74dcc53cfce4eb = v; });
$parcel$export($af8515e03594d28d$exports, "video", function () { return $af8515e03594d28d$export$5f8d3589eb8441ca; }, function (v) { return $af8515e03594d28d$export$5f8d3589eb8441ca = v; });
$parcel$export($af8515e03594d28d$exports, "poster", function () { return $af8515e03594d28d$export$b840e55573b2d2e7; }, function (v) { return $af8515e03594d28d$export$b840e55573b2d2e7 = v; });
$parcel$export($af8515e03594d28d$exports, "showPoster", function () { return $af8515e03594d28d$export$9923295fd53b46; }, function (v) { return $af8515e03594d28d$export$9923295fd53b46 = v; });
$parcel$export($af8515e03594d28d$exports, "hideVideo", function () { return $af8515e03594d28d$export$b01a3572c4575b57; }, function (v) { return $af8515e03594d28d$export$b01a3572c4575b57 = v; });
var $af8515e03594d28d$export$cc74dcc53cfce4eb;
var $af8515e03594d28d$export$5f8d3589eb8441ca;
var $af8515e03594d28d$export$b840e55573b2d2e7;
var $af8515e03594d28d$export$9923295fd53b46;
var $af8515e03594d28d$export$b01a3572c4575b57;
$af8515e03594d28d$export$cc74dcc53cfce4eb = "_app-components-VideoWrapper-_styles__wrapper";
$af8515e03594d28d$export$5f8d3589eb8441ca = "_app-components-VideoWrapper-_styles__video";
$af8515e03594d28d$export$b840e55573b2d2e7 = "_app-components-VideoWrapper-_styles__poster";
$af8515e03594d28d$export$9923295fd53b46 = "_app-components-VideoWrapper-_styles__showPoster";
$af8515e03594d28d$export$b01a3572c4575b57 = "_app-components-VideoWrapper-_styles__hideVideo";


class $36d87e6ef2269301$var$VideoWrapper extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    static defaultProps = {
        innerRef: ()=>{},
        hidePosterOnPlaying: false
    };
    state = {
        videoReady: false,
        posterReady: false
    };
    componentDidMount() {
    // Auto-play
    // this.play()
    }
    play() {
        let p = this._player.play();
        if (p) p.catch((e)=>{
            if (this.props.hidePosterOnPlaying) this.setState({
                videoReady: false
            });
            if (this.props.onCannotPlay) this.props.onCannotPlay();
        });
    }
    onPosterLoaded = ()=>{
        this.setState({
            posterReady: true
        });
        if (this.props.onPosterLoaded) this.props.onPosterLoaded();
    };
    onLoadedData = ()=>{
        if (!this.props.hidePosterOnPlaying) this.setState({
            videoReady: true
        });
        if (this.props.onLoadedData) this.props.onLoadedData();
    };
    onPlay = ()=>{
        if (this.props.hidePosterOnPlaying) this.setState({
            videoReady: true
        });
        if (this.props.onPlay) this.props.onPlay();
    };
    handleOnEnded = ()=>{
        if (this.props.onEnded) this.props.onEnded();
    };
    render() {
        if (this.props.isCurrent && this._player && this._player.paused) {
            this._player.currentTime = 0;
            this.play();
        } else if (this._player && this.props.isOrigin) this._player.pause();
        let showPoster = this.props.isSkippingMoreThanOneSlide && !this.props.isCurrent && !this.props.isOrigin;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($af8515e03594d28d$exports))).wrapper, this.props.className),
            style: this.props.style,
            ref: (c)=>{
                this._video = c;
            }
        }, (this.props.isCurrentOrNext || this.props.isPrevious || this.props.isOrigin) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("video", {
            width: this.props.width,
            height: this.props.height,
            src: this.props.src,
            muted: true,
            playsInline: true,
            loop: this.props.loop,
            onLoadedData: this.onLoadedData,
            onEnded: ()=>this.handleOnEnded(),
            onPlay: this.onPlay,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($af8515e03594d28d$exports))).video, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($af8515e03594d28d$exports))).hideVideo]: this.props.isSkippingMoreThanOneSlide && !this.props.isCurrent
            }),
            // data-autoplay='true' // fullpagejs can handle play/pause
            ref: (c)=>{
                this._player = c;
                this.props.innerRef(c);
            }
        }), this.props.logoAnimationComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($af8515e03594d28d$exports))).poster, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($af8515e03594d28d$exports))).showPoster]: showPoster
            }),
            src: this.props.poster
        }));
    }
}
var $36d87e6ef2269301$export$2e2bcd8739ae039 = $36d87e6ef2269301$var$VideoWrapper;



const $ef5e9f5377aadda6$var$IS_TOUCH = (0, $e5aa747dbfb4ff26$export$971e5333ff27c622)();
class $ef5e9f5377aadda6$var$Video extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    static defaultProps = {};
    state = {
        ready: false,
        width: 0,
        height: 0,
        over: false,
        cannotPlay: false
    };
    componentDidMount() {
        document.documentElement.classList.add("black");
        window.addEventListener("resize", this.onResize);
        this.resizeTimer = setTimeout(()=>this.onResize(), 500);
        if ($ef5e9f5377aadda6$var$IS_TOUCH) {
            this.open();
            this.iconTimer = setTimeout(()=>this.close(), 1000);
        }
    // if (this.props.audio) bus.on("sound:mute", this.onMuteChange)
    }
    componentDidUpdate(prevProps) {
        if (this.props.isCurrentOrNext !== prevProps.isCurrentOrNext && !this.state.slideHasChanged) this.setState({
            slideHasChanged: true
        });
        else if (this.props.isCurrentOrNext === prevProps.isCurrentOrNext && this.state.slideHasChanged) this.setState({
            slideHasChanged: false
        });
    }
    componentWillUnmount() {
        this._unmounted = true;
        clearTimeout(this.timer);
        clearTimeout(this.iconTimer);
        clearTimeout(this.resizeTimer);
        document.documentElement.classList.remove("black");
        window.removeEventListener("resize", this.onResize);
    }
    onResize = ()=>{
        let rect = this._el.getBoundingClientRect();
        let sizingFunc = this.props.contain ? (0, $e5aa747dbfb4ff26$export$cab8c345dc6d78ad) : (0, $e5aa747dbfb4ff26$export$a5d4d60be2a7d682);
        let dimens;
        if (this.props.coverCropReposition && (0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() && (0, $e5aa747dbfb4ff26$export$5cd843239dff6e53)()) dimens = sizingFunc(this.props.height / this.props.width, rect.height, rect.width);
        else dimens = sizingFunc(this.props.width / this.props.height, rect.width, rect.height);
        this.setState({
            width: dimens[0],
            height: dimens[1]
        });
    };
    onReady = ()=>{
        this.setState({
            ready: true
        });
    };
    open() {
        clearTimeout(this.iconTimer);
        this.setState({
            over: true
        });
    }
    close() {
        this.setState({
            over: false
        });
    }
    onDescToggle = ()=>{
        this.props.onVideoDescToggle();
    };
    onOverlayClick = ()=>{
        this.props.onVideoDescToggle();
    };
    getOffset = ()=>{
        if (window.innerWidth > 600) return "320px";
        return "70px";
    };
    onPlay = ()=>{
        this.setState({
            cannotPlay: false
        });
    };
    onPlayClick = ()=>{
        this._playerWrapper.play();
    };
    onCannotPlay = ()=>{
        if (this._unmounted) return;
        this.setState({
            cannotPlay: true
        });
    };
    render() {
        let wrapperStyle = {
            width: this.state.width + "px",
            height: this.state.height + "px"
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f3ec22ee18c5e765$exports))).container),
            onTouchEnd: this.onTouchEnd,
            ref: (c)=>{
                this._el = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $36d87e6ef2269301$export$2e2bcd8739ae039), {
            style: wrapperStyle,
            src: this.props.src,
            poster: this.props.poster,
            width: this.props.width,
            height: this.props.height,
            innerRef: (c)=>{
                this._player = c;
                if (this.props.innerRef) this.props.innerRef(c);
            },
            ref: (c)=>{
                this._playerWrapper = c;
            },
            onPlay: this.onPlay,
            onEnded: this.props.onEnded,
            onLoadedData: this.onReady,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f3ec22ee18c5e765$exports))).videoWrapper, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($f3ec22ee18c5e765$exports))).coverCropReposition]: this.props.coverCropReposition
            }, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($f3ec22ee18c5e765$exports))).ready]: this.state.ready
            }, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($f3ec22ee18c5e765$exports))).isSkippingMoreThanOneSlide]: this.props.isSkippingMoreThanOneSlide
            }),
            onCannotPlay: this.onCannotPlay,
            isCurrent: this.props.isCurrent,
            isCurrentOrNext: this.props.isCurrentOrNext,
            isPrevious: this.props.isPrevious,
            isSkippingMoreThanOneSlide: this.props.isSkippingMoreThanOneSlide,
            isOrigin: this.props.isOrigin,
            loop: this.props.loop,
            logoAnimationComplete: this.props.logoAnimationComplete,
            coverCropPosition: this.props.coverCropReposition
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f3ec22ee18c5e765$exports))).overlay, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($f3ec22ee18c5e765$exports))).active]: this.state.socialOpen || this.props.descOpen
            }),
            onClick: this.onOverlayClick
        }));
    }
}
var $ef5e9f5377aadda6$export$2e2bcd8739ae039 = $ef5e9f5377aadda6$var$Video;



var $jiXHd = parcelRequire("jiXHd");

var $fbb6fed4c8ea0be8$exports = {};

$parcel$export($fbb6fed4c8ea0be8$exports, "arrow", function () { return $fbb6fed4c8ea0be8$export$f2120bbfa5450bd2; }, function (v) { return $fbb6fed4c8ea0be8$export$f2120bbfa5450bd2 = v; });
var $fbb6fed4c8ea0be8$export$f2120bbfa5450bd2;
$fbb6fed4c8ea0be8$export$f2120bbfa5450bd2 = "_app-components-Arrow-_styles__arrow";


class $dbc9106da083fb2e$var$Arrow extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($fbb6fed4c8ea0be8$exports))).arrow, this.props.className),
            viewBox: "0 0 50.91 26.16"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("polyline", {
            className: "cls-1",
            points: "0.35 0.35 25.46 25.46 50.56 0.35"
        }));
    }
}
var $dbc9106da083fb2e$export$2e2bcd8739ae039 = $dbc9106da083fb2e$var$Arrow;



var $jiXHd = parcelRequire("jiXHd");


var $jiXHd = parcelRequire("jiXHd");


var $05795ace34153bbd$exports = {};

$parcel$export($05795ace34153bbd$exports, "description", function () { return $05795ace34153bbd$export$6d59db4903f20f7d; }, function (v) { return $05795ace34153bbd$export$6d59db4903f20f7d = v; });
$parcel$export($05795ace34153bbd$exports, "animationComplete", function () { return $05795ace34153bbd$export$ceb5ab28ca4b7fa0; }, function (v) { return $05795ace34153bbd$export$ceb5ab28ca4b7fa0 = v; });
$parcel$export($05795ace34153bbd$exports, "open", function () { return $05795ace34153bbd$export$3ce6949f20cea765; }, function (v) { return $05795ace34153bbd$export$3ce6949f20cea765 = v; });
$parcel$export($05795ace34153bbd$exports, "descriptionText", function () { return $05795ace34153bbd$export$5050f8adede8c46c; }, function (v) { return $05795ace34153bbd$export$5050f8adede8c46c = v; });
$parcel$export($05795ace34153bbd$exports, "burger", function () { return $05795ace34153bbd$export$9f42c466da956b3; }, function (v) { return $05795ace34153bbd$export$9f42c466da956b3 = v; });
var $05795ace34153bbd$export$6d59db4903f20f7d;
var $05795ace34153bbd$export$ceb5ab28ca4b7fa0;
var $05795ace34153bbd$export$3ce6949f20cea765;
var $05795ace34153bbd$export$5050f8adede8c46c;
var $05795ace34153bbd$export$9f42c466da956b3;
$05795ace34153bbd$export$6d59db4903f20f7d = "_app-components-Description-_styles__description";
$05795ace34153bbd$export$ceb5ab28ca4b7fa0 = "_app-components-Description-_styles__animationComplete";
$05795ace34153bbd$export$3ce6949f20cea765 = "_app-components-Description-_styles__open";
$05795ace34153bbd$export$5050f8adede8c46c = "_app-components-Description-_styles__descriptionText";
$05795ace34153bbd$export$9f42c466da956b3 = "_app-components-Description-_styles__burger";



const $ea2bb5a257a78fef$var$Burger = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($05795ace34153bbd$exports))).burger),
        viewBox: "0 0 42 18.5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("style", null, '.cls-1{fill:none;stroke:#957a3f;stroke-miterlimit:10;}')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("title", null, "burger2"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
        className: "cls-1",
        x1: "19.03",
        y1: "0.5",
        x2: "3.57",
        y2: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
        className: "cls-1",
        x1: "19.03",
        y1: "6.33",
        y2: "6.33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
        className: "cls-1",
        x1: "19.03",
        y1: "12.17",
        x2: "5.95",
        y2: "12.17"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
        className: "cls-1",
        x1: "19.03",
        y1: "18",
        x2: "2.38",
        y2: "18"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
        className: "cls-1",
        x1: "22.97",
        y1: "0.5",
        x2: "38.43",
        y2: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
        className: "cls-1",
        x1: "22.97",
        y1: "6.33",
        x2: "42",
        y2: "6.33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
        className: "cls-1",
        x1: "22.97",
        y1: "12.17",
        x2: "36.05",
        y2: "12.17"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
        className: "cls-1",
        x1: "22.97",
        y1: "18",
        x2: "39.62",
        y2: "18"
    }));
};
class $ea2bb5a257a78fef$var$Description extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        over: false
    };
    componentDidMount() {
        let delay = 4.25;
        if ((0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)()) delay = 1;
        this._el.style.pointerEvents = 'none';
        this._el.style.opacity = '0';
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._el, {
            opacity: 1,
            duration: .4,
            delay: delay,
            onComplete: this.onCompleteAnimate,
            onCompleteParams: [
                this._el
            ]
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._text, {
            opacity: 1,
            duration: .4,
            delay: delay + 0.25
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._text, {
            color: '#ffffff'
        }, {
            color: '#957a3f',
            duration: 3,
            delay: delay + 0.25 + 0.25
        });
    }
    onCompleteAnimate = (el)=>{
        el.style.pointerEvents = 'auto';
        this.setState({
            animationComplete: true
        });
    };
    onMouseClick = ()=>{
        if ((0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)()) this.props.onDescToggle();
    };
    onMouseEnter = ()=>{
        if (!(0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)()) this.props.onDescToggle();
    };
    onMouseLeave = ()=>{
        if (!(0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)()) this.props.onDescToggle();
    };
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))(this.props.className, (0, (/*@__PURE__*/$parcel$interopDefault($05795ace34153bbd$exports))).description, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($05795ace34153bbd$exports))).open]: this.props.descOpen,
                [(0, (/*@__PURE__*/$parcel$interopDefault($05795ace34153bbd$exports))).animationComplete]: this.state.animationComplete
            }),
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
            onClick: this.onMouseClick,
            ref: (c)=>{
                this._el = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement($ea2bb5a257a78fef$var$Burger, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._text = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($05795ace34153bbd$exports))).descriptionText),
            dangerouslySetInnerHTML: {
                __html: this.props.children
            }
        }));
    }
}
var $ea2bb5a257a78fef$export$2e2bcd8739ae039 = $ea2bb5a257a78fef$var$Description;


var $4c01966dbb3eaa7e$exports = {};

$parcel$export($4c01966dbb3eaa7e$exports, "videoDetail", function () { return $4c01966dbb3eaa7e$export$c6f9e6855ea53600; }, function (v) { return $4c01966dbb3eaa7e$export$c6f9e6855ea53600 = v; });
$parcel$export($4c01966dbb3eaa7e$exports, "open", function () { return $4c01966dbb3eaa7e$export$3ce6949f20cea765; }, function (v) { return $4c01966dbb3eaa7e$export$3ce6949f20cea765 = v; });
$parcel$export($4c01966dbb3eaa7e$exports, "videoDetailRow", function () { return $4c01966dbb3eaa7e$export$a0f26e034030653e; }, function (v) { return $4c01966dbb3eaa7e$export$a0f26e034030653e = v; });
$parcel$export($4c01966dbb3eaa7e$exports, "videoDetailLenses", function () { return $4c01966dbb3eaa7e$export$bae592e93f26cdbc; }, function (v) { return $4c01966dbb3eaa7e$export$bae592e93f26cdbc = v; });
$parcel$export($4c01966dbb3eaa7e$exports, "videoDetailLeft", function () { return $4c01966dbb3eaa7e$export$d33f306bc226b6f2; }, function (v) { return $4c01966dbb3eaa7e$export$d33f306bc226b6f2 = v; });
var $4c01966dbb3eaa7e$export$c6f9e6855ea53600;
var $4c01966dbb3eaa7e$export$3ce6949f20cea765;
var $4c01966dbb3eaa7e$export$a0f26e034030653e;
var $4c01966dbb3eaa7e$export$bae592e93f26cdbc;
var $4c01966dbb3eaa7e$export$d33f306bc226b6f2;
$4c01966dbb3eaa7e$export$c6f9e6855ea53600 = "_app-components-Credit-_styles__videoDetail";
$4c01966dbb3eaa7e$export$3ce6949f20cea765 = "_app-components-Credit-_styles__open";
$4c01966dbb3eaa7e$export$a0f26e034030653e = "_app-components-Credit-_styles__videoDetailRow";
$4c01966dbb3eaa7e$export$bae592e93f26cdbc = "_app-components-Credit-_styles__videoDetailLenses";
$4c01966dbb3eaa7e$export$d33f306bc226b6f2 = "_app-components-Credit-_styles__videoDetailLeft";


//  This component displays the credits for a video
class $591a3184c9ba5f9e$var$Credit extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    render() {
        const { descOpen: descOpen, onLandingPage: onLandingPage, onVideoDescToggle: onVideoDescToggle, credit: credit } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $ea2bb5a257a78fef$export$2e2bcd8739ae039), {
            onDescToggle: onVideoDescToggle,
            descOpen: descOpen,
            onLandingPage: onLandingPage
        }, credit.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c01966dbb3eaa7e$exports))).videoDetail, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($4c01966dbb3eaa7e$exports))).open]: descOpen
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("h3", {
            dangerouslySetInnerHTML: {
                __html: credit.title
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c01966dbb3eaa7e$exports))).videoDetailRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c01966dbb3eaa7e$exports))).videoDetailLeft)
        }, "Lenses"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c01966dbb3eaa7e$exports))).videoDetailLenses)
        }, "Blackwing", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " ", credit.lenses)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c01966dbb3eaa7e$exports))).videoDetailRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c01966dbb3eaa7e$exports))).videoDetailLeft)
        }, "Director"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, credit.director)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c01966dbb3eaa7e$exports))).videoDetailRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c01966dbb3eaa7e$exports))).videoDetailLeft)
        }, "Cinematographer"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, credit.dop)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c01966dbb3eaa7e$exports))).videoDetailRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c01966dbb3eaa7e$exports))).videoDetailLeft)
        }, "Format"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, credit.format))));
    }
}
var $591a3184c9ba5f9e$export$2e2bcd8739ae039 = $591a3184c9ba5f9e$var$Credit;



const $f6b3a4fa27ca8a91$export$8ebae31efd30e025 = `${"https://blackwing7.directus.app"}`;


const $902644c2b34dba62$export$776d1d96e65b96de = "6NL1J-IM037-KYD66-G3SJ9-ULCWN";


// Video dimensions are hardcoded.
const $f956e2716070b9ed$var$VIDEO_HEIGHT = "1080";
const $f956e2716070b9ed$var$VIDEO_WIDTH = "1920";
class $f956e2716070b9ed$var$Videos extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        currentSlide: 0,
        logoAnimationComplete: false,
        videosData: [],
        firstLoad: true
    };
    async componentDidMount() {
        window.addEventListener("resize", this.resizeFullpageNav);
        let delay = 4450;
        if ((0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)()) delay = 1000;
        setTimeout(()=>{
            this.setState({
                logoAnimationComplete: true
            });
        }, delay);
        // video credits need to be fetched before animating navigation dots
        // because the number of dots depends on the number of videos
        await this.fetchVideosData();
        this.revealNavigationDots(delay);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeFullpageNav);
    }
    // fetch video credits from Directus
    fetchVideosData = async ()=>{
        const res = await fetch(`${(0, $f6b3a4fa27ca8a91$export$8ebae31efd30e025)}/items/featured_videos`);
        const parsedVideosData = await res.json();
        this.setState({
            videosData: parsedVideosData.data
        });
    };
    // finds the navigation dots and changes the opacity from 0 to 1
    revealNavigationDots = (delay)=>{
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(document.getElementById("fp-nav"), {
            opacity: 0
        }, {
            opacity: 1,
            delay: delay / 1000
        });
    };
    handleClickNext = ()=>{
        if (this.state.currentSlide < this.state.videosData.length - 1) {
            this.setState({
                currentSlide: this.state.currentSlide + 1
            });
            if (this.props.descOpen) this.props.onVideoDescToggle();
        }
    };
    onLeave = (_origin, destination)=>{
        this.setState({
            currentSlide: destination.index,
            slideHasChanged: this.state.currentSlide !== destination.index,
            firstLoad: false
        });
    };
    resizeFullpageNav = ()=>{
        if ((0, $e5aa747dbfb4ff26$export$971e5333ff27c622)()) {
            const fullpageNav = document.querySelector("#fp-nav");
            if (fullpageNav) fullpageNav.style.height = `${window.innerHeight}!important`;
        }
    };
    render() {
        const { descOpen: descOpen, onVideoDescToggle: onVideoDescToggle, onLandingPage: onLandingPage, landingOnLensed: landingOnLensed } = this.props;
        const { logoAnimationComplete: logoAnimationComplete, currentSlide: currentSlide, videosData: videosData, slideHasChanged: slideHasChanged } = this.state;
        // only try to render fullpage videos if the videos were fetched
        if (videosData.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Fragment, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($23a6f697c7f6d205$exports))).videosWrapper)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($23a6f697c7f6d205$exports))).videosWrapperInner)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7565755634e5a3f9$exports))), {
            licenseKey: (0, $902644c2b34dba62$export$776d1d96e65b96de),
            onLeave: this.onLeave,
            navigation: true,
            credits: {
                enabled: false
            },
            // scrollingSpeed = {15000}
            render: ({ state: state, fullpageApi: fullpageApi })=>{
                // Destructure the state passed down from fullpage.js
                const { destination: destination, origin: origin } = state;
                if (fullpageApi && this.state.firstLoad) fullpageApi.silentMoveTo(1);
                if (fullpageApi) // allow scrolling only after the landing page animations complete
                fullpageApi.setAllowScrolling(logoAnimationComplete);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7565755634e5a3f9$exports))).Wrapper, null, videosData.map((slide, slideIndex)=>{
                    const isCurrent = slideIndex === currentSlide;
                    const isPrevious = slideIndex === currentSlide - 1;
                    const isNext = slideIndex === currentSlide + 1;
                    const isCurrentOrNext = isCurrent || isNext;
                    const isSkippingMoreThanOneSlide = destination && origin && Math.abs(destination.index - origin.index) > 1;
                    // makes sure that the current video pauses when skipping to another slide, as opposed to just disappearing
                    const isOrigin = origin && origin.index === slideIndex;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                        className: "section",
                        key: slideIndex
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($23a6f697c7f6d205$exports))).container)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($23a6f697c7f6d205$exports))).containerRef)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $ef5e9f5377aadda6$export$2e2bcd8739ae039), {
                        ...slide,
                        height: $f956e2716070b9ed$var$VIDEO_HEIGHT,
                        width: $f956e2716070b9ed$var$VIDEO_WIDTH,
                        descOpen: descOpen,
                        onVideoDescToggle: onVideoDescToggle,
                        isPrevious: isPrevious,
                        isCurrent: isCurrent,
                        isCurrentOrNext: isCurrentOrNext,
                        slideHasChanged: slideHasChanged,
                        slideNumber: slideIndex,
                        isSkippingMoreThanOneSlide: isSkippingMoreThanOneSlide,
                        isOrigin: isOrigin,
                        onLandingPage: onLandingPage,
                        logoAnimationComplete: logoAnimationComplete,
                        onEnded: ()=>{
                            if (isCurrent && destination && destination.isLast) fullpageApi.moveTo(1) // first slide
                            ;
                            else if (isCurrent) fullpageApi.moveSectionDown();
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $591a3184c9ba5f9e$export$2e2bcd8739ae039), {
                        onVideoDescToggle: onVideoDescToggle,
                        descOpen: descOpen,
                        landingOnLensed: landingOnLensed,
                        credit: slide,
                        currentSlide: currentSlide
                    })), (destination && !destination.isLast || !destination) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", {
                        onClick: ()=>{
                            this.handleClickNext();
                            fullpageApi.moveSectionDown();
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($23a6f697c7f6d205$exports))).arrowWrap, {
                            [(0, (/*@__PURE__*/$parcel$interopDefault($23a6f697c7f6d205$exports))).arrowFadeIn]: this.state.logoAnimationComplete
                        })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $dbc9106da083fb2e$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($23a6f697c7f6d205$exports))).arrow
                    }))));
                }));
            }
        }))));
    }
}
var $f956e2716070b9ed$export$2e2bcd8739ae039 = (0, $29c0cf2e84800dc5$export$2e2bcd8739ae039)($f956e2716070b9ed$var$Videos);



var $jiXHd = parcelRequire("jiXHd");


var $jiXHd = parcelRequire("jiXHd");

var $ePVXJ = parcelRequire("ePVXJ");


var $jiXHd = parcelRequire("jiXHd");

var $ePVXJ = parcelRequire("ePVXJ");


var $a95e5bd931a583da$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $a95e5bd931a583da$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $a95e5bd931a583da$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a95e5bd931a583da$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a95e5bd931a583da$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a95e5bd931a583da$var$isModifiedEvent = function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
/**
 * The public API for rendering a history-aware <a>.
 */ var $a95e5bd931a583da$var$Link = function(_React$Component) {
    $a95e5bd931a583da$var$_inherits(Link, _React$Component);
    function Link() {
        var _temp, _this, _ret;
        $a95e5bd931a583da$var$_classCallCheck(this, Link);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $a95e5bd931a583da$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            !_this.props.target && // let browser handle "target=_blank" etc.
            !$a95e5bd931a583da$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                var history = _this.context.router.history;
                var _this$props = _this.props, replace = _this$props.replace, to = _this$props.to;
                if (replace) history.replace(to);
                else history.push(to);
            }
        }, _temp), $a95e5bd931a583da$var$_possibleConstructorReturn(_this, _ret);
    }
    Link.prototype.render = function render() {
        var _props = this.props, replace = _props.replace, to = _props.to, innerRef = _props.innerRef, props = $a95e5bd931a583da$var$_objectWithoutProperties(_props, [
            "replace",
            "to",
            "innerRef"
        ]); // eslint-disable-line no-unused-vars
        (0, (/*@__PURE__*/$parcel$interopDefault($1595ade849514d51$exports)))(this.context.router, "You should not use <Link> outside a <Router>");
        (0, (/*@__PURE__*/$parcel$interopDefault($1595ade849514d51$exports)))(to !== undefined, 'You must specify the "to" property');
        var history = this.context.router.history;
        var location = typeof to === "string" ? (0, $18d2ccbe4875bc55$export$90c043f1c57770b8)(to, null, null, history.location) : to;
        var href = history.createHref(location);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", $a95e5bd931a583da$var$_extends({}, props, {
            onClick: this.handleClick,
            href: href,
            ref: innerRef
        }));
    };
    return Link;
}((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component);
$a95e5bd931a583da$var$Link.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).bool,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object
    ]).isRequired,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func
    ])
};
$a95e5bd931a583da$var$Link.defaultProps = {
    replace: false
};
$a95e5bd931a583da$var$Link.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func.isRequired,
            createHref: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func.isRequired
        }).isRequired
    }).isRequired
};
var $a95e5bd931a583da$export$2e2bcd8739ae039 = $a95e5bd931a583da$var$Link;


var $050314eceb27ab38$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $050314eceb27ab38$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $050314eceb27ab38$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $050314eceb27ab38$var$NavLink = function NavLink(_ref) {
    var to = _ref.to, exact = _ref.exact, strict = _ref.strict, location = _ref.location, activeClassName = _ref.activeClassName, className = _ref.className, activeStyle = _ref.activeStyle, style = _ref.style, getIsActive = _ref.isActive, ariaCurrent = _ref["aria-current"], rest = $050314eceb27ab38$var$_objectWithoutProperties(_ref, [
        "to",
        "exact",
        "strict",
        "location",
        "activeClassName",
        "className",
        "activeStyle",
        "style",
        "isActive",
        "aria-current"
    ]);
    var path = (typeof to === "undefined" ? "undefined" : $050314eceb27ab38$var$_typeof(to)) === "object" ? to.pathname : to;
    // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    return (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
        path: escapedPath,
        exact: exact,
        strict: strict,
        location: location,
        children: function children(_ref2) {
            var location = _ref2.location, match = _ref2.match;
            var isActive = !!(getIsActive ? getIsActive(match, location) : match);
            return (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $a95e5bd931a583da$export$2e2bcd8739ae039), $050314eceb27ab38$var$_extends({
                to: to,
                className: isActive ? [
                    className,
                    activeClassName
                ].filter(function(i) {
                    return i;
                }).join(" ") : className,
                style: isActive ? $050314eceb27ab38$var$_extends({}, style, activeStyle) : style,
                "aria-current": isActive && ariaCurrent || null
            }, rest));
        }
    });
};
$050314eceb27ab38$var$NavLink.propTypes = {
    to: (0, $a95e5bd931a583da$export$2e2bcd8739ae039).propTypes.to,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).bool,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object,
    activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
    activeStyle: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func,
    "aria-current": (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).oneOf([
        "page",
        "step",
        "location",
        "date",
        "time",
        "true"
    ])
};
$050314eceb27ab38$var$NavLink.defaultProps = {
    activeClassName: "active",
    "aria-current": "page"
};
var $050314eceb27ab38$export$2e2bcd8739ae039 = $050314eceb27ab38$var$NavLink;




var $87ccb540bf205d9c$exports = {};

$parcel$export($87ccb540bf205d9c$exports, "navigation", function () { return $87ccb540bf205d9c$export$428e7c787d57587d; }, function (v) { return $87ccb540bf205d9c$export$428e7c787d57587d = v; });
$parcel$export($87ccb540bf205d9c$exports, "hidden", function () { return $87ccb540bf205d9c$export$73920f18ca706874; }, function (v) { return $87ccb540bf205d9c$export$73920f18ca706874 = v; });
$parcel$export($87ccb540bf205d9c$exports, "logoT", function () { return $87ccb540bf205d9c$export$92c6d95b99150201; }, function (v) { return $87ccb540bf205d9c$export$92c6d95b99150201 = v; });
$parcel$export($87ccb540bf205d9c$exports, "logoAnimations", function () { return $87ccb540bf205d9c$export$cda85f9e23cf517d; }, function (v) { return $87ccb540bf205d9c$export$cda85f9e23cf517d = v; });
$parcel$export($87ccb540bf205d9c$exports, "item", function () { return $87ccb540bf205d9c$export$7061c75fc5af8b7e; }, function (v) { return $87ccb540bf205d9c$export$7061c75fc5af8b7e = v; });
$parcel$export($87ccb540bf205d9c$exports, "active", function () { return $87ccb540bf205d9c$export$89da14300d534261; }, function (v) { return $87ccb540bf205d9c$export$89da14300d534261 = v; });
$parcel$export($87ccb540bf205d9c$exports, "navMobile", function () { return $87ccb540bf205d9c$export$3a2707b50c3b4a73; }, function (v) { return $87ccb540bf205d9c$export$3a2707b50c3b4a73 = v; });
$parcel$export($87ccb540bf205d9c$exports, "navMobileArea", function () { return $87ccb540bf205d9c$export$292959d476ae1115; }, function (v) { return $87ccb540bf205d9c$export$292959d476ae1115 = v; });
$parcel$export($87ccb540bf205d9c$exports, "navMobileButton", function () { return $87ccb540bf205d9c$export$fc360f8a08579374; }, function (v) { return $87ccb540bf205d9c$export$fc360f8a08579374 = v; });
$parcel$export($87ccb540bf205d9c$exports, "mobileOpen", function () { return $87ccb540bf205d9c$export$cd5619cf55a4b54e; }, function (v) { return $87ccb540bf205d9c$export$cd5619cf55a4b54e = v; });
$parcel$export($87ccb540bf205d9c$exports, "logoTribeNav", function () { return $87ccb540bf205d9c$export$64cfa52d45f5e4c3; }, function (v) { return $87ccb540bf205d9c$export$64cfa52d45f5e4c3 = v; });
var $87ccb540bf205d9c$export$428e7c787d57587d;
var $87ccb540bf205d9c$export$73920f18ca706874;
var $87ccb540bf205d9c$export$92c6d95b99150201;
var $87ccb540bf205d9c$export$cda85f9e23cf517d;
var $87ccb540bf205d9c$export$7061c75fc5af8b7e;
var $87ccb540bf205d9c$export$89da14300d534261;
var $87ccb540bf205d9c$export$3a2707b50c3b4a73;
var $87ccb540bf205d9c$export$292959d476ae1115;
var $87ccb540bf205d9c$export$fc360f8a08579374;
var $87ccb540bf205d9c$export$cd5619cf55a4b54e;
var $87ccb540bf205d9c$export$64cfa52d45f5e4c3;
$87ccb540bf205d9c$export$428e7c787d57587d = "_app-components-Navigation-_styles__navigation";
$87ccb540bf205d9c$export$73920f18ca706874 = "_app-components-Navigation-_styles__hidden";
$87ccb540bf205d9c$export$92c6d95b99150201 = "_app-components-Navigation-_styles__logoT";
$87ccb540bf205d9c$export$cda85f9e23cf517d = "_app-components-Navigation-_styles__logoAnimations";
$87ccb540bf205d9c$export$7061c75fc5af8b7e = "_app-components-Navigation-_styles__item";
$87ccb540bf205d9c$export$89da14300d534261 = "_app-components-Navigation-_styles__active";
$87ccb540bf205d9c$export$3a2707b50c3b4a73 = "_app-components-Navigation-_styles__navMobile";
$87ccb540bf205d9c$export$292959d476ae1115 = "_app-components-Navigation-_styles__navMobileArea";
$87ccb540bf205d9c$export$fc360f8a08579374 = "_app-components-Navigation-_styles__navMobileButton";
$87ccb540bf205d9c$export$cd5619cf55a4b54e = "_app-components-Navigation-_styles__mobileOpen";
$87ccb540bf205d9c$export$64cfa52d45f5e4c3 = "_app-components-Navigation-_styles__logoTribeNav";



var $jiXHd = parcelRequire("jiXHd");

var $dfd261e8e83f5c29$exports = {};

$parcel$export($dfd261e8e83f5c29$exports, "logo", function () { return $dfd261e8e83f5c29$export$db3c28d99448dcff; }, function (v) { return $dfd261e8e83f5c29$export$db3c28d99448dcff = v; });
var $dfd261e8e83f5c29$export$db3c28d99448dcff;
$dfd261e8e83f5c29$export$db3c28d99448dcff = "_app-components-LogoT-_styles__logo";




class $872c63a65b67d0e2$var$LogoT extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }
    onResize = ()=>{
        this.forceUpdate();
    };
    componentDidMount() {
        window.addEventListener("resize", this.onResize);
        // when optimizing, maybe try to disable glow selectively
        if (this.props.animated) {
            (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._topPath, {}, {
                delay: .3,
                onStart: this.topAnimate,
                onStartParams: [
                    this._topPath
                ]
            });
            (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._circlePath, {}, {
                delay: .3,
                onStart: this.circleAnimate,
                onStartParams: [
                    this._circlePath
                ]
            });
            (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._topPath, {}, {
                delay: 3.5,
                onStart: this.topAnimateOut,
                onStartParams: [
                    this._topPath
                ]
            });
            (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._circlePath, {}, {
                delay: 3.5,
                onStart: this.circleAnimateOut,
                onStartParams: [
                    this._circlePath
                ]
            });
        } else if (this.props.inquireAnimation) {
            (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._topPath, {}, {
                delay: .3,
                onStart: this.topAnimate,
                onStartParams: [
                    this._topPath
                ]
            });
            (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._circlePath, {}, {
                delay: .3,
                onStart: this.circleAnimate,
                onStartParams: [
                    this._circlePath
                ]
            });
        }
    }
    topAnimate(el) {
        el.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($dfd261e8e83f5c29$exports))).topAnimating));
    }
    topAnimateOut(el) {
        el.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($dfd261e8e83f5c29$exports))).topAnimating));
    }
    circleAnimate(el) {
        el.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($dfd261e8e83f5c29$exports))).circleAnimating));
    }
    circleAnimateOut(el) {
        el.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($dfd261e8e83f5c29$exports))).circleAnimating));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
            viewBox: "0 0 212.24 106.19",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($dfd261e8e83f5c29$exports))).logo, this.props.className, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($dfd261e8e83f5c29$exports))).hidden]: this.props.animated || this.props.inquireAnimation
            }),
            alt: "Tribe7 logo",
            ref: (c)=>{
                this._el = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("filter", {
            id: "sofGlow",
            height: "300%",
            width: "300%",
            x: "-75%",
            y: "-75%"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("feMorphology", {
            operator: "dilate",
            radius: "2",
            in: "SourceAlpha",
            result: "thicken"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("feGaussianBlur", {
            in: "thicken",
            stdDeviation: "2",
            result: "blurred"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("feFlood", {
            floodColor: "rgba(255,255,255,.2)",
            result: "glowColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("feComposite", {
            in: "glowColor",
            in2: "blurred",
            operator: "in",
            result: "softGlow_colored"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("feMerge", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("feMergeNode", {
            in: "softGlow_colored"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("feMergeNode", {
            in: "SourceGraphic"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("path", {
            filter: (0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() ? "" : "url(#sofGlow)",
            ref: (c)=>{
                this._topPath = c;
            },
            style: {
                willChange: 'transform'
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($dfd261e8e83f5c29$exports))).topPath),
            d: "M0,0v0.25c4.82,11.03,11.3,21.17,19.14,30.09h173.85c7.9-8.99,14.43-19.21,19.25-30.34H0z"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("path", {
            filter: (0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() ? "" : "url(#sofGlow)",
            ref: (c)=>{
                this._circlePath = c;
            },
            style: {
                willChange: 'transform'
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($dfd261e8e83f5c29$exports))).circlePath),
            d: "M136.46,75.85 c0,16.76-13.58,30.34-30.34,30.34S75.78,92.6,75.78,75.85s13.58-30.34,30.34-30.34S136.46,59.09,136.46,75.85"
        }))));
    }
}
var $872c63a65b67d0e2$export$2e2bcd8739ae039 = $872c63a65b67d0e2$var$LogoT;



var $jiXHd = parcelRequire("jiXHd");

var $48761e7ff36011e3$exports = {};

$parcel$export($48761e7ff36011e3$exports, "logo", function () { return $48761e7ff36011e3$export$db3c28d99448dcff; }, function (v) { return $48761e7ff36011e3$export$db3c28d99448dcff = v; });
$parcel$export($48761e7ff36011e3$exports, "hover", function () { return $48761e7ff36011e3$export$3f60957f5dbf3876; }, function (v) { return $48761e7ff36011e3$export$3f60957f5dbf3876 = v; });
$parcel$export($48761e7ff36011e3$exports, "landingOnLensed", function () { return $48761e7ff36011e3$export$6de6ca95c418d612; }, function (v) { return $48761e7ff36011e3$export$6de6ca95c418d612 = v; });
var $48761e7ff36011e3$export$db3c28d99448dcff;
var $48761e7ff36011e3$export$3f60957f5dbf3876;
var $48761e7ff36011e3$export$6de6ca95c418d612;
$48761e7ff36011e3$export$db3c28d99448dcff = "_app-components-LogoTribe-_styles__logo";
$48761e7ff36011e3$export$3f60957f5dbf3876 = "_app-components-LogoTribe-_styles__hover";
$48761e7ff36011e3$export$6de6ca95c418d612 = "_app-components-LogoTribe-_styles__landingOnLensed";




var $jiXHd = parcelRequire("jiXHd");
const $f51df0133a591ab7$var$Logo = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
        viewBox: "0 0 53.679 36",
        alt: "Tribe7 logo",
        title: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("path", {
        d: "M47.953,30.274a17.248,17.248,0,0,1-12.274,5.084,17.614,17.614,0,0,1-3.125-.28,18.016,18.016,0,0,0,0-34.156,17.521,17.521,0,0,1,3.125-.28A17.358,17.358,0,0,1,47.953,30.274m-42.227,0A17.358,17.358,0,0,1,18,.642a17.513,17.513,0,0,1,3.125.28,18.016,18.016,0,0,0,0,34.156,17.606,17.606,0,0,1-3.125.28A17.248,17.248,0,0,1,5.726,30.274M26.839,2.311A17.7,17.7,0,0,0,23.714.922a17.584,17.584,0,0,1,6.251,0,17.744,17.744,0,0,0-3.126,1.389m.641,31a18.142,18.142,0,0,0,3.248-2.58,18,18,0,0,0,0-25.456,18.142,18.142,0,0,0-3.248-2.58,17.115,17.115,0,0,1,3.779-1.484,17.363,17.363,0,0,1,7.854,29.066,17.254,17.254,0,0,1-7.854,4.518,17.115,17.115,0,0,1-3.779-1.484M22.951,5.272a18,18,0,0,0,0,25.456,18.142,18.142,0,0,0,3.248,2.58,17.115,17.115,0,0,1-3.779,1.484A17.363,17.363,0,0,1,14.566,5.726,17.254,17.254,0,0,1,22.42,1.208,17.115,17.115,0,0,1,26.2,2.692a18.142,18.142,0,0,0-3.248,2.58M18.325,17.679a17.245,17.245,0,0,1,5.08-11.953,17.51,17.51,0,0,1,3.434-2.672,17.487,17.487,0,0,1,3.435,2.672,17.237,17.237,0,0,1,5.08,11.953ZM26.518,32.75a17.52,17.52,0,0,1-3.113-2.476,17.245,17.245,0,0,1-5.08-11.953h8.193Zm.643-14.429h8.193a17.237,17.237,0,0,1-5.08,11.953,17.52,17.52,0,0,1-3.113,2.476Zm-.322,17.037a17.614,17.614,0,0,1-3.125-.28,17.775,17.775,0,0,0,3.125-1.389,17.817,17.817,0,0,0,3.126,1.389,17.617,17.617,0,0,1-3.126.28M48.407,5.272A17.882,17.882,0,0,0,35.679,0H18A18,18,0,0,0,5.272,30.728,17.882,17.882,0,0,0,18,36H35.736A18,18,0,0,0,48.407,5.272"
    })));
var $f51df0133a591ab7$export$2e2bcd8739ae039 = $f51df0133a591ab7$var$Logo;


class $fd7a96e2a03b7dc9$var$LogoTribe extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {
        if (this.props.landingOnLensed) (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._el, {
            opacity: .6,
            duration: .3,
            delay: 4.9
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "https://7isatribe.com/",
            target: "_blank",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($48761e7ff36011e3$exports))).logo, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($48761e7ff36011e3$exports))).landingOnLensed]: this.props.landingOnLensed
            }, this.props.className),
            ref: (c)=>{
                this._el = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f51df0133a591ab7$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($48761e7ff36011e3$exports))).hover
        }, "TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7")));
    }
}
var $fd7a96e2a03b7dc9$export$2e2bcd8739ae039 = $fd7a96e2a03b7dc9$var$LogoTribe;



var $jiXHd = parcelRequire("jiXHd");

var $01cbee2008dacdc1$exports = {};

$parcel$export($01cbee2008dacdc1$exports, "logo", function () { return $01cbee2008dacdc1$export$db3c28d99448dcff; }, function (v) { return $01cbee2008dacdc1$export$db3c28d99448dcff = v; });
$parcel$export($01cbee2008dacdc1$exports, "svg", function () { return $01cbee2008dacdc1$export$7ed1367e7fa1ad68; }, function (v) { return $01cbee2008dacdc1$export$7ed1367e7fa1ad68 = v; });
var $01cbee2008dacdc1$export$db3c28d99448dcff;
var $01cbee2008dacdc1$export$7ed1367e7fa1ad68;
$01cbee2008dacdc1$export$db3c28d99448dcff = "_app-components-IconX-_styles__logo";
$01cbee2008dacdc1$export$7ed1367e7fa1ad68 = "_app-components-IconX-_styles__svg";


class $a236a42500d6f7c3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($01cbee2008dacdc1$exports))).svg,
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 39.599 39.599"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
            x1: "0.708",
            y1: "0.707",
            x2: "38.892",
            y2: "38.891"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
            x1: "0.707",
            y1: "38.892",
            x2: "38.891",
            y2: "0.708"
        })));
    }
}


class $e210a18e449d81cc$var$Navigation extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        mobileOpen: false
    };
    componentDidMount() {
        window.addEventListener("resize", this.onResize);
        this.animateNavComponent();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }
    onResize = ()=>{
        this.toggleDesktopMobileNav();
    };
    // change menu opacity for mobile & desktop when the window is resized
    toggleDesktopMobileNav = ()=>{
        const navDesktop = document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item}`);
        const navMobile = document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navMobile}`);
        if ((0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)()) {
            navDesktop.forEach((e)=>e.style.opacity = "0");
            navMobile.forEach((e)=>e.style.opacity = "1");
        } else {
            navDesktop.forEach((e)=>e.style.opacity = "1");
            navMobile.forEach((e)=>e.style.opacity = "0");
        }
    };
    animateNavComponent = ()=>{
        if (this.props.logoAnimating) {
            let tl = (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline();
            if ((0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)()) {
                let el = [].slice.call(document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navMobile}`));
                tl.to(el, {
                    opacity: 1,
                    duration: 0.4,
                    delay: 5
                });
            } else {
                // load all the nav items, convert Nodelist to array
                let els = [].slice.call(this._el.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item}`));
                tl.to(els, {
                    opacity: 1,
                    duration: .3,
                    stagger: {
                        amount: .2
                    },
                    delay: 1.4
                });
            }
        }
    };
    handleMobileClick = ()=>{
        if (this.state.mobileOpen) {
            (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline().to(document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navMobile} ul`), {
                opacity: 0,
                duration: 0.3
            }).to(document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navMobile} li`), {
                opacity: 0,
                duration: 0,
                delay: 0.1
            });
            this.closeTimer = setTimeout(()=>{
                this.setState({
                    mobileOpen: false
                });
            }, 310);
        } else {
            (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline().to(document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navMobile} ul`), {
                opacity: 1,
                duration: 0.3
            }).to(document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navMobile} li`), {
                opacity: 1,
                duration: 0.3,
                stagger: {
                    amount: 0.2
                },
                delay: -0.3
            });
            this.setState({
                mobileOpen: true
            });
        }
    };
    render() {
        if (this.props.hideLinks) {
            if (!(0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navigation, {
                    [(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).hidden]: this.props.descOpen,
                    [(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).logoAnimations]: this.props.logoAnimating
                }),
                ref: (c)=>{
                    this._el = c;
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item),
                activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
                exact: true,
                to: "/"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $872c63a65b67d0e2$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).logoT, (0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item)
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navMobile, {
                    [(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).hidden]: this.props.descOpen,
                    [(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).logoAnimations]: this.props.logoAnimating,
                    [(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).mobileOpen]: this.state.mobileOpen
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navMobileArea)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $872c63a65b67d0e2$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).logoT)
            }))));
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navigation, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).hidden]: this.props.descOpen,
                [(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).logoAnimations]: this.props.logoAnimating
            }),
            ref: (c)=>{
                this._el = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item),
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            exact: true,
            to: "/"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $872c63a65b67d0e2$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).logoT, (0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item),
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/lenses"
        }, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item),
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/lensrange"
        }, "LENS RANGE")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item),
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/tuning"
        }, "TUNING")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item),
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/specs"
        }, "SPECS")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item),
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/credits"
        }, "CREDITS")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item),
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/obscura"
        }, "OBSCURA", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "37"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).item),
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/contact"
        }, "CONTACT")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navMobile, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).hidden]: this.props.descOpen,
                [(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).logoAnimations]: this.props.logoAnimating,
                [(0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).mobileOpen]: this.state.mobileOpen
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navMobileArea)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $872c63a65b67d0e2$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).logoT)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).navMobileButton,
            onClick: this.handleMobileClick
        }, this.state.mobileOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $a236a42500d6f7c3$export$2e2bcd8739ae039), null) : "\uFF1D")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            exact: true,
            to: "/"
        }, "FEATURED")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/lenses"
        }, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/lensrange"
        }, "LENS RANGE")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/tuning"
        }, "TUNING")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/specs"
        }, "SPECS")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/credits"
        }, "CREDITS")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/obscura"
        }, "OBSCURA", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "37"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).active),
            to: "/contact"
        }, "CONTACT")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($87ccb540bf205d9c$exports))).logoTribeNav
        })))));
    }
}
var $e210a18e449d81cc$export$2e2bcd8739ae039 = (0, $29c0cf2e84800dc5$export$2e2bcd8739ae039)($e210a18e449d81cc$var$Navigation);





var $ePVXJ = parcelRequire("ePVXJ");
var $b0653fa1fdae7494$exports = {};
'use strict';
function $b0653fa1fdae7494$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $jiXHd = parcelRequire("jiXHd");
var $b0653fa1fdae7494$var$React__default = $b0653fa1fdae7494$var$_interopDefault($jiXHd);
function $b0653fa1fdae7494$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b0653fa1fdae7494$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $b0653fa1fdae7494$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $b0653fa1fdae7494$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $b0653fa1fdae7494$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $b0653fa1fdae7494$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($jiXHd.PureComponent);
        $b0653fa1fdae7494$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $b0653fa1fdae7494$var$_defineProperty(SideEffect, "canUseDOM", $b0653fa1fdae7494$var$canUseDOM);
        return SideEffect;
    };
}
$b0653fa1fdae7494$exports = $b0653fa1fdae7494$var$withSideEffect;


var $828557725e2375de$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $828557725e2375de$var$hasElementType = typeof Element !== 'undefined';
var $828557725e2375de$var$hasMap = typeof Map === 'function';
var $828557725e2375de$var$hasSet = typeof Set === 'function';
var $828557725e2375de$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $828557725e2375de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$828557725e2375de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($828557725e2375de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$828557725e2375de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($828557725e2375de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($828557725e2375de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($828557725e2375de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$828557725e2375de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$828557725e2375de$exports = function isEqual(a, b) {
    try {
        return $828557725e2375de$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $jiXHd = parcelRequire("jiXHd");

var $lT6GZ = parcelRequire("lT6GZ");
var $f7489db668f41cb3$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $f7489db668f41cb3$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $f7489db668f41cb3$var$VALID_TAG_NAMES = Object.keys($f7489db668f41cb3$var$TAG_NAMES).map(function(name) {
    return $f7489db668f41cb3$var$TAG_NAMES[name];
});
var $f7489db668f41cb3$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $f7489db668f41cb3$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $f7489db668f41cb3$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $f7489db668f41cb3$var$HTML_TAG_MAP = Object.keys($f7489db668f41cb3$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$f7489db668f41cb3$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $f7489db668f41cb3$var$SELF_CLOSING_TAGS = [
    $f7489db668f41cb3$var$TAG_NAMES.NOSCRIPT,
    $f7489db668f41cb3$var$TAG_NAMES.SCRIPT,
    $f7489db668f41cb3$var$TAG_NAMES.STYLE
];
var $f7489db668f41cb3$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $f7489db668f41cb3$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $f7489db668f41cb3$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $f7489db668f41cb3$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $f7489db668f41cb3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f7489db668f41cb3$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $f7489db668f41cb3$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $f7489db668f41cb3$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $f7489db668f41cb3$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $f7489db668f41cb3$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $f7489db668f41cb3$var$getInnermostProperty(propsList, $f7489db668f41cb3$var$TAG_NAMES.TITLE);
    var innermostTemplate = $f7489db668f41cb3$var$getInnermostProperty(propsList, $f7489db668f41cb3$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $f7489db668f41cb3$var$getInnermostProperty(propsList, $f7489db668f41cb3$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $f7489db668f41cb3$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $f7489db668f41cb3$var$getInnermostProperty(propsList, $f7489db668f41cb3$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $f7489db668f41cb3$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $f7489db668f41cb3$var$_extends({}, tagAttrs, current);
    }, {});
};
var $f7489db668f41cb3$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$f7489db668f41cb3$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$f7489db668f41cb3$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $f7489db668f41cb3$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $f7489db668f41cb3$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $f7489db668f41cb3$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $f7489db668f41cb3$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $f7489db668f41cb3$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $f7489db668f41cb3$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $f7489db668f41cb3$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $f7489db668f41cb3$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($lT6GZ)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $f7489db668f41cb3$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $f7489db668f41cb3$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $f7489db668f41cb3$var$getBaseTagFromPropsList([
            $f7489db668f41cb3$var$TAG_PROPERTIES.HREF,
            $f7489db668f41cb3$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $f7489db668f41cb3$var$getAttributesFromPropsList($f7489db668f41cb3$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $f7489db668f41cb3$var$getInnermostProperty(propsList, $f7489db668f41cb3$var$HELMET_PROPS.DEFER),
        encode: $f7489db668f41cb3$var$getInnermostProperty(propsList, $f7489db668f41cb3$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $f7489db668f41cb3$var$getAttributesFromPropsList($f7489db668f41cb3$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $f7489db668f41cb3$var$getTagsFromPropsList($f7489db668f41cb3$var$TAG_NAMES.LINK, [
            $f7489db668f41cb3$var$TAG_PROPERTIES.REL,
            $f7489db668f41cb3$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $f7489db668f41cb3$var$getTagsFromPropsList($f7489db668f41cb3$var$TAG_NAMES.META, [
            $f7489db668f41cb3$var$TAG_PROPERTIES.NAME,
            $f7489db668f41cb3$var$TAG_PROPERTIES.CHARSET,
            $f7489db668f41cb3$var$TAG_PROPERTIES.HTTPEQUIV,
            $f7489db668f41cb3$var$TAG_PROPERTIES.PROPERTY,
            $f7489db668f41cb3$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $f7489db668f41cb3$var$getTagsFromPropsList($f7489db668f41cb3$var$TAG_NAMES.NOSCRIPT, [
            $f7489db668f41cb3$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $f7489db668f41cb3$var$getOnChangeClientState(propsList),
        scriptTags: $f7489db668f41cb3$var$getTagsFromPropsList($f7489db668f41cb3$var$TAG_NAMES.SCRIPT, [
            $f7489db668f41cb3$var$TAG_PROPERTIES.SRC,
            $f7489db668f41cb3$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $f7489db668f41cb3$var$getTagsFromPropsList($f7489db668f41cb3$var$TAG_NAMES.STYLE, [
            $f7489db668f41cb3$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $f7489db668f41cb3$var$getTitleFromPropsList(propsList),
        titleAttributes: $f7489db668f41cb3$var$getAttributesFromPropsList($f7489db668f41cb3$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $f7489db668f41cb3$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $f7489db668f41cb3$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $f7489db668f41cb3$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $f7489db668f41cb3$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $f7489db668f41cb3$var$rafPolyfill : $parcel$global.requestAnimationFrame || $f7489db668f41cb3$var$rafPolyfill;
var $f7489db668f41cb3$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $f7489db668f41cb3$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $f7489db668f41cb3$var$cafPolyfill;
var $f7489db668f41cb3$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $f7489db668f41cb3$var$_helmetCallback = null;
var $f7489db668f41cb3$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($f7489db668f41cb3$var$_helmetCallback) $f7489db668f41cb3$var$cancelAnimationFrame($f7489db668f41cb3$var$_helmetCallback);
    if (newState.defer) $f7489db668f41cb3$var$_helmetCallback = $f7489db668f41cb3$var$requestAnimationFrame(function() {
        $f7489db668f41cb3$var$commitTagChanges(newState, function() {
            $f7489db668f41cb3$var$_helmetCallback = null;
        });
    });
    else {
        $f7489db668f41cb3$var$commitTagChanges(newState);
        $f7489db668f41cb3$var$_helmetCallback = null;
    }
};
var $f7489db668f41cb3$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $f7489db668f41cb3$var$updateAttributes($f7489db668f41cb3$var$TAG_NAMES.BODY, bodyAttributes);
    $f7489db668f41cb3$var$updateAttributes($f7489db668f41cb3$var$TAG_NAMES.HTML, htmlAttributes);
    $f7489db668f41cb3$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $f7489db668f41cb3$var$updateTags($f7489db668f41cb3$var$TAG_NAMES.BASE, baseTag),
        linkTags: $f7489db668f41cb3$var$updateTags($f7489db668f41cb3$var$TAG_NAMES.LINK, linkTags),
        metaTags: $f7489db668f41cb3$var$updateTags($f7489db668f41cb3$var$TAG_NAMES.META, metaTags),
        noscriptTags: $f7489db668f41cb3$var$updateTags($f7489db668f41cb3$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $f7489db668f41cb3$var$updateTags($f7489db668f41cb3$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $f7489db668f41cb3$var$updateTags($f7489db668f41cb3$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $f7489db668f41cb3$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $f7489db668f41cb3$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $f7489db668f41cb3$var$flattenArray(title);
    $f7489db668f41cb3$var$updateAttributes($f7489db668f41cb3$var$TAG_NAMES.TITLE, attributes);
};
var $f7489db668f41cb3$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($f7489db668f41cb3$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($f7489db668f41cb3$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($f7489db668f41cb3$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($f7489db668f41cb3$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $f7489db668f41cb3$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($f7489db668f41cb3$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $f7489db668f41cb3$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $f7489db668f41cb3$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $f7489db668f41cb3$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($f7489db668f41cb3$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $f7489db668f41cb3$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $f7489db668f41cb3$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $f7489db668f41cb3$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $f7489db668f41cb3$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $f7489db668f41cb3$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $f7489db668f41cb3$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $f7489db668f41cb3$var$HELMET_ATTRIBUTE + "=\"true\">" + $f7489db668f41cb3$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $f7489db668f41cb3$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $f7489db668f41cb3$var$TAG_PROPERTIES.INNER_HTML || attribute === $f7489db668f41cb3$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $f7489db668f41cb3$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $f7489db668f41cb3$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $f7489db668f41cb3$var$HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $f7489db668f41cb3$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$f7489db668f41cb3$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $f7489db668f41cb3$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$f7489db668f41cb3$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $f7489db668f41cb3$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$f7489db668f41cb3$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $f7489db668f41cb3$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement($f7489db668f41cb3$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $f7489db668f41cb3$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$f7489db668f41cb3$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $f7489db668f41cb3$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $f7489db668f41cb3$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $f7489db668f41cb3$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement(type, mappedTag);
    });
};
var $f7489db668f41cb3$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $f7489db668f41cb3$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $f7489db668f41cb3$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $f7489db668f41cb3$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $f7489db668f41cb3$var$ATTRIBUTE_NAMES.BODY:
        case $f7489db668f41cb3$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $f7489db668f41cb3$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $f7489db668f41cb3$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $f7489db668f41cb3$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $f7489db668f41cb3$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $f7489db668f41cb3$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $f7489db668f41cb3$var$getMethodsForTag($f7489db668f41cb3$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $f7489db668f41cb3$var$getMethodsForTag($f7489db668f41cb3$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $f7489db668f41cb3$var$getMethodsForTag($f7489db668f41cb3$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $f7489db668f41cb3$var$getMethodsForTag($f7489db668f41cb3$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $f7489db668f41cb3$var$getMethodsForTag($f7489db668f41cb3$var$TAG_NAMES.META, metaTags, encode),
        noscript: $f7489db668f41cb3$var$getMethodsForTag($f7489db668f41cb3$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $f7489db668f41cb3$var$getMethodsForTag($f7489db668f41cb3$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $f7489db668f41cb3$var$getMethodsForTag($f7489db668f41cb3$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $f7489db668f41cb3$var$getMethodsForTag($f7489db668f41cb3$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $f7489db668f41cb3$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $f7489db668f41cb3$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $f7489db668f41cb3$var$classCallCheck(this, HelmetWrapper);
            return $f7489db668f41cb3$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($828557725e2375de$exports)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $f7489db668f41cb3$var$TAG_NAMES.SCRIPT:
                case $f7489db668f41cb3$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $f7489db668f41cb3$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $f7489db668f41cb3$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $f7489db668f41cb3$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $f7489db668f41cb3$var$TAG_NAMES.TITLE:
                    return $f7489db668f41cb3$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $f7489db668f41cb3$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $f7489db668f41cb3$var$TAG_NAMES.BODY:
                    return $f7489db668f41cb3$var$_extends({}, newProps, {
                        bodyAttributes: $f7489db668f41cb3$var$_extends({}, newChildProps)
                    });
                case $f7489db668f41cb3$var$TAG_NAMES.HTML:
                    return $f7489db668f41cb3$var$_extends({}, newProps, {
                        htmlAttributes: $f7489db668f41cb3$var$_extends({}, newChildProps)
                    });
            }
            return $f7489db668f41cb3$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $f7489db668f41cb3$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $f7489db668f41cb3$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $f7489db668f41cb3$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $f7489db668f41cb3$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $f7489db668f41cb3$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $f7489db668f41cb3$var$TAG_NAMES.LINK:
                    case $f7489db668f41cb3$var$TAG_NAMES.META:
                    case $f7489db668f41cb3$var$TAG_NAMES.NOSCRIPT:
                    case $f7489db668f41cb3$var$TAG_NAMES.SCRIPT:
                    case $f7489db668f41cb3$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $f7489db668f41cb3$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $f7489db668f41cb3$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement(Component, newProps);
        };
        $f7489db668f41cb3$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($ePVXJ))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $f7489db668f41cb3$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $f7489db668f41cb3$var$NullComponent = function NullComponent() {
    return null;
};
var $f7489db668f41cb3$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($b0653fa1fdae7494$exports)))($f7489db668f41cb3$var$reducePropsToState, $f7489db668f41cb3$var$handleClientStateChange, $f7489db668f41cb3$var$mapStateOnServer)($f7489db668f41cb3$var$NullComponent);
var $f7489db668f41cb3$export$dcef8f9bb9a41431 = $f7489db668f41cb3$var$Helmet($f7489db668f41cb3$var$HelmetSideEffects);
$f7489db668f41cb3$export$dcef8f9bb9a41431.renderStatic = $f7489db668f41cb3$export$dcef8f9bb9a41431.rewind;
var $f7489db668f41cb3$export$2e2bcd8739ae039 = $f7489db668f41cb3$export$dcef8f9bb9a41431;



class $49461d249929a3fc$var$Lensed extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        descOpen: false,
        logoAnimationsComplete: false
    };
    componentDidMount() {
        let tl = (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline();
        tl.to(this._el, {
            opacity: 0.7,
            duration: 1.2,
            delay: 0.4
        });
        tl.to(this._el, {
            opacity: 0,
            duration: 1.2,
            delay: 2.3
        });
    }
    componentWillUnmount() {}
    handleLogoAnimationsComplete = ()=>{
        this.setState({
            logoAnimationsComplete: true
        });
    };
    handleVideoDescToggle = ()=>{
        const navigationDots = document.getElementById("fp-nav");
        if (!this.state.descOpen) (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline().to(navigationDots, {
            opacity: 0,
            duration: 0.25
        });
        else (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline().to(navigationDots, {
            opacity: 1,
            duration: 0.25
        });
        this.setState({
            descOpen: !this.state.descOpen
        });
    };
    render() {
        const meta = {
            title: "BLACKWING7 lenses by TRIBE7",
            description: "Bring a greater expressive range, intentionality and unique visual authorship to your story."
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: "descOpenGlobal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f7489db668f41cb3$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("title", null, meta.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("meta", {
            name: "description",
            content: meta.description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("link", {
            rel: "canonical",
            href: window.location.origin
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), {
            descOpen: this.state.descOpen,
            logoAnimating: this.props.landingOnLensed,
            logoAnimationsComplete: this.state.logoAnimationsComplete
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), {
            descOpen: this.state.descOpen,
            landingOnLensed: this.props.landingOnLensed
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, !this.state.descOpen && !this.state.logoAnimationsComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($061aca2e1fe74638$exports))).logoArea, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($061aca2e1fe74638$exports))).hidden]: this.props.descOpen
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $aca3e5e588c79778$export$2e2bcd8739ae039), {
            animated: true,
            logoAnimationsComplete: this.handleLogoAnimationsComplete
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e6a04f3734eaac1b$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._el = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($061aca2e1fe74638$exports))).logoAreaCaption)
        }, "TUNABLE LARGE FORMAT", (0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), !(0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, " "), "CINE LENSES")), (!(0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() || (0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() && this.state.logoAnimationsComplete) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f956e2716070b9ed$export$2e2bcd8739ae039), {
            onVideoDescToggle: this.handleVideoDescToggle,
            descOpen: this.state.descOpen,
            clickedNext: this.state.clickedNext,
            landingOnLensed: this.props.landingOnLensed
        })));
    }
}
var $49461d249929a3fc$export$2e2bcd8739ae039 = $49461d249929a3fc$var$Lensed;



var $jiXHd = parcelRequire("jiXHd");
/* eslint-disable prettier/prettier */ 
var $jiXHd = parcelRequire("jiXHd");



var $7852a4ee5bba25ac$exports = {};

$parcel$export($7852a4ee5bba25ac$exports, "header", function () { return $7852a4ee5bba25ac$export$38e42c68cf43b5d4; }, function (v) { return $7852a4ee5bba25ac$export$38e42c68cf43b5d4 = v; });
$parcel$export($7852a4ee5bba25ac$exports, "firstSection", function () { return $7852a4ee5bba25ac$export$c64e618c6a2b286f; }, function (v) { return $7852a4ee5bba25ac$export$c64e618c6a2b286f = v; });
$parcel$export($7852a4ee5bba25ac$exports, "pageBody", function () { return $7852a4ee5bba25ac$export$39c96952803efd29; }, function (v) { return $7852a4ee5bba25ac$export$39c96952803efd29 = v; });
$parcel$export($7852a4ee5bba25ac$exports, "bg", function () { return $7852a4ee5bba25ac$export$136fd86de524d3c2; }, function (v) { return $7852a4ee5bba25ac$export$136fd86de524d3c2 = v; });
$parcel$export($7852a4ee5bba25ac$exports, "bgReady", function () { return $7852a4ee5bba25ac$export$2eddb9afc6c2340f; }, function (v) { return $7852a4ee5bba25ac$export$2eddb9afc6c2340f = v; });
$parcel$export($7852a4ee5bba25ac$exports, "lensesBg", function () { return $7852a4ee5bba25ac$export$a83893c98eb33f58; }, function (v) { return $7852a4ee5bba25ac$export$a83893c98eb33f58 = v; });
$parcel$export($7852a4ee5bba25ac$exports, "arrowWrap", function () { return $7852a4ee5bba25ac$export$f47a18c8bbf2941e; }, function (v) { return $7852a4ee5bba25ac$export$f47a18c8bbf2941e = v; });
$parcel$export($7852a4ee5bba25ac$exports, "visible", function () { return $7852a4ee5bba25ac$export$664c6d24e3175067; }, function (v) { return $7852a4ee5bba25ac$export$664c6d24e3175067 = v; });
$parcel$export($7852a4ee5bba25ac$exports, "arrow", function () { return $7852a4ee5bba25ac$export$f2120bbfa5450bd2; }, function (v) { return $7852a4ee5bba25ac$export$f2120bbfa5450bd2 = v; });
var $7852a4ee5bba25ac$export$38e42c68cf43b5d4;
var $7852a4ee5bba25ac$export$c64e618c6a2b286f;
var $7852a4ee5bba25ac$export$39c96952803efd29;
var $7852a4ee5bba25ac$export$136fd86de524d3c2;
var $7852a4ee5bba25ac$export$2eddb9afc6c2340f;
var $7852a4ee5bba25ac$export$a83893c98eb33f58;
var $7852a4ee5bba25ac$export$f47a18c8bbf2941e;
var $7852a4ee5bba25ac$export$664c6d24e3175067;
var $7852a4ee5bba25ac$export$f2120bbfa5450bd2;
$7852a4ee5bba25ac$export$38e42c68cf43b5d4 = "_app-views-Lenses-LensesDesktop-_styles__header";
$7852a4ee5bba25ac$export$c64e618c6a2b286f = "_app-views-Lenses-LensesDesktop-_styles__firstSection";
$7852a4ee5bba25ac$export$39c96952803efd29 = "_app-views-Lenses-LensesDesktop-_styles__pageBody";
$7852a4ee5bba25ac$export$136fd86de524d3c2 = "_app-views-Lenses-LensesDesktop-_styles__bg";
$7852a4ee5bba25ac$export$2eddb9afc6c2340f = "_app-views-Lenses-LensesDesktop-_styles__bgReady";
$7852a4ee5bba25ac$export$a83893c98eb33f58 = "_app-views-Lenses-LensesDesktop-_styles__lensesBg";
$7852a4ee5bba25ac$export$f47a18c8bbf2941e = "_app-views-Lenses-LensesDesktop-_styles__arrowWrap";
$7852a4ee5bba25ac$export$664c6d24e3175067 = "_app-views-Lenses-LensesDesktop-_styles__visible";
$7852a4ee5bba25ac$export$f2120bbfa5450bd2 = "_app-views-Lenses-LensesDesktop-_styles__arrow";







var $jiXHd = parcelRequire("jiXHd");

var $8cf7770604238ebc$exports = {};

$parcel$export($8cf7770604238ebc$exports, "pageText", function () { return $8cf7770604238ebc$export$f11b2bba6755aef8; }, function (v) { return $8cf7770604238ebc$export$f11b2bba6755aef8 = v; });
$parcel$export($8cf7770604238ebc$exports, "first", function () { return $8cf7770604238ebc$export$43128fadae87b74a; }, function (v) { return $8cf7770604238ebc$export$43128fadae87b74a = v; });
$parcel$export($8cf7770604238ebc$exports, "shrink", function () { return $8cf7770604238ebc$export$8b1f3092f5e28575; }, function (v) { return $8cf7770604238ebc$export$8b1f3092f5e28575 = v; });
var $8cf7770604238ebc$export$f11b2bba6755aef8;
var $8cf7770604238ebc$export$43128fadae87b74a;
var $8cf7770604238ebc$export$8b1f3092f5e28575;
$8cf7770604238ebc$export$f11b2bba6755aef8 = "_app-components-TextBox-_styles__pageText";
$8cf7770604238ebc$export$43128fadae87b74a = "_app-components-TextBox-_styles__first";
$8cf7770604238ebc$export$8b1f3092f5e28575 = "_app-components-TextBox-_styles__shrink";



class $59ab0f51efb2dc52$var$TextBox extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {}
    componentDidUpdate() {
        let delay = this.props.slideNumber === 0 ? 1.3 : .7;
        if (this.props.currentSlide === this.props.slideNumber) (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._el, {
            opacity: .7,
            y: 0,
            duration: 1.7,
            delay: delay,
            ease: "power2.out"
        });
        else // make sure this doesn't run repeatedly
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._el, {
            opacity: 0,
            y: 20,
            duration: 2,
            delay: 0
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8cf7770604238ebc$exports))).pageText, {
                // [styles.active]: this.props.currentSlide == this.props.slideNumber,
                [(0, (/*@__PURE__*/$parcel$interopDefault($8cf7770604238ebc$exports))).first]: this.props.slideNumber === 0
            }, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($8cf7770604238ebc$exports))).shrink]: this.props.shrink
            }),
            ref: (c)=>{
                this._el = c;
            },
            style: {
                marginLeft: `calc(${this.props.position} / 26 * 100%)`
            }
        }, this.props.children);
    }
}
var $59ab0f51efb2dc52$export$2e2bcd8739ae039 = $59ab0f51efb2dc52$var$TextBox;




var $jiXHd = parcelRequire("jiXHd");
class $35950112c9f1df8b$var$ImgBg extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        ready: false
    };
    onLoad = ()=>{
        // TODO Figure out why this timeout is necessary
        this.timeout = setTimeout(()=>{
            this.setState({
                ready: true
            }, ()=>{
                if (this.props.onLoad) this.props.onLoad();
            });
        }, 10);
    };
    componentDidMount() {
        const img = new Image();
        img.onload = this.onLoad;
        img.src = this.props.src;
        this._img = img;
    }
    componentWillUnmount() {
        this._img.onload = function() {};
        delete this._img;
    }
    render() {
        let { src: src, className: className, readyClassName: readyClassName, style: style, ...rest } = this.props;
        const cn = (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))(className, {
            [readyClassName]: this.state.ready
        });
        const divStyle = Object.assign({}, style);
        if (this.state.ready) divStyle['backgroundImage'] = 'url(' + src + ')';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: cn,
            style: divStyle,
            ...rest
        });
    }
}
var $35950112c9f1df8b$export$2e2bcd8739ae039 = $35950112c9f1df8b$var$ImgBg;



var $f08fcdce49270724$exports = {};
$f08fcdce49270724$exports = $parcel$resolve("8MkNG");


const $19b6091432748998$var$backgroundUrl = new URL($f08fcdce49270724$exports);
const $19b6091432748998$var$frames = {
    0: {
        start: 0,
        stop: 2.2
    },
    1: {
        start: 2.45,
        stop: 7.2
    },
    2: {
        start: 7.45,
        stop: 12.22
    },
    3: {
        start: 12.7,
        stop: 17.75
    }
};
class $19b6091432748998$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        donePlayingVideo: false,
        firstLoad: true
    };
    componentDidMount() {
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(document.getElementById("fp-nav"), {
            opacity: 0
        }, {
            opacity: 1,
            delay: 2.3,
            duration: 0.5
        });
    }
    afterLoad(origin, dest, direction) {
        if (origin.index == 0 && dest.index == 0) this.stopAt($19b6091432748998$var$frames[0]);
    }
    onLeave(origin, dest, direction) {
        this.stopAt($19b6091432748998$var$frames[dest.index]);
        this.setState({
            firstLoad: false
        });
    }
    stopAt = (time)=>{
        if (time) {
            this.setState({
                donePlayingVideo: false
            });
            this._player.currentTime = time["start"];
            this._stopAtTime = time["stop"];
            this._player.play();
            this._player.ontimeupdate = ()=>{
                if (this._player && this._player.currentTime >= this._stopAtTime) {
                    this._player.pause();
                    this.setState({
                        donePlayingVideo: true
                    });
                // re-enable scroll
                }
            };
            this._player.style.transition = ".5s opacity";
            this._player.style.opacity = 1;
        } else {
            this._player.pause();
            this._player.style.transition = ".5s opacity";
            this._player.style.opacity = 0;
        }
    };
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $35950112c9f1df8b$export$2e2bcd8739ae039), {
            src: $19b6091432748998$var$backgroundUrl,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).bg,
            readyClassName: (0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).bgReady
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            style: {
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                zIndex: "-1"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $ef5e9f5377aadda6$export$2e2bcd8739ae039), {
            // poster='https://i.vimeocdn.com/video/821929072_1920x1080.jpg?r=pad'
            src: "https://bwing-dev.s3.amazonaws.com/render.mp4",
            height: "1080",
            width: "1920",
            isCurrentOrNext: true,
            innerRef: (c)=>{
                this._player = c;
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7565755634e5a3f9$exports))), {
            //fullpage options
            // scrollingSpeed = {1000} /* Options here */
            licenseKey: (0, $902644c2b34dba62$export$776d1d96e65b96de),
            onLeave: this.onLeave.bind(this),
            afterLoad: this.afterLoad.bind(this),
            navigation: true,
            credits: {
                enabled: false
            },
            render: ({ state: state, fullpageApi: fullpageApi })=>{
                if (fullpageApi) fullpageApi.setAllowScrolling(this.state.donePlayingVideo);
                if (fullpageApi && this.state.firstLoad) fullpageApi.silentMoveTo(1);
                let currentSlide = state.destination && !state.firstLoad ? state.destination.index : 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7565755634e5a3f9$exports))).Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: "section"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).firstSection)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $59ab0f51efb2dc52$export$2e2bcd8739ae039), {
                    slideNumber: 0,
                    currentSlide: currentSlide,
                    position: 0
                }, "TUNABLE LARGE FORMAT CINE LENSES")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).arrowWrap, {
                        [(0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).visible]: this.state.donePlayingVideo && currentSlide === 0
                    }),
                    onClick: ()=>fullpageApi.moveSectionDown()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $dbc9106da083fb2e$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).arrow)
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: "section"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: ""
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $59ab0f51efb2dc52$export$2e2bcd8739ae039), {
                    slideNumber: 1,
                    currentSlide: currentSlide,
                    position: 3
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Purpose-designed for", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "large format motion picture"), " imaging,", " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7")), " ", "lenses from TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " represent an entirely new range of tuned optics for contemporary film makers to use within their creative story telling."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " optics exhibit unique imaging properties which arise from the introduction of controlled distortion during the development and manufacturing processes. This distortion is modular and allows a level of tuneability over key parameters which shape many creative characteristics of the lenses.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).arrowWrap, {
                        [(0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).visible]: this.state.donePlayingVideo && currentSlide === 1
                    }),
                    onClick: ()=>fullpageApi.moveSectionDown()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $dbc9106da083fb2e$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).arrow)
                })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: "section"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: ""
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $59ab0f51efb2dc52$export$2e2bcd8739ae039), {
                    slideNumber: 2,
                    currentSlide: currentSlide,
                    position: 5
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "The lens range comprises nine focal lengths: a core set of seven plus two additional wide lenses, configurable and customisable at point of manufacture."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " lens tuning allows parameters such as sharpness, contrast, roll-off, spherical aberration, field curvature, edge halation and flare to be modified to provide sets of \u201Ccurated\u201D optics to suit the personality and intent of the owner."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Many of the design cues for BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " primes originate in optics manufactured during the 1930 - 1960s, but the real inspiration behind the lenses lies in the evolutionary nature of experimental music and audio synthesis, and the process of creating distortion through sound amplification.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).arrowWrap, {
                        [(0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).visible]: this.state.donePlayingVideo && currentSlide === 2
                    }),
                    onClick: ()=>fullpageApi.moveSectionDown()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $dbc9106da083fb2e$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7852a4ee5bba25ac$exports))).arrow)
                })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: "section"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: ""
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $59ab0f51efb2dc52$export$2e2bcd8739ae039), {
                    slideNumber: 3,
                    currentSlide: currentSlide,
                    position: 5,
                    shrink: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Conceptually, the ability to tune each BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " lens is identical to how EQ adjustment is used in music production - to control the range, or shape of tonality in specific bands across the audio frequency spectrum. The image produced by a BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " lens can be described as having a musical fidelity to it; with each focal length having an underlying level of distortion which can be controlled to produce strong artistic resonances including unique flaring characteristics."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Ten sets of BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " BINARIES were created by TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " to help introduce the film making community to the concept of audio merging into imaging. These limited-edition BINARIES are named in recognition of creative imaging not being a black or white process \u2013 film makers accessing a wide choice of optics is essential to serve creative storytelling. BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " BINARIES have been widely used on commercials, music videos, TV and feature productions and all feedback from these unique lenses has contributed to the production tuning of the BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " prime lenses which are now shipping.")))));
            }
        }));
    }
}



var $jiXHd = parcelRequire("jiXHd");

/*!
 * CustomEase 3.0.4
 * https://greensock.com
 *
 * @license Copyright 2008-2019, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ /*!
 * paths 3.0.4
 * https://greensock.com
 *
 * Copyright 2008-2019, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $a5a3d0ec1668ca64$var$_svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, $a5a3d0ec1668ca64$var$_numbersExp = /(?:(-)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, $a5a3d0ec1668ca64$var$_scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig, $a5a3d0ec1668ca64$var$_selectorExp = /(^[#\.][a-z]|[a-y][a-z])/i, $a5a3d0ec1668ca64$var$_DEG2RAD = Math.PI / 180, $a5a3d0ec1668ca64$var$_RAD2DEG = 180 / Math.PI, $a5a3d0ec1668ca64$var$_sin = Math.sin, $a5a3d0ec1668ca64$var$_cos = Math.cos, $a5a3d0ec1668ca64$var$_abs = Math.abs, $a5a3d0ec1668ca64$var$_sqrt = Math.sqrt, $a5a3d0ec1668ca64$var$_atan2 = Math.atan2, $a5a3d0ec1668ca64$var$_largeNum = 1e8, $a5a3d0ec1668ca64$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $a5a3d0ec1668ca64$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $a5a3d0ec1668ca64$var$_isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, $a5a3d0ec1668ca64$var$_temp = {}, $a5a3d0ec1668ca64$var$_temp2 = {}, $a5a3d0ec1668ca64$var$_roundingNum = 1e5, $a5a3d0ec1668ca64$var$_wrapProgress = function _wrapProgress(progress) {
    return Math.round((progress + $a5a3d0ec1668ca64$var$_largeNum) % 1 * $a5a3d0ec1668ca64$var$_roundingNum) / $a5a3d0ec1668ca64$var$_roundingNum || (progress < 0 ? 0 : 1);
}, //if progress lands on 1, the % will make it 0 which is why we || 1, but not if it's negative because it makes more sense for motion to end at 0 in that case.
$a5a3d0ec1668ca64$var$_round = function _round(value) {
    return ~~(value * $a5a3d0ec1668ca64$var$_roundingNum + (value < 0 ? -0.5 : .5)) / $a5a3d0ec1668ca64$var$_roundingNum;
}, $a5a3d0ec1668ca64$var$_splitSegment = function _splitSegment(rawPath, segIndex, i, t) {
    var segment = rawPath[segIndex], shift = t === 1 ? 6 : $a5a3d0ec1668ca64$export$bd9f14de8998b2c6(segment, i, t);
    if (shift && shift + i + 2 < segment.length) {
        rawPath.splice(segIndex, 0, segment.slice(0, i + shift + 2));
        segment.splice(0, i + shift);
        return 1;
    }
}, $a5a3d0ec1668ca64$var$_reverseRawPath = function _reverseRawPath(rawPath, skipOuter) {
    var i = rawPath.length;
    if (!skipOuter) rawPath.reverse();
    while(i--)if (!rawPath[i].reversed) $a5a3d0ec1668ca64$export$1c1e155a66a9b65a(rawPath[i]);
}, $a5a3d0ec1668ca64$var$_copyMetaData = function _copyMetaData(source, copy) {
    copy.totalLength = source.totalLength;
    if (source.samples) {
        //segment
        copy.samples = source.samples.slice(0);
        copy.lookup = source.lookup.slice(0);
        copy.minLength = source.minLength;
        copy.resolution = source.resolution;
    } else //rawPath
    copy.totalPoints = source.totalPoints;
    return copy;
}, //pushes a new segment into a rawPath, but if its starting values match the ending values of the last segment, it'll merge it into that same segment (to reduce the number of segments)
$a5a3d0ec1668ca64$var$_appendOrMerge = function _appendOrMerge(rawPath, segment) {
    var index = rawPath.length, prevSeg = rawPath[index - 1] || [], l = prevSeg.length;
    if (segment[0] === prevSeg[l - 2] && segment[1] === prevSeg[l - 1]) {
        segment = prevSeg.concat(segment.slice(2));
        index--;
    }
    rawPath[index] = segment;
}, $a5a3d0ec1668ca64$var$_bestDistance;
function $a5a3d0ec1668ca64$export$a7de45090ab95fc7(value) {
    value = $a5a3d0ec1668ca64$var$_isString(value) && $a5a3d0ec1668ca64$var$_selectorExp.test(value) ? document.querySelector(value) || value : value;
    var e = value.getAttribute ? value : 0, rawPath;
    if (e && (value = value.getAttribute("d"))) {
        //implements caching
        if (!e._gsPath) e._gsPath = {};
        rawPath = e._gsPath[value];
        return rawPath && !rawPath._dirty ? rawPath : e._gsPath[value] = $a5a3d0ec1668ca64$export$a9a6ab89eb1c2191(value);
    }
    return !value ? console.warn("Expecting a <path> element or an SVG path data string") : $a5a3d0ec1668ca64$var$_isString(value) ? $a5a3d0ec1668ca64$export$a9a6ab89eb1c2191(value) : $a5a3d0ec1668ca64$var$_isNumber(value[0]) ? [
        value
    ] : value;
} //copies a RawPath WITHOUT the length meta data (for speed)
function $a5a3d0ec1668ca64$export$e358367bf79edde2(rawPath) {
    var a = [], i = 0;
    for(; i < rawPath.length; i++)a[i] = $a5a3d0ec1668ca64$var$_copyMetaData(rawPath[i], rawPath[i].slice(0));
    return $a5a3d0ec1668ca64$var$_copyMetaData(rawPath, a);
}
function $a5a3d0ec1668ca64$export$1c1e155a66a9b65a(segment) {
    var i = 0, y;
    segment.reverse(); //this will invert the order y, x, y, x so we must flip it back.
    for(; i < segment.length; i += 2){
        y = segment[i];
        segment[i] = segment[i + 1];
        segment[i + 1] = y;
    }
    segment.reversed = !segment.reversed;
}
var $a5a3d0ec1668ca64$var$_createPath = function _createPath(e, ignore) {
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path"), attr = [].slice.call(e.attributes), i = attr.length, name;
    ignore = "," + ignore + ",";
    while(--i > -1){
        name = attr[i].nodeName.toLowerCase(); //in Microsoft Edge, if you don't set the attribute with a lowercase name, it doesn't render correctly! Super weird.
        if (ignore.indexOf("," + name + ",") < 0) path.setAttributeNS(null, name, attr[i].nodeValue);
    }
    return path;
}, $a5a3d0ec1668ca64$var$_typeAttrs = {
    rect: "rx,ry,x,y,width,height",
    circle: "r,cx,cy",
    ellipse: "rx,ry,cx,cy",
    line: "x1,x2,y1,y2"
}, $a5a3d0ec1668ca64$var$_attrToObj = function _attrToObj(e, attrs) {
    var props = attrs ? attrs.split(",") : [], obj = {}, i = props.length;
    while(--i > -1)obj[props[i]] = +e.getAttribute(props[i]) || 0;
    return obj;
}; //converts an SVG shape like <circle>, <rect>, <polygon>, <polyline>, <ellipse>, etc. to a <path>, swapping it in and copying the attributes to match.
function $a5a3d0ec1668ca64$export$1a6b6149d6272140(element, swap) {
    var type = element.tagName.toLowerCase(), circ = 0.552284749831, data, x, y, r, ry, path, rcirc, rycirc, points, w, h, x2, x3, x4, x5, x6, y2, y3, y4, y5, y6, attr;
    if (type === "path" || !element.getBBox) return element;
    path = $a5a3d0ec1668ca64$var$_createPath(element, "x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points");
    attr = $a5a3d0ec1668ca64$var$_attrToObj(element, $a5a3d0ec1668ca64$var$_typeAttrs[type]);
    if (type === "rect") {
        r = attr.rx;
        ry = attr.ry;
        x = attr.x;
        y = attr.y;
        w = attr.width - r * 2;
        h = attr.height - ry * 2;
        if (r || ry) {
            //if there are rounded corners, render cubic beziers
            x2 = x + r * (1 - circ);
            x3 = x + r;
            x4 = x3 + w;
            x5 = x4 + r * circ;
            x6 = x4 + r;
            y2 = y + ry * (1 - circ);
            y3 = y + ry;
            y4 = y3 + h;
            y5 = y4 + ry * circ;
            y6 = y4 + ry;
            data = "M" + x6 + "," + y3 + " V" + y4 + " C" + [
                x6,
                y5,
                x5,
                y6,
                x4,
                y6,
                x4 - (x4 - x3) / 3,
                y6,
                x3 + (x4 - x3) / 3,
                y6,
                x3,
                y6,
                x2,
                y6,
                x,
                y5,
                x,
                y4,
                x,
                y4 - (y4 - y3) / 3,
                x,
                y3 + (y4 - y3) / 3,
                x,
                y3,
                x,
                y2,
                x2,
                y,
                x3,
                y,
                x3 + (x4 - x3) / 3,
                y,
                x4 - (x4 - x3) / 3,
                y,
                x4,
                y,
                x5,
                y,
                x6,
                y2,
                x6,
                y3
            ].join(",") + "z";
        } else data = "M" + (x + w) + "," + y + " v" + h + " h" + -w + " v" + -h + " h" + w + "z";
    } else if (type === "circle" || type === "ellipse") {
        if (type === "circle") {
            r = ry = attr.r;
            rycirc = r * circ;
        } else {
            r = attr.rx;
            ry = attr.ry;
            rycirc = ry * circ;
        }
        x = attr.cx;
        y = attr.cy;
        rcirc = r * circ;
        data = "M" + (x + r) + "," + y + " C" + [
            x + r,
            y + rycirc,
            x + rcirc,
            y + ry,
            x,
            y + ry,
            x - rcirc,
            y + ry,
            x - r,
            y + rycirc,
            x - r,
            y,
            x - r,
            y - rycirc,
            x - rcirc,
            y - ry,
            x,
            y - ry,
            x + rcirc,
            y - ry,
            x + r,
            y - rycirc,
            x + r,
            y
        ].join(",") + "z";
    } else if (type === "line") data = "M" + attr.x1 + "," + attr.y1 + " L" + attr.x2 + "," + attr.y2; //previously, we just converted to "Mx,y Lx,y" but Safari has bugs that cause that not to render properly when using a stroke-dasharray that's not fully visible! Using a cubic bezier fixes that issue.
    else if (type === "polyline" || type === "polygon") {
        points = (element.getAttribute("points") + "").match($a5a3d0ec1668ca64$var$_numbersExp) || [];
        x = points.shift();
        y = points.shift();
        data = "M" + x + "," + y + " L" + points.join(",");
        if (type === "polygon") data += "," + x + "," + y + "z";
    }
    path.setAttribute("d", $a5a3d0ec1668ca64$export$ced9e1d9be30c397(path._gsRawPath = $a5a3d0ec1668ca64$export$a9a6ab89eb1c2191(data)));
    if (swap && element.parentNode) {
        element.parentNode.insertBefore(path, element);
        element.parentNode.removeChild(element);
    }
    return path;
} //returns the rotation (in degrees) at a particular progress on a rawPath (the slope of the tangent)
function $a5a3d0ec1668ca64$export$d03e55696b4d7894(rawPath, progress) {
    var d = $a5a3d0ec1668ca64$var$getProgressData(rawPath, progress >= 1 ? 1 - 1e-9 : progress ? progress : 1e-9);
    return $a5a3d0ec1668ca64$var$getRotationAtBezierT(d.segment, d.i, d.t);
}
function $a5a3d0ec1668ca64$var$getRotationAtBezierT(segment, i, t) {
    var a = segment[i], b = segment[i + 2], c = segment[i + 4], x;
    a += (b - a) * t;
    b += (c - b) * t;
    a += (b - a) * t;
    x = b + (c + (segment[i + 6] - c) * t - b) * t - a;
    a = segment[i + 1];
    b = segment[i + 3];
    c = segment[i + 5];
    a += (b - a) * t;
    b += (c - b) * t;
    a += (b - a) * t;
    return $a5a3d0ec1668ca64$var$_round($a5a3d0ec1668ca64$var$_atan2(b + (c + (segment[i + 7] - c) * t - b) * t - a, x) * $a5a3d0ec1668ca64$var$_RAD2DEG);
}
function $a5a3d0ec1668ca64$export$510a529ffd67482a(rawPath, start, end) {
    if ($a5a3d0ec1668ca64$var$_isUndefined(end)) end = 1;
    start = start || 0;
    var reverse = start > end, loops = Math.max(0, ~~($a5a3d0ec1668ca64$var$_abs(end - start) - 1e-8));
    if (reverse) {
        reverse = end;
        end = start;
        start = reverse;
        reverse = 1;
        loops -= loops ? 1 : 0;
    }
    if (start < 0 || end < 0) {
        var offset = ~~Math.min(start, end) + 1;
        start += offset;
        end += offset;
    }
    var path = $a5a3d0ec1668ca64$export$e358367bf79edde2(rawPath.totalLength ? rawPath : $a5a3d0ec1668ca64$export$cd44c6d3aa5b1098(rawPath)), wrap = end > 1, s = $a5a3d0ec1668ca64$var$getProgressData(path, start, $a5a3d0ec1668ca64$var$_temp), e = $a5a3d0ec1668ca64$var$getProgressData(path, end, $a5a3d0ec1668ca64$var$_temp2), eSeg = e.segment, sSeg = s.segment, eSegIndex = e.segIndex, sSegIndex = s.segIndex, ei = e.i, si = s.i, sameSegment = sSegIndex === eSegIndex, sameBezier = ei === si && sameSegment, invertedOrder = sameSegment && si > ei || sameBezier && s.t > e.t, sShift, eShift, i, copy, totalSegments, l, j;
    if (wrap || loops) {
        if ($a5a3d0ec1668ca64$var$_splitSegment(path, sSegIndex, si, s.t)) {
            sShift = 1;
            sSegIndex++;
            if (sameBezier) {
                if (invertedOrder) e.t /= s.t;
                else {
                    e.t = (e.t - s.t) / (1 - s.t);
                    eSegIndex++;
                    ei = 0;
                }
            } else if (sSegIndex <= eSegIndex + 1 && !invertedOrder) {
                eSegIndex++;
                if (sameSegment) ei -= si;
            }
        }
        if (!e.t) {
            eSegIndex--;
            if (reverse) sSegIndex--;
        } else if ($a5a3d0ec1668ca64$var$_splitSegment(path, eSegIndex, ei, e.t)) {
            if (invertedOrder && sShift) sSegIndex++;
            if (reverse) eSegIndex++;
        }
        copy = [];
        totalSegments = path.length;
        l = 1 + totalSegments * loops;
        j = sSegIndex;
        if (reverse) {
            eSegIndex = (eSegIndex || totalSegments) - 1;
            l += (totalSegments - eSegIndex + sSegIndex) % totalSegments;
            for(i = 0; i < l; i++){
                $a5a3d0ec1668ca64$var$_appendOrMerge(copy, path[j]);
                j = (j || totalSegments) - 1;
            }
        } else {
            l += (totalSegments - sSegIndex + eSegIndex) % totalSegments;
            for(i = 0; i < l; i++)$a5a3d0ec1668ca64$var$_appendOrMerge(copy, path[j++ % totalSegments]);
        }
        path = copy;
    } else {
        eShift = e.t === 1 ? 6 : $a5a3d0ec1668ca64$export$bd9f14de8998b2c6(eSeg, ei, e.t);
        if (start !== end) {
            sShift = $a5a3d0ec1668ca64$export$bd9f14de8998b2c6(sSeg, si, sameBezier ? s.t / e.t : s.t);
            if (sameSegment) eShift += sShift;
            eSeg.splice(ei + eShift + 2);
            if (sShift) sSeg.splice(0, si + sShift);
            i = path.length;
            while(i--)//chop off any extra segments
            if (i < sSegIndex || i > eSegIndex) path.splice(i, 1);
        } else {
            eSeg.angle = $a5a3d0ec1668ca64$var$getRotationAtBezierT(eSeg, ei + eShift, 0); //record the value before we chop because it'll be impossible to determine the angle after its length is 0!
            ei += eShift;
            s = eSeg[ei];
            e = eSeg[ei + 1];
            eSeg.length = eSeg.totalLength = 0;
            eSeg.totalPoints = path.totalPoints = 8;
            eSeg.push(s, e, s, e, s, e, s, e);
        }
    }
    if (reverse) $a5a3d0ec1668ca64$var$_reverseRawPath(path, wrap || loops);
    path.totalLength = 0;
    return path;
} //measures a Segment according to its resolution (so if segment.resolution is 6, for example, it'll take 6 samples equally across each Bezier) and create/populate a "samples" array that has the length up to each of those sample points (always increasing from the start) as well as a "lookup" array that's broken up according to the smallest distance between 2 samples. This gives us a very fast way of looking up a progress position rather than looping through all the points/Beziers. You can optionally have it only measure a subset, starting at startIndex and going for a specific number of beziers (remember, there are 3 x/y pairs each, for a total of 6 elements for each Bezier). It will also populate a "totalLength" property, but that's not generally super accurate because by default it'll only take 6 samples per Bezier. But for performance reasons, it's perfectly adequate for measuring progress values along the path. If you need a more accurate totalLength, either increase the resolution or use the more advanced bezierToPoints() method which keeps adding points until they don't deviate by more than a certain precision value.
function $a5a3d0ec1668ca64$var$measureSegment(segment, startIndex, bezierQty) {
    startIndex = startIndex || 0;
    if (!segment.samples) {
        segment.samples = [];
        segment.lookup = [];
    }
    var resolution = ~~segment.resolution || 12, inc = 1 / resolution, endIndex = bezierQty ? startIndex + bezierQty * 6 + 1 : segment.length, x1 = segment[startIndex], y1 = segment[startIndex + 1], samplesIndex = startIndex ? startIndex / 6 * resolution : 0, samples = segment.samples, lookup = segment.lookup, min = (startIndex ? segment.minLength : $a5a3d0ec1668ca64$var$_largeNum) || $a5a3d0ec1668ca64$var$_largeNum, prevLength = samples[samplesIndex + bezierQty * resolution - 1], length = startIndex ? samples[samplesIndex - 1] : 0, i, j, x4, x3, x2, xd, xd1, y4, y3, y2, yd, yd1, inv, t, lengthIndex, l, segLength;
    samples.length = lookup.length = 0;
    for(j = startIndex + 2; j < endIndex; j += 6){
        x4 = segment[j + 4] - x1;
        x3 = segment[j + 2] - x1;
        x2 = segment[j] - x1;
        y4 = segment[j + 5] - y1;
        y3 = segment[j + 3] - y1;
        y2 = segment[j + 1] - y1;
        xd = xd1 = yd = yd1 = 0;
        if ($a5a3d0ec1668ca64$var$_abs(x4) < 1e-5 && $a5a3d0ec1668ca64$var$_abs(y4) < 1e-5 && $a5a3d0ec1668ca64$var$_abs(x2) + $a5a3d0ec1668ca64$var$_abs(y2) < 1e-5) //dump points that are sufficiently close (basically right on top of each other, making a bezier super tiny or 0 length)
        {
            if (segment.length > 8) {
                segment.splice(j, 6);
                j -= 6;
                endIndex -= 6;
            }
        } else for(i = 1; i <= resolution; i++){
            t = inc * i;
            inv = 1 - t;
            xd = xd1 - (xd1 = (t * t * x4 + 3 * inv * (t * x3 + inv * x2)) * t);
            yd = yd1 - (yd1 = (t * t * y4 + 3 * inv * (t * y3 + inv * y2)) * t);
            l = $a5a3d0ec1668ca64$var$_sqrt(yd * yd + xd * xd);
            if (l < min) min = l;
            length += l;
            samples[samplesIndex++] = length;
        }
        x1 += x4;
        y1 += y4;
    }
    if (prevLength) {
        prevLength -= length;
        for(; samplesIndex < samples.length; samplesIndex++)samples[samplesIndex] += prevLength;
    }
    if (samples.length && min) {
        segment.totalLength = segLength = samples[samples.length - 1] || 0;
        segment.minLength = min;
        l = lengthIndex = 0;
        for(i = 0; i < segLength; i += min)lookup[l++] = samples[lengthIndex] < i ? ++lengthIndex : lengthIndex;
    } else segment.totalLength = samples[0] = 0;
    return startIndex ? length - samples[startIndex / 2 - 1] : length;
}
function $a5a3d0ec1668ca64$export$cd44c6d3aa5b1098(rawPath, resolution) {
    var pathLength, points, i;
    for(i = pathLength = points = 0; i < rawPath.length; i++){
        rawPath[i].resolution = ~~resolution || 12; //steps per Bezier curve (anchor, 2 control points, to anchor)
        points += rawPath[i].length;
        pathLength += $a5a3d0ec1668ca64$var$measureSegment(rawPath[i]);
    }
    rawPath.totalPoints = points;
    rawPath.totalLength = pathLength;
    return rawPath;
} //divide segment[i] at position t (value between 0 and 1, progress along that particular cubic bezier segment that starts at segment[i]). Returns how many elements were spliced into the segment array (either 0 or 6)
function $a5a3d0ec1668ca64$export$bd9f14de8998b2c6(segment, i, t) {
    if (t <= 0 || t >= 1) return 0;
    var ax = segment[i], ay = segment[i + 1], cp1x = segment[i + 2], cp1y = segment[i + 3], cp2x = segment[i + 4], cp2y = segment[i + 5], bx = segment[i + 6], by = segment[i + 7], x1a = ax + (cp1x - ax) * t, x2 = cp1x + (cp2x - cp1x) * t, y1a = ay + (cp1y - ay) * t, y2 = cp1y + (cp2y - cp1y) * t, x1 = x1a + (x2 - x1a) * t, y1 = y1a + (y2 - y1a) * t, x2a = cp2x + (bx - cp2x) * t, y2a = cp2y + (by - cp2y) * t;
    x2 += (x2a - x2) * t;
    y2 += (y2a - y2) * t;
    segment.splice(i + 2, 4, $a5a3d0ec1668ca64$var$_round(x1a), $a5a3d0ec1668ca64$var$_round(y1a), $a5a3d0ec1668ca64$var$_round(x1), $a5a3d0ec1668ca64$var$_round(y1), $a5a3d0ec1668ca64$var$_round(x1 + (x2 - x1) * t), $a5a3d0ec1668ca64$var$_round(y1 + (y2 - y1) * t), $a5a3d0ec1668ca64$var$_round(x2), $a5a3d0ec1668ca64$var$_round(y2), $a5a3d0ec1668ca64$var$_round(x2a), $a5a3d0ec1668ca64$var$_round(y2a));
    if (segment.samples) segment.samples.splice(i / 6 * segment.resolution | 0, 0, 0, 0, 0, 0, 0, 0);
    return 6;
} // returns an object {path, segment, segIndex, i, t}
function $a5a3d0ec1668ca64$var$getProgressData(rawPath, progress, decoratee) {
    decoratee = decoratee || {};
    if (!rawPath.totalLength) $a5a3d0ec1668ca64$export$cd44c6d3aa5b1098(rawPath);
    if (progress < 0 || progress > 1) progress = $a5a3d0ec1668ca64$var$_wrapProgress(progress);
    var segIndex = 0, segment = rawPath[0], samples, resolution, length, min, max, i;
    if (rawPath.length > 1) {
        //speed optimization: most of the time, there's only one segment so skip the recursion.
        length = rawPath.totalLength * progress;
        max = i = 0;
        while((max += rawPath[i++].totalLength) < length)segIndex = i;
        segment = rawPath[segIndex];
        min = max - segment.totalLength;
        progress = (length - min) / (max - min) || 0;
    }
    samples = segment.samples;
    resolution = segment.resolution; //how many samples per cubic bezier chunk
    length = segment.totalLength * progress;
    i = segment.lookup[~~(length / segment.minLength)] || 0;
    min = i ? samples[i - 1] : 0;
    max = samples[i];
    if (max < length) {
        min = max;
        max = samples[++i];
    }
    decoratee.path = rawPath;
    decoratee.segment = segment;
    decoratee.segIndex = segIndex;
    decoratee.i = ~~(i / resolution) * 6;
    decoratee.t = 1 / resolution * ((length - min) / (max - min) + i % resolution);
    return decoratee;
}
function $a5a3d0ec1668ca64$export$5fcb25b7d1608b70(rawPath, progress, includeAngle, point) {
    var segment = rawPath[0], result = point || {}, samples, resolution, length, min, max, i, t, a, inv;
    if (progress < 0 || progress > 1) progress = $a5a3d0ec1668ca64$var$_wrapProgress(progress);
    if (rawPath.length > 1) {
        //speed optimization: most of the time, there's only one segment so skip the recursion.
        length = rawPath.totalLength * progress;
        max = i = 0;
        while((max += rawPath[i++].totalLength) < length)segment = rawPath[i];
        min = max - segment.totalLength;
        progress = (length - min) / (max - min) || 0;
    }
    samples = segment.samples;
    resolution = segment.resolution;
    length = segment.totalLength * progress;
    i = segment.lookup[~~(length / segment.minLength)] || 0;
    min = i ? samples[i - 1] : 0;
    max = samples[i];
    if (max < length) {
        min = max;
        max = samples[++i];
    }
    t = 1 / resolution * ((length - min) / (max - min) + i % resolution) || 0;
    inv = 1 - t;
    i = ~~(i / resolution) * 6;
    a = segment[i];
    result.x = $a5a3d0ec1668ca64$var$_round((t * t * (segment[i + 6] - a) + 3 * inv * (t * (segment[i + 4] - a) + inv * (segment[i + 2] - a))) * t + a);
    result.y = $a5a3d0ec1668ca64$var$_round((t * t * (segment[i + 7] - (a = segment[i + 1])) + 3 * inv * (t * (segment[i + 5] - a) + inv * (segment[i + 3] - a))) * t + a);
    if (includeAngle) result.angle = segment.totalLength ? $a5a3d0ec1668ca64$var$getRotationAtBezierT(segment, i, t >= 1 ? 1 - 1e-9 : t ? t : 1e-9) : segment.angle || 0;
    return result;
} //applies a matrix transform to RawPath (or a segment in a RawPath) and returns whatever was passed in (it transforms the values in the array(s), not a copy).
function $a5a3d0ec1668ca64$export$9210b538875bfe33(rawPath, a, b, c, d, tx, ty) {
    var j = rawPath.length, segment, l, i, x, y;
    while(--j > -1){
        segment = rawPath[j];
        l = segment.length;
        for(i = 0; i < l; i += 2){
            x = segment[i];
            y = segment[i + 1];
            segment[i] = x * a + y * c + tx;
            segment[i + 1] = x * b + y * d + ty;
        }
    }
    rawPath._dirty = 1;
    return rawPath;
} // translates SVG arc data into a segment (cubic beziers). Angle is in degrees.
function $a5a3d0ec1668ca64$var$arcToSegment(lastX, lastY, rx, ry, angle, largeArcFlag, sweepFlag, x, y) {
    if (lastX === x && lastY === y) return;
    rx = $a5a3d0ec1668ca64$var$_abs(rx);
    ry = $a5a3d0ec1668ca64$var$_abs(ry);
    var angleRad = angle % 360 * $a5a3d0ec1668ca64$var$_DEG2RAD, cosAngle = $a5a3d0ec1668ca64$var$_cos(angleRad), sinAngle = $a5a3d0ec1668ca64$var$_sin(angleRad), PI = Math.PI, TWOPI = PI * 2, dx2 = (lastX - x) / 2, dy2 = (lastY - y) / 2, x1 = cosAngle * dx2 + sinAngle * dy2, y1 = -sinAngle * dx2 + cosAngle * dy2, x1_sq = x1 * x1, y1_sq = y1 * y1, radiiCheck = x1_sq / (rx * rx) + y1_sq / (ry * ry);
    if (radiiCheck > 1) {
        rx = $a5a3d0ec1668ca64$var$_sqrt(radiiCheck) * rx;
        ry = $a5a3d0ec1668ca64$var$_sqrt(radiiCheck) * ry;
    }
    var rx_sq = rx * rx, ry_sq = ry * ry, sq = (rx_sq * ry_sq - rx_sq * y1_sq - ry_sq * x1_sq) / (rx_sq * y1_sq + ry_sq * x1_sq);
    if (sq < 0) sq = 0;
    var coef = (largeArcFlag === sweepFlag ? -1 : 1) * $a5a3d0ec1668ca64$var$_sqrt(sq), cx1 = coef * (rx * y1 / ry), cy1 = coef * -(ry * x1 / rx), sx2 = (lastX + x) / 2, sy2 = (lastY + y) / 2, cx = sx2 + (cosAngle * cx1 - sinAngle * cy1), cy = sy2 + (sinAngle * cx1 + cosAngle * cy1), ux = (x1 - cx1) / rx, uy = (y1 - cy1) / ry, vx = (-x1 - cx1) / rx, vy = (-y1 - cy1) / ry, temp = ux * ux + uy * uy, angleStart = (uy < 0 ? -1 : 1) * Math.acos(ux / $a5a3d0ec1668ca64$var$_sqrt(temp)), angleExtent = (ux * vy - uy * vx < 0 ? -1 : 1) * Math.acos((ux * vx + uy * vy) / $a5a3d0ec1668ca64$var$_sqrt(temp * (vx * vx + vy * vy)));
    if (isNaN(angleExtent)) //rare edge case. Math.cos(-1) is NaN.
    angleExtent = PI;
    if (!sweepFlag && angleExtent > 0) angleExtent -= TWOPI;
    else if (sweepFlag && angleExtent < 0) angleExtent += TWOPI;
    angleStart %= TWOPI;
    angleExtent %= TWOPI;
    var segments = Math.ceil($a5a3d0ec1668ca64$var$_abs(angleExtent) / (TWOPI / 4)), rawPath = [], angleIncrement = angleExtent / segments, controlLength = 4 / 3 * $a5a3d0ec1668ca64$var$_sin(angleIncrement / 2) / (1 + $a5a3d0ec1668ca64$var$_cos(angleIncrement / 2)), ma = cosAngle * rx, mb = sinAngle * rx, mc = sinAngle * -ry, md = cosAngle * ry, i;
    for(i = 0; i < segments; i++){
        angle = angleStart + i * angleIncrement;
        x1 = $a5a3d0ec1668ca64$var$_cos(angle);
        y1 = $a5a3d0ec1668ca64$var$_sin(angle);
        ux = $a5a3d0ec1668ca64$var$_cos(angle += angleIncrement);
        uy = $a5a3d0ec1668ca64$var$_sin(angle);
        rawPath.push(x1 - controlLength * y1, y1 + controlLength * x1, ux + controlLength * uy, uy - controlLength * ux, ux, uy);
    } //now transform according to the actual size of the ellipse/arc (the beziers were noramlized, between 0 and 1 on a circle).
    for(i = 0; i < rawPath.length; i += 2){
        x1 = rawPath[i];
        y1 = rawPath[i + 1];
        rawPath[i] = x1 * ma + y1 * mc + cx;
        rawPath[i + 1] = x1 * mb + y1 * md + cy;
    }
    rawPath[i - 2] = x; //always set the end to exactly where it's supposed to be
    rawPath[i - 1] = y;
    return rawPath;
} //Spits back a RawPath with absolute coordinates. Each segment starts with a "moveTo" command (x coordinate, then y) and then 2 control points (x, y, x, y), then anchor. The goal is to minimize memory and maximize speed.
function $a5a3d0ec1668ca64$export$a9a6ab89eb1c2191(d) {
    var a = (d + "").replace($a5a3d0ec1668ca64$var$_scientific, function(m) {
        var n = +m;
        return n < 0.0001 && n > -0.0001 ? 0 : n;
    }).match($a5a3d0ec1668ca64$var$_svgPathExp) || [], //some authoring programs spit out very small numbers in scientific notation like "1e-5", so make sure we round that down to 0 first.
    path = [], relativeX = 0, relativeY = 0, twoThirds = 2 / 3, elements = a.length, points = 0, errorMessage = "ERROR: malformed path: " + d, i, j, x, y, command, isRelative, segment, startX, startY, difX, difY, beziers, prevCommand, flag1, flag2, line = function line(sx, sy, ex, ey) {
        difX = (ex - sx) / 3;
        difY = (ey - sy) / 3;
        segment.push(sx + difX, sy + difY, ex - difX, ey - difY, ex, ey);
    };
    if (!d || !isNaN(a[0]) || isNaN(a[1])) {
        console.log(errorMessage);
        return path;
    }
    for(i = 0; i < elements; i++){
        prevCommand = command;
        if (isNaN(a[i])) {
            command = a[i].toUpperCase();
            isRelative = command !== a[i]; //lower case means relative
        } else //commands like "C" can be strung together without any new command characters between.
        i--;
        x = +a[i + 1];
        y = +a[i + 2];
        if (isRelative) {
            x += relativeX;
            y += relativeY;
        }
        if (!i) {
            startX = x;
            startY = y;
        } // "M" (move)
        if (command === "M") {
            if (segment) {
                if (segment.length < 8) //if the path data was funky and just had a M with no actual drawing anywhere, skip it.
                path.length -= 1;
                else points += segment.length;
            }
            relativeX = startX = x;
            relativeY = startY = y;
            segment = [
                x,
                y
            ];
            path.push(segment);
            i += 2;
            command = "L"; //an "M" with more than 2 values gets interpreted as "lineTo" commands ("L").
        // "C" (cubic bezier)
        } else if (command === "C") {
            if (!segment) segment = [
                0,
                0
            ];
            if (!isRelative) relativeX = relativeY = 0;
             //note: "*1" is just a fast/short way to cast the value as a Number. WAAAY faster in Chrome, slightly slower in Firefox.
            segment.push(x, y, relativeX + a[i + 3] * 1, relativeY + a[i + 4] * 1, relativeX += a[i + 5] * 1, relativeY += a[i + 6] * 1);
            i += 6; // "S" (continuation of cubic bezier)
        } else if (command === "S") {
            difX = relativeX;
            difY = relativeY;
            if (prevCommand === "C" || prevCommand === "S") {
                difX += relativeX - segment[segment.length - 4];
                difY += relativeY - segment[segment.length - 3];
            }
            if (!isRelative) relativeX = relativeY = 0;
            segment.push(difX, difY, x, y, relativeX += a[i + 3] * 1, relativeY += a[i + 4] * 1);
            i += 4; // "Q" (quadratic bezier)
        } else if (command === "Q") {
            difX = relativeX + (x - relativeX) * twoThirds;
            difY = relativeY + (y - relativeY) * twoThirds;
            if (!isRelative) relativeX = relativeY = 0;
            relativeX += a[i + 3] * 1;
            relativeY += a[i + 4] * 1;
            segment.push(difX, difY, relativeX + (x - relativeX) * twoThirds, relativeY + (y - relativeY) * twoThirds, relativeX, relativeY);
            i += 4; // "T" (continuation of quadratic bezier)
        } else if (command === "T") {
            difX = relativeX - segment[segment.length - 4];
            difY = relativeY - segment[segment.length - 3];
            segment.push(relativeX + difX, relativeY + difY, x + (relativeX + difX * 1.5 - x) * twoThirds, y + (relativeY + difY * 1.5 - y) * twoThirds, relativeX = x, relativeY = y);
            i += 2; // "H" (horizontal line)
        } else if (command === "H") {
            line(relativeX, relativeY, relativeX = x, relativeY);
            i += 1; // "V" (vertical line)
        } else if (command === "V") {
            //adjust values because the first (and only one) isn't x in this case, it's y.
            line(relativeX, relativeY, relativeX, relativeY = x + (isRelative ? relativeY - relativeX : 0));
            i += 1; // "L" (line) or "Z" (close)
        } else if (command === "L" || command === "Z") {
            if (command === "Z") {
                x = startX;
                y = startY;
                segment.closed = true;
            }
            if (command === "L" || $a5a3d0ec1668ca64$var$_abs(relativeX - x) > 0.5 || $a5a3d0ec1668ca64$var$_abs(relativeY - y) > 0.5) {
                line(relativeX, relativeY, x, y);
                if (command === "L") i += 2;
            }
            relativeX = x;
            relativeY = y; // "A" (arc)
        } else if (command === "A") {
            flag1 = a[i + 4];
            flag2 = a[i + 5];
            difX = a[i + 6];
            difY = a[i + 7];
            j = 7;
            if (flag1.length > 1) {
                // for cases when the flags are merged, like "a8 8 0 018 8" (the 0 and 1 flags are WITH the x value of 8, but it could also be "a8 8 0 01-8 8" so it may include x or not)
                if (flag1.length < 3) {
                    difY = difX;
                    difX = flag2;
                    j--;
                } else {
                    difY = flag2;
                    difX = flag1.substr(2);
                    j -= 2;
                }
                flag2 = flag1.charAt(1);
                flag1 = flag1.charAt(0);
            }
            beziers = $a5a3d0ec1668ca64$var$arcToSegment(relativeX, relativeY, +a[i + 1], +a[i + 2], +a[i + 3], +flag1, +flag2, (isRelative ? relativeX : 0) + difX * 1, (isRelative ? relativeY : 0) + difY * 1);
            i += j;
            if (beziers) for(j = 0; j < beziers.length; j++)segment.push(beziers[j]);
            relativeX = segment[segment.length - 2];
            relativeY = segment[segment.length - 1];
        } else console.log(errorMessage);
    }
    i = segment.length;
    if (i < 6) {
        //in case there's odd SVG like a M0,0 command at the very end.
        path.pop();
        i = 0;
    } else if (segment[0] === segment[i - 2] && segment[1] === segment[i - 1]) segment.closed = true;
    path.totalPoints = points + i;
    return path;
} //populates the points array in alternating x/y values (like [x, y, x, y...] instead of individual point objects [{x, y}, {x, y}...] to conserve memory and stay in line with how we're handling segment arrays
function $a5a3d0ec1668ca64$export$f86e11e84068dc85(x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
    var x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2, x23 = (x2 + x3) / 2, y23 = (y2 + y3) / 2, x34 = (x3 + x4) / 2, y34 = (y3 + y4) / 2, x123 = (x12 + x23) / 2, y123 = (y12 + y23) / 2, x234 = (x23 + x34) / 2, y234 = (y23 + y34) / 2, x1234 = (x123 + x234) / 2, y1234 = (y123 + y234) / 2, dx = x4 - x1, dy = y4 - y1, d2 = $a5a3d0ec1668ca64$var$_abs((x2 - x4) * dy - (y2 - y4) * dx), d3 = $a5a3d0ec1668ca64$var$_abs((x3 - x4) * dy - (y3 - y4) * dx), length;
    if (!points) {
        points = [
            x1,
            y1,
            x4,
            y4
        ];
        index = 2;
    }
    points.splice(index || points.length - 2, 0, x1234, y1234);
    if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
        length = points.length;
        $a5a3d0ec1668ca64$export$f86e11e84068dc85(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
        $a5a3d0ec1668ca64$export$f86e11e84068dc85(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 2 + (points.length - length));
    }
    return points;
}
function $a5a3d0ec1668ca64$export$e3b964ae0940782f(points, curviness) {
    if (curviness === void 0) curviness = 1;
    var x = points[0], y = 0, segment = [
        x,
        y
    ], i = 2;
    for(; i < points.length; i += 2)segment.push(x, y, points[i], y = (points[i] - x) * curviness / 2, x = points[i], -y);
    return segment;
} //points is an array of x/y points, like [x, y, x, y, x, y]
function $a5a3d0ec1668ca64$export$ae6dd21671b80694(points, curviness, cornerThreshold) {
    //points = simplifyPoints(points, tolerance);
    var l = points.length - 2, x = +points[0], y = +points[1], nextX = +points[2], nextY = +points[3], segment = [
        x,
        y,
        x,
        y
    ], dx2 = nextX - x, dy2 = nextY - y, prevX, prevY, angle, slope, i, dx1, dx3, dy1, dy3, d1, d2, a, b, c;
    if (isNaN(cornerThreshold)) cornerThreshold = Math.PI / 10;
    curviness = curviness || curviness === 0 ? +curviness : 1;
    for(i = 2; i < l; i += 2){
        prevX = x;
        prevY = y;
        x = nextX;
        y = nextY;
        nextX = +points[i + 2];
        nextY = +points[i + 3];
        dx1 = dx2;
        dy1 = dy2;
        dx2 = nextX - x;
        dy2 = nextY - y;
        dx3 = nextX - prevX;
        dy3 = nextY - prevY;
        a = dx1 * dx1 + dy1 * dy1;
        b = dx2 * dx2 + dy2 * dy2;
        c = dx3 * dx3 + dy3 * dy3;
        angle = Math.acos((a + b - c) / $a5a3d0ec1668ca64$var$_sqrt(4 * a * b)); //angle between the 3 points
        d2 = angle / Math.PI * curviness; //temporary precalculation for speed (reusing d2 variable)
        d1 = $a5a3d0ec1668ca64$var$_sqrt(a) * d2; //the tighter the angle, the shorter we make the handles in proportion.
        d2 *= $a5a3d0ec1668ca64$var$_sqrt(b);
        if (x !== prevX || y !== prevY) {
            if (angle > cornerThreshold) {
                slope = $a5a3d0ec1668ca64$var$_atan2(dy3, dx3);
                segment.push($a5a3d0ec1668ca64$var$_round(x - $a5a3d0ec1668ca64$var$_cos(slope) * d1), $a5a3d0ec1668ca64$var$_round(y - $a5a3d0ec1668ca64$var$_sin(slope) * d1), $a5a3d0ec1668ca64$var$_round(x), $a5a3d0ec1668ca64$var$_round(y), $a5a3d0ec1668ca64$var$_round(x + $a5a3d0ec1668ca64$var$_cos(slope) * d2), $a5a3d0ec1668ca64$var$_round(y + $a5a3d0ec1668ca64$var$_sin(slope) * d2));
            } else {
                slope = $a5a3d0ec1668ca64$var$_atan2(dy1, dx1);
                segment.push($a5a3d0ec1668ca64$var$_round(x - $a5a3d0ec1668ca64$var$_cos(slope) * d1), $a5a3d0ec1668ca64$var$_round(y - $a5a3d0ec1668ca64$var$_sin(slope) * d1));
                slope = $a5a3d0ec1668ca64$var$_atan2(dy2, dx2);
                segment.push($a5a3d0ec1668ca64$var$_round(x), $a5a3d0ec1668ca64$var$_round(y), $a5a3d0ec1668ca64$var$_round(x + $a5a3d0ec1668ca64$var$_cos(slope) * d2), $a5a3d0ec1668ca64$var$_round(y + $a5a3d0ec1668ca64$var$_sin(slope) * d2));
            }
        }
    }
    segment.push($a5a3d0ec1668ca64$var$_round(nextX), $a5a3d0ec1668ca64$var$_round(nextY), $a5a3d0ec1668ca64$var$_round(nextX), $a5a3d0ec1668ca64$var$_round(nextY));
    return segment;
} //returns the squared distance between an x/y coordinate and a segment between x1/y1 and x2/y2
function $a5a3d0ec1668ca64$var$pointToSegDist(x, y, x1, y1, x2, y2) {
    var dx = x2 - x1, dy = y2 - y1, t;
    if (dx || dy) {
        t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return Math.pow(x - x1, 2) + Math.pow(y - y1, 2);
}
function $a5a3d0ec1668ca64$var$simplifyStep(points, first, last, tolerance, simplified) {
    var maxSqDist = tolerance, firstX = points[first], firstY = points[first + 1], lastX = points[last], lastY = points[last + 1], index, i, d;
    for(i = first + 2; i < last; i += 2){
        d = $a5a3d0ec1668ca64$var$pointToSegDist(points[i], points[i + 1], firstX, firstY, lastX, lastY);
        if (d > maxSqDist) {
            index = i;
            maxSqDist = d;
        }
    }
    if (maxSqDist > tolerance) {
        if (index - first > 2) $a5a3d0ec1668ca64$var$simplifyStep(points, first, index, tolerance, simplified);
        simplified.push(points[index], points[index + 1]);
        if (last - index > 2) $a5a3d0ec1668ca64$var$simplifyStep(points, index, last, tolerance, simplified);
    }
} //points is an array of x/y values like [x, y, x, y, x, y]
function $a5a3d0ec1668ca64$export$59627e036caae5e0(points, tolerance) {
    var prevX = parseFloat(points[0]), prevY = parseFloat(points[1]), temp = [
        prevX,
        prevY
    ], l = points.length - 2, i, x, y, dx, dy, result, last;
    tolerance = Math.pow(tolerance || 1, 2);
    for(i = 2; i < l; i += 2){
        x = parseFloat(points[i]);
        y = parseFloat(points[i + 1]);
        dx = prevX - x;
        dy = prevY - y;
        if (dx * dx + dy * dy > tolerance) {
            temp.push(x, y);
            prevX = x;
            prevY = y;
        }
    }
    temp.push(parseFloat(points[l]), parseFloat(points[l + 1]));
    last = temp.length - 2;
    result = [
        temp[0],
        temp[1]
    ];
    $a5a3d0ec1668ca64$var$simplifyStep(temp, 0, last, tolerance, result);
    result.push(temp[last], temp[last + 1]);
    return result;
}
function $a5a3d0ec1668ca64$var$getClosestProgressOnBezier(iterations, px, py, start, end, slices, x0, y0, x1, y1, x2, y2, x3, y3) {
    var inc = (end - start) / slices, best = 0, t = start, x, y, d, dx, dy, inv;
    $a5a3d0ec1668ca64$var$_bestDistance = $a5a3d0ec1668ca64$var$_largeNum;
    while(t <= end){
        inv = 1 - t;
        x = inv * inv * inv * x0 + 3 * inv * inv * t * x1 + 3 * inv * t * t * x2 + t * t * t * x3;
        y = inv * inv * inv * y0 + 3 * inv * inv * t * y1 + 3 * inv * t * t * y2 + t * t * t * y3;
        dx = x - px;
        dy = y - py;
        d = dx * dx + dy * dy;
        if (d < $a5a3d0ec1668ca64$var$_bestDistance) {
            $a5a3d0ec1668ca64$var$_bestDistance = d;
            best = t;
        }
        t += inc;
    }
    return iterations > 1 ? $a5a3d0ec1668ca64$var$getClosestProgressOnBezier(iterations - 1, px, py, Math.max(best - inc, 0), Math.min(best + inc, 1), slices, x0, y0, x1, y1, x2, y2, x3, y3) : best;
}
function $a5a3d0ec1668ca64$export$c7551252c2f97fc2(rawPath, x, y, slices) {
    //returns an object with the closest j, i, and t (j is the segment index, i is the index of the point in that segment, and t is the time/progress along that bezier)
    var closest = {
        j: 0,
        i: 0,
        t: 0
    }, bestDistance = $a5a3d0ec1668ca64$var$_largeNum, i, j, t, segment;
    for(j = 0; j < rawPath.length; j++){
        segment = rawPath[j];
        for(i = 0; i < segment.length; i += 6){
            t = $a5a3d0ec1668ca64$var$getClosestProgressOnBezier(1, x, y, 0, 1, slices || 20, segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5], segment[i + 6], segment[i + 7]);
            if (bestDistance > $a5a3d0ec1668ca64$var$_bestDistance) {
                bestDistance = $a5a3d0ec1668ca64$var$_bestDistance;
                closest.j = j;
                closest.i = i;
                closest.t = t;
            }
        }
    }
    return closest;
} //subdivide a Segment closest to a specific x,y coordinate
function $a5a3d0ec1668ca64$export$179b6e586855bec6(x, y, segment, slices, iterations) {
    var l = segment.length, bestDistance = $a5a3d0ec1668ca64$var$_largeNum, bestT = 0, bestSegmentIndex = 0, t, i;
    slices = slices || 20;
    iterations = iterations || 3;
    for(i = 0; i < l; i += 6){
        t = $a5a3d0ec1668ca64$var$getClosestProgressOnBezier(1, x, y, 0, 1, slices, segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5], segment[i + 6], segment[i + 7]);
        if (bestDistance > $a5a3d0ec1668ca64$var$_bestDistance) {
            bestDistance = $a5a3d0ec1668ca64$var$_bestDistance;
            bestT = t;
            bestSegmentIndex = i;
        }
    }
    t = $a5a3d0ec1668ca64$var$getClosestProgressOnBezier(iterations, x, y, bestT - 0.05, bestT + 0.05, slices, segment[bestSegmentIndex], segment[bestSegmentIndex + 1], segment[bestSegmentIndex + 2], segment[bestSegmentIndex + 3], segment[bestSegmentIndex + 4], segment[bestSegmentIndex + 5], segment[bestSegmentIndex + 6], segment[bestSegmentIndex + 7]);
    $a5a3d0ec1668ca64$export$bd9f14de8998b2c6(segment, bestSegmentIndex, t);
    return bestSegmentIndex + 6;
}
function $a5a3d0ec1668ca64$export$ced9e1d9be30c397(rawPath) {
    if ($a5a3d0ec1668ca64$var$_isNumber(rawPath[0])) //in case a segment is passed in instead
    rawPath = [
        rawPath
    ];
    var result = "", l = rawPath.length, sl, s, i, segment;
    for(s = 0; s < l; s++){
        segment = rawPath[s];
        result += "M" + $a5a3d0ec1668ca64$var$_round(segment[0]) + "," + $a5a3d0ec1668ca64$var$_round(segment[1]) + " C";
        sl = segment.length;
        for(i = 2; i < sl; i++)result += $a5a3d0ec1668ca64$var$_round(segment[i++]) + "," + $a5a3d0ec1668ca64$var$_round(segment[i++]) + " " + $a5a3d0ec1668ca64$var$_round(segment[i++]) + "," + $a5a3d0ec1668ca64$var$_round(segment[i++]) + " " + $a5a3d0ec1668ca64$var$_round(segment[i++]) + "," + $a5a3d0ec1668ca64$var$_round(segment[i]) + " ";
        if (segment.closed) result += "z";
    }
    return result;
} /*
// takes a segment with coordinates [x, y, x, y, ...] and converts the control points into angles and lengths [x, y, angle, length, angle, length, x, y, angle, length, ...] so that it animates more cleanly and avoids odd breaks/kinks. For example, if you animate from 1 o'clock to 6 o'clock, it'd just go directly/linearly rather than around. So the length would be very short in the middle of the tween.
export function cpCoordsToAngles(segment, copy) {
	var result = copy ? segment.slice(0) : segment,
		x, y, i;
	for (i = 0; i < segment.length; i+=6) {
		x = segment[i+2] - segment[i];
		y = segment[i+3] - segment[i+1];
		result[i+2] = Math.atan2(y, x);
		result[i+3] = Math.sqrt(x * x + y * y);
		x = segment[i+6] - segment[i+4];
		y = segment[i+7] - segment[i+5];
		result[i+4] = Math.atan2(y, x);
		result[i+5] = Math.sqrt(x * x + y * y);
	}
	return result;
}

// takes a segment that was converted with cpCoordsToAngles() to have angles and lengths instead of coordinates for the control points, and converts it BACK into coordinates.
export function cpAnglesToCoords(segment, copy) {
	var result = copy ? segment.slice(0) : segment,
		length = segment.length,
		rnd = 1000,
		angle, l, i, j;
	for (i = 0; i < length; i+=6) {
		angle = segment[i+2];
		l = segment[i+3]; //length
		result[i+2] = (((segment[i] + Math.cos(angle) * l) * rnd) | 0) / rnd;
		result[i+3] = (((segment[i+1] + Math.sin(angle) * l) * rnd) | 0) / rnd;
		angle = segment[i+4];
		l = segment[i+5]; //length
		result[i+4] = (((segment[i+6] - Math.cos(angle) * l) * rnd) | 0) / rnd;
		result[i+5] = (((segment[i+7] - Math.sin(angle) * l) * rnd) | 0) / rnd;
	}
	return result;
}

//adds an "isSmooth" array to each segment and populates it with a boolean value indicating whether or not it's smooth (the control points have basically the same slope). For any smooth control points, it converts the coordinates into angle (x, in radians) and length (y) and puts them into the same index value in a smoothData array.
export function populateSmoothData(rawPath) {
	let j = rawPath.length,
		smooth, segment, x, y, x2, y2, i, l, a, a2, isSmooth, smoothData;
	while (--j > -1) {
		segment = rawPath[j];
		isSmooth = segment.isSmooth = segment.isSmooth || [0, 0, 0, 0];
		smoothData = segment.smoothData = segment.smoothData || [0, 0, 0, 0];
		isSmooth.length = 4;
		l = segment.length - 2;
		for (i = 6; i < l; i += 6) {
			x = segment[i] - segment[i - 2];
			y = segment[i + 1] - segment[i - 1];
			x2 = segment[i + 2] - segment[i];
			y2 = segment[i + 3] - segment[i + 1];
			a = _atan2(y, x);
			a2 = _atan2(y2, x2);
			smooth = (Math.abs(a - a2) < 0.09);
			if (smooth) {
				smoothData[i - 2] = a;
				smoothData[i + 2] = a2;
				smoothData[i - 1] = _sqrt(x * x + y * y);
				smoothData[i + 3] = _sqrt(x2 * x2 + y2 * y2);
			}
			isSmooth.push(smooth, smooth, 0, 0, smooth, smooth);
		}
		//if the first and last points are identical, check to see if there's a smooth transition. We must handle this a bit differently due to their positions in the array.
		if (segment[l] === segment[0] && segment[l+1] === segment[1]) {
			x = segment[0] - segment[l-2];
			y = segment[1] - segment[l-1];
			x2 = segment[2] - segment[0];
			y2 = segment[3] - segment[1];
			a = _atan2(y, x);
			a2 = _atan2(y2, x2);
			if (Math.abs(a - a2) < 0.09) {
				smoothData[l-2] = a;
				smoothData[2] = a2;
				smoothData[l-1] = _sqrt(x * x + y * y);
				smoothData[3] = _sqrt(x2 * x2 + y2 * y2);
				isSmooth[l-2] = isSmooth[l-1] = true; //don't change indexes 2 and 3 because we'll trigger everything from the END, and this will optimize file size a bit.
			}
		}
	}
	return rawPath;
}
export function pointToScreen(svgElement, point) {
	if (arguments.length < 2) { //by default, take the first set of coordinates in the path as the point
		let rawPath = getRawPath(svgElement);
		point = svgElement.ownerSVGElement.createSVGPoint();
		point.x = rawPath[0][0];
		point.y = rawPath[0][1];
	}
	return point.matrixTransform(svgElement.getScreenCTM());
}

*/ 


var $e8afa155fcb2c918$var$gsap, $e8afa155fcb2c918$var$_coreInitted, $e8afa155fcb2c918$var$_getGSAP = function _getGSAP() {
    return $e8afa155fcb2c918$var$gsap || typeof window !== "undefined" && ($e8afa155fcb2c918$var$gsap = window.gsap) && $e8afa155fcb2c918$var$gsap.registerPlugin && $e8afa155fcb2c918$var$gsap;
}, $e8afa155fcb2c918$var$_initCore = function _initCore() {
    $e8afa155fcb2c918$var$gsap = $e8afa155fcb2c918$var$_getGSAP();
    if ($e8afa155fcb2c918$var$gsap) {
        $e8afa155fcb2c918$var$gsap.registerEase("_CE", $e8afa155fcb2c918$export$94f46869cc67acd8.create);
        $e8afa155fcb2c918$var$_coreInitted = 1;
    } else console.warn("Please gsap.registerPlugin(CustomEase)");
}, $e8afa155fcb2c918$var$_bigNum = 1e20, $e8afa155fcb2c918$var$_round = function _round(value) {
    return ~~(value * 1000 + (value < 0 ? -0.5 : .5)) / 1000;
}, $e8afa155fcb2c918$var$_bonusValidated = 1, //<name>CustomEase</name>
$e8afa155fcb2c918$var$_numExp = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$e8afa155fcb2c918$var$_needsParsingExp = /[cLlsSaAhHvVtTqQ]/g, $e8afa155fcb2c918$var$_findMinimum = function _findMinimum(values) {
    var l = values.length, min = $e8afa155fcb2c918$var$_bigNum, i;
    for(i = 1; i < l; i += 6)if (+values[i] < min) min = +values[i];
    return min;
}, //takes all the points and translates/scales them so that the x starts at 0 and ends at 1.
$e8afa155fcb2c918$var$_normalize = function _normalize(values, height, originY) {
    if (!originY && originY !== 0) originY = Math.max(+values[values.length - 1], +values[1]);
    var tx = +values[0] * -1, ty = -originY, l = values.length, sx = 1 / (+values[l - 2] + tx), sy = -height || (Math.abs(+values[l - 1] - +values[1]) < 0.01 * (+values[l - 2] - +values[0]) ? $e8afa155fcb2c918$var$_findMinimum(values) + ty : +values[l - 1] + ty), i;
    if (sy) //typically y ends at 1 (so that the end values are reached)
    sy = 1 / sy;
    else //in case the ease returns to its beginning value, scale everything proportionally
    sy = -sx;
    for(i = 0; i < l; i += 2){
        values[i] = (+values[i] + tx) * sx;
        values[i + 1] = (+values[i + 1] + ty) * sy;
    }
}, //note that this function returns point objects like {x, y} rather than working with segments which are arrays with alternating x, y values as in the similar function in paths.js
$e8afa155fcb2c918$var$_bezierToPoints = function _bezierToPoints(x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
    var x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2, x23 = (x2 + x3) / 2, y23 = (y2 + y3) / 2, x34 = (x3 + x4) / 2, y34 = (y3 + y4) / 2, x123 = (x12 + x23) / 2, y123 = (y12 + y23) / 2, x234 = (x23 + x34) / 2, y234 = (y23 + y34) / 2, x1234 = (x123 + x234) / 2, y1234 = (y123 + y234) / 2, dx = x4 - x1, dy = y4 - y1, d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx), d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx), length;
    if (!points) {
        points = [
            {
                x: x1,
                y: y1
            },
            {
                x: x4,
                y: y4
            }
        ];
        index = 1;
    }
    points.splice(index || points.length - 1, 0, {
        x: x1234,
        y: y1234
    });
    if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
        length = points.length;
        _bezierToPoints(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
        _bezierToPoints(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 1 + (points.length - length));
    }
    return points;
};
var $e8afa155fcb2c918$export$94f46869cc67acd8 = /*#__PURE__*/ function() {
    function CustomEase(id, data, config) {
        if (!$e8afa155fcb2c918$var$_coreInitted) $e8afa155fcb2c918$var$_initCore();
        this.id = id;
        if ($e8afa155fcb2c918$var$_bonusValidated) this.setData(data, config);
    }
    var _proto = CustomEase.prototype;
    _proto.setData = function setData(data, config) {
        config = config || {};
        data = data || "0,0,1,1";
        var values = data.match($e8afa155fcb2c918$var$_numExp), closest = 1, points = [], lookup = [], precision = config.precision || 1, fast = precision <= 1, l, a1, a2, i, inc, j, point, prevPoint, p;
        this.data = data;
        if ($e8afa155fcb2c918$var$_needsParsingExp.test(data) || ~data.indexOf("M") && data.indexOf("C") < 0) values = (0, $a5a3d0ec1668ca64$export$a9a6ab89eb1c2191)(data)[0];
        l = values.length;
        if (l === 4) {
            values.unshift(0, 0);
            values.push(1, 1);
            l = 8;
        } else if ((l - 2) % 6) throw "Invalid CustomEase";
        if (+values[0] !== 0 || +values[l - 2] !== 1) $e8afa155fcb2c918$var$_normalize(values, config.height, config.originY);
        this.segment = values;
        for(i = 2; i < l; i += 6){
            a1 = {
                x: +values[i - 2],
                y: +values[i - 1]
            };
            a2 = {
                x: +values[i + 4],
                y: +values[i + 5]
            };
            points.push(a1, a2);
            $e8afa155fcb2c918$var$_bezierToPoints(a1.x, a1.y, +values[i], +values[i + 1], +values[i + 2], +values[i + 3], a2.x, a2.y, 1 / (precision * 200000), points, points.length - 1);
        }
        l = points.length;
        for(i = 0; i < l; i++){
            point = points[i];
            prevPoint = points[i - 1] || point;
            if (point.x > prevPoint.x || prevPoint.y !== point.y && prevPoint.x === point.x || point === prevPoint) {
                //if a point goes BACKWARD in time or is a duplicate, just drop it.
                prevPoint.cx = point.x - prevPoint.x; //change in x between this point and the next point (performance optimization)
                prevPoint.cy = point.y - prevPoint.y;
                prevPoint.n = point;
                prevPoint.nx = point.x; //next point's x value (performance optimization, making lookups faster in getRatio()). Remember, the lookup will always land on a spot where it's either this point or the very next one (never beyond that)
                if (fast && i > 1 && Math.abs(prevPoint.cy / prevPoint.cx - points[i - 2].cy / points[i - 2].cx) > 2) //if there's a sudden change in direction, prioritize accuracy over speed. Like a bounce ease - you don't want to risk the sampling chunks landing on each side of the bounce anchor and having it clipped off.
                fast = 0;
                if (prevPoint.cx < closest) {
                    if (!prevPoint.cx) {
                        prevPoint.cx = 0.001; //avoids math problems in getRatio() (dividing by zero)
                        if (i === l - 1) {
                            //in case the final segment goes vertical RIGHT at the end, make sure we end at the end.
                            prevPoint.x -= 0.001;
                            closest = Math.min(closest, 0.001);
                            fast = 0;
                        }
                    } else closest = prevPoint.cx;
                }
            } else {
                points.splice(i--, 1);
                l--;
            }
        }
        l = 1 / closest + 1 | 0;
        inc = 1 / l;
        j = 0;
        point = points[0];
        if (fast) {
            for(i = 0; i < l; i++){
                //for fastest lookups, we just sample along the path at equal x (time) distance. Uses more memory and is slightly less accurate for anchors that don't land on the sampling points, but for the vast majority of eases it's excellent (and fast).
                p = i * inc;
                if (point.nx < p) point = points[++j];
                a1 = point.y + (p - point.x) / point.cx * point.cy;
                lookup[i] = {
                    x: p,
                    cx: inc,
                    y: a1,
                    cy: 0,
                    nx: 9
                };
                if (i) lookup[i - 1].cy = a1 - lookup[i - 1].y;
            }
            lookup[l - 1].cy = points[points.length - 1].y - a1;
        } else {
            //this option is more accurate, ensuring that EVERY anchor is hit perfectly. Clipping across a bounce, for example, would never happen.
            for(i = 0; i < l; i++){
                //build a lookup table based on the smallest distance so that we can instantly find the appropriate point (well, it'll either be that point or the very next one). We'll look up based on the linear progress. So it's it's 0.5 and the lookup table has 100 elements, it'd be like lookup[Math.floor(0.5 * 100)]
                if (point.nx < i * inc) point = points[++j];
                lookup[i] = point;
            }
            if (j < points.length - 1) lookup[i - 1] = points[points.length - 2];
        } //this._calcEnd = (points[points.length-1].y !== 1 || points[0].y !== 0); //ensures that we don't run into floating point errors. As long as we're starting at 0 and ending at 1, tell GSAP to skip the final calculation and use 0/1 as the factor.
        this.ease = function(p) {
            var point = lookup[p * l | 0] || lookup[l - 1];
            if (point.nx < p) point = point.n;
            return point.y + (p - point.x) / point.cx * point.cy;
        };
        this.ease.custom = this;
        if (this.id) $e8afa155fcb2c918$var$gsap.registerEase(this.id, this.ease);
        return this;
    };
    _proto.getSVGData = function getSVGData(config) {
        return CustomEase.getSVGData(this, config);
    };
    CustomEase.create = function create(id, data, config) {
        return new CustomEase(id, data, config).ease;
    };
    CustomEase.register = function register(core) {
        $e8afa155fcb2c918$var$gsap = core;
        $e8afa155fcb2c918$var$_initCore();
    };
    CustomEase.get = function get(id) {
        return $e8afa155fcb2c918$var$gsap.parseEase(id);
    };
    CustomEase.getSVGData = function getSVGData(ease, config) {
        config = config || {};
        var width = config.width || 100, height = config.height || 100, x = config.x || 0, y = (config.y || 0) + height, e = $e8afa155fcb2c918$var$gsap.utils.toArray(config.path)[0], a, slope, i, inc, tx, ty, precision, threshold, prevX, prevY;
        if (config.invert) {
            height = -height;
            y = 0;
        }
        if (typeof ease === "string") ease = $e8afa155fcb2c918$var$gsap.parseEase(ease);
        if (ease.custom) ease = ease.custom;
        if (ease instanceof CustomEase) a = (0, $a5a3d0ec1668ca64$export$ced9e1d9be30c397)((0, $a5a3d0ec1668ca64$export$9210b538875bfe33)([
            ease.segment
        ], width, 0, 0, -height, x, y));
        else {
            a = [
                x,
                y
            ];
            precision = Math.max(5, (config.precision || 1) * 200);
            inc = 1 / precision;
            precision += 2;
            threshold = 5 / precision;
            prevX = $e8afa155fcb2c918$var$_round(x + inc * width);
            prevY = $e8afa155fcb2c918$var$_round(y + ease(inc) * -height);
            slope = (prevY - y) / (prevX - x);
            for(i = 2; i < precision; i++){
                tx = $e8afa155fcb2c918$var$_round(x + i * inc * width);
                ty = $e8afa155fcb2c918$var$_round(y + ease(i * inc) * -height);
                if (Math.abs((ty - prevY) / (tx - prevX) - slope) > threshold || i === precision - 1) {
                    //only add points when the slope changes beyond the threshold
                    a.push(prevX, prevY);
                    slope = (ty - prevY) / (tx - prevX);
                }
                prevX = tx;
                prevY = ty;
            }
            a = "M" + a.join(",");
        }
        if (e) e.setAttribute("d", a);
        return a;
    };
    return CustomEase;
}();
$e8afa155fcb2c918$var$_getGSAP() && $e8afa155fcb2c918$var$gsap.registerPlugin($e8afa155fcb2c918$export$94f46869cc67acd8);
$e8afa155fcb2c918$export$94f46869cc67acd8.version = "3.0.4";



var $f7b2b905d468b770$exports = {};

$parcel$export($f7b2b905d468b770$exports, "header", function () { return $f7b2b905d468b770$export$38e42c68cf43b5d4; }, function (v) { return $f7b2b905d468b770$export$38e42c68cf43b5d4 = v; });
$parcel$export($f7b2b905d468b770$exports, "firstSection", function () { return $f7b2b905d468b770$export$c64e618c6a2b286f; }, function (v) { return $f7b2b905d468b770$export$c64e618c6a2b286f = v; });
$parcel$export($f7b2b905d468b770$exports, "pageBody", function () { return $f7b2b905d468b770$export$39c96952803efd29; }, function (v) { return $f7b2b905d468b770$export$39c96952803efd29 = v; });
$parcel$export($f7b2b905d468b770$exports, "bg", function () { return $f7b2b905d468b770$export$136fd86de524d3c2; }, function (v) { return $f7b2b905d468b770$export$136fd86de524d3c2 = v; });
$parcel$export($f7b2b905d468b770$exports, "bgReady", function () { return $f7b2b905d468b770$export$2eddb9afc6c2340f; }, function (v) { return $f7b2b905d468b770$export$2eddb9afc6c2340f = v; });
$parcel$export($f7b2b905d468b770$exports, "lensesBg", function () { return $f7b2b905d468b770$export$a83893c98eb33f58; }, function (v) { return $f7b2b905d468b770$export$a83893c98eb33f58 = v; });
$parcel$export($f7b2b905d468b770$exports, "arrowWrap", function () { return $f7b2b905d468b770$export$f47a18c8bbf2941e; }, function (v) { return $f7b2b905d468b770$export$f47a18c8bbf2941e = v; });
$parcel$export($f7b2b905d468b770$exports, "visible", function () { return $f7b2b905d468b770$export$664c6d24e3175067; }, function (v) { return $f7b2b905d468b770$export$664c6d24e3175067 = v; });
$parcel$export($f7b2b905d468b770$exports, "arrow", function () { return $f7b2b905d468b770$export$f2120bbfa5450bd2; }, function (v) { return $f7b2b905d468b770$export$f2120bbfa5450bd2 = v; });
$parcel$export($f7b2b905d468b770$exports, "textArea", function () { return $f7b2b905d468b770$export$d72b0b1d2d0e0735; }, function (v) { return $f7b2b905d468b770$export$d72b0b1d2d0e0735 = v; });
$parcel$export($f7b2b905d468b770$exports, "textAreaInner", function () { return $f7b2b905d468b770$export$827aa4cd93606c74; }, function (v) { return $f7b2b905d468b770$export$827aa4cd93606c74 = v; });
var $f7b2b905d468b770$export$38e42c68cf43b5d4;
var $f7b2b905d468b770$export$c64e618c6a2b286f;
var $f7b2b905d468b770$export$39c96952803efd29;
var $f7b2b905d468b770$export$136fd86de524d3c2;
var $f7b2b905d468b770$export$2eddb9afc6c2340f;
var $f7b2b905d468b770$export$a83893c98eb33f58;
var $f7b2b905d468b770$export$f47a18c8bbf2941e;
var $f7b2b905d468b770$export$664c6d24e3175067;
var $f7b2b905d468b770$export$f2120bbfa5450bd2;
var $f7b2b905d468b770$export$d72b0b1d2d0e0735;
var $f7b2b905d468b770$export$827aa4cd93606c74;
$f7b2b905d468b770$export$38e42c68cf43b5d4 = "_app-views-Lenses-LensesMobile-_styles__header";
$f7b2b905d468b770$export$c64e618c6a2b286f = "_app-views-Lenses-LensesMobile-_styles__firstSection";
$f7b2b905d468b770$export$39c96952803efd29 = "_app-views-Lenses-LensesMobile-_styles__pageBody";
$f7b2b905d468b770$export$136fd86de524d3c2 = "_app-views-Lenses-LensesMobile-_styles__bg";
$f7b2b905d468b770$export$2eddb9afc6c2340f = "_app-views-Lenses-LensesMobile-_styles__bgReady";
$f7b2b905d468b770$export$a83893c98eb33f58 = "_app-views-Lenses-LensesMobile-_styles__lensesBg";
$f7b2b905d468b770$export$f47a18c8bbf2941e = "_app-views-Lenses-LensesMobile-_styles__arrowWrap";
$f7b2b905d468b770$export$664c6d24e3175067 = "_app-views-Lenses-LensesMobile-_styles__visible";
$f7b2b905d468b770$export$f2120bbfa5450bd2 = "_app-views-Lenses-LensesMobile-_styles__arrow";
$f7b2b905d468b770$export$d72b0b1d2d0e0735 = "_app-views-Lenses-LensesMobile-_styles__textArea";
$f7b2b905d468b770$export$827aa4cd93606c74 = "_app-views-Lenses-LensesMobile-_styles__textAreaInner";







const $82edb0832a0a6c8e$var$backgroundUrl = new URL($f08fcdce49270724$exports);
class $82edb0832a0a6c8e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {
        this._player.play();
        (0, $36b3090cb6608e8f$export$99ee26438460406a).registerPlugin((0, $e8afa155fcb2c918$export$94f46869cc67acd8));
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($f7b2b905d468b770$exports))).textAreaInner}`), {
            opacity: 1,
            duration: 2.6,
            ease: (0, $e8afa155fcb2c918$export$94f46869cc67acd8).create("custom", "M0,0 C0,0 0.09116,0.26782 0.15086,0.43074 0.15694,0.44733 0.16234,0.45808 0.17283,0.47169 0.19642,0.50228 0.21314,0.52234 0.24249,0.54956 0.31205,0.61403 0.35449,0.65299 0.43055,0.71057 0.51315,0.77311 0.56472,0.80796 0.65357,0.86077 0.72937,0.90584 0.77865,0.92848 0.85807,0.96473 0.88838,0.97856 0.90924,0.98412 0.94124,0.99208 0.96291,0.99746 1,1 1,1"),
            delay: 1.5
        });
    }
    render() {
        if (this._player) this._player.play();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $35950112c9f1df8b$export$2e2bcd8739ae039), {
            src: $82edb0832a0a6c8e$var$backgroundUrl,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7b2b905d468b770$exports))).bg,
            readyClassName: (0, (/*@__PURE__*/$parcel$interopDefault($f7b2b905d468b770$exports))).bgReady
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            style: {
                position: "fixed",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                zIndex: "-1"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $ef5e9f5377aadda6$export$2e2bcd8739ae039), {
            // poster='https://i.vimeocdn.com/video/821929072_1920x1080.jpg?r=pad'
            src: "https://bwing-dev.s3.amazonaws.com/Blackwing+Lens_Mobile8-Gamma2-422HQ-Loop.mp4",
            height: "1920",
            width: "1080",
            isCurrentOrNext: true,
            innerRef: (c)=>{
                this._player = c;
            },
            loop: true,
            coverCropReposition: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7b2b905d468b770$exports))).textArea
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f7b2b905d468b770$exports))).textAreaInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f7b2b905d468b770$exports))).header)
        }, "TUNABLE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "LARGE FORMAT", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "CINE LENSES"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Purpose-designed for ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "large format motion picture"), " imaging, ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7")), " lenses from TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " represent an entirely new range of tuned optics for contemporary film makers to use within their creative story telling."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " optics exhibit unique imaging properties which arise from the introduction of controlled distortion during the development and manufacturing processes. This distortion is modular and allows a level of tuneability over key parameters which shape many creative characteristics of the lenses."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "The lens range comprises nine focal lengths: a core set of seven plus two additional wide lenses, configurable and customisable at point of manufacture."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " lens tuning allows parameters such as sharpness, contrast, roll-off, spherical aberration, field curvature, edge halation and flare to be modified to provide sets of \u201Ccurated\u201D optics to suit the personality and intent of the owner."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Many of the design cues for BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " primes originate in optics manufactured during the 1930 - 1960s, but the real inspiration behind the lenses lies in the evolutionary nature of experimental music and audio synthesis, and the process of creating distortion through sound amplification."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Conceptually, the ability to tune each BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " lens is identical to how EQ adjustment is used in music production - to control the range, or shape of tonality in specific bands across the audio frequency spectrum. The image produced by a BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), "  lens can be described as having a musical fidelity to it; with each focal length having an underlying level of distortion which can be controlled to produce strong artistic resonances including unique flaring characteristics."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Ten sets of BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " BINARIES were created by TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " to help introduce the film making community to the concept of audio merging into imaging. These limited-edition BINARIES are named in recognition of creative imaging not being a black or white process \u2013 film makers accessing a wide choice of optics is essential to serve creative storytelling. BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " BINARIES have been widely used on commercials, music videos, TV and feature productions and all feedback from these unique lenses has contributed to the production tuning of the BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " prime lenses which are now shipping."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null))));
    }
}




class $9f1f482530539ad9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {
        window.addEventListener("resize", this.onResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }
    onResize = ()=>{
        this.forceUpdate();
    };
    render() {
        const meta = {
            title: "Tunable Large Format Cine Lenses",
            description: "Explore a new range of creative tools with BLACKWING7 customizable large-format optics."
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f7489db668f41cb3$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("title", null, meta.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("meta", {
            name: "description",
            content: meta.description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("link", {
            rel: "canonical",
            href: `${window.location.origin}/lenses`
        })), !(0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $19b6091432748998$export$2e2bcd8739ae039), null), (0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $82edb0832a0a6c8e$export$2e2bcd8739ae039), null));
    }
}



var $jiXHd = parcelRequire("jiXHd");

var $jiXHd = parcelRequire("jiXHd");



var $7a18d26a8b2df62c$exports = {};

$parcel$export($7a18d26a8b2df62c$exports, "variantLabel", function () { return $7a18d26a8b2df62c$export$c877a6c4e166c3c6; }, function (v) { return $7a18d26a8b2df62c$export$c877a6c4e166c3c6 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "circlesLabel", function () { return $7a18d26a8b2df62c$export$48d80e756c09ddbc; }, function (v) { return $7a18d26a8b2df62c$export$48d80e756c09ddbc = v; });
$parcel$export($7a18d26a8b2df62c$exports, "sectionTuning", function () { return $7a18d26a8b2df62c$export$85cdcdc96b93a4ba; }, function (v) { return $7a18d26a8b2df62c$export$85cdcdc96b93a4ba = v; });
$parcel$export($7a18d26a8b2df62c$exports, "circlesSection", function () { return $7a18d26a8b2df62c$export$47b9f7f7fc7227fa; }, function (v) { return $7a18d26a8b2df62c$export$47b9f7f7fc7227fa = v; });
$parcel$export($7a18d26a8b2df62c$exports, "ready", function () { return $7a18d26a8b2df62c$export$28ee1007e174a2a6; }, function (v) { return $7a18d26a8b2df62c$export$28ee1007e174a2a6 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "letters", function () { return $7a18d26a8b2df62c$export$cf980ec1f8b21744; }, function (v) { return $7a18d26a8b2df62c$export$cf980ec1f8b21744 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "circlesLabels", function () { return $7a18d26a8b2df62c$export$278e7d06a41d55d5; }, function (v) { return $7a18d26a8b2df62c$export$278e7d06a41d55d5 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "pageText", function () { return $7a18d26a8b2df62c$export$f11b2bba6755aef8; }, function (v) { return $7a18d26a8b2df62c$export$f11b2bba6755aef8 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "chartSection", function () { return $7a18d26a8b2df62c$export$d783e99fe8e52643; }, function (v) { return $7a18d26a8b2df62c$export$d783e99fe8e52643 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "chartSectionActive", function () { return $7a18d26a8b2df62c$export$6e211bc7dcbc8179; }, function (v) { return $7a18d26a8b2df62c$export$6e211bc7dcbc8179 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "chartVariants", function () { return $7a18d26a8b2df62c$export$879c8add06cdea5; }, function (v) { return $7a18d26a8b2df62c$export$879c8add06cdea5 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "chartVariantFadeout", function () { return $7a18d26a8b2df62c$export$618b2fd2a8796434; }, function (v) { return $7a18d26a8b2df62c$export$618b2fd2a8796434 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "variantActive", function () { return $7a18d26a8b2df62c$export$619711d15ac5d9e2; }, function (v) { return $7a18d26a8b2df62c$export$619711d15ac5d9e2 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "chartVariant", function () { return $7a18d26a8b2df62c$export$65a205264429c89b; }, function (v) { return $7a18d26a8b2df62c$export$65a205264429c89b = v; });
$parcel$export($7a18d26a8b2df62c$exports, "lengths", function () { return $7a18d26a8b2df62c$export$3b026dac17332221; }, function (v) { return $7a18d26a8b2df62c$export$3b026dac17332221 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "length", function () { return $7a18d26a8b2df62c$export$f24224f1c91d8156; }, function (v) { return $7a18d26a8b2df62c$export$f24224f1c91d8156 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "lengthActive", function () { return $7a18d26a8b2df62c$export$4ce2ca2cd632f143; }, function (v) { return $7a18d26a8b2df62c$export$4ce2ca2cd632f143 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "chartArea", function () { return $7a18d26a8b2df62c$export$d342ad273db2b554; }, function (v) { return $7a18d26a8b2df62c$export$d342ad273db2b554 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "chartText", function () { return $7a18d26a8b2df62c$export$f660e51c28e4b420; }, function (v) { return $7a18d26a8b2df62c$export$f660e51c28e4b420 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "longChartText", function () { return $7a18d26a8b2df62c$export$c686b6f0ad220c64; }, function (v) { return $7a18d26a8b2df62c$export$c686b6f0ad220c64 = v; });
$parcel$export($7a18d26a8b2df62c$exports, "chartWrapOuter", function () { return $7a18d26a8b2df62c$export$f2f59be627f31d9f; }, function (v) { return $7a18d26a8b2df62c$export$f2f59be627f31d9f = v; });
$parcel$export($7a18d26a8b2df62c$exports, "chartWrap", function () { return $7a18d26a8b2df62c$export$799d32689f4d3ecb; }, function (v) { return $7a18d26a8b2df62c$export$799d32689f4d3ecb = v; });
$parcel$export($7a18d26a8b2df62c$exports, "legend", function () { return $7a18d26a8b2df62c$export$9a9b59e08de24cef; }, function (v) { return $7a18d26a8b2df62c$export$9a9b59e08de24cef = v; });
var $7a18d26a8b2df62c$export$c877a6c4e166c3c6;
var $7a18d26a8b2df62c$export$48d80e756c09ddbc;
var $7a18d26a8b2df62c$export$85cdcdc96b93a4ba;
var $7a18d26a8b2df62c$export$47b9f7f7fc7227fa;
var $7a18d26a8b2df62c$export$28ee1007e174a2a6;
var $7a18d26a8b2df62c$export$cf980ec1f8b21744;
var $7a18d26a8b2df62c$export$278e7d06a41d55d5;
var $7a18d26a8b2df62c$export$f11b2bba6755aef8;
var $7a18d26a8b2df62c$export$d783e99fe8e52643;
var $7a18d26a8b2df62c$export$6e211bc7dcbc8179;
var $7a18d26a8b2df62c$export$879c8add06cdea5;
var $7a18d26a8b2df62c$export$618b2fd2a8796434;
var $7a18d26a8b2df62c$export$619711d15ac5d9e2;
var $7a18d26a8b2df62c$export$65a205264429c89b;
var $7a18d26a8b2df62c$export$3b026dac17332221;
var $7a18d26a8b2df62c$export$f24224f1c91d8156;
var $7a18d26a8b2df62c$export$4ce2ca2cd632f143;
var $7a18d26a8b2df62c$export$d342ad273db2b554;
var $7a18d26a8b2df62c$export$f660e51c28e4b420;
var $7a18d26a8b2df62c$export$c686b6f0ad220c64;
var $7a18d26a8b2df62c$export$f2f59be627f31d9f;
var $7a18d26a8b2df62c$export$799d32689f4d3ecb;
var $7a18d26a8b2df62c$export$9a9b59e08de24cef;
$7a18d26a8b2df62c$export$c877a6c4e166c3c6 = "_app-views-Tuning-TuningDesktop-_styles__variantLabel";
$7a18d26a8b2df62c$export$48d80e756c09ddbc = "_app-views-Tuning-TuningDesktop-_styles__circlesLabel";
$7a18d26a8b2df62c$export$85cdcdc96b93a4ba = "_app-views-Tuning-TuningDesktop-_styles__sectionTuning";
$7a18d26a8b2df62c$export$47b9f7f7fc7227fa = "_app-views-Tuning-TuningDesktop-_styles__circlesSection";
$7a18d26a8b2df62c$export$28ee1007e174a2a6 = "_app-views-Tuning-TuningDesktop-_styles__ready";
$7a18d26a8b2df62c$export$cf980ec1f8b21744 = "_app-views-Tuning-TuningDesktop-_styles__letters";
$7a18d26a8b2df62c$export$278e7d06a41d55d5 = "_app-views-Tuning-TuningDesktop-_styles__circlesLabels";
$7a18d26a8b2df62c$export$f11b2bba6755aef8 = "_app-views-Tuning-TuningDesktop-_styles__pageText";
$7a18d26a8b2df62c$export$d783e99fe8e52643 = "_app-views-Tuning-TuningDesktop-_styles__chartSection";
$7a18d26a8b2df62c$export$6e211bc7dcbc8179 = "_app-views-Tuning-TuningDesktop-_styles__chartSectionActive";
$7a18d26a8b2df62c$export$879c8add06cdea5 = "_app-views-Tuning-TuningDesktop-_styles__chartVariants";
$7a18d26a8b2df62c$export$618b2fd2a8796434 = "_app-views-Tuning-TuningDesktop-_styles__chartVariantFadeout";
$7a18d26a8b2df62c$export$619711d15ac5d9e2 = "_app-views-Tuning-TuningDesktop-_styles__variantActive";
$7a18d26a8b2df62c$export$65a205264429c89b = "_app-views-Tuning-TuningDesktop-_styles__chartVariant";
$7a18d26a8b2df62c$export$3b026dac17332221 = "_app-views-Tuning-TuningDesktop-_styles__lengths";
$7a18d26a8b2df62c$export$f24224f1c91d8156 = "_app-views-Tuning-TuningDesktop-_styles__length";
$7a18d26a8b2df62c$export$4ce2ca2cd632f143 = "_app-views-Tuning-TuningDesktop-_styles__lengthActive";
$7a18d26a8b2df62c$export$d342ad273db2b554 = "_app-views-Tuning-TuningDesktop-_styles__chartArea";
$7a18d26a8b2df62c$export$f660e51c28e4b420 = "_app-views-Tuning-TuningDesktop-_styles__chartText";
$7a18d26a8b2df62c$export$c686b6f0ad220c64 = "_app-views-Tuning-TuningDesktop-_styles__longChartText";
$7a18d26a8b2df62c$export$f2f59be627f31d9f = "_app-views-Tuning-TuningDesktop-_styles__chartWrapOuter";
$7a18d26a8b2df62c$export$799d32689f4d3ecb = "_app-views-Tuning-TuningDesktop-_styles__chartWrap";
$7a18d26a8b2df62c$export$9a9b59e08de24cef = "_app-views-Tuning-TuningDesktop-_styles__legend";






var $jiXHd = parcelRequire("jiXHd");

var $6ac616acdfb95237$exports = {};

$parcel$export($6ac616acdfb95237$exports, "circlesWrap", function () { return $6ac616acdfb95237$export$910dde7540d1f6cf; }, function (v) { return $6ac616acdfb95237$export$910dde7540d1f6cf = v; });
$parcel$export($6ac616acdfb95237$exports, "circles", function () { return $6ac616acdfb95237$export$c958aa0cc90a067; }, function (v) { return $6ac616acdfb95237$export$c958aa0cc90a067 = v; });
$parcel$export($6ac616acdfb95237$exports, "letters", function () { return $6ac616acdfb95237$export$cf980ec1f8b21744; }, function (v) { return $6ac616acdfb95237$export$cf980ec1f8b21744 = v; });
$parcel$export($6ac616acdfb95237$exports, "circle", function () { return $6ac616acdfb95237$export$e1d786d2f707b414; }, function (v) { return $6ac616acdfb95237$export$e1d786d2f707b414 = v; });
$parcel$export($6ac616acdfb95237$exports, "circlesFill", function () { return $6ac616acdfb95237$export$55e8620fb8f1efdf; }, function (v) { return $6ac616acdfb95237$export$55e8620fb8f1efdf = v; });
$parcel$export($6ac616acdfb95237$exports, "circleStroke", function () { return $6ac616acdfb95237$export$15785dcc95f3e6d2; }, function (v) { return $6ac616acdfb95237$export$15785dcc95f3e6d2 = v; });
$parcel$export($6ac616acdfb95237$exports, "letter", function () { return $6ac616acdfb95237$export$30780d0b6b610af8; }, function (v) { return $6ac616acdfb95237$export$30780d0b6b610af8 = v; });
var $6ac616acdfb95237$export$910dde7540d1f6cf;
var $6ac616acdfb95237$export$c958aa0cc90a067;
var $6ac616acdfb95237$export$cf980ec1f8b21744;
var $6ac616acdfb95237$export$e1d786d2f707b414;
var $6ac616acdfb95237$export$55e8620fb8f1efdf;
var $6ac616acdfb95237$export$15785dcc95f3e6d2;
var $6ac616acdfb95237$export$30780d0b6b610af8;
$6ac616acdfb95237$export$910dde7540d1f6cf = "_app-views-Tuning-Circles-_styles__circlesWrap";
$6ac616acdfb95237$export$c958aa0cc90a067 = "_app-views-Tuning-Circles-_styles__circles";
$6ac616acdfb95237$export$cf980ec1f8b21744 = "_app-views-Tuning-Circles-_styles__letters";
$6ac616acdfb95237$export$e1d786d2f707b414 = "_app-views-Tuning-Circles-_styles__circle";
$6ac616acdfb95237$export$55e8620fb8f1efdf = "_app-views-Tuning-Circles-_styles__circlesFill";
$6ac616acdfb95237$export$15785dcc95f3e6d2 = "_app-views-Tuning-Circles-_styles__circleStroke";
$6ac616acdfb95237$export$30780d0b6b610af8 = "_app-views-Tuning-Circles-_styles__letter";



var $4a187584cb4dbfca$exports = {};
$4a187584cb4dbfca$exports = $parcel$resolve("cmWZg");


const $1323d0b01f055777$var$STXSUrl = new URL($4a187584cb4dbfca$exports);
var $2e710d10fc06f454$exports = {};
$2e710d10fc06f454$exports = $parcel$resolve("7KXrq");


const $1323d0b01f055777$var$STXTUrl = new URL($2e710d10fc06f454$exports);
var $08b0dd3494386e26$exports = {};
$08b0dd3494386e26$exports = $parcel$resolve("6eio2");


const $1323d0b01f055777$var$STXXUrl = new URL($08b0dd3494386e26$exports);
class $1323d0b01f055777$var$Circles extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {
        let delay = 0.2;
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._circles, {
            opacity: 0
        }, {
            opacity: .9,
            delay: delay,
            duration: 3
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._circle1, {
            opacity: .5
        }, {
            opacity: .5,
            x: "-=50",
            delay: delay,
            duration: 15
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._circle2, {
            opacity: .5,
            filter: 'blur(0.7px)'
        }, {
            opacity: .5,
            filter: 'blur(4px)',
            delay: delay,
            duration: 15
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._circle3, {
            filter: 'blur(1.2px)'
        }, {
            filter: 'blur(8px)',
            x: "+=50",
            delay: delay,
            duration: 15
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo([
            this._letter1,
            this._letter2,
            this._letter3
        ], {
            opacity: 0
        }, {
            opacity: .9,
            delay: delay + .1,
            duration: 3,
            stagger: .2
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._letter1, {
            x: "-=50",
            delay: delay,
            duration: 15
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._letter3, {
            x: "+=50",
            delay: delay,
            duration: 15
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).circlesWrap)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._circles = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).circles)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).circle),
            viewBox: "0 0 100 100",
            style: {
                left: 0
            },
            ref: (c)=>{
                this._circle1 = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("circle", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).circleStroke),
            cx: "50",
            cy: "50",
            r: "49"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).circle),
            viewBox: "0 0 100 100",
            style: {
                left: "50%",
                transform: "translateX(-50%)"
            },
            ref: (c)=>{
                this._circle2 = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("circle", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).circleStroke),
            cx: "50",
            cy: "50",
            r: "49"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).circle),
            viewBox: "0 0 100 100",
            style: {
                right: 0
            },
            ref: (c)=>{
                this._circle3 = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("circle", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).circleStroke),
            cx: "50",
            cy: "50",
            r: "49"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._letters = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).letters)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).letter),
            style: {
                left: 0
            },
            ref: (c)=>{
                this._letter1 = c;
            },
            src: $1323d0b01f055777$var$STXSUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).letter, (0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).letter2),
            style: {
                display: 'block',
                position: 'static',
                margin: '0 auto'
            },
            ref: (c)=>{
                this._letter2 = c;
            },
            src: $1323d0b01f055777$var$STXTUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6ac616acdfb95237$exports))).letter),
            style: {
                right: 0
            },
            ref: (c)=>{
                this._letter3 = c;
            },
            src: $1323d0b01f055777$var$STXXUrl
        })));
    }
}
var $1323d0b01f055777$export$2e2bcd8739ae039 = $1323d0b01f055777$var$Circles;


var $991fb83ad4494ad4$exports = {};
"use strict";
Object.defineProperty($991fb83ad4494ad4$exports, "__esModule", {
    value: true
});
Object.defineProperty($991fb83ad4494ad4$exports, "Chart", {
    enumerable: true,
    get: function get() {
        return $991fb83ad4494ad4$var$_chart["default"];
    }
});
$991fb83ad4494ad4$exports.defaults = $991fb83ad4494ad4$exports.Scatter = $991fb83ad4494ad4$exports.Bubble = $991fb83ad4494ad4$exports.Polar = $991fb83ad4494ad4$exports.Radar = $991fb83ad4494ad4$exports.HorizontalBar = $991fb83ad4494ad4$exports.Bar = $991fb83ad4494ad4$exports.Line = $991fb83ad4494ad4$exports.Pie = $991fb83ad4494ad4$exports.Doughnut = $991fb83ad4494ad4$exports["default"] = void 0;

var $991fb83ad4494ad4$var$_react = $991fb83ad4494ad4$var$_interopRequireDefault((parcelRequire("jiXHd")));

var $991fb83ad4494ad4$var$_propTypes = $991fb83ad4494ad4$var$_interopRequireDefault((parcelRequire("ePVXJ")));

var $991fb83ad4494ad4$var$_chart = $991fb83ad4494ad4$var$_interopRequireDefault((parcelRequire("dBqQ7")));

var $991fb83ad4494ad4$var$_isEqual = $991fb83ad4494ad4$var$_interopRequireDefault((parcelRequire("gjhmZ")));

var $991fb83ad4494ad4$var$_keyBy = $991fb83ad4494ad4$var$_interopRequireDefault((parcelRequire("epOIy")));
function $991fb83ad4494ad4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $991fb83ad4494ad4$var$_extends() {
    $991fb83ad4494ad4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $991fb83ad4494ad4$var$_extends.apply(this, arguments);
}
function $991fb83ad4494ad4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $991fb83ad4494ad4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $991fb83ad4494ad4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $991fb83ad4494ad4$var$_typeof(obj);
}
function $991fb83ad4494ad4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $991fb83ad4494ad4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $991fb83ad4494ad4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $991fb83ad4494ad4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $991fb83ad4494ad4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $991fb83ad4494ad4$var$ownKeys(Object(source), true).forEach(function(key) {
            $991fb83ad4494ad4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $991fb83ad4494ad4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $991fb83ad4494ad4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $991fb83ad4494ad4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $991fb83ad4494ad4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $991fb83ad4494ad4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $991fb83ad4494ad4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $991fb83ad4494ad4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $991fb83ad4494ad4$var$_setPrototypeOf(subClass, superClass);
}
function $991fb83ad4494ad4$var$_setPrototypeOf(o, p) {
    $991fb83ad4494ad4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $991fb83ad4494ad4$var$_setPrototypeOf(o, p);
}
function $991fb83ad4494ad4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $991fb83ad4494ad4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $991fb83ad4494ad4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $991fb83ad4494ad4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $991fb83ad4494ad4$var$_possibleConstructorReturn(this, result);
    };
}
function $991fb83ad4494ad4$var$_possibleConstructorReturn(self, call) {
    if (call && ($991fb83ad4494ad4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $991fb83ad4494ad4$var$_assertThisInitialized(self);
}
function $991fb83ad4494ad4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $991fb83ad4494ad4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $991fb83ad4494ad4$var$_getPrototypeOf(o) {
    $991fb83ad4494ad4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $991fb83ad4494ad4$var$_getPrototypeOf(o);
}
function $991fb83ad4494ad4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $991fb83ad4494ad4$var$NODE_ENV = false;
var $991fb83ad4494ad4$var$ChartComponent = /*#__PURE__*/ function(_React$Component) {
    $991fb83ad4494ad4$var$_inherits(ChartComponent, _React$Component);
    var _super = $991fb83ad4494ad4$var$_createSuper(ChartComponent);
    function ChartComponent() {
        var _this;
        $991fb83ad4494ad4$var$_classCallCheck(this, ChartComponent);
        _this = _super.call(this);
        $991fb83ad4494ad4$var$_defineProperty($991fb83ad4494ad4$var$_assertThisInitialized(_this), "handleOnClick", function(event) {
            var instance = _this.chartInstance;
            var _this$props = _this.props, getDatasetAtEvent = _this$props.getDatasetAtEvent, getElementAtEvent = _this$props.getElementAtEvent, getElementsAtEvent = _this$props.getElementsAtEvent, onElementsClick = _this$props.onElementsClick;
            getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
            getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
            getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
            onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
        });
        $991fb83ad4494ad4$var$_defineProperty($991fb83ad4494ad4$var$_assertThisInitialized(_this), "ref", function(element) {
            _this.element = element;
        });
        _this.chartInstance = undefined;
        return _this;
    }
    $991fb83ad4494ad4$var$_createClass(ChartComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.renderChart();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.redraw) {
                    this.destroyChart();
                    this.renderChart();
                    return;
                }
                this.updateChart();
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this$props2 = this.props, redraw = _this$props2.redraw, type = _this$props2.type, options = _this$props2.options, plugins = _this$props2.plugins, legend = _this$props2.legend, height = _this$props2.height, width = _this$props2.width;
                if (nextProps.redraw === true) return true;
                if (height !== nextProps.height || width !== nextProps.width) return true;
                if (type !== nextProps.type) return true;
                if (!(0, $991fb83ad4494ad4$var$_isEqual["default"])(legend, nextProps.legend)) return true;
                if (!(0, $991fb83ad4494ad4$var$_isEqual["default"])(options, nextProps.options)) return true;
                var nextData = this.transformDataProp(nextProps);
                if (!(0, $991fb83ad4494ad4$var$_isEqual["default"])(this.shadowDataProp, nextData)) return true;
                return !(0, $991fb83ad4494ad4$var$_isEqual["default"])(plugins, nextProps.plugins);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyChart();
            }
        },
        {
            key: "transformDataProp",
            value: function transformDataProp(props) {
                var data = props.data;
                if (typeof data == 'function') {
                    var node = this.element;
                    return data(node);
                } else return data;
            } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
        },
        {
            key: "memoizeDataProps",
            value: function memoizeDataProps() {
                if (!this.props.data) return;
                var data = this.transformDataProp(this.props);
                this.shadowDataProp = $991fb83ad4494ad4$var$_objectSpread($991fb83ad4494ad4$var$_objectSpread({}, data), {}, {
                    datasets: data.datasets && data.datasets.map(function(set) {
                        return $991fb83ad4494ad4$var$_objectSpread({}, set);
                    })
                });
                this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed
                return data;
            }
        },
        {
            key: "checkDatasets",
            value: function checkDatasets(datasets) {
                var isDev = $991fb83ad4494ad4$var$NODE_ENV !== 'production' && $991fb83ad4494ad4$var$NODE_ENV !== 'prod';
                var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
                var multipleDatasets = datasets.length > 1;
                if (isDev && multipleDatasets && !usingCustomKeyProvider) {
                    var shouldWarn = false;
                    datasets.forEach(function(dataset) {
                        if (!dataset.label) shouldWarn = true;
                    });
                    if (shouldWarn) console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
                }
            }
        },
        {
            key: "getCurrentDatasets",
            value: function getCurrentDatasets() {
                return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
            }
        },
        {
            key: "saveCurrentDatasets",
            value: function saveCurrentDatasets() {
                var _this2 = this;
                this.datasets = this.datasets || {};
                var currentDatasets = this.getCurrentDatasets();
                currentDatasets.forEach(function(d) {
                    _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
                });
            }
        },
        {
            key: "updateChart",
            value: function updateChart() {
                var _this3 = this;
                var options = this.props.options;
                var data = this.memoizeDataProps(this.props);
                if (!this.chartInstance) return;
                if (options) this.chartInstance.options = $991fb83ad4494ad4$var$_chart["default"].helpers.configMerge(this.chartInstance.options, options);
                 // Pipe datasets to chart instance datasets enabling
                // seamless transitions
                var currentDatasets = this.getCurrentDatasets();
                var nextDatasets = data.datasets || [];
                this.checkDatasets(currentDatasets);
                var currentDatasetsIndexed = (0, $991fb83ad4494ad4$var$_keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
                // on each dataset.
                this.chartInstance.config.data.datasets = nextDatasets.map(function(next) {
                    var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
                    if (current && current.type === next.type && next.data) {
                        // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
                        // The data array must be edited in place. As chart.js adds listeners to it.
                        current.data.splice(next.data.length);
                        next.data.forEach(function(point, pid) {
                            current.data[pid] = next.data[pid];
                        });
                        var _data = next.data, otherProps = $991fb83ad4494ad4$var$_objectWithoutProperties(next, [
                            "data"
                        ]); // Merge properties. Notice a weakness here. If a property is removed
                        // from next, it will be retained by current and never disappears.
                        // Workaround is to set value to null or undefined in next.
                        return $991fb83ad4494ad4$var$_objectSpread($991fb83ad4494ad4$var$_objectSpread({}, current), otherProps);
                    } else return next;
                });
                var datasets = data.datasets, rest = $991fb83ad4494ad4$var$_objectWithoutProperties(data, [
                    "datasets"
                ]);
                this.chartInstance.config.data = $991fb83ad4494ad4$var$_objectSpread($991fb83ad4494ad4$var$_objectSpread({}, this.chartInstance.config.data), rest);
                this.chartInstance.update();
            }
        },
        {
            key: "renderChart",
            value: function renderChart() {
                var _this$props3 = this.props, options = _this$props3.options, legend = _this$props3.legend, type = _this$props3.type, plugins = _this$props3.plugins;
                var node = this.element;
                var data = this.memoizeDataProps();
                if (typeof legend !== 'undefined' && !(0, $991fb83ad4494ad4$var$_isEqual["default"])(ChartComponent.defaultProps.legend, legend)) options.legend = legend;
                this.chartInstance = new $991fb83ad4494ad4$var$_chart["default"](node, {
                    type: type,
                    data: data,
                    options: options,
                    plugins: plugins
                });
            }
        },
        {
            key: "destroyChart",
            value: function destroyChart() {
                if (!this.chartInstance) return;
                 // Put all of the datasets that have existed in the chart back on the chart
                // so that the metadata associated with this chart get destroyed.
                // This allows the datasets to be used in another chart. This can happen,
                // for example, in a tabbed UI where the chart gets created each time the
                // tab gets switched to the chart and uses the same data).
                this.saveCurrentDatasets();
                var datasets = Object.values(this.datasets);
                this.chartInstance.config.data.datasets = datasets;
                this.chartInstance.destroy();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, height = _this$props4.height, width = _this$props4.width, id = _this$props4.id;
                return /*#__PURE__*/ $991fb83ad4494ad4$var$_react["default"].createElement("canvas", {
                    ref: this.ref,
                    height: height,
                    width: width,
                    id: id,
                    onClick: this.handleOnClick
                });
            }
        }
    ]);
    return ChartComponent;
}($991fb83ad4494ad4$var$_react["default"].Component);
$991fb83ad4494ad4$var$_defineProperty($991fb83ad4494ad4$var$ChartComponent, "getLabelAsKey", function(d) {
    return d.label;
});
$991fb83ad4494ad4$var$_defineProperty($991fb83ad4494ad4$var$ChartComponent, "propTypes", {
    data: $991fb83ad4494ad4$var$_propTypes["default"].oneOfType([
        $991fb83ad4494ad4$var$_propTypes["default"].object,
        $991fb83ad4494ad4$var$_propTypes["default"].func
    ]).isRequired,
    getDatasetAtEvent: $991fb83ad4494ad4$var$_propTypes["default"].func,
    getElementAtEvent: $991fb83ad4494ad4$var$_propTypes["default"].func,
    getElementsAtEvent: $991fb83ad4494ad4$var$_propTypes["default"].func,
    height: $991fb83ad4494ad4$var$_propTypes["default"].number,
    legend: $991fb83ad4494ad4$var$_propTypes["default"].object,
    onElementsClick: $991fb83ad4494ad4$var$_propTypes["default"].func,
    options: $991fb83ad4494ad4$var$_propTypes["default"].object,
    plugins: $991fb83ad4494ad4$var$_propTypes["default"].arrayOf($991fb83ad4494ad4$var$_propTypes["default"].object),
    redraw: $991fb83ad4494ad4$var$_propTypes["default"].bool,
    type: function type(props, propName, componentName) {
        if (!$991fb83ad4494ad4$var$_chart["default"].controllers[props[propName]]) return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    },
    width: $991fb83ad4494ad4$var$_propTypes["default"].number,
    datasetKeyProvider: $991fb83ad4494ad4$var$_propTypes["default"].func
});
$991fb83ad4494ad4$var$_defineProperty($991fb83ad4494ad4$var$ChartComponent, "defaultProps", {
    legend: {
        display: true,
        position: 'bottom'
    },
    type: 'doughnut',
    height: 150,
    width: 300,
    redraw: false,
    options: {},
    datasetKeyProvider: $991fb83ad4494ad4$var$ChartComponent.getLabelAsKey
});
var $991fb83ad4494ad4$var$_default = $991fb83ad4494ad4$var$ChartComponent;
$991fb83ad4494ad4$exports["default"] = $991fb83ad4494ad4$var$_default;
var $991fb83ad4494ad4$var$Doughnut = /*#__PURE__*/ function(_React$Component2) {
    $991fb83ad4494ad4$var$_inherits(Doughnut, _React$Component2);
    var _super2 = $991fb83ad4494ad4$var$_createSuper(Doughnut);
    function Doughnut() {
        $991fb83ad4494ad4$var$_classCallCheck(this, Doughnut);
        return _super2.apply(this, arguments);
    }
    $991fb83ad4494ad4$var$_createClass(Doughnut, [
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                return /*#__PURE__*/ $991fb83ad4494ad4$var$_react["default"].createElement($991fb83ad4494ad4$var$ChartComponent, $991fb83ad4494ad4$var$_extends({}, this.props, {
                    ref: function ref(_ref) {
                        return _this4.chartInstance = _ref && _ref.chartInstance;
                    },
                    type: "doughnut"
                }));
            }
        }
    ]);
    return Doughnut;
}($991fb83ad4494ad4$var$_react["default"].Component);
$991fb83ad4494ad4$exports.Doughnut = $991fb83ad4494ad4$var$Doughnut;
var $991fb83ad4494ad4$var$Pie = /*#__PURE__*/ function(_React$Component3) {
    $991fb83ad4494ad4$var$_inherits(Pie, _React$Component3);
    var _super3 = $991fb83ad4494ad4$var$_createSuper(Pie);
    function Pie() {
        $991fb83ad4494ad4$var$_classCallCheck(this, Pie);
        return _super3.apply(this, arguments);
    }
    $991fb83ad4494ad4$var$_createClass(Pie, [
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                return /*#__PURE__*/ $991fb83ad4494ad4$var$_react["default"].createElement($991fb83ad4494ad4$var$ChartComponent, $991fb83ad4494ad4$var$_extends({}, this.props, {
                    ref: function ref(_ref2) {
                        return _this5.chartInstance = _ref2 && _ref2.chartInstance;
                    },
                    type: "pie"
                }));
            }
        }
    ]);
    return Pie;
}($991fb83ad4494ad4$var$_react["default"].Component);
$991fb83ad4494ad4$exports.Pie = $991fb83ad4494ad4$var$Pie;
var $991fb83ad4494ad4$var$Line = /*#__PURE__*/ function(_React$Component4) {
    $991fb83ad4494ad4$var$_inherits(Line, _React$Component4);
    var _super4 = $991fb83ad4494ad4$var$_createSuper(Line);
    function Line() {
        $991fb83ad4494ad4$var$_classCallCheck(this, Line);
        return _super4.apply(this, arguments);
    }
    $991fb83ad4494ad4$var$_createClass(Line, [
        {
            key: "render",
            value: function render() {
                var _this6 = this;
                return /*#__PURE__*/ $991fb83ad4494ad4$var$_react["default"].createElement($991fb83ad4494ad4$var$ChartComponent, $991fb83ad4494ad4$var$_extends({}, this.props, {
                    ref: function ref(_ref3) {
                        return _this6.chartInstance = _ref3 && _ref3.chartInstance;
                    },
                    type: "line"
                }));
            }
        }
    ]);
    return Line;
}($991fb83ad4494ad4$var$_react["default"].Component);
$991fb83ad4494ad4$exports.Line = $991fb83ad4494ad4$var$Line;
var $991fb83ad4494ad4$var$Bar = /*#__PURE__*/ function(_React$Component5) {
    $991fb83ad4494ad4$var$_inherits(Bar, _React$Component5);
    var _super5 = $991fb83ad4494ad4$var$_createSuper(Bar);
    function Bar() {
        $991fb83ad4494ad4$var$_classCallCheck(this, Bar);
        return _super5.apply(this, arguments);
    }
    $991fb83ad4494ad4$var$_createClass(Bar, [
        {
            key: "render",
            value: function render() {
                var _this7 = this;
                return /*#__PURE__*/ $991fb83ad4494ad4$var$_react["default"].createElement($991fb83ad4494ad4$var$ChartComponent, $991fb83ad4494ad4$var$_extends({}, this.props, {
                    ref: function ref(_ref4) {
                        return _this7.chartInstance = _ref4 && _ref4.chartInstance;
                    },
                    type: "bar"
                }));
            }
        }
    ]);
    return Bar;
}($991fb83ad4494ad4$var$_react["default"].Component);
$991fb83ad4494ad4$exports.Bar = $991fb83ad4494ad4$var$Bar;
var $991fb83ad4494ad4$var$HorizontalBar = /*#__PURE__*/ function(_React$Component6) {
    $991fb83ad4494ad4$var$_inherits(HorizontalBar, _React$Component6);
    var _super6 = $991fb83ad4494ad4$var$_createSuper(HorizontalBar);
    function HorizontalBar() {
        $991fb83ad4494ad4$var$_classCallCheck(this, HorizontalBar);
        return _super6.apply(this, arguments);
    }
    $991fb83ad4494ad4$var$_createClass(HorizontalBar, [
        {
            key: "render",
            value: function render() {
                var _this8 = this;
                return /*#__PURE__*/ $991fb83ad4494ad4$var$_react["default"].createElement($991fb83ad4494ad4$var$ChartComponent, $991fb83ad4494ad4$var$_extends({}, this.props, {
                    ref: function ref(_ref5) {
                        return _this8.chartInstance = _ref5 && _ref5.chartInstance;
                    },
                    type: "horizontalBar"
                }));
            }
        }
    ]);
    return HorizontalBar;
}($991fb83ad4494ad4$var$_react["default"].Component);
$991fb83ad4494ad4$exports.HorizontalBar = $991fb83ad4494ad4$var$HorizontalBar;
var $991fb83ad4494ad4$var$Radar = /*#__PURE__*/ function(_React$Component7) {
    $991fb83ad4494ad4$var$_inherits(Radar, _React$Component7);
    var _super7 = $991fb83ad4494ad4$var$_createSuper(Radar);
    function Radar() {
        $991fb83ad4494ad4$var$_classCallCheck(this, Radar);
        return _super7.apply(this, arguments);
    }
    $991fb83ad4494ad4$var$_createClass(Radar, [
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                return /*#__PURE__*/ $991fb83ad4494ad4$var$_react["default"].createElement($991fb83ad4494ad4$var$ChartComponent, $991fb83ad4494ad4$var$_extends({}, this.props, {
                    ref: function ref(_ref6) {
                        return _this9.chartInstance = _ref6 && _ref6.chartInstance;
                    },
                    type: "radar"
                }));
            }
        }
    ]);
    return Radar;
}($991fb83ad4494ad4$var$_react["default"].Component);
$991fb83ad4494ad4$exports.Radar = $991fb83ad4494ad4$var$Radar;
var $991fb83ad4494ad4$var$Polar = /*#__PURE__*/ function(_React$Component8) {
    $991fb83ad4494ad4$var$_inherits(Polar, _React$Component8);
    var _super8 = $991fb83ad4494ad4$var$_createSuper(Polar);
    function Polar() {
        $991fb83ad4494ad4$var$_classCallCheck(this, Polar);
        return _super8.apply(this, arguments);
    }
    $991fb83ad4494ad4$var$_createClass(Polar, [
        {
            key: "render",
            value: function render() {
                var _this10 = this;
                return /*#__PURE__*/ $991fb83ad4494ad4$var$_react["default"].createElement($991fb83ad4494ad4$var$ChartComponent, $991fb83ad4494ad4$var$_extends({}, this.props, {
                    ref: function ref(_ref7) {
                        return _this10.chartInstance = _ref7 && _ref7.chartInstance;
                    },
                    type: "polarArea"
                }));
            }
        }
    ]);
    return Polar;
}($991fb83ad4494ad4$var$_react["default"].Component);
$991fb83ad4494ad4$exports.Polar = $991fb83ad4494ad4$var$Polar;
var $991fb83ad4494ad4$var$Bubble = /*#__PURE__*/ function(_React$Component9) {
    $991fb83ad4494ad4$var$_inherits(Bubble, _React$Component9);
    var _super9 = $991fb83ad4494ad4$var$_createSuper(Bubble);
    function Bubble() {
        $991fb83ad4494ad4$var$_classCallCheck(this, Bubble);
        return _super9.apply(this, arguments);
    }
    $991fb83ad4494ad4$var$_createClass(Bubble, [
        {
            key: "render",
            value: function render() {
                var _this11 = this;
                return /*#__PURE__*/ $991fb83ad4494ad4$var$_react["default"].createElement($991fb83ad4494ad4$var$ChartComponent, $991fb83ad4494ad4$var$_extends({}, this.props, {
                    ref: function ref(_ref8) {
                        return _this11.chartInstance = _ref8 && _ref8.chartInstance;
                    },
                    type: "bubble"
                }));
            }
        }
    ]);
    return Bubble;
}($991fb83ad4494ad4$var$_react["default"].Component);
$991fb83ad4494ad4$exports.Bubble = $991fb83ad4494ad4$var$Bubble;
var $991fb83ad4494ad4$var$Scatter = /*#__PURE__*/ function(_React$Component10) {
    $991fb83ad4494ad4$var$_inherits(Scatter, _React$Component10);
    var _super10 = $991fb83ad4494ad4$var$_createSuper(Scatter);
    function Scatter() {
        $991fb83ad4494ad4$var$_classCallCheck(this, Scatter);
        return _super10.apply(this, arguments);
    }
    $991fb83ad4494ad4$var$_createClass(Scatter, [
        {
            key: "render",
            value: function render() {
                var _this12 = this;
                return /*#__PURE__*/ $991fb83ad4494ad4$var$_react["default"].createElement($991fb83ad4494ad4$var$ChartComponent, $991fb83ad4494ad4$var$_extends({}, this.props, {
                    ref: function ref(_ref9) {
                        return _this12.chartInstance = _ref9 && _ref9.chartInstance;
                    },
                    type: "scatter"
                }));
            }
        }
    ]);
    return Scatter;
}($991fb83ad4494ad4$var$_react["default"].Component);
$991fb83ad4494ad4$exports.Scatter = $991fb83ad4494ad4$var$Scatter;
var $991fb83ad4494ad4$var$defaults = $991fb83ad4494ad4$var$_chart["default"].defaults;
$991fb83ad4494ad4$exports.defaults = $991fb83ad4494ad4$var$defaults;


const $803e9b9f767390d1$export$29f9f81de5c56283 = {
    F27: {
        s: `
      <div>
        The 27-S has the highest central sharpness of all BLACKWING<sup>7</sup> S-variants, with good rectilinear imaging, low breathing and good field illumination. Contrast is higher than T and X, with less roll-off across the fame.
      </div>
    `,
        t: `
      <div>
        The 27-T has the highest central sharpness of all BLACKWING<sup>7</sup> T-variants, with good rectilinear imaging, subtle halation, low breathing and good field illumination across the frame.
      </div>
    `,
        x: `
      <div>
        The 27-X has the same rectilinear imaging, breathing and field illumination as its S and T BLACKWING<sup>7</sup> counterparts. Contrast roll-off is more accentuated and diffused than T, particularly under flaring conditions.
      </div>
    `
    },
    F37: {
        s: `
      <div>
        The 37-S has tighter central contrast and a reduced resonant veiling flare characteristic compared to the 37-T BLACKWING<sup>7</sup> prime. The overall look of the 37-S is similar to the 27-S and 47-T primes in the BLACKWING<sup>7</sup> range.
      </div>
    `,
        t: `
      <div>
        The 37-T has a large image circle, suitable for 65mm format capture, has good central contrast and the strongest pupil flare characteristic of all the BLACKWING<sup>7</sup> T-tuned lenses. The overall look of the 37-T is unique within the BLACKWING<sup>7</sup> range.
      </div>
    `,
        x: `
      <div>
        The 37-X has lower central contrast and a strong but diffused resonant flare characteristic - the look of the 37-X when flared is milkier and softer than the 37-T BLACKWING<sup>7</sup> prime.
      </div>
    `
    },
    F47: {
        s: `
      <div>
        The 47-S is the workhorse BLACKWING<sup>7</sup> focal length for large format 35mm capture, with good central contrast and well controlled flare.
      </div>
    `,
        t: `
      <div>
        The 47-T has softer halation properties than the 57-T, with more controlled flare and shallower roll-off across the frame. The 47-T is the workhorse BLACKWING<sup>7</sup> focal length for large format 35mm capture.
      </div>
    `,
        x: `
      <div>
        The 47-X has softer central contrast than its T counterpart, with more veiling flare and roll-off across the frame. The 47-X is especially suited to medium-wide portraiture work.
      </div>
    `
    },
    F57: {
        s: `
      <div>
        The 57-S has sharper central contrast and a reduced resonant pupil flare characteristic compared to the 57-T BLACKWING<sup>7</sup> prime. The overall look of the 57-S is similar to the 77-S prime.
      </div>
    `,
        t: `
      <div>
        The 57-T has a high level of edge halation wide open, and a smooth, soft image with a creamy overall look as the lens is stopped down. The 57-T has a vibrant lenticular flare characteristic similar to the 37-T, and is a hero focal length for 65mm format capture.
      </div>
    `,
        x: `
      <div>
        The 57-X has reduced central contrast and a more defined resonant pupil flare characteristic compared to the 57-T BLACKWING<sup>7</sup> prime. Under hard flaring, the 57-X exhibits strong veiling characteristics but still produces a defined, impressionistic image.
      </div>
    `
    },
    F77: {
        s: `
      <div>
        The 77-S is a pure medium format portrait lens - with good central contrast and definition wide open, reducing in sharpness and smoothly rolling off to the edge of the image. The 77-S has more controlled pupil flare than its 77-T counterpart.
      </div>
    `,
        t: `
      <div>
        The 77-T offers beautiful, almost painterly imaging qualities. The lens has low contrast and is creamy-smooth wide open, with a subtle level of edge halation, and accentuated roll-off.
      </div>
    `,
        x: `
      <div>
        The 77-X prime has lower central contrast and a strong but diffused resonant flare characteristic compared to 77-T. The look of the 77-X is soft and flattering when used in medium format portraiture work.
      </div>
    `
    },
    F107: {
        s: `
      <div>
        The 107-S  has a characteristic similar to the 137-S BLACKWING<sup>7</sup> prime, well protected under flare conditions and with higher central contrast. Though well and truly a telephoto focal length, wide open the lens has a subtle softness and retains the BLACKWING<sup>7</sup> vintage 'look'.
      </div>
    `,
        t: `
      <div>
        The 107-T has relatively modest sharpness for a telephoto focal length \u{2014} allowing flattering portraiture whilst still retaining good micro-contrast to render distant fine textures accurately. The lens has smooth halation at high contrast edges and a creamy bokeh.
      </div>
    `,
        x: `
      <div>
        The 107-X has a characteristic similar to the 77X BLACKWING<sup>7</sup> prime, with reduced contrast under flare conditions due to its uncoated element structures. Despite being semi-telephoto in nature, the lens has a subtle softness and produces a true vintage look.
      </div>
    `
    },
    F137: {
        s: `
      <div>
        The 137-S has good, but not high central sharpness despite its long focal length. In many ways the 137-S prime defies conventionality and has imaging properties unlike many other large format telephoto lenses. 
      </div>
    `,
        t: `
      <div>
        The 137-T has characteristics like the 107-T BLACKWING<sup>7</sup> prime, with good flare control and slightly higher contrast. Though well and truly a telephoto focal length, wide open the lens has a subtle softness and retains the BLACKWING<sup>7</sup> vintage \u{201C}look\u{201D}.
      </div>
    `,
        x: `
      <div>
        The 137-X has very modest sharpness for a telephoto focal length \u{2014} designed for flattering portraiture work at longer ranges, the lens has smooth halation and a creamy \u{201C}big\u{201D} bokeh.
      </div>
    `
    }
};
const $803e9b9f767390d1$var$solid = {
    showLine: true,
    borderCapStyle: 'round',
    borderWidth: 2,
    pointRadius: 0,
    backgroundColor: 'transparent'
};
const $803e9b9f767390d1$var$dashed = {
    showLine: true,
    borderCapStyle: 'butt',
    borderDash: [
        6,
        6
    ],
    borderWidth: 2,
    pointRadius: 0,
    backgroundColor: 'transparent'
};
const $803e9b9f767390d1$var$yellow = {
    borderColor: '#9b8235'
};
const $803e9b9f767390d1$var$blue = {
    borderColor: '#1f525e'
};
const $803e9b9f767390d1$var$red = {
    borderColor: '#b42000'
};
const $803e9b9f767390d1$export$fa75311891f179ce = {
    '27': {
        data: {
            's': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.982,
                        0.983,
                        0.985,
                        0.985,
                        0.985,
                        0.985,
                        0.983,
                        0.980,
                        0.975,
                        0.965,
                        0.955,
                        0.950,
                        0.950,
                        0.953,
                        0.960,
                        0.968,
                        0.980,
                        0.995,
                        0.980,
                        0.940
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.979,
                        0.978,
                        0.977,
                        0.976,
                        0.975,
                        0.966,
                        0.955,
                        0.945,
                        0.925,
                        0.910,
                        0.880,
                        0.850,
                        0.815,
                        0.770,
                        0.690,
                        0.600,
                        0.480,
                        0.380
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.950,
                        0.950,
                        0.9525,
                        0.955,
                        0.9575,
                        0.962,
                        0.965,
                        0.968,
                        0.963,
                        0.945,
                        0.925,
                        0.903,
                        0.880,
                        0.860,
                        0.840,
                        0.825,
                        0.822,
                        0.827,
                        0.845,
                        0.880,
                        0.927,
                        0.975,
                        0.940,
                        0.780
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.950,
                        0.95,
                        0.95,
                        0.95,
                        0.950,
                        0.950,
                        0.947,
                        0.945,
                        0.940,
                        0.925,
                        0.905,
                        0.880,
                        0.855,
                        0.815,
                        0.765,
                        0.700,
                        0.630,
                        0.550,
                        0.440,
                        0.330,
                        0.280,
                        0.270,
                        0.280,
                        0.275
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.880,
                        0.880,
                        0.882,
                        0.890,
                        0.900,
                        0.915,
                        0.920,
                        0.910,
                        0.880,
                        0.840,
                        0.785,
                        0.720,
                        0.650,
                        0.585,
                        0.525,
                        0.485,
                        0.470,
                        0.490,
                        0.560,
                        0.660,
                        0.780,
                        0.860,
                        0.810,
                        0.600
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.880,
                        0.880,
                        0.880,
                        0.880,
                        0.885,
                        0.890,
                        0.890,
                        0.880,
                        0.850,
                        0.810,
                        0.750,
                        0.680,
                        0.610,
                        0.520,
                        0.420,
                        0.380,
                        0.360,
                        0.360,
                        0.340,
                        0.300,
                        0.260,
                        0.220,
                        0.170,
                        0.130
                    ]
                }
            ],
            't': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.958,
                        0.958,
                        0.959,
                        0.960,
                        0.961,
                        0.962,
                        0.962,
                        0.961,
                        0.960,
                        0.959,
                        0.955,
                        0.946,
                        0.938,
                        0.925,
                        0.914,
                        0.901,
                        0.890,
                        0.880,
                        0.870,
                        0.857,
                        0.838,
                        0.804,
                        0.748,
                        0.655
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.958,
                        0.958,
                        0.959,
                        0.961,
                        0.963,
                        0.965,
                        0.969,
                        0.968,
                        0.966,
                        0.960,
                        0.956,
                        0.947,
                        0.940,
                        0.929,
                        0.916,
                        0.903,
                        0.884,
                        0.860,
                        0.819,
                        0.770,
                        0.698,
                        0.600,
                        0.495,
                        0.425
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.875,
                        0.883,
                        0.889,
                        0.894,
                        0.899,
                        0.903,
                        0.905,
                        0.906,
                        0.901,
                        0.881,
                        0.854,
                        0.822,
                        0.790,
                        0.763,
                        0.746,
                        0.735,
                        0.731,
                        0.734,
                        0.742,
                        0.756,
                        0.757,
                        0.709,
                        0.573,
                        0.386
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.875,
                        0.886,
                        0.894,
                        0.901,
                        0.907,
                        0.914,
                        0.916,
                        0.911,
                        0.903,
                        0.888,
                        0.869,
                        0.844,
                        0.814,
                        0.774,
                        0.731,
                        0.685,
                        0.638,
                        0.580,
                        0.493,
                        0.383,
                        0.280,
                        0.251,
                        0.258,
                        0.260
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.760,
                        0.764,
                        0.772,
                        0.785,
                        0.805,
                        0.816,
                        0.810,
                        0.786,
                        0.745,
                        0.690,
                        0.616,
                        0.533,
                        0.455,
                        0.398,
                        0.360,
                        0.346,
                        0.358,
                        0.400,
                        0.470,
                        0.555,
                        0.608,
                        0.590,
                        0.435,
                        0.173
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.760,
                        0.764,
                        0.771,
                        0.783,
                        0.799,
                        0.805,
                        0.796,
                        0.775,
                        0.745,
                        0.705,
                        0.655,
                        0.590,
                        0.528,
                        0.460,
                        0.398,
                        0.358,
                        0.330,
                        0.315,
                        0.303,
                        0.278,
                        0.230,
                        0.175,
                        0.125,
                        0.123
                    ]
                }
            ],
            'x': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.950,
                        0.951,
                        0.952,
                        0.953,
                        0.954,
                        0.955,
                        0.954,
                        0.953,
                        0.952,
                        0.950,
                        0.945,
                        0.935,
                        0.925,
                        0.912,
                        0.900,
                        0.885,
                        0.870,
                        0.855,
                        0.840,
                        0.820,
                        0.790,
                        0.740,
                        0.670,
                        0.560
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.950,
                        0.951,
                        0.952,
                        0.954,
                        0.957,
                        0.960,
                        0.965,
                        0.965,
                        0.962,
                        0.955,
                        0.950,
                        0.940,
                        0.935,
                        0.924,
                        0.913,
                        0.900,
                        0.885,
                        0.863,
                        0.820,
                        0.770,
                        0.700,
                        0.600,
                        0.500,
                        0.440
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.850,
                        0.860,
                        0.868,
                        0.873,
                        0.88,
                        0.883,
                        0.885,
                        0.885,
                        0.880,
                        0.860,
                        0.830,
                        0.795,
                        0.760,
                        0.730,
                        0.715,
                        0.705,
                        0.701,
                        0.703,
                        0.708,
                        0.714,
                        0.700,
                        0.620,
                        0.450,
                        0.255
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.850,
                        0.865,
                        0.875,
                        0.884,
                        0.893,
                        0.902,
                        0.905,
                        0.900,
                        0.890,
                        0.875,
                        0.857,
                        0.832,
                        0.800,
                        0.760,
                        0.720,
                        0.680,
                        0.640,
                        0.590,
                        0.510,
                        0.400,
                        0.280,
                        0.245,
                        0.250,
                        0.255
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.720,
                        0.725,
                        0.735,
                        0.750,
                        0.773,
                        0.783,
                        0.773,
                        0.745,
                        0.700,
                        0.640,
                        0.560,
                        0.470,
                        0.390,
                        0.335,
                        0.305,
                        0.300,
                        0.320,
                        0.370,
                        0.440,
                        0.520,
                        0.550,
                        0.500,
                        0.310,
                        0.030
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.720,
                        0.725,
                        0.735,
                        0.750,
                        0.770,
                        0.777,
                        0.765,
                        0.740,
                        0.710,
                        0.670,
                        0.623,
                        0.560,
                        0.500,
                        0.440,
                        0.390,
                        0.350,
                        0.320,
                        0.300,
                        0.290,
                        0.270,
                        0.220,
                        0.160,
                        0.110,
                        0.120
                    ]
                }
            ]
        }
    },
    '37': {
        data: {
            's': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.979,
                        0.978,
                        0.977,
                        0.976,
                        0.973,
                        0.968,
                        0.960,
                        0.953,
                        0.950,
                        0.950,
                        0.950,
                        0.953,
                        0.960,
                        0.970,
                        0.980,
                        0.985,
                        0.980,
                        0.950
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.980,
                        0.979,
                        0.978,
                        0.977,
                        0.976,
                        0.974,
                        0.972,
                        0.970,
                        0.965,
                        0.958,
                        0.950,
                        0.945,
                        0.940,
                        0.938,
                        0.940,
                        0.941,
                        0.942,
                        0.945,
                        0.950,
                        0.958,
                        0.960,
                        0.955,
                        0.948,
                        0.940
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.960,
                        0.960,
                        0.960,
                        0.958,
                        0.955,
                        0.950,
                        0.945,
                        0.935,
                        0.925,
                        0.913,
                        0.900,
                        0.885,
                        0.868,
                        0.850,
                        0.835,
                        0.827,
                        0.827,
                        0.840,
                        0.862,
                        0.890,
                        0.918,
                        0.935,
                        0.920,
                        0.850
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.960,
                        0.957,
                        0.950,
                        0.945,
                        0.937,
                        0.920,
                        0.900,
                        0.880,
                        0.860,
                        0.840,
                        0.820,
                        0.805,
                        0.790,
                        0.780,
                        0.780,
                        0.785,
                        0.805,
                        0.820,
                        0.845,
                        0.865,
                        0.880,
                        0.875,
                        0.865,
                        0.845
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.890,
                        0.890,
                        0.890,
                        0.887,
                        0.880,
                        0.865,
                        0.845,
                        0.820,
                        0.787,
                        0.750,
                        0.700,
                        0.650,
                        0.600,
                        0.553,
                        0.515,
                        0.490,
                        0.483,
                        0.500,
                        0.560,
                        0.640,
                        0.720,
                        0.780,
                        0.775,
                        0.710
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.890,
                        0.880,
                        0.865,
                        0.840,
                        0.800,
                        0.750,
                        0.700,
                        0.650,
                        0.600,
                        0.550,
                        0.510,
                        0.475,
                        0.453,
                        0.435,
                        0.425,
                        0.426,
                        0.445,
                        0.475,
                        0.530,
                        0.610,
                        0.650,
                        0.660,
                        0.640,
                        0.590
                    ]
                }
            ],
            't': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.973,
                        0.971,
                        0.969,
                        0.965,
                        0.961,
                        0.954,
                        0.946,
                        0.938,
                        0.931,
                        0.923,
                        0.918,
                        0.910,
                        0.900,
                        0.891,
                        0.883,
                        0.875,
                        0.871,
                        0.872,
                        0.878,
                        0.891,
                        0.905,
                        0.906,
                        0.898,
                        0.883
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.973,
                        0.971,
                        0.967,
                        0.962,
                        0.954,
                        0.941,
                        0.933,
                        0.925,
                        0.920,
                        0.915,
                        0.913,
                        0.915,
                        0.918,
                        0.921,
                        0.925,
                        0.929,
                        0.931,
                        0.934,
                        0.935,
                        0.933,
                        0.926,
                        0.914,
                        0.890,
                        0.865
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.855,
                        0.851,
                        0.848,
                        0.843,
                        0.839,
                        0.834,
                        0.827,
                        0.819,
                        0.809,
                        0.798,
                        0.788,
                        0.776,
                        0.765,
                        0.753,
                        0.740,
                        0.726,
                        0.709,
                        0.690,
                        0.666,
                        0.635,
                        0.605,
                        0.571,
                        0.530,
                        0.475
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.855,
                        0.847,
                        0.838,
                        0.829,
                        0.812,
                        0.793,
                        0.765,
                        0.738,
                        0.706,
                        0.683,
                        0.663,
                        0.651,
                        0.644,
                        0.638,
                        0.634,
                        0.631,
                        0.633,
                        0.633,
                        0.635,
                        0.636,
                        0.633,
                        0.624,
                        0.614,
                        0.601
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.673,
                        0.665,
                        0.658,
                        0.649,
                        0.640,
                        0.629,
                        0.616,
                        0.603,
                        0.587,
                        0.570,
                        0.552,
                        0.534,
                        0.518,
                        0.502,
                        0.489,
                        0.477,
                        0.466,
                        0.451,
                        0.433,
                        0.411,
                        0.394,
                        0.383,
                        0.374,
                        0.365
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.673,
                        0.633,
                        0.591,
                        0.555,
                        0.523,
                        0.488,
                        0.456,
                        0.425,
                        0.394,
                        0.370,
                        0.353,
                        0.340,
                        0.333,
                        0.326,
                        0.324,
                        0.324,
                        0.330,
                        0.340,
                        0.355,
                        0.376,
                        0.388,
                        0.388,
                        0.381,
                        0.365
                    ]
                }
            ],
            'x': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.970,
                        0.968,
                        0.965,
                        0.960,
                        0.955,
                        0.945,
                        0.935,
                        0.925,
                        0.915,
                        0.905,
                        0.900,
                        0.890,
                        0.880,
                        0.870,
                        0.860,
                        0.850,
                        0.845,
                        0.845,
                        0.850,
                        0.865,
                        0.880,
                        0.880,
                        0.870,
                        0.860
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.970,
                        0.968,
                        0.963,
                        0.957,
                        0.946,
                        0.930,
                        0.920,
                        0.910,
                        0.905,
                        0.900,
                        0.900,
                        0.905,
                        0.910,
                        0.915,
                        0.920,
                        0.925,
                        0.927,
                        0.930,
                        0.930,
                        0.925,
                        0.915,
                        0.900,
                        0.870,
                        0.840
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.820,
                        0.815,
                        0.810,
                        0.805,
                        0.800,
                        0.795,
                        0.788,
                        0.780,
                        0.770,
                        0.760,
                        0.750,
                        0.740,
                        0.730,
                        0.720,
                        0.708,
                        0.692,
                        0.670,
                        0.640,
                        0.600,
                        0.550,
                        0.500,
                        0.450,
                        0.400,
                        0.350
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.820,
                        0.81,
                        0.8,
                        0.79,
                        0.770,
                        0.750,
                        0.720,
                        0.690,
                        0.655,
                        0.630,
                        0.610,
                        0.600,
                        0.595,
                        0.590,
                        0.585,
                        0.580,
                        0.575,
                        0.570,
                        0.565,
                        0.560,
                        0.550,
                        0.540,
                        0.530,
                        0.520
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.600,
                        0.590,
                        0.580,
                        0.570,
                        0.560,
                        0.550,
                        0.540,
                        0.530,
                        0.520,
                        0.510,
                        0.502,
                        0.495,
                        0.490,
                        0.485,
                        0.480,
                        0.472,
                        0.460,
                        0.435,
                        0.390,
                        0.335,
                        0.285,
                        0.250,
                        0.240,
                        0.250
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.600,
                        0.550,
                        0.500,
                        0.460,
                        0.430,
                        0.400,
                        0.375,
                        0.350,
                        0.325,
                        0.310,
                        0.300,
                        0.295,
                        0.293,
                        0.290,
                        0.290,
                        0.290,
                        0.292,
                        0.295,
                        0.297,
                        0.298,
                        0.300,
                        0.297,
                        0.295,
                        0.290
                    ]
                }
            ]
        }
    },
    '47': {
        data: {
            's': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.978,
                        0.975,
                        0.970,
                        0.965,
                        0.960,
                        0.957,
                        0.955,
                        0.955,
                        0.955,
                        0.953,
                        0.950,
                        0.945,
                        0.930,
                        0.890,
                        0.830,
                        0.760
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.979,
                        0.978,
                        0.977,
                        0.976,
                        0.974,
                        0.972,
                        0.970,
                        0.967,
                        0.960,
                        0.945,
                        0.925,
                        0.910,
                        0.890,
                        0.875,
                        0.865,
                        0.850,
                        0.825,
                        0.790,
                        0.755,
                        0.690
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.960,
                        0.960,
                        0.960,
                        0.958,
                        0.956,
                        0.954,
                        0.950,
                        0.943,
                        0.935,
                        0.923,
                        0.910,
                        0.900,
                        0.889,
                        0.880,
                        0.875,
                        0.872,
                        0.870,
                        0.870,
                        0.869,
                        0.845,
                        0.790,
                        0.700,
                        0.570,
                        0.390
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.960,
                        0.96,
                        0.962,
                        0.96,
                        0.960,
                        0.960,
                        0.955,
                        0.950,
                        0.940,
                        0.930,
                        0.915,
                        0.900,
                        0.875,
                        0.830,
                        0.790,
                        0.750,
                        0.720,
                        0.690,
                        0.675,
                        0.660,
                        0.650,
                        0.625,
                        0.600,
                        0.525
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.910,
                        0.910,
                        0.904,
                        0.900,
                        0.890,
                        0.880,
                        0.860,
                        0.825,
                        0.790,
                        0.750,
                        0.710,
                        0.670,
                        0.635,
                        0.610,
                        0.595,
                        0.590,
                        0.592,
                        0.600,
                        0.605,
                        0.590,
                        0.520,
                        0.450,
                        0.400,
                        0.350
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.910,
                        0.910,
                        0.907,
                        0.902,
                        0.900,
                        0.895,
                        0.890,
                        0.875,
                        0.850,
                        0.815,
                        0.780,
                        0.730,
                        0.680,
                        0.640,
                        0.600,
                        0.550,
                        0.520,
                        0.500,
                        0.475,
                        0.445,
                        0.400,
                        0.350,
                        0.310,
                        0.230
                    ]
                }
            ],
            't': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.935,
                        0.935,
                        0.935,
                        0.935,
                        0.933,
                        0.931,
                        0.928,
                        0.924,
                        0.917,
                        0.913,
                        0.908,
                        0.901,
                        0.894,
                        0.887,
                        0.880,
                        0.869,
                        0.856,
                        0.838,
                        0.815,
                        0.789,
                        0.758,
                        0.725,
                        0.688,
                        0.655
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.935,
                        0.935,
                        0.931,
                        0.928,
                        0.924,
                        0.920,
                        0.912,
                        0.904,
                        0.900,
                        0.897,
                        0.895,
                        0.893,
                        0.890,
                        0.885,
                        0.878,
                        0.876,
                        0.871,
                        0.873,
                        0.876,
                        0.869,
                        0.844,
                        0.798,
                        0.714,
                        0.585
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.855,
                        0.855,
                        0.855,
                        0.851,
                        0.847,
                        0.841,
                        0.834,
                        0.827,
                        0.819,
                        0.808,
                        0.796,
                        0.784,
                        0.770,
                        0.756,
                        0.744,
                        0.728,
                        0.713,
                        0.698,
                        0.676,
                        0.646,
                        0.603,
                        0.550,
                        0.495,
                        0.435
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.855,
                        0.851,
                        0.848,
                        0.836,
                        0.818,
                        0.803,
                        0.794,
                        0.785,
                        0.775,
                        0.765,
                        0.754,
                        0.743,
                        0.729,
                        0.710,
                        0.695,
                        0.683,
                        0.679,
                        0.675,
                        0.662,
                        0.630,
                        0.568,
                        0.479,
                        0.375,
                        0.229
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.700,
                        0.700,
                        0.699,
                        0.698,
                        0.694,
                        0.687,
                        0.676,
                        0.660,
                        0.642,
                        0.620,
                        0.598,
                        0.573,
                        0.549,
                        0.528,
                        0.509,
                        0.493,
                        0.478,
                        0.458,
                        0.429,
                        0.380,
                        0.318,
                        0.270,
                        0.243,
                        0.223
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.700,
                        0.693,
                        0.677,
                        0.661,
                        0.645,
                        0.629,
                        0.616,
                        0.601,
                        0.588,
                        0.571,
                        0.555,
                        0.535,
                        0.515,
                        0.501,
                        0.488,
                        0.475,
                        0.460,
                        0.425,
                        0.344,
                        0.261,
                        0.198,
                        0.148,
                        0.115,
                        0.106
                    ]
                }
            ],
            'x': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.920,
                        0.920,
                        0.920,
                        0.920,
                        0.917,
                        0.915,
                        0.910,
                        0.905,
                        0.897,
                        0.893,
                        0.887,
                        0.880,
                        0.872,
                        0.863,
                        0.855,
                        0.840,
                        0.823,
                        0.800,
                        0.770,
                        0.737,
                        0.700,
                        0.670,
                        0.640,
                        0.620
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.920,
                        0.920,
                        0.915,
                        0.910,
                        0.905,
                        0.900,
                        0.890,
                        0.880,
                        0.875,
                        0.872,
                        0.870,
                        0.868,
                        0.867,
                        0.865,
                        0.862,
                        0.865,
                        0.865,
                        0.872,
                        0.880,
                        0.875,
                        0.850,
                        0.800,
                        0.700,
                        0.550
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.820,
                        0.820,
                        0.820,
                        0.815,
                        0.810,
                        0.803,
                        0.795,
                        0.788,
                        0.780,
                        0.770,
                        0.758,
                        0.745,
                        0.730,
                        0.715,
                        0.700,
                        0.680,
                        0.660,
                        0.640,
                        0.612,
                        0.580,
                        0.540,
                        0.500,
                        0.470,
                        0.450
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.820,
                        0.815,
                        0.81,
                        0.795,
                        0.770,
                        0.750,
                        0.740,
                        0.730,
                        0.720,
                        0.710,
                        0.700,
                        0.690,
                        0.680,
                        0.670,
                        0.663,
                        0.660,
                        0.665,
                        0.670,
                        0.657,
                        0.620,
                        0.540,
                        0.430,
                        0.300,
                        0.130
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.630,
                        0.630,
                        0.630,
                        0.630,
                        0.628,
                        0.623,
                        0.615,
                        0.605,
                        0.592,
                        0.576,
                        0.560,
                        0.540,
                        0.520,
                        0.500,
                        0.480,
                        0.460,
                        0.440,
                        0.410,
                        0.370,
                        0.310,
                        0.250,
                        0.210,
                        0.190,
                        0.180
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.630,
                        0.620,
                        0.600,
                        0.580,
                        0.560,
                        0.540,
                        0.525,
                        0.510,
                        0.500,
                        0.490,
                        0.480,
                        0.470,
                        0.460,
                        0.455,
                        0.450,
                        0.450,
                        0.440,
                        0.400,
                        0.300,
                        0.200,
                        0.130,
                        0.080,
                        0.050,
                        0.065
                    ]
                }
            ]
        }
    },
    '57': {
        data: {
            's': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.979,
                        0.977,
                        0.974,
                        0.970,
                        0.965,
                        0.960,
                        0.955,
                        0.952,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.948,
                        0.945,
                        0.930,
                        0.900,
                        0.850
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.978,
                        0.975,
                        0.970,
                        0.960,
                        0.950,
                        0.940,
                        0.930,
                        0.925,
                        0.915,
                        0.905,
                        0.895,
                        0.880,
                        0.870,
                        0.860,
                        0.850,
                        0.840,
                        0.820,
                        0.790
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.950,
                        0.950,
                        0.948,
                        0.945,
                        0.94,
                        0.933,
                        0.925,
                        0.918,
                        0.910,
                        0.900,
                        0.888,
                        0.875,
                        0.860,
                        0.848,
                        0.837,
                        0.828,
                        0.822,
                        0.820,
                        0.819,
                        0.818,
                        0.815,
                        0.800,
                        0.750,
                        0.640
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.950,
                        0.949,
                        0.948,
                        0.945,
                        0.940,
                        0.927,
                        0.920,
                        0.905,
                        0.890,
                        0.875,
                        0.860,
                        0.845,
                        0.830,
                        0.810,
                        0.800,
                        0.790,
                        0.780,
                        0.760,
                        0.750,
                        0.730,
                        0.715,
                        0.690,
                        0.650,
                        0.580
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.870,
                        0.865,
                        0.862,
                        0.855,
                        0.840,
                        0.820,
                        0.792,
                        0.760,
                        0.725,
                        0.690,
                        0.650,
                        0.610,
                        0.570,
                        0.530,
                        0.500,
                        0.485,
                        0.480,
                        0.480,
                        0.485,
                        0.490,
                        0.492,
                        0.490,
                        0.477,
                        0.450
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.870,
                        0.860,
                        0.845,
                        0.830,
                        0.815,
                        0.795,
                        0.775,
                        0.745,
                        0.720,
                        0.690,
                        0.670,
                        0.650,
                        0.630,
                        0.610,
                        0.580,
                        0.560,
                        0.535,
                        0.510,
                        0.485,
                        0.460,
                        0.430,
                        0.390,
                        0.320,
                        0.225
                    ]
                }
            ],
            't': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.958,
                        0.958,
                        0.958,
                        0.958,
                        0.955,
                        0.954,
                        0.948,
                        0.942,
                        0.934,
                        0.926,
                        0.918,
                        0.909,
                        0.900,
                        0.891,
                        0.885,
                        0.881,
                        0.879,
                        0.877,
                        0.879,
                        0.880,
                        0.883,
                        0.885,
                        0.885,
                        0.880
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.958,
                        0.958,
                        0.958,
                        0.958,
                        0.958,
                        0.958,
                        0.957,
                        0.956,
                        0.955,
                        0.953,
                        0.950,
                        0.945,
                        0.941,
                        0.936,
                        0.930,
                        0.920,
                        0.906,
                        0.888,
                        0.866,
                        0.843,
                        0.813,
                        0.769,
                        0.715,
                        0.666
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.823,
                        0.823,
                        0.818,
                        0.812,
                        0.805,
                        0.796,
                        0.786,
                        0.777,
                        0.768,
                        0.758,
                        0.747,
                        0.735,
                        0.721,
                        0.706,
                        0.689,
                        0.672,
                        0.656,
                        0.640,
                        0.625,
                        0.610,
                        0.594,
                        0.579,
                        0.563,
                        0.539
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.823,
                        0.800,
                        0.777,
                        0.754,
                        0.726,
                        0.704,
                        0.684,
                        0.665,
                        0.650,
                        0.643,
                        0.635,
                        0.635,
                        0.635,
                        0.634,
                        0.635,
                        0.633,
                        0.626,
                        0.610,
                        0.593,
                        0.569,
                        0.543,
                        0.514,
                        0.481,
                        0.445
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.578,
                        0.569,
                        0.559,
                        0.544,
                        0.525,
                        0.505,
                        0.485,
                        0.468,
                        0.454,
                        0.443,
                        0.431,
                        0.421,
                        0.410,
                        0.398,
                        0.389,
                        0.380,
                        0.374,
                        0.364,
                        0.350,
                        0.333,
                        0.318,
                        0.307,
                        0.303,
                        0.300
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.578,
                        0.553,
                        0.519,
                        0.493,
                        0.466,
                        0.435,
                        0.411,
                        0.389,
                        0.375,
                        0.364,
                        0.360,
                        0.361,
                        0.368,
                        0.385,
                        0.402,
                        0.406,
                        0.393,
                        0.368,
                        0.339,
                        0.310,
                        0.280,
                        0.248,
                        0.208,
                        0.154
                    ]
                }
            ],
            'x': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.947,
                        0.945,
                        0.937,
                        0.930,
                        0.920,
                        0.910,
                        0.900,
                        0.890,
                        0.880,
                        0.870,
                        0.863,
                        0.858,
                        0.855,
                        0.853,
                        0.855,
                        0.857,
                        0.862,
                        0.870,
                        0.880,
                        0.890
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.947,
                        0.945,
                        0.940,
                        0.935,
                        0.925,
                        0.910,
                        0.890,
                        0.865,
                        0.837,
                        0.800,
                        0.745,
                        0.680,
                        0.625
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.780,
                        0.780,
                        0.775,
                        0.768,
                        0.76,
                        0.750,
                        0.740,
                        0.730,
                        0.720,
                        0.710,
                        0.700,
                        0.688,
                        0.675,
                        0.658,
                        0.640,
                        0.620,
                        0.600,
                        0.580,
                        0.560,
                        0.540,
                        0.520,
                        0.505,
                        0.500,
                        0.505
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.780,
                        0.75,
                        0.72,
                        0.69,
                        0.655,
                        0.630,
                        0.605,
                        0.585,
                        0.570,
                        0.565,
                        0.560,
                        0.565,
                        0.570,
                        0.575,
                        0.580,
                        0.580,
                        0.575,
                        0.560,
                        0.540,
                        0.515,
                        0.485,
                        0.455,
                        0.425,
                        0.400
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.480,
                        0.470,
                        0.458,
                        0.440,
                        0.420,
                        0.400,
                        0.383,
                        0.370,
                        0.363,
                        0.360,
                        0.358,
                        0.358,
                        0.356,
                        0.354,
                        0.352,
                        0.345,
                        0.338,
                        0.325,
                        0.305,
                        0.280,
                        0.260,
                        0.246,
                        0.245,
                        0.250
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.480,
                        0.450,
                        0.410,
                        0.380,
                        0.350,
                        0.315,
                        0.290,
                        0.270,
                        0.260,
                        0.255,
                        0.257,
                        0.265,
                        0.280,
                        0.310,
                        0.342,
                        0.355,
                        0.345,
                        0.320,
                        0.290,
                        0.260,
                        0.230,
                        0.200,
                        0.170,
                        0.130
                    ]
                }
            ]
        }
    },
    '77': {
        data: {
            's': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.977,
                        0.973,
                        0.970,
                        0.965,
                        0.960,
                        0.955,
                        0.950,
                        0.945,
                        0.943,
                        0.942,
                        0.943,
                        0.945,
                        0.950,
                        0.955,
                        0.960,
                        0.970,
                        0.968,
                        0.950,
                        0.900
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.980,
                        0.977,
                        0.975,
                        0.971,
                        0.968,
                        0.963,
                        0.960,
                        0.955,
                        0.950,
                        0.945,
                        0.940
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.960,
                        0.960,
                        0.960,
                        0.958,
                        0.955,
                        0.950,
                        0.940,
                        0.930,
                        0.917,
                        0.900,
                        0.880,
                        0.860,
                        0.845,
                        0.830,
                        0.820,
                        0.815,
                        0.815,
                        0.825,
                        0.840,
                        0.863,
                        0.880,
                        0.870,
                        0.820,
                        0.700
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.960,
                        0.960,
                        0.960,
                        0.959,
                        0.957,
                        0.955,
                        0.950,
                        0.945,
                        0.940,
                        0.938,
                        0.935,
                        0.930,
                        0.925,
                        0.920,
                        0.917,
                        0.915,
                        0.915,
                        0.912,
                        0.910,
                        0.905,
                        0.900,
                        0.885,
                        0.870,
                        0.820
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.880,
                        0.877,
                        0.873,
                        0.865,
                        0.850,
                        0.833,
                        0.815,
                        0.790,
                        0.757,
                        0.715,
                        0.670,
                        0.623,
                        0.578,
                        0.540,
                        0.505,
                        0.490,
                        0.490,
                        0.500,
                        0.530,
                        0.570,
                        0.610,
                        0.610,
                        0.560,
                        0.430
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.880,
                        0.880,
                        0.877,
                        0.870,
                        0.860,
                        0.850,
                        0.840,
                        0.820,
                        0.800,
                        0.790,
                        0.780,
                        0.770,
                        0.760,
                        0.755,
                        0.750,
                        0.745,
                        0.740,
                        0.730,
                        0.720,
                        0.705,
                        0.690,
                        0.660,
                        0.620,
                        0.530
                    ]
                }
            ],
            't': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.958,
                        0.955,
                        0.953,
                        0.950,
                        0.946,
                        0.942,
                        0.936,
                        0.930,
                        0.922,
                        0.917,
                        0.910,
                        0.905,
                        0.900,
                        0.897,
                        0.896,
                        0.896,
                        0.897,
                        0.901,
                        0.904,
                        0.905,
                        0.905,
                        0.898,
                        0.886,
                        0.864
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.958,
                        0.957,
                        0.956,
                        0.955,
                        0.955,
                        0.954,
                        0.953,
                        0.952,
                        0.952,
                        0.951,
                        0.951,
                        0.952,
                        0.952,
                        0.953,
                        0.953,
                        0.953,
                        0.952,
                        0.952,
                        0.950,
                        0.950,
                        0.948,
                        0.947,
                        0.945,
                        0.943
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.870,
                        0.866,
                        0.860,
                        0.851,
                        0.839,
                        0.823,
                        0.805,
                        0.788,
                        0.769,
                        0.750,
                        0.730,
                        0.714,
                        0.703,
                        0.695,
                        0.693,
                        0.694,
                        0.701,
                        0.715,
                        0.735,
                        0.761,
                        0.788,
                        0.803,
                        0.790,
                        0.738
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.870,
                        0.862,
                        0.861,
                        0.860,
                        0.859,
                        0.858,
                        0.856,
                        0.853,
                        0.852,
                        0.850,
                        0.850,
                        0.849,
                        0.849,
                        0.848,
                        0.848,
                        0.848,
                        0.848,
                        0.848,
                        0.847,
                        0.846,
                        0.845,
                        0.841,
                        0.836,
                        0.823
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.625,
                        0.621,
                        0.614,
                        0.603,
                        0.584,
                        0.561,
                        0.530,
                        0.494,
                        0.452,
                        0.408,
                        0.366,
                        0.325,
                        0.291,
                        0.263,
                        0.243,
                        0.237,
                        0.243,
                        0.260,
                        0.298,
                        0.353,
                        0.434,
                        0.550,
                        0.598,
                        0.595
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.625,
                        0.621,
                        0.615,
                        0.613,
                        0.605,
                        0.599,
                        0.593,
                        0.588,
                        0.586,
                        0.588,
                        0.593,
                        0.601,
                        0.610,
                        0.620,
                        0.626,
                        0.629,
                        0.628,
                        0.621,
                        0.611,
                        0.600,
                        0.587,
                        0.570,
                        0.553,
                        0.515
                    ]
                }
            ],
            'x': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.950,
                        0.947,
                        0.944,
                        0.940,
                        0.935,
                        0.930,
                        0.923,
                        0.916,
                        0.908,
                        0.902,
                        0.895,
                        0.890,
                        0.885,
                        0.882,
                        0.881,
                        0.880,
                        0.881,
                        0.884,
                        0.887,
                        0.887,
                        0.883,
                        0.875,
                        0.864,
                        0.852
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.950,
                        0.949,
                        0.948,
                        0.947,
                        0.946,
                        0.945,
                        0.944,
                        0.943,
                        0.942,
                        0.941,
                        0.941,
                        0.942,
                        0.943,
                        0.944,
                        0.945,
                        0.946,
                        0.946,
                        0.946,
                        0.946,
                        0.946,
                        0.946,
                        0.946,
                        0.945,
                        0.944
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.840,
                        0.835,
                        0.827,
                        0.815,
                        0.800,
                        0.780,
                        0.760,
                        0.740,
                        0.720,
                        0.700,
                        0.680,
                        0.665,
                        0.655,
                        0.650,
                        0.650,
                        0.654,
                        0.663,
                        0.678,
                        0.700,
                        0.727,
                        0.757,
                        0.780,
                        0.780,
                        0.750
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.840,
                        0.829,
                        0.828,
                        0.827,
                        0.826,
                        0.825,
                        0.824,
                        0.823,
                        0.822,
                        0.821,
                        0.821,
                        0.822,
                        0.823,
                        0.824,
                        0.825,
                        0.826,
                        0.826,
                        0.826,
                        0.826,
                        0.826,
                        0.826,
                        0.826,
                        0.825,
                        0.824
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.540,
                        0.535,
                        0.527,
                        0.515,
                        0.495,
                        0.470,
                        0.435,
                        0.395,
                        0.350,
                        0.305,
                        0.265,
                        0.226,
                        0.195,
                        0.170,
                        0.156,
                        0.153,
                        0.160,
                        0.180,
                        0.220,
                        0.280,
                        0.375,
                        0.530,
                        0.610,
                        0.650
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.540,
                        0.535,
                        0.528,
                        0.527,
                        0.520,
                        0.515,
                        0.510,
                        0.510,
                        0.515,
                        0.521,
                        0.530,
                        0.545,
                        0.560,
                        0.575,
                        0.585,
                        0.590,
                        0.590,
                        0.585,
                        0.575,
                        0.565,
                        0.553,
                        0.540,
                        0.530,
                        0.510
                    ]
                }
            ]
        }
    },
    '107': {
        data: {
            's': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.975,
                        0.975,
                        0.975,
                        0.975,
                        0.974,
                        0.973,
                        0.972,
                        0.971,
                        0.970,
                        0.967,
                        0.960,
                        0.953,
                        0.943,
                        0.935,
                        0.930,
                        0.925,
                        0.920,
                        0.917,
                        0.915,
                        0.917,
                        0.920,
                        0.927,
                        0.940,
                        0.960
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.975,
                        0.975,
                        0.970,
                        0.965,
                        0.960,
                        0.955,
                        0.950,
                        0.945,
                        0.940,
                        0.935,
                        0.930,
                        0.925,
                        0.920,
                        0.917,
                        0.915,
                        0.915,
                        0.915,
                        0.913,
                        0.910,
                        0.890,
                        0.860,
                        0.800,
                        0.700,
                        0.600
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.925,
                        0.925,
                        0.925,
                        0.925,
                        0.925,
                        0.923,
                        0.920,
                        0.913,
                        0.900,
                        0.880,
                        0.860,
                        0.840,
                        0.820,
                        0.797,
                        0.775,
                        0.752,
                        0.730,
                        0.715,
                        0.712,
                        0.720,
                        0.742,
                        0.775,
                        0.815,
                        0.860
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.925,
                        0.925,
                        0.922,
                        0.91,
                        0.900,
                        0.890,
                        0.870,
                        0.855,
                        0.840,
                        0.820,
                        0.805,
                        0.790,
                        0.780,
                        0.770,
                        0.765,
                        0.760,
                        0.755,
                        0.750,
                        0.740,
                        0.730,
                        0.720,
                        0.700,
                        0.640,
                        0.520
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.775,
                        0.775,
                        0.775,
                        0.772,
                        0.764,
                        0.750,
                        0.730,
                        0.705,
                        0.670,
                        0.630,
                        0.580,
                        0.530,
                        0.483,
                        0.440,
                        0.397,
                        0.360,
                        0.335,
                        0.325,
                        0.330,
                        0.350,
                        0.390,
                        0.443,
                        0.510,
                        0.580
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.775,
                        0.765,
                        0.750,
                        0.725,
                        0.690,
                        0.650,
                        0.600,
                        0.550,
                        0.505,
                        0.460,
                        0.425,
                        0.400,
                        0.380,
                        0.365,
                        0.355,
                        0.360,
                        0.365,
                        0.375,
                        0.385,
                        0.385,
                        0.380,
                        0.360,
                        0.300,
                        0.230
                    ]
                }
            ],
            't': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.956,
                        0.956,
                        0.956,
                        0.954,
                        0.952,
                        0.948,
                        0.944,
                        0.938,
                        0.933,
                        0.924,
                        0.915,
                        0.906,
                        0.896,
                        0.887,
                        0.879,
                        0.874,
                        0.871,
                        0.871,
                        0.874,
                        0.882,
                        0.892,
                        0.896,
                        0.891,
                        0.885
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.956,
                        0.956,
                        0.955,
                        0.954,
                        0.953,
                        0.951,
                        0.950,
                        0.949,
                        0.948,
                        0.946,
                        0.945,
                        0.942,
                        0.939,
                        0.934,
                        0.930,
                        0.923,
                        0.911,
                        0.896,
                        0.876,
                        0.850,
                        0.815,
                        0.778,
                        0.753,
                        0.735
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.809,
                        0.809,
                        0.809,
                        0.809,
                        0.809,
                        0.807,
                        0.804,
                        0.794,
                        0.779,
                        0.756,
                        0.733,
                        0.705,
                        0.678,
                        0.649,
                        0.624,
                        0.601,
                        0.584,
                        0.576,
                        0.576,
                        0.585,
                        0.606,
                        0.636,
                        0.681,
                        0.740
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.809,
                        0.801,
                        0.793,
                        0.775,
                        0.754,
                        0.740,
                        0.720,
                        0.701,
                        0.683,
                        0.663,
                        0.644,
                        0.633,
                        0.619,
                        0.609,
                        0.604,
                        0.603,
                        0.601,
                        0.593,
                        0.575,
                        0.546,
                        0.503,
                        0.445,
                        0.385,
                        0.318
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.636,
                        0.629,
                        0.621,
                        0.613,
                        0.602,
                        0.585,
                        0.564,
                        0.536,
                        0.501,
                        0.465,
                        0.422,
                        0.380,
                        0.346,
                        0.313,
                        0.283,
                        0.260,
                        0.245,
                        0.239,
                        0.240,
                        0.252,
                        0.281,
                        0.321,
                        0.375,
                        0.445
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.636,
                        0.623,
                        0.608,
                        0.586,
                        0.563,
                        0.538,
                        0.510,
                        0.475,
                        0.434,
                        0.398,
                        0.363,
                        0.340,
                        0.320,
                        0.309,
                        0.299,
                        0.293,
                        0.283,
                        0.274,
                        0.261,
                        0.246,
                        0.223,
                        0.195,
                        0.158,
                        0.118
                    ]
                }
            ],
            'x': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.950,
                        0.950,
                        0.950,
                        0.947,
                        0.945,
                        0.940,
                        0.935,
                        0.927,
                        0.920,
                        0.910,
                        0.900,
                        0.890,
                        0.880,
                        0.871,
                        0.862,
                        0.857,
                        0.854,
                        0.855,
                        0.860,
                        0.870,
                        0.883,
                        0.885,
                        0.875,
                        0.860
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.950,
                        0.947,
                        0.945,
                        0.940,
                        0.935,
                        0.925,
                        0.910,
                        0.890,
                        0.865,
                        0.837,
                        0.800,
                        0.770,
                        0.770,
                        0.780
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.770,
                        0.770,
                        0.77,
                        0.770,
                        0.77,
                        0.768,
                        0.765,
                        0.755,
                        0.738,
                        0.715,
                        0.690,
                        0.660,
                        0.630,
                        0.600,
                        0.573,
                        0.550,
                        0.535,
                        0.530,
                        0.530,
                        0.540,
                        0.560,
                        0.590,
                        0.636,
                        0.700
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.770,
                        0.76,
                        0.75,
                        0.73,
                        0.705,
                        0.690,
                        0.670,
                        0.650,
                        0.630,
                        0.610,
                        0.590,
                        0.580,
                        0.565,
                        0.555,
                        0.550,
                        0.550,
                        0.550,
                        0.540,
                        0.520,
                        0.485,
                        0.430,
                        0.360,
                        0.300,
                        0.250
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.590,
                        0.580,
                        0.570,
                        0.560,
                        0.548,
                        0.530,
                        0.508,
                        0.480,
                        0.445,
                        0.410,
                        0.369,
                        0.330,
                        0.300,
                        0.270,
                        0.245,
                        0.227,
                        0.215,
                        0.210,
                        0.210,
                        0.219,
                        0.245,
                        0.280,
                        0.330,
                        0.400
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.590,
                        0.575,
                        0.560,
                        0.540,
                        0.520,
                        0.500,
                        0.480,
                        0.450,
                        0.410,
                        0.377,
                        0.342,
                        0.320,
                        0.300,
                        0.290,
                        0.280,
                        0.270,
                        0.255,
                        0.240,
                        0.220,
                        0.200,
                        0.170,
                        0.140,
                        0.110,
                        0.080
                    ]
                }
            ]
        }
    },
    '137': {
        data: {
            's': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.970,
                        0.970,
                        0.970,
                        0.970,
                        0.970,
                        0.967,
                        0.965,
                        0.960,
                        0.953,
                        0.945,
                        0.940,
                        0.935,
                        0.930,
                        0.925,
                        0.920,
                        0.915,
                        0.910,
                        0.907,
                        0.905,
                        0.903,
                        0.902,
                        0.903,
                        0.908,
                        0.915
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.970,
                        0.968,
                        0.965,
                        0.960,
                        0.953,
                        0.948,
                        0.940,
                        0.930,
                        0.920,
                        0.910,
                        0.905,
                        0.900,
                        0.895,
                        0.893,
                        0.891,
                        0.887,
                        0.883,
                        0.875,
                        0.867,
                        0.860,
                        0.850,
                        0.845,
                        0.830,
                        0.810
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.875,
                        0.875,
                        0.875,
                        0.875,
                        0.875,
                        0.873,
                        0.870,
                        0.863,
                        0.855,
                        0.843,
                        0.825,
                        0.800,
                        0.775,
                        0.750,
                        0.725,
                        0.700,
                        0.675,
                        0.653,
                        0.640,
                        0.635,
                        0.645,
                        0.665,
                        0.695,
                        0.740
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.875,
                        0.87,
                        0.865,
                        0.857,
                        0.845,
                        0.820,
                        0.800,
                        0.770,
                        0.745,
                        0.720,
                        0.700,
                        0.680,
                        0.660,
                        0.650,
                        0.645,
                        0.640,
                        0.637,
                        0.635,
                        0.633,
                        0.630,
                        0.625,
                        0.627,
                        0.635,
                        0.648
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.690,
                        0.690,
                        0.690,
                        0.688,
                        0.682,
                        0.668,
                        0.645,
                        0.615,
                        0.580,
                        0.540,
                        0.495,
                        0.450,
                        0.400,
                        0.350,
                        0.305,
                        0.270,
                        0.242,
                        0.225,
                        0.220,
                        0.230,
                        0.260,
                        0.300,
                        0.365,
                        0.460
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.690,
                        0.680,
                        0.670,
                        0.640,
                        0.585,
                        0.530,
                        0.470,
                        0.400,
                        0.342,
                        0.285,
                        0.245,
                        0.210,
                        0.180,
                        0.170,
                        0.165,
                        0.170,
                        0.180,
                        0.190,
                        0.210,
                        0.220,
                        0.230,
                        0.250,
                        0.270,
                        0.305
                    ]
                }
            ],
            't': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.933,
                        0.933,
                        0.934,
                        0.936,
                        0.938,
                        0.939,
                        0.939,
                        0.938,
                        0.936,
                        0.932,
                        0.925,
                        0.916,
                        0.908,
                        0.899,
                        0.890,
                        0.881,
                        0.873,
                        0.866,
                        0.862,
                        0.861,
                        0.863,
                        0.867,
                        0.876,
                        0.889
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.933,
                        0.932,
                        0.931,
                        0.930,
                        0.928,
                        0.927,
                        0.925,
                        0.917,
                        0.909,
                        0.899,
                        0.894,
                        0.889,
                        0.885,
                        0.884,
                        0.883,
                        0.882,
                        0.881,
                        0.879,
                        0.875,
                        0.868,
                        0.858,
                        0.849,
                        0.834,
                        0.810
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.804,
                        0.805,
                        0.806,
                        0.808,
                        0.809,
                        0.811,
                        0.810,
                        0.806,
                        0.800,
                        0.788,
                        0.769,
                        0.744,
                        0.719,
                        0.690,
                        0.661,
                        0.633,
                        0.611,
                        0.596,
                        0.588,
                        0.588,
                        0.600,
                        0.620,
                        0.654,
                        0.703
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.804,
                        0.803,
                        0.801,
                        0.798,
                        0.789,
                        0.771,
                        0.755,
                        0.736,
                        0.721,
                        0.700,
                        0.685,
                        0.667,
                        0.653,
                        0.643,
                        0.638,
                        0.635,
                        0.632,
                        0.628,
                        0.623,
                        0.619,
                        0.614,
                        0.611,
                        0.609,
                        0.608
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.641,
                        0.638,
                        0.636,
                        0.633,
                        0.628,
                        0.617,
                        0.596,
                        0.563,
                        0.520,
                        0.478,
                        0.433,
                        0.389,
                        0.342,
                        0.300,
                        0.264,
                        0.233,
                        0.211,
                        0.203,
                        0.203,
                        0.217,
                        0.245,
                        0.281,
                        0.336,
                        0.415
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.641,
                        0.631,
                        0.618,
                        0.588,
                        0.544,
                        0.500,
                        0.451,
                        0.400,
                        0.348,
                        0.300,
                        0.264,
                        0.233,
                        0.210,
                        0.196,
                        0.191,
                        0.193,
                        0.199,
                        0.211,
                        0.229,
                        0.239,
                        0.245,
                        0.250,
                        0.263,
                        0.286
                    ]
                }
            ],
            'x': [
                {
                    label: '1',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.920,
                        0.920,
                        0.922,
                        0.925,
                        0.927,
                        0.930,
                        0.930,
                        0.930,
                        0.930,
                        0.927,
                        0.920,
                        0.910,
                        0.900,
                        0.890,
                        0.880,
                        0.870,
                        0.860,
                        0.852,
                        0.847,
                        0.847,
                        0.850,
                        0.855,
                        0.865,
                        0.880
                    ]
                },
                {
                    label: '2',
                    ...$803e9b9f767390d1$var$yellow,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.920,
                        0.920,
                        0.920,
                        0.920,
                        0.920,
                        0.920,
                        0.920,
                        0.913,
                        0.905,
                        0.895,
                        0.890,
                        0.885,
                        0.882,
                        0.881,
                        0.880,
                        0.880,
                        0.880,
                        0.880,
                        0.877,
                        0.870,
                        0.860,
                        0.850,
                        0.835,
                        0.810
                    ]
                },
                {
                    label: '3',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.780,
                        0.782,
                        0.783,
                        0.785,
                        0.787,
                        0.790,
                        0.790,
                        0.787,
                        0.782,
                        0.770,
                        0.750,
                        0.725,
                        0.700,
                        0.670,
                        0.640,
                        0.610,
                        0.590,
                        0.577,
                        0.571,
                        0.572,
                        0.585,
                        0.605,
                        0.640,
                        0.690
                    ]
                },
                {
                    label: '4',
                    ...$803e9b9f767390d1$var$red,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.780,
                        0.78,
                        0.78,
                        0.778,
                        0.770,
                        0.755,
                        0.740,
                        0.725,
                        0.713,
                        0.693,
                        0.680,
                        0.663,
                        0.650,
                        0.640,
                        0.635,
                        0.633,
                        0.630,
                        0.625,
                        0.620,
                        0.615,
                        0.610,
                        0.605,
                        0.600,
                        0.595
                    ]
                },
                {
                    label: '5',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$solid,
                    data: [
                        null,
                        0.625,
                        0.620,
                        0.618,
                        0.615,
                        0.610,
                        0.600,
                        0.580,
                        0.545,
                        0.500,
                        0.457,
                        0.412,
                        0.368,
                        0.323,
                        0.283,
                        0.250,
                        0.220,
                        0.200,
                        0.195,
                        0.197,
                        0.212,
                        0.240,
                        0.275,
                        0.326,
                        0.400
                    ]
                },
                {
                    label: '6',
                    ...$803e9b9f767390d1$var$blue,
                    ...$803e9b9f767390d1$var$dashed,
                    data: [
                        null,
                        0.625,
                        0.615,
                        0.600,
                        0.570,
                        0.530,
                        0.490,
                        0.445,
                        0.400,
                        0.350,
                        0.305,
                        0.270,
                        0.240,
                        0.220,
                        0.205,
                        0.200,
                        0.200,
                        0.205,
                        0.218,
                        0.235,
                        0.245,
                        0.250,
                        0.250,
                        0.260,
                        0.280
                    ]
                }
            ]
        }
    }
};
const $803e9b9f767390d1$export$d4c72bab9d6cc13a = {
    labels: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
    ],
    datasets: [
        {
            label: '1',
            ...$803e9b9f767390d1$var$yellow,
            ...$803e9b9f767390d1$var$solid,
            data: [
                null,
                0.970,
                0.968,
                0.965,
                0.960,
                0.955,
                0.945,
                0.930,
                0.920,
                0.910,
                0.905,
                0.900,
                0.895,
                0.890,
                0.885,
                0.877,
                0.870,
                0.865,
                0.860,
                0.860,
                0.870,
                0.883,
                0.880,
                0.864,
                0.860
            ]
        },
        {
            label: '2',
            ...$803e9b9f767390d1$var$yellow,
            ...$803e9b9f767390d1$var$dashed,
            data: [
                null,
                0.970,
                0.968,
                0.963,
                0.957,
                0.946,
                0.930,
                0.920,
                0.910,
                0.905,
                0.900,
                0.900,
                0.905,
                0.910,
                0.915,
                0.920,
                0.925,
                0.927,
                0.930,
                0.930,
                0.925,
                0.915,
                0.900,
                0.870,
                0.840
            ]
        },
        {
            label: '3',
            ...$803e9b9f767390d1$var$red,
            ...$803e9b9f767390d1$var$solid,
            data: [
                null,
                0.820,
                0.815,
                0.810,
                0.805,
                0.800,
                0.795,
                0.790,
                0.780,
                0.770,
                0.760,
                0.750,
                0.740,
                0.730,
                0.720,
                0.710,
                0.695,
                0.670,
                0.640,
                0.600,
                0.550,
                0.500,
                0.450,
                0.400,
                0.350
            ]
        },
        {
            label: '4',
            ...$803e9b9f767390d1$var$red,
            ...$803e9b9f767390d1$var$dashed,
            data: [
                null,
                0.820,
                0.81,
                0.8,
                0.79,
                0.770,
                0.750,
                0.720,
                0.690,
                0.655,
                0.630,
                0.610,
                0.600,
                0.595,
                0.590,
                0.585,
                0.580,
                0.575,
                0.570,
                0.565,
                0.560,
                0.550,
                0.540,
                0.530,
                0.520
            ]
        },
        {
            label: '5',
            ...$803e9b9f767390d1$var$blue,
            ...$803e9b9f767390d1$var$solid,
            data: [
                null,
                0.600,
                0.590,
                0.580,
                0.570,
                0.560,
                0.550,
                0.540,
                0.530,
                0.520,
                0.510,
                0.502,
                0.495,
                0.490,
                0.487,
                0.480,
                0.470,
                0.460,
                0.430,
                0.380,
                0.320,
                0.280,
                0.260,
                0.250,
                0.250
            ]
        },
        {
            label: '6',
            ...$803e9b9f767390d1$var$blue,
            ...$803e9b9f767390d1$var$dashed,
            data: [
                null,
                0.600,
                0.550,
                0.500,
                0.460,
                0.430,
                0.400,
                0.375,
                0.350,
                0.325,
                0.310,
                0.300,
                0.295,
                0.293,
                0.290,
                0.290,
                0.290,
                0.292,
                0.295,
                0.297,
                0.298,
                0.300,
                0.297,
                0.295,
                0.290
            ]
        }
    ]
};





const $bd93cd6e66a878fc$var$backgroundUrl = new URL($f08fcdce49270724$exports);
var $f78b537bd3a1a5e6$exports = {};
$f78b537bd3a1a5e6$exports = $parcel$resolve("4Na36");


const $bd93cd6e66a878fc$var$STXSUrl = new URL($f78b537bd3a1a5e6$exports);
var $b528e1a5f57580c2$exports = {};
$b528e1a5f57580c2$exports = $parcel$resolve("6A5tu");


const $bd93cd6e66a878fc$var$STXTUrl = new URL($b528e1a5f57580c2$exports);
var $1976700d2926664c$exports = {};
$1976700d2926664c$exports = $parcel$resolve("i7jca");


const $bd93cd6e66a878fc$var$STXXUrl = new URL($1976700d2926664c$exports);

const $bd93cd6e66a878fc$var$STXTblurredUrl = new URL($2e710d10fc06f454$exports);
const $bd93cd6e66a878fc$var$options = {
    // Force height on xxwide screens
    maintainAspectRatio: window.innerWidth < 1800,
    // aspectRatio: 4,
    animation: {
    },
    // tooltips: {
    //   mode: 'index',
    //   intersect: false,
    // },
    // hover: {
    //   mode: 'nearest',
    //   intersect: true
    // },
    // scales: {
    //   yAxes: [{
    //     ticks: {
    //       beginAtZero:true,
    //       stepSize: 2
    //     }
    //   }],
    //   xAxes: [{
    //     ticks: {
    //       stepSize: 4
    //     }
    //   }]
    // },
    tooltips: {
        enabled: false
    },
    legend: {
        display: false
    },
    scales: {
        yAxes: [
            {
                ticks: {
                    // Include a dollar sign in the ticks
                    fontColor: "rgba(255,255,255,.5)",
                    fontFamily: "Calibre, sans-serif",
                    fontSize: window.innerWidth < 1800 ? 10 : 12,
                    min: 0,
                    max: 1
                },
                gridLines: {
                    zeroLineColor: "rgba(255,255,255,.3)",
                    color: "transparent"
                }
            }
        ],
        xAxes: [
            {
                ticks: {
                    fontColor: "rgba(255,255,255,.5)",
                    fontFamily: "Calibre, sans-serif",
                    fontSize: window.innerWidth < 2000 ? 9 : 11.5,
                    stepSize: 1,
                    min: 0,
                    max: 23
                },
                gridLines: {
                    zeroLineColor: "rgba(255,255,255,.3)",
                    color: "transparent"
                }
            }
        ]
    }
};
class $bd93cd6e66a878fc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        currentLength: "37",
        currentVariant: "t",
        chartState: (0, $803e9b9f767390d1$export$d4c72bab9d6cc13a),
        ready: false,
        firstLoad: true
    };
    handleLengthClick = (newLength)=>{
        let newDataset = (0, $803e9b9f767390d1$export$fa75311891f179ce)[newLength]["data"][this.state.currentVariant] || (0, $803e9b9f767390d1$export$fa75311891f179ce)[newLength]["data"]["t"];
        if (this.state.currentLength != newLength) {
            (0, $36b3090cb6608e8f$export$99ee26438460406a).killTweensOf(this._chartText);
            (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._chartText, {
                opacity: 0,
                duration: 0.2
            });
        }
        setTimeout(()=>{
            this.setState({
                currentLength: newLength,
                chartState: {
                    ...(0, $803e9b9f767390d1$export$d4c72bab9d6cc13a),
                    datasets: newDataset
                }
            });
        }, 100);
    };
    handleVariantClick = (newVariant)=>{
        let newDataset = (0, $803e9b9f767390d1$export$fa75311891f179ce)[this.state.currentLength]["data"][newVariant] || (0, $803e9b9f767390d1$export$fa75311891f179ce)[this.state.currentLength]["data"]["t"];
        if (this.state.currentVariant != newVariant) {
            (0, $36b3090cb6608e8f$export$99ee26438460406a).killTweensOf(this._chartText);
            (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._chartText, {
                opacity: 0,
                duration: 0.2
            });
        }
        setTimeout(()=>{
            this.setState({
                currentVariant: newVariant,
                chartState: {
                    ...(0, $803e9b9f767390d1$export$d4c72bab9d6cc13a),
                    datasets: newDataset
                }
            });
        }, 100);
    };
    onLeave(origin, dest, direction) {
        if (dest && dest.index === 1) {
            let els = document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).chartVariants} > div`);
            (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(els, {
                opacity: 1
            }, {
                opacity: 0.5,
                delay: 2.5,
                duration: 1
            });
        }
        this.setState({
            firstLoad: false
        });
    }
    componentDidMount() {
        (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline().to(this._copy, {
            opacity: 0.9,
            duration: 1,
            delay: 1.75
        });
        let delay = 0.2;
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo([
            this._circlesLabel1,
            this._circlesLabel2,
            this._circlesLabel3
        ], {
            opacity: 0
        }, {
            opacity: 0.9,
            delay: delay + 0.1,
            duration: 3,
            stagger: 0.2
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._circlesLabel1, {
            x: "-=50",
            delay: delay,
            duration: 15
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._circlesLabel3, {
            x: "+=50",
            delay: delay,
            duration: 15
        });
        // hide Circles until the main image is loaded, to prevent layout jumping
        let img = new Image();
        let that = this;
        img.onload = function() {
            that.setState({
                ready: true
            });
        };
        img.src = $bd93cd6e66a878fc$var$STXTblurredUrl;
    }
    render() {
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._chartText, {
            opacity: 0.7,
            duration: 0.3,
            delay: 0.1
        });
        let that = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))({
                [(0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).ready]: this.state.ready
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: "bg"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $35950112c9f1df8b$export$2e2bcd8739ae039), {
            src: $bd93cd6e66a878fc$var$backgroundUrl,
            className: "bg",
            readyClassName: "bgReady"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7565755634e5a3f9$exports))), {
            licenseKey: (0, $902644c2b34dba62$export$776d1d96e65b96de),
            onLeave: this.onLeave.bind(this),
            credits: {
                enabled: false
            },
            render: ({ state: state, fullpageApi: fullpageApi })=>{
                if (fullpageApi && this.state.firstLoad) fullpageApi.silentMoveTo(1);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7565755634e5a3f9$exports))).Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))("section", (0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).sectionTuning)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).circlesSection)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $1323d0b01f055777$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    ref: (c)=>{
                        this._circlesLabels = c;
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).circlesLabels)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    style: {
                        left: 0
                    },
                    ref: (c)=>{
                        this._circlesLabel1 = c;
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).circlesLabel)
                }, "STRAIGHT"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    style: {
                        left: "50%",
                        transform: "translateX(-50%)"
                    },
                    ref: (c)=>{
                        this._circlesLabel2 = c;
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).circlesLabel)
                }, "TRANSIENT"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    style: {
                        right: 0
                    },
                    ref: (c)=>{
                        this._circlesLabel3 = c;
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).circlesLabel)
                }, "EXPRESSIVE"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    ref: (c)=>{
                        this._copy = c;
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).pageText)
                }, "Every BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " lens is hand-built, using proprietary production processes which allow the optical performance of each lens in the range to be uniquely configured and tuned to their owner\u2019s wishes and creative style.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "Three pre-set tonalities are available to order."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", {
                    onClick: ()=>fullpageApi.moveSectionDown()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $dbc9106da083fb2e$export$2e2bcd8739ae039), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: "section"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))("sectionInner", (0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).chartSection, {
                        [(0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).chartSectionActive]: state.destination && state.destination.isLast
                    })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).chartVariants)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))({
                        [(0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).variantActive]: this.state.currentVariant == "s"
                    }),
                    onMouseEnter: ()=>that.handleVariantClick("s")
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).chartVariant),
                    style: {
                        textAlign: "center"
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
                    src: $bd93cd6e66a878fc$var$STXSUrl
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).variantLabel)
                }, "STRAIGHT")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))({
                        [(0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).variantActive]: this.state.currentVariant == "t"
                    }),
                    onMouseEnter: ()=>that.handleVariantClick("t")
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).chartVariant),
                    style: {
                        textAlign: "center"
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
                    src: $bd93cd6e66a878fc$var$STXTUrl
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).variantLabel)
                }, "TRANSIENT")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))({
                        [(0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).variantActive]: this.state.currentVariant == "x"
                    }),
                    onMouseEnter: ()=>that.handleVariantClick("x")
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).chartVariant),
                    style: {
                        textAlign: "center"
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
                    src: $bd93cd6e66a878fc$var$STXXUrl
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).variantLabel)
                }, "EXPRESSIVE"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).lengths)
                }, Object.keys((0, $803e9b9f767390d1$export$fa75311891f179ce)).map((key, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).length, {
                            [(0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).lengthActive]: this.state.currentLength == key
                        }),
                        onMouseEnter: ()=>that.handleLengthClick(key),
                        key: index
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("b", null, key.slice(0, -1)), "7"), "MM"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).chartArea),
                    ref: (c)=>{
                        this._chartArea = c;
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    ref: (c)=>{
                        this._chartText = c;
                    },
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).chartText, {
                        [(0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).longChartText]: this.state.currentLength == "77"
                    }),
                    dangerouslySetInnerHTML: {
                        __html: (0, $803e9b9f767390d1$export$29f9f81de5c56283)[`F${this.state.currentLength}`][this.state.currentVariant]
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).chartWrapOuter)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).chartWrap)
                }, this.state.chartState["datasets"] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $991fb83ad4494ad4$exports.Line), {
                    width: 440,
                    height: 300,
                    data: this.state.chartState,
                    options: $bd93cd6e66a878fc$var$options
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($7a18d26a8b2df62c$exports))).legend)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
                    style: {
                        borderTop: "2px solid var(--gold)"
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "5 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "SAGITTAL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
                    style: {
                        borderTop: "2px dashed var(--gold)"
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "5 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "TANGENTIAL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
                    style: {
                        borderTop: "2px solid var(--red)"
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "10 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "SAGITTAL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
                    style: {
                        borderTop: "2px dashed var(--red)"
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "10 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "TANGENTIAL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
                    style: {
                        borderTop: "2px solid var(--blue)"
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "20 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "SAGITTAL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
                    style: {
                        borderTop: "2px dashed var(--blue)"
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "20 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "TANGENTIAL"))))))));
            }
        }));
    }
}



var $jiXHd = parcelRequire("jiXHd");





var $ff670b086ea499e5$exports = {};

$parcel$export($ff670b086ea499e5$exports, "header", function () { return $ff670b086ea499e5$export$38e42c68cf43b5d4; }, function (v) { return $ff670b086ea499e5$export$38e42c68cf43b5d4 = v; });
$parcel$export($ff670b086ea499e5$exports, "variantLabel", function () { return $ff670b086ea499e5$export$c877a6c4e166c3c6; }, function (v) { return $ff670b086ea499e5$export$c877a6c4e166c3c6 = v; });
$parcel$export($ff670b086ea499e5$exports, "circlesLabel", function () { return $ff670b086ea499e5$export$48d80e756c09ddbc; }, function (v) { return $ff670b086ea499e5$export$48d80e756c09ddbc = v; });
$parcel$export($ff670b086ea499e5$exports, "sectionTuning", function () { return $ff670b086ea499e5$export$85cdcdc96b93a4ba; }, function (v) { return $ff670b086ea499e5$export$85cdcdc96b93a4ba = v; });
$parcel$export($ff670b086ea499e5$exports, "circlesSectionWrap", function () { return $ff670b086ea499e5$export$844764279ad4876e; }, function (v) { return $ff670b086ea499e5$export$844764279ad4876e = v; });
$parcel$export($ff670b086ea499e5$exports, "circlesSection", function () { return $ff670b086ea499e5$export$47b9f7f7fc7227fa; }, function (v) { return $ff670b086ea499e5$export$47b9f7f7fc7227fa = v; });
$parcel$export($ff670b086ea499e5$exports, "ready", function () { return $ff670b086ea499e5$export$28ee1007e174a2a6; }, function (v) { return $ff670b086ea499e5$export$28ee1007e174a2a6 = v; });
$parcel$export($ff670b086ea499e5$exports, "circlesLabels", function () { return $ff670b086ea499e5$export$278e7d06a41d55d5; }, function (v) { return $ff670b086ea499e5$export$278e7d06a41d55d5 = v; });
$parcel$export($ff670b086ea499e5$exports, "pageText", function () { return $ff670b086ea499e5$export$f11b2bba6755aef8; }, function (v) { return $ff670b086ea499e5$export$f11b2bba6755aef8 = v; });
$parcel$export($ff670b086ea499e5$exports, "chartSectionWrap", function () { return $ff670b086ea499e5$export$d2b5aea298fd2355; }, function (v) { return $ff670b086ea499e5$export$d2b5aea298fd2355 = v; });
$parcel$export($ff670b086ea499e5$exports, "chartSection", function () { return $ff670b086ea499e5$export$d783e99fe8e52643; }, function (v) { return $ff670b086ea499e5$export$d783e99fe8e52643 = v; });
$parcel$export($ff670b086ea499e5$exports, "chartVariants", function () { return $ff670b086ea499e5$export$879c8add06cdea5; }, function (v) { return $ff670b086ea499e5$export$879c8add06cdea5 = v; });
$parcel$export($ff670b086ea499e5$exports, "chartVariantFadeout", function () { return $ff670b086ea499e5$export$618b2fd2a8796434; }, function (v) { return $ff670b086ea499e5$export$618b2fd2a8796434 = v; });
$parcel$export($ff670b086ea499e5$exports, "variantActive", function () { return $ff670b086ea499e5$export$619711d15ac5d9e2; }, function (v) { return $ff670b086ea499e5$export$619711d15ac5d9e2 = v; });
$parcel$export($ff670b086ea499e5$exports, "chartVariant", function () { return $ff670b086ea499e5$export$65a205264429c89b; }, function (v) { return $ff670b086ea499e5$export$65a205264429c89b = v; });
$parcel$export($ff670b086ea499e5$exports, "lengths", function () { return $ff670b086ea499e5$export$3b026dac17332221; }, function (v) { return $ff670b086ea499e5$export$3b026dac17332221 = v; });
$parcel$export($ff670b086ea499e5$exports, "variantt", function () { return $ff670b086ea499e5$export$504fc74010d8bcb2; }, function (v) { return $ff670b086ea499e5$export$504fc74010d8bcb2 = v; });
$parcel$export($ff670b086ea499e5$exports, "variantx", function () { return $ff670b086ea499e5$export$4324b00daa0227a0; }, function (v) { return $ff670b086ea499e5$export$4324b00daa0227a0 = v; });
$parcel$export($ff670b086ea499e5$exports, "length", function () { return $ff670b086ea499e5$export$f24224f1c91d8156; }, function (v) { return $ff670b086ea499e5$export$f24224f1c91d8156 = v; });
$parcel$export($ff670b086ea499e5$exports, "chartArea", function () { return $ff670b086ea499e5$export$d342ad273db2b554; }, function (v) { return $ff670b086ea499e5$export$d342ad273db2b554 = v; });
$parcel$export($ff670b086ea499e5$exports, "lengthActive", function () { return $ff670b086ea499e5$export$4ce2ca2cd632f143; }, function (v) { return $ff670b086ea499e5$export$4ce2ca2cd632f143 = v; });
$parcel$export($ff670b086ea499e5$exports, "moreInfo", function () { return $ff670b086ea499e5$export$864caeab2e8f5ac5; }, function (v) { return $ff670b086ea499e5$export$864caeab2e8f5ac5 = v; });
$parcel$export($ff670b086ea499e5$exports, "chartText", function () { return $ff670b086ea499e5$export$f660e51c28e4b420; }, function (v) { return $ff670b086ea499e5$export$f660e51c28e4b420 = v; });
$parcel$export($ff670b086ea499e5$exports, "longChartText", function () { return $ff670b086ea499e5$export$c686b6f0ad220c64; }, function (v) { return $ff670b086ea499e5$export$c686b6f0ad220c64 = v; });
$parcel$export($ff670b086ea499e5$exports, "chartWrap", function () { return $ff670b086ea499e5$export$799d32689f4d3ecb; }, function (v) { return $ff670b086ea499e5$export$799d32689f4d3ecb = v; });
$parcel$export($ff670b086ea499e5$exports, "legend", function () { return $ff670b086ea499e5$export$9a9b59e08de24cef; }, function (v) { return $ff670b086ea499e5$export$9a9b59e08de24cef = v; });
$parcel$export($ff670b086ea499e5$exports, "popup", function () { return $ff670b086ea499e5$export$63b4813c5280c707; }, function (v) { return $ff670b086ea499e5$export$63b4813c5280c707 = v; });
$parcel$export($ff670b086ea499e5$exports, "open", function () { return $ff670b086ea499e5$export$3ce6949f20cea765; }, function (v) { return $ff670b086ea499e5$export$3ce6949f20cea765 = v; });
$parcel$export($ff670b086ea499e5$exports, "popupInner", function () { return $ff670b086ea499e5$export$561d0e41d7c15aad; }, function (v) { return $ff670b086ea499e5$export$561d0e41d7c15aad = v; });
$parcel$export($ff670b086ea499e5$exports, "x", function () { return $ff670b086ea499e5$export$d141bba7fdc215a3; }, function (v) { return $ff670b086ea499e5$export$d141bba7fdc215a3 = v; });
var $ff670b086ea499e5$export$38e42c68cf43b5d4;
var $ff670b086ea499e5$export$c877a6c4e166c3c6;
var $ff670b086ea499e5$export$48d80e756c09ddbc;
var $ff670b086ea499e5$export$85cdcdc96b93a4ba;
var $ff670b086ea499e5$export$844764279ad4876e;
var $ff670b086ea499e5$export$47b9f7f7fc7227fa;
var $ff670b086ea499e5$export$28ee1007e174a2a6;
var $ff670b086ea499e5$export$278e7d06a41d55d5;
var $ff670b086ea499e5$export$f11b2bba6755aef8;
var $ff670b086ea499e5$export$d2b5aea298fd2355;
var $ff670b086ea499e5$export$d783e99fe8e52643;
var $ff670b086ea499e5$export$879c8add06cdea5;
var $ff670b086ea499e5$export$618b2fd2a8796434;
var $ff670b086ea499e5$export$619711d15ac5d9e2;
var $ff670b086ea499e5$export$65a205264429c89b;
var $ff670b086ea499e5$export$3b026dac17332221;
var $ff670b086ea499e5$export$504fc74010d8bcb2;
var $ff670b086ea499e5$export$4324b00daa0227a0;
var $ff670b086ea499e5$export$f24224f1c91d8156;
var $ff670b086ea499e5$export$d342ad273db2b554;
var $ff670b086ea499e5$export$4ce2ca2cd632f143;
var $ff670b086ea499e5$export$864caeab2e8f5ac5;
var $ff670b086ea499e5$export$f660e51c28e4b420;
var $ff670b086ea499e5$export$c686b6f0ad220c64;
var $ff670b086ea499e5$export$799d32689f4d3ecb;
var $ff670b086ea499e5$export$9a9b59e08de24cef;
var $ff670b086ea499e5$export$63b4813c5280c707;
var $ff670b086ea499e5$export$3ce6949f20cea765;
var $ff670b086ea499e5$export$561d0e41d7c15aad;
var $ff670b086ea499e5$export$d141bba7fdc215a3;
$ff670b086ea499e5$export$38e42c68cf43b5d4 = "_app-views-Tuning-TuningMobile-_styles__header";
$ff670b086ea499e5$export$c877a6c4e166c3c6 = "_app-views-Tuning-TuningMobile-_styles__variantLabel";
$ff670b086ea499e5$export$48d80e756c09ddbc = "_app-views-Tuning-TuningMobile-_styles__circlesLabel";
$ff670b086ea499e5$export$85cdcdc96b93a4ba = "_app-views-Tuning-TuningMobile-_styles__sectionTuning";
$ff670b086ea499e5$export$844764279ad4876e = "_app-views-Tuning-TuningMobile-_styles__circlesSectionWrap";
$ff670b086ea499e5$export$47b9f7f7fc7227fa = "_app-views-Tuning-TuningMobile-_styles__circlesSection";
$ff670b086ea499e5$export$28ee1007e174a2a6 = "_app-views-Tuning-TuningMobile-_styles__ready";
$ff670b086ea499e5$export$278e7d06a41d55d5 = "_app-views-Tuning-TuningMobile-_styles__circlesLabels";
$ff670b086ea499e5$export$f11b2bba6755aef8 = "_app-views-Tuning-TuningMobile-_styles__pageText";
$ff670b086ea499e5$export$d2b5aea298fd2355 = "_app-views-Tuning-TuningMobile-_styles__chartSectionWrap";
$ff670b086ea499e5$export$d783e99fe8e52643 = "_app-views-Tuning-TuningMobile-_styles__chartSection";
$ff670b086ea499e5$export$879c8add06cdea5 = "_app-views-Tuning-TuningMobile-_styles__chartVariants";
$ff670b086ea499e5$export$618b2fd2a8796434 = "_app-views-Tuning-TuningMobile-_styles__chartVariantFadeout";
$ff670b086ea499e5$export$619711d15ac5d9e2 = "_app-views-Tuning-TuningMobile-_styles__variantActive";
$ff670b086ea499e5$export$65a205264429c89b = "_app-views-Tuning-TuningMobile-_styles__chartVariant";
$ff670b086ea499e5$export$3b026dac17332221 = "_app-views-Tuning-TuningMobile-_styles__lengths";
$ff670b086ea499e5$export$504fc74010d8bcb2 = "_app-views-Tuning-TuningMobile-_styles__variantt";
$ff670b086ea499e5$export$4324b00daa0227a0 = "_app-views-Tuning-TuningMobile-_styles__variantx";
$ff670b086ea499e5$export$f24224f1c91d8156 = "_app-views-Tuning-TuningMobile-_styles__length";
$ff670b086ea499e5$export$d342ad273db2b554 = "_app-views-Tuning-TuningMobile-_styles__chartArea";
$ff670b086ea499e5$export$4ce2ca2cd632f143 = "_app-views-Tuning-TuningMobile-_styles__lengthActive";
$ff670b086ea499e5$export$864caeab2e8f5ac5 = "_app-views-Tuning-TuningMobile-_styles__moreInfo";
$ff670b086ea499e5$export$f660e51c28e4b420 = "_app-views-Tuning-TuningMobile-_styles__chartText";
$ff670b086ea499e5$export$c686b6f0ad220c64 = "_app-views-Tuning-TuningMobile-_styles__longChartText";
$ff670b086ea499e5$export$799d32689f4d3ecb = "_app-views-Tuning-TuningMobile-_styles__chartWrap";
$ff670b086ea499e5$export$9a9b59e08de24cef = "_app-views-Tuning-TuningMobile-_styles__legend";
$ff670b086ea499e5$export$63b4813c5280c707 = "_app-views-Tuning-TuningMobile-_styles__popup";
$ff670b086ea499e5$export$3ce6949f20cea765 = "_app-views-Tuning-TuningMobile-_styles__open";
$ff670b086ea499e5$export$561d0e41d7c15aad = "_app-views-Tuning-TuningMobile-_styles__popupInner";
$ff670b086ea499e5$export$d141bba7fdc215a3 = "_app-views-Tuning-TuningMobile-_styles__x";





var $jiXHd = parcelRequire("jiXHd");

var $bd1886c0795fcefa$exports = {};

$parcel$export($bd1886c0795fcefa$exports, "circlesWrap", function () { return $bd1886c0795fcefa$export$910dde7540d1f6cf; }, function (v) { return $bd1886c0795fcefa$export$910dde7540d1f6cf = v; });
$parcel$export($bd1886c0795fcefa$exports, "circles", function () { return $bd1886c0795fcefa$export$c958aa0cc90a067; }, function (v) { return $bd1886c0795fcefa$export$c958aa0cc90a067 = v; });
$parcel$export($bd1886c0795fcefa$exports, "letters", function () { return $bd1886c0795fcefa$export$cf980ec1f8b21744; }, function (v) { return $bd1886c0795fcefa$export$cf980ec1f8b21744 = v; });
$parcel$export($bd1886c0795fcefa$exports, "circle", function () { return $bd1886c0795fcefa$export$e1d786d2f707b414; }, function (v) { return $bd1886c0795fcefa$export$e1d786d2f707b414 = v; });
$parcel$export($bd1886c0795fcefa$exports, "circlesFill", function () { return $bd1886c0795fcefa$export$55e8620fb8f1efdf; }, function (v) { return $bd1886c0795fcefa$export$55e8620fb8f1efdf = v; });
$parcel$export($bd1886c0795fcefa$exports, "circleStroke", function () { return $bd1886c0795fcefa$export$15785dcc95f3e6d2; }, function (v) { return $bd1886c0795fcefa$export$15785dcc95f3e6d2 = v; });
$parcel$export($bd1886c0795fcefa$exports, "letter", function () { return $bd1886c0795fcefa$export$30780d0b6b610af8; }, function (v) { return $bd1886c0795fcefa$export$30780d0b6b610af8 = v; });
var $bd1886c0795fcefa$export$910dde7540d1f6cf;
var $bd1886c0795fcefa$export$c958aa0cc90a067;
var $bd1886c0795fcefa$export$cf980ec1f8b21744;
var $bd1886c0795fcefa$export$e1d786d2f707b414;
var $bd1886c0795fcefa$export$55e8620fb8f1efdf;
var $bd1886c0795fcefa$export$15785dcc95f3e6d2;
var $bd1886c0795fcefa$export$30780d0b6b610af8;
$bd1886c0795fcefa$export$910dde7540d1f6cf = "_app-views-Tuning-CirclesMobile-_styles__circlesWrap";
$bd1886c0795fcefa$export$c958aa0cc90a067 = "_app-views-Tuning-CirclesMobile-_styles__circles";
$bd1886c0795fcefa$export$cf980ec1f8b21744 = "_app-views-Tuning-CirclesMobile-_styles__letters";
$bd1886c0795fcefa$export$e1d786d2f707b414 = "_app-views-Tuning-CirclesMobile-_styles__circle";
$bd1886c0795fcefa$export$55e8620fb8f1efdf = "_app-views-Tuning-CirclesMobile-_styles__circlesFill";
$bd1886c0795fcefa$export$15785dcc95f3e6d2 = "_app-views-Tuning-CirclesMobile-_styles__circleStroke";
$bd1886c0795fcefa$export$30780d0b6b610af8 = "_app-views-Tuning-CirclesMobile-_styles__letter";




const $6528f34e56d8cc79$var$STXSUrl = new URL($4a187584cb4dbfca$exports);

const $6528f34e56d8cc79$var$STXTUrl = new URL($2e710d10fc06f454$exports);

const $6528f34e56d8cc79$var$STXXUrl = new URL($08b0dd3494386e26$exports);
class $6528f34e56d8cc79$var$Circles extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {
        let delay = 0.2;
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._circles, {
            opacity: 0
        }, {
            opacity: .9,
            delay: delay,
            duration: 3
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._circle1, {
            opacity: .5
        }, {
            opacity: .5,
            y: "-=15",
            delay: delay,
            duration: 15
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._circle2, {
            opacity: .5,
            filter: 'blur(0.5px)'
        }, {
            opacity: .5,
            filter: 'blur(1.5px)',
            delay: delay,
            duration: 15
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._circle3, {
            y: "+=0"
        }, {
            y: "+=15",
            delay: delay,
            duration: 15
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo([
            this._letter1,
            this._letter2,
            this._letter3
        ], {
            opacity: 0
        }, {
            opacity: .9,
            delay: delay + .1,
            duration: 3,
            stagger: .2
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._letter1, {
            y: "-=15",
            delay: delay,
            duration: 15
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._letter3, {
            y: "+=15",
            delay: delay,
            duration: 15
        });
        if (this._circle3) {
            let position = this._circle3.getBoundingClientRect();
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).circlesWrap)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._circles = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).circles)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).circle),
            viewBox: "0 0 100 100",
            ref: (c)=>{
                this._circle1 = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("circle", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).circleStroke),
            cx: "50",
            cy: "50",
            r: "49"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
            style: {
                filter: "blur(1px)"
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).circle),
            viewBox: "0 0 100 100",
            ref: (c)=>{
                this._circle2 = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("circle", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).circleStroke),
            cx: "50",
            cy: "50",
            r: "49"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
            style: {
                filter: "blur(3px)"
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).circle),
            viewBox: "0 0 100 100",
            ref: (c)=>{
                this._circle3 = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("circle", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).circleStroke),
            cx: "50",
            cy: "50",
            r: "49"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._letters = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).letters)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).letter),
            ref: (c)=>{
                this._letter1 = c;
            },
            src: $6528f34e56d8cc79$var$STXSUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).letter, (0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).letter2),
            ref: (c)=>{
                this._letter2 = c;
            },
            src: $6528f34e56d8cc79$var$STXTUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bd1886c0795fcefa$exports))).letter),
            ref: (c)=>{
                this._letter3 = c;
            },
            src: $6528f34e56d8cc79$var$STXXUrl
        })));
    }
}
var $6528f34e56d8cc79$export$2e2bcd8739ae039 = $6528f34e56d8cc79$var$Circles;







const $21a43a919769bc50$var$backgroundUrl = new URL($f08fcdce49270724$exports);

const $21a43a919769bc50$var$STXSUrl = new URL($f78b537bd3a1a5e6$exports);

const $21a43a919769bc50$var$STXTUrl = new URL($b528e1a5f57580c2$exports);

const $21a43a919769bc50$var$STXXUrl = new URL($1976700d2926664c$exports);

const $21a43a919769bc50$var$STXTblurredUrl = new URL($2e710d10fc06f454$exports);
const $21a43a919769bc50$var$options = {
    // Force height on xxwide screens
    maintainAspectRatio: window.innerWidth < 1800,
    // aspectRatio: 4,
    animation: {
    },
    // tooltips: {
    //   mode: 'index',
    //   intersect: false,
    // },
    // hover: {
    //   mode: 'nearest',
    //   intersect: true
    // },
    // scales: {
    //   yAxes: [{
    //     ticks: {
    //       beginAtZero:true,
    //       stepSize: 2
    //     }
    //   }],
    //   xAxes: [{
    //     ticks: {
    //       stepSize: 4
    //     }
    //   }]
    // },
    tooltips: {
        enabled: false
    },
    legend: {
        display: false
    },
    scales: {
        yAxes: [
            {
                ticks: {
                    // Include a dollar sign in the ticks
                    fontColor: "rgba(255,255,255,.5)",
                    fontFamily: "Calibre, sans-serif",
                    fontSize: window.innerWidth < 1800 ? 10 : 12,
                    min: 0,
                    max: 1
                },
                gridLines: {
                    zeroLineColor: "rgba(255,255,255,.3)",
                    color: "transparent"
                }
            }
        ],
        xAxes: [
            {
                ticks: {
                    fontColor: "rgba(255,255,255,.5)",
                    fontFamily: "Calibre, sans-serif",
                    fontSize: window.innerWidth < 2000 ? 9 : 11.5,
                    stepSize: 1,
                    min: 0,
                    max: 23
                },
                gridLines: {
                    zeroLineColor: "rgba(255,255,255,.3)",
                    color: "transparent"
                }
            }
        ]
    }
};
class $21a43a919769bc50$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        currentLength: "37",
        currentVariant: "t",
        chartState: (0, $803e9b9f767390d1$export$d4c72bab9d6cc13a),
        ready: false,
        open: false,
        closeButtonWasClicked: false
    };
    handleLengthClick = (newLength)=>{
        let newDataset = (0, $803e9b9f767390d1$export$fa75311891f179ce)[newLength]["data"][this.state.currentVariant] || (0, $803e9b9f767390d1$export$fa75311891f179ce)[newLength]["data"]["t"];
        let el = document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).popupInner}`);
        (0, $36b3090cb6608e8f$export$99ee26438460406a).killTweensOf(el);
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(el, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 1,
            delay: 0.09
        });
        setTimeout(()=>{
            this.setState({
                open: !this.state.open,
                currentLength: newLength,
                chartState: {
                    ...(0, $803e9b9f767390d1$export$d4c72bab9d6cc13a),
                    datasets: newDataset
                }
            });
        }, 100);
    };
    handleVariantClick = (newVariant)=>{
        let newDataset = (0, $803e9b9f767390d1$export$fa75311891f179ce)[this.state.currentLength]["data"][newVariant] || (0, $803e9b9f767390d1$export$fa75311891f179ce)[this.state.currentLength]["data"]["t"];
        if (this.state.currentVariant != newVariant) {
            let el = document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).lengths}`);
            (0, $36b3090cb6608e8f$export$99ee26438460406a).killTweensOf(el);
            (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline().to(el, {
                opacity: 0,
                duration: 0
            }).to(el, {
                opacity: 0.7,
                duration: 2.6,
                ease: (0, $e8afa155fcb2c918$export$94f46869cc67acd8).create("custom", "M0,0 C0,0 0.09116,0.26782 0.15086,0.43074 0.15694,0.44733 0.16234,0.45808 0.17283,0.47169 0.19642,0.50228 0.21314,0.52234 0.24249,0.54956 0.31205,0.61403 0.35449,0.65299 0.43055,0.71057 0.51315,0.77311 0.56472,0.80796 0.65357,0.86077 0.72937,0.90584 0.77865,0.92848 0.85807,0.96473 0.88838,0.97856 0.90924,0.98412 0.94124,0.99208 0.96291,0.99746 1,1 1,1")
            });
        }
        setTimeout(()=>{
            this.setState({
                currentVariant: newVariant,
                chartState: {
                    ...(0, $803e9b9f767390d1$export$d4c72bab9d6cc13a),
                    datasets: newDataset
                }
            });
        }, 50);
    };
    closePopup = ()=>{
        this.setState({
            open: false,
            closeButtonWasClicked: true
        });
    };
    componentDidMount() {
        (0, $36b3090cb6608e8f$export$99ee26438460406a).registerPlugin((0, $e8afa155fcb2c918$export$94f46869cc67acd8));
        (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline().to(this._copy, {
            opacity: 0.9,
            duration: 1,
            delay: 1.75
        });
        let delay = 0.2;
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo([
            this._circlesLabel1,
            this._circlesLabel2,
            this._circlesLabel3
        ], {
            opacity: 0
        }, {
            opacity: 0.9,
            delay: delay + 0.1,
            duration: 3,
            stagger: 0.4
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._circlesLabel1, {
            y: "-=15",
            delay: delay,
            duration: 15
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._circlesLabel3, {
            y: "+=15",
            delay: delay,
            duration: 15
        });
        // hide CirclesMobile until the main image is loaded, to prevent layout jumping
        let img = new Image();
        let that = this;
        img.onload = function() {
            that.setState({
                ready: true
            });
        };
        img.src = $21a43a919769bc50$var$STXTblurredUrl;
    }
    render() {
        if (!this.state.open && this.state.closeButtonWasClicked) document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).chartSectionWrap}`)[0].scrollIntoView();
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._chartText, {
            opacity: 0.7,
            duration: 0.3,
            delay: 0.1
        });
        let that = this;
        let lengthNumber = this.state.currentLength.replace("F", "").replace(/7$/, "");
        let variantName = "STRAIGHT";
        switch(this.state.currentVariant){
            case "t":
                variantName = "TRANSIENT";
                break;
            case "x":
                variantName = "EXPRESSIVE";
                break;
        }
        // make padding between copy and surrounding elements the same
        let distanceFromCirclesToCopy = 100;
        if (this._circlesLabels) {
            distanceFromCirclesToCopy = this._copy.getBoundingClientRect().top - this._circlesLabels.getBoundingClientRect().bottom - 62 - 12;
            if (distanceFromCirclesToCopy < 0) distanceFromCirclesToCopy = 0;
            distanceFromCirclesToCopy = `${distanceFromCirclesToCopy}px`;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))({
                [(0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).ready]: this.state.ready
            }, (0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports)))[`variant${this.state.currentVariant}`])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: "bg"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $35950112c9f1df8b$export$2e2bcd8739ae039), {
            src: $21a43a919769bc50$var$backgroundUrl,
            className: "bg",
            readyClassName: "bgReady"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).sectionTuning)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).circlesSectionWrapOuter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).circlesSectionWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).circlesSection)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $6528f34e56d8cc79$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._circlesLabels = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).circlesLabels)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._circlesLabel1 = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).circlesLabel)
        }, "STRAIGHT"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._circlesLabel2 = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).circlesLabel)
        }, "TRANSIENT"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._circlesLabel3 = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).circlesLabel)
        }, "EXPRESSIVE"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._copy = c;
            },
            // style={{paddingBottom: distanceFromCirclesToCopy}}
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).pageText)
        }, "Every BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " lens is hand-built, using proprietary production processes which allow the optical performance of each lens in the range to be uniquely configured and tuned to their owner\u2019s wishes and creative style.", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "Three pre-set tonalities are available to\xa0order.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).chartSectionWrap
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).chartSection)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).moreInfo
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "*"), "TAP EACH FOR MORE INFO", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "*")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).chartVariants)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))({
                [(0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).variantActive]: this.state.currentVariant == "s"
            }),
            onClick: ()=>that.handleVariantClick("s")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).chartVariant),
            style: {
                textAlign: "center"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            src: $21a43a919769bc50$var$STXSUrl
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).variantLabel)
        }, "STRAIGHT")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))({
                [(0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).variantActive]: this.state.currentVariant == "t"
            }),
            onClick: ()=>that.handleVariantClick("t")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).chartVariant),
            style: {
                textAlign: "center"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            src: $21a43a919769bc50$var$STXTUrl
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).variantLabel)
        }, "TRANSIENT")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))({
                [(0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).variantActive]: this.state.currentVariant == "x"
            }),
            onClick: ()=>that.handleVariantClick("x")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).chartVariant),
            style: {
                textAlign: "center"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            src: $21a43a919769bc50$var$STXXUrl
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).variantLabel)
        }, "EXPRESSIVE"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).lengths)
        }, Object.keys((0, $803e9b9f767390d1$export$fa75311891f179ce)).map((key, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).length, {
                    [(0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).lengthActive]: this.state.currentLength == key
                }),
                onClick: ()=>that.handleLengthClick(key),
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("b", null, key.slice(0, -1)), "7"), "MM"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).popup, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).open]: this.state.open
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).popupInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).x,
            onClick: this.closePopup
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $a236a42500d6f7c3$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).chartArea),
            ref: (c)=>{
                this._chartArea = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).length)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("b", null, lengthNumber), "7"), "MM"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).variantLabel)
        }, variantName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._chartText = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).chartText, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).longChartText]: this.state.currentLength == "77"
            }),
            dangerouslySetInnerHTML: {
                __html: (0, $803e9b9f767390d1$export$29f9f81de5c56283)[`F${this.state.currentLength}`][this.state.currentVariant]
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).chartWrapOuter)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).chartWrap)
        }, this.state.chartState["datasets"] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $991fb83ad4494ad4$exports.Line), {
            width: 440,
            height: 300,
            data: this.state.chartState,
            options: $21a43a919769bc50$var$options
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ff670b086ea499e5$exports))).legend)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
            style: {
                borderTop: "2px solid var(--gold)"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "5 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "SAGITTAL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
            style: {
                borderTop: "2px dashed var(--gold)"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "5 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "TANGENTIAL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
            style: {
                borderTop: "2px solid var(--red)"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "10 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "SAGITTAL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
            style: {
                borderTop: "2px dashed var(--red)"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "10 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "TANGENTIAL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
            style: {
                borderTop: "2px solid var(--blue)"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "20 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "SAGITTAL")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", {
            style: {
                borderTop: "2px dashed var(--blue)"
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "20 LP/MM", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "TANGENTIAL"))))))));
    }
}




class $09cf08068afebea4$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {
        window.addEventListener("resize", this.onResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }
    onResize = ()=>{
        this.forceUpdate();
    };
    render() {
        const meta = {
            title: "Tuning",
            description: "Individually tune your set to enhance or distort elements of color and light."
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f7489db668f41cb3$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("title", null, meta.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("meta", {
            name: "description",
            content: meta.description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("link", {
            rel: "canonical",
            href: `${window.location.origin}/tuning`
        })), !(0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $bd93cd6e66a878fc$export$2e2bcd8739ae039), null), (0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $21a43a919769bc50$export$2e2bcd8739ae039), null));
    }
}



var $jiXHd = parcelRequire("jiXHd");

var $jiXHd = parcelRequire("jiXHd");



var $0b85533b89c6e362$exports = {};

$parcel$export($0b85533b89c6e362$exports, "header", function () { return $0b85533b89c6e362$export$38e42c68cf43b5d4; }, function (v) { return $0b85533b89c6e362$export$38e42c68cf43b5d4 = v; });
$parcel$export($0b85533b89c6e362$exports, "firstSection", function () { return $0b85533b89c6e362$export$c64e618c6a2b286f; }, function (v) { return $0b85533b89c6e362$export$c64e618c6a2b286f = v; });
$parcel$export($0b85533b89c6e362$exports, "lengths", function () { return $0b85533b89c6e362$export$3b026dac17332221; }, function (v) { return $0b85533b89c6e362$export$3b026dac17332221 = v; });
$parcel$export($0b85533b89c6e362$exports, "length", function () { return $0b85533b89c6e362$export$f24224f1c91d8156; }, function (v) { return $0b85533b89c6e362$export$f24224f1c91d8156 = v; });
$parcel$export($0b85533b89c6e362$exports, "lengthActive", function () { return $0b85533b89c6e362$export$4ce2ca2cd632f143; }, function (v) { return $0b85533b89c6e362$export$4ce2ca2cd632f143 = v; });
$parcel$export($0b85533b89c6e362$exports, "diagram", function () { return $0b85533b89c6e362$export$6118d022d940d562; }, function (v) { return $0b85533b89c6e362$export$6118d022d940d562 = v; });
$parcel$export($0b85533b89c6e362$exports, "pageBody", function () { return $0b85533b89c6e362$export$39c96952803efd29; }, function (v) { return $0b85533b89c6e362$export$39c96952803efd29 = v; });
$parcel$export($0b85533b89c6e362$exports, "diagramSectionOuter", function () { return $0b85533b89c6e362$export$1fa59405f11ef2c8; }, function (v) { return $0b85533b89c6e362$export$1fa59405f11ef2c8 = v; });
$parcel$export($0b85533b89c6e362$exports, "diagramSectionInner", function () { return $0b85533b89c6e362$export$75f0379a58392c2b; }, function (v) { return $0b85533b89c6e362$export$75f0379a58392c2b = v; });
$parcel$export($0b85533b89c6e362$exports, "diagramText", function () { return $0b85533b89c6e362$export$bb68a1a9c911666b; }, function (v) { return $0b85533b89c6e362$export$bb68a1a9c911666b = v; });
$parcel$export($0b85533b89c6e362$exports, "inspiration", function () { return $0b85533b89c6e362$export$21421aa1df9329d4; }, function (v) { return $0b85533b89c6e362$export$21421aa1df9329d4 = v; });
$parcel$export($0b85533b89c6e362$exports, "inspirationHeader", function () { return $0b85533b89c6e362$export$965a827f71b58a62; }, function (v) { return $0b85533b89c6e362$export$965a827f71b58a62 = v; });
$parcel$export($0b85533b89c6e362$exports, "testimonialQuote", function () { return $0b85533b89c6e362$export$537a312deb4e679a; }, function (v) { return $0b85533b89c6e362$export$537a312deb4e679a = v; });
$parcel$export($0b85533b89c6e362$exports, "author", function () { return $0b85533b89c6e362$export$571b02044ddb2ab3; }, function (v) { return $0b85533b89c6e362$export$571b02044ddb2ab3 = v; });
$parcel$export($0b85533b89c6e362$exports, "authorName", function () { return $0b85533b89c6e362$export$9acf1a0a0a3c8f42; }, function (v) { return $0b85533b89c6e362$export$9acf1a0a0a3c8f42 = v; });
$parcel$export($0b85533b89c6e362$exports, "authorCompany", function () { return $0b85533b89c6e362$export$b3b15719e74ba5ee; }, function (v) { return $0b85533b89c6e362$export$b3b15719e74ba5ee = v; });
$parcel$export($0b85533b89c6e362$exports, "bg", function () { return $0b85533b89c6e362$export$136fd86de524d3c2; }, function (v) { return $0b85533b89c6e362$export$136fd86de524d3c2 = v; });
$parcel$export($0b85533b89c6e362$exports, "bgReady", function () { return $0b85533b89c6e362$export$2eddb9afc6c2340f; }, function (v) { return $0b85533b89c6e362$export$2eddb9afc6c2340f = v; });
$parcel$export($0b85533b89c6e362$exports, "lensesBg", function () { return $0b85533b89c6e362$export$a83893c98eb33f58; }, function (v) { return $0b85533b89c6e362$export$a83893c98eb33f58 = v; });
$parcel$export($0b85533b89c6e362$exports, "arrowWrap", function () { return $0b85533b89c6e362$export$f47a18c8bbf2941e; }, function (v) { return $0b85533b89c6e362$export$f47a18c8bbf2941e = v; });
$parcel$export($0b85533b89c6e362$exports, "visible", function () { return $0b85533b89c6e362$export$664c6d24e3175067; }, function (v) { return $0b85533b89c6e362$export$664c6d24e3175067 = v; });
var $0b85533b89c6e362$export$38e42c68cf43b5d4;
var $0b85533b89c6e362$export$c64e618c6a2b286f;
var $0b85533b89c6e362$export$3b026dac17332221;
var $0b85533b89c6e362$export$f24224f1c91d8156;
var $0b85533b89c6e362$export$4ce2ca2cd632f143;
var $0b85533b89c6e362$export$6118d022d940d562;
var $0b85533b89c6e362$export$39c96952803efd29;
var $0b85533b89c6e362$export$1fa59405f11ef2c8;
var $0b85533b89c6e362$export$75f0379a58392c2b;
var $0b85533b89c6e362$export$bb68a1a9c911666b;
var $0b85533b89c6e362$export$21421aa1df9329d4;
var $0b85533b89c6e362$export$965a827f71b58a62;
var $0b85533b89c6e362$export$537a312deb4e679a;
var $0b85533b89c6e362$export$571b02044ddb2ab3;
var $0b85533b89c6e362$export$9acf1a0a0a3c8f42;
var $0b85533b89c6e362$export$b3b15719e74ba5ee;
var $0b85533b89c6e362$export$136fd86de524d3c2;
var $0b85533b89c6e362$export$2eddb9afc6c2340f;
var $0b85533b89c6e362$export$a83893c98eb33f58;
var $0b85533b89c6e362$export$f47a18c8bbf2941e;
var $0b85533b89c6e362$export$664c6d24e3175067;
$0b85533b89c6e362$export$38e42c68cf43b5d4 = "_app-views-LensRange-LensRangeDesktop-_styles__header";
$0b85533b89c6e362$export$c64e618c6a2b286f = "_app-views-LensRange-LensRangeDesktop-_styles__firstSection";
$0b85533b89c6e362$export$3b026dac17332221 = "_app-views-LensRange-LensRangeDesktop-_styles__lengths";
$0b85533b89c6e362$export$f24224f1c91d8156 = "_app-views-LensRange-LensRangeDesktop-_styles__length";
$0b85533b89c6e362$export$4ce2ca2cd632f143 = "_app-views-LensRange-LensRangeDesktop-_styles__lengthActive";
$0b85533b89c6e362$export$6118d022d940d562 = "_app-views-LensRange-LensRangeDesktop-_styles__diagram";
$0b85533b89c6e362$export$39c96952803efd29 = "_app-views-LensRange-LensRangeDesktop-_styles__pageBody";
$0b85533b89c6e362$export$1fa59405f11ef2c8 = "_app-views-LensRange-LensRangeDesktop-_styles__diagramSectionOuter";
$0b85533b89c6e362$export$75f0379a58392c2b = "_app-views-LensRange-LensRangeDesktop-_styles__diagramSectionInner";
$0b85533b89c6e362$export$bb68a1a9c911666b = "_app-views-LensRange-LensRangeDesktop-_styles__diagramText";
$0b85533b89c6e362$export$21421aa1df9329d4 = "_app-views-LensRange-LensRangeDesktop-_styles__inspiration";
$0b85533b89c6e362$export$965a827f71b58a62 = "_app-views-LensRange-LensRangeDesktop-_styles__inspirationHeader";
$0b85533b89c6e362$export$537a312deb4e679a = "_app-views-LensRange-LensRangeDesktop-_styles__testimonialQuote";
$0b85533b89c6e362$export$571b02044ddb2ab3 = "_app-views-LensRange-LensRangeDesktop-_styles__author";
$0b85533b89c6e362$export$9acf1a0a0a3c8f42 = "_app-views-LensRange-LensRangeDesktop-_styles__authorName";
$0b85533b89c6e362$export$b3b15719e74ba5ee = "_app-views-LensRange-LensRangeDesktop-_styles__authorCompany";
$0b85533b89c6e362$export$136fd86de524d3c2 = "_app-views-LensRange-LensRangeDesktop-_styles__bg";
$0b85533b89c6e362$export$2eddb9afc6c2340f = "_app-views-LensRange-LensRangeDesktop-_styles__bgReady";
$0b85533b89c6e362$export$a83893c98eb33f58 = "_app-views-LensRange-LensRangeDesktop-_styles__lensesBg";
$0b85533b89c6e362$export$f47a18c8bbf2941e = "_app-views-LensRange-LensRangeDesktop-_styles__arrowWrap";
$0b85533b89c6e362$export$664c6d24e3175067 = "_app-views-LensRange-LensRangeDesktop-_styles__visible";





/* eslint-disable prettier/prettier */ // eslint-disable-next-line import/prefer-default-export
const $d183b23a1dd3620d$export$29f9f81de5c56283 = [
    {
        focalLength: "F17",
        inspiration: [],
        testimonial: null
    },
    {
        focalLength: "F207",
        inspiration: [
            "1980 LEICA 21mm f/2.8",
            "Retrofocus design"
        ],
        testimonial: null
    },
    {
        focalLength: "F237",
        inspiration: [
            "1950\u2019s Retrofocus construction",
            "P. Angenieux Paris 24mm f/2.2 Retrofocus Type R2"
        ],
        testimonial: {
            quote: "The 23.7mm has impressive coverage for large format. It has a clearness in the centre but also has a nice, slight fall off towards the edges that reminds me of the old  glass I love.",
            author: {
                name: "Darius Khondji AFC ASC",
                title: "Cinematographer",
                company: null
            }
        }
    },
    {
        focalLength: "F27",
        inspiration: [
            "1960\u2019s Retrofocus construction",
            "Sigma WIDEMAX",
            "Asahi Super TAKUMAR"
        ],
        testimonial: {
            quote: "The 27mm BLACKWING<sup>7</sup> prime is truly cinematic. The skin color rendition and the fall-off are superb and the subtle softness of the lens is very pleasing on faces. I like the \u2018distancing from reality\u2019 that the BLACKWING<sup>7</sup> lens creates.",
            author: {
                name: "NICOLAS LOIR",
                title: "Cinematographer",
                company: null
            }
        }
    },
    {
        focalLength: "F37",
        inspiration: [
            "1950\u2019s retrofocus construction",
            "R1 Angenieux 35mm f/2.5"
        ],
        testimonial: {
            quote: "I used the 37 for a flashback memory sequence on the upcoming Brave New World show; I found the lens at T1.8 to be so magical, so painterly, so evocative and unique. BLACKWING<sup>7</sup> lenses allow for total artistic expression in cinema.",
            author: {
                name: "ANDRIJ PAREKH ASC",
                title: "Cinematographer/Director",
                company: null
            }
        }
    },
    {
        focalLength: "F47",
        inspiration: [
            "1930\u2019s \u2013 1950\u2019s retrofocus construction",
            "1950 Wray UNILITE 50 mm f/2",
            "1936 Kodak EKTAR 45 mm f/2"
        ],
        testimonial: {
            quote: "The 47 proves to be way more than the sum of its parts. It speaks to the vision and philosophy of its creators, who championed a simplicity in design that shines through in the authenticity of the images it produces. The results speak for themselves; images from a lens that resolves beautifully and has a nuanced gentle fall off to a creamy bokeh. And most importantly performs best wide open. So impressive.",
            author: {
                name: "BEN SERESIN BSC ASC",
                title: "Cinematographer",
                company: null
            }
        }
    },
    {
        focalLength: "F57",
        inspiration: [
            "1940\u2019s Biotar construction",
            "Asahi TAKUMAR 55mm f/1.8"
        ],
        testimonial: {
            quote: "There is something ethereal and dimensional about the 57 T tuned lens that has my mind thinking about glass in a whole new way. I find myself lighting and blocking setups conscientiously to embrace the flare and falloff of this lens. There have been entire days when the 57 never left our camera.",
            author: {
                name: "DOUG EMMETT",
                title: "Cinematographer",
                company: null
            }
        }
    },
    {
        focalLength: "F77",
        inspiration: [
            "1950\u2019s Double-Gauss construction",
            "Schneider XENOTAR",
            "Carl Zeiss BIOTAR"
        ],
        testimonial: {
            quote: "These lenses, and the 77 in particular, offer image makers \u2018atmospheric protection\u2019. They counter the digital sharpness of big sensors (a sharpness that destroys suspension of disbelief) with a vision of pure story. Soft and vast and warm, all in one.",
            author: {
                name: "ISAIAH SERET",
                title: "Director",
                company: null
            }
        }
    },
    {
        focalLength: "F107",
        inspiration: [
            "1970\u2019s BIOTAR / PETZVAL construction",
            "Hasselblad 110mm f/2 PLANAR"
        ],
        testimonial: {
            quote: "BLACKWING<sup>7</sup> lenses are a pleasure to work with and bring a level of richness like no others. The 107 has a strong and glamorous look, with those loopy magnetic flux flares that we love.",
            author: {
                name: "CHRIS SILANO",
                title: "First Assistant Cameraman",
                company: "LISEY'S STORY"
            }
        }
    },
    {
        focalLength: "F137",
        inspiration: [
            "1970\u2019s BIOTAR / PETZVAL construction",
            "Leica M tele-ELMAR"
        ],
        testimonial: {
            quote: "The 137mm BLACKWING<sup>7</sup> prime focuses close and sharp, without being overly sharp. It delivers a really interesting reaction to a strong source light and is a lovely addition to this unique set of lenses.",
            author: {
                name: "KAVON ELHAMI",
                title: "President",
                company: "CAMTEC - MOTION PICTURE CAMERA SYSTEMS"
            }
        }
    }
];


var $67388cfb98eb9018$exports = {};
$67388cfb98eb9018$exports = $parcel$resolve("fWVzQ");


// Individual image imports replacing glob pattern
const $5c0a55ddb3f17563$var$F17Url = new URL($67388cfb98eb9018$exports);
var $ecabcd6637e99560$exports = {};
$ecabcd6637e99560$exports = $parcel$resolve("l7K4W");


const $5c0a55ddb3f17563$var$F207Url = new URL($ecabcd6637e99560$exports);
var $a749dd74ecc7c3c6$exports = {};
$a749dd74ecc7c3c6$exports = $parcel$resolve("4WFCh");


const $5c0a55ddb3f17563$var$F237Url = new URL($a749dd74ecc7c3c6$exports);
var $7152a6bd115072ca$exports = {};
$7152a6bd115072ca$exports = $parcel$resolve("ka6xu");


const $5c0a55ddb3f17563$var$F27Url = new URL($7152a6bd115072ca$exports);
var $fd9bba83e88a6a4c$exports = {};
$fd9bba83e88a6a4c$exports = $parcel$resolve("2s1iv");


const $5c0a55ddb3f17563$var$F37Url = new URL($fd9bba83e88a6a4c$exports);
var $07d41b166079b03b$exports = {};
$07d41b166079b03b$exports = $parcel$resolve("1G8JQ");


const $5c0a55ddb3f17563$var$F47Url = new URL($07d41b166079b03b$exports);
var $0faa079f98fa02a8$exports = {};
$0faa079f98fa02a8$exports = $parcel$resolve("fdY6i");


const $5c0a55ddb3f17563$var$F57Url = new URL($0faa079f98fa02a8$exports);
var $28ff9179045122c9$exports = {};
$28ff9179045122c9$exports = $parcel$resolve("23NbK");


const $5c0a55ddb3f17563$var$F77Url = new URL($28ff9179045122c9$exports);
var $420e7c2c69f91cfa$exports = {};
$420e7c2c69f91cfa$exports = $parcel$resolve("8kVOU");


const $5c0a55ddb3f17563$var$F107Url = new URL($420e7c2c69f91cfa$exports);
var $57356064f48783c6$exports = {};
$57356064f48783c6$exports = $parcel$resolve("3bt0H");


const $5c0a55ddb3f17563$var$F137Url = new URL($57356064f48783c6$exports);
// Create diagrams object to maintain compatibility
const $5c0a55ddb3f17563$var$diagrams = {
    F17: $5c0a55ddb3f17563$var$F17Url,
    F207: $5c0a55ddb3f17563$var$F207Url,
    F237: $5c0a55ddb3f17563$var$F237Url,
    F27: $5c0a55ddb3f17563$var$F27Url,
    F37: $5c0a55ddb3f17563$var$F37Url,
    F47: $5c0a55ddb3f17563$var$F47Url,
    F57: $5c0a55ddb3f17563$var$F57Url,
    F77: $5c0a55ddb3f17563$var$F77Url,
    F107: $5c0a55ddb3f17563$var$F107Url,
    F137: $5c0a55ddb3f17563$var$F137Url
};

const $5c0a55ddb3f17563$var$backgroundUrl = new URL($f08fcdce49270724$exports);
class $5c0a55ddb3f17563$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        currentLens: "F77",
        lenses: [
            {
                focalLength: "17",
                symbol: "F17"
            },
            {
                focalLength: "20.7",
                symbol: "F207"
            },
            {
                focalLength: "23.7",
                symbol: "F237"
            },
            {
                focalLength: "27",
                symbol: "F27"
            },
            {
                focalLength: "37",
                symbol: "F37"
            },
            {
                focalLength: "47",
                symbol: "F47"
            },
            {
                focalLength: "57",
                symbol: "F57"
            },
            {
                focalLength: "77",
                symbol: "F77"
            },
            {
                focalLength: "107",
                symbol: "F107"
            },
            {
                focalLength: "137",
                symbol: "F137"
            }
        ]
    };
    componentDidMount() {
        // preload diagram images
        let images = new Array();
        for(var key in $5c0a55ddb3f17563$var$diagrams)images.push($5c0a55ddb3f17563$var$diagrams[key]);
        this.loadImagesInSequence(images, $5c0a55ddb3f17563$var$diagrams);
    }
    loadImagesInSequence = (images, diagrams)=>{
        if (!images.length) return;
        // fade in the page after first image loads
        if (images.length === Object.keys(diagrams).length - 1) this.fadeInPage();
        let img = new Image(), url = images.shift();
        let that = this;
        img.onload = function() {
            that.loadImagesInSequence(images, diagrams);
        };
        img.src = url;
    };
    handleLengthChange = (newLens)=>{
        if (this.state.currentLens !== newLens) {
            (0, $36b3090cb6608e8f$export$99ee26438460406a).killTweensOf(this._el);
            (0, $36b3090cb6608e8f$export$99ee26438460406a).killTweensOf(this._text);
            (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline().to(this._el, {
                opacity: 0,
                scaleY: 1.03,
                duration: 0.2,
                onComplete: this.onCompleteHandler,
                onCompleteParams: [
                    newLens
                ]
            }).to(this._text, {
                opacity: 0,
                duration: 0.12
            }, "-=0.2");
        }
    };
    onCompleteHandler = (newLens)=>{
        this.setState({
            currentLens: newLens
        });
    };
    fadeInPage = ()=>{
        (0, $36b3090cb6608e8f$export$99ee26438460406a).registerPlugin((0, $e8afa155fcb2c918$export$94f46869cc67acd8));
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(this._wrap, {
            opacity: 0
        }, {
            opacity: 0.7,
            duration: 2.6,
            ease: (0, $e8afa155fcb2c918$export$94f46869cc67acd8).create("custom", "M0,0 C0,0 0.09116,0.26782 0.15086,0.43074 0.15694,0.44733 0.16234,0.45808 0.17283,0.47169 0.19642,0.50228 0.21314,0.52234 0.24249,0.54956 0.31205,0.61403 0.35449,0.65299 0.43055,0.71057 0.51315,0.77311 0.56472,0.80796 0.65357,0.86077 0.72937,0.90584 0.77865,0.92848 0.85807,0.96473 0.88838,0.97856 0.90924,0.98412 0.94124,0.99208 0.96291,0.99746 1,1 1,1")
        });
    };
    fadeIn = ()=>{
        (0, $36b3090cb6608e8f$export$99ee26438460406a).registerPlugin((0, $e8afa155fcb2c918$export$94f46869cc67acd8));
        if (this._el && this._text) (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline().fromTo(this._text, {
            opacity: 0
        }, {
            opacity: 0.7,
            duration: 2.6,
            ease: (0, $e8afa155fcb2c918$export$94f46869cc67acd8).create("custom", "M0,0 C0,0 0.09116,0.26782 0.15086,0.43074 0.15694,0.44733 0.16234,0.45808 0.17283,0.47169 0.19642,0.50228 0.21314,0.52234 0.24249,0.54956 0.31205,0.61403 0.35449,0.65299 0.43055,0.71057 0.51315,0.77311 0.56472,0.80796 0.65357,0.86077 0.72937,0.90584 0.77865,0.92848 0.85807,0.96473 0.88838,0.97856 0.90924,0.98412 0.94124,0.99208 0.96291,0.99746 1,1 1,1")
        }).fromTo(this._el, {
            opacity: 0,
            scaleY: 0.94
        }, {
            opacity: 1,
            scaleY: 1,
            duration: 10,
            ease: (0, $e8afa155fcb2c918$export$94f46869cc67acd8).create("custom", "M0,0,C0.028,0.398,0.035,0.658,0.226,0.762,0.44,0.878,0.818,1.001,1,1")
        }, "-=2.5");
    };
    // Iterate over lenses and display them
    displayLenses = (lenses)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).lengths)
        }, lenses.map((lens)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).length, {
                    [(0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).lengthActive]: this.state.currentLens === lens.symbol
                }),
                onMouseEnter: ()=>this.handleLengthChange(lens.symbol),
                key: lens.symbol
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("b", null, lens.focalLength.slice(0, -1)), "7"), "MM");
        }));
    };
    // Iterate over lenses' inspiration section text and display it if it's currently selected
    mappedLenses = (lenses, currentLens)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, lenses.map((lens)=>{
            if (lens.focalLength === currentLens) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                key: lens.symbol,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).inspiration)
            }, lens.inspiration.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).inspirationHeader)
            }, "INSPIRATION"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("ul", null, lens.inspiration.map((inspirationLine)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", {
                    key: inspirationLine
                }, inspirationLine);
            }))), lens.testimonial && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).testimonial)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).testimonialQuote),
                dangerouslySetInnerHTML: {
                    __html: lens.testimonial.quote
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).author)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).authorName)
            }, lens.testimonial.author.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).authorTitle)
            }, lens.testimonial.author.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).authorCompany)
            }, lens.testimonial.author.company))));
        }));
    };
    render() {
        this.fadeIn();
        const { lenses: lenses, currentLens: currentLens } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $35950112c9f1df8b$export$2e2bcd8739ae039), {
            src: $5c0a55ddb3f17563$var$backgroundUrl,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).bg,
            readyClassName: (0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).bgReady
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: "section",
            style: {
                display: "table",
                tableLayout: "fixed",
                width: "100%",
                height: "100vh"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).diagramSectionOuter),
            ref: (c)=>{
                this._wrap = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).diagramSectionInner)
        }, this.displayLenses(lenses), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).pageBody)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._text = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).diagramText)
        }, this.mappedLenses((0, $d183b23a1dd3620d$export$29f9f81de5c56283), currentLens)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._el = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0b85533b89c6e362$exports))).diagram)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            src: $5c0a55ddb3f17563$var$diagrams[currentLens]
        })))))));
    }
}



var $jiXHd = parcelRequire("jiXHd");

var $8d02d1ad28b3b359$exports = {};

$parcel$export($8d02d1ad28b3b359$exports, "header", function () { return $8d02d1ad28b3b359$export$38e42c68cf43b5d4; }, function (v) { return $8d02d1ad28b3b359$export$38e42c68cf43b5d4 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "firstSection", function () { return $8d02d1ad28b3b359$export$c64e618c6a2b286f; }, function (v) { return $8d02d1ad28b3b359$export$c64e618c6a2b286f = v; });
$parcel$export($8d02d1ad28b3b359$exports, "moreInfo", function () { return $8d02d1ad28b3b359$export$864caeab2e8f5ac5; }, function (v) { return $8d02d1ad28b3b359$export$864caeab2e8f5ac5 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "lengths", function () { return $8d02d1ad28b3b359$export$3b026dac17332221; }, function (v) { return $8d02d1ad28b3b359$export$3b026dac17332221 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "length", function () { return $8d02d1ad28b3b359$export$f24224f1c91d8156; }, function (v) { return $8d02d1ad28b3b359$export$f24224f1c91d8156 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "lengthActive", function () { return $8d02d1ad28b3b359$export$4ce2ca2cd632f143; }, function (v) { return $8d02d1ad28b3b359$export$4ce2ca2cd632f143 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "diagram", function () { return $8d02d1ad28b3b359$export$6118d022d940d562; }, function (v) { return $8d02d1ad28b3b359$export$6118d022d940d562 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "popup", function () { return $8d02d1ad28b3b359$export$63b4813c5280c707; }, function (v) { return $8d02d1ad28b3b359$export$63b4813c5280c707 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "open", function () { return $8d02d1ad28b3b359$export$3ce6949f20cea765; }, function (v) { return $8d02d1ad28b3b359$export$3ce6949f20cea765 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "popupInner", function () { return $8d02d1ad28b3b359$export$561d0e41d7c15aad; }, function (v) { return $8d02d1ad28b3b359$export$561d0e41d7c15aad = v; });
$parcel$export($8d02d1ad28b3b359$exports, "x", function () { return $8d02d1ad28b3b359$export$d141bba7fdc215a3; }, function (v) { return $8d02d1ad28b3b359$export$d141bba7fdc215a3 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "diagramSectionOuter", function () { return $8d02d1ad28b3b359$export$1fa59405f11ef2c8; }, function (v) { return $8d02d1ad28b3b359$export$1fa59405f11ef2c8 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "diagramSectionInner", function () { return $8d02d1ad28b3b359$export$75f0379a58392c2b; }, function (v) { return $8d02d1ad28b3b359$export$75f0379a58392c2b = v; });
$parcel$export($8d02d1ad28b3b359$exports, "diagramText", function () { return $8d02d1ad28b3b359$export$bb68a1a9c911666b; }, function (v) { return $8d02d1ad28b3b359$export$bb68a1a9c911666b = v; });
$parcel$export($8d02d1ad28b3b359$exports, "inspiration", function () { return $8d02d1ad28b3b359$export$21421aa1df9329d4; }, function (v) { return $8d02d1ad28b3b359$export$21421aa1df9329d4 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "inspirationHeader", function () { return $8d02d1ad28b3b359$export$965a827f71b58a62; }, function (v) { return $8d02d1ad28b3b359$export$965a827f71b58a62 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "testimonialQuote", function () { return $8d02d1ad28b3b359$export$537a312deb4e679a; }, function (v) { return $8d02d1ad28b3b359$export$537a312deb4e679a = v; });
$parcel$export($8d02d1ad28b3b359$exports, "author", function () { return $8d02d1ad28b3b359$export$571b02044ddb2ab3; }, function (v) { return $8d02d1ad28b3b359$export$571b02044ddb2ab3 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "authorName", function () { return $8d02d1ad28b3b359$export$9acf1a0a0a3c8f42; }, function (v) { return $8d02d1ad28b3b359$export$9acf1a0a0a3c8f42 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "authorCompany", function () { return $8d02d1ad28b3b359$export$b3b15719e74ba5ee; }, function (v) { return $8d02d1ad28b3b359$export$b3b15719e74ba5ee = v; });
$parcel$export($8d02d1ad28b3b359$exports, "bg", function () { return $8d02d1ad28b3b359$export$136fd86de524d3c2; }, function (v) { return $8d02d1ad28b3b359$export$136fd86de524d3c2 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "bgReady", function () { return $8d02d1ad28b3b359$export$2eddb9afc6c2340f; }, function (v) { return $8d02d1ad28b3b359$export$2eddb9afc6c2340f = v; });
$parcel$export($8d02d1ad28b3b359$exports, "lensesBg", function () { return $8d02d1ad28b3b359$export$a83893c98eb33f58; }, function (v) { return $8d02d1ad28b3b359$export$a83893c98eb33f58 = v; });
$parcel$export($8d02d1ad28b3b359$exports, "arrowWrap", function () { return $8d02d1ad28b3b359$export$f47a18c8bbf2941e; }, function (v) { return $8d02d1ad28b3b359$export$f47a18c8bbf2941e = v; });
$parcel$export($8d02d1ad28b3b359$exports, "visible", function () { return $8d02d1ad28b3b359$export$664c6d24e3175067; }, function (v) { return $8d02d1ad28b3b359$export$664c6d24e3175067 = v; });
var $8d02d1ad28b3b359$export$38e42c68cf43b5d4;
var $8d02d1ad28b3b359$export$c64e618c6a2b286f;
var $8d02d1ad28b3b359$export$864caeab2e8f5ac5;
var $8d02d1ad28b3b359$export$3b026dac17332221;
var $8d02d1ad28b3b359$export$f24224f1c91d8156;
var $8d02d1ad28b3b359$export$4ce2ca2cd632f143;
var $8d02d1ad28b3b359$export$6118d022d940d562;
var $8d02d1ad28b3b359$export$63b4813c5280c707;
var $8d02d1ad28b3b359$export$3ce6949f20cea765;
var $8d02d1ad28b3b359$export$561d0e41d7c15aad;
var $8d02d1ad28b3b359$export$d141bba7fdc215a3;
var $8d02d1ad28b3b359$export$1fa59405f11ef2c8;
var $8d02d1ad28b3b359$export$75f0379a58392c2b;
var $8d02d1ad28b3b359$export$bb68a1a9c911666b;
var $8d02d1ad28b3b359$export$21421aa1df9329d4;
var $8d02d1ad28b3b359$export$965a827f71b58a62;
var $8d02d1ad28b3b359$export$537a312deb4e679a;
var $8d02d1ad28b3b359$export$571b02044ddb2ab3;
var $8d02d1ad28b3b359$export$9acf1a0a0a3c8f42;
var $8d02d1ad28b3b359$export$b3b15719e74ba5ee;
var $8d02d1ad28b3b359$export$136fd86de524d3c2;
var $8d02d1ad28b3b359$export$2eddb9afc6c2340f;
var $8d02d1ad28b3b359$export$a83893c98eb33f58;
var $8d02d1ad28b3b359$export$f47a18c8bbf2941e;
var $8d02d1ad28b3b359$export$664c6d24e3175067;
$8d02d1ad28b3b359$export$38e42c68cf43b5d4 = "_app-views-LensRange-LensRangeMobile-_styles__header";
$8d02d1ad28b3b359$export$c64e618c6a2b286f = "_app-views-LensRange-LensRangeMobile-_styles__firstSection";
$8d02d1ad28b3b359$export$864caeab2e8f5ac5 = "_app-views-LensRange-LensRangeMobile-_styles__moreInfo";
$8d02d1ad28b3b359$export$3b026dac17332221 = "_app-views-LensRange-LensRangeMobile-_styles__lengths";
$8d02d1ad28b3b359$export$f24224f1c91d8156 = "_app-views-LensRange-LensRangeMobile-_styles__length";
$8d02d1ad28b3b359$export$4ce2ca2cd632f143 = "_app-views-LensRange-LensRangeMobile-_styles__lengthActive";
$8d02d1ad28b3b359$export$6118d022d940d562 = "_app-views-LensRange-LensRangeMobile-_styles__diagram";
$8d02d1ad28b3b359$export$63b4813c5280c707 = "_app-views-LensRange-LensRangeMobile-_styles__popup";
$8d02d1ad28b3b359$export$3ce6949f20cea765 = "_app-views-LensRange-LensRangeMobile-_styles__open";
$8d02d1ad28b3b359$export$561d0e41d7c15aad = "_app-views-LensRange-LensRangeMobile-_styles__popupInner";
$8d02d1ad28b3b359$export$d141bba7fdc215a3 = "_app-views-LensRange-LensRangeMobile-_styles__x";
$8d02d1ad28b3b359$export$1fa59405f11ef2c8 = "_app-views-LensRange-LensRangeMobile-_styles__diagramSectionOuter";
$8d02d1ad28b3b359$export$75f0379a58392c2b = "_app-views-LensRange-LensRangeMobile-_styles__diagramSectionInner";
$8d02d1ad28b3b359$export$bb68a1a9c911666b = "_app-views-LensRange-LensRangeMobile-_styles__diagramText";
$8d02d1ad28b3b359$export$21421aa1df9329d4 = "_app-views-LensRange-LensRangeMobile-_styles__inspiration";
$8d02d1ad28b3b359$export$965a827f71b58a62 = "_app-views-LensRange-LensRangeMobile-_styles__inspirationHeader";
$8d02d1ad28b3b359$export$537a312deb4e679a = "_app-views-LensRange-LensRangeMobile-_styles__testimonialQuote";
$8d02d1ad28b3b359$export$571b02044ddb2ab3 = "_app-views-LensRange-LensRangeMobile-_styles__author";
$8d02d1ad28b3b359$export$9acf1a0a0a3c8f42 = "_app-views-LensRange-LensRangeMobile-_styles__authorName";
$8d02d1ad28b3b359$export$b3b15719e74ba5ee = "_app-views-LensRange-LensRangeMobile-_styles__authorCompany";
$8d02d1ad28b3b359$export$136fd86de524d3c2 = "_app-views-LensRange-LensRangeMobile-_styles__bg";
$8d02d1ad28b3b359$export$2eddb9afc6c2340f = "_app-views-LensRange-LensRangeMobile-_styles__bgReady";
$8d02d1ad28b3b359$export$a83893c98eb33f58 = "_app-views-LensRange-LensRangeMobile-_styles__lensesBg";
$8d02d1ad28b3b359$export$f47a18c8bbf2941e = "_app-views-LensRange-LensRangeMobile-_styles__arrowWrap";
$8d02d1ad28b3b359$export$664c6d24e3175067 = "_app-views-LensRange-LensRangeMobile-_styles__visible";









// Individual image imports replacing glob pattern
const $79a511817b5c4841$var$F17Url = new URL($67388cfb98eb9018$exports);

const $79a511817b5c4841$var$F207Url = new URL($ecabcd6637e99560$exports);

const $79a511817b5c4841$var$F237Url = new URL($a749dd74ecc7c3c6$exports);

const $79a511817b5c4841$var$F27Url = new URL($7152a6bd115072ca$exports);

const $79a511817b5c4841$var$F37Url = new URL($fd9bba83e88a6a4c$exports);

const $79a511817b5c4841$var$F47Url = new URL($07d41b166079b03b$exports);

const $79a511817b5c4841$var$F57Url = new URL($0faa079f98fa02a8$exports);

const $79a511817b5c4841$var$F77Url = new URL($28ff9179045122c9$exports);

const $79a511817b5c4841$var$F107Url = new URL($420e7c2c69f91cfa$exports);

const $79a511817b5c4841$var$F137Url = new URL($57356064f48783c6$exports);
// Create diagrams object to maintain compatibility
const $79a511817b5c4841$var$diagrams = {
    F17: $79a511817b5c4841$var$F17Url,
    F207: $79a511817b5c4841$var$F207Url,
    F237: $79a511817b5c4841$var$F237Url,
    F27: $79a511817b5c4841$var$F27Url,
    F37: $79a511817b5c4841$var$F37Url,
    F47: $79a511817b5c4841$var$F47Url,
    F57: $79a511817b5c4841$var$F57Url,
    F77: $79a511817b5c4841$var$F77Url,
    F107: $79a511817b5c4841$var$F107Url,
    F137: $79a511817b5c4841$var$F137Url
};

const $79a511817b5c4841$var$backgroundUrl = new URL($f08fcdce49270724$exports);
class $79a511817b5c4841$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        currentLens: "F77",
        open: false,
        lenses: [
            {
                focalLength: "17",
                symbol: "F17"
            },
            {
                focalLength: "20.7",
                symbol: "F207"
            },
            {
                focalLength: "23.7",
                symbol: "F237"
            },
            {
                focalLength: "27",
                symbol: "F27"
            },
            {
                focalLength: "37",
                symbol: "F37"
            },
            {
                focalLength: "47",
                symbol: "F47"
            },
            {
                focalLength: "57",
                symbol: "F57"
            },
            {
                focalLength: "77",
                symbol: "F77"
            },
            {
                focalLength: "107",
                symbol: "F107"
            },
            {
                focalLength: "137",
                symbol: "F137"
            }
        ]
    };
    componentDidMount() {
        // preload diagram images
        let images = new Array();
        for(const key in $79a511817b5c4841$var$diagrams)images.push($79a511817b5c4841$var$diagrams[key]);
        this.loadImagesInSequence(images, $79a511817b5c4841$var$diagrams);
    }
    loadImagesInSequence = (images, diagrams)=>{
        if (!images.length) return;
        // fade in the page after first image loads
        // if (images.length === Object.keys(diagrams).length - 1) {
        //   this.fadeInPage()
        // }
        let img = new Image(), url = images.shift();
        let that = this;
        img.onload = function() {
            that.loadImagesInSequence(images, diagrams);
        };
        img.src = url;
    };
    handleLengthChange = (newLens)=>{
        let el = document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).popup} > div`);
        (0, $36b3090cb6608e8f$export$99ee26438460406a).killTweensOf(el);
        (0, $36b3090cb6608e8f$export$99ee26438460406a).fromTo(el, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 2.2,
            delay: 0
        });
        this.setState({
            open: !this.state.open,
            currentLens: newLens
        });
    };
    closePopup = ()=>{
        this.setState({
            open: false
        });
    };
    // Iterate over lenses and display them
    displayLenses = (lenses)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).lengths)
        }, lenses.map((lens)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                key: lens.symbol,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).length),
                onClick: ()=>this.handleLengthChange(lens.symbol)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("b", null, lens.focalLength.slice(0, -1)), "7"), "MM")));
    };
    // Iterate over lenses' inspiration section text and display it if it's currently selected
    mappedLenses = (lenses, currentLens)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, lenses.map((lens)=>{
            if (lens.focalLength === currentLens) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                key: lens.symbol,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).inspiration)
            }, lens.inspiration.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).inspirationHeader)
            }, "INSPIRATION"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("ul", null, lens.inspiration.map((inspirationLine)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", {
                    key: inspirationLine
                }, inspirationLine);
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).testimonial)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).testimonialQuote),
                dangerouslySetInnerHTML: {
                    __html: lens.testimonial.quote
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).author)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).authorName)
            }, lens.testimonial.author.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).authorTitle)
            }, lens.testimonial.author.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).authorCompany)
            }, lens.testimonial.author.company))));
        }));
    };
    render() {
        const { lenses: lenses } = this.state;
        // Find the current lens form lenses array
        const currentFocalLensObject = lenses.find((lens)=>lens.symbol === this.state.currentLens);
        // Trim the "7" off the lens focal length to display current lens at the top of the page
        const currentFocalLensTitle = currentFocalLensObject.focalLength.slice(0, -1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $35950112c9f1df8b$export$2e2bcd8739ae039), {
            src: $79a511817b5c4841$var$backgroundUrl,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).bg,
            readyClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).bgReady
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            style: {
                paddingTop: '62px'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).header
        }, "FOCAL LENGTH RANGE"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).moreInfo
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "*"), "TAP EACH FOR MORE INFO", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "*")), this.displayLenses(lenses)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).popup, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).open]: this.state.open
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).popupInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).x,
            onClick: this.closePopup
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $a236a42500d6f7c3$export$2e2bcd8739ae039), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).length)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("b", null, currentFocalLensTitle), "7"), "MM"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._el = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).diagram)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            src: $79a511817b5c4841$var$diagrams[this.state.currentLens]
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._text = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($8d02d1ad28b3b359$exports))).diagramText)
        }, this.mappedLenses((0, $d183b23a1dd3620d$export$29f9f81de5c56283), this.state.currentLens)))));
    }
}




class $b165a22c0310a835$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {
        window.addEventListener("resize", this.onResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }
    onResize = ()=>{
        this.forceUpdate();
    };
    render() {
        const meta = {
            title: "Lens Range",
            description: "Ten focal lengths: 17mm - 137mm. Inspired by 20th century primes."
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f7489db668f41cb3$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("title", null, meta.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("meta", {
            name: "description",
            content: meta.description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("link", {
            rel: "canonical",
            href: `${window.location.origin}/lensrange`
        })), !(0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $5c0a55ddb3f17563$export$2e2bcd8739ae039), null), (0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $79a511817b5c4841$export$2e2bcd8739ae039), null));
    }
}



var $jiXHd = parcelRequire("jiXHd");


var $d39415832ed187ec$exports = {};

$parcel$export($d39415832ed187ec$exports, "header", function () { return $d39415832ed187ec$export$38e42c68cf43b5d4; }, function (v) { return $d39415832ed187ec$export$38e42c68cf43b5d4 = v; });
$parcel$export($d39415832ed187ec$exports, "page", function () { return $d39415832ed187ec$export$523fb3936f49e028; }, function (v) { return $d39415832ed187ec$export$523fb3936f49e028 = v; });
$parcel$export($d39415832ed187ec$exports, "download", function () { return $d39415832ed187ec$export$24422be91ad4011f; }, function (v) { return $d39415832ed187ec$export$24422be91ad4011f = v; });
$parcel$export($d39415832ed187ec$exports, "downloadArrow", function () { return $d39415832ed187ec$export$3c45fe1a16e08a4e; }, function (v) { return $d39415832ed187ec$export$3c45fe1a16e08a4e = v; });
$parcel$export($d39415832ed187ec$exports, "cls1", function () { return $d39415832ed187ec$export$d2753d4d52dae554; }, function (v) { return $d39415832ed187ec$export$d2753d4d52dae554 = v; });
$parcel$export($d39415832ed187ec$exports, "chart", function () { return $d39415832ed187ec$export$8fde8ebd684d5072; }, function (v) { return $d39415832ed187ec$export$8fde8ebd684d5072 = v; });
$parcel$export($d39415832ed187ec$exports, "chartRow", function () { return $d39415832ed187ec$export$d68a25fbf718d552; }, function (v) { return $d39415832ed187ec$export$d68a25fbf718d552 = v; });
$parcel$export($d39415832ed187ec$exports, "label", function () { return $d39415832ed187ec$export$1237798dc640739a; }, function (v) { return $d39415832ed187ec$export$1237798dc640739a = v; });
$parcel$export($d39415832ed187ec$exports, "chartLabels", function () { return $d39415832ed187ec$export$58bb175d479bfd71; }, function (v) { return $d39415832ed187ec$export$58bb175d479bfd71 = v; });
$parcel$export($d39415832ed187ec$exports, "rows", function () { return $d39415832ed187ec$export$2dd197b55cf13440; }, function (v) { return $d39415832ed187ec$export$2dd197b55cf13440 = v; });
$parcel$export($d39415832ed187ec$exports, "row", function () { return $d39415832ed187ec$export$120ff0929b202a6d; }, function (v) { return $d39415832ed187ec$export$120ff0929b202a6d = v; });
$parcel$export($d39415832ed187ec$exports, "serif", function () { return $d39415832ed187ec$export$25a7f12564a22bf0; }, function (v) { return $d39415832ed187ec$export$25a7f12564a22bf0 = v; });
$parcel$export($d39415832ed187ec$exports, "colLeft", function () { return $d39415832ed187ec$export$24c087b0ab0e5be6; }, function (v) { return $d39415832ed187ec$export$24c087b0ab0e5be6 = v; });
$parcel$export($d39415832ed187ec$exports, "line", function () { return $d39415832ed187ec$export$53f1d5ea8de3d7c; }, function (v) { return $d39415832ed187ec$export$53f1d5ea8de3d7c = v; });
$parcel$export($d39415832ed187ec$exports, "colRight", function () { return $d39415832ed187ec$export$d1a2d2ff27d72f4; }, function (v) { return $d39415832ed187ec$export$d1a2d2ff27d72f4 = v; });
$parcel$export($d39415832ed187ec$exports, "diagram", function () { return $d39415832ed187ec$export$6118d022d940d562; }, function (v) { return $d39415832ed187ec$export$6118d022d940d562 = v; });
$parcel$export($d39415832ed187ec$exports, "hideOnMobile", function () { return $d39415832ed187ec$export$6cd0da7d3aacdeca; }, function (v) { return $d39415832ed187ec$export$6cd0da7d3aacdeca = v; });
$parcel$export($d39415832ed187ec$exports, "hideOnDesktop", function () { return $d39415832ed187ec$export$553e69fd6cb9566c; }, function (v) { return $d39415832ed187ec$export$553e69fd6cb9566c = v; });
var $d39415832ed187ec$export$38e42c68cf43b5d4;
var $d39415832ed187ec$export$523fb3936f49e028;
var $d39415832ed187ec$export$24422be91ad4011f;
var $d39415832ed187ec$export$3c45fe1a16e08a4e;
var $d39415832ed187ec$export$d2753d4d52dae554;
var $d39415832ed187ec$export$8fde8ebd684d5072;
var $d39415832ed187ec$export$d68a25fbf718d552;
var $d39415832ed187ec$export$1237798dc640739a;
var $d39415832ed187ec$export$58bb175d479bfd71;
var $d39415832ed187ec$export$2dd197b55cf13440;
var $d39415832ed187ec$export$120ff0929b202a6d;
var $d39415832ed187ec$export$25a7f12564a22bf0;
var $d39415832ed187ec$export$24c087b0ab0e5be6;
var $d39415832ed187ec$export$53f1d5ea8de3d7c;
var $d39415832ed187ec$export$d1a2d2ff27d72f4;
var $d39415832ed187ec$export$6118d022d940d562;
var $d39415832ed187ec$export$6cd0da7d3aacdeca;
var $d39415832ed187ec$export$553e69fd6cb9566c;
$d39415832ed187ec$export$38e42c68cf43b5d4 = "_app-views-Specs-_styles__header";
$d39415832ed187ec$export$523fb3936f49e028 = "_app-views-Specs-_styles__page";
$d39415832ed187ec$export$24422be91ad4011f = "_app-views-Specs-_styles__download";
$d39415832ed187ec$export$3c45fe1a16e08a4e = "_app-views-Specs-_styles__downloadArrow";
$d39415832ed187ec$export$d2753d4d52dae554 = "_app-views-Specs-_styles__cls1";
$d39415832ed187ec$export$8fde8ebd684d5072 = "_app-views-Specs-_styles__chart";
$d39415832ed187ec$export$d68a25fbf718d552 = "_app-views-Specs-_styles__chartRow";
$d39415832ed187ec$export$1237798dc640739a = "_app-views-Specs-_styles__label";
$d39415832ed187ec$export$58bb175d479bfd71 = "_app-views-Specs-_styles__chartLabels";
$d39415832ed187ec$export$2dd197b55cf13440 = "_app-views-Specs-_styles__rows";
$d39415832ed187ec$export$120ff0929b202a6d = "_app-views-Specs-_styles__row";
$d39415832ed187ec$export$25a7f12564a22bf0 = "_app-views-Specs-_styles__serif";
$d39415832ed187ec$export$24c087b0ab0e5be6 = "_app-views-Specs-_styles__colLeft";
$d39415832ed187ec$export$53f1d5ea8de3d7c = "_app-views-Specs-_styles__line";
$d39415832ed187ec$export$d1a2d2ff27d72f4 = "_app-views-Specs-_styles__colRight";
$d39415832ed187ec$export$6118d022d940d562 = "_app-views-Specs-_styles__diagram";
$d39415832ed187ec$export$6cd0da7d3aacdeca = "_app-views-Specs-_styles__hideOnMobile";
$d39415832ed187ec$export$553e69fd6cb9566c = "_app-views-Specs-_styles__hideOnDesktop";








const $481b93b11560829c$var$backgroundUrl = new URL($f08fcdce49270724$exports);
var $869be4f806bf14fe$exports = {};
$869be4f806bf14fe$exports = $parcel$resolve("e5tFV");


const $481b93b11560829c$var$techSpecDiagram1Url = new URL($869be4f806bf14fe$exports);
var $d72ef0f7864ada42$exports = {};
$d72ef0f7864ada42$exports = $parcel$resolve("5nphD");


const $481b93b11560829c$var$techSpecDiagram2Url = new URL($d72ef0f7864ada42$exports);
const $481b93b11560829c$var$DownloadArrow = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).downloadArrow),
        viewBox: "0 0 36 37.83"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("polyline", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).cls1),
        points: "0.351 16.618 18 34.06 35.648 16.618"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).cls1),
        x1: "0.322",
        y1: "37.33",
        x2: "35.677",
        y2: "37.33"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("line", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).cls1),
        x1: "18",
        x2: "18",
        y2: "34.295"
    })));
class $481b93b11560829c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        specificationData: []
    };
    async componentDidMount() {
        const specs = document.querySelectorAll(`.${(0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow}, .${(0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row}`);
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to([
            this._header,
            this._download
        ], {
            duration: 1.2,
            opacity: 1,
            stagger: '0.2'
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to([
            this._diagram,
            this._diagram2
        ], {
            duration: 1,
            opacity: .7,
            delay: .7
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(specs, {
            duration: .5,
            opacity: 1,
            y: 0,
            stagger: '0.03',
            delay: .35
        });
        await this.fetchSpecificationsData();
    }
    // We need to fetch data on Specifications collection from Directus to get pdf_id
    // This is later used to access and download the file from Directus CMS
    fetchSpecificationsData = async ()=>{
        const res = await fetch(`${(0, $f6b3a4fa27ca8a91$export$8ebae31efd30e025)}/items/specifications`);
        const parsedSpecificationsData = await res.json();
        this.setState({
            specificationData: parsedSpecificationsData.data
        });
    };
    render() {
        const { specificationData: specificationData } = this.state;
        const meta = {
            title: "Specifications",
            description: "Technical specifications for BLACKWING7 lenses."
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f7489db668f41cb3$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("title", null, meta.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("meta", {
            name: "description",
            content: meta.description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("link", {
            rel: "canonical",
            href: `${window.location.origin}/specs`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $35950112c9f1df8b$export$2e2bcd8739ae039), {
            src: $481b93b11560829c$var$backgroundUrl,
            className: 'bg',
            readyClassName: 'bgReady'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).page)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._header = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).header)
        }, 'TECHNICAL SPECS'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._download = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).download)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: `${(0, $f6b3a4fa27ca8a91$export$8ebae31efd30e025)}/assets/${specificationData.pdf_id}?download`,
            download: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement($481b93b11560829c$var$DownloadArrow, null), "DOWNLOAD")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._chart = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chart)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow, (0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartLabels)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "FOCAL LENGTH")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "IMAGE CIRCLE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).hideOnDesktop
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "MAX ILLUMINATION"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "CLOSE FOCUS")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "WEIGHT"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).hideOnMobile
        }, " max illumination"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "in")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "cm"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "lb")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "kg")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "17"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "56"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "8.7"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "22.0")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "3.8"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "1.75"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "20.7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "56"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "9.0"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "23.0")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "3.2"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "1.5"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "23.7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "56"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "10.3"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "26.0")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "3.2"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "1.5"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "27"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "56"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "13.0"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "34.0")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "3.6"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "1.7"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "37"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "67"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "18.0"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "45.7")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "3.4"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "1.6"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "47"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "60"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "17.5"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "44.5")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "3.2"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "1.5"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "57"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "67"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "19.0"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "48.3")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "3.5"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "1.6"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "77"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "67"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "26.0"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "66.0")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "3.0"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "1.4"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "107"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "67"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "27.0"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "68.5")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "3.2"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "1.4"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).chartRow)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "137"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "67"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "32.0"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "81.3")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "3.2"), "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "1.5")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).rows)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
        }, "APERTURE"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
        }, "T1.8 to T22 for 77 & 107", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "T1.9 to T22 for all other focal lengths")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
        }, "IRIS SYSTEM"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
        }, "non-linear, 14 blade")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
        }, "Image Distortion"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
        }, "less than -4% / +0.5%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
        }, "Transmission waveband"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
        }, "420", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "nm"), " to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "680nm"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
        }, "Color and tonality"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
        }, "matched across the range")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
        }, "Magnification Shift"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
        }, "less than 4% (from \u221E to close focus)")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
        }, "Focus and Iris Backlash"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
        }, "negligible")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
        }, "Flange system"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
        }, "PL mount")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
        }, "Focus Scale and Drive", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "17 ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "to"), " 137", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
        }, "windowed", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "left/right in feet (meters on request)", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "270-degree rotation", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "gearing: 142 teeth, 0.8", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm"), " mod, 6", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm"), " width, 115.2", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm"), " dia")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
        }, "Aperture Scale and Drive"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
        }, "non-windowed left/right", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "90-degree rotation", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), "gearing: 134 teeth, 0.8", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm"), " mod, 3", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm"), " width, 108.8", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm"), " dia")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
        }, "Operating Temperature Range"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
        }, "-20 to +45 C"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            ref: (c)=>{
                this._diagram = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).diagram),
            src: $481b93b11560829c$var$techSpecDiagram1Url
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            ref: (c)=>{
                this._diagram2 = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).diagram),
            src: $481b93b11560829c$var$techSpecDiagram2Url
        })));
    }
}



var $jiXHd = parcelRequire("jiXHd");

var $4a94aac5f8d749ad$exports = {};

$parcel$export($4a94aac5f8d749ad$exports, "pageTitle", function () { return $4a94aac5f8d749ad$export$cf9644ba8d6cd7c3; }, function (v) { return $4a94aac5f8d749ad$export$cf9644ba8d6cd7c3 = v; });
$parcel$export($4a94aac5f8d749ad$exports, "page", function () { return $4a94aac5f8d749ad$export$523fb3936f49e028; }, function (v) { return $4a94aac5f8d749ad$export$523fb3936f49e028 = v; });
$parcel$export($4a94aac5f8d749ad$exports, "blue", function () { return $4a94aac5f8d749ad$export$2aa0182783e7e9de; }, function (v) { return $4a94aac5f8d749ad$export$2aa0182783e7e9de = v; });
$parcel$export($4a94aac5f8d749ad$exports, "filterOptions", function () { return $4a94aac5f8d749ad$export$60d56ed3961c839c; }, function (v) { return $4a94aac5f8d749ad$export$60d56ed3961c839c = v; });
$parcel$export($4a94aac5f8d749ad$exports, "posters", function () { return $4a94aac5f8d749ad$export$574a5c7d82985eab; }, function (v) { return $4a94aac5f8d749ad$export$574a5c7d82985eab = v; });
var $4a94aac5f8d749ad$export$cf9644ba8d6cd7c3;
var $4a94aac5f8d749ad$export$523fb3936f49e028;
var $4a94aac5f8d749ad$export$2aa0182783e7e9de;
var $4a94aac5f8d749ad$export$60d56ed3961c839c;
var $4a94aac5f8d749ad$export$574a5c7d82985eab;
$4a94aac5f8d749ad$export$cf9644ba8d6cd7c3 = "_app-views-Credits-_styles__pageTitle";
$4a94aac5f8d749ad$export$523fb3936f49e028 = "_app-views-Credits-_styles__page";
$4a94aac5f8d749ad$export$2aa0182783e7e9de = "_app-views-Credits-_styles__blue";
$4a94aac5f8d749ad$export$60d56ed3961c839c = "_app-views-Credits-_styles__filterOptions";
$4a94aac5f8d749ad$export$574a5c7d82985eab = "_app-views-Credits-_styles__posters";






var $jiXHd = parcelRequire("jiXHd");

var $749f164ce1e4840d$exports = {};

$parcel$export($749f164ce1e4840d$exports, "filter", function () { return $749f164ce1e4840d$export$3dea766d36a8935f; }, function (v) { return $749f164ce1e4840d$export$3dea766d36a8935f = v; });
$parcel$export($749f164ce1e4840d$exports, "filterName", function () { return $749f164ce1e4840d$export$f910a245b39b4e35; }, function (v) { return $749f164ce1e4840d$export$f910a245b39b4e35 = v; });
$parcel$export($749f164ce1e4840d$exports, "options", function () { return $749f164ce1e4840d$export$41c562ebe57d11e2; }, function (v) { return $749f164ce1e4840d$export$41c562ebe57d11e2 = v; });
$parcel$export($749f164ce1e4840d$exports, "selected", function () { return $749f164ce1e4840d$export$d90250155de6d7e7; }, function (v) { return $749f164ce1e4840d$export$d90250155de6d7e7 = v; });
$parcel$export($749f164ce1e4840d$exports, "break", function () { return $749f164ce1e4840d$export$7b2afae041a3efa9; }, function (v) { return $749f164ce1e4840d$export$7b2afae041a3efa9 = v; });
$parcel$export($749f164ce1e4840d$exports, "standardTuning", function () { return $749f164ce1e4840d$export$a254b7723d686155; }, function (v) { return $749f164ce1e4840d$export$a254b7723d686155 = v; });
var $749f164ce1e4840d$export$3dea766d36a8935f;
var $749f164ce1e4840d$export$f910a245b39b4e35;
var $749f164ce1e4840d$export$41c562ebe57d11e2;
var $749f164ce1e4840d$export$d90250155de6d7e7;
var $749f164ce1e4840d$export$7b2afae041a3efa9;
var $749f164ce1e4840d$export$a254b7723d686155;
$749f164ce1e4840d$export$3dea766d36a8935f = "_app-components-Filter-_styles__filter";
$749f164ce1e4840d$export$f910a245b39b4e35 = "_app-components-Filter-_styles__filterName";
$749f164ce1e4840d$export$41c562ebe57d11e2 = "_app-components-Filter-_styles__options";
$749f164ce1e4840d$export$d90250155de6d7e7 = "_app-components-Filter-_styles__selected";
$749f164ce1e4840d$export$7b2afae041a3efa9 = "_app-components-Filter-_styles__break";
$749f164ce1e4840d$export$a254b7723d686155 = "_app-components-Filter-_styles__standardTuning";


// This component shows the filter options for the credits
const $4cdf3ca821cd2be4$var$Filter = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($749f164ce1e4840d$exports))).filter)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($749f164ce1e4840d$exports))).filterName)
    }, props.filterName, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($749f164ce1e4840d$exports))).options)
    }, props.options.map((type)=>{
        const isHighlighted = type === props.selected;
        // Standard tuning types are all one letter
        const isStandardTuning = type.name.length === 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("button", {
            onClick: ()=>props.onSelect(type),
            key: type.id,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))({
                [(0, (/*@__PURE__*/$parcel$interopDefault($749f164ce1e4840d$exports))).selected]: isHighlighted
            }, {
                [(0, (/*@__PURE__*/$parcel$interopDefault($749f164ce1e4840d$exports))).standardTuning]: isStandardTuning
            })
        }, type.name));
    })));
};
var $4cdf3ca821cd2be4$export$2e2bcd8739ae039 = $4cdf3ca821cd2be4$var$Filter;



var $jiXHd = parcelRequire("jiXHd");

var $ca6fd30e23e07b84$exports = {};

$parcel$export($ca6fd30e23e07b84$exports, "posterWithTuning", function () { return $ca6fd30e23e07b84$export$384da05dc35d48e9; }, function (v) { return $ca6fd30e23e07b84$export$384da05dc35d48e9 = v; });
$parcel$export($ca6fd30e23e07b84$exports, "poster", function () { return $ca6fd30e23e07b84$export$b840e55573b2d2e7; }, function (v) { return $ca6fd30e23e07b84$export$b840e55573b2d2e7 = v; });
$parcel$export($ca6fd30e23e07b84$exports, "blurred", function () { return $ca6fd30e23e07b84$export$6eb305f1664666bd; }, function (v) { return $ca6fd30e23e07b84$export$6eb305f1664666bd = v; });
$parcel$export($ca6fd30e23e07b84$exports, "clear", function () { return $ca6fd30e23e07b84$export$42ffd38884aecdac; }, function (v) { return $ca6fd30e23e07b84$export$42ffd38884aecdac = v; });
$parcel$export($ca6fd30e23e07b84$exports, "tuning", function () { return $ca6fd30e23e07b84$export$5805fc0148faebdd; }, function (v) { return $ca6fd30e23e07b84$export$5805fc0148faebdd = v; });
var $ca6fd30e23e07b84$export$384da05dc35d48e9;
var $ca6fd30e23e07b84$export$b840e55573b2d2e7;
var $ca6fd30e23e07b84$export$6eb305f1664666bd;
var $ca6fd30e23e07b84$export$42ffd38884aecdac;
var $ca6fd30e23e07b84$export$5805fc0148faebdd;
$ca6fd30e23e07b84$export$384da05dc35d48e9 = "_app-components-Poster-_styles__posterWithTuning";
$ca6fd30e23e07b84$export$b840e55573b2d2e7 = "_app-components-Poster-_styles__poster";
$ca6fd30e23e07b84$export$6eb305f1664666bd = "_app-components-Poster-_styles__blurred";
$ca6fd30e23e07b84$export$42ffd38884aecdac = "_app-components-Poster-_styles__clear";
$ca6fd30e23e07b84$export$5805fc0148faebdd = "_app-components-Poster-_styles__tuning";




var $jiXHd = parcelRequire("jiXHd");

var $f89d60677493611f$exports = {};

$parcel$export($f89d60677493611f$exports, "overlay", function () { return $f89d60677493611f$export$29dd17c7f3c81c36; }, function (v) { return $f89d60677493611f$export$29dd17c7f3c81c36 = v; });
$parcel$export($f89d60677493611f$exports, "active", function () { return $f89d60677493611f$export$89da14300d534261; }, function (v) { return $f89d60677493611f$export$89da14300d534261 = v; });
$parcel$export($f89d60677493611f$exports, "posterDetail", function () { return $f89d60677493611f$export$16e2329afe8a5be9; }, function (v) { return $f89d60677493611f$export$16e2329afe8a5be9 = v; });
$parcel$export($f89d60677493611f$exports, "open", function () { return $f89d60677493611f$export$3ce6949f20cea765; }, function (v) { return $f89d60677493611f$export$3ce6949f20cea765 = v; });
$parcel$export($f89d60677493611f$exports, "posterDetailTitle", function () { return $f89d60677493611f$export$eb5c6826df0806c3; }, function (v) { return $f89d60677493611f$export$eb5c6826df0806c3 = v; });
$parcel$export($f89d60677493611f$exports, "posterDetailYear", function () { return $f89d60677493611f$export$83ddc912cdecb899; }, function (v) { return $f89d60677493611f$export$83ddc912cdecb899 = v; });
$parcel$export($f89d60677493611f$exports, "posterDetailRow", function () { return $f89d60677493611f$export$37ad6ce51852ce6d; }, function (v) { return $f89d60677493611f$export$37ad6ce51852ce6d = v; });
$parcel$export($f89d60677493611f$exports, "posterDetailHeader", function () { return $f89d60677493611f$export$c10ddb4d614ddb0; }, function (v) { return $f89d60677493611f$export$c10ddb4d614ddb0 = v; });
$parcel$export($f89d60677493611f$exports, "posterDetailContent", function () { return $f89d60677493611f$export$6fc293abe195cda2; }, function (v) { return $f89d60677493611f$export$6fc293abe195cda2 = v; });
$parcel$export($f89d60677493611f$exports, "posterDetailButton", function () { return $f89d60677493611f$export$48df8145f8a5ed8c; }, function (v) { return $f89d60677493611f$export$48df8145f8a5ed8c = v; });
var $f89d60677493611f$export$29dd17c7f3c81c36;
var $f89d60677493611f$export$89da14300d534261;
var $f89d60677493611f$export$16e2329afe8a5be9;
var $f89d60677493611f$export$3ce6949f20cea765;
var $f89d60677493611f$export$eb5c6826df0806c3;
var $f89d60677493611f$export$83ddc912cdecb899;
var $f89d60677493611f$export$37ad6ce51852ce6d;
var $f89d60677493611f$export$c10ddb4d614ddb0;
var $f89d60677493611f$export$6fc293abe195cda2;
var $f89d60677493611f$export$48df8145f8a5ed8c;
$f89d60677493611f$export$29dd17c7f3c81c36 = "_app-components-CreditOverlay-_styles__overlay";
$f89d60677493611f$export$89da14300d534261 = "_app-components-CreditOverlay-_styles__active";
$f89d60677493611f$export$16e2329afe8a5be9 = "_app-components-CreditOverlay-_styles__posterDetail";
$f89d60677493611f$export$3ce6949f20cea765 = "_app-components-CreditOverlay-_styles__open";
$f89d60677493611f$export$eb5c6826df0806c3 = "_app-components-CreditOverlay-_styles__posterDetailTitle";
$f89d60677493611f$export$83ddc912cdecb899 = "_app-components-CreditOverlay-_styles__posterDetailYear";
$f89d60677493611f$export$37ad6ce51852ce6d = "_app-components-CreditOverlay-_styles__posterDetailRow";
$f89d60677493611f$export$c10ddb4d614ddb0 = "_app-components-CreditOverlay-_styles__posterDetailHeader";
$f89d60677493611f$export$6fc293abe195cda2 = "_app-components-CreditOverlay-_styles__posterDetailContent";
$f89d60677493611f$export$48df8145f8a5ed8c = "_app-components-CreditOverlay-_styles__posterDetailButton";


// This component creates a dark overlay over the poster.
// It also displays the credits from data fetched from Directus CMS.
const $0fb6afac3e5e36a0$var$CreditOverlay = (props)=>{
    const releaseDate = new Date(props.release_date);
    const releaseYear = releaseDate.getUTCFullYear();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).overlay, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).active]: props.showCredits
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).posterDetail, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).open]: props.showCredits
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).posterDetailContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).posterDetailTitle)
    }, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).posterDetailYear)
    }, releaseYear)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("hr", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, props.director && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).posterDetailRow)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).posterDetailHeader)
    }, "Director"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, props.director)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).posterDetailRow)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).posterDetailHeader)
    }, "Cinematographer"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, props.cinematographer)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
        target: "blank",
        href: props.trailer_url,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f89d60677493611f$exports))).posterDetailButton)
    }, "Watch")));
};
var $0fb6afac3e5e36a0$export$2e2bcd8739ae039 = $0fb6afac3e5e36a0$var$CreditOverlay;



// This component displays the poster from data fetched from Directus CMS.
// It includes behaviour for rendering the credits.
const $e9a916cc25dfc931$var$Poster = (props)=>{
    // We can modify the image from Directus is query params.
    // format - allows us to specify a format
    // quality - takes a value from 1 to 100
    const baseSrcUrl = `${(0, $f6b3a4fa27ca8a91$export$8ebae31efd30e025)}/assets/${props.image}?format=webp&quality=`;
    const lowQualitySrcUrl = `${baseSrcUrl}1`;
    const highQualitySrcUrl = `${baseSrcUrl}90`;
    const [blur, setBlur] = (0, $jiXHd.useState)(true);
    const [src, setSrc] = (0, $jiXHd.useState)(lowQualitySrcUrl);
    const [showCredits, setShowCredits] = (0, $jiXHd.useState)(false);
    (0, $jiXHd.useEffect)(()=>{
        swapImgToHighRes();
    }, []);
    // Load the high resolution data in the background
    // And swap from low resolution when loaded
    const swapImgToHighRes = ()=>{
        const img = new Image();
        img.src = highQualitySrcUrl;
        img.onload = ()=>{
            setSrc(highQualitySrcUrl);
            setBlur(false);
        };
    };
    const handleToggleCredits = ()=>{
        setShowCredits(!showCredits);
    };
    const tuning_copy = ()=>{
        const tuningName = props.tuning.name;
        if (tuningName === "Custom") return `Custom ${props.custom_tuning_type}`;
        else if (tuningName === "Binaries") return `Binary ${props.custom_tuning_type}`;
        return tuningName;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ca6fd30e23e07b84$exports))).posterWithTuning)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ca6fd30e23e07b84$exports))).tuning)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, tuning_copy()), "-Tuned")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ca6fd30e23e07b84$exports))).poster),
        key: props.id,
        onClick: (0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() ? handleToggleCredits : undefined,
        // Blocked mouse enter/leave behaviour on mobile
        // To prevent odd behaviour of credits overlay
        onMouseEnter: (0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() ? undefined : handleToggleCredits,
        onMouseLeave: (0, $e5aa747dbfb4ff26$export$d0a8044dce8ff2fc)() ? undefined : handleToggleCredits
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
        src: src,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($ca6fd30e23e07b84$exports))).poster, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($ca6fd30e23e07b84$exports))).blurred]: blur
        }, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($ca6fd30e23e07b84$exports))).clear]: !blur
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $0fb6afac3e5e36a0$export$2e2bcd8739ae039), {
        ...props,
        showCredits: showCredits
    })));
};
var $e9a916cc25dfc931$export$2e2bcd8739ae039 = $e9a916cc25dfc931$var$Poster;



var $jiXHd = parcelRequire("jiXHd");
var $73db87620e526bb1$exports = {};
'use strict';

$73db87620e526bb1$exports = (parcelRequire("9T9vB"));



var $jiXHd = parcelRequire("jiXHd");
// Shared state between server components and client components
const $45e5cdb0ee77bb20$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $45e5cdb0ee77bb20$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $45e5cdb0ee77bb20$export$8793edee2d425525();
const $45e5cdb0ee77bb20$export$8b8a958a7f6f130c = Object;
const $45e5cdb0ee77bb20$export$fce6876652108ab = (v)=>v === $45e5cdb0ee77bb20$export$6db089fe7b26f5b6;
const $45e5cdb0ee77bb20$export$f6e2535fb5126e54 = (v)=>typeof v == 'function';
const $45e5cdb0ee77bb20$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $45e5cdb0ee77bb20$export$ae936b9d47e5870e = (x)=>$45e5cdb0ee77bb20$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $45e5cdb0ee77bb20$var$table = new WeakMap();
// counter of the key
let $45e5cdb0ee77bb20$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $45e5cdb0ee77bb20$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($45e5cdb0ee77bb20$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $45e5cdb0ee77bb20$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$45e5cdb0ee77bb20$var$counter + '~';
        $45e5cdb0ee77bb20$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $45e5cdb0ee77bb20$export$e9a4e06c7dfb0bd4(arg[index]) + ',';
            $45e5cdb0ee77bb20$var$table.set(arg, result);
        }
        if (constructor == $45e5cdb0ee77bb20$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = '#';
            const keys = $45e5cdb0ee77bb20$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$45e5cdb0ee77bb20$export$fce6876652108ab(index = keys.pop()))if (!$45e5cdb0ee77bb20$export$fce6876652108ab(arg[index])) result += index + ':' + $45e5cdb0ee77bb20$export$e9a4e06c7dfb0bd4(arg[index]) + ',';
            $45e5cdb0ee77bb20$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $45e5cdb0ee77bb20$export$b94ca9901c60634 = new WeakMap();
const $45e5cdb0ee77bb20$var$EMPTY_CACHE = {};
const $45e5cdb0ee77bb20$var$INITIAL_CACHE = {};
const $45e5cdb0ee77bb20$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $45e5cdb0ee77bb20$export$6e85fd745dc51282 = typeof window != $45e5cdb0ee77bb20$var$STR_UNDEFINED;
const $45e5cdb0ee77bb20$export$842dfe7a9f24298 = typeof document != $45e5cdb0ee77bb20$var$STR_UNDEFINED;
const $45e5cdb0ee77bb20$export$a9116928c9d15917 = ()=>$45e5cdb0ee77bb20$export$6e85fd745dc51282 && typeof window['requestAnimationFrame'] != $45e5cdb0ee77bb20$var$STR_UNDEFINED;
const $45e5cdb0ee77bb20$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $45e5cdb0ee77bb20$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$45e5cdb0ee77bb20$export$fce6876652108ab(key) && cache.get(key) || $45e5cdb0ee77bb20$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$45e5cdb0ee77bb20$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $45e5cdb0ee77bb20$var$INITIAL_CACHE)) $45e5cdb0ee77bb20$var$INITIAL_CACHE[key] = prev;
                state[5](key, $45e5cdb0ee77bb20$export$2321aea138b44780(prev, info), prev || $45e5cdb0ee77bb20$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$45e5cdb0ee77bb20$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $45e5cdb0ee77bb20$var$INITIAL_CACHE) return $45e5cdb0ee77bb20$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$45e5cdb0ee77bb20$export$fce6876652108ab(key) && cache.get(key) || $45e5cdb0ee77bb20$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $45e5cdb0ee77bb20$var$online = true;
const $45e5cdb0ee77bb20$var$isOnline = ()=>$45e5cdb0ee77bb20$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$45e5cdb0ee77bb20$var$onWindowEvent, $45e5cdb0ee77bb20$var$offWindowEvent] = $45e5cdb0ee77bb20$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $45e5cdb0ee77bb20$export$8793edee2d425525,
    $45e5cdb0ee77bb20$export$8793edee2d425525
];
const $45e5cdb0ee77bb20$var$isVisible = ()=>{
    const visibilityState = $45e5cdb0ee77bb20$export$842dfe7a9f24298 && document.visibilityState;
    return $45e5cdb0ee77bb20$export$fce6876652108ab(visibilityState) || visibilityState !== 'hidden';
};
const $45e5cdb0ee77bb20$var$initFocus = (callback)=>{
    // focus revalidate
    if ($45e5cdb0ee77bb20$export$842dfe7a9f24298) document.addEventListener('visibilitychange', callback);
    $45e5cdb0ee77bb20$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($45e5cdb0ee77bb20$export$842dfe7a9f24298) document.removeEventListener('visibilitychange', callback);
        $45e5cdb0ee77bb20$var$offWindowEvent('focus', callback);
    };
};
const $45e5cdb0ee77bb20$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $45e5cdb0ee77bb20$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $45e5cdb0ee77bb20$var$online = false;
    };
    $45e5cdb0ee77bb20$var$onWindowEvent('online', onOnline);
    $45e5cdb0ee77bb20$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $45e5cdb0ee77bb20$var$offWindowEvent('online', onOnline);
        $45e5cdb0ee77bb20$var$offWindowEvent('offline', onOffline);
    };
};
const $45e5cdb0ee77bb20$export$f5ab8217e0edff04 = {
    isOnline: $45e5cdb0ee77bb20$var$isOnline,
    isVisible: $45e5cdb0ee77bb20$var$isVisible
};
const $45e5cdb0ee77bb20$export$b1857f3440a65373 = {
    initFocus: $45e5cdb0ee77bb20$var$initFocus,
    initReconnect: $45e5cdb0ee77bb20$var$initReconnect
};
const $45e5cdb0ee77bb20$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).useId;
const $45e5cdb0ee77bb20$export$d2f4d8e74279c212 = !$45e5cdb0ee77bb20$export$6e85fd745dc51282 || 'Deno' in window;
// Polyfill requestAnimationFrame
const $45e5cdb0ee77bb20$export$eba6076d3d7d0c06 = (f)=>$45e5cdb0ee77bb20$export$a9116928c9d15917() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $45e5cdb0ee77bb20$export$700979bc83e7db82 = $45e5cdb0ee77bb20$export$d2f4d8e74279c212 ? (0, $jiXHd.useEffect) : (0, $jiXHd.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $45e5cdb0ee77bb20$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $45e5cdb0ee77bb20$export$3723beb60427dc52 = !$45e5cdb0ee77bb20$export$d2f4d8e74279c212 && $45e5cdb0ee77bb20$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($45e5cdb0ee77bb20$var$navigatorConnection.effectiveType) || $45e5cdb0ee77bb20$var$navigatorConnection.saveData);
const $45e5cdb0ee77bb20$export$dfdc1655ccc5b9cb = (key)=>{
    if ($45e5cdb0ee77bb20$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $45e5cdb0ee77bb20$export$e9a4e06c7dfb0bd4(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $45e5cdb0ee77bb20$var$__timestamp = 0;
const $45e5cdb0ee77bb20$export$3c95c4c8b671ef0 = ()=>++$45e5cdb0ee77bb20$var$__timestamp;
const $45e5cdb0ee77bb20$var$FOCUS_EVENT = 0;
const $45e5cdb0ee77bb20$var$RECONNECT_EVENT = 1;
const $45e5cdb0ee77bb20$var$MUTATE_EVENT = 2;
const $45e5cdb0ee77bb20$var$ERROR_REVALIDATE_EVENT = 3;
var $45e5cdb0ee77bb20$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $45e5cdb0ee77bb20$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $45e5cdb0ee77bb20$var$FOCUS_EVENT,
    MUTATE_EVENT: $45e5cdb0ee77bb20$var$MUTATE_EVENT,
    RECONNECT_EVENT: $45e5cdb0ee77bb20$var$RECONNECT_EVENT
};
async function $45e5cdb0ee77bb20$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $45e5cdb0ee77bb20$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const revalidate = options.revalidate !== false;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($45e5cdb0ee77bb20$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $45e5cdb0ee77bb20$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $45e5cdb0ee77bb20$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $45e5cdb0ee77bb20$export$b94ca9901c60634.get(cache);
        const revalidators = EVENT_REVALIDATORS[key];
        const startRevalidate = ()=>{
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($45e5cdb0ee77bb20$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $45e5cdb0ee77bb20$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$45e5cdb0ee77bb20$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $45e5cdb0ee77bb20$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $45e5cdb0ee77bb20$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($45e5cdb0ee77bb20$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $45e5cdb0ee77bb20$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                data = committedData;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: data,
                    _c: $45e5cdb0ee77bb20$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($45e5cdb0ee77bb20$export$f6e2535fb5126e54(populateCache)) data = populateCache(data, committedData);
                // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $45e5cdb0ee77bb20$export$6db089fe7b26f5b6,
                    _c: $45e5cdb0ee77bb20$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $45e5cdb0ee77bb20$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        const res = await startRevalidate();
        // The mutation and revalidation are ended, we can clear it since the data is
        // not an optimistic value anymore.
        set({
            _c: $45e5cdb0ee77bb20$export$6db089fe7b26f5b6
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return populateCache ? res : data;
    }
}
const $45e5cdb0ee77bb20$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $45e5cdb0ee77bb20$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$45e5cdb0ee77bb20$export$b94ca9901c60634.has(provider)) {
        const opts = $45e5cdb0ee77bb20$export$2321aea138b44780($45e5cdb0ee77bb20$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $45e5cdb0ee77bb20$export$c9d44e5bea4509be.bind($45e5cdb0ee77bb20$export$6db089fe7b26f5b6, provider);
        let unmount = $45e5cdb0ee77bb20$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$45e5cdb0ee77bb20$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $45e5cdb0ee77bb20$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$45e5cdb0ee77bb20$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($45e5cdb0ee77bb20$export$6db089fe7b26f5b6, $45e5cdb0ee77bb20$var$revalidateAllKeys.bind($45e5cdb0ee77bb20$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $45e5cdb0ee77bb20$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($45e5cdb0ee77bb20$export$6db089fe7b26f5b6, $45e5cdb0ee77bb20$var$revalidateAllKeys.bind($45e5cdb0ee77bb20$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $45e5cdb0ee77bb20$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $45e5cdb0ee77bb20$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $45e5cdb0ee77bb20$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $45e5cdb0ee77bb20$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$45e5cdb0ee77bb20$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $45e5cdb0ee77bb20$export$398604a469f7de9a = (currentData, newData)=>$45e5cdb0ee77bb20$export$e9a4e06c7dfb0bd4(currentData) == $45e5cdb0ee77bb20$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$45e5cdb0ee77bb20$export$69a3209f1a06c04d, $45e5cdb0ee77bb20$export$57e795267c26e600] = $45e5cdb0ee77bb20$export$4008f5b66f9e0b3c(new Map());
// Default config
const $45e5cdb0ee77bb20$export$f84bd70098573c5c = $45e5cdb0ee77bb20$export$2321aea138b44780({
    // events
    onLoadingSlow: $45e5cdb0ee77bb20$export$8793edee2d425525,
    onSuccess: $45e5cdb0ee77bb20$export$8793edee2d425525,
    onError: $45e5cdb0ee77bb20$export$8793edee2d425525,
    onErrorRetry: $45e5cdb0ee77bb20$var$onErrorRetry,
    onDiscarded: $45e5cdb0ee77bb20$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $45e5cdb0ee77bb20$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $45e5cdb0ee77bb20$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $45e5cdb0ee77bb20$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $45e5cdb0ee77bb20$export$69a3209f1a06c04d,
    mutate: $45e5cdb0ee77bb20$export$57e795267c26e600,
    fallback: {}
}, $45e5cdb0ee77bb20$export$f5ab8217e0edff04);
const $45e5cdb0ee77bb20$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $45e5cdb0ee77bb20$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $45e5cdb0ee77bb20$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $45e5cdb0ee77bb20$var$SWRConfigContext = (0, $jiXHd.createContext)({});
const $45e5cdb0ee77bb20$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $jiXHd.useContext)($45e5cdb0ee77bb20$var$SWRConfigContext);
    const isFunctionalConfig = $45e5cdb0ee77bb20$export$f6e2535fb5126e54(value);
    const config = (0, $jiXHd.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $jiXHd.useMemo)(()=>isFunctionalConfig ? config : $45e5cdb0ee77bb20$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $jiXHd.useRef)($45e5cdb0ee77bb20$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $45e5cdb0ee77bb20$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $45e5cdb0ee77bb20$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $45e5cdb0ee77bb20$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $jiXHd.createElement)($45e5cdb0ee77bb20$var$SWRConfigContext.Provider, $45e5cdb0ee77bb20$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
// @ts-expect-error
const $45e5cdb0ee77bb20$var$enableDevtools = $45e5cdb0ee77bb20$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $45e5cdb0ee77bb20$var$use = $45e5cdb0ee77bb20$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $45e5cdb0ee77bb20$var$setupDevTools = ()=>{
    if ($45e5cdb0ee77bb20$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd)));
};
const $45e5cdb0ee77bb20$export$a3295358bff77e = (args)=>{
    return $45e5cdb0ee77bb20$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $45e5cdb0ee77bb20$export$f1dc0e282d4c1c0 = ()=>{
    return $45e5cdb0ee77bb20$export$2321aea138b44780($45e5cdb0ee77bb20$export$f84bd70098573c5c, (0, $jiXHd.useContext)($45e5cdb0ee77bb20$var$SWRConfigContext));
};
const $45e5cdb0ee77bb20$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $45e5cdb0ee77bb20$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $45e5cdb0ee77bb20$export$b94ca9901c60634.get($45e5cdb0ee77bb20$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $45e5cdb0ee77bb20$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $45e5cdb0ee77bb20$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $45e5cdb0ee77bb20$export$b94ca9901c60634.get($45e5cdb0ee77bb20$export$69a3209f1a06c04d);
            const req = PRELOAD[key];
            if ($45e5cdb0ee77bb20$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $45e5cdb0ee77bb20$var$BUILT_IN_MIDDLEWARE = $45e5cdb0ee77bb20$var$use.concat($45e5cdb0ee77bb20$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $45e5cdb0ee77bb20$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $45e5cdb0ee77bb20$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $45e5cdb0ee77bb20$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $45e5cdb0ee77bb20$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($45e5cdb0ee77bb20$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
/**
 * An implementation of state with dependency-tracking.
 */ const $45e5cdb0ee77bb20$export$e1784150b9e765ac = (state)=>{
    const rerender = (0, $jiXHd.useState)({})[1];
    const unmountedRef = (0, $jiXHd.useRef)(false);
    const stateRef = (0, $jiXHd.useRef)(state);
    // If a state property (data, error, or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    const stateDependenciesRef = (0, $jiXHd.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
   * @param payload To change stateRef, pass the values explicitly to setState:
   * @example
   * ```js
   * setState({
   *   isValidating: false
   *   data: newData // set data to newData
   *   error: undefined // set error to undefined
   * })
   *
   * setState({
   *   isValidating: false
   *   data: undefined // set data to undefined
   *   error: err // set error to err
   * })
   * ```
   */ const setState = (0, $jiXHd.useCallback)((payload)=>{
        let shouldRerender = false;
        const currentState = stateRef.current;
        for(const _ in payload){
            const k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) shouldRerender = true;
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            if ($45e5cdb0ee77bb20$export$ddb64fe6466374f7) rerender({});
            else (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).startTransition(()=>rerender({}));
        }
    }, [
        rerender
    ]);
    $45e5cdb0ee77bb20$export$700979bc83e7db82(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
        };
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $45e5cdb0ee77bb20$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $45e5cdb0ee77bb20$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $45e5cdb0ee77bb20$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$45e5cdb0ee77bb20$var$setupDevTools();


const $9e15602fdd51849b$export$dbab534a48e651ef = (key)=>(0, $45e5cdb0ee77bb20$export$dfdc1655ccc5b9cb)(key)[0];
/// <reference types="react/experimental" />
const $9e15602fdd51849b$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).use || ((promise)=>{
    if (promise.status === 'pending') throw promise;
    else if (promise.status === 'fulfilled') return promise.value;
    else if (promise.status === 'rejected') throw promise.reason;
    else {
        promise.status = 'pending';
        promise.then((v)=>{
            promise.status = 'fulfilled';
            promise.value = v;
        }, (e)=>{
            promise.status = 'rejected';
            promise.reason = e;
        });
        throw promise;
    }
});
const $9e15602fdd51849b$var$WITH_DEDUPE = {
    dedupe: true
};
const $9e15602fdd51849b$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $45e5cdb0ee77bb20$export$b94ca9901c60634).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $45e5cdb0ee77bb20$export$dfdc1655ccc5b9cb)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $jiXHd.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $jiXHd.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $jiXHd.useRef)(key);
    const fetcherRef = (0, $jiXHd.useRef)(fetcher);
    const configRef = (0, $jiXHd.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $45e5cdb0ee77bb20$export$1251d51d9c571b45)(cache, key);
    const stateDependencies = (0, $jiXHd.useRef)({}).current;
    const fallback = (0, $45e5cdb0ee77bb20$export$fce6876652108ab)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $45e5cdb0ee77bb20$export$fce6876652108ab)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $jiXHd.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $45e5cdb0ee77bb20$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $45e5cdb0ee77bb20$export$fce6876652108ab)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $45e5cdb0ee77bb20$export$2321aea138b44780)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $73db87620e526bb1$exports.useSyncExternalStore)((0, $jiXHd.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $45e5cdb0ee77bb20$export$fce6876652108ab)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $jiXHd.useRef)(data);
    const returnedData = keepPreviousData ? (0, $45e5cdb0ee77bb20$export$fce6876652108ab)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $45e5cdb0ee77bb20$export$fce6876652108ab)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $45e5cdb0ee77bb20$export$fce6876652108ab)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $45e5cdb0ee77bb20$export$fce6876652108ab)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $45e5cdb0ee77bb20$export$fce6876652108ab)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $45e5cdb0ee77bb20$export$fce6876652108ab)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $45e5cdb0ee77bb20$export$fce6876652108ab)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $jiXHd.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $45e5cdb0ee77bb20$export$ddb64fe6466374f7) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $45e5cdb0ee77bb20$export$fce6876652108ab)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $45e5cdb0ee77bb20$export$fce6876652108ab)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $45e5cdb0ee77bb20$export$3c95c4c8b671ef0)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $45e5cdb0ee77bb20$export$6db089fe7b26f5b6);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $45e5cdb0ee77bb20$export$fce6876652108ab)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $45e5cdb0ee77bb20$export$f6e2535fb5126e54)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $45e5cdb0ee77bb20$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const boundMutate = (0, $jiXHd.useCallback)((...args)=>{
        return (0, $45e5cdb0ee77bb20$export$c9d44e5bea4509be)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $45e5cdb0ee77bb20$export$700979bc83e7db82)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $45e5cdb0ee77bb20$export$fce6876652108ab)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $45e5cdb0ee77bb20$export$700979bc83e7db82)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $45e5cdb0ee77bb20$export$6db089fe7b26f5b6), $9e15602fdd51849b$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $45e5cdb0ee77bb20$export$10213d6aa5ce32e6).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $45e5cdb0ee77bb20$export$10213d6aa5ce32e6).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $45e5cdb0ee77bb20$export$10213d6aa5ce32e6).MUTATE_EVENT) return revalidate();
            else if (type == (0, $45e5cdb0ee77bb20$export$10213d6aa5ce32e6).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $45e5cdb0ee77bb20$export$e005210ed621746)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $45e5cdb0ee77bb20$export$fce6876652108ab)(data) || (0, $45e5cdb0ee77bb20$export$d2f4d8e74279c212)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $45e5cdb0ee77bb20$export$eba6076d3d7d0c06)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $45e5cdb0ee77bb20$export$700979bc83e7db82)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $45e5cdb0ee77bb20$export$f6e2535fb5126e54)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($9e15602fdd51849b$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $jiXHd.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $45e5cdb0ee77bb20$export$fce6876652108ab)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $45e5cdb0ee77bb20$export$ddb64fe6466374f7) && (0, $45e5cdb0ee77bb20$export$d2f4d8e74279c212)) throw new Error('Fallback data is required when using suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $45e5cdb0ee77bb20$export$fce6876652108ab)(req)) {
            const promise = boundMutate(req);
            $9e15602fdd51849b$var$use(promise);
        }
        if ((0, $45e5cdb0ee77bb20$export$fce6876652108ab)(error)) {
            const promise = revalidate($9e15602fdd51849b$var$WITH_DEDUPE);
            if (!(0, $45e5cdb0ee77bb20$export$fce6876652108ab)(returnedData)) {
                promise.status = 'fulfilled';
                promise.value = true;
            }
            $9e15602fdd51849b$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $9e15602fdd51849b$export$4c7bbecdacc3ca2c = (0, $45e5cdb0ee77bb20$export$8b8a958a7f6f130c).defineProperty((0, $45e5cdb0ee77bb20$export$4c7bbecdacc3ca2c), 'defaultValue', {
    value: (0, $45e5cdb0ee77bb20$export$f84bd70098573c5c)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (!data) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $9e15602fdd51849b$export$2e2bcd8739ae039 = (0, $45e5cdb0ee77bb20$export$84d44e54e14b0133)($9e15602fdd51849b$var$useSWRHandler);


const $2715ed0e804b1705$export$47fdd40111eda34c = (...args)=>fetch(...args).then((res)=>res.json());



const $f43c6a2edf35cc7b$export$794eb6d8e9a18529 = ()=>{
    const { data: data, error: error, isLoading: isLoading } = (0, $9e15602fdd51849b$export$2e2bcd8739ae039)(`${(0, $f6b3a4fa27ca8a91$export$8ebae31efd30e025)}/items/credits?sort=-release_date&limit=300`, (0, $2715ed0e804b1705$export$47fdd40111eda34c));
    return {
        credits: data?.data,
        creditsError: error,
        isLoadingCredits: isLoading
    };
};





const $1722b418e5f0ff9d$export$fb7bb829892eb14f = ()=>{
    const { data: data, error: error, isLoading: isLoading } = (0, $9e15602fdd51849b$export$2e2bcd8739ae039)(`${(0, $f6b3a4fa27ca8a91$export$8ebae31efd30e025)}/items/project_types`, (0, $2715ed0e804b1705$export$47fdd40111eda34c));
    return {
        projectTypes: data?.data,
        projectTypesError: error,
        isLoadingProjectTypes: isLoading
    };
};





const $ed7c29e17c3ce2f6$export$5db67bf2b95e4219 = ()=>{
    const { data: data, error: error, isLoading: isLoading } = (0, $9e15602fdd51849b$export$2e2bcd8739ae039)(`${(0, $f6b3a4fa27ca8a91$export$8ebae31efd30e025)}/items/tuning_types`, (0, $2715ed0e804b1705$export$47fdd40111eda34c));
    return {
        tuningTypes: data?.data,
        tuningTypesError: error,
        isLoadingTuningTypes: isLoading
    };
};




const $4db6c283b58230db$var$backgroundUrl = new URL($f08fcdce49270724$exports);
function $4db6c283b58230db$export$2e2bcd8739ae039() {
    const { credits: credits, creditsError: creditsError, isLoadingCredits: isLoadingCredits } = (0, $f43c6a2edf35cc7b$export$794eb6d8e9a18529)();
    const { projectTypes: projectTypes, projectTypesError: projectTypesError, isLoadingProjectTypes: isLoadingProjectTypes } = (0, $1722b418e5f0ff9d$export$fb7bb829892eb14f)();
    const { tuningTypes: tuningTypes, tuningTypesError: tuningTypesError, isLoadingTuningTypes: isLoadingTuningTypes } = (0, $ed7c29e17c3ce2f6$export$5db67bf2b95e4219)();
    const [selectedProjectType, setSelectedProjectType] = (0, $jiXHd.useState)({});
    const [selectedTuning, setSelectedTuning] = (0, $jiXHd.useState)({});
    const meta = {
        title: "Credits",
        description: "Discover the creative possibilities of using BLACKWING7 lenses."
    };
    // We want to set the default credit type to 'Film' when we first get onto the credits page
    (0, $jiXHd.useEffect)(()=>{
        if (projectTypes) {
            const featureType = projectTypes.find((type)=>type.id === 1);
            setSelectedProjectType(featureType);
        }
    }, [
        projectTypes
    ]);
    // We want to set the default tuning type to 'All' when we first get onto the credits page
    (0, $jiXHd.useEffect)(()=>{
        if (tuningTypes) {
            const tuningType = tuningTypes.find((type)=>type.name === "All");
            setSelectedTuning(tuningType);
        }
    }, [
        tuningTypes
    ]);
    // We filter credits based on their tuning type and their project type
    const filteredResults = ()=>{
        return credits.filter((credit)=>{
            // If the project type doesn't match return false
            if (credit.project_type_id !== selectedProjectType.id) return false;
            // If the tuning type is All, return true
            if (selectedTuning.name === "All") return true;
            // Otherwise return true if the tuning type matches the selected tuning type
            return credit.tuning_type_id === selectedTuning.id;
        });
    };
    const renderContent = ()=>{
        // TODO: We need to handle the loading and error state.
        // But we do not have any designs yet.
        // Let's see what things look like once we have the posters rendering.
        if (creditsError || projectTypesError || tuningTypesError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "Please refresh the page");
        if (isLoadingCredits || isLoadingProjectTypes || isLoadingTuningTypes) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, "Loading...");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4a94aac5f8d749ad$exports))).filterOptions)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $4cdf3ca821cd2be4$export$2e2bcd8739ae039), {
            onSelect: setSelectedProjectType,
            filterName: "Type",
            options: projectTypes,
            selected: selectedProjectType
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $4cdf3ca821cd2be4$export$2e2bcd8739ae039), {
            onSelect: setSelectedTuning,
            filterName: "Tuning",
            options: tuningTypes,
            selected: selectedTuning
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4a94aac5f8d749ad$exports))).posters)
        }, filteredResults().map((credit)=>{
            const tuning = tuningTypes.find((type)=>type.id === credit.tuning_type_id);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e9a916cc25dfc931$export$2e2bcd8739ae039), {
                key: credit.id,
                ...credit,
                tuning: tuning
            });
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f7489db668f41cb3$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("title", null, meta.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("meta", {
        name: "description",
        content: meta.description
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("link", {
        rel: "canonical",
        href: `${window.location.origin}/credits`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $35950112c9f1df8b$export$2e2bcd8739ae039), {
        src: $4db6c283b58230db$var$backgroundUrl,
        className: "bg",
        readyClassName: "bgReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4a94aac5f8d749ad$exports))).page)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4a94aac5f8d749ad$exports))).pageTitle)
    }, "Production Credits"), renderContent()));
}



var $jiXHd = parcelRequire("jiXHd");


var $41351eb782856059$exports = {};

$parcel$export($41351eb782856059$exports, "page", function () { return $41351eb782856059$export$523fb3936f49e028; }, function (v) { return $41351eb782856059$export$523fb3936f49e028 = v; });
$parcel$export($41351eb782856059$exports, "body", function () { return $41351eb782856059$export$32180ef41b15b513; }, function (v) { return $41351eb782856059$export$32180ef41b15b513 = v; });
$parcel$export($41351eb782856059$exports, "contactFormHeader", function () { return $41351eb782856059$export$16ced959452cf29d; }, function (v) { return $41351eb782856059$export$16ced959452cf29d = v; });
$parcel$export($41351eb782856059$exports, "credits", function () { return $41351eb782856059$export$68c7321cb43cac49; }, function (v) { return $41351eb782856059$export$68c7321cb43cac49 = v; });
$parcel$export($41351eb782856059$exports, "creditsItems", function () { return $41351eb782856059$export$f56ec4f71d6bca43; }, function (v) { return $41351eb782856059$export$f56ec4f71d6bca43 = v; });
$parcel$export($41351eb782856059$exports, "submitMessage", function () { return $41351eb782856059$export$8fd5706e716dbba; }, function (v) { return $41351eb782856059$export$8fd5706e716dbba = v; });
$parcel$export($41351eb782856059$exports, "socialMediaLinks", function () { return $41351eb782856059$export$2fb746beae324a4b; }, function (v) { return $41351eb782856059$export$2fb746beae324a4b = v; });
$parcel$export($41351eb782856059$exports, "recaptchaLinks", function () { return $41351eb782856059$export$ea9f74c87cc3ddaf; }, function (v) { return $41351eb782856059$export$ea9f74c87cc3ddaf = v; });
var $41351eb782856059$export$523fb3936f49e028;
var $41351eb782856059$export$32180ef41b15b513;
var $41351eb782856059$export$16ced959452cf29d;
var $41351eb782856059$export$68c7321cb43cac49;
var $41351eb782856059$export$f56ec4f71d6bca43;
var $41351eb782856059$export$8fd5706e716dbba;
var $41351eb782856059$export$2fb746beae324a4b;
var $41351eb782856059$export$ea9f74c87cc3ddaf;
$41351eb782856059$export$523fb3936f49e028 = "_app-views-Inquire-_styles__page";
$41351eb782856059$export$32180ef41b15b513 = "_app-views-Inquire-_styles__body";
$41351eb782856059$export$16ced959452cf29d = "_app-views-Inquire-_styles__contactFormHeader";
$41351eb782856059$export$68c7321cb43cac49 = "_app-views-Inquire-_styles__credits";
$41351eb782856059$export$f56ec4f71d6bca43 = "_app-views-Inquire-_styles__creditsItems";
$41351eb782856059$export$8fd5706e716dbba = "_app-views-Inquire-_styles__submitMessage";
$41351eb782856059$export$2fb746beae324a4b = "_app-views-Inquire-_styles__socialMediaLinks";
$41351eb782856059$export$ea9f74c87cc3ddaf = "_app-views-Inquire-_styles__recaptchaLinks";



var $jiXHd = parcelRequire("jiXHd");


var $jiXHd = parcelRequire("jiXHd");

var $907aa1317a74c843$exports = {};

$parcel$export($907aa1317a74c843$exports, "form", function () { return $907aa1317a74c843$export$6210fa4921d2a466; }, function (v) { return $907aa1317a74c843$export$6210fa4921d2a466 = v; });
$parcel$export($907aa1317a74c843$exports, "formField", function () { return $907aa1317a74c843$export$2a668e8d088a0667; }, function (v) { return $907aa1317a74c843$export$2a668e8d088a0667 = v; });
$parcel$export($907aa1317a74c843$exports, "error", function () { return $907aa1317a74c843$export$a3bc9b8ed74fc; }, function (v) { return $907aa1317a74c843$export$a3bc9b8ed74fc = v; });
$parcel$export($907aa1317a74c843$exports, "errorText", function () { return $907aa1317a74c843$export$f1a76e4a6085c675; }, function (v) { return $907aa1317a74c843$export$f1a76e4a6085c675 = v; });
$parcel$export($907aa1317a74c843$exports, "formButton", function () { return $907aa1317a74c843$export$58a3e2e25d011ae1; }, function (v) { return $907aa1317a74c843$export$58a3e2e25d011ae1 = v; });
$parcel$export($907aa1317a74c843$exports, "disabled", function () { return $907aa1317a74c843$export$683472f6198a076e; }, function (v) { return $907aa1317a74c843$export$683472f6198a076e = v; });
$parcel$export($907aa1317a74c843$exports, "baseErrorText", function () { return $907aa1317a74c843$export$c2fa28b81fad2e23; }, function (v) { return $907aa1317a74c843$export$c2fa28b81fad2e23 = v; });
$parcel$export($907aa1317a74c843$exports, "line", function () { return $907aa1317a74c843$export$53f1d5ea8de3d7c; }, function (v) { return $907aa1317a74c843$export$53f1d5ea8de3d7c = v; });
$parcel$export($907aa1317a74c843$exports, "lineShow", function () { return $907aa1317a74c843$export$9519373988617a1f; }, function (v) { return $907aa1317a74c843$export$9519373988617a1f = v; });
var $907aa1317a74c843$export$6210fa4921d2a466;
var $907aa1317a74c843$export$2a668e8d088a0667;
var $907aa1317a74c843$export$a3bc9b8ed74fc;
var $907aa1317a74c843$export$f1a76e4a6085c675;
var $907aa1317a74c843$export$58a3e2e25d011ae1;
var $907aa1317a74c843$export$683472f6198a076e;
var $907aa1317a74c843$export$c2fa28b81fad2e23;
var $907aa1317a74c843$export$53f1d5ea8de3d7c;
var $907aa1317a74c843$export$9519373988617a1f;
$907aa1317a74c843$export$6210fa4921d2a466 = "_app-components-Form-_styles__form";
$907aa1317a74c843$export$2a668e8d088a0667 = "_app-components-Form-_styles__formField";
$907aa1317a74c843$export$a3bc9b8ed74fc = "_app-components-Form-_styles__error";
$907aa1317a74c843$export$f1a76e4a6085c675 = "_app-components-Form-_styles__errorText";
$907aa1317a74c843$export$58a3e2e25d011ae1 = "_app-components-Form-_styles__formButton";
$907aa1317a74c843$export$683472f6198a076e = "_app-components-Form-_styles__disabled";
$907aa1317a74c843$export$c2fa28b81fad2e23 = "_app-components-Form-_styles__baseErrorText";
$907aa1317a74c843$export$53f1d5ea8de3d7c = "_app-components-Form-_styles__line";
$907aa1317a74c843$export$9519373988617a1f = "_app-components-Form-_styles__lineShow";


const $f3218a61ba395453$var$FormField = ({ label: label, component: component, className: className, name: name, value: value, error: error, onChange: onChange, attrs: attrs })=>{
    const fieldClass = (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($907aa1317a74c843$exports))).formField, {
        [(0, (/*@__PURE__*/$parcel$interopDefault($907aa1317a74c843$exports))).error]: error
    }, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: fieldClass
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("label", {
        htmlFor: name
    }, label), component === "textarea" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("textarea", {
        id: name,
        name: name,
        value: value,
        onChange: onChange,
        ...attrs
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("input", {
        id: name,
        name: name,
        type: attrs.type || "text",
        value: value,
        onChange: onChange,
        ...attrs
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($907aa1317a74c843$exports))).errorText
    }, error));
};
var $f3218a61ba395453$export$2e2bcd8739ae039 = $f3218a61ba395453$var$FormField;



var $jiXHd = parcelRequire("jiXHd");


const $b2258b1b83b775f2$var$FormButton = ({ label: label, color: color, disabled: disabled, className: className })=>{
    const buttonStyles = (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($907aa1317a74c843$exports))).formButton, {
        [(0, (/*@__PURE__*/$parcel$interopDefault($907aa1317a74c843$exports))).disabled]: disabled
    }, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("button", {
        className: buttonStyles,
        type: "submit",
        disabled: disabled,
        style: {
            backgroundColor: color
        }
    }, label);
};
var $b2258b1b83b775f2$export$2e2bcd8739ae039 = $b2258b1b83b775f2$var$FormButton;



var $4153dfb849ed43f5$exports = {};
/*!
 * ScrollMagic v2.0.8 (2020-08-14)
 * The javascript library for magical scroll interactions.
 * (c) 2020 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 * 
 * @version 2.0.8
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file ScrollMagic main library.
 */ /**
 * @namespace ScrollMagic
 */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // CommonJS
    $4153dfb849ed43f5$exports = factory();
})($4153dfb849ed43f5$exports, function() {
    "use strict";
    var ScrollMagic = function() {
        _util.log(2, '(COMPATIBILITY NOTICE) -> As of ScrollMagic 2.0.0 you need to use \'new ScrollMagic.Controller()\' to create a new controller instance. Use \'new ScrollMagic.Scene()\' to instance a scene.');
    };
    ScrollMagic.version = "2.0.8";
    // TODO: temporary workaround for chrome's scroll jitter bug
    if (typeof window !== 'undefined') window.addEventListener("mousewheel", void 0);
    // global const
    var PIN_SPACER_ATTRIBUTE = "data-scrollmagic-pin-spacer";
    /**
	 * The main class that is needed once per scroll container.
	 *
	 * @class
	 *
	 * @example
	 * // basic initialization
	 * var controller = new ScrollMagic.Controller();
	 *
	 * // passing options
	 * var controller = new ScrollMagic.Controller({container: "#myContainer", loglevel: 3});
	 *
	 * @param {object} [options] - An object containing one or more options for the controller.
	 * @param {(string|object)} [options.container=window] - A selector, DOM object that references the main container for scrolling.
	 * @param {boolean} [options.vertical=true] - Sets the scroll mode to vertical (`true`) or horizontal (`false`) scrolling.
	 * @param {object} [options.globalSceneOptions={}] - These options will be passed to every Scene that is added to the controller using the addScene method. For more information on Scene options see {@link ScrollMagic.Scene}.
	 * @param {number} [options.loglevel=2] Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
											 ** `0` => silent
											 ** `1` => errors
											 ** `2` => errors, warnings
											 ** `3` => errors, warnings, debuginfo
	 * @param {boolean} [options.refreshInterval=100] - Some changes don't call events by default, like changing the container size or moving a scene trigger element.  
	 																										 This interval polls these parameters to fire the necessary events.  
	 																										 If you don't use custom containers, trigger elements or have static layouts, where the positions of the trigger elements don't change, you can set this to 0 disable interval checking and improve performance.
	 *
	 */ ScrollMagic.Controller = function(options) {
        /*
		 * ----------------------------------------------------------------
		 * settings
		 * ----------------------------------------------------------------
		 */ var NAMESPACE = 'ScrollMagic.Controller', SCROLL_DIRECTION_FORWARD = 'FORWARD', SCROLL_DIRECTION_REVERSE = 'REVERSE', SCROLL_DIRECTION_PAUSED = 'PAUSED', DEFAULT_OPTIONS = CONTROLLER_OPTIONS.defaults;
        /*
		 * ----------------------------------------------------------------
		 * private vars
		 * ----------------------------------------------------------------
		 */ var Controller = this, _options = _util.extend({}, DEFAULT_OPTIONS, options), _sceneObjects = [], _updateScenesOnNextCycle = false, _scrollPos = 0, _scrollDirection = SCROLL_DIRECTION_PAUSED, _isDocument = true, _viewPortSize = 0, _enabled = true, _updateTimeout, _refreshTimeout;
        /*
		 * ----------------------------------------------------------------
		 * private functions
		 * ----------------------------------------------------------------
		 */ /**
		 * Internal constructor function of the ScrollMagic Controller
		 * @private
		 */ var construct = function() {
            for(var key in _options)if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
                log(2, "WARNING: Unknown option \"" + key + "\"");
                delete _options[key];
            }
            _options.container = _util.get.elements(_options.container)[0];
            // check ScrollContainer
            if (!_options.container) {
                log(1, "ERROR creating object " + NAMESPACE + ": No valid scroll container supplied");
                throw NAMESPACE + " init failed."; // cancel
            }
            _isDocument = _options.container === window || _options.container === document.body || !document.body.contains(_options.container);
            // normalize to window
            if (_isDocument) _options.container = window;
            // update container size immediately
            _viewPortSize = getViewportSize();
            // set event handlers
            _options.container.addEventListener("resize", onChange);
            _options.container.addEventListener("scroll", onChange);
            var ri = parseInt(_options.refreshInterval, 10);
            _options.refreshInterval = _util.type.Number(ri) ? ri : DEFAULT_OPTIONS.refreshInterval;
            scheduleRefresh();
            log(3, "added new " + NAMESPACE + " controller (v" + ScrollMagic.version + ")");
        };
        /**
		 * Schedule the next execution of the refresh function
		 * @private
		 */ var scheduleRefresh = function() {
            if (_options.refreshInterval > 0) _refreshTimeout = window.setTimeout(refresh, _options.refreshInterval);
        };
        /**
		 * Default function to get scroll pos - overwriteable using `Controller.scrollPos(newFunction)`
		 * @private
		 */ var getScrollPos = function() {
            return _options.vertical ? _util.get.scrollTop(_options.container) : _util.get.scrollLeft(_options.container);
        };
        /**
		 * Returns the current viewport Size (width vor horizontal, height for vertical)
		 * @private
		 */ var getViewportSize = function() {
            return _options.vertical ? _util.get.height(_options.container) : _util.get.width(_options.container);
        };
        /**
		 * Default function to set scroll pos - overwriteable using `Controller.scrollTo(newFunction)`
		 * Make available publicly for pinned mousewheel workaround.
		 * @private
		 */ var setScrollPos = this._setScrollPos = function(pos) {
            if (_options.vertical) {
                if (_isDocument) window.scrollTo(_util.get.scrollLeft(), pos);
                else _options.container.scrollTop = pos;
            } else if (_isDocument) window.scrollTo(pos, _util.get.scrollTop());
            else _options.container.scrollLeft = pos;
        };
        /**
		 * Handle updates in cycles instead of on scroll (performance)
		 * @private
		 */ var updateScenes = function() {
            if (_enabled && _updateScenesOnNextCycle) {
                // determine scenes to update
                var scenesToUpdate = _util.type.Array(_updateScenesOnNextCycle) ? _updateScenesOnNextCycle : _sceneObjects.slice(0);
                // reset scenes
                _updateScenesOnNextCycle = false;
                var oldScrollPos = _scrollPos;
                // update scroll pos now instead of onChange, as it might have changed since scheduling (i.e. in-browser smooth scroll)
                _scrollPos = Controller.scrollPos();
                var deltaScroll = _scrollPos - oldScrollPos;
                if (deltaScroll !== 0) _scrollDirection = deltaScroll > 0 ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_REVERSE;
                // reverse order of scenes if scrolling reverse
                if (_scrollDirection === SCROLL_DIRECTION_REVERSE) scenesToUpdate.reverse();
                // update scenes
                scenesToUpdate.forEach(function(scene, index) {
                    log(3, "updating Scene " + (index + 1) + "/" + scenesToUpdate.length + " (" + _sceneObjects.length + " total)");
                    scene.update(true);
                });
                if (scenesToUpdate.length === 0 && _options.loglevel >= 3) log(3, "updating 0 Scenes (nothing added to controller)");
            }
        };
        /**
		 * Initializes rAF callback
		 * @private
		 */ var debounceUpdate = function() {
            _updateTimeout = _util.rAF(updateScenes);
        };
        /**
		 * Handles Container changes
		 * @private
		 */ var onChange = function(e) {
            log(3, "event fired causing an update:", e.type);
            if (e.type == "resize") {
                // resize
                _viewPortSize = getViewportSize();
                _scrollDirection = SCROLL_DIRECTION_PAUSED;
            }
            // schedule update
            if (_updateScenesOnNextCycle !== true) {
                _updateScenesOnNextCycle = true;
                debounceUpdate();
            }
        };
        var refresh = function() {
            if (!_isDocument) // simulate resize event. Only works for viewport relevant param (performance)
            {
                if (_viewPortSize != getViewportSize()) {
                    var resizeEvent;
                    try {
                        resizeEvent = new Event('resize', {
                            bubbles: false,
                            cancelable: false
                        });
                    } catch (e) {
                        resizeEvent = document.createEvent("Event");
                        resizeEvent.initEvent("resize", false, false);
                    }
                    _options.container.dispatchEvent(resizeEvent);
                }
            }
            _sceneObjects.forEach(function(scene, index) {
                scene.refresh();
            });
            scheduleRefresh();
        };
        /**
		 * Send a debug message to the console.
		 * provided publicly with _log for plugins
		 * @private
		 *
		 * @param {number} loglevel - The loglevel required to initiate output for the message.
		 * @param {...mixed} output - One or more variables that should be passed to the console.
		 */ var log = this._log = function(loglevel, output) {
            if (_options.loglevel >= loglevel) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");
                _util.log.apply(window, arguments);
            }
        };
        // for scenes we have getters for each option, but for the controller we don't, so we need to make it available externally for plugins
        this._options = _options;
        /**
		 * Sort scenes in ascending order of their start offset.
		 * @private
		 *
		 * @param {array} ScenesArray - an array of ScrollMagic Scenes that should be sorted
		 * @return {array} The sorted array of Scenes.
		 */ var sortScenes = function(ScenesArray) {
            if (ScenesArray.length <= 1) return ScenesArray;
            else {
                var scenes = ScenesArray.slice(0);
                scenes.sort(function(a, b) {
                    return a.scrollOffset() > b.scrollOffset() ? 1 : -1;
                });
                return scenes;
            }
        };
        /**
		 * ----------------------------------------------------------------
		 * public functions
		 * ----------------------------------------------------------------
		 */ /**
		 * Add one ore more scene(s) to the controller.  
		 * This is the equivalent to `Scene.addTo(controller)`.
		 * @public
		 * @example
		 * // with a previously defined scene
		 * controller.addScene(scene);
		 *
		 * // with a newly created scene.
		 * controller.addScene(new ScrollMagic.Scene({duration : 0}));
		 *
		 * // adding multiple scenes
		 * controller.addScene([scene, scene2, new ScrollMagic.Scene({duration : 0})]);
		 *
		 * @param {(ScrollMagic.Scene|array)} newScene - ScrollMagic Scene or Array of Scenes to be added to the controller.
		 * @return {Controller} Parent object for chaining.
		 */ this.addScene = function(newScene) {
            if (_util.type.Array(newScene)) newScene.forEach(function(scene, index) {
                Controller.addScene(scene);
            });
            else if (newScene instanceof ScrollMagic.Scene) {
                if (newScene.controller() !== Controller) newScene.addTo(Controller);
                else if (_sceneObjects.indexOf(newScene) < 0) {
                    // new scene
                    _sceneObjects.push(newScene); // add to array
                    _sceneObjects = sortScenes(_sceneObjects); // sort
                    newScene.on("shift.controller_sort", function() {
                        _sceneObjects = sortScenes(_sceneObjects);
                    });
                    // insert Global defaults.
                    for(var key in _options.globalSceneOptions)if (newScene[key]) newScene[key].call(newScene, _options.globalSceneOptions[key]);
                    log(3, "adding Scene (now " + _sceneObjects.length + " total)");
                }
            } else log(1, "ERROR: invalid argument supplied for '.addScene()'");
            return Controller;
        };
        /**
		 * Remove one ore more scene(s) from the controller.  
		 * This is the equivalent to `Scene.remove()`.
		 * @public
		 * @example
		 * // remove a scene from the controller
		 * controller.removeScene(scene);
		 *
		 * // remove multiple scenes from the controller
		 * controller.removeScene([scene, scene2, scene3]);
		 *
		 * @param {(ScrollMagic.Scene|array)} Scene - ScrollMagic Scene or Array of Scenes to be removed from the controller.
		 * @returns {Controller} Parent object for chaining.
		 */ this.removeScene = function(Scene) {
            if (_util.type.Array(Scene)) Scene.forEach(function(scene, index) {
                Controller.removeScene(scene);
            });
            else {
                var index = _sceneObjects.indexOf(Scene);
                if (index > -1) {
                    Scene.off("shift.controller_sort");
                    _sceneObjects.splice(index, 1);
                    log(3, "removing Scene (now " + _sceneObjects.length + " left)");
                    Scene.remove();
                }
            }
            return Controller;
        };
        /**
	 * Update one ore more scene(s) according to the scroll position of the container.  
	 * This is the equivalent to `Scene.update()`.  
	 * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
	 * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.  
	 * _**Note:** This method gets called constantly whenever Controller detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
	 * @public
	 * @example
	 * // update a specific scene on next cycle
 	 * controller.updateScene(scene);
 	 *
	 * // update a specific scene immediately
	 * controller.updateScene(scene, true);
 	 *
	 * // update multiple scenes scene on next cycle
	 * controller.updateScene([scene1, scene2, scene3]);
	 *
	 * @param {ScrollMagic.Scene} Scene - ScrollMagic Scene or Array of Scenes that is/are supposed to be updated.
	 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle.  
	 										  This is useful when changing multiple properties of the scene - this way it will only be updated once all new properties are set (updateScenes).
	 * @return {Controller} Parent object for chaining.
	 */ this.updateScene = function(Scene, immediately) {
            if (_util.type.Array(Scene)) Scene.forEach(function(scene, index) {
                Controller.updateScene(scene, immediately);
            });
            else {
                if (immediately) Scene.update(true);
                else if (_updateScenesOnNextCycle !== true && Scene instanceof ScrollMagic.Scene) {
                    // prep array for next update cycle
                    _updateScenesOnNextCycle = _updateScenesOnNextCycle || [];
                    if (_updateScenesOnNextCycle.indexOf(Scene) == -1) _updateScenesOnNextCycle.push(Scene);
                    _updateScenesOnNextCycle = sortScenes(_updateScenesOnNextCycle); // sort
                    debounceUpdate();
                }
            }
            return Controller;
        };
        /**
		 * Updates the controller params and calls updateScene on every scene, that is attached to the controller.  
		 * See `Controller.updateScene()` for more information about what this means.  
		 * In most cases you will not need this function, as it is called constantly, whenever ScrollMagic detects a state change event, like resize or scroll.  
		 * The only application for this method is when ScrollMagic fails to detect these events.  
		 * One application is with some external scroll libraries (like iScroll) that move an internal container to a negative offset instead of actually scrolling. In this case the update on the controller needs to be called whenever the child container's position changes.
		 * For this case there will also be the need to provide a custom function to calculate the correct scroll position. See `Controller.scrollPos()` for details.
		 * @public
		 * @example
		 * // update the controller on next cycle (saves performance due to elimination of redundant updates)
		 * controller.update();
		 *
		 * // update the controller immediately
		 * controller.update(true);
		 *
		 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance)
		 * @return {Controller} Parent object for chaining.
		 */ this.update = function(immediately) {
            onChange({
                type: "resize"
            }); // will update size and set _updateScenesOnNextCycle to true
            if (immediately) updateScenes();
            return Controller;
        };
        /**
		 * Scroll to a numeric scroll offset, a DOM element, the start of a scene or provide an alternate method for scrolling.  
		 * For vertical controllers it will change the top scroll offset and for horizontal applications it will change the left offset.
		 * @public
		 *
		 * @since 1.1.0
		 * @example
		 * // scroll to an offset of 100
		 * controller.scrollTo(100);
		 *
		 * // scroll to a DOM element
		 * controller.scrollTo("#anchor");
		 *
		 * // scroll to the beginning of a scene
		 * var scene = new ScrollMagic.Scene({offset: 200});
		 * controller.scrollTo(scene);
		 *
		 * // define a new scroll position modification function (jQuery animate instead of jump)
		 * controller.scrollTo(function (newScrollPos) {
		 *	$("html, body").animate({scrollTop: newScrollPos});
		 * });
		 * controller.scrollTo(100); // call as usual, but the new function will be used instead
		 *
		 * // define a new scroll function with an additional parameter
		 * controller.scrollTo(function (newScrollPos, message) {
		 *  console.log(message);
		 *	$(this).animate({scrollTop: newScrollPos});
		 * });
		 * // call as usual, but supply an extra parameter to the defined custom function
		 * controller.scrollTo(100, "my message");
		 *
		 * // define a new scroll function with an additional parameter containing multiple variables
		 * controller.scrollTo(function (newScrollPos, options) {
		 *  someGlobalVar = options.a + options.b;
		 *	$(this).animate({scrollTop: newScrollPos});
		 * });
		 * // call as usual, but supply an extra parameter containing multiple options
		 * controller.scrollTo(100, {a: 1, b: 2});
		 *
		 * // define a new scroll function with a callback supplied as an additional parameter
		 * controller.scrollTo(function (newScrollPos, callback) {
		 *	$(this).animate({scrollTop: newScrollPos}, 400, "swing", callback);
		 * });
		 * // call as usual, but supply an extra parameter, which is used as a callback in the previously defined custom scroll function
		 * controller.scrollTo(100, function() {
		 *	console.log("scroll has finished.");
		 * });
		 *
		 * @param {mixed} scrollTarget - The supplied argument can be one of these types:
		 * 1. `number` -> The container will scroll to this new scroll offset.
		 * 2. `string` or `object` -> Can be a selector or a DOM object.  
		 *  The container will scroll to the position of this element.
		 * 3. `ScrollMagic Scene` -> The container will scroll to the start of this scene.
		 * 4. `function` -> This function will be used for future scroll position modifications.  
		 *  This provides a way for you to change the behaviour of scrolling and adding new behaviour like animation. The function receives the new scroll position as a parameter and a reference to the container element using `this`.  
		 *  It may also optionally receive an optional additional parameter (see below)  
		 *  _**NOTE:**  
		 *  All other options will still work as expected, using the new function to scroll._
		 * @param {mixed} [additionalParameter] - If a custom scroll function was defined (see above 4.), you may want to supply additional parameters to it, when calling it. You can do this using this parameter – see examples for details. Please note, that this parameter will have no effect, if you use the default scrolling function.
		 * @returns {Controller} Parent object for chaining.
		 */ this.scrollTo = function(scrollTarget, additionalParameter) {
            if (_util.type.Number(scrollTarget)) setScrollPos.call(_options.container, scrollTarget, additionalParameter);
            else if (scrollTarget instanceof ScrollMagic.Scene) {
                if (scrollTarget.controller() === Controller) Controller.scrollTo(scrollTarget.scrollOffset(), additionalParameter);
                else log(2, "scrollTo(): The supplied scene does not belong to this controller. Scroll cancelled.", scrollTarget);
            } else if (_util.type.Function(scrollTarget)) setScrollPos = scrollTarget;
            else {
                var elem = _util.get.elements(scrollTarget)[0];
                if (elem) {
                    // if parent is pin spacer, use spacer position instead so correct start position is returned for pinned elements.
                    while(elem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE))elem = elem.parentNode;
                    var param = _options.vertical ? "top" : "left", containerOffset = _util.get.offset(_options.container), elementOffset = _util.get.offset(elem);
                    if (!_isDocument) containerOffset[param] -= Controller.scrollPos();
                    Controller.scrollTo(elementOffset[param] - containerOffset[param], additionalParameter);
                } else log(2, "scrollTo(): The supplied argument is invalid. Scroll cancelled.", scrollTarget);
            }
            return Controller;
        };
        /**
		 * **Get** the current scrollPosition or **Set** a new method to calculate it.  
		 * -> **GET**:
		 * When used as a getter this function will return the current scroll position.  
		 * To get a cached value use Controller.info("scrollPos"), which will be updated in the update cycle.  
		 * For vertical controllers it will return the top scroll offset and for horizontal applications it will return the left offset.
		 *
		 * -> **SET**:
		 * When used as a setter this method prodes a way to permanently overwrite the controller's scroll position calculation.  
		 * A typical usecase is when the scroll position is not reflected by the containers scrollTop or scrollLeft values, but for example by the inner offset of a child container.  
		 * Moving a child container inside a parent is a commonly used method for several scrolling frameworks, including iScroll.  
		 * By providing an alternate calculation function you can make sure ScrollMagic receives the correct scroll position.  
		 * Please also bear in mind that your function should return y values for vertical scrolls an x for horizontals.
		 *
		 * To change the current scroll position please use `Controller.scrollTo()`.
		 * @public
		 *
		 * @example
		 * // get the current scroll Position
		 * var scrollPos = controller.scrollPos();
		 *
		 * // set a new scroll position calculation method
		 * controller.scrollPos(function () {
		 *	return this.info("vertical") ? -mychildcontainer.y : -mychildcontainer.x
		 * });
		 *
		 * @param {function} [scrollPosMethod] - The function to be used for the scroll position calculation of the container.
		 * @returns {(number|Controller)} Current scroll position or parent object for chaining.
		 */ this.scrollPos = function(scrollPosMethod) {
            if (!arguments.length) return getScrollPos.call(Controller);
            else if (_util.type.Function(scrollPosMethod)) getScrollPos = scrollPosMethod;
            else log(2, "Provided value for method 'scrollPos' is not a function. To change the current scroll position use 'scrollTo()'.");
            return Controller;
        };
        /**
		 * **Get** all infos or one in particular about the controller.
		 * @public
		 * @example
		 * // returns the current scroll position (number)
		 * var scrollPos = controller.info("scrollPos");
		 *
		 * // returns all infos as an object
		 * var infos = controller.info();
		 *
		 * @param {string} [about] - If passed only this info will be returned instead of an object containing all.  
		 							 Valid options are:
		 							 ** `"size"` => the current viewport size of the container
		 							 ** `"vertical"` => true if vertical scrolling, otherwise false
		 							 ** `"scrollPos"` => the current scroll position
		 							 ** `"scrollDirection"` => the last known direction of the scroll
		 							 ** `"container"` => the container element
		 							 ** `"isDocument"` => true if container element is the document.
		 * @returns {(mixed|object)} The requested info(s).
		 */ this.info = function(about) {
            var values = {
                size: _viewPortSize,
                vertical: _options.vertical,
                scrollPos: _scrollPos,
                scrollDirection: _scrollDirection,
                container: _options.container,
                isDocument: _isDocument
            };
            if (!arguments.length) return values;
            else if (values[about] !== undefined) return values[about];
            else {
                log(1, "ERROR: option \"" + about + "\" is not available");
                return;
            }
        };
        /**
		 * **Get** or **Set** the current loglevel option value.
		 * @public
		 *
		 * @example
		 * // get the current value
		 * var loglevel = controller.loglevel();
		 *
		 * // set a new value
		 * controller.loglevel(3);
		 *
		 * @param {number} [newLoglevel] - The new loglevel setting of the Controller. `[0-3]`
		 * @returns {(number|Controller)} Current loglevel or parent object for chaining.
		 */ this.loglevel = function(newLoglevel) {
            if (!arguments.length) return _options.loglevel;
            else if (_options.loglevel != newLoglevel) _options.loglevel = newLoglevel;
            return Controller;
        };
        /**
		 * **Get** or **Set** the current enabled state of the controller.  
		 * This can be used to disable all Scenes connected to the controller without destroying or removing them.
		 * @public
		 *
		 * @example
		 * // get the current value
		 * var enabled = controller.enabled();
		 *
		 * // disable the controller
		 * controller.enabled(false);
		 *
		 * @param {boolean} [newState] - The new enabled state of the controller `true` or `false`.
		 * @returns {(boolean|Controller)} Current enabled state or parent object for chaining.
		 */ this.enabled = function(newState) {
            if (!arguments.length) return _enabled;
            else if (_enabled != newState) {
                _enabled = !!newState;
                Controller.updateScene(_sceneObjects, true);
            }
            return Controller;
        };
        /**
		 * Destroy the Controller, all Scenes and everything.
		 * @public
		 *
		 * @example
		 * // without resetting the scenes
		 * controller = controller.destroy();
		 *
		 * // with scene reset
		 * controller = controller.destroy(true);
		 *
		 * @param {boolean} [resetScenes=false] - If `true` the pins and tweens (if existent) of all scenes will be reset.
		 * @returns {null} Null to unset handler variables.
		 */ this.destroy = function(resetScenes) {
            window.clearTimeout(_refreshTimeout);
            var i = _sceneObjects.length;
            while(i--)_sceneObjects[i].destroy(resetScenes);
            _options.container.removeEventListener("resize", onChange);
            _options.container.removeEventListener("scroll", onChange);
            _util.cAF(_updateTimeout);
            log(3, "destroyed " + NAMESPACE + " (reset: " + (resetScenes ? "true" : "false") + ")");
            return null;
        };
        // INIT
        construct();
        return Controller;
    };
    // store pagewide controller options
    var CONTROLLER_OPTIONS = {
        defaults: {
            container: window,
            vertical: true,
            globalSceneOptions: {},
            loglevel: 2,
            refreshInterval: 100
        }
    };
    /*
	 * method used to add an option to ScrollMagic Scenes.
	 */ ScrollMagic.Controller.addOption = function(name, defaultValue) {
        CONTROLLER_OPTIONS.defaults[name] = defaultValue;
    };
    // instance extension function for plugins
    ScrollMagic.Controller.extend = function(extension) {
        var oldClass = this;
        ScrollMagic.Controller = function() {
            oldClass.apply(this, arguments);
            this.$super = _util.extend({}, this); // copy parent state
            return extension.apply(this, arguments) || this;
        };
        _util.extend(ScrollMagic.Controller, oldClass); // copy properties
        ScrollMagic.Controller.prototype = oldClass.prototype; // copy prototype
        ScrollMagic.Controller.prototype.constructor = ScrollMagic.Controller; // restore constructor
    };
    /**
	 * A Scene defines where the controller should react and how.
	 *
	 * @class
	 *
	 * @example
	 * // create a standard scene and add it to a controller
	 * new ScrollMagic.Scene()
	 *		.addTo(controller);
	 *
	 * // create a scene with custom options and assign a handler to it.
	 * var scene = new ScrollMagic.Scene({
	 * 		duration: 100,
	 *		offset: 200,
	 *		triggerHook: "onEnter",
	 *		reverse: false
	 * });
	 *
	 * @param {object} [options] - Options for the Scene. The options can be updated at any time.  
	 							   Instead of setting the options for each scene individually you can also set them globally in the controller as the controllers `globalSceneOptions` option. The object accepts the same properties as the ones below.  
	 							   When a scene is added to the controller the options defined using the Scene constructor will be overwritten by those set in `globalSceneOptions`.
	 * @param {(number|string|function)} [options.duration=0] - The duration of the scene. 
	 					Please see `Scene.duration()` for details.
	 * @param {number} [options.offset=0] - Offset Value for the Trigger Position. If no triggerElement is defined this will be the scroll distance from the start of the page, after which the scene will start.
	 * @param {(string|object)} [options.triggerElement=null] - Selector or DOM object that defines the start of the scene. If undefined the scene will start right at the start of the page (unless an offset is set).
	 * @param {(number|string)} [options.triggerHook="onCenter"] - Can be a number between 0 and 1 defining the position of the trigger Hook in relation to the viewport.  
	 															  Can also be defined using a string:
	 															  ** `"onEnter"` => `1`
	 															  ** `"onCenter"` => `0.5`
	 															  ** `"onLeave"` => `0`
	 * @param {boolean} [options.reverse=true] - Should the scene reverse, when scrolling up?
	 * @param {number} [options.loglevel=2] - Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
	 										  ** `0` => silent
	 										  ** `1` => errors
	 										  ** `2` => errors, warnings
	 										  ** `3` => errors, warnings, debuginfo
	 * 
	 */ ScrollMagic.Scene = function(options) {
        /*
		 * ----------------------------------------------------------------
		 * settings
		 * ----------------------------------------------------------------
		 */ var NAMESPACE = 'ScrollMagic.Scene', SCENE_STATE_BEFORE = 'BEFORE', SCENE_STATE_DURING = 'DURING', SCENE_STATE_AFTER = 'AFTER', DEFAULT_OPTIONS = SCENE_OPTIONS.defaults;
        /*
		 * ----------------------------------------------------------------
		 * private vars
		 * ----------------------------------------------------------------
		 */ var Scene = this, _options = _util.extend({}, DEFAULT_OPTIONS, options), _state = SCENE_STATE_BEFORE, _progress = 0, _scrollOffset = {
            start: 0,
            end: 0
        }, _triggerPos = 0, _enabled = true, _durationUpdateMethod, _controller;
        /**
		 * Internal constructor function of the ScrollMagic Scene
		 * @private
		 */ var construct = function() {
            for(var key in _options)if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
                log(2, "WARNING: Unknown option \"" + key + "\"");
                delete _options[key];
            }
            // add getters/setters for all possible options
            for(var optionName in DEFAULT_OPTIONS)addSceneOption(optionName);
            // validate all options
            validateOption();
        };
        /*
		 * ----------------------------------------------------------------
		 * Event Management
		 * ----------------------------------------------------------------
		 */ var _listeners = {};
        /**
		 * Scene start event.  
		 * Fires whenever the scroll position its the starting point of the scene.  
		 * It will also fire when scrolling back up going over the start position of the scene. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#start
		 *
		 * @example
		 * scene.on("start", function (event) {
		 * 	console.log("Hit start point of scene.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"` or `"DURING"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene end event.  
		 * Fires whenever the scroll position its the ending point of the scene.  
		 * It will also fire when scrolling back up from after the scene and going over its end position. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#end
		 *
		 * @example
		 * scene.on("end", function (event) {
		 * 	console.log("Hit end point of scene.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"DURING"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene enter event.  
		 * Fires whenever the scene enters the "DURING" state.  
		 * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene enters its active scroll timeframe, regardless of the scroll-direction.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#enter
		 *
		 * @example
		 * scene.on("enter", function (event) {
		 * 	console.log("Scene entered.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene - always `"DURING"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene leave event.  
		 * Fires whenever the scene's state goes from "DURING" to either "BEFORE" or "AFTER".  
		 * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene leaves its active scroll timeframe, regardless of the scroll-direction.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#leave
		 *
		 * @example
		 * scene.on("leave", function (event) {
		 * 	console.log("Scene left.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene update event.  
		 * Fires whenever the scene is updated (but not necessarily changes the progress).
		 *
		 * @event ScrollMagic.Scene#update
		 *
		 * @example
		 * scene.on("update", function (event) {
		 * 	console.log("Scene updated.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.startPos - The starting position of the scene (in relation to the conainer)
		 * @property {number} event.endPos - The ending position of the scene (in relation to the conainer)
		 * @property {number} event.scrollPos - The current scroll position of the container
		 */ /**
		 * Scene progress event.  
		 * Fires whenever the progress of the scene changes.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#progress
		 *
		 * @example
		 * scene.on("progress", function (event) {
		 * 	console.log("Scene progress changed to " + event.progress);
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"`, `"DURING"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */ /**
		 * Scene change event.  
		 * Fires whenvever a property of the scene is changed.
		 *
		 * @event ScrollMagic.Scene#change
		 *
		 * @example
		 * scene.on("change", function (event) {
		 * 	console.log("Scene Property \"" + event.what + "\" changed to " + event.newval);
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {string} event.what - Indicates what value has been changed
		 * @property {mixed} event.newval - The new value of the changed property
		 */ /**
		 * Scene shift event.  
		 * Fires whenvever the start or end **scroll offset** of the scene change.
		 * This happens explicitely, when one of these values change: `offset`, `duration` or `triggerHook`.
		 * It will fire implicitly when the `triggerElement` changes, if the new element has a different position (most cases).
		 * It will also fire implicitly when the size of the container changes and the triggerHook is anything other than `onLeave`.
		 *
		 * @event ScrollMagic.Scene#shift
		 * @since 1.1.0
		 *
		 * @example
		 * scene.on("shift", function (event) {
		 * 	console.log("Scene moved, because the " + event.reason + " has changed.)");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {string} event.reason - Indicates why the scene has shifted
		 */ /**
		 * Scene destroy event.  
		 * Fires whenvever the scene is destroyed.
		 * This can be used to tidy up custom behaviour used in events.
		 *
		 * @event ScrollMagic.Scene#destroy
		 * @since 1.1.0
		 *
		 * @example
		 * scene.on("enter", function (event) {
		 *        // add custom action
		 *        $("#my-elem").left("200");
		 *      })
		 *      .on("destroy", function (event) {
		 *        // reset my element to start position
		 *        if (event.reset) {
		 *          $("#my-elem").left("0");
		 *        }
		 *      });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {boolean} event.reset - Indicates if the destroy method was called with reset `true` or `false`.
		 */ /**
		 * Scene add event.  
		 * Fires when the scene is added to a controller.
		 * This is mostly used by plugins to know that change might be due.
		 *
		 * @event ScrollMagic.Scene#add
		 * @since 2.0.0
		 *
		 * @example
		 * scene.on("add", function (event) {
		 * 	console.log('Scene was added to a new controller.');
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {boolean} event.controller - The controller object the scene was added to.
		 */ /**
		 * Scene remove event.  
		 * Fires when the scene is removed from a controller.
		 * This is mostly used by plugins to know that change might be due.
		 *
		 * @event ScrollMagic.Scene#remove
		 * @since 2.0.0
		 *
		 * @example
		 * scene.on("remove", function (event) {
		 * 	console.log('Scene was removed from its controller.');
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 */ /**
		 * Add one ore more event listener.  
		 * The callback function will be fired at the respective event, and an object containing relevant data will be passed to the callback.
		 * @method ScrollMagic.Scene#on
		 *
		 * @example
		 * function callback (event) {
		 * 		console.log("Event fired! (" + event.type + ")");
		 * }
		 * // add listeners
		 * scene.on("change update progress start end enter leave", callback);
		 *
		 * @param {string} names - The name or names of the event the callback should be attached to.
		 * @param {function} callback - A function that should be executed, when the event is dispatched. An event object will be passed to the callback.
		 * @returns {Scene} Parent object for chaining.
		 */ this.on = function(names, callback) {
            if (_util.type.Function(callback)) {
                names = names.trim().split(' ');
                names.forEach(function(fullname) {
                    var nameparts = fullname.split('.'), eventname = nameparts[0], namespace = nameparts[1];
                    if (eventname != "*") {
                        if (!_listeners[eventname]) _listeners[eventname] = [];
                        _listeners[eventname].push({
                            namespace: namespace || '',
                            callback: callback
                        });
                    }
                });
            } else log(1, "ERROR when calling '.on()': Supplied callback for '" + names + "' is not a valid function!");
            return Scene;
        };
        /**
		 * Remove one or more event listener.
		 * @method ScrollMagic.Scene#off
		 *
		 * @example
		 * function callback (event) {
		 * 		console.log("Event fired! (" + event.type + ")");
		 * }
		 * // add listeners
		 * scene.on("change update", callback);
		 * // remove listeners
		 * scene.off("change update", callback);
		 *
		 * @param {string} names - The name or names of the event that should be removed.
		 * @param {function} [callback] - A specific callback function that should be removed. If none is passed all callbacks to the event listener will be removed.
		 * @returns {Scene} Parent object for chaining.
		 */ this.off = function(names, callback) {
            if (!names) {
                log(1, "ERROR: Invalid event name supplied.");
                return Scene;
            }
            names = names.trim().split(' ');
            names.forEach(function(fullname, key) {
                var nameparts = fullname.split('.'), eventname = nameparts[0], namespace = nameparts[1] || '', removeList = eventname === '*' ? Object.keys(_listeners) : [
                    eventname
                ];
                removeList.forEach(function(remove) {
                    var list = _listeners[remove] || [], i = list.length;
                    while(i--){
                        var listener = list[i];
                        if (listener && (namespace === listener.namespace || namespace === '*') && (!callback || callback == listener.callback)) list.splice(i, 1);
                    }
                    if (!list.length) delete _listeners[remove];
                });
            });
            return Scene;
        };
        /**
		 * Trigger an event.
		 * @method ScrollMagic.Scene#trigger
		 *
		 * @example
		 * this.trigger("change");
		 *
		 * @param {string} name - The name of the event that should be triggered.
		 * @param {object} [vars] - An object containing info that should be passed to the callback.
		 * @returns {Scene} Parent object for chaining.
		 */ this.trigger = function(name, vars) {
            if (name) {
                var nameparts = name.trim().split('.'), eventname = nameparts[0], namespace = nameparts[1], listeners = _listeners[eventname];
                log(3, 'event fired:', eventname, vars ? "->" : '', vars || '');
                if (listeners) listeners.forEach(function(listener, key) {
                    if (!namespace || namespace === listener.namespace) listener.callback.call(Scene, new ScrollMagic.Event(eventname, listener.namespace, Scene, vars));
                });
            } else log(1, "ERROR: Invalid event name supplied.");
            return Scene;
        };
        // set event listeners
        Scene.on("change.internal", function(e) {
            if (e.what !== "loglevel" && e.what !== "tweenChanges") {
                if (e.what === "triggerElement") updateTriggerElementPosition();
                else if (e.what === "reverse") Scene.update();
            }
        }).on("shift.internal", function(e) {
            updateScrollOffset();
            Scene.update(); // update scene to reflect new position
        });
        /**
		 * Send a debug message to the console.
		 * @private
		 * but provided publicly with _log for plugins
		 *
		 * @param {number} loglevel - The loglevel required to initiate output for the message.
		 * @param {...mixed} output - One or more variables that should be passed to the console.
		 */ var log = this._log = function(loglevel, output) {
            if (_options.loglevel >= loglevel) {
                Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");
                _util.log.apply(window, arguments);
            }
        };
        /**
		 * Add the scene to a controller.  
		 * This is the equivalent to `Controller.addScene(scene)`.
		 * @method ScrollMagic.Scene#addTo
		 *
		 * @example
		 * // add a scene to a ScrollMagic Controller
		 * scene.addTo(controller);
		 *
		 * @param {ScrollMagic.Controller} controller - The controller to which the scene should be added.
		 * @returns {Scene} Parent object for chaining.
		 */ this.addTo = function(controller) {
            if (!(controller instanceof ScrollMagic.Controller)) log(1, "ERROR: supplied argument of 'addTo()' is not a valid ScrollMagic Controller");
            else if (_controller != controller) {
                // new controller
                if (_controller) _controller.removeScene(Scene);
                _controller = controller;
                validateOption();
                updateDuration(true);
                updateTriggerElementPosition(true);
                updateScrollOffset();
                _controller.info("container").addEventListener('resize', onContainerResize);
                controller.addScene(Scene);
                Scene.trigger("add", {
                    controller: _controller
                });
                log(3, "added " + NAMESPACE + " to controller");
                Scene.update();
            }
            return Scene;
        };
        /**
		 * **Get** or **Set** the current enabled state of the scene.  
		 * This can be used to disable this scene without removing or destroying it.
		 * @method ScrollMagic.Scene#enabled
		 *
		 * @example
		 * // get the current value
		 * var enabled = scene.enabled();
		 *
		 * // disable the scene
		 * scene.enabled(false);
		 *
		 * @param {boolean} [newState] - The new enabled state of the scene `true` or `false`.
		 * @returns {(boolean|Scene)} Current enabled state or parent object for chaining.
		 */ this.enabled = function(newState) {
            if (!arguments.length) return _enabled;
            else if (_enabled != newState) {
                _enabled = !!newState;
                Scene.update(true);
            }
            return Scene;
        };
        /**
		 * Remove the scene from the controller.  
		 * This is the equivalent to `Controller.removeScene(scene)`.
		 * The scene will not be updated anymore until you readd it to a controller.
		 * To remove the pin or the tween you need to call removeTween() or removePin() respectively.
		 * @method ScrollMagic.Scene#remove
		 * @example
		 * // remove the scene from its controller
		 * scene.remove();
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.remove = function() {
            if (_controller) {
                _controller.info("container").removeEventListener('resize', onContainerResize);
                var tmpParent = _controller;
                _controller = undefined;
                tmpParent.removeScene(Scene);
                Scene.trigger("remove");
                log(3, "removed " + NAMESPACE + " from controller");
            }
            return Scene;
        };
        /**
		 * Destroy the scene and everything.
		 * @method ScrollMagic.Scene#destroy
		 * @example
		 * // destroy the scene without resetting the pin and tween to their initial positions
		 * scene = scene.destroy();
		 *
		 * // destroy the scene and reset the pin and tween
		 * scene = scene.destroy(true);
		 *
		 * @param {boolean} [reset=false] - If `true` the pin and tween (if existent) will be reset.
		 * @returns {null} Null to unset handler variables.
		 */ this.destroy = function(reset) {
            Scene.trigger("destroy", {
                reset: reset
            });
            Scene.remove();
            Scene.off("*.*");
            log(3, "destroyed " + NAMESPACE + " (reset: " + (reset ? "true" : "false") + ")");
            return null;
        };
        /**
		 * Updates the Scene to reflect the current state.  
		 * This is the equivalent to `Controller.updateScene(scene, immediately)`.  
		 * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
		 * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.
		 * This means an update doesn't necessarily result in a progress change. The `progress` event will be fired if the progress has indeed changed between this update and the last.  
		 * _**NOTE:** This method gets called constantly whenever ScrollMagic detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
		 * @method ScrollMagic.Scene#update
		 * @example
		 * // update the scene on next tick
		 * scene.update();
		 *
		 * // update the scene immediately
		 * scene.update(true);
		 *
		 * @fires Scene.update
		 *
		 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance).
		 * @returns {Scene} Parent object for chaining.
		 */ this.update = function(immediately) {
            if (_controller) {
                if (immediately) {
                    if (_controller.enabled() && _enabled) {
                        var scrollPos = _controller.info("scrollPos"), newProgress;
                        if (_options.duration > 0) newProgress = (scrollPos - _scrollOffset.start) / (_scrollOffset.end - _scrollOffset.start);
                        else newProgress = scrollPos >= _scrollOffset.start ? 1 : 0;
                        Scene.trigger("update", {
                            startPos: _scrollOffset.start,
                            endPos: _scrollOffset.end,
                            scrollPos: scrollPos
                        });
                        Scene.progress(newProgress);
                    } else if (_pin && _state === SCENE_STATE_DURING) updatePinState(true); // unpin in position
                } else _controller.updateScene(Scene, false);
            }
            return Scene;
        };
        /**
		 * Updates dynamic scene variables like the trigger element position or the duration.
		 * This method is automatically called in regular intervals from the controller. See {@link ScrollMagic.Controller} option `refreshInterval`.
		 * 
		 * You can call it to minimize lag, for example when you intentionally change the position of the triggerElement.
		 * If you don't it will simply be updated in the next refresh interval of the container, which is usually sufficient.
		 *
		 * @method ScrollMagic.Scene#refresh
		 * @since 1.1.0
		 * @example
		 * scene = new ScrollMagic.Scene({triggerElement: "#trigger"});
		 * 
		 * // change the position of the trigger
		 * $("#trigger").css("top", 500);
		 * // immediately let the scene know of this change
		 * scene.refresh();
		 *
		 * @fires {@link Scene.shift}, if the trigger element position or the duration changed
		 * @fires {@link Scene.change}, if the duration changed
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.refresh = function() {
            updateDuration();
            updateTriggerElementPosition();
            // update trigger element position
            return Scene;
        };
        /**
		 * **Get** or **Set** the scene's progress.  
		 * Usually it shouldn't be necessary to use this as a setter, as it is set automatically by scene.update().  
		 * The order in which the events are fired depends on the duration of the scene:
		 *  1. Scenes with `duration == 0`:  
		 *  Scenes that have no duration by definition have no ending. Thus the `end` event will never be fired.  
		 *  When the trigger position of the scene is passed the events are always fired in this order:  
		 *  `enter`, `start`, `progress` when scrolling forward  
		 *  and  
		 *  `progress`, `start`, `leave` when scrolling in reverse
		 *  2. Scenes with `duration > 0`:  
		 *  Scenes with a set duration have a defined start and end point.  
		 *  When scrolling past the start position of the scene it will fire these events in this order:  
		 *  `enter`, `start`, `progress`  
		 *  When continuing to scroll and passing the end point it will fire these events:  
		 *  `progress`, `end`, `leave`  
		 *  When reversing through the end point these events are fired:  
		 *  `enter`, `end`, `progress`  
		 *  And when continuing to scroll past the start position in reverse it will fire:  
		 *  `progress`, `start`, `leave`  
		 *  In between start and end the `progress` event will be called constantly, whenever the progress changes.
		 * 
		 * In short:  
		 * `enter` events will always trigger **before** the progress update and `leave` envents will trigger **after** the progress update.  
		 * `start` and `end` will always trigger at their respective position.
		 * 
		 * Please review the event descriptions for details on the events and the event object that is passed to the callback.
		 * 
		 * @method ScrollMagic.Scene#progress
		 * @example
		 * // get the current scene progress
		 * var progress = scene.progress();
		 *
		 * // set new scene progress
		 * scene.progress(0.3);
		 *
		 * @fires {@link Scene.enter}, when used as setter
		 * @fires {@link Scene.start}, when used as setter
		 * @fires {@link Scene.progress}, when used as setter
		 * @fires {@link Scene.end}, when used as setter
		 * @fires {@link Scene.leave}, when used as setter
		 *
		 * @param {number} [progress] - The new progress value of the scene `[0-1]`.
		 * @returns {number} `get` -  Current scene progress.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ this.progress = function(progress) {
            if (!arguments.length) return _progress;
            else {
                var doUpdate = false, oldState = _state, scrollDirection = _controller ? _controller.info("scrollDirection") : 'PAUSED', reverseOrForward = _options.reverse || progress >= _progress;
                if (_options.duration === 0) {
                    // zero duration scenes
                    doUpdate = _progress != progress;
                    _progress = progress < 1 && reverseOrForward ? 0 : 1;
                    _state = _progress === 0 ? SCENE_STATE_BEFORE : SCENE_STATE_DURING;
                } else {
                    // scenes with start and end
                    if (progress < 0 && _state !== SCENE_STATE_BEFORE && reverseOrForward) {
                        // go back to initial state
                        _progress = 0;
                        _state = SCENE_STATE_BEFORE;
                        doUpdate = true;
                    } else if (progress >= 0 && progress < 1 && reverseOrForward) {
                        _progress = progress;
                        _state = SCENE_STATE_DURING;
                        doUpdate = true;
                    } else if (progress >= 1 && _state !== SCENE_STATE_AFTER) {
                        _progress = 1;
                        _state = SCENE_STATE_AFTER;
                        doUpdate = true;
                    } else if (_state === SCENE_STATE_DURING && !reverseOrForward) updatePinState(); // in case we scrolled backwards mid-scene and reverse is disabled => update the pin position, so it doesn't move back as well.
                }
                if (doUpdate) {
                    // fire events
                    var eventVars = {
                        progress: _progress,
                        state: _state,
                        scrollDirection: scrollDirection
                    }, stateChanged = _state != oldState;
                    var trigger = function(eventName) {
                        Scene.trigger(eventName, eventVars);
                    };
                    if (stateChanged) {
                        if (oldState !== SCENE_STATE_DURING) {
                            trigger("enter");
                            trigger(oldState === SCENE_STATE_BEFORE ? "start" : "end");
                        }
                    }
                    trigger("progress");
                    if (stateChanged) {
                        if (_state !== SCENE_STATE_DURING) {
                            trigger(_state === SCENE_STATE_BEFORE ? "start" : "end");
                            trigger("leave");
                        }
                    }
                }
                return Scene;
            }
        };
        /**
		 * Update the start and end scrollOffset of the container.
		 * The positions reflect what the controller's scroll position will be at the start and end respectively.
		 * Is called, when:
		 *   - Scene event "change" is called with: offset, triggerHook, duration 
		 *   - scroll container event "resize" is called
		 *   - the position of the triggerElement changes
		 *   - the controller changes -> addTo()
		 * @private
		 */ var updateScrollOffset = function() {
            _scrollOffset = {
                start: _triggerPos + _options.offset
            };
            if (_controller && _options.triggerElement) // take away triggerHook portion to get relative to top
            _scrollOffset.start -= _controller.info("size") * _options.triggerHook;
            _scrollOffset.end = _scrollOffset.start + _options.duration;
        };
        /**
		 * Updates the duration if set to a dynamic function.
		 * This method is called when the scene is added to a controller and in regular intervals from the controller through scene.refresh().
		 * 
		 * @fires {@link Scene.change}, if the duration changed
		 * @fires {@link Scene.shift}, if the duration changed
		 *
		 * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
		 * @private
		 */ var updateDuration = function(suppressEvents) {
            // update duration
            if (_durationUpdateMethod) {
                var varname = "duration";
                if (changeOption(varname, _durationUpdateMethod.call(Scene)) && !suppressEvents) {
                    Scene.trigger("change", {
                        what: varname,
                        newval: _options[varname]
                    });
                    Scene.trigger("shift", {
                        reason: varname
                    });
                }
            }
        };
        /**
		 * Updates the position of the triggerElement, if present.
		 * This method is called ...
		 *  - ... when the triggerElement is changed
		 *  - ... when the scene is added to a (new) controller
		 *  - ... in regular intervals from the controller through scene.refresh().
		 * 
		 * @fires {@link Scene.shift}, if the position changed
		 *
		 * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
		 * @private
		 */ var updateTriggerElementPosition = function(suppressEvents) {
            var elementPos = 0, telem = _options.triggerElement;
            if (_controller && (telem || _triggerPos > 0)) {
                if (telem) {
                    if (telem.parentNode) {
                        var controllerInfo = _controller.info(), containerOffset = _util.get.offset(controllerInfo.container), param = controllerInfo.vertical ? "top" : "left"; // which param is of interest ?
                        // if parent is spacer, use spacer position instead so correct start position is returned for pinned elements.
                        while(telem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE))telem = telem.parentNode;
                        var elementOffset = _util.get.offset(telem);
                        if (!controllerInfo.isDocument) containerOffset[param] -= _controller.scrollPos();
                        elementPos = elementOffset[param] - containerOffset[param];
                    } else {
                        log(2, "WARNING: triggerElement was removed from DOM and will be reset to", undefined);
                        Scene.triggerElement(undefined); // unset, so a change event is triggered
                    }
                }
                var changed = elementPos != _triggerPos;
                _triggerPos = elementPos;
                if (changed && !suppressEvents) Scene.trigger("shift", {
                    reason: "triggerElementPosition"
                });
            }
        };
        /**
		 * Trigger a shift event, when the container is resized and the triggerHook is > 1.
		 * @private
		 */ var onContainerResize = function(e) {
            if (_options.triggerHook > 0) Scene.trigger("shift", {
                reason: "containerResize"
            });
        };
        var _validate = _util.extend(SCENE_OPTIONS.validate, {
            // validation for duration handled internally for reference to private var _durationMethod
            duration: function(val) {
                if (_util.type.String(val) && val.match(/^(\.|\d)*\d+%$/)) {
                    // percentage value
                    var perc = parseFloat(val) / 100;
                    val = function() {
                        return _controller ? _controller.info("size") * perc : 0;
                    };
                }
                if (_util.type.Function(val)) {
                    // function
                    _durationUpdateMethod = val;
                    try {
                        val = parseFloat(_durationUpdateMethod.call(Scene));
                    } catch (e) {
                        val = -1; // will cause error below
                    }
                }
                // val has to be float
                val = parseFloat(val);
                if (!_util.type.Number(val) || val < 0) {
                    if (_durationUpdateMethod) {
                        _durationUpdateMethod = undefined;
                        throw [
                            "Invalid return value of supplied function for option \"duration\":",
                            val
                        ];
                    } else throw [
                        "Invalid value for option \"duration\":",
                        val
                    ];
                }
                return val;
            }
        });
        /**
		 * Checks the validity of a specific or all options and reset to default if neccessary.
		 * @private
		 */ var validateOption = function(check) {
            check = arguments.length ? [
                check
            ] : Object.keys(_validate);
            check.forEach(function(optionName, key) {
                var value;
                if (_validate[optionName]) try {
                    value = _validate[optionName](_options[optionName]);
                } catch (e) {
                    value = DEFAULT_OPTIONS[optionName];
                    var logMSG = _util.type.String(e) ? [
                        e
                    ] : e;
                    if (_util.type.Array(logMSG)) {
                        logMSG[0] = "ERROR: " + logMSG[0];
                        logMSG.unshift(1); // loglevel 1 for error msg
                        log.apply(this, logMSG);
                    } else log(1, "ERROR: Problem executing validation callback for option '" + optionName + "':", e.message);
                } finally{
                    _options[optionName] = value;
                }
            });
        };
        /**
		 * Helper used by the setter/getters for scene options
		 * @private
		 */ var changeOption = function(varname, newval) {
            var changed = false, oldval = _options[varname];
            if (_options[varname] != newval) {
                _options[varname] = newval;
                validateOption(varname); // resets to default if necessary
                changed = oldval != _options[varname];
            }
            return changed;
        };
        // generate getters/setters for all options
        var addSceneOption = function(optionName) {
            if (!Scene[optionName]) Scene[optionName] = function(newVal) {
                if (!arguments.length) return _options[optionName];
                else {
                    if (optionName === "duration") _durationUpdateMethod = undefined;
                    if (changeOption(optionName, newVal)) {
                        Scene.trigger("change", {
                            what: optionName,
                            newval: _options[optionName]
                        });
                        if (SCENE_OPTIONS.shifts.indexOf(optionName) > -1) Scene.trigger("shift", {
                            reason: optionName
                        });
                    }
                }
                return Scene;
            };
        };
        /**
		 * **Get** or **Set** the duration option value.
		 *
		 * As a **setter** it accepts three types of parameters:
		 * 1. `number`: Sets the duration of the scene to exactly this amount of pixels.  
		 *   This means the scene will last for exactly this amount of pixels scrolled. Sub-Pixels are also valid.
		 *   A value of `0` means that the scene is 'open end' and no end will be triggered. Pins will never unpin and animations will play independently of scroll progress.
		 * 2. `string`: Always updates the duration relative to parent scroll container.  
		 *   For example `"100%"` will keep the duration always exactly at the inner height of the scroll container.
		 *   When scrolling vertically the width is used for reference respectively.
		 * 3. `function`: The supplied function will be called to return the scene duration.
		 *   This is useful in setups where the duration depends on other elements who might change size. By supplying a function you can return a value instead of updating potentially multiple scene durations.  
		 *   The scene can be referenced inside the callback using `this`.
		 *   _**WARNING:** This is an easy way to kill performance, as the callback will be executed every time `Scene.refresh()` is called, which happens a lot. The interval is defined by the controller (see ScrollMagic.Controller option `refreshInterval`).  
		 *   It's recomended to avoid calculations within the function and use cached variables as return values.  
		 *   This counts double if you use the same function for multiple scenes._
		 *
		 * @method ScrollMagic.Scene#duration
		 * @example
		 * // get the current duration value
		 * var duration = scene.duration();
		 *
		 * // set a new duration
		 * scene.duration(300);
		 *
		 * // set duration responsively to container size
		 * scene.duration("100%");
		 *
		 * // use a function to randomize the duration for some reason.
		 * var durationValueCache;
		 * function durationCallback () {
		 *   return durationValueCache;
		 * }
		 * function updateDuration () {
		 *   durationValueCache = Math.random() * 100;
		 * }
		 * updateDuration(); // set to initial value
		 * scene.duration(durationCallback); // set duration callback
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {(number|string|function)} [newDuration] - The new duration setting for the scene.
		 * @returns {number} `get` -  Current scene duration.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the offset option value.
		 * @method ScrollMagic.Scene#offset
		 * @example
		 * // get the current offset
		 * var offset = scene.offset();
		 *
		 * // set a new offset
		 * scene.offset(100);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {number} [newOffset] - The new offset of the scene.
		 * @returns {number} `get` -  Current scene offset.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the triggerElement option value.
		 * Does **not** fire `Scene.shift`, because changing the trigger Element doesn't necessarily mean the start position changes. This will be determined in `Scene.refresh()`, which is automatically triggered.
		 * @method ScrollMagic.Scene#triggerElement
		 * @example
		 * // get the current triggerElement
		 * var triggerElement = scene.triggerElement();
		 *
		 * // set a new triggerElement using a selector
		 * scene.triggerElement("#trigger");
		 * // set a new triggerElement using a DOM object
		 * scene.triggerElement(document.getElementById("trigger"));
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {(string|object)} [newTriggerElement] - The new trigger element for the scene.
		 * @returns {(string|object)} `get` -  Current triggerElement.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the triggerHook option value.
		 * @method ScrollMagic.Scene#triggerHook
		 * @example
		 * // get the current triggerHook value
		 * var triggerHook = scene.triggerHook();
		 *
		 * // set a new triggerHook using a string
		 * scene.triggerHook("onLeave");
		 * // set a new triggerHook using a number
		 * scene.triggerHook(0.7);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {(number|string)} [newTriggerHook] - The new triggerHook of the scene. See {@link Scene} parameter description for value options.
		 * @returns {number} `get` -  Current triggerHook (ALWAYS numerical).
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the reverse option value.
		 * @method ScrollMagic.Scene#reverse
		 * @example
		 * // get the current reverse option
		 * var reverse = scene.reverse();
		 *
		 * // set new reverse option
		 * scene.reverse(false);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {boolean} [newReverse] - The new reverse setting of the scene.
		 * @returns {boolean} `get` -  Current reverse option value.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** or **Set** the loglevel option value.
		 * @method ScrollMagic.Scene#loglevel
		 * @example
		 * // get the current loglevel
		 * var loglevel = scene.loglevel();
		 *
		 * // set new loglevel
		 * scene.loglevel(3);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {number} [newLoglevel] - The new loglevel setting of the scene. `[0-3]`
		 * @returns {number} `get` -  Current loglevel.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */ /**
		 * **Get** the associated controller.
		 * @method ScrollMagic.Scene#controller
		 * @example
		 * // get the controller of a scene
		 * var controller = scene.controller();
		 *
		 * @returns {ScrollMagic.Controller} Parent controller or `undefined`
		 */ this.controller = function() {
            return _controller;
        };
        /**
		 * **Get** the current state.
		 * @method ScrollMagic.Scene#state
		 * @example
		 * // get the current state
		 * var state = scene.state();
		 *
		 * @returns {string} `"BEFORE"`, `"DURING"` or `"AFTER"`
		 */ this.state = function() {
            return _state;
        };
        /**
		 * **Get** the current scroll offset for the start of the scene.  
		 * Mind, that the scrollOffset is related to the size of the container, if `triggerHook` is bigger than `0` (or `"onLeave"`).  
		 * This means, that resizing the container or changing the `triggerHook` will influence the scene's start offset.
		 * @method ScrollMagic.Scene#scrollOffset
		 * @example
		 * // get the current scroll offset for the start and end of the scene.
		 * var start = scene.scrollOffset();
		 * var end = scene.scrollOffset() + scene.duration();
		 * console.log("the scene starts at", start, "and ends at", end);
		 *
		 * @returns {number} The scroll offset (of the container) at which the scene will trigger. Y value for vertical and X value for horizontal scrolls.
		 */ this.scrollOffset = function() {
            return _scrollOffset.start;
        };
        /**
		 * **Get** the trigger position of the scene (including the value of the `offset` option).  
		 * @method ScrollMagic.Scene#triggerPosition
		 * @example
		 * // get the scene's trigger position
		 * var triggerPosition = scene.triggerPosition();
		 *
		 * @returns {number} Start position of the scene. Top position value for vertical and left position value for horizontal scrolls.
		 */ this.triggerPosition = function() {
            var pos = _options.offset; // the offset is the basis
            if (_controller) {
                // get the trigger position
                if (_options.triggerElement) // Element as trigger
                pos += _triggerPos;
                else // return the height of the triggerHook to start at the beginning
                pos += _controller.info("size") * Scene.triggerHook();
            }
            return pos;
        };
        var _pin, _pinOptions;
        Scene.on("shift.internal", function(e) {
            var durationChanged = e.reason === "duration";
            if (_state === SCENE_STATE_AFTER && durationChanged || _state === SCENE_STATE_DURING && _options.duration === 0) // if [duration changed after a scene (inside scene progress updates pin position)] or [duration is 0, we are in pin phase and some other value changed].
            updatePinState();
            if (durationChanged) updatePinDimensions();
        }).on("progress.internal", function(e) {
            updatePinState();
        }).on("add.internal", function(e) {
            updatePinDimensions();
        }).on("destroy.internal", function(e) {
            Scene.removePin(e.reset);
        });
        /**
		 * Update the pin state.
		 * @private
		 */ var updatePinState = function(forceUnpin) {
            if (_pin && _controller) {
                var containerInfo = _controller.info(), pinTarget = _pinOptions.spacer.firstChild; // may be pin element or another spacer, if cascading pins
                if (!forceUnpin && _state === SCENE_STATE_DURING) {
                    // pinned state
                    if (_util.css(pinTarget, "position") != "fixed") {
                        // change state before updating pin spacer (position changes due to fixed collapsing might occur.)
                        _util.css(pinTarget, {
                            "position": "fixed"
                        });
                        // update pin spacer
                        updatePinDimensions();
                    }
                    var fixedPos = _util.get.offset(_pinOptions.spacer, true), scrollDistance = _options.reverse || _options.duration === 0 ? containerInfo.scrollPos - _scrollOffset.start // quicker
                     : Math.round(_progress * _options.duration * 10) / 10; // if no reverse and during pin the position needs to be recalculated using the progress
                    // add scrollDistance
                    fixedPos[containerInfo.vertical ? "top" : "left"] += scrollDistance;
                    // set new values
                    _util.css(_pinOptions.spacer.firstChild, {
                        top: fixedPos.top,
                        left: fixedPos.left
                    });
                } else {
                    // unpinned state
                    var newCSS = {
                        position: _pinOptions.inFlow ? "relative" : "absolute",
                        top: 0,
                        left: 0
                    }, change = _util.css(pinTarget, "position") != newCSS.position;
                    if (!_pinOptions.pushFollowers) newCSS[containerInfo.vertical ? "top" : "left"] = _options.duration * _progress;
                    else if (_options.duration > 0) {
                        if (_state === SCENE_STATE_AFTER && parseFloat(_util.css(_pinOptions.spacer, "padding-top")) === 0) change = true; // if in after state but havent updated spacer yet (jumped past pin)
                        else if (_state === SCENE_STATE_BEFORE && parseFloat(_util.css(_pinOptions.spacer, "padding-bottom")) === 0) change = true; // jumped past fixed state upward direction
                    }
                    // set new values
                    _util.css(pinTarget, newCSS);
                    if (change) // update pin spacer if state changed
                    updatePinDimensions();
                }
            }
        };
        /**
		 * Update the pin spacer and/or element size.
		 * The size of the spacer needs to be updated whenever the duration of the scene changes, if it is to push down following elements.
		 * @private
		 */ var updatePinDimensions = function() {
            if (_pin && _controller && _pinOptions.inFlow) {
                var after = _state === SCENE_STATE_AFTER, before = _state === SCENE_STATE_BEFORE, during = _state === SCENE_STATE_DURING, vertical = _controller.info("vertical"), pinTarget = _pinOptions.spacer.firstChild, marginCollapse = _util.isMarginCollapseType(_util.css(_pinOptions.spacer, "display")), css = {};
                // set new size
                // if relsize: spacer -> pin | else: pin -> spacer
                if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) {
                    if (during) _util.css(_pin, {
                        "width": _util.get.width(_pinOptions.spacer)
                    });
                    else _util.css(_pin, {
                        "width": "100%"
                    });
                } else {
                    // minwidth is needed for cascaded pins.
                    css["min-width"] = _util.get.width(vertical ? _pin : pinTarget, true, true);
                    css.width = during ? css["min-width"] : "auto";
                }
                if (_pinOptions.relSize.height) {
                    if (during) // the only padding the spacer should ever include is the duration (if pushFollowers = true), so we need to substract that.
                    _util.css(_pin, {
                        "height": _util.get.height(_pinOptions.spacer) - (_pinOptions.pushFollowers ? _options.duration : 0)
                    });
                    else _util.css(_pin, {
                        "height": "100%"
                    });
                } else {
                    // margin is only included if it's a cascaded pin to resolve an IE9 bug
                    css["min-height"] = _util.get.height(vertical ? pinTarget : _pin, true, !marginCollapse); // needed for cascading pins
                    css.height = during ? css["min-height"] : "auto";
                }
                // add space for duration if pushFollowers is true
                if (_pinOptions.pushFollowers) {
                    css["padding" + (vertical ? "Top" : "Left")] = _options.duration * _progress;
                    css["padding" + (vertical ? "Bottom" : "Right")] = _options.duration * (1 - _progress);
                }
                _util.css(_pinOptions.spacer, css);
            }
        };
        /**
		 * Updates the Pin state (in certain scenarios)
		 * If the controller container is not the document and we are mid-pin-phase scrolling or resizing the main document can result to wrong pin positions.
		 * So this function is called on resize and scroll of the document.
		 * @private
		 */ var updatePinInContainer = function() {
            if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) updatePinState();
        };
        /**
		 * Updates the Pin spacer size state (in certain scenarios)
		 * If container is resized during pin and relatively sized the size of the pin might need to be updated...
		 * So this function is called on resize of the container.
		 * @private
		 */ var updateRelativePinSpacer = function() {
            if (_controller && _pin && // well, duh
            _state === SCENE_STATE_DURING && // element in pinned state?
            ((_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) && _util.get.width(window) != _util.get.width(_pinOptions.spacer.parentNode) || _pinOptions.relSize.height && _util.get.height(window) != _util.get.height(_pinOptions.spacer.parentNode))) updatePinDimensions();
        };
        /**
		 * Is called, when the mousewhel is used while over a pinned element inside a div container.
		 * If the scene is in fixed state scroll events would be counted towards the body. This forwards the event to the scroll container.
		 * @private
		 */ var onMousewheelOverPin = function(e) {
            if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) {
                e.preventDefault();
                _controller._setScrollPos(_controller.info("scrollPos") - ((e.wheelDelta || e[_controller.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"]) / 3 || -e.detail * 30));
            }
        };
        /**
		 * Pin an element for the duration of the scene.
		 * If the scene duration is 0 the element will only be unpinned, if the user scrolls back past the start position.  
		 * Make sure only one pin is applied to an element at the same time.
		 * An element can be pinned multiple times, but only successively.
		 * _**NOTE:** The option `pushFollowers` has no effect, when the scene duration is 0._
		 * @method ScrollMagic.Scene#setPin
		 * @example
		 * // pin element and push all following elements down by the amount of the pin duration.
		 * scene.setPin("#pin");
		 *
		 * // pin element and keeping all following elements in their place. The pinned element will move past them.
		 * scene.setPin("#pin", {pushFollowers: false});
		 *
		 * @param {(string|object)} element - A Selector targeting an element or a DOM object that is supposed to be pinned.
		 * @param {object} [settings] - settings for the pin
		 * @param {boolean} [settings.pushFollowers=true] - If `true` following elements will be "pushed" down for the duration of the pin, if `false` the pinned element will just scroll past them.  
		 												   Ignored, when duration is `0`.
		 * @param {string} [settings.spacerClass="scrollmagic-pin-spacer"] - Classname of the pin spacer element, which is used to replace the element.
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.setPin = function(element, settings) {
            var defaultSettings = {
                pushFollowers: true,
                spacerClass: "scrollmagic-pin-spacer"
            };
            var pushFollowersActivelySet = settings && settings.hasOwnProperty('pushFollowers');
            settings = _util.extend({}, defaultSettings, settings);
            // validate Element
            element = _util.get.elements(element)[0];
            if (!element) {
                log(1, "ERROR calling method 'setPin()': Invalid pin element supplied.");
                return Scene; // cancel
            } else if (_util.css(element, "position") === "fixed") {
                log(1, "ERROR calling method 'setPin()': Pin does not work with elements that are positioned 'fixed'.");
                return Scene; // cancel
            }
            if (_pin) {
                if (_pin === element) // same pin we already have -> do nothing
                return Scene; // cancel
                else // kill old pin
                Scene.removePin();
            }
            _pin = element;
            var parentDisplay = _pin.parentNode.style.display, boundsParams = [
                "top",
                "left",
                "bottom",
                "right",
                "margin",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom"
            ];
            _pin.parentNode.style.display = 'none'; // hack start to force css to return stylesheet values instead of calculated px values.
            var inFlow = _util.css(_pin, "position") != "absolute", pinCSS = _util.css(_pin, boundsParams.concat([
                "display"
            ])), sizeCSS = _util.css(_pin, [
                "width",
                "height"
            ]);
            _pin.parentNode.style.display = parentDisplay; // hack end.
            if (!inFlow && settings.pushFollowers) {
                log(2, "WARNING: If the pinned element is positioned absolutely pushFollowers will be disabled.");
                settings.pushFollowers = false;
            }
            window.setTimeout(function() {
                if (_pin && _options.duration === 0 && pushFollowersActivelySet && settings.pushFollowers) log(2, "WARNING: pushFollowers =", true, "has no effect, when scene duration is 0.");
            }, 0);
            // create spacer and insert
            var spacer = _pin.parentNode.insertBefore(document.createElement('div'), _pin), spacerCSS = _util.extend(pinCSS, {
                position: inFlow ? "relative" : "absolute",
                boxSizing: "content-box",
                mozBoxSizing: "content-box",
                webkitBoxSizing: "content-box"
            });
            if (!inFlow) _util.extend(spacerCSS, _util.css(_pin, [
                "width",
                "height"
            ]));
            _util.css(spacer, spacerCSS);
            spacer.setAttribute(PIN_SPACER_ATTRIBUTE, "");
            _util.addClass(spacer, settings.spacerClass);
            // set the pin Options
            _pinOptions = {
                spacer: spacer,
                relSize: {
                    width: sizeCSS.width.slice(-1) === "%",
                    height: sizeCSS.height.slice(-1) === "%",
                    autoFullWidth: sizeCSS.width === "auto" && inFlow && _util.isMarginCollapseType(pinCSS.display)
                },
                pushFollowers: settings.pushFollowers,
                inFlow: inFlow
            };
            if (!_pin.___origStyle) {
                _pin.___origStyle = {};
                var pinInlineCSS = _pin.style, copyStyles = boundsParams.concat([
                    "width",
                    "height",
                    "position",
                    "boxSizing",
                    "mozBoxSizing",
                    "webkitBoxSizing"
                ]);
                copyStyles.forEach(function(val) {
                    _pin.___origStyle[val] = pinInlineCSS[val] || "";
                });
            }
            // if relative size, transfer it to spacer and make pin calculate it...
            if (_pinOptions.relSize.width) _util.css(spacer, {
                width: sizeCSS.width
            });
            if (_pinOptions.relSize.height) _util.css(spacer, {
                height: sizeCSS.height
            });
            // now place the pin element inside the spacer	
            spacer.appendChild(_pin);
            // and set new css
            _util.css(_pin, {
                position: inFlow ? "relative" : "absolute",
                margin: "auto",
                top: "auto",
                left: "auto",
                bottom: "auto",
                right: "auto"
            });
            if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) _util.css(_pin, {
                boxSizing: "border-box",
                mozBoxSizing: "border-box",
                webkitBoxSizing: "border-box"
            });
            // add listener to document to update pin position in case controller is not the document.
            window.addEventListener('scroll', updatePinInContainer);
            window.addEventListener('resize', updatePinInContainer);
            window.addEventListener('resize', updateRelativePinSpacer);
            // add mousewheel listener to catch scrolls over fixed elements
            _pin.addEventListener("mousewheel", onMousewheelOverPin);
            _pin.addEventListener("DOMMouseScroll", onMousewheelOverPin);
            log(3, "added pin");
            // finally update the pin to init
            updatePinState();
            return Scene;
        };
        /**
		 * Remove the pin from the scene.
		 * @method ScrollMagic.Scene#removePin
		 * @example
		 * // remove the pin from the scene without resetting it (the spacer is not removed)
		 * scene.removePin();
		 *
		 * // remove the pin from the scene and reset the pin element to its initial position (spacer is removed)
		 * scene.removePin(true);
		 *
		 * @param {boolean} [reset=false] - If `false` the spacer will not be removed and the element's position will not be reset.
		 * @returns {Scene} Parent object for chaining.
		 */ this.removePin = function(reset) {
            if (_pin) {
                if (_state === SCENE_STATE_DURING) updatePinState(true); // force unpin at position
                if (reset || !_controller) {
                    var pinTarget = _pinOptions.spacer.firstChild; // usually the pin element, but may be another spacer (cascaded pins)...
                    if (pinTarget.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
                        var style = _pinOptions.spacer.style, values = [
                            "margin",
                            "marginLeft",
                            "marginRight",
                            "marginTop",
                            "marginBottom"
                        ], margins = {};
                        values.forEach(function(val) {
                            margins[val] = style[val] || "";
                        });
                        _util.css(pinTarget, margins);
                    }
                    _pinOptions.spacer.parentNode.insertBefore(pinTarget, _pinOptions.spacer);
                    _pinOptions.spacer.parentNode.removeChild(_pinOptions.spacer);
                    if (!_pin.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
                        // TODO: only correctly set for first pin (when cascading) - how to fix?
                        _util.css(_pin, _pin.___origStyle);
                        delete _pin.___origStyle;
                    }
                }
                window.removeEventListener('scroll', updatePinInContainer);
                window.removeEventListener('resize', updatePinInContainer);
                window.removeEventListener('resize', updateRelativePinSpacer);
                _pin.removeEventListener("mousewheel", onMousewheelOverPin);
                _pin.removeEventListener("DOMMouseScroll", onMousewheelOverPin);
                _pin = undefined;
                log(3, "removed pin (reset: " + (reset ? "true" : "false") + ")");
            }
            return Scene;
        };
        var _cssClasses, _cssClassElems = [];
        Scene.on("destroy.internal", function(e) {
            Scene.removeClassToggle(e.reset);
        });
        /**
		 * Define a css class modification while the scene is active.  
		 * When the scene triggers the classes will be added to the supplied element and removed, when the scene is over.
		 * If the scene duration is 0 the classes will only be removed if the user scrolls back past the start position.
		 * @method ScrollMagic.Scene#setClassToggle
		 * @example
		 * // add the class 'myclass' to the element with the id 'my-elem' for the duration of the scene
		 * scene.setClassToggle("#my-elem", "myclass");
		 *
		 * // add multiple classes to multiple elements defined by the selector '.classChange'
		 * scene.setClassToggle(".classChange", "class1 class2 class3");
		 *
		 * @param {(string|object)} element - A Selector targeting one or more elements or a DOM object that is supposed to be modified.
		 * @param {string} classes - One or more Classnames (separated by space) that should be added to the element during the scene.
		 *
		 * @returns {Scene} Parent object for chaining.
		 */ this.setClassToggle = function(element, classes) {
            var elems = _util.get.elements(element);
            if (elems.length === 0 || !_util.type.String(classes)) {
                log(1, "ERROR calling method 'setClassToggle()': Invalid " + (elems.length === 0 ? "element" : "classes") + " supplied.");
                return Scene;
            }
            if (_cssClassElems.length > 0) // remove old ones
            Scene.removeClassToggle();
            _cssClasses = classes;
            _cssClassElems = elems;
            Scene.on("enter.internal_class leave.internal_class", function(e) {
                var toggle = e.type === "enter" ? _util.addClass : _util.removeClass;
                _cssClassElems.forEach(function(elem, key) {
                    toggle(elem, _cssClasses);
                });
            });
            return Scene;
        };
        /**
		 * Remove the class binding from the scene.
		 * @method ScrollMagic.Scene#removeClassToggle
		 * @example
		 * // remove class binding from the scene without reset
		 * scene.removeClassToggle();
		 *
		 * // remove class binding and remove the changes it caused
		 * scene.removeClassToggle(true);
		 *
		 * @param {boolean} [reset=false] - If `false` and the classes are currently active, they will remain on the element. If `true` they will be removed.
		 * @returns {Scene} Parent object for chaining.
		 */ this.removeClassToggle = function(reset) {
            if (reset) _cssClassElems.forEach(function(elem, key) {
                _util.removeClass(elem, _cssClasses);
            });
            Scene.off("start.internal_class end.internal_class");
            _cssClasses = undefined;
            _cssClassElems = [];
            return Scene;
        };
        // INIT
        construct();
        return Scene;
    };
    // store pagewide scene options
    var SCENE_OPTIONS = {
        defaults: {
            duration: 0,
            offset: 0,
            triggerElement: undefined,
            triggerHook: 0.5,
            reverse: true,
            loglevel: 2
        },
        validate: {
            offset: function(val) {
                val = parseFloat(val);
                if (!_util.type.Number(val)) throw [
                    "Invalid value for option \"offset\":",
                    val
                ];
                return val;
            },
            triggerElement: function(val) {
                val = val || undefined;
                if (val) {
                    var elem = _util.get.elements(val)[0];
                    if (elem && elem.parentNode) val = elem;
                    else throw [
                        "Element defined in option \"triggerElement\" was not found:",
                        val
                    ];
                }
                return val;
            },
            triggerHook: function(val) {
                var translate = {
                    "onCenter": 0.5,
                    "onEnter": 1,
                    "onLeave": 0
                };
                if (_util.type.Number(val)) val = Math.max(0, Math.min(parseFloat(val), 1)); //  make sure its betweeen 0 and 1
                else if (val in translate) val = translate[val];
                else throw [
                    "Invalid value for option \"triggerHook\": ",
                    val
                ];
                return val;
            },
            reverse: function(val) {
                return !!val; // force boolean
            },
            loglevel: function(val) {
                val = parseInt(val);
                if (!_util.type.Number(val) || val < 0 || val > 3) throw [
                    "Invalid value for option \"loglevel\":",
                    val
                ];
                return val;
            }
        },
        shifts: [
            "duration",
            "offset",
            "triggerHook"
        ]
    };
    /*
	 * method used to add an option to ScrollMagic Scenes.
	 * TODO: DOC (private for dev)
	 */ ScrollMagic.Scene.addOption = function(name, defaultValue, validationCallback, shifts) {
        if (!(name in SCENE_OPTIONS.defaults)) {
            SCENE_OPTIONS.defaults[name] = defaultValue;
            SCENE_OPTIONS.validate[name] = validationCallback;
            if (shifts) SCENE_OPTIONS.shifts.push(name);
        } else ScrollMagic._util.log(1, "[static] ScrollMagic.Scene -> Cannot add Scene option '" + name + "', because it already exists.");
    };
    // instance extension function for plugins
    // TODO: DOC (private for dev)
    ScrollMagic.Scene.extend = function(extension) {
        var oldClass = this;
        ScrollMagic.Scene = function() {
            oldClass.apply(this, arguments);
            this.$super = _util.extend({}, this); // copy parent state
            return extension.apply(this, arguments) || this;
        };
        _util.extend(ScrollMagic.Scene, oldClass); // copy properties
        ScrollMagic.Scene.prototype = oldClass.prototype; // copy prototype
        ScrollMagic.Scene.prototype.constructor = ScrollMagic.Scene; // restore constructor
    };
    /**
	 * TODO: DOCS (private for dev)
	 * @class
	 * @private
	 */ ScrollMagic.Event = function(type, namespace, target, vars) {
        vars = vars || {};
        for(var key in vars)this[key] = vars[key];
        this.type = type;
        this.target = this.currentTarget = target;
        this.namespace = namespace || '';
        this.timeStamp = this.timestamp = Date.now();
        return this;
    };
    /*
	 * TODO: DOCS (private for dev)
	 */ var _util = ScrollMagic._util = function(window1) {
        var U = {}, i;
        /**
		 * ------------------------------
		 * internal helpers
		 * ------------------------------
		 */ // parse float and fall back to 0.
        var floatval = function(number) {
            return parseFloat(number) || 0;
        };
        // get current style IE safe (otherwise IE would return calculated values for 'auto')
        var _getComputedStyle = function(elem) {
            return elem.currentStyle ? elem.currentStyle : window1.getComputedStyle(elem);
        };
        // get element dimension (width or height)
        var _dimension = function(which, elem, outer, includeMargin) {
            elem = elem === document ? window1 : elem;
            if (elem === window1) includeMargin = false;
            else if (!_type.DomElement(elem)) return 0;
            which = which.charAt(0).toUpperCase() + which.substr(1).toLowerCase();
            var dimension = (outer ? elem['offset' + which] || elem['outer' + which] : elem['client' + which] || elem['inner' + which]) || 0;
            if (outer && includeMargin) {
                var style = _getComputedStyle(elem);
                dimension += which === 'Height' ? floatval(style.marginTop) + floatval(style.marginBottom) : floatval(style.marginLeft) + floatval(style.marginRight);
            }
            return dimension;
        };
        // converts 'margin-top' into 'marginTop'
        var _camelCase = function(str) {
            return str.replace(/^[^a-z]+([a-z])/g, '$1').replace(/-([a-z])/g, function(g) {
                return g[1].toUpperCase();
            });
        };
        /**
		 * ------------------------------
		 * external helpers
		 * ------------------------------
		 */ // extend obj – same as jQuery.extend({}, objA, objB)
        U.extend = function(obj) {
            obj = obj || {};
            for(i = 1; i < arguments.length; i++){
                if (!arguments[i]) continue;
                for(var key in arguments[i])if (arguments[i].hasOwnProperty(key)) obj[key] = arguments[i][key];
            }
            return obj;
        };
        // check if a css display type results in margin-collapse or not
        U.isMarginCollapseType = function(str) {
            return [
                "block",
                "flex",
                "list-item",
                "table",
                "-webkit-box"
            ].indexOf(str) > -1;
        };
        // implementation of requestAnimationFrame
        // based on https://gist.github.com/paulirish/1579671
        var lastTime = 0, vendors = [
            'ms',
            'moz',
            'webkit',
            'o'
        ];
        var _requestAnimationFrame = window1.requestAnimationFrame;
        var _cancelAnimationFrame = window1.cancelAnimationFrame;
        // try vendor prefixes if the above doesn't work
        for(i = 0; !_requestAnimationFrame && i < vendors.length; ++i){
            _requestAnimationFrame = window1[vendors[i] + 'RequestAnimationFrame'];
            _cancelAnimationFrame = window1[vendors[i] + 'CancelAnimationFrame'] || window1[vendors[i] + 'CancelRequestAnimationFrame'];
        }
        // fallbacks
        if (!_requestAnimationFrame) _requestAnimationFrame = function(callback) {
            var currTime = new Date().getTime(), timeToCall = Math.max(0, 16 - (currTime - lastTime)), id = window1.setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
        if (!_cancelAnimationFrame) _cancelAnimationFrame = function(id) {
            window1.clearTimeout(id);
        };
        U.rAF = _requestAnimationFrame.bind(window1);
        U.cAF = _cancelAnimationFrame.bind(window1);
        var loglevels = [
            "error",
            "warn",
            "log"
        ], console = window1.console || {};
        console.log = console.log || function() {}; // no console log, well - do nothing then...
        // make sure methods for all levels exist.
        for(i = 0; i < loglevels.length; i++){
            var method = loglevels[i];
            if (!console[method]) console[method] = console.log; // prefer .log over nothing
        }
        U.log = function(loglevel) {
            if (loglevel > loglevels.length || loglevel <= 0) loglevel = loglevels.length;
            var now = new Date(), time = ("0" + now.getHours()).slice(-2) + ":" + ("0" + now.getMinutes()).slice(-2) + ":" + ("0" + now.getSeconds()).slice(-2) + ":" + ("00" + now.getMilliseconds()).slice(-3), method = loglevels[loglevel - 1], args = Array.prototype.splice.call(arguments, 1), func = Function.prototype.bind.call(console[method], console);
            args.unshift(time);
            func.apply(console, args);
        };
        /**
		 * ------------------------------
		 * type testing
		 * ------------------------------
		 */ var _type = U.type = function(v) {
            return Object.prototype.toString.call(v).replace(/^\[object (.+)\]$/, "$1").toLowerCase();
        };
        _type.String = function(v) {
            return _type(v) === 'string';
        };
        _type.Function = function(v) {
            return _type(v) === 'function';
        };
        _type.Array = function(v) {
            return Array.isArray(v);
        };
        _type.Number = function(v) {
            return !_type.Array(v) && v - parseFloat(v) + 1 >= 0;
        };
        _type.DomElement = function(o) {
            return typeof HTMLElement === "object" || typeof HTMLElement === "function" ? o instanceof HTMLElement || o instanceof SVGElement : o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string";
        };
        /**
		 * ------------------------------
		 * DOM Element info
		 * ------------------------------
		 */ // always returns a list of matching DOM elements, from a selector, a DOM element or an list of elements or even an array of selectors
        var _get = U.get = {};
        _get.elements = function(selector) {
            var arr = [];
            if (_type.String(selector)) try {
                selector = document.querySelectorAll(selector);
            } catch (e) {
                return arr;
            }
            if (_type(selector) === 'nodelist' || _type.Array(selector) || selector instanceof NodeList) for(var i = 0, ref = arr.length = selector.length; i < ref; i++){
                var elem = selector[i];
                arr[i] = _type.DomElement(elem) ? elem : _get.elements(elem); // if not an element, try to resolve recursively
            }
            else if (_type.DomElement(selector) || selector === document || selector === window1) arr = [
                selector
            ]; // only the element
            return arr;
        };
        // get scroll top value
        _get.scrollTop = function(elem) {
            return elem && typeof elem.scrollTop === 'number' ? elem.scrollTop : window1.pageYOffset || 0;
        };
        // get scroll left value
        _get.scrollLeft = function(elem) {
            return elem && typeof elem.scrollLeft === 'number' ? elem.scrollLeft : window1.pageXOffset || 0;
        };
        // get element height
        _get.width = function(elem, outer, includeMargin) {
            return _dimension('width', elem, outer, includeMargin);
        };
        // get element width
        _get.height = function(elem, outer, includeMargin) {
            return _dimension('height', elem, outer, includeMargin);
        };
        // get element position (optionally relative to viewport)
        _get.offset = function(elem, relativeToViewport) {
            var offset = {
                top: 0,
                left: 0
            };
            if (elem && elem.getBoundingClientRect) {
                var rect = elem.getBoundingClientRect();
                offset.top = rect.top;
                offset.left = rect.left;
                if (!relativeToViewport) {
                    offset.top += _get.scrollTop();
                    offset.left += _get.scrollLeft();
                }
            }
            return offset;
        };
        /**
		 * ------------------------------
		 * DOM Element manipulation
		 * ------------------------------
		 */ U.addClass = function(elem, classname) {
            if (classname) {
                if (elem.classList) elem.classList.add(classname);
                else elem.className += ' ' + classname;
            }
        };
        U.removeClass = function(elem, classname) {
            if (classname) {
                if (elem.classList) elem.classList.remove(classname);
                else elem.className = elem.className.replace(new RegExp('(^|\\b)' + classname.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        };
        // if options is string -> returns css value
        // if options is array -> returns object with css value pairs
        // if options is object -> set new css values
        U.css = function(elem, options) {
            if (_type.String(options)) return _getComputedStyle(elem)[_camelCase(options)];
            else if (_type.Array(options)) {
                var obj = {}, style = _getComputedStyle(elem);
                options.forEach(function(option, key) {
                    obj[option] = style[_camelCase(option)];
                });
                return obj;
            } else for(var option in options){
                var val = options[option];
                if (val == parseFloat(val)) val += 'px';
                elem.style[_camelCase(option)] = val;
            }
        };
        return U;
    }(window || {});
    ScrollMagic.Scene.prototype.addIndicators = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling addIndicators() due to missing Plugin \'debug.addIndicators\'. Please make sure to include plugins/debug.addIndicators.js');
        return this;
    };
    ScrollMagic.Scene.prototype.removeIndicators = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeIndicators() due to missing Plugin \'debug.addIndicators\'. Please make sure to include plugins/debug.addIndicators.js');
        return this;
    };
    ScrollMagic.Scene.prototype.setTween = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling setTween() due to missing Plugin \'animation.gsap\'. Please make sure to include plugins/animation.gsap.js');
        return this;
    };
    ScrollMagic.Scene.prototype.removeTween = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeTween() due to missing Plugin \'animation.gsap\'. Please make sure to include plugins/animation.gsap.js');
        return this;
    };
    ScrollMagic.Scene.prototype.setVelocity = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling setVelocity() due to missing Plugin \'animation.velocity\'. Please make sure to include plugins/animation.velocity.js');
        return this;
    };
    ScrollMagic.Scene.prototype.removeVelocity = function() {
        ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeVelocity() due to missing Plugin \'animation.velocity\'. Please make sure to include plugins/animation.velocity.js');
        return this;
    };
    return ScrollMagic;
});


const $5e953b8f37931d32$var$Form = ({ buttonLabel: buttonLabel, classNameButton: classNameButton, classNameField: classNameField, classNameContainer: classNameContainer = (0, (/*@__PURE__*/$parcel$interopDefault($907aa1317a74c843$exports))).form, fields: fields, onSubmit: onSubmit, onSuccess: onSuccess, onChange: onChange, withHiddenSubmitButton: withHiddenSubmitButton = false, withExpandingLine: withExpandingLine = false })=>{
    const [values, setValues] = (0, $jiXHd.useState)({});
    const [errors, setErrors] = (0, $jiXHd.useState)([]);
    const [submitting, setSubmitting] = (0, $jiXHd.useState)(false);
    const line = (0, $jiXHd.useRef)();
    const handleChange = (event)=>{
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
        const hasError = errorDetail(event.target.name) !== null;
        if (hasError) setErrors({
            ...errors,
            [event.target.name]: null
        });
        if (withHiddenSubmitButton) onChange(event);
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        setErrors([]);
        setSubmitting(true);
        onSubmit(values).then((response)=>{
            if (response.ok) {
                setValues({});
                onSuccess();
                return;
            }
            response?.json().then((data)=>{
                if (data.errors.length > 0) setErrors(data.errors);
            });
        }).catch((err)=>{
            console.error({
                err: err
            });
        }).finally(()=>{
            setSubmitting(false);
        });
    };
    const errorDetail = (id)=>{
        if (errors.length > 0) {
            const error = errors.find((error)=>error.id === id);
            if (error) return error.detail;
        }
        return null;
    };
    (0, $jiXHd.useEffect)(()=>{
        if (withExpandingLine) {
            const controller = new (0, (/*@__PURE__*/$parcel$interopDefault($4153dfb849ed43f5$exports))).Controller();
            const scene = new (0, (/*@__PURE__*/$parcel$interopDefault($4153dfb849ed43f5$exports))).Scene({
                triggerElement: line.current,
                offset: 0 - window.innerHeight / 2
            }).setClassToggle(line.current, (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($907aa1317a74c843$exports))).lineShow)).addTo(controller);
        }
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))(classNameContainer),
        onSubmit: handleSubmit
    }, fields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f3218a61ba395453$export$2e2bcd8739ae039), {
            key: field.name,
            ...field,
            value: values[field.name] || "",
            error: errorDetail(field.name),
            onChange: handleChange,
            className: classNameField
        })), withExpandingLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($907aa1317a74c843$exports))).line),
        ref: line
    }), errorDetail(undefined) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($907aa1317a74c843$exports))).baseErrorText
    }, "Something went wrong, please try again."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $b2258b1b83b775f2$export$2e2bcd8739ae039), {
        label: buttonLabel,
        disabled: submitting,
        className: classNameButton
    }));
};
var $5e953b8f37931d32$export$2e2bcd8739ae039 = $5e953b8f37931d32$var$Form;



var $jiXHd = parcelRequire("jiXHd");

var $fe94b4babebd711c$exports = {};

$parcel$export($fe94b4babebd711c$exports, "heading", function () { return $fe94b4babebd711c$export$46e4a324ac90507f; }, function (v) { return $fe94b4babebd711c$export$46e4a324ac90507f = v; });
$parcel$export($fe94b4babebd711c$exports, "light", function () { return $fe94b4babebd711c$export$a43af521ac8c3202; }, function (v) { return $fe94b4babebd711c$export$a43af521ac8c3202 = v; });
var $fe94b4babebd711c$export$46e4a324ac90507f;
var $fe94b4babebd711c$export$a43af521ac8c3202;
$fe94b4babebd711c$export$46e4a324ac90507f = "_app-components-Heading-_styles__heading";
$fe94b4babebd711c$export$a43af521ac8c3202 = "_app-components-Heading-_styles__light";


// Displays a styled heading, currently only really intended for h1-h3.
// TODO: get the heading styles for h1-h6 from client in more detail.
const $17cd0eb7cfcb3363$var$Heading = ({ level: level = '1', children: children, light: light, className: className })=>{
    const Tag = `h${level}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement(Tag, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($fe94b4babebd711c$exports))).heading, {
            [(0, (/*@__PURE__*/$parcel$interopDefault($fe94b4babebd711c$exports)))['light']]: light
        }, className)
    }, children);
};
var $17cd0eb7cfcb3363$export$2e2bcd8739ae039 = $17cd0eb7cfcb3363$var$Heading;





var $jiXHd = parcelRequire("jiXHd");

var $27c25a7addb3cd0a$exports = {};

$parcel$export($27c25a7addb3cd0a$exports, "logo", function () { return $27c25a7addb3cd0a$export$db3c28d99448dcff; }, function (v) { return $27c25a7addb3cd0a$export$db3c28d99448dcff = v; });
$parcel$export($27c25a7addb3cd0a$exports, "hidden", function () { return $27c25a7addb3cd0a$export$73920f18ca706874; }, function (v) { return $27c25a7addb3cd0a$export$73920f18ca706874 = v; });
$parcel$export($27c25a7addb3cd0a$exports, "topPath", function () { return $27c25a7addb3cd0a$export$1e80c203db7bfaf0; }, function (v) { return $27c25a7addb3cd0a$export$1e80c203db7bfaf0 = v; });
$parcel$export($27c25a7addb3cd0a$exports, "topAnimating", function () { return $27c25a7addb3cd0a$export$6533b2ee733d741b; }, function (v) { return $27c25a7addb3cd0a$export$6533b2ee733d741b = v; });
$parcel$export($27c25a7addb3cd0a$exports, "circlePath", function () { return $27c25a7addb3cd0a$export$f3ea4332080b36fb; }, function (v) { return $27c25a7addb3cd0a$export$f3ea4332080b36fb = v; });
$parcel$export($27c25a7addb3cd0a$exports, "circleAnimating", function () { return $27c25a7addb3cd0a$export$1253a914f93acef5; }, function (v) { return $27c25a7addb3cd0a$export$1253a914f93acef5 = v; });
var $27c25a7addb3cd0a$export$db3c28d99448dcff;
var $27c25a7addb3cd0a$export$73920f18ca706874;
var $27c25a7addb3cd0a$export$1e80c203db7bfaf0;
var $27c25a7addb3cd0a$export$6533b2ee733d741b;
var $27c25a7addb3cd0a$export$f3ea4332080b36fb;
var $27c25a7addb3cd0a$export$1253a914f93acef5;
$27c25a7addb3cd0a$export$db3c28d99448dcff = "_app-components-LogoTRasterInquire-_styles__logo";
$27c25a7addb3cd0a$export$73920f18ca706874 = "_app-components-LogoTRasterInquire-_styles__hidden";
$27c25a7addb3cd0a$export$1e80c203db7bfaf0 = "_app-components-LogoTRasterInquire-_styles__topPath";
$27c25a7addb3cd0a$export$6533b2ee733d741b = "_app-components-LogoTRasterInquire-_styles__topAnimating";
$27c25a7addb3cd0a$export$f3ea4332080b36fb = "_app-components-LogoTRasterInquire-_styles__circlePath";
$27c25a7addb3cd0a$export$1253a914f93acef5 = "_app-components-LogoTRasterInquire-_styles__circleAnimating";



var $fd66f5d8df143174$exports = {};
$fd66f5d8df143174$exports = $parcel$resolve("6F8OB");


const $deecaa6c65a98f36$var$LogoTTopUrl = new URL($fd66f5d8df143174$exports);
var $b987ec1835c3ff9a$exports = {};
$b987ec1835c3ff9a$exports = $parcel$resolve("dOLao");


const $deecaa6c65a98f36$var$LogoTCircleUrl = new URL($b987ec1835c3ff9a$exports);
class $deecaa6c65a98f36$var$LogoTRasterInquire extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {
        let tl = (0, $36b3090cb6608e8f$export$99ee26438460406a).timeline();
        tl.to(this._topPath, {
            scaleX: 1,
            duration: 1.2,
            delay: .3
        });
        tl.to(this._circlePath, {
            scale: 1,
            duration: 1.2,
            delay: "-1.2"
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($27c25a7addb3cd0a$exports))).logo, (0, (/*@__PURE__*/$parcel$interopDefault($27c25a7addb3cd0a$exports))).hidden),
            ref: (c)=>{
                this._el = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            ref: (c)=>{
                this._topPath = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($27c25a7addb3cd0a$exports))).topPath),
            src: $deecaa6c65a98f36$var$LogoTTopUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            ref: (c)=>{
                this._circlePath = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($27c25a7addb3cd0a$exports))).circlePath),
            src: $deecaa6c65a98f36$var$LogoTCircleUrl
        }));
    }
}
var $deecaa6c65a98f36$export$2e2bcd8739ae039 = $deecaa6c65a98f36$var$LogoTRasterInquire;



const $b05fdcb39db176db$export$650cc1adfbebd6d7 = {
    fields: [
        {
            label: "Name",
            component: "input",
            name: "name",
            attrs: {
                placeholder: "Name"
            }
        },
        {
            label: "Email",
            component: "input",
            name: "email",
            attrs: {
                type: "email",
                placeholder: "Email"
            }
        },
        {
            label: "Location",
            component: "input",
            name: "location",
            attrs: {
                type: "location",
                placeholder: "City, Country"
            }
        },
        {
            label: "Message",
            component: "textarea",
            name: "message",
            attrs: {
                placeholder: "How can we help?",
                rows: 5
            }
        }
    ],
    callback: (values)=>{
        return new Promise((resolve, reject)=>{
            window.grecaptcha.ready(()=>{
                window.grecaptcha.execute("6LfV4hUnAAAAAIwwq6GZuFlw3B8tcd1z7sOpVjwZ", {
                    action: 'submit'
                }).then((token)=>{
                    values.token = token;
                    fetch("/api/submitContactForm", {
                        method: "POST",
                        cache: "no-cache",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(values)
                    }).then(resolve, reject);
                });
            });
        });
    }
};




const $6558741a40a6102b$var$backgroundUrl = new URL($f08fcdce49270724$exports);
class $6558741a40a6102b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        isFormSubmitted: false
    };
    componentDidMount() {
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this._el, {
            opacity: 1,
            duration: 2
        });
    }
    handleFormSuccess = ()=>{
        this.setState({
            isFormSubmitted: true
        });
    };
    renderForm = ()=>{
        if (!this.state.isFormSubmitted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $5e953b8f37931d32$export$2e2bcd8739ae039), {
            fields: (0, $b05fdcb39db176db$export$650cc1adfbebd6d7).fields,
            buttonLabel: "Send",
            onSubmit: (0, $b05fdcb39db176db$export$650cc1adfbebd6d7).callback,
            onSuccess: this.handleFormSuccess
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($41351eb782856059$exports))).submitMessage)
        }, "Thanks for contacting us, we\u2019ll be in touch");
    };
    render() {
        const meta = {
            title: "Contact",
            description: "Contact us to configure, quote and customize your BLACKWING7 lens set."
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f7489db668f41cb3$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("title", null, meta.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("meta", {
            name: "description",
            content: meta.description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("link", {
            rel: "canonical",
            href: `${window.location.origin}/contact`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $35950112c9f1df8b$export$2e2bcd8739ae039), {
            src: $6558741a40a6102b$var$backgroundUrl,
            className: "bg",
            readyClassName: "bgReady"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: "sectionInner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($41351eb782856059$exports))).page),
            ref: (c)=>{
                this._el = c;
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("section", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($41351eb782856059$exports))).body)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $17cd0eb7cfcb3363$export$2e2bcd8739ae039), {
            level: "1",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($41351eb782856059$exports))).contactFormHeader)
        }, "Contact us"), this.renderForm()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $deecaa6c65a98f36$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($41351eb782856059$exports))).socialMediaLinks)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $17cd0eb7cfcb3363$export$2e2bcd8739ae039), {
            level: "1",
            light: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "https://www.instagram.com/7isatribe/",
            target: "_blank"
        }, "Instagram", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($41351eb782856059$exports))).credits
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($41351eb782856059$exports))).creditsItems
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "/termsandconditions"
        }, "TERMS & CONDITIONS"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "https://www.instagram.com/osk.co",
            target: "_blank"
        }, "SITE BY ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "OSK")))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($41351eb782856059$exports))).recaptchaLinks)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("small", null, "This site is protected by reCAPTCHA and the Google ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "https://policies.google.com/privacy"
        }, "Privacy Policy"), " and ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "https://policies.google.com/terms"
        }, "Terms of Service"), " apply."))));
    }
}



var $jiXHd = parcelRequire("jiXHd");


var $3cd6a95b0d5face1$exports = {};

$parcel$export($3cd6a95b0d5face1$exports, "header", function () { return $3cd6a95b0d5face1$export$38e42c68cf43b5d4; }, function (v) { return $3cd6a95b0d5face1$export$38e42c68cf43b5d4 = v; });
$parcel$export($3cd6a95b0d5face1$exports, "page", function () { return $3cd6a95b0d5face1$export$523fb3936f49e028; }, function (v) { return $3cd6a95b0d5face1$export$523fb3936f49e028 = v; });
$parcel$export($3cd6a95b0d5face1$exports, "list", function () { return $3cd6a95b0d5face1$export$8837f4fc672e936d; }, function (v) { return $3cd6a95b0d5face1$export$8837f4fc672e936d = v; });
$parcel$export($3cd6a95b0d5face1$exports, "footer", function () { return $3cd6a95b0d5face1$export$adb608be33961c98; }, function (v) { return $3cd6a95b0d5face1$export$adb608be33961c98 = v; });
$parcel$export($3cd6a95b0d5face1$exports, "bg", function () { return $3cd6a95b0d5face1$export$136fd86de524d3c2; }, function (v) { return $3cd6a95b0d5face1$export$136fd86de524d3c2 = v; });
$parcel$export($3cd6a95b0d5face1$exports, "bgReady", function () { return $3cd6a95b0d5face1$export$2eddb9afc6c2340f; }, function (v) { return $3cd6a95b0d5face1$export$2eddb9afc6c2340f = v; });
var $3cd6a95b0d5face1$export$38e42c68cf43b5d4;
var $3cd6a95b0d5face1$export$523fb3936f49e028;
var $3cd6a95b0d5face1$export$8837f4fc672e936d;
var $3cd6a95b0d5face1$export$adb608be33961c98;
var $3cd6a95b0d5face1$export$136fd86de524d3c2;
var $3cd6a95b0d5face1$export$2eddb9afc6c2340f;
$3cd6a95b0d5face1$export$38e42c68cf43b5d4 = "_app-views-TermsAndConditions-_styles__header";
$3cd6a95b0d5face1$export$523fb3936f49e028 = "_app-views-TermsAndConditions-_styles__page";
$3cd6a95b0d5face1$export$8837f4fc672e936d = "_app-views-TermsAndConditions-_styles__list";
$3cd6a95b0d5face1$export$adb608be33961c98 = "_app-views-TermsAndConditions-_styles__footer";
$3cd6a95b0d5face1$export$136fd86de524d3c2 = "_app-views-TermsAndConditions-_styles__bg";
$3cd6a95b0d5face1$export$2eddb9afc6c2340f = "_app-views-TermsAndConditions-_styles__bgReady";







const $d9a0ccacb9275e58$var$backgroundUrl = new URL($f08fcdce49270724$exports);
class $d9a0ccacb9275e58$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    componentDidMount() {
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to([
            this._header
        ], {
            duration: 1.2,
            opacity: 1,
            stagger: '0.2'
        });
        (0, $36b3090cb6608e8f$export$99ee26438460406a).to([
            this.list
        ], {
            duration: .5,
            opacity: 1,
            y: 0,
            stagger: '0.03',
            delay: .35
        });
    }
    render() {
        const meta = {
            title: "Terms & Conditions",
            description: "Sales, shipping, warranty and returns terms. The small print."
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f7489db668f41cb3$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("title", null, meta.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("meta", {
            name: "description",
            content: meta.description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("link", {
            rel: "canonical",
            href: `${window.location.origin}/termsandconditions`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $35950112c9f1df8b$export$2e2bcd8739ae039), {
            src: $d9a0ccacb9275e58$var$backgroundUrl,
            className: 'bg',
            readyClassName: 'bgReady'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($3cd6a95b0d5face1$exports))).page)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: (c)=>{
                this._header = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($3cd6a95b0d5face1$exports))).header)
        }, "TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC TERMS AND CONDITIONS"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("ol", {
            ref: (c)=>{
                this.list = c;
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($3cd6a95b0d5face1$exports))).list)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("h3", null, "Prices and Quoting"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Quotes are valid for one month from date of issue. Price changes will only apply to orders placed after the date of change. Quotes and invoices do not include VAT, shipping, storage, customs duties or local taxes (where applicable). All prices are subject to change.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("h3", null, "Pre-orders and Order Acceptance"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Under these terms, an order is an offer to buy products listed in a Quote. Orders will be accepted with a deposit. A set of lenses may be delivered in stages. Lead-time for the first delivery varies and a lead-time estimate will be provided at the time of quoting. Deposits will be held until the last shipment. Lead-times are subject to change."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC requires, at minimum, a valid contact name, billing address, and email for all transactions. While we try to ensure accuracy, we reserve the right to correct any errors in pricing or descriptions, and to cancel or refuse any orders based on incorrect price or description. Such corrections may be made even after an order is accepted.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("h3", null, "Property of Goods"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "All goods remain the property of TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC and/or its subsidiaries until full payment has been received.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("h3", null, "Payment, Delivery and Insurance"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Payment can be made via wire transfer or card. For all card payments, there is a small card handling surcharge fee.\u202FFull payment will be required prior to shipping."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "At point of shipment, goods become property of the buyer. Delivery will be ex-works under Incoterms 2020. All shipments require appropriate insurance coverage. It is the buyer\u2019s responsibility to ensure there is insurance to cover goods during transit. TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC is not responsible for goods lost, stolen or damaged in transit. "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "The buyer is obliged to take delivery of the goods at the time they are made available. When the buyer\u2019s lenses are at sight of completion, the buyer will be issued a shipping invoice. TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC will hold the buyer\u2019s lenses for 30 days from the date of the shipping invoice. If no payment or contact has been made within that time frame, the lenses may be re-allocated and a delay on the order could occur."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC cannot advise on local import rules and taxes. Custom duties or local taxes (where applicable) are the responsibility of the buyer. TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC reserves the right to ship products from any office or subsidiary around the world."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Shipments to customers in the USA will be shipped via TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC\u2019s appointed customs broker to ensure smooth transition through customs - this may impact quoted shipping times.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("h3", null, "Cancellation of Orders"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Due to the configuration of the BLACKWING", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " lenses, up to 10% of the deposit is at risk if a cancellation occurs more than 8 weeks after the order is placed. Up to 25% of the deposit could be non-refundable 8 weeks before order shipment commences, depending on the nature of the order cancellation. Any refunds payable will be made on a timeline agreed with the buyer."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Following receipt of a deposit payment to secure a buyer\u2019s order, TRIBE7 LLC reserves the right to cancel the order without notice and without refund of the deposit payment if a mutually agreed delivery commitment and/or payment plan is not established with the buyer within twelve (12) calendar months from the date the deposit payment is received and acknowledged."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Cancellations must be requested in writing to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "mailto:seven@7isatribe.com"
        }, "seven@7isatribe.com"), ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("h3", null, "Warranty"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC offers a twelve (12) month limited materials and workmanship warranty on all purchased products. Warranty begins from the day of shipment to the customer. Failure or performance degradation due to fair wear and tear or harsh usage is not covered under warranty and will be evaluated on a case-by-case basis. Warranty is considered void if a lens is partially or fully disassembled by unauthorized serviced persons."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "For warranty repairs, the customer is responsible for returning items that need servicing or repairs. TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC, or the regional distributor, will arrange the return shipment back to the customer after repair. For repairs out of warranty, the customer is responsible for all shipping."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "All service and repairs for goods in warranty must be requested in writing to  ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "mailto:service@blackwing7.com"
        }, "service@blackwing7.com"), " or ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "mailto:seven@7isatribe.com"
        }, "seven@7isatribe.com"), ". Warranty repairs with service partners will only be accepted once approved and following issuance of an RMA number by TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC. ")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("h3", null, "Service and Repairs"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "All service and repairs for goods in warranty must be requested in writing to ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "mailto:seven@7isatribe.com"
        }, "seven@7isatribe.com"), ". Repairs with service partners will only be accepted once approved and following issuance of an RMA number by TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("h3", null, "Transfer of Order or Warranty"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "Buyers shall not assign, transfer or delegate any of its rights and obligations without the prior written consent of TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "For any further details or questions, please email ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "mailto:seven@7isatribe.com"
        }, "seven@7isatribe.com"), ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("h3", null, "Returns and Exchanges"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "We do not accept returns or exchanges."))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($3cd6a95b0d5face1$exports))).footer)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("p", null, "TRIBE", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7"), " LLC is a company registered in the United States of America under company number EIN830912748. Registered office: 1013 Centre Road, Suite 403S, Wilmington, Delaware 19805, USA"))));
    }
}



var $jiXHd = parcelRequire("jiXHd");


var $aa7488b971f85591$exports = {};

$parcel$export($aa7488b971f85591$exports, "page", function () { return $aa7488b971f85591$export$523fb3936f49e028; }, function (v) { return $aa7488b971f85591$export$523fb3936f49e028 = v; });
$parcel$export($aa7488b971f85591$exports, "gridContainer", function () { return $aa7488b971f85591$export$711e2b273dbb00ac; }, function (v) { return $aa7488b971f85591$export$711e2b273dbb00ac = v; });
$parcel$export($aa7488b971f85591$exports, "bg", function () { return $aa7488b971f85591$export$136fd86de524d3c2; }, function (v) { return $aa7488b971f85591$export$136fd86de524d3c2 = v; });
$parcel$export($aa7488b971f85591$exports, "bgReady", function () { return $aa7488b971f85591$export$2eddb9afc6c2340f; }, function (v) { return $aa7488b971f85591$export$2eddb9afc6c2340f = v; });
$parcel$export($aa7488b971f85591$exports, "container", function () { return $aa7488b971f85591$export$34e0f9847d4c02dd; }, function (v) { return $aa7488b971f85591$export$34e0f9847d4c02dd = v; });
$parcel$export($aa7488b971f85591$exports, "topLogoContainer", function () { return $aa7488b971f85591$export$7940a387c74f91b1; }, function (v) { return $aa7488b971f85591$export$7940a387c74f91b1 = v; });
$parcel$export($aa7488b971f85591$exports, "logoT", function () { return $aa7488b971f85591$export$92c6d95b99150201; }, function (v) { return $aa7488b971f85591$export$92c6d95b99150201 = v; });
$parcel$export($aa7488b971f85591$exports, "formContainer", function () { return $aa7488b971f85591$export$231ba5fc42c01d86; }, function (v) { return $aa7488b971f85591$export$231ba5fc42c01d86 = v; });
$parcel$export($aa7488b971f85591$exports, "formHeading", function () { return $aa7488b971f85591$export$2573c9689ec84d1; }, function (v) { return $aa7488b971f85591$export$2573c9689ec84d1 = v; });
$parcel$export($aa7488b971f85591$exports, "formField", function () { return $aa7488b971f85591$export$2a668e8d088a0667; }, function (v) { return $aa7488b971f85591$export$2a668e8d088a0667 = v; });
$parcel$export($aa7488b971f85591$exports, "formButton", function () { return $aa7488b971f85591$export$58a3e2e25d011ae1; }, function (v) { return $aa7488b971f85591$export$58a3e2e25d011ae1 = v; });
$parcel$export($aa7488b971f85591$exports, "submitMessage", function () { return $aa7488b971f85591$export$8fd5706e716dbba; }, function (v) { return $aa7488b971f85591$export$8fd5706e716dbba = v; });
$parcel$export($aa7488b971f85591$exports, "bottomLogoContainer", function () { return $aa7488b971f85591$export$e1bbdc241abafae2; }, function (v) { return $aa7488b971f85591$export$e1bbdc241abafae2 = v; });
$parcel$export($aa7488b971f85591$exports, "bottomLogo", function () { return $aa7488b971f85591$export$60725bc580e0b286; }, function (v) { return $aa7488b971f85591$export$60725bc580e0b286 = v; });
var $aa7488b971f85591$export$523fb3936f49e028;
var $aa7488b971f85591$export$711e2b273dbb00ac;
var $aa7488b971f85591$export$136fd86de524d3c2;
var $aa7488b971f85591$export$2eddb9afc6c2340f;
var $aa7488b971f85591$export$34e0f9847d4c02dd;
var $aa7488b971f85591$export$7940a387c74f91b1;
var $aa7488b971f85591$export$92c6d95b99150201;
var $aa7488b971f85591$export$231ba5fc42c01d86;
var $aa7488b971f85591$export$2573c9689ec84d1;
var $aa7488b971f85591$export$2a668e8d088a0667;
var $aa7488b971f85591$export$58a3e2e25d011ae1;
var $aa7488b971f85591$export$8fd5706e716dbba;
var $aa7488b971f85591$export$e1bbdc241abafae2;
var $aa7488b971f85591$export$60725bc580e0b286;
$aa7488b971f85591$export$523fb3936f49e028 = "_app-views-Linktree-_styles__page";
$aa7488b971f85591$export$711e2b273dbb00ac = "_app-views-Linktree-_styles__gridContainer";
$aa7488b971f85591$export$136fd86de524d3c2 = "_app-views-Linktree-_styles__bg";
$aa7488b971f85591$export$2eddb9afc6c2340f = "_app-views-Linktree-_styles__bgReady";
$aa7488b971f85591$export$34e0f9847d4c02dd = "_app-views-Linktree-_styles__container";
$aa7488b971f85591$export$7940a387c74f91b1 = "_app-views-Linktree-_styles__topLogoContainer";
$aa7488b971f85591$export$92c6d95b99150201 = "_app-views-Linktree-_styles__logoT";
$aa7488b971f85591$export$231ba5fc42c01d86 = "_app-views-Linktree-_styles__formContainer";
$aa7488b971f85591$export$2573c9689ec84d1 = "_app-views-Linktree-_styles__formHeading";
$aa7488b971f85591$export$2a668e8d088a0667 = "_app-views-Linktree-_styles__formField";
$aa7488b971f85591$export$58a3e2e25d011ae1 = "_app-views-Linktree-_styles__formButton";
$aa7488b971f85591$export$8fd5706e716dbba = "_app-views-Linktree-_styles__submitMessage";
$aa7488b971f85591$export$e1bbdc241abafae2 = "_app-views-Linktree-_styles__bottomLogoContainer";
$aa7488b971f85591$export$60725bc580e0b286 = "_app-views-Linktree-_styles__bottomLogo";




var $jiXHd = parcelRequire("jiXHd");


var $088e281caf4d79d7$exports = {};

$parcel$export($088e281caf4d79d7$exports, "links", function () { return $088e281caf4d79d7$export$463d32b91de8b4d; }, function (v) { return $088e281caf4d79d7$export$463d32b91de8b4d = v; });
var $088e281caf4d79d7$export$463d32b91de8b4d;
$088e281caf4d79d7$export$463d32b91de8b4d = "_app-components-LinktreeList-_styles__links";


function $c0aa8f26a87001f2$var$LinktreeList({ links: links }) {
    const listRefs = (0, $jiXHd.useRef)([]);
    (0, $jiXHd.useEffect)(()=>{
        if (listRefs.current.length !== 0) (0, $36b3090cb6608e8f$export$99ee26438460406a).to(listRefs.current, {
            opacity: 1,
            duration: 1,
            stagger: 0.2,
            ease: 'power3.in'
        });
    }, [
        links
    ]);
    const upgradeIfEndsInSeven = (0, $jiXHd.useCallback)((title)=>{
        return title.endsWith('7') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, title.slice(0, -1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("sup", null, "7")) : title;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($088e281caf4d79d7$exports))).links)
    }, links.map((link, i)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("li", {
            key: link.id,
            ref: (el)=>listRefs.current[i] = el,
            style: {
                opacity: 0
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: link.url
        }, upgradeIfEndsInSeven(link.title)));
    }));
}
var $c0aa8f26a87001f2$export$2e2bcd8739ae039 = $c0aa8f26a87001f2$var$LinktreeList;






const $7f768043dddea54d$export$5607e5fcce563459 = {
    fields: [
        {
            label: "Email",
            component: "input",
            name: "email",
            attrs: {
                type: "email",
                placeholder: "Email"
            }
        }
    ],
    callback: (values)=>{
        return new Promise((resolve, reject)=>{
            window.grecaptcha.ready(()=>{
                window.grecaptcha.execute("6LfV4hUnAAAAAIwwq6GZuFlw3B8tcd1z7sOpVjwZ", {
                    action: 'submit'
                }).then((token)=>{
                    values.token = token;
                    values.listId = "713afd95a9";
                    fetch("/api/submitEmailSignUpForm", {
                        method: "POST",
                        cache: "no-cache",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(values)
                    }).then(resolve, reject);
                });
            });
        });
    }
};






const $7f1cd82914b1358d$var$backgroundUrl = new URL($f08fcdce49270724$exports);
class $7f1cd82914b1358d$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    constructor(props){
        super(props);
        this.state = {
            isFormSubmitted: false,
            links: []
        };
        this.formRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createRef();
    }
    async componentDidMount() {
        await this.fetchLinktreeData();
        // Animate the form if the ref is set
        if (this.formRef.current) window.setTimeout(()=>{
            (0, $36b3090cb6608e8f$export$99ee26438460406a).to(this.formRef.current, {
                opacity: 1,
                duration: 1,
                ease: "power3.in"
            });
        }, 1000);
    }
    // We need to fetch data on Links collection from Directus
    // This is later used to render links on Linktree page
    fetchLinktreeData = async ()=>{
        const res = await fetch(`${(0, $f6b3a4fa27ca8a91$export$8ebae31efd30e025)}/items/links`);
        const parsedLinksData = await res.json();
        this.setState({
            links: parsedLinksData.data
        });
    };
    handleFormSuccess = ()=>{
        this.setState({
            isFormSubmitted: true
        });
    };
    renderForm = ()=>{
        let formTemplate = null;
        if (!this.state.isFormSubmitted) formTemplate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $5e953b8f37931d32$export$2e2bcd8739ae039), {
            fields: (0, $7f768043dddea54d$export$5607e5fcce563459).fields,
            buttonLabel: "Subscribe",
            onSubmit: (0, $7f768043dddea54d$export$5607e5fcce563459).callback,
            onSuccess: this.handleFormSuccess,
            classNameButton: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).formButton),
            classNameField: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).formField)
        });
        else formTemplate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).submitMessage)
        }, "Thanks for signing up!");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            ref: this.formRef,
            style: {
                opacity: 0
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).formContainer)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $17cd0eb7cfcb3363$export$2e2bcd8739ae039), {
            level: 2,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).formHeading)
        }, "Sign up to newsletter"), formTemplate);
    };
    render() {
        const { links: links } = this.state;
        const meta = {
            title: "Linktree",
            description: ""
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).gridContainer)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f7489db668f41cb3$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("title", null, meta.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("meta", {
            name: "description",
            content: meta.description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("link", {
            rel: "canonical",
            href: `${window.location.origin}/specs`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $35950112c9f1df8b$export$2e2bcd8739ae039), {
            src: $7f1cd82914b1358d$var$backgroundUrl,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).bg),
            readyClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).bgReady)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).topLogoContainer)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $050314eceb27ab38$export$2e2bcd8739ae039), {
            exact: true,
            to: "/"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $872c63a65b67d0e2$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).logoT)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).container)
        }, this.state.links.length !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $c0aa8f26a87001f2$export$2e2bcd8739ae039), {
            links: links
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).container)
        }, this.renderForm()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).bottomLogoContainer)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($aa7488b971f85591$exports))).bottomLogo)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f51df0133a591ab7$export$2e2bcd8739ae039), null))));
    }
}



var $jiXHd = parcelRequire("jiXHd");

var $febb9bb555576c75$exports = {};

$parcel$export($febb9bb555576c75$exports, "page", function () { return $febb9bb555576c75$export$523fb3936f49e028; }, function (v) { return $febb9bb555576c75$export$523fb3936f49e028 = v; });
$parcel$export($febb9bb555576c75$exports, "container", function () { return $febb9bb555576c75$export$34e0f9847d4c02dd; }, function (v) { return $febb9bb555576c75$export$34e0f9847d4c02dd = v; });
$parcel$export($febb9bb555576c75$exports, "header", function () { return $febb9bb555576c75$export$38e42c68cf43b5d4; }, function (v) { return $febb9bb555576c75$export$38e42c68cf43b5d4 = v; });
$parcel$export($febb9bb555576c75$exports, "headerObscura", function () { return $febb9bb555576c75$export$9e2719b82b0a01d0; }, function (v) { return $febb9bb555576c75$export$9e2719b82b0a01d0 = v; });
$parcel$export($febb9bb555576c75$exports, "headerThirtySeven", function () { return $febb9bb555576c75$export$422610bdfbf685cb; }, function (v) { return $febb9bb555576c75$export$422610bdfbf685cb = v; });
$parcel$export($febb9bb555576c75$exports, "image", function () { return $febb9bb555576c75$export$5c452ff88e35e47d; }, function (v) { return $febb9bb555576c75$export$5c452ff88e35e47d = v; });
$parcel$export($febb9bb555576c75$exports, "fadeInAnimation", function () { return $febb9bb555576c75$export$8497679fcaaeceb; }, function (v) { return $febb9bb555576c75$export$8497679fcaaeceb = v; });
$parcel$export($febb9bb555576c75$exports, "description", function () { return $febb9bb555576c75$export$6d59db4903f20f7d; }, function (v) { return $febb9bb555576c75$export$6d59db4903f20f7d = v; });
$parcel$export($febb9bb555576c75$exports, "specsContainer", function () { return $febb9bb555576c75$export$f7b6a88299ea727e; }, function (v) { return $febb9bb555576c75$export$f7b6a88299ea727e = v; });
$parcel$export($febb9bb555576c75$exports, "videoSection", function () { return $febb9bb555576c75$export$826389ee43586363; }, function (v) { return $febb9bb555576c75$export$826389ee43586363 = v; });
$parcel$export($febb9bb555576c75$exports, "specsHeading", function () { return $febb9bb555576c75$export$42ea932ee7db45ce; }, function (v) { return $febb9bb555576c75$export$42ea932ee7db45ce = v; });
$parcel$export($febb9bb555576c75$exports, "specRows", function () { return $febb9bb555576c75$export$c1915e1df8b12fc5; }, function (v) { return $febb9bb555576c75$export$c1915e1df8b12fc5 = v; });
$parcel$export($febb9bb555576c75$exports, "specRow", function () { return $febb9bb555576c75$export$8262fe1c326daad1; }, function (v) { return $febb9bb555576c75$export$8262fe1c326daad1 = v; });
$parcel$export($febb9bb555576c75$exports, "buyNowContainer", function () { return $febb9bb555576c75$export$30af3b31aef9b7c5; }, function (v) { return $febb9bb555576c75$export$30af3b31aef9b7c5 = v; });
$parcel$export($febb9bb555576c75$exports, "buyNowButton", function () { return $febb9bb555576c75$export$f2be135d9053bf65; }, function (v) { return $febb9bb555576c75$export$f2be135d9053bf65 = v; });
$parcel$export($febb9bb555576c75$exports, "formContainer", function () { return $febb9bb555576c75$export$231ba5fc42c01d86; }, function (v) { return $febb9bb555576c75$export$231ba5fc42c01d86 = v; });
$parcel$export($febb9bb555576c75$exports, "form", function () { return $febb9bb555576c75$export$6210fa4921d2a466; }, function (v) { return $febb9bb555576c75$export$6210fa4921d2a466 = v; });
$parcel$export($febb9bb555576c75$exports, "formHeading", function () { return $febb9bb555576c75$export$2573c9689ec84d1; }, function (v) { return $febb9bb555576c75$export$2573c9689ec84d1 = v; });
$parcel$export($febb9bb555576c75$exports, "formHeadingAccent", function () { return $febb9bb555576c75$export$a296f990af56e87c; }, function (v) { return $febb9bb555576c75$export$a296f990af56e87c = v; });
$parcel$export($febb9bb555576c75$exports, "formField", function () { return $febb9bb555576c75$export$2a668e8d088a0667; }, function (v) { return $febb9bb555576c75$export$2a668e8d088a0667 = v; });
$parcel$export($febb9bb555576c75$exports, "formButton", function () { return $febb9bb555576c75$export$58a3e2e25d011ae1; }, function (v) { return $febb9bb555576c75$export$58a3e2e25d011ae1 = v; });
$parcel$export($febb9bb555576c75$exports, "formButtonVisible", function () { return $febb9bb555576c75$export$60dd73a2d10db88; }, function (v) { return $febb9bb555576c75$export$60dd73a2d10db88 = v; });
$parcel$export($febb9bb555576c75$exports, "submitMessage", function () { return $febb9bb555576c75$export$8fd5706e716dbba; }, function (v) { return $febb9bb555576c75$export$8fd5706e716dbba = v; });
$parcel$export($febb9bb555576c75$exports, "signUp", function () { return $febb9bb555576c75$export$cf64224bcd829024; }, function (v) { return $febb9bb555576c75$export$cf64224bcd829024 = v; });
var $febb9bb555576c75$export$523fb3936f49e028;
var $febb9bb555576c75$export$34e0f9847d4c02dd;
var $febb9bb555576c75$export$38e42c68cf43b5d4;
var $febb9bb555576c75$export$9e2719b82b0a01d0;
var $febb9bb555576c75$export$422610bdfbf685cb;
var $febb9bb555576c75$export$5c452ff88e35e47d;
var $febb9bb555576c75$export$8497679fcaaeceb;
var $febb9bb555576c75$export$6d59db4903f20f7d;
var $febb9bb555576c75$export$f7b6a88299ea727e;
var $febb9bb555576c75$export$826389ee43586363;
var $febb9bb555576c75$export$42ea932ee7db45ce;
var $febb9bb555576c75$export$c1915e1df8b12fc5;
var $febb9bb555576c75$export$8262fe1c326daad1;
var $febb9bb555576c75$export$30af3b31aef9b7c5;
var $febb9bb555576c75$export$f2be135d9053bf65;
var $febb9bb555576c75$export$231ba5fc42c01d86;
var $febb9bb555576c75$export$6210fa4921d2a466;
var $febb9bb555576c75$export$2573c9689ec84d1;
var $febb9bb555576c75$export$a296f990af56e87c;
var $febb9bb555576c75$export$2a668e8d088a0667;
var $febb9bb555576c75$export$58a3e2e25d011ae1;
var $febb9bb555576c75$export$60dd73a2d10db88;
var $febb9bb555576c75$export$8fd5706e716dbba;
var $febb9bb555576c75$export$cf64224bcd829024;
$febb9bb555576c75$export$523fb3936f49e028 = "_app-views-Obscura-_styles__page";
$febb9bb555576c75$export$34e0f9847d4c02dd = "_app-views-Obscura-_styles__container";
$febb9bb555576c75$export$38e42c68cf43b5d4 = "_app-views-Obscura-_styles__header";
$febb9bb555576c75$export$9e2719b82b0a01d0 = "_app-views-Obscura-_styles__headerObscura";
$febb9bb555576c75$export$422610bdfbf685cb = "_app-views-Obscura-_styles__headerThirtySeven";
$febb9bb555576c75$export$5c452ff88e35e47d = "_app-views-Obscura-_styles__image";
$febb9bb555576c75$export$8497679fcaaeceb = "_app-views-Obscura-_styles__fadeInAnimation";
$febb9bb555576c75$export$6d59db4903f20f7d = "_app-views-Obscura-_styles__description";
$febb9bb555576c75$export$f7b6a88299ea727e = "_app-views-Obscura-_styles__specsContainer";
$febb9bb555576c75$export$826389ee43586363 = "_app-views-Obscura-_styles__videoSection";
$febb9bb555576c75$export$42ea932ee7db45ce = "_app-views-Obscura-_styles__specsHeading";
$febb9bb555576c75$export$c1915e1df8b12fc5 = "_app-views-Obscura-_styles__specRows";
$febb9bb555576c75$export$8262fe1c326daad1 = "_app-views-Obscura-_styles__specRow";
$febb9bb555576c75$export$30af3b31aef9b7c5 = "_app-views-Obscura-_styles__buyNowContainer";
$febb9bb555576c75$export$f2be135d9053bf65 = "_app-views-Obscura-_styles__buyNowButton";
$febb9bb555576c75$export$231ba5fc42c01d86 = "_app-views-Obscura-_styles__formContainer";
$febb9bb555576c75$export$6210fa4921d2a466 = "_app-views-Obscura-_styles__form";
$febb9bb555576c75$export$2573c9689ec84d1 = "_app-views-Obscura-_styles__formHeading";
$febb9bb555576c75$export$a296f990af56e87c = "_app-views-Obscura-_styles__formHeadingAccent";
$febb9bb555576c75$export$2a668e8d088a0667 = "_app-views-Obscura-_styles__formField";
$febb9bb555576c75$export$58a3e2e25d011ae1 = "_app-views-Obscura-_styles__formButton";
$febb9bb555576c75$export$60dd73a2d10db88 = "_app-views-Obscura-_styles__formButtonVisible";
$febb9bb555576c75$export$8fd5706e716dbba = "_app-views-Obscura-_styles__submitMessage";
$febb9bb555576c75$export$cf64224bcd829024 = "_app-views-Obscura-_styles__signUp";







var $jiXHd = parcelRequire("jiXHd");
class $9fdbc079ba52b604$var$Img extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        loaded: false,
        src: ''
    };
    static getDerivedStateFromProps(props, state) {
        // Reset loaded status if src prop changes
        if (props.src !== state.src) return {
            loaded: false,
            src: props.src
        };
        // No state update necessary
        return null;
    }
    componentDidMount() {
        if (this.img.complete && !this.state.loaded) this.onLoad();
    }
    componentWillUnmount() {
        clearTimeout(this.timeout);
    }
    componentDidUpdate() {
        if (this.img.complete && !this.state.loaded) this.onLoad();
    }
    onLoad = ()=>{
        // TODO Figure out why this timeout is necessary
        this.timeout = setTimeout(()=>{
            this.setState({
                loaded: true
            });
            if (this.props.onLoad) this.props.onLoad();
        }, 10);
    };
    render() {
        let { className: className, readyClassName: readyClassName, onLoad: onLoad, ...rest } = this.props;
        let cn = (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))(className, {
            [readyClassName]: this.state.loaded
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("img", {
            className: cn,
            onLoad: this.onLoad,
            ...rest,
            ref: (c)=>{
                this.img = c;
            }
        });
    }
}
var $9fdbc079ba52b604$export$2e2bcd8739ae039 = $9fdbc079ba52b604$var$Img;



const $5463d96c7603332f$export$5607e5fcce563459 = {
    fields: [
        {
            label: "Email",
            component: "input",
            name: "email",
            attrs: {
                type: "email",
                placeholder: "EMAIL"
            }
        }
    ],
    callback: (values)=>{
        return new Promise((resolve, reject)=>{
            window.grecaptcha.ready(()=>{
                window.grecaptcha.execute("6LfV4hUnAAAAAIwwq6GZuFlw3B8tcd1z7sOpVjwZ", {
                    action: 'submit'
                }).then((token)=>{
                    values.token = token;
                    values.listId = "16e82d9162";
                    fetch("/api/submitEmailSignUpForm", {
                        method: "POST",
                        cache: "no-cache",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(values)
                    }).then(resolve, reject);
                });
            });
        });
    }
};





var $d9deb89431398b19$exports = {};
$d9deb89431398b19$exports = $parcel$resolve("gFVvo");


const $5c978716cd1ab4be$var$imageUrl = new URL($d9deb89431398b19$exports);
const $5c978716cd1ab4be$var$obscuraSpecifications = [
    {
        label: "Focal Length",
        value: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Fragment, null, "37", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm"))
    },
    {
        label: "Mount",
        value: "ARRI PL-Mount"
    },
    {
        label: "Pupil diameter",
        value: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Fragment, null, "277 ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "um"))
    },
    {
        label: "F-stop equivalent",
        value: "f/133"
    },
    {
        label: "Substrate thickness",
        value: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Fragment, null, "9 ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "um"))
    },
    {
        label: "Weight",
        value: "47g (without packaging)"
    },
    {
        label: "Front cover diameter",
        value: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Fragment, null, "55", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm"))
    },
    {
        label: "Depth front to back",
        value: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Fragment, null, "23", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "mm"))
    }
];
class $5c978716cd1ab4be$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    constructor(props){
        super(props);
        this.state = {
            isFormSubmitted: false
        };
    }
    handleFormSuccess = ()=>{
        this.setState({
            isFormSubmitted: true
        });
    };
    displaySubmitButton = (event)=>{
        const submitButton = document.querySelector('button[type="submit"]');
        if (event.target.value) submitButton.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).formButtonVisible);
        else submitButton.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).formButtonVisible);
    };
    renderForm = ()=>{
        let formTemplate = null;
        if (!this.state.isFormSubmitted) formTemplate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $5e953b8f37931d32$export$2e2bcd8739ae039), {
            fields: (0, $5463d96c7603332f$export$5607e5fcce563459).fields,
            buttonLabel: "submit",
            onSubmit: (0, $5463d96c7603332f$export$5607e5fcce563459).callback,
            onSuccess: this.handleFormSuccess,
            onChange: this.displaySubmitButton,
            classNameButton: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).formButton),
            classNameField: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).formField),
            classNameContainer: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).form),
            withHiddenSubmitButton: true,
            withExpandingLine: true
        });
        else formTemplate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).submitMessage)
        }, "Thanks for registering your interest in OBSCURA", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", null, "37"), ", we'll be in touch soon");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $17cd0eb7cfcb3363$export$2e2bcd8739ae039), {
            level: 2,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).formHeading)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).formHeadingAccent)
        }, "Register"), " your interest"), formTemplate);
    };
    renderSpecifications = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).specsContainer)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $17cd0eb7cfcb3363$export$2e2bcd8739ae039), {
            level: 2,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).specsHeading)
        }, "Specifications"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).rows, (0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).specRows)
        }, $5c978716cd1ab4be$var$obscuraSpecifications.map((spec)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                key: spec.label,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).row, (0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).specRow)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colLeft)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).label)
            }, spec.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).line)
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d39415832ed187ec$exports))).colRight)
            }, spec.value)))));
    render() {
        const meta = {
            title: "Obscura37 by Blackwing7",
            description: ""
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $f7489db668f41cb3$export$dcef8f9bb9a41431), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("title", null, meta.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("meta", {
            name: "description",
            content: meta.page
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("link", {
            rel: "canonical",
            href: `${window.location.origin}/obscura`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e210a18e449d81cc$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fd7a96e2a03b7dc9$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).page)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).container)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).header)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).headerObscura)
        }, "OBSCURA"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).headerThirtySeven)
        }, "37")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).imageContainer)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $9fdbc079ba52b604$export$2e2bcd8739ae039), {
            src: $5c978716cd1ab4be$var$imageUrl,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).image),
            readyClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).imageReady)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).description)
        }, "OBSCURe/a is our attempt to hand those who we love the most, our supporters, a tool that will allow them to reconnect to their childhood senses. The origin story of their first tastes, their first smells. As cinematographers, a reconnection to the origin of our art form, the first lens."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).videoSection)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $ef5e9f5377aadda6$export$2e2bcd8739ae039), {
            src: "https://player.vimeo.com/progressive_redirect/playback/1142420900/rendition/1080p/file.mp4?loc=external&log_user=0&signature=455e8c6d1d6b5c767e6ec25d5c273e7440a812ce32db05552dd866a004133c8d",
            width: "1920",
            height: "1080",
            isCurrent: true,
            isCurrentOrNext: true,
            loop: true
        })), this.renderSpecifications(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).buyNowContainer)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("a", {
            href: "https://blackslate7.com/cart/47393294188682:1?return_to=/checkout",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).buyNowButton)
        }, "Order Now")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($febb9bb555576c75$exports))).signUp)
        }, this.renderForm()))));
    }
}


class $0a363e6fa8afa5c8$var$Root extends (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).Component {
    state = {
        landingOnLensed: true
    };
    componentDidMount() {
        if (this.props.location.pathname !== "/") this.setState({
            landingOnLensed: false
        });
    }
    componentDidUpdate(prevProps) {
        // Scroll to top on URL Change
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scrollTo(0, 0);
            if (this.state.landingOnLensed === true) this.setState({
                landingOnLensed: false
            });
        }
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ddc83218ad96e131$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0bb83cf2583d18f7$exports))).wrap)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $fc0bff407010a116$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
            path: "/lenses",
            component: (0, $9f1f482530539ad9$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
            path: "/tuning",
            component: (0, $09cf08068afebea4$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
            path: "/lensrange",
            component: (0, $b165a22c0310a835$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
            path: "/specs",
            component: (0, $481b93b11560829c$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
            path: "/contact",
            component: (0, $6558741a40a6102b$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
            path: "/credits",
            component: (0, $4db6c283b58230db$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
            path: "/termsandconditions",
            component: (0, $d9a0ccacb9275e58$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
            path: "/linktree",
            component: (0, $7f1cd82914b1358d$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
            path: "/obscura37",
            component: (0, $5c978716cd1ab4be$export$2e2bcd8739ae039)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
            path: "/obscura"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $20adb9c38480af55$export$2e2bcd8739ae039), {
            to: "/obscura37"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $adca9692c2edcaaa$export$2e2bcd8739ae039), {
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $49461d249929a3fc$export$2e2bcd8739ae039), {
                    ...props,
                    landingOnLensed: this.state.landingOnLensed
                })
        })));
    }
}
var $0a363e6fa8afa5c8$export$2e2bcd8739ae039 = (0, $29c0cf2e84800dc5$export$2e2bcd8739ae039)($0a363e6fa8afa5c8$var$Root);


function $e803c9110e675736$var$init() {
    let router = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $e6284243182d7c7d$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $0a363e6fa8afa5c8$export$2e2bcd8739ae039), null));
    const current_env = "production";
    const shouldReportErrors = [
        "production",
        "staging"
    ].includes(current_env);
    if (shouldReportErrors) {
        const rollbarConfig = {
            accessToken: "5b3cffad39c9496c8c27f9898b40986b",
            environment: current_env
        };
        router = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $755f8773177e6dc1$export$56c0d5a1e737357d), {
            config: rollbarConfig
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jiXHd))).createElement((0, $8840d96c4e9442b9$export$e926676385687eaf), null, router));
    }
    (0, $d5c398fad52d3d9a$exports.render)(router, document.getElementById("root"));
}
$e803c9110e675736$var$init();


//# sourceMappingURL=app.3f35ba3b.js.map
